//
// A collection of common functions that makes JS more functional
//
// Values
function $c6a9e46ee7e4d896$export$e9bab7fafb253603(a, b) {
    return Object.is(a, b);
}
function $c6a9e46ee7e4d896$export$630801d484da15df(x) {
    return Object.is(x, null);
}
function $c6a9e46ee7e4d896$export$fce6876652108ab(x) {
    return Object.is(x, undefined);
}
function $c6a9e46ee7e4d896$export$f6e2535fb5126e54(x) {
    return $c6a9e46ee7e4d896$export$e9bab7fafb253603(typeof x, 'function');
}
function $c6a9e46ee7e4d896$export$43bee75e5e14138e(x) {
    return Array.isArray(x);
}
function $c6a9e46ee7e4d896$export$9dd3754ae86f0017(x) {
    return x instanceof ArrayBuffer;
}
function $c6a9e46ee7e4d896$export$2f3f84b787c83cc3(x) {
    return x instanceof DataView;
}
function $c6a9e46ee7e4d896$export$a6cdc56e425d0d0a(x) {
    return $c6a9e46ee7e4d896$export$e9bab7fafb253603(typeof x, 'object') && !$c6a9e46ee7e4d896$export$43bee75e5e14138e(x);
}
function $c6a9e46ee7e4d896$export$cea7aa84e978eba5(x) {
    return $c6a9e46ee7e4d896$export$43bee75e5e14138e(x) || $c6a9e46ee7e4d896$export$a6cdc56e425d0d0a(x);
}
function $c6a9e46ee7e4d896$export$844ec244b1367d54(x) {
    return $c6a9e46ee7e4d896$export$e9bab7fafb253603(typeof x, 'string');
}
function $c6a9e46ee7e4d896$export$7e4aa119212bc614(x) {
    if (isNaN(x)) return false;
    return $c6a9e46ee7e4d896$export$e9bab7fafb253603(typeof x, 'number');
}
function $c6a9e46ee7e4d896$export$595884dc072315a0(x) {
    return $c6a9e46ee7e4d896$export$7e4aa119212bc614(x) || $c6a9e46ee7e4d896$export$844ec244b1367d54(x);
}
function $c6a9e46ee7e4d896$export$f7e9f41ea797a17(x) {
    if ($c6a9e46ee7e4d896$export$630801d484da15df(x) || $c6a9e46ee7e4d896$export$fce6876652108ab(x)) return false;
    return true;
}
function $c6a9e46ee7e4d896$export$32e504f4cccd6638(value, fallback) {
    if ($c6a9e46ee7e4d896$export$f7e9f41ea797a17(value)) return value;
    if ($c6a9e46ee7e4d896$export$f7e9f41ea797a17(fallback)) return fallback;
    throw new Error(`existance needs a fallback value `, value);
}
function $c6a9e46ee7e4d896$export$3570f33b1a1f3329(x, msg = 'expected value here') {
    if ($c6a9e46ee7e4d896$export$f7e9f41ea797a17(x)) return x;
    throw new Error(msg);
}
function $c6a9e46ee7e4d896$export$a22775fa5e2eebd9(predicates = [], value, fallback) {
    if (predicates.reduce((acc, p)=>acc && p(value), true)) return value;
    if ($c6a9e46ee7e4d896$export$f7e9f41ea797a17(fallback)) return fallback;
    throw new Error(`validate needs a fallback value with `, value);
}
// Collections
function $c6a9e46ee7e4d896$export$6e22c362a0406a2c(x) {
    if ($c6a9e46ee7e4d896$export$a6cdc56e425d0d0a(x)) return Object.keys(x).length === 0;
    return x.length === 0;
}
const $c6a9e46ee7e4d896$export$6f6258299a22298a = $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2(function(offset, xs) {
    let i = offset < 0 ? xs.length + offset : offset;
    if ($c6a9e46ee7e4d896$export$844ec244b1367d54(xs)) return xs.charAt(i);
    return xs[i];
});
function $c6a9e46ee7e4d896$export$43128fadae87b74a(xs) {
    return xs.at(0);
}
function $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d(xs) {
    return xs.at(1);
}
function $c6a9e46ee7e4d896$export$1fa4a8860392dfdb(xs) {
    return xs.at(2);
}
function $c6a9e46ee7e4d896$export$4c7897fafd92b108(xs) {
    return xs.at(-1);
}
const $c6a9e46ee7e4d896$var$prop = $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2(function(p, x) {
    if (!$c6a9e46ee7e4d896$export$f7e9f41ea797a17(x)) return;
    return Number.isInteger(p) ? $c6a9e46ee7e4d896$export$6f6258299a22298a(p, x) : x[p];
});
function $c6a9e46ee7e4d896$export$871de8747c9eaa88(coll, fn) {
    if ($c6a9e46ee7e4d896$export$43bee75e5e14138e(coll)) return coll.map(fn);
    if ($c6a9e46ee7e4d896$export$a6cdc56e425d0d0a(coll)) {
        for(let prop in coll)coll[prop] = fn(coll[prop]);
        return coll;
    }
    if ($c6a9e46ee7e4d896$export$844ec244b1367d54(coll)) return coll.split('').map(fn).join('');
    throw new Error(`map called with unkown collection `, coll);
}
function $c6a9e46ee7e4d896$export$df3f009e3d155b20(obj, fn = (x)=>x, acc = []) {
    function recur(fn, obj, keys, acc) {
        if ($c6a9e46ee7e4d896$export$6e22c362a0406a2c(keys)) return acc;
        else {
            let [k, ...ks] = keys;
            let v = obj[k];
            if ($c6a9e46ee7e4d896$export$a6cdc56e425d0d0a(v)) {
                acc = recur(fn, v, Object.keys(v), acc);
                return recur(fn, obj, ks, acc);
            } else {
                acc = fn(acc, k, v, obj);
                return recur(fn, obj, ks, acc);
            }
        }
    }
    return recur(fn, obj, Object.keys(obj), acc);
}
function $c6a9e46ee7e4d896$export$c52e5867d5879e24(...args) {
    let [collection, ...path] = args;
    return path.reduce((acc, key)=>{
        if ($c6a9e46ee7e4d896$export$f7e9f41ea797a17(acc[key])) return acc[key];
        return undefined;
    }, collection);
}
function $c6a9e46ee7e4d896$export$adaa4cf7ef1b65be(coll, k, v) {
    coll = coll || {};
    coll[k] = v;
    return coll;
}
function $c6a9e46ee7e4d896$export$e6bdf135a54e021b(coll = {}, [k, ...keys], v) {
    return keys.length ? $c6a9e46ee7e4d896$export$adaa4cf7ef1b65be(coll, k, $c6a9e46ee7e4d896$export$e6bdf135a54e021b(coll[k], keys, v)) : $c6a9e46ee7e4d896$export$adaa4cf7ef1b65be(coll, k, v);
}
function $c6a9e46ee7e4d896$export$86c4352b5bd9c815(xs, prop = false) {
    if (prop !== false) return xs.reduce((acc, v, i)=>acc + (v[prop] - acc) / (i + 1), 0);
    else return xs.reduce((acc, v, i)=>acc + (v - acc) / (i + 1), 0);
}
function $c6a9e46ee7e4d896$export$f63d28b738249587(value_c, value_p, count_c, count_p = count_c - 1) {
    return (value_c + count_p * value_p) / count_c;
}
function $c6a9e46ee7e4d896$export$8960430cfd85939f(xs, prop = false) {
    if (prop !== false) return xs.reduce((acc, v, i)=>v[prop] > acc ? v[prop] : acc, 0);
    else return Math.max(xs);
}
function $c6a9e46ee7e4d896$export$8a63f25cc62965f1(xs, path = false) {
    if (path !== false) return xs.reduce((acc, v, i)=>acc + v[path], 0);
    else return xs.reduce((acc, v, i)=>acc + v, 0);
}
function $c6a9e46ee7e4d896$export$bb0a9c36cf454ea0(min = 0, max = 10) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function $c6a9e46ee7e4d896$export$9a00dee1beb8f576(str) {
    return str.trim().replace(/^\w/, (c)=>c.toUpperCase());
}
function $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4(lower, upper, value) {
    if (value >= upper) return upper;
    else if (value < lower) return lower;
    else return value;
}
// Functions
function $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30(f, g) {
    return function(...args) {
        return f(g(...args));
    };
}
function $c6a9e46ee7e4d896$export$f672e0b6f7222cd7(...fns) {
    return fns.reduce($c6a9e46ee7e4d896$export$3f77d4ba3adcbe30);
}
function $c6a9e46ee7e4d896$export$a4627e546088548d(...fns) {
    return fns.reduceRight($c6a9e46ee7e4d896$export$3f77d4ba3adcbe30);
}
function $c6a9e46ee7e4d896$export$76d90c956114f2c2(n) {
    return function(f) {
        return function(x) {
            if (n > 0) return $c6a9e46ee7e4d896$export$76d90c956114f2c2(n - 1)(f)(f(x));
            else return x;
        };
    };
}
function $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2(fn) {
    return function(arg1, arg2) {
        if ($c6a9e46ee7e4d896$export$f7e9f41ea797a17(arg2)) return fn(arg1, arg2);
        else return function(arg2) {
            return fn(arg1, arg2);
        };
    };
}
function $c6a9e46ee7e4d896$export$d2de3aaeafa91619(fn, context) {
    let result;
    return function() {
        if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
        }
        return result;
    };
}
//
// Copied from lodash.js
//
function $c6a9e46ee7e4d896$export$61fc7d43ac8f84b0(func, wait, options = {}) {
    const root = window;
    let lastArgs, lastThis, maxWait, result, timerId, lastCallTime;
    let lastInvokeTime = 0;
    let leading = false;
    let maxing = false;
    let trailing = true;
    // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    const useRAF = !wait && wait !== 0 && typeof root.requestAnimationFrame === 'function';
    if (!$c6a9e46ee7e4d896$export$f6e2535fb5126e54(func)) // edit
    throw new TypeError('debounce expectes a function');
    wait = $c6a9e46ee7e4d896$export$32e504f4cccd6638($c6a9e46ee7e4d896$export$a0a81dc3380ce7d3(wait), 0); // edit
    // if (isObject(options)) {
    leading = $c6a9e46ee7e4d896$export$a5e0e20515fe635(options.leading);
    maxing = $c6a9e46ee7e4d896$export$f7e9f41ea797a17(options.maxWait);
    maxWait = maxing ? Math.max($c6a9e46ee7e4d896$export$32e504f4cccd6638($c6a9e46ee7e4d896$export$a0a81dc3380ce7d3(options.maxWait), 0), wait) : maxWait;
    trailing = $c6a9e46ee7e4d896$export$f7e9f41ea797a17(options.trailing) ? $c6a9e46ee7e4d896$export$a5e0e20515fe635(options.trailing) : trailing;
    // }
    function invokeFunc(time) {
        const args = lastArgs;
        const thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function startTimer(pendingFunc, wait) {
        if (useRAF) {
            root.cancelAnimationFrame(timerId);
            return root.requestAnimationFrame(pendingFunc);
        }
        return setTimeout(pendingFunc, wait);
    }
    function cancelTimer(id) {
        if (useRAF) return root.cancelAnimationFrame(id);
        return clearTimeout(id); // edit
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = startTimer(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        const timeSinceLastCall = time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime;
        const timeWaiting = wait - timeSinceLastCall;
        return maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = startTimer(timerExpired, remainingWait(time));
        return timerId; // edit
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) cancelTimer(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return $c6a9e46ee7e4d896$export$fce6876652108ab(timerId) ? result : trailingEdge(Date.now());
    }
    function pending() {
        return !$c6a9e46ee7e4d896$export$fce6876652108ab(timerId);
    }
    function debounced(...args) {
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        lastArgs = args;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if ($c6a9e46ee7e4d896$export$fce6876652108ab(timerId)) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = startTimer(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if ($c6a9e46ee7e4d896$export$fce6876652108ab(timerId)) timerId = startTimer(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    debounced.pending = pending;
    return debounced;
}
// end copied from lodash.js
// Async
async function $c6a9e46ee7e4d896$export$1391212d75b2ee65(ms) {
    return await new Promise((res)=>setTimeout(res, ms));
}
async function $c6a9e46ee7e4d896$export$5c069c93d2b7493f(ms) {
    return await new Promise((res)=>setTimeout(res, ms));
}
// XF (Events)
function $c6a9e46ee7e4d896$var$XF(args = {}) {
    let data = {};
    let name = args.name || 'db';
    function create(obj) {
        data = proxify(obj);
    }
    function proxify(obj) {
        let handler = {
            set: (target, key, value)=>{
                target[key] = value;
                dispatch(`${name}:${key}`, target);
                return true;
            }
        };
        return new Proxy(obj, handler);
    }
    function dispatch(eventType, value) {
        window.dispatchEvent(evt(eventType)(value));
    }
    function sub(eventType, handler, options = {}) {
        function handlerWraper(e) {
            if (isStoreSource(eventType)) handler(e.detail.data[evtProp(eventType)]);
            else handler(e.detail.data);
        }
        window.addEventListener(eventType, handlerWraper, Object.assign({
            capture: false
        }, options));
        return handlerWraper;
    }
    function reg(eventType, handler, options = {}) {
        function handlerWraper(e) {
            return handler(e.detail.data, data);
        }
        window.addEventListener(eventType, handlerWraper, Object.assign({
            capture: false
        }, options));
        return handlerWraper;
    }
    function unsub(eventType, handler, options = {}) {
        // console.log(`unsub ${eventType}`, handler); // rmv
        window.removeEventListener(eventType, handler, Object.assign({
            capture: false
        }, options));
    }
    function isStoreSource(eventType) {
        return $c6a9e46ee7e4d896$export$e9bab7fafb253603(evtSource(eventType), name);
    }
    function evt(eventType) {
        return function(value) {
            return new CustomEvent(eventType, {
                detail: {
                    data: value
                }
            });
        };
    }
    function evtProp(eventType) {
        return $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d(eventType.split(':'));
    }
    function evtSource(eventType) {
        return $c6a9e46ee7e4d896$export$43128fadae87b74a(eventType.split(':'));
    }
    return Object.freeze({
        create: create,
        reg: reg,
        sub: sub,
        dispatch: dispatch,
        unsub: unsub
    });
}
const $c6a9e46ee7e4d896$export$499ab16161e1b192 = $c6a9e46ee7e4d896$var$XF();
// format
function $c6a9e46ee7e4d896$export$834dfc94dde4b3d8(n) {
    return '0x' + parseInt(n).toString(16).toUpperCase().padStart(2, '0');
}
function $c6a9e46ee7e4d896$export$a0a81dc3380ce7d3(value) {
    return +value;
}
function $c6a9e46ee7e4d896$export$a5e0e20515fe635(value) {
    return !!value;
}
function $c6a9e46ee7e4d896$export$a81f732198733497(x, points = 2, fallback = 0) {
    if (!$c6a9e46ee7e4d896$export$7e4aa119212bc614(x)) return fallback;
    const precision = 10 ** points;
    return Math.round(x * precision) / precision;
}
function $c6a9e46ee7e4d896$export$d59ba87ce515b3fd(dataview) {
    return Array.from(new Uint8Array(dataview.buffer));
}
function $c6a9e46ee7e4d896$export$c6c1336eae0a8aa5(dataview) {
    let utf8decoder = new TextDecoder('utf-8');
    return utf8decoder.decode(dataview.buffer);
}
function $c6a9e46ee7e4d896$export$9d73071cd264bdb(buffer) {
    return Array.from(new Uint8Array(buffer));
}
function $c6a9e46ee7e4d896$export$a2d7432cc0a79bc(str) {
    return str.split('').map((c)=>c.charCodeAt(0));
}
function $c6a9e46ee7e4d896$var$stringToDataview(str) {
    let charCodes = $c6a9e46ee7e4d896$export$a2d7432cc0a79bc(str);
    let uint8 = new Uint8Array(charCodes);
    let dataview = new DataView(uint8.buffer);
    return dataview;
}
function $c6a9e46ee7e4d896$export$2da9be4cfdb689b1() {
    const d = new Date();
    const mm = d.getMinutes().toString().padStart(2, '0');
    const ss = d.getSeconds().toString().padStart(2, '0');
    const mmmm = d.getMilliseconds().toString().padStart(4, '0');
    return `${mm}:${ss}:${mmmm}`;
}
function $c6a9e46ee7e4d896$export$3ae94a2503e890a1(args = {}) {
    const date = args.date ?? new Date();
    const s = args.separator ?? '/';
    const showYear = args.year ?? true;
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}${s}${month}${showYear ? s : ''}${showYear ? year : ''}`;
}
// Bits
function $c6a9e46ee7e4d896$export$8154c826aac5e341(field, bit) {
    return field >> bit & 1;
}
function $c6a9e46ee7e4d896$export$75ed722ad5e2887(i, n) {
    return n |= 1 << i;
}
function $c6a9e46ee7e4d896$export$afb88973713cb16a(start, end, value) {
    return value >> start & (1 << end - start) - 1;
}
function $c6a9e46ee7e4d896$export$bc7d73a5d14928db(field, bit) {
    return $c6a9e46ee7e4d896$export$a5e0e20515fe635($c6a9e46ee7e4d896$export$8154c826aac5e341(field, bit));
}
function $c6a9e46ee7e4d896$export$6444ef5cd411280c(view, start = 0, end = view.byteLength) {
    let cs = 0;
    const length = end < 0 ? view.byteLength + end : end;
    for(let i = start; i < length; i++)cs ^= view.getUint8(i);
    return cs;
}
function $c6a9e46ee7e4d896$export$372c9535d2b44aa1(dataview, index, value) {
    dataview.setUint8(index, value & 0xFF, true); // LSB
    dataview.setUint8(index + 1, value >> 8 & 0xFF, true);
    dataview.setUint8(index + 2, value >> 16, true); // MSB
    return dataview;
}
function $c6a9e46ee7e4d896$export$ac13700e638c384c(dataview, index = 0) {
    const LSB = dataview.getUint8(index, true); // LSB
    const MB = dataview.getUint8(index + 1, true);
    const MSB = dataview.getUint8(index + 2, true); // MSB
    return (MSB << 16) + (MB << 8) + LSB;
}
function $c6a9e46ee7e4d896$export$6298b650a59e6ea5(args = {}) {
    const definitions = $c6a9e46ee7e4d896$export$3570f33b1a1f3329(args.definitions);
    const applyResolution = $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2((prop, value)=>{
        return value / definitions[prop].resolution;
    });
    const removeResolution = $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2((prop, value)=>{
        return value * definitions[prop].resolution;
    });
    function encodeField(prop, input, transform = applyResolution(prop)) {
        const fallback = definitions[prop].default;
        const min = applyResolution(definitions[prop].min);
        const max = applyResolution(definitions[prop].max);
        const value = input ?? fallback;
        return Math.floor($c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4(min, max, transform(value)));
    }
    function decodeField(prop, input, transform = removeResolution) {
        return transform(prop, input);
    }
    return {
        definitions: definitions,
        applyResolution: applyResolution,
        removeResolution: removeResolution,
        encodeField: encodeField,
        decodeField: decodeField
    };
}
// print
function $c6a9e46ee7e4d896$var$Print() {
    if (!$c6a9e46ee7e4d896$export$f7e9f41ea797a17(process)) var process = {
        env: {
            NODE_ENV: "development"
        }
    };
    let printLog = process?.env?.NODE_ENV ?? true ?? false;
    let printWarn = true;
    console.log(`:env ${process?.env?.NODE_ENV} :print ${printLog}`);
    function log(msg) {
        if (printLog) console.log(`[${$c6a9e46ee7e4d896$export$2da9be4cfdb689b1()}] ${msg}`);
    }
    function warn(msg) {
        if (printWarn) console.warn(`[${$c6a9e46ee7e4d896$export$2da9be4cfdb689b1()}] ${msg}`);
    }
    function callKarenFromHR() {
        console.warn(`calling Karen from HR ...`);
    }
    function makeCoffee() {
        console.warn(`making coffee ...`);
        console.warn(`
      )  (
     (   ) )
      ) ( (
    _______)_
 .-'---------|
( C|=========|
 '-./_/_/_/_/|
   '_________'
    '-------'
`);
    }
    return {
        log: log,
        warn: warn,
        makeCoffee: makeCoffee,
        callKarenFromHR: callKarenFromHR
    };
}
const $c6a9e46ee7e4d896$export$c2d084dc44961371 = $c6a9e46ee7e4d896$var$Print();





// format
function $820877bea407f5fe$export$3203edd9e5edd663(args = {}) {
    const defaults = {
        unit: 'seconds',
        format: 'hh:mm:ss'
    };
    const value = args.value;
    const format = args.format ?? defaults.format;
    const unit = args.unit ?? defaults.unit;
    if (unit === 'seconds') {
        let hour = Math.floor(value / 3600);
        let min = Math.floor(value % 3600 / 60);
        let sec = value % 60;
        let sD = sec < 10 ? `0${sec}` : `${sec}`;
        let mD = min < 10 ? `0${min}` : `${min}`;
        let hD = hour < 10 ? `0${hour}` : `${hour}`;
        let hDs = hour < 10 ? `${hour}` : `${hour}`;
        let res = ``;
        if (format === 'hh:mm:ss') res = `${hD}:${mD}:${sD}`;
        if (format === 'mm:ss') {
            if (value < 3600) res = `${mD}:${sD}`;
            else res = `${hD}:${mD}:${sD}`;
        }
        return res;
    }
    return value;
}
function $820877bea407f5fe$export$d19070df23277278(date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year}-at-${hour}-${minute}h`;
}
function $820877bea407f5fe$export$2da9be4cfdb689b1() {
    const date = new Date();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const milliseconds = date.getSeconds().toString().padStart(4, '0');
    return `${hours}:${minutes}:${seconds}:${milliseconds}`;
}
function $820877bea407f5fe$export$ea0a2d2ae29ba628(date = new Date(), local = true) {
    if (local) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${year}-${month}-${day}`;
    } else // toISOString returns always the utc date
    return date.toISOString().split('T')[0];
}
function $820877bea407f5fe$export$d9468344d3651243(x, precision = 1000) {
    return Math.round(x * precision) / precision;
}
function $820877bea407f5fe$export$772b6f10912cb36(kph) {
    return $820877bea407f5fe$export$d9468344d3651243(kph / 3.6);
}
function $820877bea407f5fe$export$7fb4fed351a997f3(mps) {
    return 3.6 * mps;
}
// Async
// var res = await backoff({max: 4, wait: 1000, fn: maybeFailOp, msg: 'debug'});
// needs a way to be canceled
async function $820877bea407f5fe$export$562bc4a862c31607(args = {}) {
    const defaults = {
        max: 1,
        wait: 1000,
        rate: (x)=>x * 1,
        success: (x)=>x,
        fail: (x)=>x
    };
    const max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, defaults.max);
    const wait = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.wait, defaults.wait);
    const fn = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.fn);
    const success = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.success, defaults.success);
    const fail = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.fail, defaults.fail);
    const rate = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.rate, defaults.rate);
    const msg = args.msg;
    async function recur(max, wait, fn, success, fail, msg) {
        try {
            const result = await fn(max);
            return success(result);
        } catch (e) {
            if (max <= 0) return fail(e);
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(msg)) console.log(`:retry :${msg} :in ${rate(wait)} :left ${max}`);
            await delay(wait);
            return recur(max - 1, rate(wait), fn, success, fail, msg);
        }
    }
    return await recur(max, wait, fn, success, fail, msg);
}
// Math
const $820877bea407f5fe$var$bod = Math.pow(2, 31) / 180;
const $820877bea407f5fe$var$dob = 180 / Math.pow(2, 31);
function $820877bea407f5fe$var$degToSemicircles(degrees) {
    return degrees * $820877bea407f5fe$var$bod;
}
function $820877bea407f5fe$var$semicirclesToDeg(semicircles) {
    return semicircles * $820877bea407f5fe$var$dob;
}
function $820877bea407f5fe$export$9c0987062f8f5d89(n) {
    return Math.log(n) * Math.LOG10E + 1 | 0;
}
function $820877bea407f5fe$export$bb0a9c36cf454ea0(min = 0, max = 10) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function $820877bea407f5fe$export$aac79e834d1b4aed(a, b) {
    return a >= b;
}
function $820877bea407f5fe$export$489c007ed603c05d(a, b) {
    return a <= b;
}
function $820877bea407f5fe$export$dafeacbfe3530cd9(a, b) {
    return a > b;
}
function $820877bea407f5fe$export$b961576059b7aeb6(a, b) {
    return a < b;
}
function $820877bea407f5fe$export$ddf89a9c5af38f94(min, max, value, lb = $820877bea407f5fe$export$aac79e834d1b4aed, ub = $820877bea407f5fe$export$489c007ed603c05d) {
    return lb(value, min) && ub(value, max);
}
function $820877bea407f5fe$export$7304eb65c858ba16(number) {
    let divisors = [
        1
    ];
    for(let i = 2; i < number / 2; i++)if (number % i === 0) divisors.push(i);
    return divisors;
}
// end Math
// Graphs
function $820877bea407f5fe$export$d73ee8ef04f5226a(value, leftMin, leftMax, rightMin, rightMax) {
    const leftSpan = leftMax - leftMin;
    const rightSpan = rightMax - rightMin;
    const valueScaled = (value - leftMin) / leftSpan;
    return rightMin + valueScaled * rightSpan;
}
function $820877bea407f5fe$export$801173a9ed5e91f6(hex) {
    return hex.replace('#', '').match(/.{1,2}/g).map((x)=>parseInt(x, 16));
}
function $820877bea407f5fe$export$92ce74b434f055ba(arr) {
    return '#' + arr.map((x)=>x.toString(16).toUpperCase()).join('');
}
function $820877bea407f5fe$export$58c1c8ee8c223f8f(hex1, hex2) {
    const color1 = $820877bea407f5fe$export$801173a9ed5e91f6(hex1);
    const color2 = $820877bea407f5fe$export$801173a9ed5e91f6(hex2);
    const color = color1.map((channel, i)=>parseInt((channel + color2[i]) / 2));
    return $820877bea407f5fe$export$92ce74b434f055ba(color);
}
// end Graphs
// WebBLE
function $820877bea407f5fe$export$834dfc94dde4b3d8(n) {
    let h = parseInt(n).toString(16).toUpperCase();
    if (h.length === 1) h = '0' + h;
    return '0x' + h;
}
// end WebBLE
// ANT+ and .FIT
const $820877bea407f5fe$var$garmin_epoch = Date.parse('31 Dec 1989 00:00:00 GMT');
function $820877bea407f5fe$export$42227781a6d43c62(timestamp) {
    return Math.round((timestamp - $820877bea407f5fe$var$garmin_epoch) / 1000);
}
function $820877bea407f5fe$export$3f4b674900f48111(fitTimestamp) {
    return fitTimestamp * 1000 + $820877bea407f5fe$var$garmin_epoch;
}
function $820877bea407f5fe$export$461939dd4422153() {
    return $820877bea407f5fe$export$42227781a6d43c62(Date.now());
}
function $820877bea407f5fe$export$5348c053b94136a6(timestamp1, timestamp2) {
    let difference = timestamp1 / 1000 - timestamp2 / 1000;
    return Math.round(Math.abs(difference));
}
function $820877bea407f5fe$export$e203afec977ab35c(speed, unit = 'kph') {
    const scale = 1000;
    if (unit === 'kph') return parseInt(speed / 3.6 * scale, 10);
    return speed;
}
function $820877bea407f5fe$export$c6c8e6734bdb4c30(distance, unit = 'km') {
    const scale = 100;
    if (unit === 'km') return parseInt(distance * 1000 * scale, 10);
    return distance;
}
function $820877bea407f5fe$export$b0d75975ac0be0e1(xs, at) {
    if (!(0, $c6a9e46ee7e4d896$export$43bee75e5e14138e)(xs)) throw new Error(`splitAt takes an array: ${xs}`);
    let i = -1;
    return xs.reduce((acc, x)=>{
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(x, at) || (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(acc.length, 0) && !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(x, at)) {
            acc.push([
                x
            ]);
            i++;
        } else acc[i].push(x);
        return acc;
    }, []);
}
function $820877bea407f5fe$export$5d04458e2a6c373e(xs = [], length = 0, value = 0) {
    for(let i = xs.length - 1; i < length; i += 1)xs.push(value);
    return xs;
}
function $820877bea407f5fe$export$c53208620547ef71(uint8array, start, end) {
    const crcTable = [
        0x0000,
        0xCC01,
        0xD801,
        0x1400,
        0xF001,
        0x3C00,
        0x2800,
        0xE401,
        0xA001,
        0x6C00,
        0x7800,
        0xB401,
        0x5000,
        0x9C01,
        0x8801,
        0x4400
    ];
    let crc = 0;
    for(let i = start; i < end; i++){
        const byte = uint8array[i];
        let tmp = crcTable[crc & 0xF];
        crc = crc >> 4 & 0x0FFF;
        crc = crc ^ tmp ^ crcTable[byte & 0xF];
        tmp = crcTable[crc & 0xF];
        crc = crc >> 4 & 0x0FFF;
        crc = crc ^ tmp ^ crcTable[byte >> 4 & 0xF];
    }
    return crc;
}
function $820877bea407f5fe$export$4de9669b66486993(basetype, method = 'set') {
    const uint8 = [
        0,
        2,
        7,
        10,
        13,
        'enum',
        'uint8',
        'string',
        'byte'
    ];
    const uint16 = [
        132,
        139,
        'uint16',
        'uint16z'
    ];
    const uint32 = [
        134,
        140,
        'uint32',
        'uint32z'
    ];
    const uint64 = [
        143,
        144,
        'uint64',
        'uint64z'
    ];
    const int8 = [
        1,
        'sint8'
    ];
    const int16 = [
        131,
        'sint16'
    ];
    const int32 = [
        133,
        'sint32'
    ];
    const int64 = [
        142,
        'sint64'
    ];
    const float32 = [
        136,
        'float32'
    ];
    const float64 = [
        137,
        'float64'
    ];
    if (uint8.includes(basetype)) return `${method}Uint8`;
    if (uint16.includes(basetype)) return `${method}Uint16`;
    if (uint32.includes(basetype)) return `${method}Uint32`;
    if (uint64.includes(basetype)) return `${method}Uint64`;
    if (int8.includes(basetype)) return `${method}Int8`;
    if (int16.includes(basetype)) return `${method}Int16`;
    if (int32.includes(basetype)) return `${method}Int32`;
    if (int64.includes(basetype)) return `${method}Int64`;
    if (float32.includes(basetype)) return `${method}Float32`;
    if (float64.includes(basetype)) return `${method}Float64`;
    return `${method}Uint8`;
}


//
// LocalStorageItem
//

function $e0788cfb3ff22b2a$export$e1f6585d046ad36a(args = {}) {
    const defaults = {
        fallback: '',
        isValid: function(v) {
            return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(v);
        },
        parse: function(str) {
            return str;
        },
        encode: function(str) {
            return str;
        }
    };
    let key = args.key;
    let fallback = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.fallback, defaults.fallback);
    let isValid = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.isValid, defaults.isValid);
    let parse = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.parse, defaults.parse);
    let encode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.encode, defaults.encode);
    if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(key)) throw new Error('LocalStorageItem needs a key!');
    function restore() {
        const inStorageValue = get();
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(inStorageValue, fallback)) set(fallback);
        return get();
    }
    function get() {
        const value = window.localStorage.getItem(`${key}`);
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value)) {
            console.warn(`Trying to get non-existing value from Local Storage at key ${key}!`);
            return fallback;
        }
        return parse(value);
    }
    function set(value) {
        if (isValid(value)) {
            window.localStorage.setItem(`${key}`, encode(value));
            return value;
        } else {
            console.warn(`Trying to enter invalid ${key} value in Local Storage: ${typeof value}`, value);
            window.localStorage.setItem(`${key}`, fallback);
            return fallback;
        }
    }
    function remove() {
        window.localStorage.removeItem(`${key}`);
    }
    return Object.freeze({
        restore: restore,
        get: get,
        set: set,
        remove: remove
    });
}


//
// IDB
//

//
// UUID
//
// Source:
// https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid/65500983#answer-65500983
//
// Usage:
// eval: console.log(Xuid.v4New)
// emits: {1eb4a659-8bdc-4ce0-c002-b1d505d38ea8}
class $36efb14127c8c4dd$var$Xuid {
    //@ edges.sm.st, ess.dev: MIT license Smallscript/David Simmons 2020
    //! Can't use `static const field = const` xbrowser (thus, const's duped)
    static get v4New() {
        const ns7Now = this.ns7Now, xnode48 = this.xnode48;
        let clock_seq13;
        // monotonic `clock_seq` guarantee (13-bits/time-quantum)
        if (ns7Now <= this.ns7Now_prevSeq && this.ns7Now_prevSeq) clock_seq13 = (this.ns7Now_prevSeq += 1n) - ns7Now & 0b1111111111111n;
        else clock_seq13 = 0n, this.ns7Now_prevSeq = ns7Now;
        const time60 = ns7Now << 4n & 0xFFFFFFFFFFFF0000n | ns7Now & 0x0000000000000FFFn, v4 = 0x100000000000000000000000000000000n | time60 << 64n | 0x00000000000040000000000000000000n | // M: V4
        0b110n << 61n | clock_seq13 << 48n | // N: Variant-2 time-seq collation
        xnode48, s = v4.toString(16); //.substr(1)
        return `{${s.substr(1, 8)}-${s.substr(9, 4)}-${s.substr(13, 4)}-${s.substr(17, 4)}-${s.substr(21, 12)}}`;
    }
    static get xnode48() /*:<BigInt#48>*/ {
        if (this.xnode48_) return this.xnode48_;
        let clockSeqNode;
        if (typeof URL !== 'undefined' && URL.createObjectURL) {
            const url = URL.createObjectURL(new Blob());
            const id = url.toString().split('/').reverse()[0].split('-');
            URL.revokeObjectURL(url);
            clockSeqNode = BigInt('0x' + id[3] + id[4]);
        } else {
            const a4 = this.a4;
            this.getRandomValues(this.a4);
            clockSeqNode = BigInt(a4[2]) << 32n | BigInt(a4[3]);
        }
        // simulate the 48-bit node-id and 13-bit clock-seq
        // to combine with 3-bit uuid-variant
        return this.xnode48_ = clockSeqNode & 0xFFFFFFFFFFFFn;
    }
    static get jdNow() /*:<double#ns7>*/ {
        // return 2440587.5+Date.now()/864e5 // <- Date-quantum-ms form (7ns form below)
        return this.jdFromNs7(this.ns7Now);
    }
    static get ns7Now() /*:<BigInt#60>*/ {
        if (typeof performance !== 'undefined' && performance.now) Reflect.defineProperty(this, 'ns7Now', Reflect.getOwnPropertyDescriptor(this, 'ns7Now_performance'));
        else Reflect.defineProperty(this, 'ns7Now', Reflect.getOwnPropertyDescriptor(this, 'ns7Now_Date'));
        return this.ns7Now;
    }
    static get ns7Now_Date() /*:<BigInt#60>*/ {
        // const epoch1582Ns7_bias = 0x1b2_1dd2_1381_4000  // V1 1582 Oct 15
        // const epoch1601Ns7_bias = 0x19d_b1de_d53e_8000n // FILETIME base
        const epoch1970Ns7 = BigInt(Date.now() * 10000.0);
        return epoch1970Ns7 + 0x1b21dd213814000n;
    }
    static get ns7Now_performance() /*:<BigInt#60>*/ {
        const epochPgNs7 = BigInt(performance.now() * /*15*/ 10000.0 | /*17*/ 0);
        if (!this.epoch1970PgNs7) // performance.timing.navigationStart
        this.epoch1970PgNs7 = this.ns7Now_Date - epochPgNs7;
        return epochPgNs7 + this.epoch1970PgNs7;
    }
    static dateFromJd(jd) {
        return new Date((jd - 2440587.5) * 864e5);
    }
    static dateFromNs7(ns7) {
        return new Date(Number(ns7 - 0x1b21dd213814000n) / 10000.0);
    }
    static jdFromNs7(ns7) {
        // atomic-clock leap-seconds (ignored)
        return 2440587.5 + Number(ns7 - 0x1b21dd213814000n) / 864e9;
    }
    static ns7FromJd(jd) {
        return BigInt((jd - 2440587.5) * 864e9) + 0x1b21dd213814000n;
    }
    static getRandomValues(va /*:<Uint32Array>*/ ) {
        if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(va);
        else for(let i = 0, n = va.length; i < n; i += 1)va[i] = Math.random() * 0x100000000 >>> 0;
    }
    static get a4() {
        return this.a4_ || (this.a4_ = new Uint32Array(4));
    }
    static ntohl(v) /*:<BigInt>*/ {
        let r = '0x', sign = 1n, s = BigInt(v).toString(16);
        if (s[0] == '-') s = s.substr(1), sign = -1n;
        for(let i = s.length; i > 0; i -= 2)r += i == 1 ? '0' + s[i - 1] : s[i - 2] + s[i - 1];
        return sign * BigInt(r);
    }
    static ntohl32(v) /*:<Number>*/ {
        return Number(this.ntohl(v));
    }
}
function $36efb14127c8c4dd$export$31b40729666a4ae0() {
    if ('crypto' in window && crypto.randomUUID) return crypto.randomUUID();
    return $36efb14127c8c4dd$var$Xuid.v4New;
}


function $e655ee46f487092f$var$promisify(request) {
    return new Promise((resolve, reject)=>{
        request.onsuccess = function(event) {
            return resolve(request.result);
        };
        request.onerror = function(event) {
            return reject(request.error);
        };
    });
}
function $e655ee46f487092f$var$IDB(args = {}) {
    let db;
    function setDB(idb) {
        db = idb;
    }
    async function start(database = '', version = 1, stores = []) {
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(database)) throw new Error(`:idb idb.start() needs database name!`);
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(database)) throw new Error(`:idb idb.start() called with empty name!`);
        await open(database, version, stores);
    }
    function open(name, version, storeNames) {
        console.log(`:idb :open :db '${name}' :store-name '${storeNames}' ...`);
        let openReq = window.indexedDB.open(name, version);
        return new Promise((resolve, reject)=>{
            openReq.onupgradeneeded = function(e) {
                setDB(openReq.result);
                console.log(`:idb :version ${db.version} :old ${e.oldVersion}`);
                switch(e.oldVersion){
                    // switch(db.version) {
                    case 0:
                        createStores(storeNames);
                    case 1:
                        update(storeNames);
                    case 2:
                        update(storeNames);
                    case 3:
                        latest(storeNames);
                }
            };
            openReq.onerror = function() {
                console.error(`:idb :error :open :db '${name}'`, openReq.error);
                return reject(openReq.error);
            };
            openReq.onsuccess = function() {
                setDB(openReq.result);
                console.log(`:idb :version ${db.version}`);
                return resolve(openReq.result);
            };
        });
    }
    function deleteStore(name) {
        let deleteReq = db.deleteObjectStore(name);
        return $e655ee46f487092f$var$promisify(deleteReq).then((res)=>{
            console.log(`:idb :delete-store '${name}'`);
            return res;
        }).catch((err)=>{
            console.error(`:idb :error :delete-store '${name}'`, err);
            return {};
        });
    }
    function createStore(name, keyPath = 'id') {
        if (!db.objectStoreNames.contains(name)) {
            db.createObjectStore(name, {
                keyPath: keyPath
            });
            console.log(`:idb :create-store '${name}'`);
        } else console.warn(`:idb :error :createStore 'trying to create store with existing name: ${name}'`);
    }
    function createStores(storeNames, keyPaths = []) {
        storeNames.forEach((storeName, i)=>{
            createStore(storeName, (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(keyPaths[i], 'id'));
        });
    }
    async function update(storeNames) {
        console.log(`:idb :update :stores ${storeNames}`);
        // create IndexedDB > db > session, workouts
        await createStores(storeNames);
    }
    function latest(storeNames) {
        console.log(`:idb :latest :stores ${storeNames}`);
    }
    function transaction(storeName, method, param, type = 'readonly') {
        if (!db.objectStoreNames.contains(storeName)) return undefined;
        let transaction1 = db.transaction(storeName, type);
        let store = transaction1.objectStore(storeName);
        let req;
        if (param === undefined) req = store[method]();
        else req = store[method](param);
        return $e655ee46f487092f$var$promisify(req).then((res)=>{
            console.log(`:idb :${method} :store '${storeName}' :success`);
            return res;
        }).catch((err)=>{
            console.error(`:idb :error :${method} :store '${storeName}'`, err);
            return [];
        });
    }
    function add(storeName, item) {
        return transaction(storeName, 'add', item, 'readwrite');
    }
    function put(storeName, item) {
        return transaction(storeName, 'put', item, 'readwrite');
    }
    function get(storeName, key) {
        return transaction(storeName, 'get', key, 'readonly');
    }
    function getAll(storeName) {
        return transaction(storeName, 'getAll', undefined, 'readonly');
    }
    function remove(storeName, id) {
        return transaction(storeName, 'delete', id, 'readwrite');
    }
    function clear(storeName) {
        return transaction(storeName, 'clear', undefined, 'readwrite');
    }
    function setId(item, id) {
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(item.id)) {
            if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(id)) id = (0, $36efb14127c8c4dd$export$31b40729666a4ae0)();
            item.id = id;
            console.log(`:idb :setId`, id);
        }
        return item;
    }
    return Object.freeze({
        start: start,
        open: open,
        createStore: createStore,
        deleteStore: deleteStore,
        add: add,
        put: put,
        get: get,
        getAll: getAll,
        remove: remove,
        clear: clear,
        setId: setId
    });
}
const $e655ee46f487092f$export$53df56d89c7d7ac4 = $e655ee46f487092f$var$IDB();





const $f66b95f67168c04c$export$42aa85db4eb429d1 = {
    noAuth: ':no-auth'
};
const $f66b95f67168c04c$export$905bf243392675e9 = {
    strava: 'strava',
    intervals: 'intervals',
    trainingPeaks: 'trainingPeaks'
};
function $f66b95f67168c04c$export$9a3fa0d339d13fa0() {
    function encode(name) {
        const param = name + '_' + (0, $36efb14127c8c4dd$export$31b40729666a4ae0)();
        return param;
    }
    function decode(param) {
        const parts = param.split('_');
        return {
            service: parts[0] ?? '',
            id: parts[1] ?? ''
        };
    }
    function store() {}
    function restore() {}
    return Object.freeze({
        encode: encode,
        decode: decode,
        store: store,
        restore: restore
    });
}
const $f66b95f67168c04c$export$d6e67cdb4484c6ad = $f66b95f67168c04c$export$9a3fa0d339d13fa0();



class $615dc4b6f4ba99dc$var$Config {
    #defaultStravaClientId = 0;
    #defaultIntervalsClientId = 0;
    #defaultTrainingPeaksClientId = 0;
    constructor(){
        this.env = {
            // PWA_URI: "http://localhost:1234",
            // API_URI: "http://localhost:8080",
            PWA_URI: window.location.origin ?? "https://auuki.com",
            API_URI: "https://api.auuki.com",
            STRAVA_CLIENT_ID: this.defaultStravaClientId,
            INTERVALS_CLIENT_ID: this.defaultIntervalsClientId,
            TRAINING_PEAKS_CLIENT_ID: this.defaultTrainingPeaksClientId
        };
    }
    setServices(args = {}) {
        this.env.STRAVA_CLIENT_ID = args.strava ?? this.defaultStravaClientId;
        this.env.INTERVALS_CLIENT_ID = args.intervals ?? this.defaultIntervalsClientId;
        this.env.TRAINING_PEAKS_CLIENT_ID = args.trainingPeaks ?? this.defaultTrainingPeaksClientId;
    }
    get() {
        return this.env;
    }
}
const $615dc4b6f4ba99dc$var$config = new $615dc4b6f4ba99dc$var$Config();
var $615dc4b6f4ba99dc$export$2e2bcd8739ae039 = $615dc4b6f4ba99dc$var$config;





function $a6d9171c3f0032d8$var$Strava(args = {}) {
    const serviceName = (0, $f66b95f67168c04c$export$905bf243392675e9).strava;
    const api_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().API_URI;
    const pwa_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().PWA_URI;
    let strava_client_id = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().STRAVA_CLIENT_ID;
    const update = function() {
        strava_client_id = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().STRAVA_CLIENT_ID;
    };
    // Step D
    async function connect() {
        const scope = 'activity:write';
        const state = (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).encode(serviceName);
        (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).store(state);
        const url = "https://www.strava.com/oauth/authorize?" + new URLSearchParams({
            client_id: strava_client_id,
            redirect_uri: pwa_uri,
            response_type: 'code',
            state: state,
            scope: scope
        }).toString();
        window.location.replace(url);
    }
    async function disconnect() {
        try {
            const stravaResponse = await fetch("https://www.strava.com/oauth/deauthorize", {
                method: 'POST'
            });
            console.log(`:oauth :strava :disconnect`);
            const stravaBody = await stravaResponse.text();
            const apiResponse = await fetch(api_uri + `/api/strava/deauthorize`, {
                method: 'POST',
                credentials: 'include'
            });
            const apiBody = await apiResponse.text();
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`services`, {
                strava: false
            });
        } catch (e) {
            console.log(`:strava :deauthorize :error `, e);
        }
    }
    // Step 3
    async function paramsHandler(args = {}) {
        const state = args.state ?? '';
        const code = args.code ?? '';
        const scope = args.scope ?? '';
        const url = `${api_uri}/api/strava/oauth/code` + '?' + new URLSearchParams({
            state: state,
            code: code,
            scope: scope
        }).toString();
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include'
            });
            const result = await response.text();
            console.log(`:oauth :strava :connnect`);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`services`, {
                strava: true
            });
            console.log(result);
            clearParams();
        } catch (e) {
            console.log(`:strava :oauth :code :error `, e);
        }
    }
    function clearParams() {
        window.history.pushState({}, document.title, window.location.pathname);
    }
    async function uploadWorkout(record) {
        const blob = record.blob;
        const workoutName = record.summary?.name ?? 'Powered by Auuki workout';
        const url = `${api_uri}/api/strava/upload`;
        const formData = new FormData();
        formData.append('name', workoutName);
        formData.append('file', blob);
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if (response.ok) return ':success';
            else {
                if (response.status === 403) {
                    console.log(`:api :no-auth`);
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:modal:error:open', (0, $f66b95f67168c04c$export$42aa85db4eb429d1).noAuth);
                }
                return ':fail';
            }
        } catch (e) {
            console.log(`:strava :upload :error `, e);
            return ':fail';
        }
    }
    return Object.freeze({
        connect: connect,
        disconnect: disconnect,
        paramsHandler: paramsHandler,
        uploadWorkout: uploadWorkout,
        update: update
    });
}
const $a6d9171c3f0032d8$var$strava = $a6d9171c3f0032d8$var$Strava();
var $a6d9171c3f0032d8$export$2e2bcd8739ae039 = $a6d9171c3f0032d8$var$strava;






function $13e019b38be36fc6$var$Intervals(args = {}) {
    const serviceName = (0, $f66b95f67168c04c$export$905bf243392675e9).intervals;
    const api_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().API_URI;
    const pwa_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().PWA_URI;
    let intervals_client_id = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().INTERVALS_CLIENT_ID;
    const update = function() {
        intervals_client_id = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().INTERVALS_CLIENT_ID;
    };
    // Step D
    async function connect() {
        const scope = 'ACTIVITY:WRITE,CALENDAR:READ,SETTINGS:READ';
        const state = (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).encode(serviceName);
        (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).store(state);
        const url = "https://intervals.icu/oauth/authorize?" + new URLSearchParams({
            client_id: intervals_client_id,
            redirect_uri: pwa_uri,
            scope: scope,
            state: state
        }).toString();
        window.location.replace(url);
    }
    async function disconnect() {
        // TODO:
        // try {
        //     const stravaResponse = await fetch(
        //         "https://intervals.icu/api/v1/disconnect-app",
        //         {method: 'DELETE',}
        //     );
        //     console.log(`:oauth :intervals :disconnect`);
        //     const stravaBody = await stravaResponse.text();
        //     const apiResponse = await fetch(
        //         api_uri+`/api/intervals/deauthorize`,
        //         {method: 'POST', credentials: 'include',},
        //     );
        //     const apiBody = await apiResponse.text();
        //     xf.dispatch(`services`, {intervals: false});
        // } catch (e) {
        //     console.log(`:intervals :deauthorize :error `, e);
        // }
        // fallback since it seems deauthorize it supported only from
        // the Intervals.icu settings page
        await connect();
    }
    // Step 3
    async function paramsHandler(args = {}) {
        const state = args.state ?? '';
        const code = args.code ?? '';
        const scope = args.scope ?? '';
        const url = `${api_uri}/api/intervals/oauth/code` + '?' + new URLSearchParams({
            state: state,
            code: code,
            scope: scope
        }).toString();
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include'
            });
            const result = await response.text();
            console.log(`:oauth :intervals :connnect`);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`services`, {
                intervals: true
            });
            clearParams();
        } catch (e) {
            console.log(``, e);
        }
    }
    function clearParams() {
        window.history.pushState({}, document.title, window.location.pathname);
    }
    async function uploadWorkout(record) {
        const blob = record.blob;
        const workoutName = record.summary?.name ?? 'Powered by Auuki workout';
        const url = `${api_uri}/api/intervals/upload`;
        const formData = new FormData();
        formData.append('file', blob);
        formData.append('name', workoutName);
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if (response.ok) return ':success';
            else {
                if (response.status === 403) {
                    console.log(`:api :no-auth`);
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:modal:error:open', (0, $f66b95f67168c04c$export$42aa85db4eb429d1).noAuth);
                }
                return ':fail';
            }
        } catch (error) {
            console.log(error);
            return ':fail';
        }
    }
    async function wod() {
        const oldest = (0, $820877bea407f5fe$export$ea0a2d2ae29ba628)();
        const newest = (0, $820877bea407f5fe$export$ea0a2d2ae29ba628)();
        const url = `${api_uri}/api/intervals/events` + '?' + new URLSearchParams({
            oldest: oldest,
            newest: newest
        }).toString();
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:planned', ':intervals:wod:success');
                console.log(data);
                return data.filter((item)=>(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(item.workout_file_base64));
            } else {
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:planned', ':intervals:wod:fail');
                if (response.status === 403) {
                    console.log(`:api :no-auth`);
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:modal:error:open', (0, $f66b95f67168c04c$export$42aa85db4eb429d1).noAuth);
                }
                return [];
            }
        } catch (error) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:planned', ':intervals:wod:fail');
            console.log(error);
            return [];
        }
    }
    async function wodMock() {
        const body = [
            {
                id: 47549572,
                start_date_local: `${(0, $820877bea407f5fe$export$ea0a2d2ae29ba628)()}T00:00:00`,
                category: "WORKOUT",
                name: "Intervals.icu Threshold",
                indoor: true,
                workout_filename: "Intervals_icu_Threshold.zwo",
                workout_file_base64: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/Pgo8d29ya291dF9maWxlPgogICAgPGF1dGhvcj5EaW1pdGFyIE1hcmlub3Y8L2F1dGhvcj4KICAgIDxuYW1lPkludGVydmFscy5pY3UgVGhyZXNob2xkPC9uYW1lPgogICAgPGRlc2NyaXB0aW9uPjwvZGVzY3JpcHRpb24+CiAgICA8c3BvcnRUeXBlPmJpa2U8L3Nwb3J0VHlwZT4KICAgIDx0YWdzLz4KICAgIDx3b3Jrb3V0PgogICAgICAgIDxXYXJtdXAgUG93ZXJIaWdoPSIwLjYyNyIgUG93ZXJMb3c9IjAuMzg5IiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMC42MjciIER1cmF0aW9uPSI2MCIvPgogICAgICAgIDxTdGVhZHlTdGF0ZSBzaG93X2F2Zz0iMSIgUG93ZXI9IjAuOTc4IiBEdXJhdGlvbj0iMzAiLz4KICAgICAgICA8U3RlYWR5U3RhdGUgc2hvd19hdmc9IjEiIFBvd2VyPSIwLjUiIER1cmF0aW9uPSIzMCIvPgogICAgICAgIDxTdGVhZHlTdGF0ZSBzaG93X2F2Zz0iMSIgUG93ZXI9IjAuOTc4IiBEdXJhdGlvbj0iMzAiLz4KICAgICAgICA8U3RlYWR5U3RhdGUgc2hvd19hdmc9IjEiIFBvd2VyPSIwLjUiIER1cmF0aW9uPSIzMCIvPgogICAgICAgIDxTdGVhZHlTdGF0ZSBzaG93X2F2Zz0iMSIgUG93ZXI9IjAuNTU5IiBEdXJhdGlvbj0iMTIwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMS4wIiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMC41IiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMS4wIiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMC41IiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMS4wIiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMC41IiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMS4wIiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMC41IiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMS4wIiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPFN0ZWFkeVN0YXRlIHNob3dfYXZnPSIxIiBQb3dlcj0iMC41IiBEdXJhdGlvbj0iMzAwIi8+CiAgICAgICAgPENvb2xkb3duIFBvd2VySGlnaD0iMC4zODkiIFBvd2VyTG93PSIwLjUiIER1cmF0aW9uPSIzMDAiLz4KICAgIDwvd29ya291dD4KPC93b3Jrb3V0X2ZpbGU+Cg=="
            }
        ];
        return body;
    }
    // {
    //     weight: Int,
    //     icu_weight: Int,
    //     icu_weight_sync: String,
    //     sportSettings: [{
    //         types: [String],
    //         ftp: Int,
    //         indoor_ftp: Int,
    //         lthr: Int,
    //         max_hr: Int,
    //     }]
    // }
    // ->
    // { weight: Int, ftp: Int }
    function athleteToSettings(athlete = {}, defaults = {
        weight: 0,
        ftp: 0
    }) {
        const sportSettings = athlete.sportSettings ?? [];
        const weight = athlete.weight ?? athlete.icu_weight ?? defaults.weight;
        let ftp = defaults.ftp;
        let rideSetting;
        let virtualRideSetting;
        for (let sportSetting of sportSettings){
            const types = sportSetting.types;
            for (let type of types){
                if (type === "VirtualRide") virtualRideSetting = sportSetting;
                if (type === "Ride") rideSetting = sportSetting;
            }
        }
        if (virtualRideSetting) {
            ftp = virtualRideSetting.indoor_ftp ?? virtualRideSetting.ftp ?? defaults.ftp;
            return {
                weight: weight,
                ftp: ftp
            };
        }
        if (rideSetting) {
            ftp = rideSetting.indoor_ftp ?? rideSetting.ftp ?? 0;
            return {
                weight: weight,
                ftp: ftp
            };
        }
        return {
            weight: weight,
            ftp: ftp
        };
    }
    async function getAthlete() {
        // GET /api/v1/athlete/{id}
        //
        // Weight is icu_weight (in kg).
        // The FTP is per sport (sportSettings array).
        // Search for one with types field containing ‘Ride’ or ‘VirtualRide’.
        // Then check ‘indoor_ftp’ (might be null) and ‘ftp’.
        // {
        //     weight: Int,
        //     icu_weight: Int,
        //     icu_weight_sync: String,
        //     sportSettings: [{
        //         types: [String]
        //         ftp: Int,
        //         indoor_ftp: Int,
        //         lthr: Int,
        //         max_hr: Int,
        //     }]
        // }
        const url = `${api_uri}/api/intervals/athlete`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:athlete', ':intervals:athlete:success');
                console.log(data);
                return athleteToSettings(data);
            } else {
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:athlete', ':intervals:athlete:fail');
                if (response.status === 403) {
                    console.log(`:api :no-auth`);
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:modal:error:open', (0, $f66b95f67168c04c$export$42aa85db4eb429d1).noAuth);
                }
                return athleteToSettings();
            }
        } catch (error) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:athlete', ':intervals:athlete:fail');
            console.log(error);
            return athleteToSettings();
        }
    }
    return Object.freeze({
        connect: connect,
        disconnect: disconnect,
        paramsHandler: paramsHandler,
        uploadWorkout: uploadWorkout,
        update: update,
        wod: wod,
        getAthlete: getAthlete,
        athleteToSettings: athleteToSettings,
        wodMock: wodMock
    });
}
const $13e019b38be36fc6$var$intervals = $13e019b38be36fc6$var$Intervals();
var $13e019b38be36fc6$export$2e2bcd8739ae039 = $13e019b38be36fc6$var$intervals;





function $2823724957b5fb1a$var$TrainingPeaks(args = {}) {
    const serviceName = (0, $f66b95f67168c04c$export$905bf243392675e9).trainingPeaks;
    const api_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().API_URI;
    const pwa_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().PWA_URI;
    let training_peaks_client_id = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().TRAINING_PEAKS_CLIENT_ID;
    const update = function() {
        training_peaks_client_id = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().TRAINING_PEAKS_CLIENT_ID;
    };
    // Step D
    async function connect() {
        const scope = 'file:write workouts:wod';
        const state = (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).encode(serviceName);
        (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).store(state);
        const url = "https://oauth.sandbox.trainingpeaks.com/OAuth/Authorize?" + new URLSearchParams({
            response_type: 'code',
            client_id: training_peaks_client_id,
            scope: scope,
            redirect_uri: pwa_uri,
            state: state
        }).toString();
        console.log(url);
        console.log(training_peaks_client_id);
        console.log(scope);
        console.log(pwa_uri);
        window.location.replace(url);
    }
    async function disconnect() {
        try {
            const serviceResponse = await fetch('https://oauth.sandbox.trainingpeaks.com/oauth/deauthorize', {
                method: 'POST'
            });
            console.log(`:oauth :trainingPeaks :disconnect`);
            const serviceBody = await serviceResponse.text();
            const apiResponse = await fetch(api_uri + `/api/trainingpeaks/deauthorize`, {
                method: 'POST',
                credentials: 'include'
            });
            const apiBody = await apiResponse.text();
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`services`, {
                trainingPeaks: false
            });
        } catch (e) {
            console.log(`:trainingPeaks :deauthorize :error `, e);
        }
    }
    // Step 3
    async function paramsHandler(args = {}) {
        const state = args.state ?? '';
        const code = args.code ?? '';
        const scope = args.scope ?? '';
        const url = `${api_uri}/api/trainingpeaks/oauth/code` + '?' + new URLSearchParams({
            state: state,
            code: code,
            scope: scope
        }).toString();
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include'
            });
            const result = await response.text();
            console.log(`:oauth :trainingPeaks :connnect`);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`services`, {
                trainingPeaks: true
            });
            console.log(result);
            clearParams();
        } catch (e) {
            console.log(`:trainingPeaks :oauth :code :error `, e);
        }
    }
    function clearParams() {
        window.history.pushState({}, document.title, window.location.pathname);
    }
    async function uploadWorkout(record) {
        const blob = record.blob;
        const workoutName = record.summary.name;
        const url = `${api_uri}/api/trainingpeaks/upload`;
        const formData = new FormData();
        formData.append('file', blob);
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if (response.ok) return ':success';
            else {
                if (response.status === 403) {
                    console.log(`:api :no-auth`);
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:modal:error:open', (0, $f66b95f67168c04c$export$42aa85db4eb429d1).noAuth);
                }
                return ':fail';
            }
        } catch (e) {
            console.log(`:trainingPeaks :upload :error `, e);
            return ':fail';
        }
    }
    return Object.freeze({
        connect: connect,
        disconnect: disconnect,
        paramsHandler: paramsHandler,
        uploadWorkout: uploadWorkout,
        update: update
    });
}
const $2823724957b5fb1a$var$trainingPeaks = $2823724957b5fb1a$var$TrainingPeaks();
var $2823724957b5fb1a$export$2e2bcd8739ae039 = $2823724957b5fb1a$var$trainingPeaks;









function $0a0f5809901d5ba7$var$Auth(args = {}) {
    const api_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().API_URI;
    const pwa_uri = (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).get().PWA_URI;
    let _loggedIn = false;
    let _hasApi = true;
    let _turnstileLoaded = false;
    let _turnstileId;
    let _expired = true;
    function loadTurnstile() {
        if (!_loggedIn && _hasApi && !_turnstileLoaded) {
            console.log(`:turnstile :load`);
            const script = document.createElement('script');
            script.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onloadTurnstile`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }
    }
    window.onloadTurnstile = function() {
        console.log(`:turnstile :onload`);
        _turnstileLoaded = true;
        renderTurnstile();
    };
    function renderTurnstile() {
        if ('turnstile' in window) {
            console.log(`:turnstile :render ${_turnstileId}`);
            _turnstileId = window.turnstile.render("#cf-turnstile-container", {
                sitekey: "0x4AAAAAAA2IUz1CU0EU3E-O"
            });
            _expired = false;
        }
    }
    function resetTurnstile() {
        if ('turnstile' in window) {
            console.log(`:turnstile :reset ${_turnstileId}`);
            window.turnstile.reset(_turnstileId);
            _expired = false;
        }
    }
    function isTurnstileExpired() {
        if ('turnstile' in window) {
            console.log(`:turnstile :reset ${_turnstileId}`);
            _expired = window.turnstile.isExpired(_turnstileId);
            return _expired;
        }
        return true;
    }
    function removeTurnstile() {
        if ('turnstile' in window) {
            console.log(`:turnstile :remove ${_turnstileId}`);
            window.turnstile.remove(_turnstileId);
            _expired = true;
        }
    }
    function isBrowser() {
        return 'bluetooth' in navigator && 'wakeLock' in navigator;
    }
    // {data: {FormData}} -> Void
    async function register(args = {}) {
        const url = `${api_uri}/api/register`;
        const data = args.data;
        if (data.email.trim() === '' || data.password.trim() === '' || data.password_confirmation.trim() === '' || !isBrowser()) {
            console.log(`:register :blocked :is-browser ${isBrowser()}`);
            return;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            const status = response.status;
            const json = await response.json();
            if (json.error) {
                console.log(':api :register :error');
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':error');
                return;
            }
            if (json?.result?.success) {
                console.log(':api :register :success');
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:nav', 'settings:profile');
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                return;
            }
            console.log(`register: :none`);
        } catch (error) {
            console.log(error);
        }
    }
    // {data: {FormData}} -> Void
    async function login(args = {}) {
        const url = `${api_uri}/api/login`;
        const data = args.data;
        if (data.email.trim() === '' || data.password.trim() === '' || !isBrowser()) {
            console.log(`:login :blocked :is-browser ${isBrowser()}`);
            return;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(data)
            });
            const json = await response.json();
            if (json.error) {
                console.log(`:api :login :error`);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':error');
                return;
            }
            if (json?.result?.success) {
                console.log(`:api :login :success`);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:profile');
                status();
                return;
            }
            console.log(`:api :login :none`);
        } catch (error) {
            console.log(error);
        }
    }
    async function logout() {
        const url = `${api_uri}/api/logout`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    logout: true
                })
            });
            const result = await response.json();
            console.log(`:api :logout :success`);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:logout');
            _loggedIn = false;
            if (_turnstileLoaded) renderTurnstile();
            else loadTurnstile();
            status();
        } catch (error) {
            console.log(error);
        }
    }
    // {data: {FormData}} -> Void
    async function forgot(args = {}) {
        const url = `${api_uri}/api/forgot-password`;
        const data = args.data;
        if (data.email.trim() === '' || !isBrowser()) {
            console.log(`:forgot :blocked :is-browser ${isBrowser()}`);
            return;
        }
        try {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':forgot:loading');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(data)
            });
            if (response.ok) {
                console.log(`:api :forgot :success`);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':forgot:success');
            } else {
                console.log(`:api :forgot :fail :with ${response.status}`);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':forgot:fail');
            }
        } catch (error) {
            console.log(`:api :forgot :fail`);
            console.log(error);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':forgot:fail');
        }
    }
    // {data: {FormData}} -> Void
    async function reset(args = {}) {
        const params = new URL(document.location).searchParams;
        const token = params.get('token') ?? '';
        const url = `${api_uri}/api/reset-password`;
        const data = args.data;
        data.token = token;
        if (data.password.trim() === '' || data.password_confirmation.trim() === '' || !isBrowser()) {
            console.log(`:reset :blocked :is-browser ${isBrowser()}`);
            return;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                console.log(`:api :reset :success`);
                window.history.pushState({}, document.title, window.location.pathname);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
            } else {
                console.error(`:api :reset :fail`);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':error');
            }
        } catch (e) {
            console.error(`:api :reset :error `, e);
        }
    }
    async function status() {
        const url = `${api_uri}/api/rpc`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    id: (0, $36efb14127c8c4dd$export$31b40729666a4ae0)(),
                    method: 'status_handler',
                    params: {
                        data: {}
                    }
                })
            });
            const status = response.status;
            const body = await response.json();
            if (response.ok) {
                console.log(`:api :profile`);
                _loggedIn = true;
                if (_turnstileLoaded) removeTurnstile();
                console.log(`:status`, body.result);
                (0, $615dc4b6f4ba99dc$export$2e2bcd8739ae039).setServices(body.result.services);
                (0, $a6d9171c3f0032d8$export$2e2bcd8739ae039).update();
                (0, $13e019b38be36fc6$export$2e2bcd8739ae039).update();
                (0, $2823724957b5fb1a$export$2e2bcd8739ae039).update();
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:profile');
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('services', body?.result);
                return body.result;
            }
            if (status === 403) {
                _loggedIn = false;
                _turnstileLoaded;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:status', ':logout');
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:login');
                return {
                    strava: false,
                    intervals: false,
                    trainingPeaks: false
                };
            }
            if (status === 500 || status === 405) {
                console.log(`:api :no-api`);
                _loggedIn = false;
                _hasApi = false;
                if (_turnstileLoaded) removeTurnstile();
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':no-api');
                return {
                    strava: false,
                    intervals: false,
                    trainingPeaks: false
                };
            }
            return {
                strava: false,
                intervals: false,
                trainingPeaks: false
            };
        } catch (error) {
            console.log(`:api :no-api`);
            console.log(error);
            if (_turnstileLoaded) removeTurnstile();
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':no-api');
            return {
                strava: false,
                intervals: false,
                trainingPeaks: false
            };
        }
    }
    return Object.freeze({
        register: register,
        login: login,
        logout: logout,
        forgot: forgot,
        reset: reset,
        status: status,
        loadTurnstile: loadTurnstile,
        resetTurnstile: resetTurnstile,
        isTurnstileExpired: isTurnstileExpired,
        removeTurnstile: removeTurnstile
    });
}
const $0a0f5809901d5ba7$var$auth = $0a0f5809901d5ba7$var$Auth();
var $0a0f5809901d5ba7$export$2e2bcd8739ae039 = $0a0f5809901d5ba7$var$auth;


//
function $7a52499dfd919b34$var$API() {
    const router = $7a52499dfd919b34$var$Router();
    async function start() {
        router.start();
    }
    function stop() {}
    return Object.freeze({
        auth: $0a0f5809901d5ba7$export$2e2bcd8739ae039,
        strava: $a6d9171c3f0032d8$export$2e2bcd8739ae039,
        intervals: $13e019b38be36fc6$export$2e2bcd8739ae039,
        trainingPeaks: $2823724957b5fb1a$export$2e2bcd8739ae039,
        start: start,
        stop: stop
    });
}
// TODO: create a proper minimalist router
function $7a52499dfd919b34$var$Router(args = {}) {
    async function start() {
        const status = await (0, $0a0f5809901d5ba7$export$2e2bcd8739ae039).status();
        const params = getParams();
        if (hasParams(params)) {
            console.log(params);
            await onQueryParams(params);
        } else // TODO: remove
        // get list of planned events once per period
        status.intervals;
        return;
    }
    function getParams() {
        return new URL(document.location).searchParams;
    }
    function hasParams(params) {
        if (params) return params.size > 0;
        else {
            const params = new URL(document.location).searchParams;
            return params.size > 0;
        }
    }
    async function onQueryParams(params) {
        // strava params
        const state = params.get('state');
        const code = params.get('code');
        const scope = params.get('scope');
        const error = params.get('error');
        const token = params.get('token');
        // switch
        if (error) {
            console.error(`:api :param :error `, error);
            return true;
        }
        if (!error && (code || scope || state)) {
            const { service: service, id: id } = (0, $f66b95f67168c04c$export$d6e67cdb4484c6ad).decode(state);
            console.log(`:api :onQueryParams service: ${service} id: ${id}`);
            if (service === (0, $f66b95f67168c04c$export$905bf243392675e9).strava) await (0, $a6d9171c3f0032d8$export$2e2bcd8739ae039).paramsHandler({
                state: state,
                code: code,
                scope: scope
            });
            if (service === (0, $f66b95f67168c04c$export$905bf243392675e9).intervals) await (0, $13e019b38be36fc6$export$2e2bcd8739ae039).paramsHandler({
                state: state,
                code: code,
                scope: scope
            });
            if (service === (0, $f66b95f67168c04c$export$905bf243392675e9).trainingPeaks) await (0, $2823724957b5fb1a$export$2e2bcd8739ae039).paramsHandler({
                state: state,
                code: code,
                scope: scope
            });
            return true;
        }
        if (!error && token) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:page-set', 'settings');
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:nav', 'settings:profile');
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('action:auth', ':password:reset');
            return true;
        }
        // clearParams();
        return false;
    }
    function clearParams() {
        window.history.pushState({}, document.title, window.location.pathname);
    }
    return Object.freeze({
        onQueryParams: onQueryParams,
        clearParams: clearParams,
        start: start
    });
}
var $7a52499dfd919b34$export$2e2bcd8739ae039 = $7a52499dfd919b34$var$API;


let $dcdf7029c6c77c73$export$550a5441be043621 = [
    `<workout_file>
    <author>RDR</author>
    <name>Steady 50% FTP</name>
    <category>Recovery</category>
    <description>Steady 50% FTP</description>
    <sportType>bike</sportType>
    <tags>
    </tags>
    <workout>
         <SteadyState Duration="1800" Power="0.50"/>
    </workout>
</workout_file>
`
];



// TODO: replace with ParserCombinators.js implementation
// - allow for wrong xml syntax
function $bf91c66429ac832e$var$readAttribute(args = {}) {
    const el = args.el;
    const name = args.name;
    const decode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.decode, (x)=>x);
    if (el.hasAttribute(name)) return decode(el.getAttribute(name));
    else return undefined;
}
function $bf91c66429ac832e$var$writeAttribute(args = {}) {
    const encode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.encode, (x)=>x);
    const name = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.name);
    const value = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.value);
    return `${name}="${encode(value)}"`;
}
function $bf91c66429ac832e$var$Attribute(args = {}) {
    const defaults = {
        name: '',
        decode: (x)=>x
    };
    const name = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.name, defaults.name);
    const decode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.decode, defaults.decode);
    const encode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.encode, decode);
    function getName() {
        return name;
    }
    function read(args = {}) {
        const el = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.el);
        return $bf91c66429ac832e$var$readAttribute({
            el: el,
            name: name,
            decode: decode
        });
    }
    function write(args = {}) {
        const value = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.value);
        return $bf91c66429ac832e$var$writeAttribute({
            name: name,
            value: value,
            encode: encode
        });
    }
    return Object.freeze({
        getName: getName,
        read: read,
        write: write
    });
}
function $bf91c66429ac832e$var$attributesToStep(args = {}) {
    const tag = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.element);
    const filter = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.filter, (_)=>true);
    const toName = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.toName, (x)=>x);
    return Object.keys(tag).reduce(function(acc, key) {
        if (filter(key) && (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(tag[key])) {
            const name = toName(key);
            const value = tag[key];
            acc[name] = value;
        }
        return acc;
    }, {});
}
function $bf91c66429ac832e$var$Step(element) {
    const spec = {
        element: element,
        filter: (key)=>!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(key, 'element'),
        toName: (key)=>key.toLowerCase()
    };
    return $bf91c66429ac832e$var$attributesToStep(spec);
}
function $bf91c66429ac832e$var$OnStep(element) {
    const spec = {
        element: element,
        filter: (key)=>key.startsWith('On') || (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(key, 'Cadence'),
        toName: (key)=>key.replace(/On/g, '').toLocaleLowerCase()
    };
    return $bf91c66429ac832e$var$attributesToStep(spec);
}
function $bf91c66429ac832e$var$OffStep(element) {
    const spec = {
        element: element,
        filter: (key)=>key.startsWith('Off') || key.endsWith('Resting'),
        toName: (key)=>key.replace(/On|Off|Resting/g, '').toLocaleLowerCase()
    };
    return $bf91c66429ac832e$var$attributesToStep(spec);
}
function $bf91c66429ac832e$var$Element(args = {}) {
    const defaults = {
        name: 'Unknown',
        tagOpen: '<Unknown',
        tagClose: ' />',
        content: ''
    };
    const name = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.name, defaults.name);
    const tagOpen = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.tagOpen, defaults.tagOpen);
    const tagClose = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.tagClose, defaults.tagClose);
    const toInterval = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.toInterval, defaultToInterval);
    const fromInterval = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.fromInterval, defaultFromInterval);
    const calcDuration = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.calcDuration, defaultCalcDuration);
    function getName() {
        return name;
    }
    function readContent(el) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(el)) {
            let value = el.textContent;
            if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(value)) return undefined;
            else return value;
        }
        return undefined;
    }
    function read(args = {}) {
        const el = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.el);
        const attrsNodeList = el.attributes || [];
        const length = attrsNodeList.length;
        let acc = {
            element: name
        };
        for(let i = 0; i < length; i++){
            const name = attrsNodeList[i].name;
            const attrFn = $bf91c66429ac832e$var$Attrs[name];
            const key = name;
            let value = attrsNodeList[i].value;
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(attrFn)) value = attrFn.read({
                el: el
            });
            acc[key] = value;
        }
        return acc;
    }
    function write(args = {}) {
        let { content: content, ...attributes } = args;
        content = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.content, defaults.content);
        const attrsString = Object.keys(attributes).reduce((acc, key)=>{
            acc += ` ${key}="${args[key]}"`;
            return acc;
        }, '');
        return `${tagOpen + attrsString}${content}${tagClose}`;
    }
    function defaultCalcDuration(element) {
        const duration = element.Duration;
        return duration;
    }
    function defaultToInterval(element) {
        const duration = calcDuration(element);
        const step = $bf91c66429ac832e$var$Step(element);
        return {
            duration: duration,
            steps: [
                step
            ]
        };
    }
    function defaultFromInterval(interval) {
        const res = {
            element: name,
            Duration: interval.duration
        };
        const step = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(interval.steps);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(step.power)) res.Power = step.power;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(step.cadence)) res.Cadence = step.cadence;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(step.slope)) res.Slope = step.slope;
        return res;
    }
    function readToInterval(args = {}) {
        return toInterval(read(args));
    }
    function writeFromInterval(args = {}) {
        return fromInterval(write(args));
    }
    return Object.freeze({
        getName: getName,
        readContent: readContent,
        read: read,
        write: write,
        toInterval: toInterval,
        fromInterval: fromInterval,
        calcDuration: calcDuration,
        defaultCalcDuration: defaultCalcDuration,
        defaultToInterval: defaultToInterval,
        readToInterval: readToInterval,
        defaultFromInterval: defaultFromInterval,
        writeFromInterval: writeFromInterval
    });
}
function $bf91c66429ac832e$var$IntervalsT(args = {}) {
    const spec = {
        name: 'IntervalsT',
        tagOpen: '<IntervalsT',
        tagClose: ' />',
        toInterval: toInterval,
        calcDuration: calcDuration
    };
    function calcDuration(element) {
        return element.Repeat * (element.OnDuration + element.OffDuration);
    }
    function toInterval(element) {
        const duration = calcDuration(element);
        const stepsCount = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(element.Repeat, 1);
        const onStep = $bf91c66429ac832e$var$OnStep(element);
        const offStep = $bf91c66429ac832e$var$OffStep(element);
        const steps = (0, $c6a9e46ee7e4d896$export$76d90c956114f2c2)(stepsCount)(function(acc) {
            acc.push({
                duration: onStep.duration,
                steps: [
                    onStep
                ]
            });
            acc.push({
                duration: offStep.duration,
                steps: [
                    offStep
                ]
            });
            return acc;
        })([]);
        return steps;
    }
    return $bf91c66429ac832e$var$Element(spec);
}
function $bf91c66429ac832e$var$Unknown(args = {}) {
    const spec = {
        name: 'Unknown',
        tagOpen: '<Unknown',
        tagClose: ' />'
    };
    // console.warn(`Unknown Element in .zwo workout: ${args.el}`);
    return $bf91c66429ac832e$var$Element(spec);
}
function $bf91c66429ac832e$var$FreeRide(args = {}) {
    const spec = {
        name: 'FreeRide',
        tagOpen: '<FreeRide',
        tagClose: ' />',
        toInterval: toInterval
    };
    function toInterval(element) {
        let duration = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(element.Duration, 1);
        const sim = element.Sim;
        const track = element.Track;
        const power = 0;
        const slope = 0;
        const steps = [];
        let simDuration = 0;
        let trackDistance = 0;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(sim)) {
            for(let i = 0; i < sim.length; i += 2){
                simDuration += sim[i + 1];
                steps.push({
                    duration: sim[i + 1],
                    slope: sim[i],
                    power: power
                });
            }
            if (simDuration < duration) steps.push({
                duration: duration - simDuration,
                slope: slope,
                power: power
            });
            if (simDuration > duration) duration = simDuration;
        } else if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(track)) for(let i = 0; i < track.length; i += 2){
            trackDistance += track[i + 1];
            steps.push({
                distance: track[i + 1],
                slope: track[i],
                power: power
            });
        }
        else steps.push({
            duration: duration,
            slope: slope,
            power: power
        });
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(track)) return {
            distance: trackDistance,
            steps: steps
        };
        return {
            duration: duration,
            steps: steps
        };
    }
    return $bf91c66429ac832e$var$Element(spec);
}
function $bf91c66429ac832e$var$Warmup(args = {}) {
    const defaults = {
        timeDx: 10
    };
    const timeDx = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.timeDx, defaults.timeDx);
    const spec = Object.assign({
        name: 'Warmup',
        tagOpen: '<Warmup',
        tagClose: ' />',
        toInterval: toInterval,
        fromInterval: fromInterval
    }, args.spec);
    function toInterval(element) {
        const duration = element.Duration;
        const powerLow = element.PowerLow ?? element.Power;
        const powerHigh = element.PowerHigh ?? element.Power;
        const cadence = element.Cadence;
        const cadenceLow = element.CadenceLow;
        const cadenceHigh = element.CadenceHigh;
        const stepsCount = parseInt(duration / timeDx);
        const powerDx = (powerHigh - powerLow) / (stepsCount - 1);
        const cadenceDx = (cadenceHigh - cadenceLow) / (stepsCount - 1);
        let steps = [];
        let stepPower = powerLow;
        let stepCadence = cadenceLow;
        for(let i = 0; i < stepsCount; i++){
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(cadenceLow) && (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(cadenceHigh)) {
                steps.push({
                    duration: timeDx,
                    power: stepPower,
                    cadence: Math.round(stepCadence)
                });
                stepCadence = stepCadence + cadenceDx;
            } else if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(cadence)) steps.push({
                duration: timeDx,
                power: stepPower,
                cadence: cadence
            });
            else steps.push({
                duration: timeDx,
                power: stepPower
            });
            stepPower = stepPower + powerDx;
        }
        const fixedSteps = steps.map((step)=>{
            step.power = (0, $c6a9e46ee7e4d896$export$a81f732198733497)(step.power, 2);
            return step;
        });
        return {
            duration: duration,
            steps: fixedSteps
        };
    }
    function fromInterval(interval) {
        const res = {
            element: spec.name,
            Duration: interval.duration
        };
        const start = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(interval.steps);
        const end = (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(interval.steps);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(start.power)) res.PowerLow = start.power;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(end.power)) res.PowerHigh = end.power;
        return res;
    }
    return $bf91c66429ac832e$var$Element(spec);
}
function $bf91c66429ac832e$var$Cooldown(args = {}) {
    const defaults = {
        timeDx: 10
    };
    const timeDx = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.timeDx, defaults.timeDx);
    const spec = {
        name: 'Cooldown',
        tagOpen: '<Cooldown',
        tagClose: ' />',
        toInterval: toInterval,
        fromInterval: fromInterval
    };
    function toInterval(element) {
        const duration = element.Duration;
        const powerLow = element.PowerHigh;
        const powerHigh = element.PowerLow;
        const stepsCount = parseInt(duration / timeDx);
        const powerDx = (powerHigh - powerLow) / (stepsCount - 1);
        let steps = [];
        let stepPower = powerHigh;
        for(let i = 0; i < stepsCount; i++){
            steps.push({
                duration: timeDx,
                power: stepPower
            });
            stepPower = stepPower - powerDx;
        }
        const fixedSteps = steps.map((step)=>{
            step.power = (0, $c6a9e46ee7e4d896$export$a81f732198733497)(step.power, 2);
            return step;
        });
        return {
            duration: duration,
            steps: fixedSteps
        };
    }
    function fromInterval(interval) {
        const res = {
            element: spec.name,
            Duration: interval.duration
        };
        const start = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(interval.steps);
        const end = (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(interval.steps);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(start.power)) res.PowerLow = start.power;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(end.power)) res.PowerHigh = end.power;
        return res;
    }
    return $bf91c66429ac832e$var$Element(spec);
}
function $bf91c66429ac832e$var$Ramp(args = {}) {
    const spec = {
        name: 'Ramp',
        tagOpen: '<Ramp',
        tagClose: ' />'
    };
    return $bf91c66429ac832e$var$Warmup(spec);
}
function $bf91c66429ac832e$var$SteadyState(args = {}) {
    const spec = Object.assign({
        name: 'SteadyState',
        tagOpen: '<SteadyState',
        tagClose: ' />',
        toInterval: toInterval
    }, args.spec);
    function toInterval(element) {
        const duration = element.Duration;
        const power = element.Power;
        const powerLow = element.PowerLow;
        const powerHigh = element.PowerHigh;
        let step = {};
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(power)) step = $bf91c66429ac832e$var$Step(element);
        else if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(powerLow) || (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(powerHigh)) {
            element.Power = [
                powerLow,
                powerHigh
            ].filter((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)).reduce((acc, x, _, { length: length })=>acc + x / length, 0);
            element.PowerLow = undefined;
            element.PowerHigh = undefined;
            step = $bf91c66429ac832e$var$Step(element);
        } else {
            element.Power = 0;
            element.Slope = 0;
            step = $bf91c66429ac832e$var$Step(element);
        }
        return {
            duration: duration,
            steps: [
                step
            ]
        };
    }
    return $bf91c66429ac832e$var$Element(spec);
}
function $bf91c66429ac832e$var$readContent(el) {
    if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(el)) {
        let value = el.textContent;
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(value)) return undefined;
        else return value;
    }
    return undefined;
}
function $bf91c66429ac832e$var$Head(args = {}) {
    const defaults = {
        author: 'Unknown',
        name: 'Custom',
        description: 'Custom',
        category: 'Custom',
        subcategory: '',
        sportType: 'bike',
        tags: ''
    };
    function read(args = {}) {
        const doc = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.doc);
        const author = $bf91c66429ac832e$var$readContent(doc.querySelector('author'));
        const name = $bf91c66429ac832e$var$readContent(doc.querySelector('name'));
        const description = $bf91c66429ac832e$var$readContent(doc.querySelector('description'));
        const category = $bf91c66429ac832e$var$readContent(doc.querySelector('category'));
        const subcategory = $bf91c66429ac832e$var$readContent(doc.querySelector('subcategory'));
        const sportType = $bf91c66429ac832e$var$readContent(doc.querySelector('sportType'));
        return {
            author: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(author, defaults.author),
            name: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(name, defaults.name),
            description: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(description, defaults.description),
            category: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(category, defaults.category),
            subcategory: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(subcategory, defaults.subcategory),
            sportType: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(sportType, defaults.sportType)
        };
    }
    function write(args = {}) {
        const author = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.author, defaults.author);
        const name = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.name, defaults.name);
        const description = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.description, defaults.description);
        const sportType = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.sportType, defaults.sportType);
        const category = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.category, defaults.category);
        const subcategory = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.subcategory, defaults.subcategory);
        const tags = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.tags, defaults.tags);
        const elements = [
            $bf91c66429ac832e$var$Elements.Author.write({
                content: author
            }),
            $bf91c66429ac832e$var$Elements.Name.write({
                content: name
            }),
            $bf91c66429ac832e$var$Elements.Category.write({
                content: category
            }),
            $bf91c66429ac832e$var$Elements.SubCategory.write({
                content: subcategory
            }),
            $bf91c66429ac832e$var$Elements.Description.write({
                content: description
            }),
            $bf91c66429ac832e$var$Elements.SportType.write({
                content: sportType
            }),
            $bf91c66429ac832e$var$Elements.Tags.write({
                content: tags
            })
        ];
        return elements.reduce((acc, el)=>acc + el.padStart(el.length + 4, ' ') + '\n', '\n');
    }
    function fromInterval(intervals) {
        return {
            author: intervals.meta.author,
            name: intervals.meta.name,
            category: intervals.meta.category,
            subcategory: intervals.meta.subcategory,
            sportType: intervals.meta.sportType,
            description: intervals.meta.description
        };
    }
    return Object.freeze({
        read: read,
        write: write,
        fromInterval: fromInterval
    });
}
function $bf91c66429ac832e$var$Body() {
    const defaults = {
        parent: 'workout'
    };
    const parent = defaults.parent;
    function apply(el, method = 'read') {
        const name = el.tagName;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)($bf91c66429ac832e$var$Elements[name])) return $bf91c66429ac832e$var$Elements[name][method]({
            el: el
        });
        return $bf91c66429ac832e$var$Elements.Unknown[method]({
            el: el
        });
    }
    function queryElements(doc) {
        const workoutEl = doc.querySelector(parent);
        const elements = Array.from(workoutEl.children);
        return elements;
    }
    function read(args = {}) {
        const doc = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.doc);
        const elements = queryElements(doc);
        return elements.map((el)=>apply(el, 'read'), []);
    }
    function readToInterval(args = {}) {
        const doc = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.doc);
        const elements = queryElements(doc);
        return elements.flatMap((el)=>apply(el, 'readToInterval'), []);
    }
    function writeElement(args = {}) {
        const { element: element, ...spec } = args;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)($bf91c66429ac832e$var$Elements[element])) return $bf91c66429ac832e$var$Elements[element].write(spec);
        return $bf91c66429ac832e$var$Elements.Unknown.write(spec);
    }
    function isRamp(steps) {
        return steps.length > 1;
    }
    function isRampUp(steps) {
        return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(steps).power < (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(steps).power;
    }
    function isRampDown(steps) {
        return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(steps).power > (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(steps).power;
    }
    function fromInterval(value) {
        const intervals = value.intervals;
        const acc = [];
        for(var i = 0; i < intervals.length; i++){
            var interval = intervals[i];
            var steps = intervals[i].steps;
            var node = {};
            if (isRamp(steps)) {
                if (isRampUp(steps)) node = $bf91c66429ac832e$var$Elements.Warmup.fromInterval(interval);
                else if (isRampDown(steps)) node = $bf91c66429ac832e$var$Elements.Cooldown.fromInterval(interval);
            } else node = $bf91c66429ac832e$var$Elements.SteadyState.fromInterval(interval);
            acc.push(node);
        }
        return acc;
    }
    function writeElements(elements) {
        return elements.reduce((acc, element)=>{
            const row = writeElement(element);
            acc += row.padStart(row.length + 8, ' ') + '\n';
            return acc;
        }, '');
    }
    function write(args = {}) {
        return `<workout>\n${writeElements(args)}    </workout>`;
    }
    return Object.freeze({
        read: read,
        readToInterval: readToInterval,
        fromInterval: fromInterval,
        write: write
    });
}
function $bf91c66429ac832e$var$encodeSim(arr) {
    return arr.join(',');
}
function $bf91c66429ac832e$var$decodeSim(str) {
    return str.split(',').reduce((acc, x)=>{
        const n = parseFloat(x);
        if (!isNaN(n)) acc.push(n);
        return acc;
    }, []);
}
const $bf91c66429ac832e$var$Attrs = {
    Duration: $bf91c66429ac832e$var$Attribute({
        name: 'Duration',
        decode: parseInt
    }),
    OnDuration: $bf91c66429ac832e$var$Attribute({
        name: 'OnDuration',
        decode: parseInt
    }),
    OffDuration: $bf91c66429ac832e$var$Attribute({
        name: 'OffDuration',
        decode: parseInt
    }),
    Power: $bf91c66429ac832e$var$Attribute({
        name: 'Power',
        decode: parseFloat
    }),
    OnPower: $bf91c66429ac832e$var$Attribute({
        name: 'OnPower',
        decode: parseFloat
    }),
    OffPower: $bf91c66429ac832e$var$Attribute({
        name: 'OffPower',
        decode: parseFloat
    }),
    PowerLow: $bf91c66429ac832e$var$Attribute({
        name: 'PowerLow',
        decode: parseFloat
    }),
    PowerHigh: $bf91c66429ac832e$var$Attribute({
        name: 'PowerHigh',
        decode: parseFloat
    }),
    Cadence: $bf91c66429ac832e$var$Attribute({
        name: 'Cadence',
        decode: parseInt
    }),
    CadenceLow: $bf91c66429ac832e$var$Attribute({
        name: 'CadenceLow',
        decode: parseInt
    }),
    CadenceHigh: $bf91c66429ac832e$var$Attribute({
        name: 'CadenceHigh',
        decode: parseInt
    }),
    CadenceResting: $bf91c66429ac832e$var$Attribute({
        name: 'CadenceResting',
        decode: parseInt
    }),
    Slope: $bf91c66429ac832e$var$Attribute({
        name: 'Slope',
        decode: parseFloat
    }),
    OnSlope: $bf91c66429ac832e$var$Attribute({
        name: 'OnSlope',
        decode: parseFloat
    }),
    OffSlope: $bf91c66429ac832e$var$Attribute({
        name: 'OffSlope',
        decode: parseFloat
    }),
    SlopeLow: $bf91c66429ac832e$var$Attribute({
        name: 'SlopeLow',
        decode: parseFloat
    }),
    SlopeHigh: $bf91c66429ac832e$var$Attribute({
        name: 'SlopeHigh',
        decode: parseFloat
    }),
    Distance: $bf91c66429ac832e$var$Attribute({
        name: 'Distance',
        decode: parseInt
    }),
    Sim: $bf91c66429ac832e$var$Attribute({
        name: 'Sim',
        decode: $bf91c66429ac832e$var$decodeSim,
        encode: $bf91c66429ac832e$var$encodeSim
    }),
    Track: $bf91c66429ac832e$var$Attribute({
        name: 'Track',
        decode: $bf91c66429ac832e$var$decodeSim,
        encode: $bf91c66429ac832e$var$encodeSim
    }),
    Repeat: $bf91c66429ac832e$var$Attribute({
        name: 'Repeat',
        decode: parseInt
    })
};
const $bf91c66429ac832e$var$Elements = {
    Warmup: $bf91c66429ac832e$var$Warmup(),
    // SteadyState: Element({name: 'SteadyState', tagOpen: '<SteadyState', tagClose: ' />'}),
    SteadyState: $bf91c66429ac832e$var$SteadyState(),
    IntervalsT: $bf91c66429ac832e$var$IntervalsT(),
    FreeRide: $bf91c66429ac832e$var$FreeRide(),
    Ramp: $bf91c66429ac832e$var$Ramp(),
    Cooldown: $bf91c66429ac832e$var$Cooldown(),
    Unknown: $bf91c66429ac832e$var$Unknown(),
    Author: $bf91c66429ac832e$var$Element({
        name: 'author',
        tagOpen: '<author>',
        tagClose: '</author>'
    }),
    Name: $bf91c66429ac832e$var$Element({
        name: 'name',
        tagOpen: '<name>',
        tagClose: '</name>'
    }),
    Category: $bf91c66429ac832e$var$Element({
        name: 'category',
        tagOpen: '<category>',
        tagClose: '</category>'
    }),
    SubCategory: $bf91c66429ac832e$var$Element({
        name: 'subcategory',
        tagOpen: '<subcategory>',
        tagClose: '</subcategory>'
    }),
    Description: $bf91c66429ac832e$var$Element({
        name: 'description',
        tagOpen: '<description>',
        tagClose: '</description>'
    }),
    SportType: $bf91c66429ac832e$var$Element({
        name: 'sporttype',
        tagOpen: '<sporttype>',
        tagClose: '</sporttype>'
    }),
    Tags: $bf91c66429ac832e$var$Element({
        name: 'tags',
        tagOpen: '<tags>',
        tagClose: '</tags>'
    })
};
const $bf91c66429ac832e$var$head = $bf91c66429ac832e$var$Head();
const $bf91c66429ac832e$var$body = $bf91c66429ac832e$var$Body();
const $bf91c66429ac832e$var$parser = new DOMParser();
function $bf91c66429ac832e$var$readToInterval(zwo) {
    const doc = $bf91c66429ac832e$var$parser.parseFromString(zwo, 'text/xml');
    const meta = $bf91c66429ac832e$var$head.read({
        doc: doc
    });
    const intervals = $bf91c66429ac832e$var$body.readToInterval({
        doc: doc
    });
    const duration = intervals.reduce((acc, i)=>acc + i.duration, 0);
    return {
        meta: Object.assign(meta, {
            duration: duration
        }),
        intervals: intervals
    };
}
function $bf91c66429ac832e$var$read(zwo) {
    const doc = $bf91c66429ac832e$var$parser.parseFromString(zwo, 'text/xml');
    const headElements = $bf91c66429ac832e$var$head.read({
        doc: doc
    });
    const bodyElements = $bf91c66429ac832e$var$body.read({
        doc: doc
    });
    return {
        head: headElements,
        body: bodyElements
    };
}
function $bf91c66429ac832e$var$fromInterval(intervals) {
    const res = {
        head: $bf91c66429ac832e$var$head.fromInterval(intervals),
        body: $bf91c66429ac832e$var$body.fromInterval(intervals)
    };
    return res;
}
function $bf91c66429ac832e$var$write(args = {}) {
    const headElements = $bf91c66429ac832e$var$head.write(args.head);
    const bodyElements = $bf91c66429ac832e$var$body.write(args.body);
    return `<workout_file>${headElements}    ${bodyElements}\n</workout_file>`;
}
const $bf91c66429ac832e$export$85cfc7c114c368df = {
    readAttribute: $bf91c66429ac832e$var$readAttribute,
    writeAttribute: $bf91c66429ac832e$var$writeAttribute,
    Attribute: $bf91c66429ac832e$var$Attribute,
    Attrs: $bf91c66429ac832e$var$Attrs,
    Element: $bf91c66429ac832e$var$Element,
    Elements: $bf91c66429ac832e$var$Elements,
    attributesToStep: $bf91c66429ac832e$var$attributesToStep,
    Step: $bf91c66429ac832e$var$Step,
    OnStep: $bf91c66429ac832e$var$OnStep,
    OffStep: $bf91c66429ac832e$var$OffStep,
    head: $bf91c66429ac832e$var$head,
    body: $bf91c66429ac832e$var$body,
    readToInterval: $bf91c66429ac832e$var$readToInterval,
    read: $bf91c66429ac832e$var$read,
    fromInterval: $bf91c66429ac832e$var$fromInterval,
    write: $bf91c66429ac832e$var$write
};


//
// File Handler
//

class $4720983c2827b7ff$var$FileHandler {
    Type = {
        OctetStream: 'application/octet-stream',
        textPlain: 'text/plain'
    };
    constructor(args){}
    readTextFile(file) {
        const self = this;
        const reader = new FileReader();
        reader.readAsText(file);
        return new Promise((resolve, reject)=>{
            reader.onload = function(event) {
                return resolve(reader.result);
            };
            reader.onerror = function(event) {
                return reject(reader.error);
            };
        });
    }
    readBinaryFile(file) {
        const self = this;
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        return new Promise((resolve, reject)=>{
            reader.onload = function(event) {
                return resolve(reader.result);
            };
            reader.onerror = function(event) {
                return reject(reader.error);
            };
        });
    }
    unsupporedFormat() {
        console.warn(`.fit workout files and other binary formats are not yet supported!`);
    }
    read(file) {
        const self = this;
        let ext = file.name.split('.').pop();
        switch(ext){
            case 'zwo':
                return self.readTextFile(file);
            case 'erg':
                return self.readTextFile(file);
            case 'mrc':
                return self.readTextFile(file);
            case 'fit':
                return self.readBinaryFile(file);
            default:
                self.unsupportedFormat();
                break;
        }
    }
    toBlob(buffer, type) {
        const self = this;
        return new Blob([
            buffer
        ], {
            type: type ?? self.Type.OctetStream
        });
    }
    download() {
        const self = this;
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        return function(buffer, name, type) {
            let url = window.URL.createObjectURL(self.toBlob(buffer, type));
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
        };
    }
}
const $4720983c2827b7ff$export$1d35aa040498b1e5 = new $4720983c2827b7ff$var$FileHandler();


// Qubic
// Source: https://stackoverflow.com/questions/27176423/function-to-solve-cubic-equation-analytically
function $46ce891f4ee94034$var$Qubic(a, b, c, d) {
    if (Math.abs(a) < 1e-8) {
        // Quadratic case, ax^2+bx+c=0
        a = b;
        b = c;
        c = d;
        if (Math.abs(a) < 1e-8) {
            // Linear case, ax+b=0
            a = b;
            b = c;
            if (Math.abs(a) < 1e-8) // Degenerate case
            return [];
            return [
                -b / a
            ];
        }
        var D = b * b - 4 * a * c;
        if (Math.abs(D) < 1e-8) return [
            -b / (2 * a)
        ];
        else if (D > 0) return [
            (-b + Math.sqrt(D)) / (2 * a),
            (-b - Math.sqrt(D)) / (2 * a)
        ];
        return [];
    }
    // Convert to depressed cubic t^3+pt+q = 0 (subst x = t - b/3a)
    var p = (3 * a * c - b * b) / (3 * a * a);
    var q = (2 * b * b * b - 9 * a * b * c + 27 * a * a * d) / (27 * a * a * a);
    var roots;
    if (Math.abs(p) < 1e-8) // p = 0 -> t^3 = -q -> t = -q^1/3
    roots = [
        Math.cbrt(-q)
    ];
    else if (Math.abs(q) < 1e-8) // q = 0 -> t^3 + pt = 0 -> t(t^2+p)=0
    roots = [
        0
    ].concat(p < 0 ? [
        Math.sqrt(-p),
        -Math.sqrt(-p)
    ] : []);
    else {
        D = q * q / 4 + p * p * p / 27;
        if (Math.abs(D) < 1e-8) // D = 0 -> two roots
        roots = [
            -1.5 * q / p,
            3 * q / p
        ];
        else if (D > 0) {
            // Only one real root
            var u = Math.cbrt(-q / 2 - Math.sqrt(D));
            roots = [
                u - p / (3 * u)
            ];
        } else {
            // D < 0, three roots, but needs to use complex numbers/trigonometric solution
            u = 2 * Math.sqrt(-p / 3);
            var t = Math.acos(3 * q / p / u) / 3; // D < 0 implies p < 0 and acos argument in [-1..1]
            var k = 2 * Math.PI / 3;
            roots = [
                u * Math.cos(t),
                u * Math.cos(t - k),
                u * Math.cos(t - 2 * k)
            ];
        }
    }
    // Convert back from depressed cubic
    for(var i = 0; i < roots.length; i++)roots[i] -= b / (3 * a);
    return roots;
}
// end Qubic
// Original
// written in VBA by GCUser based on Validation of a Mathematical Model for Road Cycling Power, Martin et al
// dynamic rolling resistance based on http://www.kreuzotter.de/english/espeed.htm#forml
function $46ce891f4ee94034$var$calcVel(power, slope = 0, mass = 85, crr = 0.004, cda = 0.4, rhoAir = 1, lossDt = 0, vWind = 0, wheelCircumference = 2000, accel = 0, modelSpokeDrag = false, modelBearingLoss = false, modelWheelInertia = false, modelDynRollRes = false, smallAngleApprox = false) {
    const pi = Math.PI; // 4 * Math.atan(1);
    const g = 9.80665;
    let cosBeta = 0;
    let sinBeta = 0;
    if (smallAngleApprox) {
        cosBeta = 1;
        sinBeta = slope;
    } else {
        cosBeta = 1 / Math.sqrt(slope * slope + 1); // Math.cos(Math.atan(slope))
        sinBeta = slope * cosBeta; // Math.sin(Math.atan(slope))
    }
    let mwheel = 0;
    if (modelWheelInertia) {
        const r = wheelCircumference / (2000 * pi);
        const i = 0.14;
        mwheel = i / Math.pow(r, 2); // r^2
    }
    const fw = modelSpokeDrag ? 0.0044 : 0;
    const c1bl = modelBearingLoss ? 0.091 : 0;
    const c2bl = modelBearingLoss ? 0.0087 : 0;
    const crv = modelDynRollRes ? 0.1 : 0;
    const c1ke = (mass + mwheel) * accel;
    const c1grav = g * mass * sinBeta;
    const c1roll = g * mass * crr * cosBeta;
    const c1air = 0.5 * (cda + fw) * rhoAir * Math.pow(vWind, 2); // vWind ^ 2
    const c2air = (cda + fw) * rhoAir * vWind;
    const c2dynroll = crv * cosBeta;
    const c3air = 0.5 * (cda + fw) * rhoAir;
    const c0 = -power * (1 - lossDt);
    const c1 = c1grav + c1roll + c1air + c1bl + c1ke;
    const c2 = c2air + c2bl + c2dynroll;
    const c3 = c3air;
    const roots = $46ce891f4ee94034$var$Qubic(c3, c2, c1, c0); // roots = Qubic(c2 / c3, c1 / c3, c0 / c3);
    let velocity = roots[0]; // original index is 1, maybe it's 0
    let thisVelocity;
    for (var root of roots){
        thisVelocity = root;
        if (velocity > 0) {
            if (thisVelocity > 0 && thisVelocity < velocity) velocity = thisVelocity;
        } else if (thisVelocity > velocity) velocity = thisVelocity;
    }
    return velocity;
}
function $46ce891f4ee94034$var$calcPower(velocity, slope, mass, crr = 0.004, cda = 0.4, rhoAir = 1, lossDt = 0, vWind = 0, wheelCircumference = 2000, accel = 0, modelSpokeDrag = false, modelBearingLoss = false, modelWheelInertia = false, modelDynRollRes = false, smallAngleApprox = false) {
    const pi = Math.PI; // 4 * Math.atan(1)
    const g = 9.80665; // exact grav accel
    let cosBeta = 0;
    let sinBeta = 0;
    if (smallAngleApprox) {
        cosBeta = 1;
        sinBeta = slope;
    } else {
        cosBeta = 1 / Math.sqrt(slope * slope + 1); // Math.cos(Math.atan(slope))
        sinBeta = slope * cosBeta; // Math.sin(Math.atan(slope))
    }
    let mwheel = 0;
    if (modelWheelInertia) {
        let r = wheelCircumference / (2000 * pi);
        let i = 0.14; // moment of inertia of wheels (kg*m^2)
        mwheel = i / Math.pow(r, 2);
    }
    const fw = modelSpokeDrag ? 0.0044 : 0; // incremental drag associated with area of spokes in m^2
    const crv = modelDynRollRes ? 0.1 : 0;
    const pgrav = g * mass * sinBeta * velocity;
    const proll = g * crr * mass * cosBeta * velocity;
    const pair = 0.5 * (cda + fw) * rhoAir * Math.pow(velocity + vWind, 2) * velocity;
    const pdynroll = velocity * crv * cosBeta * velocity;
    const pke = (mass + mwheel) * accel * velocity;
    const pwbearing = modelBearingLoss ? 0.091 * velocity + 0.0087 * Math.pow(velocity, 2) : 0;
    return (pgrav + proll + pair + pke + pwbearing + pdynroll) / (1 - lossDt);
}
// end Original
// Usage:
// var v = calcVel(200, 0.00, 75 + 10, 0.00330, 0.5, 1.225, 0.02, 0, 2105, 0, true, true, true, true, true) * 3.6 -> 29.251301130884464
// calcPower(v /3.6, 0.00, 75 + 10, 0.00330, 0.5, 1.225, 0.02, 0, 2105, 0, true, true, true, true, true) -> 200.00000000003962
// var v = calcVel(200, 0.00, 75 + 10, 0.00330, 0.5, 1.225, 0.02, 0, 2105, 0, true, true, true, true, true) * 3.6;
// p = calcPower(v/3.6, 0.00, 75 + 10, 0.00330, 0.5, 1.225, 0.02, 0, 2105, 0, true, true, true, true, true);
function $46ce891f4ee94034$export$a1edc412be3e1841(args = {
    use: {}
}) {
    const defaults = {
        mass: 85,
        slope: 0,
        wheelCircumference: 2105,
        drivetrainLoss: 0.02,
        crr: 0.004,
        windSpeed: 0,
        rho: 1.275,
        dragCoefficient: 1.0,
        frontalArea: 0.4,
        CdA: 0.4,
        draftingFactor: 1,
        use: {
            spokeDrag: false,
            bearingLoss: false,
            wheelInertia: false,
            useDynamicCrr: false
        }
    };
    const pi = Math.PI;
    const g = 9.80665;
    const wheelCircumference = args.wheelCircumference ?? defaults.wheelCircumference;
    const drivetrainLoss = args.drivetrainLoss ?? defaults.drivetrainLoss;
    const crr = args.crr ?? defaults.crr;
    const rho = args.rho ?? defaults.rho;
    const CdA = args.CdA ?? defaults.CdA;
    const use = Object.assign(defaults.use, args.use);
    function CosBeta(slope) {
        return 1 / Math.sqrt(slope * slope + 1);
    }
    function SinBeta(slope, cosBeta) {
        return slope * cosBeta;
    }
    function calcWheelInertia(wheelCircumference, useWheelInertia = false) {
        if (useWheelInertia) {
            const r = wheelCircumference / (2000 * pi);
            const i = 0.14;
            return i / Math.pow(r, 2);
        }
        return 0;
    }
    const wheelInertia = calcWheelInertia(wheelCircumference, use.wheelInertia);
    const spokeDrag = use.spokeDrag ? 0.0044 : 0;
    const c1bearingLoss = use.bearingLoss ? 0.091 : 0;
    const c2bearingLoss = use.bearingLoss ? 0.0087 : 0;
    const crv = use.dynamicCrr ? 0.1 : 0;
    function powerToMaxSpeed(args = {}) {
        const power = args.power;
        const slope = args.slope ?? defaults.slope;
        const mass = args.mass ?? defaults.mass;
        const windSpeed = args.windSpeed ?? defaults.windSpeed;
        const acceleration = args.acceleration ?? 0;
        const drivetrainLoss = args.drivetrainLoss ?? 0; //defaults.drivetrainLoss;
        const draftingFactor = args.draftingFactor ?? defaults.draftingFactor;
        const cosBeta = CosBeta(slope);
        const sinBeta = SinBeta(slope, cosBeta);
        const c1KE = (mass + wheelInertia) * acceleration;
        const c1Grav = g * mass * sinBeta;
        const c1Roll = g * mass * crr * cosBeta;
        const c1Air = 0.5 * (CdA + spokeDrag) * rho * Math.pow(windSpeed, 2);
        const c2Air = (CdA + spokeDrag) * rho * windSpeed;
        const c2DynamicCrr = crv * cosBeta;
        const c3Air = 0.5 * (CdA + spokeDrag) * rho;
        const c0 = -power * (1 - drivetrainLoss);
        const c1 = c1Grav + c1Roll + c1Air + c1bearingLoss + c1KE;
        const c2 = c2Air + c2bearingLoss + c2DynamicCrr;
        const c3 = c3Air;
        const roots = $46ce891f4ee94034$var$Qubic(c3, c2, c1, c0);
        let velocity = roots[0];
        for (var root of roots){
            if (velocity > 0) {
                if (root > 0 && root < velocity) velocity = root;
            } else if (root > velocity) velocity = root;
        }
        return velocity;
    }
    function virtualSpeed(args = {}) {
        const power = args.power; // W
        const slope = args.slope ?? defaults.slope; // 0.01 is 1%
        const mass = args.mass ?? defaults.mass; // kg
        const windSpeed = args.windSpeed ?? 0; // m/s
        const drivetrainLoss = args.drivetrainLoss ?? 0;
        const draftingFactor = args.draftingFactor ?? defaults.draftingFactor; // 0..1
        const dt = args.dt ?? 1; // s
        const speedPrev = args.speed ?? 0; // m/s
        let speed = args.speed ?? 0; // m/s
        let distance = args.distance ?? 0; // m
        let altitude = args.altitude ?? 0; // m
        const cosBeta = CosBeta(slope);
        const sinBeta = SinBeta(slope, cosBeta);
        const gravitationalResistance = g * mass * sinBeta;
        const rollingResistance = g * mass * cosBeta * crr + speedPrev * crv * cosBeta;
        const windResistance = 0.5 * rho * (CdA + spokeDrag) * Math.pow(speed + windSpeed, 2) * draftingFactor;
        const bearingLossResistance = use.bearingLoss ? 0.091 + 0.0087 * speedPrev : 0;
        const keResistance = 0;
        const totalResistance = gravitationalResistance + rollingResistance + windResistance + bearingLossResistance + keResistance;
        const powerSteadyState = totalResistance * speedPrev;
        const powerKE = power * (1 - drivetrainLoss) - powerSteadyState;
        speed = Math.sqrt(Math.pow(speedPrev, 2) + 2 * powerKE * dt / (mass + wheelInertia));
        if (speed < 0 || isNaN(speed)) speed = 0;
        const acceleration = (speed - speedPrev) / dt;
        const dx = speed * dt;
        const da = dx * sinBeta;
        distance += dx;
        altitude += da;
        if (altitude < 0) altitude = 0;
        return {
            acceleration: acceleration,
            speed: speed,
            distance: distance,
            altitude: altitude
        };
    }
    function virtualSpeedCF(args = {}) {
        const power = args.power; // W
        const slope = args.slope ?? defaults.slope; // 0.01 is 1%
        const mass = args.mass ?? defaults.mass; // kg
        const windSpeed = args.windSpeed ?? 0; // m/s
        const drivetrainLoss = args.drivetrainLoss ?? 0;
        const draftingFactor = args.draftingFactor ?? defaults.draftingFactor; // 0..1
        const dt = args.dt ?? 1; // s
        const speedPrev = args.speed ?? 0; // m/s
        let speed = args.speed ?? 0; // m/s
        let distance = args.distance ?? 0; // m
        let altitude = args.altitude ?? 0; // m
        let ascent = args.ascent ?? 0; // m
        const cosBeta = CosBeta(slope);
        const sinBeta = SinBeta(slope, cosBeta);
        const c1bl = c1bearingLoss;
        const c2bl = c2bearingLoss;
        // set to zero for no pke modeling, one for full pke modeling
        const pkefactor = 1;
        const c0ke = -0.5 * (mass + wheelInertia) * Math.pow(speedPrev, 2) * pkefactor / dt;
        const c2ke = 0.5 * (mass + wheelInertia) * pkefactor / dt;
        const c1grav = g * mass * sinBeta;
        const c1roll = g * mass * crr * cosBeta;
        const c1air = 0.5 * (CdA + spokeDrag) * rho * Math.pow(windSpeed, 2) * draftingFactor;
        const c2air = (CdA + spokeDrag) * rho * windSpeed * draftingFactor;
        const c2dynroll = crv * cosBeta;
        const c3air = 0.5 * (CdA + spokeDrag) * rho * draftingFactor;
        const c0 = -power * (1 - drivetrainLoss) + c0ke;
        const c1 = c1grav + c1roll + c1air + c1bl;
        const c2 = c2air + c2bl + c2dynroll + c2ke;
        const c3 = c3air;
        const roots = $46ce891f4ee94034$var$Qubic(c3, c2, c1, c0);
        speed = roots[0];
        let thisSpeed;
        for (var root of roots){
            thisSpeed = root;
            if (speed > 0) {
                if (thisSpeed > 0 && thisSpeed < speed) speed = thisSpeed;
            } else if (thisSpeed > speed) speed = thisSpeed;
        }
        if (speed < 0.1 || isNaN(speed)) speed = 0;
        const acceleration = (speed - speedPrev) / dt;
        const dx = speed * dt;
        const da = dx * sinBeta;
        distance += dx;
        altitude += da;
        ascent += da > 0 ? da : 0;
        if (altitude < 0) altitude = 0;
        return {
            acceleration: acceleration,
            speed: speed,
            distance: distance,
            altitude: altitude,
            ascent: ascent
        };
    }
    function trainerSpeed(args = {}) {
        const slope = args.slope ?? defaults.slope; // 0.01 is 1%
        const dt = args.dt ?? 1; // s
        const speedPrev = args.speedPrev ?? 0; // m/s
        let speed = args.speed ?? 0; // m/s
        let distance = args.distance ?? 0; // m
        let altitude = args.altitude ?? 0; // m
        let ascent = args.ascent ?? 0; // m
        const cosBeta = CosBeta(slope);
        const sinBeta = SinBeta(slope, cosBeta);
        const acceleration = (speed - speedPrev) / dt;
        const dx = speed * dt;
        const da = dx * sinBeta;
        distance += dx;
        altitude += da;
        ascent += da > 0 ? da : 0;
        if (altitude < 0) altitude = 0;
        return {
            acceleration: acceleration,
            distance: distance,
            altitude: altitude,
            ascent: ascent
        };
    }
    return Object.freeze({
        powerToMaxSpeed: powerToMaxSpeed,
        virtualSpeed: virtualSpeed,
        virtualSpeedCF: virtualSpeedCF,
        trainerSpeed: trainerSpeed
    });
}


//
// FITjs
//


const $46e0b5f74a2a4c34$export$f244c03754a3885c = {
    normal: 'normal',
    timestamp: 'timestamp'
};
const $46e0b5f74a2a4c34$export$2edcab8dd1869daa = {
    header: 'header',
    definition: 'definition',
    data: 'data',
    crc: 'crc'
};
// Base Type To DataView accessor method
const $46e0b5f74a2a4c34$var$uint8 = [
    0,
    2,
    7,
    10,
    13,
    'enum',
    'uint8',
    'string',
    'byte'
];
const $46e0b5f74a2a4c34$var$uint16 = [
    132,
    139,
    'uint16',
    'uint16z'
];
const $46e0b5f74a2a4c34$var$uint32 = [
    134,
    140,
    'uint32',
    'uint32z'
];
const $46e0b5f74a2a4c34$var$uint64 = [
    143,
    144,
    'uint64',
    'uint64z'
];
const $46e0b5f74a2a4c34$var$int8 = [
    1,
    'sint8'
];
const $46e0b5f74a2a4c34$var$int16 = [
    131,
    'sint16'
];
const $46e0b5f74a2a4c34$var$int32 = [
    133,
    'sint32'
];
const $46e0b5f74a2a4c34$var$int64 = [
    142,
    'sint64'
];
const $46e0b5f74a2a4c34$var$float32 = [
    136,
    'float32'
];
const $46e0b5f74a2a4c34$var$float64 = [
    137,
    'float64'
];
function $46e0b5f74a2a4c34$export$4de9669b66486993(basetype, method = 'set') {
    if ($46e0b5f74a2a4c34$var$uint8.includes(basetype)) return `${method}Uint8`;
    if ($46e0b5f74a2a4c34$var$uint16.includes(basetype)) return `${method}Uint16`;
    if ($46e0b5f74a2a4c34$var$uint32.includes(basetype)) return `${method}Uint32`;
    if ($46e0b5f74a2a4c34$var$uint64.includes(basetype)) return `${method}Uint64`;
    if ($46e0b5f74a2a4c34$var$int8.includes(basetype)) return `${method}Int8`;
    if ($46e0b5f74a2a4c34$var$int16.includes(basetype)) return `${method}Int16`;
    if ($46e0b5f74a2a4c34$var$int32.includes(basetype)) return `${method}Int32`;
    if ($46e0b5f74a2a4c34$var$int64.includes(basetype)) return `${method}Int64`;
    if ($46e0b5f74a2a4c34$var$float32.includes(basetype)) return `${method}Float32`;
    if ($46e0b5f74a2a4c34$var$float64.includes(basetype)) return `${method}Float64`;
    return `${method}Uint8`;
}
// END Base Type To DataView accessor method
// BaseType | DataviewType, DataView, Int, Bool, Bool -> Int?
function $46e0b5f74a2a4c34$export$513f42987b822fd7(type, dataview, i = 0, architecture = true, useBaseType = true) {
    if (useBaseType) return dataview[$46e0b5f74a2a4c34$export$4de9669b66486993(type, 'get')](i, architecture);
    try {
        return dataview[`get${type}`](i, architecture);
    } catch (e) {
        console.error(`:fit :getView ${type} at ${i}`, e);
    }
}
// Int, DataView, Int, Bool, -> String
function $46e0b5f74a2a4c34$var$getStringView(size, dataview, i = 0, architecture = true) {
    let value = '';
    for(let f = 0; f < size; f++)value += String.fromCharCode(dataview.getUint8(i + f, architecture));
    return value.replace(/\x00/gi, '');
}
// BaseType | DataviewType, Number, DataView, Int, Bool -> Dataview
function $46e0b5f74a2a4c34$export$78fa5045d0400717(type, value, dataview, i = 0, architecture = true, useBaseType = true) {
    if (useBaseType) return dataview[$46e0b5f74a2a4c34$export$4de9669b66486993(type, 'set')](i, value, architecture);
    return dataview[`set${type}`](i, value, architecture);
}
function $46e0b5f74a2a4c34$export$7a0ab2bd845e822(args = {}) {
    return Object.freeze({
        encode: args.encode ?? ((x)=>x),
        decode: args.decode ?? ((x)=>x)
    });
}
const $46e0b5f74a2a4c34$export$fb4220bff6c248ec = $46e0b5f74a2a4c34$export$7a0ab2bd845e822();
function $46e0b5f74a2a4c34$var$FitString() {
    // BaseType -> Bool
    function isString(base_type) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(base_type, 7);
    }
    function encode() {}
    // {size: Int}, DataView, Int, Bool, -> String
    function decode(field, dataview, i = 0, architecture) {
        return $46e0b5f74a2a4c34$var$getStringView(field.size, dataview, i, architecture);
    }
    return Object.freeze({
        isString: isString,
        encode: encode,
        decode: decode
    });
}
function $46e0b5f74a2a4c34$var$FitTimestamp() {
    const garmin_epoch = Date.parse('31 Dec 1989 00:00:00 GMT');
    // FitSemanticType -> Bool
    function isTimestamp(type) {
        return [
            'date_time',
            'local_date_time'
        ].includes(type);
    }
    // JSTimestamp -> FitTimestamp
    function apply(jsTimestamp) {
        return Math.round((jsTimestamp - garmin_epoch) / 1000);
    }
    // FitTimestamp -> JSTimestamp
    function remove(fitTimestamp) {
        return fitTimestamp * 1000 + garmin_epoch;
    }
    // JSTimestamp, JSTimestamp -> FitTimestamp
    function elapsed(start, end) {
        return apply(end) - apply(start);
    }
    function encode(field, value, view, i, architecture) {
        return $46e0b5f74a2a4c34$export$78fa5045d0400717(field.base_type, apply(value), view, i, architecture);
    }
    // {base_type: BaseType}, Dataview, Int, Bool -> Timestamp
    function decode(field, view, i, architecture) {
        return remove($46e0b5f74a2a4c34$export$513f42987b822fd7(field.base_type, view, i, architecture));
    }
    return Object.freeze({
        isTimestamp: isTimestamp,
        apply: apply,
        remove: remove,
        elapsed: elapsed,
        encode: encode,
        decode: decode
    });
}
function $46e0b5f74a2a4c34$var$FitNumber() {
    function isNumber() {
        throw `Not implemented!`;
    }
    function apply(scale, offset, value, invalid) {
        if (invalid !== undefined && value === invalid) return value;
        return (value ?? 0) * (scale ?? 1) + (offset ?? 0) * (scale ?? 1);
    }
    function remove(scale, offset, value, invalid) {
        if (invalid !== undefined && value === invalid) return value;
        return ((value ?? 0) - (offset ?? 0) * (scale ?? 1)) / (scale ?? 1);
    }
    // {base_type: BaseType, scale: Int, offset: Int}, Number, DataView, Int, Bool,
    // ->
    // DataView
    function encode(field, value, view, i = 0, architecture = true) {
        return $46e0b5f74a2a4c34$export$78fa5045d0400717(field.base_type, apply(field.scale, field.offset, value, field.invalid), view, i, architecture);
    }
    // {base_type: BaseType, scale: Int, offset: Int}, DataView, Int, Bool,
    // ->
    // Number
    function decode(field, view, i = 0, architecture = true) {
        return remove(field.scale, field.offset, $46e0b5f74a2a4c34$export$513f42987b822fd7(field.base_type, view, i, architecture), field.invalid);
    }
    return Object.freeze({
        isNumber: isNumber,
        apply: apply,
        remove: remove,
        encode: encode,
        decode: decode
    });
}
const $46e0b5f74a2a4c34$export$bf9fb029d174d554 = {
    string: $46e0b5f74a2a4c34$var$FitString(),
    timestamp: $46e0b5f74a2a4c34$var$FitTimestamp(),
    number: $46e0b5f74a2a4c34$var$FitNumber()
};


function $5d332605c5db3f98$export$b121a1c183ce1009(args = {}) {
    const _type = (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).crc;
    const size = 2;
    const architecture = args.architecture ?? true;
    function toGetter(file) {
        if ((0, $c6a9e46ee7e4d896$export$2f3f84b787c83cc3)(file)) return function(file, i) {
            return file.getUint8(i, true);
        };
        return function(file, i) {
            return file[i];
        };
    }
    // DataView, Int, Int -> u16
    function calculateCRC(file, start, end) {
        const crcTable = [
            0x0000,
            0xCC01,
            0xD801,
            0x1400,
            0xF001,
            0x3C00,
            0x2800,
            0xE401,
            0xA001,
            0x6C00,
            0x7800,
            0xB401,
            0x5000,
            0x9C01,
            0x8801,
            0x4400
        ];
        let crc = 0;
        for(let i = start; i <= end; i++){
            const byte = file.getUint8(i, true);
            let tmp = crcTable[crc & 0xF];
            crc = crc >> 4 & 0x0FFF;
            crc = crc ^ tmp ^ crcTable[byte & 0xF];
            tmp = crcTable[crc & 0xF];
            crc = crc >> 4 & 0x0FFF;
            crc = crc ^ tmp ^ crcTable[byte >> 4 & 0xF];
        }
        return crc;
    }
    function isValid(view, crc) {
        // const start = fileHeader.decode(view).size; // without file header
        const start = 0;
        const end = view.byteLangth - size;
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(crc, calculateCRC(view, start, end));
    }
    // Dataview, Int -> Bool
    function isCRC(view, i) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(view.byteLength - i, size);
    }
    function encode(crc, view, i = 0) {
        view.setUint16(i, crc, architecture);
        return view;
    }
    function decode(view, i = 0) {
        let value = view.getUint16(i, architecture);
        return {
            type: _type,
            length: size,
            crc: value
        };
    }
    function toFITjs(crc) {
        return {
            type: _type,
            length: size,
            crc: crc ?? undefined
        };
    }
    // Uint16 -> [Uint8]
    function toArray(crc) {
        return [
            crc & 0xFF,
            crc >> 8
        ];
    }
    // [Uint8] -> Uint16
    function fromArray(array) {
        return array[0] + array[1] << 8;
    }
    // Dataview -> {number: Uint16, array: [Uint8]}
    function getHeaderCRC(dataview) {
        const number = dataview.getUint16(12, true);
        const array = [
            dataview.getUint8(12, true),
            dataview.getUint8(13, true)
        ];
        return {
            number: number,
            array: array
        };
    }
    // Dataview -> {number: Uint16, array: [Uint8]}
    function getFileCRC(dataview) {
        const byteLength = dataview.byteLength;
        const number = dataview.getUint16(byteLength - size, true);
        const array = [
            dataview.getUint8(byteLength - size, true),
            dataview.getUint8(byteLength - (size - 1), true)
        ];
        return {
            number: number,
            array: array
        };
    }
    return Object.freeze({
        size: size,
        calculateCRC: calculateCRC,
        isValid: isValid,
        isCRC: isCRC,
        encode: encode,
        decode: decode,
        toFITjs: toFITjs,
        toArray: toArray,
        fromArray: fromArray,
        getHeaderCRC: getHeaderCRC,
        getFileCRC: getFileCRC
    });
}
const $5d332605c5db3f98$export$5be0c4d7d8d17551 = $5d332605c5db3f98$export$b121a1c183ce1009();





function $ed88c44bd8f99c46$export$3ec5619209a0e980(args = {}) {
    const _type = (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).header;
    const architecture = args.architecture ?? true;
    const protocolVersion = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: function(version) {
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(version, '2.0')) return 32;
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(version, '1.0')) return 16;
            return 16;
        },
        decode: function(code) {
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(code, 32)) return '2.0';
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(code, 16)) return '1.0';
            return '1.0';
        }
    });
    const profileVersion = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: function(version) {
            if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(version)) return 2140;
            return parseInt(parseFloat(version) * 100);
        },
        decode: function(code) {
            return (code / 100).toFixed(2);
        }
    });
    const dataType = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: function(str) {
            let code = 0;
            for(let i = 0; i < fields.dataType.size; i++)code += str.charCodeAt(i) << 8 * i;
            return code;
        },
        decode: function(code) {
            let str = '';
            for(let i = 0; i < fields.dataType.size; i++)str += String.fromCharCode((code & 0xFF << 8 * i) >> 8 * i);
            return str;
        }
    });
    const headerCRC = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: (_, view)=>(0, $5d332605c5db3f98$export$5be0c4d7d8d17551).calculateCRC(view, 0, 11)
    });
    const crcPresent = (headerSize)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(headerSize, 14) ? true : false;
    const fields = {
        // Indicates the length of this file header including header size.
        // Minimum size is 12. This may be increased in future to add additional
        // optional information
        headerSize: {
            size: 1,
            type: 'Uint8',
            default: 14,
            present: (_)=>true,
            parser: (0, $46e0b5f74a2a4c34$export$fb4220bff6c248ec)
        },
        protocolVersion: {
            size: 1,
            type: 'Uint8',
            default: '2.0',
            present: (_)=>true,
            parser: protocolVersion
        },
        profileVersion: {
            size: 2,
            type: 'Uint16',
            default: '21.40',
            present: (_)=>true,
            parser: profileVersion
        },
        // Length of the Data Records section in bytesDoes not include Header or CRC
        dataSize: {
            size: 4,
            type: 'Uint32',
            default: 0,
            present: (_)=>true,
            parser: (0, $46e0b5f74a2a4c34$export$fb4220bff6c248ec)
        },
        // ASCII values for ".FIT", [46, 70, 73, 84], 1414088238
        dataType: {
            size: 4,
            type: 'Uint32',
            default: '.FIT',
            present: (_)=>true,
            parser: dataType
        },
        // Contains the value of the CRC of Bytes 0 through 11 or may be set to 0x0000. Optional.
        crc: {
            size: 2,
            type: 'Uint16',
            default: 0x0000,
            present: crcPresent,
            parser: headerCRC
        }
    };
    const order = [
        'headerSize',
        // acts as flags
        'protocolVersion',
        'profileVersion',
        'dataSize',
        'dataType',
        'crc'
    ];
    // FitRecord{
    //  type: Record.header,
    //  length: Int,
    //  headerSize: Int,
    //  protocolVersion: String,
    //  profileVersion: String,
    //  dataSize: Int,
    //  dataType: String,
    //  crc: Int
    // },
    // DataView,
    // Int,
    // -> DataView
    function encode(definition, view, i = 0) {
        return order.reduce(function(acc, fieldName) {
            const field = fields[fieldName];
            if (field.present(definition.headerSize)) {
                const value = field.parser.encode(definition[fieldName], acc.view);
                (0, $46e0b5f74a2a4c34$export$78fa5045d0400717)(field.type, value, acc.view, acc.i, architecture, false);
                acc.i += field.size;
            }
            return acc;
        }, {
            i: 0,
            view: view
        }).view;
    }
    // DataView
    //->
    // FitRecord{
    //  type: Record.header,
    //  length: Int,
    //  headerSize: Int,
    //  protocolVersion: String,
    //  profileVersion: String,
    //  dataSize: Int,
    //  dataType: String,
    //  crc: Int
    // }
    function decode(view, start = 0) {
        return order.reduce(function(acc, fieldName) {
            const field = fields[fieldName];
            if (field.present(acc?.data?.headerSize)) {
                const value = (0, $46e0b5f74a2a4c34$export$513f42987b822fd7)(field.type, view, acc.i, architecture, false);
                acc.data[fieldName] = field.parser.decode(value);
                acc.i += field.size;
                acc.data.length += field.size;
            }
            return acc;
        }, {
            i: start,
            data: {
                type: _type,
                length: 0
            }
        }).data;
    }
    function isFileHeader(view, start = 0) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(start, 0);
    }
    function toFITjs(args = {}) {
        const headerSize = args.headerSize ?? 14;
        const length = headerSize;
        const crc = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(headerSize, 14) ? args.crc ?? 0 : undefined;
        return {
            type: _type,
            length: length,
            headerSize: headerSize,
            protocolVersion: args.protocolVersion ?? '2.0',
            profileVersion: args.profileVersion ?? '21.40',
            dataSize: args.dataSize ?? 0,
            dataType: '.FIT',
            crc: crc
        };
    }
    return Object.freeze({
        type: _type,
        encode: encode,
        decode: decode,
        isFileHeader: isFileHeader,
        toFITjs: toFITjs
    });
}
const $ed88c44bd8f99c46$export$97013678e68d80d7 = $ed88c44bd8f99c46$export$3ec5619209a0e980();




function $483b10c4679c37af$export$1dac98070f384f52() {
    // NOTE: Supports only Normal Header Type
    // does not support Compressed Timestamp Header
    const size = 1;
    const headerType = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: (type)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(type, (0, $46e0b5f74a2a4c34$export$f244c03754a3885c).normal) ? 0 : 1,
        decode: (code)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(code, 0) ? (0, $46e0b5f74a2a4c34$export$f244c03754a3885c).normal : (0, $46e0b5f74a2a4c34$export$f244c03754a3885c).timestamp
    });
    const messageType = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: (type)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(type, (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition) ? 1 : 0,
        decode: (code)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(code, 1) ? (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition : (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).data
    });
    const messageTypeSpecific = (0, $46e0b5f74a2a4c34$export$7a0ab2bd845e822)({
        encode: (byte)=>0,
        decode: (byte)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(byte, 6), 1) && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(byte, 5), 1) ? 'developer' : 'reserved'
    });
    const bits = {
        // 0 normal header, 1 Compressed Timestamp Header
        'headerType': {
            size: 1,
            default: 0,
            present: (_)=>true,
            parser: headerType
        },
        // 0 data message, 1 definition message
        'messageType': {
            size: 1,
            default: 0,
            present: (_)=>true,
            parser: messageType
        },
        // if definition message and set to 1 the message contains extended definitions for developer data
        'messageTypeSpecific': {
            size: 1,
            default: 0,
            present: (_)=>true,
            parser: (0, $46e0b5f74a2a4c34$export$fb4220bff6c248ec)
        },
        'reserved': {
            size: 1,
            default: 0,
            present: (_)=>true,
            parser: (0, $46e0b5f74a2a4c34$export$fb4220bff6c248ec)
        },
        // local message type/number
        'localMessageType': {
            size: 4,
            default: 0,
            present: (_)=>true,
            parser: (0, $46e0b5f74a2a4c34$export$fb4220bff6c248ec)
        }
    };
    const order = [
        'headerType',
        'messageType',
        'messageTypeSpecific',
        'reserved',
        'localMessageType'
    ];
    // {headerType: String, messageType: String, messageTypeSpecific: String, localMessageType: Int}
    // ->
    // Int,
    function encode(definition) {
        let byte = 0 + (definition.localMessageType ?? 0);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(definition.headerType, (0, $46e0b5f74a2a4c34$export$f244c03754a3885c).timestamp)) byte = (0, $c6a9e46ee7e4d896$export$75ed722ad5e2887)(7, byte);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(definition.messageType, (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition)) byte = (0, $c6a9e46ee7e4d896$export$75ed722ad5e2887)(6, byte);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(definition.messageTypeSpecific, 'developer')) byte = (0, $c6a9e46ee7e4d896$export$75ed722ad5e2887)(5, byte);
        return byte;
    }
    // Int,
    // ->
    // {headerType: String, messageType: String, messageTypeSpecific: String, localMessageType: Int}
    function decode(byte) {
        return {
            headerType: headerType.decode((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(byte, 7)),
            messageType: messageType.decode((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(byte, 6)),
            messageTypeSpecific: messageTypeSpecific.decode(byte),
            localMessageType: byte & 15
        };
    }
    function isDefinition(header) {
        if ((0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)(header)) return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(header, 6), 0) ? true : false;
        if ((0, $c6a9e46ee7e4d896$export$a6cdc56e425d0d0a)(header)) return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(header.messageType, (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition) ? true : false;
        return false;
    }
    function isData(header) {
        if ((0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)(header)) return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(header, 6), 1) ? true : false;
        if ((0, $c6a9e46ee7e4d896$export$a6cdc56e425d0d0a)(header)) return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(header.messageType, (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).data) ? true : false;
        return false;
    }
    function isDeveloper(header) {
        if ((0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)(header)) return isDefinition(header) && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$8154c826aac5e341)(header, 5), 1) ? true : false;
        if ((0, $c6a9e46ee7e4d896$export$a6cdc56e425d0d0a)(header)) return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(header.messageTypeSpecific, 'developer') && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(header.messageType, (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition) ? true : false;
        return false;
    }
    return Object.freeze({
        size: size,
        isDefinition: isDefinition,
        isData: isData,
        isDeveloper: isDeveloper,
        encode: encode,
        decode: decode
    });
}
const $483b10c4679c37af$export$a29c13bd16217000 = $483b10c4679c37af$export$1dac98070f384f52();


//
// Profiles
//
// merge, shape, and export, data from the global and product profile json files
//

//
// Types
//
// as defined in table 1 of the fit protocol profiles.xmls
//
const $2c445aecb1469f67$export$716a6faa393fdf39 = {
    enum: 0,
    // 0x00
    sint8: 1,
    // 0x01
    uint8: 2,
    // 0x02
    sint16: 131,
    // 0x83
    uint16: 132,
    // 0x84
    sint32: 133,
    // 0x85
    uint32: 134,
    // 0x86
    string: 7,
    // 0x07
    float32: 136,
    // 0x88
    float64: 137,
    // 0x89
    uint8z: 10,
    // 0x0A
    uint16z: 139,
    // 0x8B
    uint32z: 140,
    // 0x8C
    byte: 13,
    // 0x0D
    sint64: 142,
    // 0x8E
    uint64: 143,
    // 0x8F
    uint64z: 144,
    // 0x90
    '0': 'enum',
    '1': 'sint8',
    '2': 'uint8',
    '131': 'sint16',
    '132': 'uint16',
    '133': 'sint32',
    '134': 'uint32',
    '7': 'string',
    '136': 'float32',
    '137': 'float64',
    '10': 'uint8z',
    '139': 'uint16z',
    '140': 'uint32z',
    '13': 'byte',
    '142': 'sint64',
    '143': 'uint64',
    '144': 'uint64z'
};
const $2c445aecb1469f67$export$c40f74f6a9873fff = {
    'enum': {
        name: 'enum',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.enum,
        endian_ability: 0,
        size: 1,
        invalid_value: 0xFF
    },
    'sint8': {
        name: 'sint8',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.sint8,
        endian_ability: 0,
        size: 1,
        invalid_value: 0x7F
    },
    'uint8': {
        name: 'uint8',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint8,
        endian_ability: 0,
        size: 1,
        invalid_value: 0xFF
    },
    'sint16': {
        name: 'sint16',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.sint16,
        endian_ability: 1,
        size: 2,
        invalid_value: 0x7FFF
    },
    'uint16': {
        name: 'uint16',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint16,
        endian_ability: 1,
        size: 2,
        invalid_value: 0xFFFF
    },
    'sint32': {
        name: 'sint32',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.sint32,
        endian_ability: 1,
        size: 4,
        invalid_value: 0x7FFFFFFF
    },
    'uint32': {
        name: 'uint32',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint32,
        endian_ability: 1,
        size: 4,
        invalid_value: 0xFFFFFFFF
    },
    'string': {
        name: 'string',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.string,
        endian_ability: 0,
        size: 1,
        invalid_value: 0x00
    },
    'float32': {
        name: 'float32',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.float32,
        endian_ability: 1,
        size: 4,
        invalid_value: 0xFFFFFFFF
    },
    'float64': {
        name: 'float64',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.float64,
        endian_ability: 1,
        size: 8,
        invalid_value: 0xFFFFFFFFFFFFFFFF
    },
    'uint8z': {
        name: 'uint8z',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint8z,
        endian_ability: 0,
        size: 1,
        invalid_value: 0x00
    },
    'uint16z': {
        name: 'uint16z',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint16z,
        endian_ability: 1,
        size: 2,
        invalid_value: 0x0000
    },
    'uint32z': {
        name: 'uint32z',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint32z,
        endian_ability: 1,
        size: 4,
        invalid_value: 0x00000000
    },
    'byte': {
        name: 'byte',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.byte,
        endian_ability: 0,
        size: 1,
        invalid_value: 0xFF
    },
    'sint64': {
        name: 'sint64',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.sint64,
        endian_ability: 1,
        size: 8,
        invalid_value: 0x7FFFFFFFFFFFFFFF
    },
    'uint64': {
        name: 'uint64',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint64,
        endian_ability: 1,
        size: 8,
        invalid_value: 0xFFFFFFFFFFFFFFFF
    },
    'uint64z': {
        name: 'uint64z',
        base_type: $2c445aecb1469f67$export$716a6faa393fdf39.uint64z,
        endian_ability: 1,
        size: 8,
        invalid_value: 0x0000000000000000
    }
};


var $848d20dca154f858$export$2e2bcd8739ae039 = {
    "file_id": {
        "fields": {
            "type": 0,
            "manufacturer": 1,
            "product": 2,
            "serial_number": 3,
            "time_created": 4,
            "number": 5,
            "product_name": 8
        }
    },
    "file_creator": {
        "fields": {
            "software_version": 0,
            "hardware_version": 1
        }
    },
    "timestamp_correlation": {
        "fields": {
            "timestamp": 253,
            "fractional_timestamp": 0,
            "system_timestamp": 1,
            "fractional_system_timestamp": 2,
            "local_timestamp": 3,
            "timestamp_ms": 4,
            "system_timestamp_ms": 5
        }
    },
    "activity": {
        "fields": {
            "timestamp": 253,
            "total_timer_time": 0,
            "num_sessions": 1,
            "type": 2,
            "event": 3,
            "event_type": 4,
            "local_timestamp": 5,
            "event_group": 6
        }
    },
    "session": {
        "fields": {
            "message_index": 254,
            "timestamp": 253,
            "event": 0,
            "event_type": 1,
            "start_time": 2,
            "start_position_lat": 3,
            "start_position_long": 4,
            "sport": 5,
            "sub_sport": 6,
            "total_elapsed_time": 7,
            "total_timer_time": 8,
            "total_distance": 9,
            "total_cycles": 10,
            "total_calories": 11,
            "total_fat_calories": 13,
            "avg_speed": 14,
            "max_speed": 15,
            "avg_heart_rate": 16,
            "max_heart_rate": 17,
            "avg_cadence": 18,
            "max_cadence": 19,
            "avg_power": 20,
            "max_power": 21,
            "total_ascent": 22,
            "total_descent": 23,
            "total_training_effect": 24,
            "first_lap_index": 25,
            "num_laps": 26,
            "event_group": 27,
            "trigger": 28,
            "nec_lat": 29,
            "nec_long": 30,
            "swc_lat": 31,
            "swc_long": 32,
            "num_lengths": 33,
            "normalized_power": 34,
            "training_stress_score": 35,
            "intensity_factor": 36,
            "left_right_balance": 37,
            "avg_stroke_count": 41,
            "avg_stroke_distance": 42,
            "swim_stroke": 43,
            "pool_length": 44,
            "threshold_power": 45,
            "pool_length_unit": 46,
            "num_active_lengths": 47,
            "total_work": 48,
            "avg_altitude": 49,
            "max_altitude": 50,
            "gps_accuracy": 51,
            "avg_grade": 52,
            "avg_pos_grade": 53,
            "avg_neg_grade": 54,
            "max_pos_grade": 55,
            "max_neg_grade": 56,
            "avg_temperature": 57,
            "max_temperature": 58,
            "total_moving_time": 59,
            "avg_pos_vertical_speed": 60,
            "avg_neg_vertical_speed": 61,
            "max_pos_vertical_speed": 62,
            "max_neg_vertical_speed": 63,
            "min_heart_rate": 64,
            "time_in_hr_zone": 65,
            "time_in_speed_zone": 66,
            "time_in_cadence_zone": 67,
            "time_in_power_zone": 68,
            "avg_lap_time": 69,
            "best_lap_index": 70,
            "min_altitude": 71,
            "player_score": 82,
            "opponent_score": 83,
            "opponent_name": 84,
            "stroke_count": 85,
            "zone_count": 86,
            "max_ball_speed": 87,
            "avg_ball_speed": 88,
            "avg_vertical_oscillation": 89,
            "avg_stance_time_percent": 90,
            "avg_stance_time": 91,
            "avg_fractional_cadence": 92,
            "max_fractional_cadence": 93,
            "total_fractional_cycles": 94,
            "avg_total_hemoglobin_conc": 95,
            "min_total_hemoglobin_conc": 96,
            "max_total_hemoglobin_conc": 97,
            "avg_saturated_hemoglobin_percent": 98,
            "min_saturated_hemoglobin_percent": 99,
            "max_saturated_hemoglobin_percent": 100,
            "avg_left_torque_effectiveness": 101,
            "avg_right_torque_effectiveness": 102,
            "avg_left_pedal_smoothness": 103,
            "avg_right_pedal_smoothness": 104,
            "avg_combined_pedal_smoothness": 105,
            "sport_index": 111,
            "time_standing": 112,
            "stand_count": 113,
            "avg_left_pco": 114,
            "avg_right_pco": 115,
            "avg_left_power_phase": 116,
            "avg_left_power_phase_peak": 117,
            "avg_right_power_phase": 118,
            "avg_right_power_phase_peak": 119,
            "avg_power_position": 120,
            "max_power_position": 121,
            "avg_cadence_position": 122,
            "max_cadence_position": 123,
            "enhanced_avg_speed": 124,
            "enhanced_max_speed": 125,
            "enhanced_avg_altitude": 126,
            "enhanced_min_altitude": 127,
            "enhanced_max_altitude": 128,
            "avg_lev_motor_power": 129,
            "max_lev_motor_power": 130,
            "lev_battery_consumption": 131,
            "avg_vertical_ratio": 132,
            "avg_stance_time_balance": 133,
            "avg_step_length": 134,
            "total_anaerobic_training_effect": 137,
            "avg_vam": 139,
            "total_grit": 181,
            "total_flow": 182,
            "jump_count": 183,
            "avg_grit": 186,
            "avg_flow": 187,
            "total_fractional_ascent": 199,
            "total_fractional_descent": 200,
            "avg_core_temperature": 208,
            "min_core_temperature": 209,
            "max_core_temperature": 210
        }
    },
    "lap": {
        "fields": {
            "message_index": 254,
            "timestamp": 253,
            "event": 0,
            "event_type": 1,
            "start_time": 2,
            "start_position_lat": 3,
            "start_position_long": 4,
            "end_position_lat": 5,
            "end_position_long": 6,
            "total_elapsed_time": 7,
            "total_timer_time": 8,
            "total_distance": 9,
            "total_cycles": 10,
            "total_calories": 11,
            "total_fat_calories": 12,
            "avg_speed": 13,
            "max_speed": 14,
            "avg_heart_rate": 15,
            "max_heart_rate": 16,
            "avg_cadence": 17,
            "max_cadence": 18,
            "avg_power": 19,
            "max_power": 20,
            "total_ascent": 21,
            "total_descent": 22,
            "intensity": 23,
            "lap_trigger": 24,
            "sport": 25,
            "event_group": 26,
            "num_lengths": 32,
            "normalized_power": 33,
            "left_right_balance": 34,
            "first_length_index": 35,
            "avg_stroke_distance": 37,
            "swim_stroke": 38,
            "sub_sport": 39,
            "num_active_lengths": 40,
            "total_work": 41,
            "avg_altitude": 42,
            "max_altitude": 43,
            "gps_accuracy": 44,
            "avg_grade": 45,
            "avg_pos_grade": 46,
            "avg_neg_grade": 47,
            "max_pos_grade": 48,
            "max_neg_grade": 49,
            "avg_temperature": 50,
            "max_temperature": 51,
            "total_moving_time": 52,
            "avg_pos_vertical_speed": 53,
            "avg_neg_vertical_speed": 54,
            "max_pos_vertical_speed": 55,
            "max_neg_vertical_speed": 56,
            "time_in_hr_zone": 57,
            "time_in_speed_zone": 58,
            "time_in_cadence_zone": 59,
            "time_in_power_zone": 60,
            "repetition_num": 61,
            "min_altitude": 62,
            "min_heart_rate": 63,
            "wkt_step_index": 71,
            "opponent_score": 74,
            "stroke_count": 75,
            "zone_count": 76,
            "avg_vertical_oscillation": 77,
            "avg_stance_time_percent": 78,
            "avg_stance_time": 79,
            "avg_fractional_cadence": 80,
            "max_fractional_cadence": 81,
            "total_fractional_cycles": 82,
            "player_score": 83,
            "avg_total_hemoglobin_conc": 84,
            "min_total_hemoglobin_conc": 85,
            "max_total_hemoglobin_conc": 86,
            "avg_saturated_hemoglobin_percent": 87,
            "min_saturated_hemoglobin_percent": 88,
            "max_saturated_hemoglobin_percent": 89,
            "avg_left_torque_effectiveness": 91,
            "avg_right_torque_effectiveness": 92,
            "avg_left_pedal_smoothness": 93,
            "avg_right_pedal_smoothness": 94,
            "avg_combined_pedal_smoothness": 95,
            "time_standing": 98,
            "stand_count": 99,
            "avg_left_pco": 100,
            "avg_right_pco": 101,
            "avg_left_power_phase": 102,
            "avg_left_power_phase_peak": 103,
            "avg_right_power_phase": 104,
            "avg_right_power_phase_peak": 105,
            "avg_power_position": 106,
            "max_power_position": 107,
            "avg_cadence_position": 108,
            "max_cadence_position": 109,
            "enhanced_avg_speed": 110,
            "enhanced_max_speed": 111,
            "enhanced_avg_altitude": 112,
            "enhanced_min_altitude": 113,
            "enhanced_max_altitude": 114,
            "avg_lev_motor_power": 115,
            "max_lev_motor_power": 116,
            "lev_battery_consumption": 117,
            "avg_vertical_ratio": 118,
            "avg_stance_time_balance": 119,
            "avg_step_length": 120,
            "avg_vam": 121,
            "total_grit": 149,
            "total_flow": 150,
            "jump_count": 151,
            "avg_grit": 153,
            "avg_flow": 154,
            "total_fractional_ascent": 156,
            "total_fractional_descent": 157,
            "avg_core_temperature": 158,
            "min_core_temperature": 159,
            "max_core_temperature": 160
        }
    },
    "length": {
        "fields": {
            "message_index": 254,
            "timestamp": 253,
            "event": 0,
            "event_type": 1,
            "start_time": 2,
            "total_elapsed_time": 3,
            "total_timer_time": 4,
            "total_strokes": 5,
            "avg_speed": 6,
            "swim_stroke": 7,
            "avg_swimming_cadence": 9,
            "event_group": 10,
            "total_calories": 11,
            "length_type": 12,
            "player_score": 18,
            "opponent_score": 19,
            "stroke_count": 20,
            "zone_count": 21
        }
    },
    "record": {
        "fields": {
            "timestamp": 253,
            "position_lat": 0,
            "position_long": 1,
            "altitude": 2,
            "heart_rate": 3,
            "cadence": 4,
            "distance": 5,
            "speed": 6,
            "power": 7,
            "compressed_speed_distance": 8,
            "grade": 9,
            "resistance": 10,
            "time_from_course": 11,
            "cycle_length": 12,
            "temperature": 13,
            "speed_1s": 17,
            "cycles": 18,
            "total_cycles": 19,
            "compressed_accumulated_power": 28,
            "accumulated_power": 29,
            "left_right_balance": 30,
            "gps_accuracy": 31,
            "vertical_speed": 32,
            "calories": 33,
            "vertical_oscillation": 39,
            "stance_time_percent": 40,
            "stance_time": 41,
            "activity_type": 42,
            "left_torque_effectiveness": 43,
            "right_torque_effectiveness": 44,
            "left_pedal_smoothness": 45,
            "right_pedal_smoothness": 46,
            "combined_pedal_smoothness": 47,
            "time128": 48,
            "stroke_type": 49,
            "zone": 50,
            "ball_speed": 51,
            "cadence256": 52,
            "fractional_cadence": 53,
            "total_hemoglobin_conc": 54,
            "total_hemoglobin_conc_min": 55,
            "total_hemoglobin_conc_max": 56,
            "saturated_hemoglobin_percent": 57,
            "saturated_hemoglobin_percent_min": 58,
            "saturated_hemoglobin_percent_max": 59,
            "device_index": 62,
            "left_pco": 67,
            "right_pco": 68,
            "left_power_phase": 69,
            "left_power_phase_peak": 70,
            "right_power_phase": 71,
            "right_power_phase_peak": 72,
            "enhanced_speed": 73,
            "enhanced_altitude": 78,
            "battery_soc": 81,
            "motor_power": 82,
            "vertical_ratio": 83,
            "stance_time_balance": 84,
            "step_length": 85,
            "absolute_pressure": 91,
            "depth": 92,
            "next_stop_depth": 93,
            "next_stop_time": 94,
            "time_to_surface": 95,
            "ndl_time": 96,
            "cns_load": 97,
            "n2_load": 98,
            "grit": 114,
            "flow": 115,
            "ebike_travel_range": 117,
            "ebike_battery_level": 118,
            "ebike_assist_mode": 119,
            "ebike_assist_level_percent": 120,
            "core_temperature": 139
        }
    },
    "event": {
        "fields": {
            "timestamp": 253,
            "event": 0,
            "event_type": 1,
            "data16": 2,
            "data": 3,
            "event_group": 4,
            "score": 7,
            "opponent_score": 8,
            "front_gear_num": 9,
            "front_gear": 10,
            "rear_gear_num": 11,
            "rear_gear": 12,
            "device_index": 13,
            "radar_threat_level_max": 21,
            "radar_threat_count": 22
        }
    },
    "device_info": {
        "fields": {
            "timestamp": 253,
            "device_index": 0,
            "device_type": 1,
            "manufacturer": 2,
            "serial_number": 3,
            "product": 4,
            "software_version": 5,
            "hardware_version": 6,
            "cum_operating_time": 7,
            "battery_voltage": 10,
            "battery_status": 11,
            "sensor_position": 18,
            "descriptor": 19,
            "ant_transmission_type": 20,
            "ant_device_number": 21,
            "ant_network": 22,
            "source_type": 25,
            "product_name": 27
        }
    },
    "training_file": {
        "fields": {
            "timestamp": 253,
            "type": 0,
            "manufacturer": 1,
            "product": 2,
            "serial_number": 3,
            "time_created": 4
        }
    },
    "hrv": {
        "fields": {
            "time": 0
        }
    },
    "weather_conditions": {
        "fields": {
            "timestamp": 253,
            "weather_report": 0,
            "temperature": 1,
            "condition": 2,
            "wind_direction": 3,
            "wind_speed": 4,
            "precipitation_probability": 5,
            "temperature_feels_like": 6,
            "relative_humidity": 7,
            "location": 8,
            "observed_at_time": 9,
            "observed_location_lat": 10,
            "observed_location_long": 11,
            "day_of_week": 12,
            "high_temperature": 13,
            "low_temperature": 14
        }
    },
    "weather_alert": {
        "fields": {
            "timestamp": 253,
            "report_id": 0,
            "issue_time": 1,
            "expire_time": 2,
            "severity": 3,
            "type": 4
        }
    },
    "gps_metadata": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "position_lat": 1,
            "position_long": 2,
            "enhanced_altitude": 3,
            "enhanced_speed": 4,
            "heading": 5,
            "utc_timestamp": 6,
            "velocity": 7
        }
    },
    "camera_event": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "camera_event_type": 1,
            "camera_file_uuid": 2,
            "camera_orientation": 3
        }
    },
    "gyroscope_data": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "sample_time_offset": 1,
            "gyro_x": 2,
            "gyro_y": 3,
            "gyro_z": 4,
            "calibrated_gyro_x": 5,
            "calibrated_gyro_y": 6,
            "calibrated_gyro_z": 7
        }
    },
    "accelerometer_data": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "sample_time_offset": 1,
            "accel_x": 2,
            "accel_y": 3,
            "accel_z": 4,
            "calibrated_accel_x": 5,
            "calibrated_accel_y": 6,
            "calibrated_accel_z": 7,
            "compressed_calibrated_accel_x": 8,
            "compressed_calibrated_accel_y": 9,
            "compressed_calibrated_accel_z": 10
        }
    },
    "magnetometer_data": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "sample_time_offset": 1,
            "mag_x": 2,
            "mag_y": 3,
            "mag_z": 4,
            "calibrated_mag_x": 5,
            "calibrated_mag_y": 6,
            "calibrated_mag_z": 7
        }
    },
    "barometer_data": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "sample_time_offset": 1,
            "baro_pres": 2
        }
    },
    "three_d_sensor_calibration": {
        "fields": {
            "timestamp": 253,
            "sensor_type": 0,
            "calibration_factor": 1,
            "calibration_divisor": 2,
            "level_shift": 3,
            "offset_cal": 4,
            "orientation_matrix": 5
        }
    },
    "one_d_sensor_calibration": {
        "fields": {
            "timestamp": 253,
            "sensor_type": 0,
            "calibration_factor": 1,
            "calibration_divisor": 2,
            "level_shift": 3,
            "offset_cal": 4
        }
    },
    "video_frame": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "frame_number": 1
        }
    },
    "obdii_data": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "time_offset": 1,
            "pid": 2,
            "raw_data": 3,
            "pid_data_size": 4,
            "system_time": 5,
            "start_timestamp": 6,
            "start_timestamp_ms": 7
        }
    },
    "nmea_sentence": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "sentence": 1
        }
    },
    "aviation_attitude": {
        "fields": {
            "timestamp": 253,
            "timestamp_ms": 0,
            "system_time": 1,
            "pitch": 2,
            "roll": 3,
            "accel_lateral": 4,
            "accel_normal": 5,
            "turn_rate": 6,
            "stage": 7,
            "attitude_stage_complete": 8,
            "track": 9,
            "validity": 10
        }
    },
    "video": {
        "fields": {
            "url": 0,
            "hosting_provider": 1,
            "duration": 2
        }
    },
    "video_title": {
        "fields": {
            "message_index": 254,
            "message_count": 0,
            "text": 1
        }
    },
    "video_description": {
        "fields": {
            "message_index": 254,
            "message_count": 0,
            "text": 1
        }
    },
    "video_clip": {
        "fields": {
            "clip_number": 0,
            "start_timestamp": 1,
            "start_timestamp_ms": 2,
            "end_timestamp": 3,
            "end_timestamp_ms": 4,
            "clip_start": 6,
            "clip_end": 7
        }
    },
    "set": {
        "fields": {
            "timestamp": 254,
            "duration": 0,
            "repetitions": 3,
            "weight": 4,
            "set_type": 5,
            "start_time": 6,
            "category": 7,
            "category_subtype": 8,
            "weight_display_unit": 9,
            "message_index": 10,
            "wkt_step_index": 11
        }
    },
    "jump": {
        "fields": {
            "timestamp": 253,
            "distance": 0,
            "height": 1,
            "rotations": 2,
            "hang_time": 3,
            "score": 4,
            "position_lat": 5,
            "position_long": 6,
            "speed": 7,
            "enhanced_speed": 8
        }
    },
    "course": {
        "fields": {
            "sport": 4,
            "name": 5,
            "capabilities": 6,
            "sub_sport": 7
        }
    },
    "course_point": {
        "fields": {
            "message_index": 254,
            "timestamp": 1,
            "position_lat": 2,
            "position_long": 3,
            "distance": 4,
            "type": 5,
            "name": 6,
            "favorite": 8
        }
    }
};


var $8464fac654ea63e2$export$2e2bcd8739ae039 = {
    "file": {
        "base_type": "enum",
        "values": {
            "1": "device",
            "2": "settings",
            "3": "sport",
            "4": "activity",
            "5": "workout",
            "6": "course",
            "7": "schedules",
            "9": "weight",
            "10": "totals",
            "11": "goals",
            "14": "blood_pressure",
            "15": "monitoring_a",
            "20": "activity_summary",
            "28": "monitoring_daily",
            "32": "monitoring_b",
            "34": "segment",
            "35": "segment_list",
            "40": "exd_configuration",
            "247": "mfg_range_min",
            "254": "mfg_range_max",
            "device": 1,
            "settings": 2,
            "sport": 3,
            "activity": 4,
            "workout": 5,
            "course": 6,
            "schedules": 7,
            "weight": 9,
            "totals": 10,
            "goals": 11,
            "blood_pressure": 14,
            "monitoring_a": 15,
            "activity_summary": 20,
            "monitoring_daily": 28,
            "monitoring_b": 32,
            "segment": 34,
            "segment_list": 35,
            "exd_configuration": 40,
            "mfg_range_min": 247,
            "mfg_range_max": 254
        }
    },
    "mesg_num": {
        "base_type": "uint16",
        "values": {
            "0": "file_id",
            "1": "capabilities",
            "2": "device_settings",
            "3": "user_profile",
            "4": "hrm_profile",
            "5": "sdm_profile",
            "6": "bike_profile",
            "7": "zones_target",
            "8": "hr_zone",
            "9": "power_zone",
            "10": "met_zone",
            "12": "sport",
            "15": "goal",
            "18": "session",
            "19": "lap",
            "20": "record",
            "21": "event",
            "23": "device_info",
            "26": "workout",
            "27": "workout_step",
            "28": "schedule",
            "30": "weight_scale",
            "31": "course",
            "32": "course_point",
            "33": "totals",
            "34": "activity",
            "35": "software",
            "37": "file_capabilities",
            "38": "mesg_capabilities",
            "39": "field_capabilities",
            "49": "file_creator",
            "51": "blood_pressure",
            "53": "speed_zone",
            "55": "monitoring",
            "72": "training_file",
            "78": "hrv",
            "80": "ant_rx",
            "81": "ant_tx",
            "82": "ant_channel_id",
            "101": "length",
            "103": "monitoring_info",
            "105": "pad",
            "106": "slave_device",
            "127": "connectivity",
            "128": "weather_conditions",
            "129": "weather_alert",
            "131": "cadence_zone",
            "132": "hr",
            "142": "segment_lap",
            "145": "memo_glob",
            "148": "segment_id",
            "149": "segment_leaderboard_entry",
            "150": "segment_point",
            "151": "segment_file",
            "158": "workout_session",
            "159": "watchface_settings",
            "160": "gps_metadata",
            "161": "camera_event",
            "162": "timestamp_correlation",
            "164": "gyroscope_data",
            "165": "accelerometer_data",
            "167": "three_d_sensor_calibration",
            "169": "video_frame",
            "174": "obdii_data",
            "177": "nmea_sentence",
            "178": "aviation_attitude",
            "184": "video",
            "185": "video_title",
            "186": "video_description",
            "187": "video_clip",
            "188": "ohr_settings",
            "200": "exd_screen_configuration",
            "201": "exd_data_field_configuration",
            "202": "exd_data_concept_configuration",
            "206": "field_description",
            "207": "developer_data_id",
            "208": "magnetometer_data",
            "209": "barometer_data",
            "210": "one_d_sensor_calibration",
            "225": "set",
            "227": "stress_level",
            "258": "dive_settings",
            "259": "dive_gas",
            "262": "dive_alarm",
            "264": "exercise_title",
            "268": "dive_summary",
            "285": "jump",
            "317": "climb_pro",
            "65280": "mfg_range_min",
            "65534": "mfg_range_max",
            "file_id": 0,
            "capabilities": 1,
            "device_settings": 2,
            "user_profile": 3,
            "hrm_profile": 4,
            "sdm_profile": 5,
            "bike_profile": 6,
            "zones_target": 7,
            "hr_zone": 8,
            "power_zone": 9,
            "met_zone": 10,
            "sport": 12,
            "goal": 15,
            "session": 18,
            "lap": 19,
            "record": 20,
            "event": 21,
            "device_info": 23,
            "workout": 26,
            "workout_step": 27,
            "schedule": 28,
            "weight_scale": 30,
            "course": 31,
            "course_point": 32,
            "totals": 33,
            "activity": 34,
            "software": 35,
            "file_capabilities": 37,
            "mesg_capabilities": 38,
            "field_capabilities": 39,
            "file_creator": 49,
            "blood_pressure": 51,
            "speed_zone": 53,
            "monitoring": 55,
            "training_file": 72,
            "hrv": 78,
            "ant_rx": 80,
            "ant_tx": 81,
            "ant_channel_id": 82,
            "length": 101,
            "monitoring_info": 103,
            "pad": 105,
            "slave_device": 106,
            "connectivity": 127,
            "weather_conditions": 128,
            "weather_alert": 129,
            "cadence_zone": 131,
            "hr": 132,
            "segment_lap": 142,
            "memo_glob": 145,
            "segment_id": 148,
            "segment_leaderboard_entry": 149,
            "segment_point": 150,
            "segment_file": 151,
            "workout_session": 158,
            "watchface_settings": 159,
            "gps_metadata": 160,
            "camera_event": 161,
            "timestamp_correlation": 162,
            "gyroscope_data": 164,
            "accelerometer_data": 165,
            "three_d_sensor_calibration": 167,
            "video_frame": 169,
            "obdii_data": 174,
            "nmea_sentence": 177,
            "aviation_attitude": 178,
            "video": 184,
            "video_title": 185,
            "video_description": 186,
            "video_clip": 187,
            "ohr_settings": 188,
            "exd_screen_configuration": 200,
            "exd_data_field_configuration": 201,
            "exd_data_concept_configuration": 202,
            "field_description": 206,
            "developer_data_id": 207,
            "magnetometer_data": 208,
            "barometer_data": 209,
            "one_d_sensor_calibration": 210,
            "set": 225,
            "stress_level": 227,
            "dive_settings": 258,
            "dive_gas": 259,
            "dive_alarm": 262,
            "exercise_title": 264,
            "dive_summary": 268,
            "jump": 285,
            "climb_pro": 317,
            "mfg_range_min": 65280,
            "mfg_range_max": 65534
        }
    },
    "checksum": {
        "base_type": "uint8",
        "values": {
            "0": "clear",
            "1": "ok",
            "clear": 0,
            "ok": 1
        }
    },
    "file_flags": {
        "base_type": "uint8z",
        "values": {
            "2": "read",
            "4": "write",
            "8": "erase",
            "read": 2,
            "write": 4,
            "erase": 8
        }
    },
    "mesg_count": {
        "base_type": "enum",
        "values": {
            "0": "num_per_file",
            "1": "max_per_file",
            "2": "max_per_file_type",
            "num_per_file": 0,
            "max_per_file": 1,
            "max_per_file_type": 2
        }
    },
    "date_time": {
        "base_type": "uint32",
        "values": {
            "268435456": "min",
            "min": 268435456
        }
    },
    "local_date_time": {
        "base_type": "uint32",
        "values": {
            "268435456": "min",
            "min": 268435456
        }
    },
    "message_index": {
        "base_type": "uint16",
        "values": {
            "4095": "mask",
            "28672": "reserved",
            "32768": "selected",
            "selected": 32768,
            "reserved": 28672,
            "mask": 4095
        }
    },
    "device_index": {
        "base_type": "uint8",
        "values": {
            "0": "creator",
            "creator": 0
        }
    },
    "gender": {
        "base_type": "enum",
        "values": {
            "0": "female",
            "1": "male",
            "female": 0,
            "male": 1
        }
    },
    "language": {
        "base_type": "enum",
        "values": {
            "0": "english",
            "1": "french",
            "2": "italian",
            "3": "german",
            "4": "spanish",
            "5": "croatian",
            "6": "czech",
            "7": "danish",
            "8": "dutch",
            "9": "finnish",
            "10": "greek",
            "11": "hungarian",
            "12": "norwegian",
            "13": "polish",
            "14": "portuguese",
            "15": "slovakian",
            "16": "slovenian",
            "17": "swedish",
            "18": "russian",
            "19": "turkish",
            "20": "latvian",
            "21": "ukrainian",
            "22": "arabic",
            "23": "farsi",
            "24": "bulgarian",
            "25": "romanian",
            "26": "chinese",
            "27": "japanese",
            "28": "korean",
            "29": "taiwanese",
            "30": "thai",
            "31": "hebrew",
            "32": "brazilian_portuguese",
            "33": "indonesian",
            "34": "malaysian",
            "35": "vietnamese",
            "36": "burmese",
            "37": "mongolian",
            "254": "custom",
            "english": 0,
            "french": 1,
            "italian": 2,
            "german": 3,
            "spanish": 4,
            "croatian": 5,
            "czech": 6,
            "danish": 7,
            "dutch": 8,
            "finnish": 9,
            "greek": 10,
            "hungarian": 11,
            "norwegian": 12,
            "polish": 13,
            "portuguese": 14,
            "slovakian": 15,
            "slovenian": 16,
            "swedish": 17,
            "russian": 18,
            "turkish": 19,
            "latvian": 20,
            "ukrainian": 21,
            "arabic": 22,
            "farsi": 23,
            "bulgarian": 24,
            "romanian": 25,
            "chinese": 26,
            "japanese": 27,
            "korean": 28,
            "taiwanese": 29,
            "thai": 30,
            "hebrew": 31,
            "brazilian_portuguese": 32,
            "indonesian": 33,
            "malaysian": 34,
            "vietnamese": 35,
            "burmese": 36,
            "mongolian": 37,
            "custom": 254
        }
    },
    "language_bits_0": {
        "base_type": "uint8z",
        "values": {
            "1": "english",
            "2": "french",
            "4": "italian",
            "8": "german",
            "16": "spanish",
            "32": "croatian",
            "64": "czech",
            "128": "danish",
            "english": 1,
            "french": 2,
            "italian": 4,
            "german": 8,
            "spanish": 16,
            "croatian": 32,
            "czech": 64,
            "danish": 128
        }
    },
    "language_bits_1": {
        "base_type": "uint8z",
        "values": {
            "1": "dutch",
            "2": "finnish",
            "4": "greek",
            "8": "hungarian",
            "16": "norwegian",
            "32": "polish",
            "64": "portuguese",
            "128": "slovakian",
            "dutch": 1,
            "finnish": 2,
            "greek": 4,
            "hungarian": 8,
            "norwegian": 16,
            "polish": 32,
            "portuguese": 64,
            "slovakian": 128
        }
    },
    "language_bits_2": {
        "base_type": "uint8z",
        "values": {
            "1": "slovenian",
            "2": "swedish",
            "4": "russian",
            "8": "turkish",
            "16": "latvian",
            "32": "ukrainian",
            "64": "arabic",
            "128": "farsi",
            "slovenian": 1,
            "swedish": 2,
            "russian": 4,
            "turkish": 8,
            "latvian": 16,
            "ukrainian": 32,
            "arabic": 64,
            "farsi": 128
        }
    },
    "language_bits_3": {
        "base_type": "uint8z",
        "values": {
            "1": "bulgarian",
            "2": "romanian",
            "4": "chinese",
            "8": "japanese",
            "16": "korean",
            "32": "taiwanese",
            "64": "thai",
            "128": "hebrew",
            "bulgarian": 1,
            "romanian": 2,
            "chinese": 4,
            "japanese": 8,
            "korean": 16,
            "taiwanese": 32,
            "thai": 64,
            "hebrew": 128
        }
    },
    "language_bits_4": {
        "base_type": "uint8z",
        "values": {
            "1": "brazilian_portuguese",
            "2": "indonesian",
            "4": "malaysian",
            "8": "vietnamese",
            "16": "burmese",
            "32": "mongolian",
            "brazilian_portuguese": 1,
            "indonesian": 2,
            "malaysian": 4,
            "vietnamese": 8,
            "burmese": 16,
            "mongolian": 32
        }
    },
    "time_zone": {
        "base_type": "enum",
        "values": {
            "0": "almaty",
            "1": "bangkok",
            "2": "bombay",
            "3": "brasilia",
            "4": "cairo",
            "5": "cape_verde_is",
            "6": "darwin",
            "7": "eniwetok",
            "8": "fiji",
            "9": "hong_kong",
            "10": "islamabad",
            "11": "kabul",
            "12": "magadan",
            "13": "mid_atlantic",
            "14": "moscow",
            "15": "muscat",
            "16": "newfoundland",
            "17": "samoa",
            "18": "sydney",
            "19": "tehran",
            "20": "tokyo",
            "21": "us_alaska",
            "22": "us_atlantic",
            "23": "us_central",
            "24": "us_eastern",
            "25": "us_hawaii",
            "26": "us_mountain",
            "27": "us_pacific",
            "28": "other",
            "29": "auckland",
            "30": "kathmandu",
            "31": "europe_western_wet",
            "32": "europe_central_cet",
            "33": "europe_eastern_eet",
            "34": "jakarta",
            "35": "perth",
            "36": "adelaide",
            "37": "brisbane",
            "38": "tasmania",
            "39": "iceland",
            "40": "amsterdam",
            "41": "athens",
            "42": "barcelona",
            "43": "berlin",
            "44": "brussels",
            "45": "budapest",
            "46": "copenhagen",
            "47": "dublin",
            "48": "helsinki",
            "49": "lisbon",
            "50": "london",
            "51": "madrid",
            "52": "munich",
            "53": "oslo",
            "54": "paris",
            "55": "prague",
            "56": "reykjavik",
            "57": "rome",
            "58": "stockholm",
            "59": "vienna",
            "60": "warsaw",
            "61": "zurich",
            "62": "quebec",
            "63": "ontario",
            "64": "manitoba",
            "65": "saskatchewan",
            "66": "alberta",
            "67": "british_columbia",
            "68": "boise",
            "69": "boston",
            "70": "chicago",
            "71": "dallas",
            "72": "denver",
            "73": "kansas_city",
            "74": "las_vegas",
            "75": "los_angeles",
            "76": "miami",
            "77": "minneapolis",
            "78": "new_york",
            "79": "new_orleans",
            "80": "phoenix",
            "81": "santa_fe",
            "82": "seattle",
            "83": "washington_dc",
            "84": "us_arizona",
            "85": "chita",
            "86": "ekaterinburg",
            "87": "irkutsk",
            "88": "kaliningrad",
            "89": "krasnoyarsk",
            "90": "novosibirsk",
            "91": "petropavlovsk_kamchatskiy",
            "92": "samara",
            "93": "vladivostok",
            "94": "mexico_central",
            "95": "mexico_mountain",
            "96": "mexico_pacific",
            "97": "cape_town",
            "98": "winkhoek",
            "99": "lagos",
            "100": "riyahd",
            "101": "venezuela",
            "102": "australia_lh",
            "103": "santiago",
            "253": "manual",
            "254": "automatic",
            "almaty": 0,
            "bangkok": 1,
            "bombay": 2,
            "brasilia": 3,
            "cairo": 4,
            "cape_verde_is": 5,
            "darwin": 6,
            "eniwetok": 7,
            "fiji": 8,
            "hong_kong": 9,
            "islamabad": 10,
            "kabul": 11,
            "magadan": 12,
            "mid_atlantic": 13,
            "moscow": 14,
            "muscat": 15,
            "newfoundland": 16,
            "samoa": 17,
            "sydney": 18,
            "tehran": 19,
            "tokyo": 20,
            "us_alaska": 21,
            "us_atlantic": 22,
            "us_central": 23,
            "us_eastern": 24,
            "us_hawaii": 25,
            "us_mountain": 26,
            "us_pacific": 27,
            "other": 28,
            "auckland": 29,
            "kathmandu": 30,
            "europe_western_wet": 31,
            "europe_central_cet": 32,
            "europe_eastern_eet": 33,
            "jakarta": 34,
            "perth": 35,
            "adelaide": 36,
            "brisbane": 37,
            "tasmania": 38,
            "iceland": 39,
            "amsterdam": 40,
            "athens": 41,
            "barcelona": 42,
            "berlin": 43,
            "brussels": 44,
            "budapest": 45,
            "copenhagen": 46,
            "dublin": 47,
            "helsinki": 48,
            "lisbon": 49,
            "london": 50,
            "madrid": 51,
            "munich": 52,
            "oslo": 53,
            "paris": 54,
            "prague": 55,
            "reykjavik": 56,
            "rome": 57,
            "stockholm": 58,
            "vienna": 59,
            "warsaw": 60,
            "zurich": 61,
            "quebec": 62,
            "ontario": 63,
            "manitoba": 64,
            "saskatchewan": 65,
            "alberta": 66,
            "british_columbia": 67,
            "boise": 68,
            "boston": 69,
            "chicago": 70,
            "dallas": 71,
            "denver": 72,
            "kansas_city": 73,
            "las_vegas": 74,
            "los_angeles": 75,
            "miami": 76,
            "minneapolis": 77,
            "new_york": 78,
            "new_orleans": 79,
            "phoenix": 80,
            "santa_fe": 81,
            "seattle": 82,
            "washington_dc": 83,
            "us_arizona": 84,
            "chita": 85,
            "ekaterinburg": 86,
            "irkutsk": 87,
            "kaliningrad": 88,
            "krasnoyarsk": 89,
            "novosibirsk": 90,
            "petropavlovsk_kamchatskiy": 91,
            "samara": 92,
            "vladivostok": 93,
            "mexico_central": 94,
            "mexico_mountain": 95,
            "mexico_pacific": 96,
            "cape_town": 97,
            "winkhoek": 98,
            "lagos": 99,
            "riyahd": 100,
            "venezuela": 101,
            "australia_lh": 102,
            "santiago": 103,
            "manual": 253,
            "automatic": 254
        }
    },
    "display_measure": {
        "base_type": "enum",
        "values": {
            "0": "metric",
            "1": "statute",
            "2": "nautical",
            "metric": 0,
            "statute": 1,
            "nautical": 2
        }
    },
    "display_heart": {
        "base_type": "enum",
        "values": {
            "0": "bpm",
            "1": "max",
            "2": "reserve",
            "bpm": 0,
            "max": 1,
            "reserve": 2
        }
    },
    "display_power": {
        "base_type": "enum",
        "values": {
            "0": "watts",
            "1": "percent_ftp",
            "watts": 0,
            "percent_ftp": 1
        }
    },
    "display_position": {
        "base_type": "enum",
        "values": {
            "0": "degree",
            "1": "degree_minute",
            "2": "degree_minute_second",
            "3": "austrian_grid",
            "4": "british_grid",
            "5": "dutch_grid",
            "6": "hungarian_grid",
            "7": "finnish_grid",
            "8": "german_grid",
            "9": "icelandic_grid",
            "10": "indonesian_equatorial",
            "11": "indonesian_irian",
            "12": "indonesian_southern",
            "13": "india_zone_0",
            "14": "india_zone_IA",
            "15": "india_zone_IB",
            "16": "india_zone_IIA",
            "17": "india_zone_IIB",
            "18": "india_zone_IIIA",
            "19": "india_zone_IIIB",
            "20": "india_zone_IVA",
            "21": "india_zone_IVB",
            "22": "irish_transverse",
            "23": "irish_grid",
            "24": "loran",
            "25": "maidenhead_grid",
            "26": "mgrs_grid",
            "27": "new_zealand_grid",
            "28": "new_zealand_transverse",
            "29": "qatar_grid",
            "30": "modified_swedish_grid",
            "31": "swedish_grid",
            "32": "south_african_grid",
            "33": "swiss_grid",
            "34": "taiwan_grid",
            "35": "united_states_grid",
            "36": "utm_ups_grid",
            "37": "west_malayan",
            "38": "borneo_rso",
            "39": "estonian_grid",
            "40": "latvian_grid",
            "41": "swedish_ref_99_grid",
            "degree": 0,
            "degree_minute": 1,
            "degree_minute_second": 2,
            "austrian_grid": 3,
            "british_grid": 4,
            "dutch_grid": 5,
            "hungarian_grid": 6,
            "finnish_grid": 7,
            "german_grid": 8,
            "icelandic_grid": 9,
            "indonesian_equatorial": 10,
            "indonesian_irian": 11,
            "indonesian_southern": 12,
            "india_zone_0": 13,
            "india_zone_IA": 14,
            "india_zone_IB": 15,
            "india_zone_IIA": 16,
            "india_zone_IIB": 17,
            "india_zone_IIIA": 18,
            "india_zone_IIIB": 19,
            "india_zone_IVA": 20,
            "india_zone_IVB": 21,
            "irish_transverse": 22,
            "irish_grid": 23,
            "loran": 24,
            "maidenhead_grid": 25,
            "mgrs_grid": 26,
            "new_zealand_grid": 27,
            "new_zealand_transverse": 28,
            "qatar_grid": 29,
            "modified_swedish_grid": 30,
            "swedish_grid": 31,
            "south_african_grid": 32,
            "swiss_grid": 33,
            "taiwan_grid": 34,
            "united_states_grid": 35,
            "utm_ups_grid": 36,
            "west_malayan": 37,
            "borneo_rso": 38,
            "estonian_grid": 39,
            "latvian_grid": 40,
            "swedish_ref_99_grid": 41
        }
    },
    "switch": {
        "base_type": "enum",
        "values": {
            "0": "off",
            "1": "on",
            "2": "auto",
            "off": 0,
            "on": 1,
            "auto": 2
        }
    },
    "sport": {
        "base_type": "enum",
        "values": {
            "0": "generic",
            "1": "running",
            "2": "cycling",
            "3": "transition",
            "4": "fitness_equipment",
            "5": "swimming",
            "6": "basketball",
            "7": "soccer",
            "8": "tennis",
            "9": "american_football",
            "10": "training",
            "11": "walking",
            "12": "cross_country_skiing",
            "13": "alpine_skiing",
            "14": "snowboarding",
            "15": "rowing",
            "16": "mountaineering",
            "17": "hiking",
            "18": "multisport",
            "19": "paddling",
            "20": "flying",
            "21": "e_biking",
            "22": "motorcycling",
            "23": "boating",
            "24": "driving",
            "25": "golf",
            "26": "hang_gliding",
            "27": "horseback_riding",
            "28": "hunting",
            "29": "fishing",
            "30": "inline_skating",
            "31": "rock_climbing",
            "32": "sailing",
            "33": "ice_skating",
            "34": "sky_diving",
            "35": "snowshoeing",
            "36": "snowmobiling",
            "37": "stand_up_paddleboarding",
            "38": "surfing",
            "39": "wakeboarding",
            "40": "water_skiing",
            "41": "kayaking",
            "42": "rafting",
            "43": "windsurfing",
            "44": "kitesurfing",
            "45": "tactical",
            "46": "jumpmaster",
            "47": "boxing",
            "48": "floor_climbing",
            "53": "diving",
            "254": "all",
            "generic": 0,
            "running": 1,
            "cycling": 2,
            "transition": 3,
            "fitness_equipment": 4,
            "swimming": 5,
            "basketball": 6,
            "soccer": 7,
            "tennis": 8,
            "american_football": 9,
            "training": 10,
            "walking": 11,
            "cross_country_skiing": 12,
            "alpine_skiing": 13,
            "snowboarding": 14,
            "rowing": 15,
            "mountaineering": 16,
            "hiking": 17,
            "multisport": 18,
            "paddling": 19,
            "flying": 20,
            "e_biking": 21,
            "motorcycling": 22,
            "boating": 23,
            "driving": 24,
            "golf": 25,
            "hang_gliding": 26,
            "horseback_riding": 27,
            "hunting": 28,
            "fishing": 29,
            "inline_skating": 30,
            "rock_climbing": 31,
            "sailing": 32,
            "ice_skating": 33,
            "sky_diving": 34,
            "snowshoeing": 35,
            "snowmobiling": 36,
            "stand_up_paddleboarding": 37,
            "surfing": 38,
            "wakeboarding": 39,
            "water_skiing": 40,
            "kayaking": 41,
            "rafting": 42,
            "windsurfing": 43,
            "kitesurfing": 44,
            "tactical": 45,
            "jumpmaster": 46,
            "boxing": 47,
            "floor_climbing": 48,
            "diving": 53,
            "all": 254
        }
    },
    "sport_bits_0": {
        "base_type": "uint8z",
        "values": {
            "1": "generic",
            "2": "running",
            "4": "cycling",
            "8": "transition",
            "16": "fitness_equipment",
            "32": "swimming",
            "64": "basketball",
            "128": "soccer",
            "generic": 1,
            "running": 2,
            "cycling": 4,
            "transition": 8,
            "fitness_equipment": 16,
            "swimming": 32,
            "basketball": 64,
            "soccer": 128
        }
    },
    "sport_bits_1": {
        "base_type": "uint8z",
        "values": {
            "1": "tennis",
            "2": "american_football",
            "4": "training",
            "8": "walking",
            "16": "cross_country_skiing",
            "32": "alpine_skiing",
            "64": "snowboarding",
            "128": "rowing",
            "tennis": 1,
            "american_football": 2,
            "training": 4,
            "walking": 8,
            "cross_country_skiing": 16,
            "alpine_skiing": 32,
            "snowboarding": 64,
            "rowing": 128
        }
    },
    "sport_bits_2": {
        "base_type": "uint8z",
        "values": {
            "1": "mountaineering",
            "2": "hiking",
            "4": "multisport",
            "8": "paddling",
            "16": "flying",
            "32": "e_biking",
            "64": "motorcycling",
            "128": "boating",
            "mountaineering": 1,
            "hiking": 2,
            "multisport": 4,
            "paddling": 8,
            "flying": 16,
            "e_biking": 32,
            "motorcycling": 64,
            "boating": 128
        }
    },
    "sport_bits_3": {
        "base_type": "uint8z",
        "values": {
            "1": "driving",
            "2": "golf",
            "4": "hang_gliding",
            "8": "horseback_riding",
            "16": "hunting",
            "32": "fishing",
            "64": "inline_skating",
            "128": "rock_climbing",
            "driving": 1,
            "golf": 2,
            "hang_gliding": 4,
            "horseback_riding": 8,
            "hunting": 16,
            "fishing": 32,
            "inline_skating": 64,
            "rock_climbing": 128
        }
    },
    "sport_bits_4": {
        "base_type": "uint8z",
        "values": {
            "1": "sailing",
            "2": "ice_skating",
            "4": "sky_diving",
            "8": "snowshoeing",
            "16": "snowmobiling",
            "32": "stand_up_paddleboarding",
            "64": "surfing",
            "128": "wakeboarding",
            "sailing": 1,
            "ice_skating": 2,
            "sky_diving": 4,
            "snowshoeing": 8,
            "snowmobiling": 16,
            "stand_up_paddleboarding": 32,
            "surfing": 64,
            "wakeboarding": 128
        }
    },
    "sport_bits_5": {
        "base_type": "uint8z",
        "values": {
            "1": "water_skiing",
            "2": "kayaking",
            "4": "rafting",
            "8": "windsurfing",
            "16": "kitesurfing",
            "32": "tactical",
            "64": "jumpmaster",
            "128": "boxing",
            "water_skiing": 1,
            "kayaking": 2,
            "rafting": 4,
            "windsurfing": 8,
            "kitesurfing": 16,
            "tactical": 32,
            "jumpmaster": 64,
            "boxing": 128
        }
    },
    "sport_bits_6": {
        "base_type": "uint8z",
        "values": {
            "1": "floor_climbing",
            "floor_climbing": 1
        }
    },
    "sub_sport": {
        "base_type": "enum",
        "values": {
            "0": "generic",
            "1": "treadmill",
            "2": "street",
            "3": "trail",
            "4": "track",
            "5": "spin",
            "6": "indoor_cycling",
            "7": "road",
            "8": "mountain",
            "9": "downhill",
            "10": "recumbent",
            "11": "cyclocross",
            "12": "hand_cycling",
            "13": "track_cycling",
            "14": "indoor_rowing",
            "15": "elliptical",
            "16": "stair_climbing",
            "17": "lap_swimming",
            "18": "open_water",
            "19": "flexibility_training",
            "20": "strength_training",
            "21": "warm_up",
            "22": "match",
            "23": "exercise",
            "24": "challenge",
            "25": "indoor_skiing",
            "26": "cardio_training",
            "27": "indoor_walking",
            "28": "e_bike_fitness",
            "29": "bmx",
            "30": "casual_walking",
            "31": "speed_walking",
            "32": "bike_to_run_transition",
            "33": "run_to_bike_transition",
            "34": "swim_to_bike_transition",
            "35": "atv",
            "36": "motocross",
            "37": "backcountry",
            "38": "resort",
            "39": "rc_drone",
            "40": "wingsuit",
            "41": "whitewater",
            "42": "skate_skiing",
            "43": "yoga",
            "44": "pilates",
            "45": "indoor_running",
            "46": "gravel_cycling",
            "47": "e_bike_mountain",
            "48": "commuting",
            "49": "mixed_surface",
            "50": "navigate",
            "51": "track_me",
            "52": "map",
            "53": "single_gas_diving",
            "54": "multi_gas_diving",
            "55": "gauge_diving",
            "56": "apnea_diving",
            "57": "apnea_hunting",
            "58": "virtual_activity",
            "59": "obstacle",
            "65": "sail_race",
            "254": "all",
            "generic": 0,
            "treadmill": 1,
            "street": 2,
            "trail": 3,
            "track": 4,
            "spin": 5,
            "indoor_cycling": 6,
            "road": 7,
            "mountain": 8,
            "downhill": 9,
            "recumbent": 10,
            "cyclocross": 11,
            "hand_cycling": 12,
            "track_cycling": 13,
            "indoor_rowing": 14,
            "elliptical": 15,
            "stair_climbing": 16,
            "lap_swimming": 17,
            "open_water": 18,
            "flexibility_training": 19,
            "strength_training": 20,
            "warm_up": 21,
            "match": 22,
            "exercise": 23,
            "challenge": 24,
            "indoor_skiing": 25,
            "cardio_training": 26,
            "indoor_walking": 27,
            "e_bike_fitness": 28,
            "bmx": 29,
            "casual_walking": 30,
            "speed_walking": 31,
            "bike_to_run_transition": 32,
            "run_to_bike_transition": 33,
            "swim_to_bike_transition": 34,
            "atv": 35,
            "motocross": 36,
            "backcountry": 37,
            "resort": 38,
            "rc_drone": 39,
            "wingsuit": 40,
            "whitewater": 41,
            "skate_skiing": 42,
            "yoga": 43,
            "pilates": 44,
            "indoor_running": 45,
            "gravel_cycling": 46,
            "e_bike_mountain": 47,
            "commuting": 48,
            "mixed_surface": 49,
            "navigate": 50,
            "track_me": 51,
            "map": 52,
            "single_gas_diving": 53,
            "multi_gas_diving": 54,
            "gauge_diving": 55,
            "apnea_diving": 56,
            "apnea_hunting": 57,
            "virtual_activity": 58,
            "obstacle": 59,
            "sail_race": 65,
            "all": 254
        }
    },
    "sport_event": {
        "base_type": "enum",
        "values": {
            "0": "uncategorized",
            "1": "geocaching",
            "2": "fitness",
            "3": "recreation",
            "4": "race",
            "5": "special_event",
            "6": "training",
            "7": "transportation",
            "8": "touring",
            "uncategorized": 0,
            "geocaching": 1,
            "fitness": 2,
            "recreation": 3,
            "race": 4,
            "special_event": 5,
            "training": 6,
            "transportation": 7,
            "touring": 8
        }
    },
    "activity": {
        "base_type": "enum",
        "values": {
            "0": "manual",
            "1": "auto_multi_sport",
            "manual": 0,
            "auto_multi_sport": 1
        }
    },
    "intensity": {
        "base_type": "enum",
        "values": {
            "0": "active",
            "1": "rest",
            "2": "warmup",
            "3": "cooldown",
            "4": "recovery",
            "5": "interval",
            "6": "other",
            "active": 0,
            "rest": 1,
            "warmup": 2,
            "cooldown": 3,
            "recovery": 4,
            "interval": 5,
            "other": 6
        }
    },
    "session_trigger": {
        "base_type": "enum",
        "values": {
            "0": "activity_end",
            "1": "manual",
            "2": "auto_multi_sport",
            "3": "fitness_equipment",
            "activity_end": 0,
            "manual": 1,
            "auto_multi_sport": 2,
            "fitness_equipment": 3
        }
    },
    "autolap_trigger": {
        "base_type": "enum",
        "values": {
            "0": "time",
            "1": "distance",
            "2": "position_start",
            "3": "position_lap",
            "4": "position_waypoint",
            "5": "position_marked",
            "6": "off",
            "time": 0,
            "distance": 1,
            "position_start": 2,
            "position_lap": 3,
            "position_waypoint": 4,
            "position_marked": 5,
            "off": 6
        }
    },
    "lap_trigger": {
        "base_type": "enum",
        "values": {
            "0": "manual",
            "1": "time",
            "2": "distance",
            "3": "position_start",
            "4": "position_lap",
            "5": "position_waypoint",
            "6": "position_marked",
            "7": "session_end",
            "8": "fitness_equipment",
            "manual": 0,
            "time": 1,
            "distance": 2,
            "position_start": 3,
            "position_lap": 4,
            "position_waypoint": 5,
            "position_marked": 6,
            "session_end": 7,
            "fitness_equipment": 8
        }
    },
    "time_mode": {
        "base_type": "enum",
        "values": {
            "0": "hour12",
            "1": "hour24",
            "2": "military",
            "3": "hour_12_with_seconds",
            "4": "hour_24_with_seconds",
            "5": "utc",
            "hour12": 0,
            "hour24": 1,
            "military": 2,
            "hour_12_with_seconds": 3,
            "hour_24_with_seconds": 4,
            "utc": 5
        }
    },
    "backlight_mode": {
        "base_type": "enum",
        "values": {
            "0": "off",
            "1": "manual",
            "2": "key_and_messages",
            "3": "auto_brightness",
            "4": "smart_notifications",
            "5": "key_and_messages_night",
            "6": "key_and_messages_and_smart_notifications",
            "off": 0,
            "manual": 1,
            "key_and_messages": 2,
            "auto_brightness": 3,
            "smart_notifications": 4,
            "key_and_messages_night": 5,
            "key_and_messages_and_smart_notifications": 6
        }
    },
    "date_mode": {
        "base_type": "enum",
        "values": {
            "0": "day_month",
            "1": "month_day",
            "day_month": 0,
            "month_day": 1
        }
    },
    "backlight_timeout": {
        "base_type": "uint8",
        "values": {
            "0": "infinite",
            "infinite": 0
        }
    },
    "event": {
        "base_type": "enum",
        "values": {
            "0": "timer",
            "3": "workout",
            "4": "workout_step",
            "5": "power_down",
            "6": "power_up",
            "7": "off_course",
            "8": "session",
            "9": "lap",
            "10": "course_point",
            "11": "battery",
            "12": "virtual_partner_pace",
            "13": "hr_high_alert",
            "14": "hr_low_alert",
            "15": "speed_high_alert",
            "16": "speed_low_alert",
            "17": "cad_high_alert",
            "18": "cad_low_alert",
            "19": "power_high_alert",
            "20": "power_low_alert",
            "21": "recovery_hr",
            "22": "battery_low",
            "23": "time_duration_alert",
            "24": "distance_duration_alert",
            "25": "calorie_duration_alert",
            "26": "activity",
            "27": "fitness_equipment",
            "28": "length",
            "32": "user_marker",
            "33": "sport_point",
            "36": "calibration",
            "42": "front_gear_change",
            "43": "rear_gear_change",
            "44": "rider_position_change",
            "45": "elev_high_alert",
            "46": "elev_low_alert",
            "47": "comm_timeout",
            "75": "radar_threat_alert",
            "timer": 0,
            "workout": 3,
            "workout_step": 4,
            "power_down": 5,
            "power_up": 6,
            "off_course": 7,
            "session": 8,
            "lap": 9,
            "course_point": 10,
            "battery": 11,
            "virtual_partner_pace": 12,
            "hr_high_alert": 13,
            "hr_low_alert": 14,
            "speed_high_alert": 15,
            "speed_low_alert": 16,
            "cad_high_alert": 17,
            "cad_low_alert": 18,
            "power_high_alert": 19,
            "power_low_alert": 20,
            "recovery_hr": 21,
            "battery_low": 22,
            "time_duration_alert": 23,
            "distance_duration_alert": 24,
            "calorie_duration_alert": 25,
            "activity": 26,
            "fitness_equipment": 27,
            "length": 28,
            "user_marker": 32,
            "sport_point": 33,
            "calibration": 36,
            "front_gear_change": 42,
            "rear_gear_change": 43,
            "rider_position_change": 44,
            "elev_high_alert": 45,
            "elev_low_alert": 46,
            "comm_timeout": 47,
            "radar_threat_alert": 75
        }
    },
    "event_type": {
        "base_type": "enum",
        "values": {
            "0": "start",
            "1": "stop",
            "2": "consecutive_depreciated",
            "3": "marker",
            "4": "stop_all",
            "5": "begin_depreciated",
            "6": "end_depreciated",
            "7": "end_all_depreciated",
            "8": "stop_disable",
            "9": "stop_disable_all",
            "start": 0,
            "stop": 1,
            "consecutive_depreciated": 2,
            "marker": 3,
            "stop_all": 4,
            "begin_depreciated": 5,
            "end_depreciated": 6,
            "end_all_depreciated": 7,
            "stop_disable": 8,
            "stop_disable_all": 9
        }
    },
    "timer_trigger": {
        "base_type": "enum",
        "values": {
            "0": "manual",
            "1": "auto",
            "2": "fitness_equipment",
            "manual": 0,
            "auto": 1,
            "fitness_equipment": 2
        }
    },
    "fitness_equipment_state": {
        "base_type": "enum",
        "values": {
            "0": "ready",
            "1": "in_use",
            "2": "paused",
            "3": "unknown",
            "ready": 0,
            "in_use": 1,
            "paused": 2,
            "unknown": 3
        }
    },
    "tone": {
        "base_type": "enum",
        "values": {
            "0": "off",
            "1": "tone",
            "2": "vibrate",
            "3": "tone_and_vibrate",
            "off": 0,
            "tone": 1,
            "vibrate": 2,
            "tone_and_vibrate": 3
        }
    },
    "autoscroll": {
        "base_type": "enum",
        "values": {
            "0": "none",
            "1": "slow",
            "2": "medium",
            "3": "fast",
            "none": 0,
            "slow": 1,
            "medium": 2,
            "fast": 3
        }
    },
    "activity_class": {
        "base_type": "enum",
        "values": {
            "100": "level_max",
            "127": "level",
            "128": "athlete",
            "level": 127,
            "level_max": 100,
            "athlete": 128
        }
    },
    "hr_zone_calc": {
        "base_type": "enum",
        "values": {
            "0": "custom",
            "1": "percent_max_hr",
            "2": "percent_hrr",
            "custom": 0,
            "percent_max_hr": 1,
            "percent_hrr": 2
        }
    },
    "pwr_zone_calc": {
        "base_type": "enum",
        "values": {
            "0": "custom",
            "1": "percent_ftp",
            "custom": 0,
            "percent_ftp": 1
        }
    },
    "wkt_step_duration": {
        "base_type": "enum",
        "values": {
            "0": "time",
            "1": "distance",
            "2": "hr_less_than",
            "3": "hr_greater_than",
            "4": "calories",
            "5": "open",
            "6": "repeat_until_steps_cmplt",
            "7": "repeat_until_time",
            "8": "repeat_until_distance",
            "9": "repeat_until_calories",
            "10": "repeat_until_hr_less_than",
            "11": "repeat_until_hr_greater_than",
            "12": "repeat_until_power_less_than",
            "13": "repeat_until_power_greater_than",
            "14": "power_less_than",
            "15": "power_greater_than",
            "16": "training_peaks_tss",
            "17": "repeat_until_power_last_lap_less_than",
            "18": "repeat_until_max_power_last_lap_less_than",
            "19": "power_3s_less_than",
            "20": "power_10s_less_than",
            "21": "power_30s_less_than",
            "22": "power_3s_greater_than",
            "23": "power_10s_greater_than",
            "24": "power_30s_greater_than",
            "25": "power_lap_less_than",
            "26": "power_lap_greater_than",
            "27": "repeat_until_training_peaks_tss",
            "28": "repetition_time",
            "29": "reps",
            "31": "time_only",
            "time": 0,
            "distance": 1,
            "hr_less_than": 2,
            "hr_greater_than": 3,
            "calories": 4,
            "open": 5,
            "repeat_until_steps_cmplt": 6,
            "repeat_until_time": 7,
            "repeat_until_distance": 8,
            "repeat_until_calories": 9,
            "repeat_until_hr_less_than": 10,
            "repeat_until_hr_greater_than": 11,
            "repeat_until_power_less_than": 12,
            "repeat_until_power_greater_than": 13,
            "power_less_than": 14,
            "power_greater_than": 15,
            "training_peaks_tss": 16,
            "repeat_until_power_last_lap_less_than": 17,
            "repeat_until_max_power_last_lap_less_than": 18,
            "power_3s_less_than": 19,
            "power_10s_less_than": 20,
            "power_30s_less_than": 21,
            "power_3s_greater_than": 22,
            "power_10s_greater_than": 23,
            "power_30s_greater_than": 24,
            "power_lap_less_than": 25,
            "power_lap_greater_than": 26,
            "repeat_until_training_peaks_tss": 27,
            "repetition_time": 28,
            "reps": 29,
            "time_only": 31
        }
    },
    "wkt_step_target": {
        "base_type": "enum",
        "values": {
            "0": "speed",
            "1": "heart_rate",
            "2": "open",
            "3": "cadence",
            "4": "power",
            "5": "grade",
            "6": "resistance",
            "7": "power_3s",
            "8": "power_10s",
            "9": "power_30s",
            "10": "power_lap",
            "11": "swim_stroke",
            "12": "speed_lap",
            "13": "heart_rate_lap",
            "speed": 0,
            "heart_rate": 1,
            "open": 2,
            "cadence": 3,
            "power": 4,
            "grade": 5,
            "resistance": 6,
            "power_3s": 7,
            "power_10s": 8,
            "power_30s": 9,
            "power_lap": 10,
            "swim_stroke": 11,
            "speed_lap": 12,
            "heart_rate_lap": 13
        }
    },
    "goal": {
        "base_type": "enum",
        "values": {
            "0": "time",
            "1": "distance",
            "2": "calories",
            "3": "frequency",
            "4": "steps",
            "5": "ascent",
            "6": "active_minutes",
            "time": 0,
            "distance": 1,
            "calories": 2,
            "frequency": 3,
            "steps": 4,
            "ascent": 5,
            "active_minutes": 6
        }
    },
    "goal_recurrence": {
        "base_type": "enum",
        "values": {
            "0": "off",
            "1": "daily",
            "2": "weekly",
            "3": "monthly",
            "4": "yearly",
            "5": "custom",
            "off": 0,
            "daily": 1,
            "weekly": 2,
            "monthly": 3,
            "yearly": 4,
            "custom": 5
        }
    },
    "goal_source": {
        "base_type": "enum",
        "values": {
            "0": "auto",
            "1": "community",
            "2": "user",
            "auto": 0,
            "community": 1,
            "user": 2
        }
    },
    "schedule": {
        "base_type": "enum",
        "values": {
            "0": "workout",
            "1": "course",
            "workout": 0,
            "course": 1
        }
    },
    "course_point": {
        "base_type": "enum",
        "values": {
            "0": "generic",
            "1": "summit",
            "2": "valley",
            "3": "water",
            "4": "food",
            "5": "danger",
            "6": "left",
            "7": "right",
            "8": "straight",
            "9": "first_aid",
            "10": "fourth_category",
            "11": "third_category",
            "12": "second_category",
            "13": "first_category",
            "14": "hors_category",
            "15": "sprint",
            "16": "left_fork",
            "17": "right_fork",
            "18": "middle_fork",
            "19": "slight_left",
            "20": "sharp_left",
            "21": "slight_right",
            "22": "sharp_right",
            "23": "u_turn",
            "24": "segment_start",
            "25": "segment_end",
            "generic": 0,
            "summit": 1,
            "valley": 2,
            "water": 3,
            "food": 4,
            "danger": 5,
            "left": 6,
            "right": 7,
            "straight": 8,
            "first_aid": 9,
            "fourth_category": 10,
            "third_category": 11,
            "second_category": 12,
            "first_category": 13,
            "hors_category": 14,
            "sprint": 15,
            "left_fork": 16,
            "right_fork": 17,
            "middle_fork": 18,
            "slight_left": 19,
            "sharp_left": 20,
            "slight_right": 21,
            "sharp_right": 22,
            "u_turn": 23,
            "segment_start": 24,
            "segment_end": 25
        }
    },
    "manufacturer": {
        "base_type": "uint16",
        "values": {
            "1": "garmin",
            "2": "garmin_fr405_antfs",
            "3": "zephyr",
            "4": "dayton",
            "5": "idt",
            "6": "srm",
            "7": "quarq",
            "8": "ibike",
            "9": "saris",
            "10": "spark_hk",
            "11": "tanita",
            "12": "echowell",
            "13": "dynastream_oem",
            "14": "nautilus",
            "15": "dynastream",
            "16": "timex",
            "17": "metrigear",
            "18": "xelic",
            "19": "beurer",
            "20": "cardiosport",
            "21": "a_and_d",
            "22": "hmm",
            "23": "suunto",
            "24": "thita_elektronik",
            "25": "gpulse",
            "26": "clean_mobile",
            "27": "pedal_brain",
            "28": "peaksware",
            "29": "saxonar",
            "30": "lemond_fitness",
            "31": "dexcom",
            "32": "wahoo_fitness",
            "33": "octane_fitness",
            "34": "archinoetics",
            "35": "the_hurt_box",
            "36": "citizen_systems",
            "37": "magellan",
            "38": "osynce",
            "39": "holux",
            "40": "concept2",
            "41": "shimano",
            "42": "one_giant_leap",
            "43": "ace_sensor",
            "44": "brim_brothers",
            "45": "xplova",
            "46": "perception_digital",
            "47": "bf1systems",
            "48": "pioneer",
            "49": "spantec",
            "50": "metalogics",
            "51": "4iiiis",
            "52": "seiko_epson",
            "53": "seiko_epson_oem",
            "54": "ifor_powell",
            "55": "maxwell_guider",
            "56": "star_trac",
            "57": "breakaway",
            "58": "alatech_technology_ltd",
            "59": "mio_technology_europe",
            "60": "rotor",
            "61": "geonaute",
            "62": "id_bike",
            "63": "specialized",
            "64": "wtek",
            "65": "physical_enterprises",
            "66": "north_pole_engineering",
            "67": "bkool",
            "68": "cateye",
            "69": "stages_cycling",
            "70": "sigmasport",
            "71": "tomtom",
            "72": "peripedal",
            "73": "wattbike",
            "76": "moxy",
            "77": "ciclosport",
            "78": "powerbahn",
            "79": "acorn_projects_aps",
            "80": "lifebeam",
            "81": "bontrager",
            "82": "wellgo",
            "83": "scosche",
            "84": "magura",
            "85": "woodway",
            "86": "elite",
            "87": "nielsen_kellerman",
            "88": "dk_city",
            "89": "tacx",
            "90": "direction_technology",
            "91": "magtonic",
            "92": "1partcarbon",
            "93": "inside_ride_technologies",
            "94": "sound_of_motion",
            "95": "stryd",
            "96": "icg",
            "97": "MiPulse",
            "98": "bsx_athletics",
            "99": "look",
            "100": "campagnolo_srl",
            "101": "body_bike_smart",
            "102": "praxisworks",
            "103": "limits_technology",
            "104": "topaction_technology",
            "105": "cosinuss",
            "106": "fitcare",
            "107": "magene",
            "108": "giant_manufacturing_co",
            "109": "tigrasport",
            "110": "salutron",
            "111": "technogym",
            "112": "bryton_sensors",
            "113": "latitude_limited",
            "114": "soaring_technology",
            "115": "igpsport",
            "116": "thinkrider",
            "117": "gopher_sport",
            "118": "waterrower",
            "119": "orangetheory",
            "120": "inpeak",
            "121": "kinetic",
            "122": "johnson_health_tech",
            "123": "polar_electro",
            "124": "seesense",
            "125": "nci_technology",
            "126": "iqsquare",
            "127": "leomo",
            "128": "ifit_com",
            "129": "coros_byte",
            "130": "versa_design",
            "131": "chileaf",
            "132": "cycplus",
            "133": "gravaa_byte",
            "134": "sigeyi",
            "135": "coospo",
            "255": "development",
            "257": "healthandlife",
            "258": "lezyne",
            "259": "scribe_labs",
            "260": "zwift",
            "261": "watteam",
            "262": "recon",
            "263": "favero_electronics",
            "264": "dynovelo",
            "265": "strava",
            "266": "precor",
            "267": "bryton",
            "268": "sram",
            "269": "navman",
            "270": "cobi",
            "271": "spivi",
            "272": "mio_magellan",
            "273": "evesports",
            "274": "sensitivus_gauge",
            "275": "podoon",
            "276": "life_time_fitness",
            "277": "falco_e_motors",
            "278": "minoura",
            "279": "cycliq",
            "280": "luxottica",
            "281": "trainer_road",
            "282": "the_sufferfest",
            "283": "fullspeedahead",
            "284": "virtualtraining",
            "285": "feedbacksports",
            "286": "omata",
            "287": "vdo",
            "288": "magneticdays",
            "289": "hammerhead",
            "290": "kinetic_by_kurt",
            "291": "shapelog",
            "292": "dabuziduo",
            "293": "jetblack",
            "294": "coros",
            "295": "virtugo",
            "296": "velosense",
            "297": "cycligentinc",
            "298": "trailforks",
            "299": "mahle_ebikemotion",
            "300": "nurvv",
            "301": "microprogram",
            "302": "zone5cloud",
            "303": "greenteg",
            "304": "yamaha_motors",
            "305": "whoop",
            "306": "gravaa",
            "307": "onelap",
            "308": "monark_exercise",
            "309": "form",
            "310": "decathlon",
            "311": "syncros",
            "5759": "actigraphcorp",
            "garmin": 1,
            "garmin_fr405_antfs": 2,
            "zephyr": 3,
            "dayton": 4,
            "idt": 5,
            "srm": 6,
            "quarq": 7,
            "ibike": 8,
            "saris": 9,
            "spark_hk": 10,
            "tanita": 11,
            "echowell": 12,
            "dynastream_oem": 13,
            "nautilus": 14,
            "dynastream": 15,
            "timex": 16,
            "metrigear": 17,
            "xelic": 18,
            "beurer": 19,
            "cardiosport": 20,
            "a_and_d": 21,
            "hmm": 22,
            "suunto": 23,
            "thita_elektronik": 24,
            "gpulse": 25,
            "clean_mobile": 26,
            "pedal_brain": 27,
            "peaksware": 28,
            "saxonar": 29,
            "lemond_fitness": 30,
            "dexcom": 31,
            "wahoo_fitness": 32,
            "octane_fitness": 33,
            "archinoetics": 34,
            "the_hurt_box": 35,
            "citizen_systems": 36,
            "magellan": 37,
            "osynce": 38,
            "holux": 39,
            "concept2": 40,
            "shimano": 41,
            "one_giant_leap": 42,
            "ace_sensor": 43,
            "brim_brothers": 44,
            "xplova": 45,
            "perception_digital": 46,
            "bf1systems": 47,
            "pioneer": 48,
            "spantec": 49,
            "metalogics": 50,
            "4iiiis": 51,
            "seiko_epson": 52,
            "seiko_epson_oem": 53,
            "ifor_powell": 54,
            "maxwell_guider": 55,
            "star_trac": 56,
            "breakaway": 57,
            "alatech_technology_ltd": 58,
            "mio_technology_europe": 59,
            "rotor": 60,
            "geonaute": 61,
            "id_bike": 62,
            "specialized": 63,
            "wtek": 64,
            "physical_enterprises": 65,
            "north_pole_engineering": 66,
            "bkool": 67,
            "cateye": 68,
            "stages_cycling": 69,
            "sigmasport": 70,
            "tomtom": 71,
            "peripedal": 72,
            "wattbike": 73,
            "moxy": 76,
            "ciclosport": 77,
            "powerbahn": 78,
            "acorn_projects_aps": 79,
            "lifebeam": 80,
            "bontrager": 81,
            "wellgo": 82,
            "scosche": 83,
            "magura": 84,
            "woodway": 85,
            "elite": 86,
            "nielsen_kellerman": 87,
            "dk_city": 88,
            "tacx": 89,
            "direction_technology": 90,
            "magtonic": 91,
            "1partcarbon": 92,
            "inside_ride_technologies": 93,
            "sound_of_motion": 94,
            "stryd": 95,
            "icg": 96,
            "MiPulse": 97,
            "bsx_athletics": 98,
            "look": 99,
            "campagnolo_srl": 100,
            "body_bike_smart": 101,
            "praxisworks": 102,
            "limits_technology": 103,
            "topaction_technology": 104,
            "cosinuss": 105,
            "fitcare": 106,
            "magene": 107,
            "giant_manufacturing_co": 108,
            "tigrasport": 109,
            "salutron": 110,
            "technogym": 111,
            "bryton_sensors": 112,
            "latitude_limited": 113,
            "soaring_technology": 114,
            "igpsport": 115,
            "thinkrider": 116,
            "gopher_sport": 117,
            "waterrower": 118,
            "orangetheory": 119,
            "inpeak": 120,
            "kinetic": 121,
            "johnson_health_tech": 122,
            "polar_electro": 123,
            "seesense": 124,
            "nci_technology": 125,
            "iqsquare": 126,
            "leomo": 127,
            "ifit_com": 128,
            "coros_byte": 129,
            "versa_design": 130,
            "chileaf": 131,
            "cycplus": 132,
            "gravaa_byte": 133,
            "sigeyi": 134,
            "coospo": 135,
            "development": 255,
            "healthandlife": 257,
            "lezyne": 258,
            "scribe_labs": 259,
            "zwift": 260,
            "watteam": 261,
            "recon": 262,
            "favero_electronics": 263,
            "dynovelo": 264,
            "strava": 265,
            "precor": 266,
            "bryton": 267,
            "sram": 268,
            "navman": 269,
            "cobi": 270,
            "spivi": 271,
            "mio_magellan": 272,
            "evesports": 273,
            "sensitivus_gauge": 274,
            "podoon": 275,
            "life_time_fitness": 276,
            "falco_e_motors": 277,
            "minoura": 278,
            "cycliq": 279,
            "luxottica": 280,
            "trainer_road": 281,
            "the_sufferfest": 282,
            "fullspeedahead": 283,
            "virtualtraining": 284,
            "feedbacksports": 285,
            "omata": 286,
            "vdo": 287,
            "magneticdays": 288,
            "hammerhead": 289,
            "kinetic_by_kurt": 290,
            "shapelog": 291,
            "dabuziduo": 292,
            "jetblack": 293,
            "coros": 294,
            "virtugo": 295,
            "velosense": 296,
            "cycligentinc": 297,
            "trailforks": 298,
            "mahle_ebikemotion": 299,
            "nurvv": 300,
            "microprogram": 301,
            "zone5cloud": 302,
            "greenteg": 303,
            "yamaha_motors": 304,
            "whoop": 305,
            "gravaa": 306,
            "onelap": 307,
            "monark_exercise": 308,
            "form": 309,
            "decathlon": 310,
            "syncros": 311,
            "actigraphcorp": 5759
        }
    },
    "garmin_product": {
        "base_type": "uint16",
        "values": {
            "1": "hrm1",
            "2": "axh01",
            "3": "axb01",
            "4": "axb02",
            "5": "hrm2ss",
            "6": "dsi_alf02",
            "7": "hrm3ss",
            "8": "hrm_run_single_byte_product_id",
            "9": "bsm",
            "10": "bcm",
            "11": "axs01",
            "12": "hrm_tri_single_byte_product_id",
            "13": "hrm4_run_single_byte_product_id",
            "14": "fr225_single_byte_product_id",
            "15": "gen3_bsm_single_byte_product_id",
            "16": "gen3_bcm_single_byte_product_id",
            "473": "fr301_china",
            "474": "fr301_japan",
            "475": "fr301_korea",
            "494": "fr301_taiwan",
            "717": "fr405",
            "782": "fr50",
            "987": "fr405_japan",
            "988": "fr60",
            "1011": "dsi_alf01",
            "1018": "fr310xt",
            "1036": "edge500",
            "1124": "fr110",
            "1169": "edge800",
            "1199": "edge500_taiwan",
            "1213": "edge500_japan",
            "1253": "chirp",
            "1274": "fr110_japan",
            "1325": "edge200",
            "1328": "fr910xt",
            "1333": "edge800_taiwan",
            "1334": "edge800_japan",
            "1341": "alf04",
            "1345": "fr610",
            "1360": "fr210_japan",
            "1380": "vector_ss",
            "1381": "vector_cp",
            "1386": "edge800_china",
            "1387": "edge500_china",
            "1405": "approach_g10",
            "1410": "fr610_japan",
            "1422": "edge500_korea",
            "1436": "fr70",
            "1446": "fr310xt_4t",
            "1461": "amx",
            "1482": "fr10",
            "1497": "edge800_korea",
            "1499": "swim",
            "1537": "fr910xt_china",
            "1551": "fenix",
            "1555": "edge200_taiwan",
            "1561": "edge510",
            "1567": "edge810",
            "1570": "tempe",
            "1600": "fr910xt_japan",
            "1623": "fr620",
            "1632": "fr220",
            "1664": "fr910xt_korea",
            "1688": "fr10_japan",
            "1721": "edge810_japan",
            "1735": "virb_elite",
            "1736": "edge_touring",
            "1742": "edge510_japan",
            "1743": "hrm_tri",
            "1752": "hrm_run",
            "1765": "fr920xt",
            "1821": "edge510_asia",
            "1822": "edge810_china",
            "1823": "edge810_taiwan",
            "1836": "edge1000",
            "1837": "vivo_fit",
            "1853": "virb_remote",
            "1885": "vivo_ki",
            "1903": "fr15",
            "1907": "vivo_active",
            "1918": "edge510_korea",
            "1928": "fr620_japan",
            "1929": "fr620_china",
            "1930": "fr220_japan",
            "1931": "fr220_china",
            "1936": "approach_s6",
            "1956": "vivo_smart",
            "1967": "fenix2",
            "1988": "epix",
            "2050": "fenix3",
            "2052": "edge1000_taiwan",
            "2053": "edge1000_japan",
            "2061": "fr15_japan",
            "2067": "edge520",
            "2070": "edge1000_china",
            "2072": "fr620_russia",
            "2073": "fr220_russia",
            "2079": "vector_s",
            "2100": "edge1000_korea",
            "2130": "fr920xt_taiwan",
            "2131": "fr920xt_china",
            "2132": "fr920xt_japan",
            "2134": "virbx",
            "2135": "vivo_smart_apac",
            "2140": "etrex_touch",
            "2147": "edge25",
            "2148": "fr25",
            "2150": "vivo_fit2",
            "2153": "fr225",
            "2156": "fr630",
            "2157": "fr230",
            "2158": "fr735xt",
            "2160": "vivo_active_apac",
            "2161": "vector_2",
            "2162": "vector_2s",
            "2172": "virbxe",
            "2173": "fr620_taiwan",
            "2174": "fr220_taiwan",
            "2175": "truswing",
            "2187": "d2airvenu",
            "2188": "fenix3_china",
            "2189": "fenix3_twn",
            "2192": "varia_headlight",
            "2193": "varia_taillight_old",
            "2204": "edge_explore_1000",
            "2219": "fr225_asia",
            "2225": "varia_radar_taillight",
            "2226": "varia_radar_display",
            "2238": "edge20",
            "2260": "edge520_asia",
            "2261": "edge520_japan",
            "2262": "d2_bravo",
            "2266": "approach_s20",
            "2271": "vivo_smart2",
            "2274": "edge1000_thai",
            "2276": "varia_remote",
            "2288": "edge25_asia",
            "2289": "edge25_jpn",
            "2290": "edge20_asia",
            "2292": "approach_x40",
            "2293": "fenix3_japan",
            "2294": "vivo_smart_emea",
            "2310": "fr630_asia",
            "2311": "fr630_jpn",
            "2313": "fr230_jpn",
            "2327": "hrm4_run",
            "2332": "epix_japan",
            "2337": "vivo_active_hr",
            "2347": "vivo_smart_gps_hr",
            "2348": "vivo_smart_hr",
            "2361": "vivo_smart_hr_asia",
            "2362": "vivo_smart_gps_hr_asia",
            "2368": "vivo_move",
            "2379": "varia_taillight",
            "2396": "fr235_asia",
            "2397": "fr235_japan",
            "2398": "varia_vision",
            "2406": "vivo_fit3",
            "2407": "fenix3_korea",
            "2408": "fenix3_sea",
            "2413": "fenix3_hr",
            "2417": "virb_ultra_30",
            "2429": "index_smart_scale",
            "2431": "fr235",
            "2432": "fenix3_chronos",
            "2441": "oregon7xx",
            "2444": "rino7xx",
            "2457": "epix_korea",
            "2473": "fenix3_hr_chn",
            "2474": "fenix3_hr_twn",
            "2475": "fenix3_hr_jpn",
            "2476": "fenix3_hr_sea",
            "2477": "fenix3_hr_kor",
            "2496": "nautix",
            "2497": "vivo_active_hr_apac",
            "2512": "oregon7xx_ww",
            "2530": "edge_820",
            "2531": "edge_explore_820",
            "2533": "fr735xt_apac",
            "2534": "fr735xt_japan",
            "2544": "fenix5s",
            "2547": "d2_bravo_titanium",
            "2567": "varia_ut800",
            "2593": "running_dynamics_pod",
            "2599": "edge_820_china",
            "2600": "edge_820_japan",
            "2604": "fenix5x",
            "2606": "vivo_fit_jr",
            "2622": "vivo_smart3",
            "2623": "vivo_sport",
            "2628": "edge_820_taiwan",
            "2629": "edge_820_korea",
            "2630": "edge_820_sea",
            "2650": "fr35_hebrew",
            "2656": "approach_s60",
            "2667": "fr35_apac",
            "2668": "fr35_japan",
            "2675": "fenix3_chronos_asia",
            "2687": "virb_360",
            "2691": "fr935",
            "2697": "fenix5",
            "2700": "vivoactive3",
            "2713": "edge_1030",
            "2733": "fr235_china_nfc",
            "2769": "foretrex_601_701",
            "2772": "vivo_move_hr",
            "2787": "vector_3",
            "2796": "fenix5_asia",
            "2797": "fenix5s_asia",
            "2798": "fenix5x_asia",
            "2806": "approach_z80",
            "2814": "fr35_korea",
            "2819": "d2charlie",
            "2831": "vivo_smart3_apac",
            "2832": "vivo_sport_apac",
            "2833": "fr935_asia",
            "2859": "descent",
            "2878": "vivo_fit4",
            "2886": "fr645",
            "2888": "fr645m",
            "2891": "fr30",
            "2900": "fenix5s_plus",
            "2909": "Edge_130",
            "2924": "edge_1030_asia",
            "2927": "vivosmart_4",
            "2945": "vivo_move_hr_asia",
            "2962": "approach_x10",
            "2977": "fr30_asia",
            "2988": "vivoactive3m_w",
            "3003": "fr645_asia",
            "3004": "fr645m_asia",
            "3011": "edge_explore",
            "3028": "gpsmap66",
            "3049": "approach_s10",
            "3066": "vivoactive3m_l",
            "3085": "approach_g80",
            "3092": "edge_130_asia",
            "3095": "edge_1030_bontrager",
            "3110": "fenix5_plus",
            "3111": "fenix5x_plus",
            "3112": "edge_520_plus",
            "3113": "fr945",
            "3121": "edge_530",
            "3122": "edge_830",
            "3126": "instinct_esports",
            "3134": "fenix5s_plus_apac",
            "3135": "fenix5x_plus_apac",
            "3142": "edge_520_plus_apac",
            "3144": "fr235l_asia",
            "3145": "fr245_asia",
            "3163": "vivo_active3m_apac",
            "3192": "gen3_bsm",
            "3193": "gen3_bcm",
            "3218": "vivo_smart4_asia",
            "3224": "vivoactive4_small",
            "3225": "vivoactive4_large",
            "3226": "venu",
            "3246": "marq_driver",
            "3247": "marq_aviator",
            "3248": "marq_captain",
            "3249": "marq_commander",
            "3250": "marq_expedition",
            "3251": "marq_athlete",
            "3258": "descent_mk2",
            "3284": "gpsmap66i",
            "3287": "fenix6S_sport",
            "3288": "fenix6S",
            "3289": "fenix6_sport",
            "3290": "fenix6",
            "3291": "fenix6x",
            "3299": "hrm_dual",
            "3300": "hrm_pro",
            "3308": "vivo_move3_premium",
            "3314": "approach_s40",
            "3321": "fr245m_asia",
            "3349": "edge_530_apac",
            "3350": "edge_830_apac",
            "3378": "vivo_move3",
            "3387": "vivo_active4_small_asia",
            "3388": "vivo_active4_large_asia",
            "3389": "vivo_active4_oled_asia",
            "3405": "swim2",
            "3420": "marq_driver_asia",
            "3421": "marq_aviator_asia",
            "3422": "vivo_move3_asia",
            "3441": "fr945_asia",
            "3446": "vivo_active3t_chn",
            "3448": "marq_captain_asia",
            "3449": "marq_commander_asia",
            "3450": "marq_expedition_asia",
            "3451": "marq_athlete_asia",
            "3469": "fr45_asia",
            "3473": "vivoactive3_daimler",
            "3498": "legacy_rey",
            "3499": "legacy_darth_vader",
            "3500": "legacy_captain_marvel",
            "3501": "legacy_first_avenger",
            "3512": "fenix6s_sport_asia",
            "3513": "fenix6s_asia",
            "3514": "fenix6_sport_asia",
            "3515": "fenix6_asia",
            "3516": "fenix6x_asia",
            "3535": "legacy_captain_marvel_asia",
            "3536": "legacy_first_avenger_asia",
            "3537": "legacy_rey_asia",
            "3538": "legacy_darth_vader_asia",
            "3542": "descent_mk2s",
            "3558": "edge_130_plus",
            "3570": "edge_1030_plus",
            "3578": "rally_200",
            "3589": "fr745",
            "3600": "venusq",
            "3615": "lily",
            "3624": "marq_adventurer",
            "3638": "enduro",
            "3639": "swim2_apac",
            "3648": "marq_adventurer_asia",
            "3702": "descent_mk2_asia",
            "3703": "venu2",
            "3704": "venu2s",
            "3737": "venu_daimler_asia",
            "3739": "marq_golfer",
            "3740": "venu_daimler",
            "3794": "fr745_asia",
            "3809": "lily_asia",
            "3812": "edge_1030_plus_asia",
            "3813": "edge_130_plus_asia",
            "3823": "approach_s12",
            "3837": "venusq_asia",
            "3850": "marq_golfer_asia",
            "3872": "enduro_asia",
            "3927": "approach_g12",
            "3930": "descent_mk2s_asia",
            "3934": "approach_s42",
            "3949": "venu2s_asia",
            "3950": "venu2_asia",
            "3986": "approach_S12_asia",
            "4001": "approach_g12_asia",
            "4002": "approach_s42_asia",
            "10007": "sdm4",
            "10014": "edge_remote",
            "20119": "training_center",
            "20533": "tacx_training_app_win",
            "20534": "tacx_training_app_mac",
            "30045": "tacx_training_app_android",
            "30046": "tacx_training_app_ios",
            "30047": "tacx_training_app_legacy",
            "65531": "connectiq_simulator",
            "65532": "android_antplus_plugin",
            "65534": "connect",
            "hrm1": 1,
            "axh01": 2,
            "axb01": 3,
            "axb02": 4,
            "hrm2ss": 5,
            "dsi_alf02": 6,
            "hrm3ss": 7,
            "hrm_run_single_byte_product_id": 8,
            "bsm": 9,
            "bcm": 10,
            "axs01": 11,
            "hrm_tri_single_byte_product_id": 12,
            "hrm4_run_single_byte_product_id": 13,
            "fr225_single_byte_product_id": 14,
            "gen3_bsm_single_byte_product_id": 15,
            "gen3_bcm_single_byte_product_id": 16,
            "fr301_china": 473,
            "fr301_japan": 474,
            "fr301_korea": 475,
            "fr301_taiwan": 494,
            "fr405": 717,
            "fr50": 782,
            "fr405_japan": 987,
            "fr60": 988,
            "dsi_alf01": 1011,
            "fr310xt": 1018,
            "edge500": 1036,
            "fr110": 1124,
            "edge800": 1169,
            "edge500_taiwan": 1199,
            "edge500_japan": 1213,
            "chirp": 1253,
            "fr110_japan": 1274,
            "edge200": 1325,
            "fr910xt": 1328,
            "edge800_taiwan": 1333,
            "edge800_japan": 1334,
            "alf04": 1341,
            "fr610": 1345,
            "fr210_japan": 1360,
            "vector_ss": 1380,
            "vector_cp": 1381,
            "edge800_china": 1386,
            "edge500_china": 1387,
            "approach_g10": 1405,
            "fr610_japan": 1410,
            "edge500_korea": 1422,
            "fr70": 1436,
            "fr310xt_4t": 1446,
            "amx": 1461,
            "fr10": 1482,
            "edge800_korea": 1497,
            "swim": 1499,
            "fr910xt_china": 1537,
            "fenix": 1551,
            "edge200_taiwan": 1555,
            "edge510": 1561,
            "edge810": 1567,
            "tempe": 1570,
            "fr910xt_japan": 1600,
            "fr620": 1623,
            "fr220": 1632,
            "fr910xt_korea": 1664,
            "fr10_japan": 1688,
            "edge810_japan": 1721,
            "virb_elite": 1735,
            "edge_touring": 1736,
            "edge510_japan": 1742,
            "hrm_tri": 1743,
            "hrm_run": 1752,
            "fr920xt": 1765,
            "edge510_asia": 1821,
            "edge810_china": 1822,
            "edge810_taiwan": 1823,
            "edge1000": 1836,
            "vivo_fit": 1837,
            "virb_remote": 1853,
            "vivo_ki": 1885,
            "fr15": 1903,
            "vivo_active": 1907,
            "edge510_korea": 1918,
            "fr620_japan": 1928,
            "fr620_china": 1929,
            "fr220_japan": 1930,
            "fr220_china": 1931,
            "approach_s6": 1936,
            "vivo_smart": 1956,
            "fenix2": 1967,
            "epix": 1988,
            "fenix3": 2050,
            "edge1000_taiwan": 2052,
            "edge1000_japan": 2053,
            "fr15_japan": 2061,
            "edge520": 2067,
            "edge1000_china": 2070,
            "fr620_russia": 2072,
            "fr220_russia": 2073,
            "vector_s": 2079,
            "edge1000_korea": 2100,
            "fr920xt_taiwan": 2130,
            "fr920xt_china": 2131,
            "fr920xt_japan": 2132,
            "virbx": 2134,
            "vivo_smart_apac": 2135,
            "etrex_touch": 2140,
            "edge25": 2147,
            "fr25": 2148,
            "vivo_fit2": 2150,
            "fr225": 2153,
            "fr630": 2156,
            "fr230": 2157,
            "fr735xt": 2158,
            "vivo_active_apac": 2160,
            "vector_2": 2161,
            "vector_2s": 2162,
            "virbxe": 2172,
            "fr620_taiwan": 2173,
            "fr220_taiwan": 2174,
            "truswing": 2175,
            "d2airvenu": 2187,
            "fenix3_china": 2188,
            "fenix3_twn": 2189,
            "varia_headlight": 2192,
            "varia_taillight_old": 2193,
            "edge_explore_1000": 2204,
            "fr225_asia": 2219,
            "varia_radar_taillight": 2225,
            "varia_radar_display": 2226,
            "edge20": 2238,
            "edge520_asia": 2260,
            "edge520_japan": 2261,
            "d2_bravo": 2262,
            "approach_s20": 2266,
            "vivo_smart2": 2271,
            "edge1000_thai": 2274,
            "varia_remote": 2276,
            "edge25_asia": 2288,
            "edge25_jpn": 2289,
            "edge20_asia": 2290,
            "approach_x40": 2292,
            "fenix3_japan": 2293,
            "vivo_smart_emea": 2294,
            "fr630_asia": 2310,
            "fr630_jpn": 2311,
            "fr230_jpn": 2313,
            "hrm4_run": 2327,
            "epix_japan": 2332,
            "vivo_active_hr": 2337,
            "vivo_smart_gps_hr": 2347,
            "vivo_smart_hr": 2348,
            "vivo_smart_hr_asia": 2361,
            "vivo_smart_gps_hr_asia": 2362,
            "vivo_move": 2368,
            "varia_taillight": 2379,
            "fr235_asia": 2396,
            "fr235_japan": 2397,
            "varia_vision": 2398,
            "vivo_fit3": 2406,
            "fenix3_korea": 2407,
            "fenix3_sea": 2408,
            "fenix3_hr": 2413,
            "virb_ultra_30": 2417,
            "index_smart_scale": 2429,
            "fr235": 2431,
            "fenix3_chronos": 2432,
            "oregon7xx": 2441,
            "rino7xx": 2444,
            "epix_korea": 2457,
            "fenix3_hr_chn": 2473,
            "fenix3_hr_twn": 2474,
            "fenix3_hr_jpn": 2475,
            "fenix3_hr_sea": 2476,
            "fenix3_hr_kor": 2477,
            "nautix": 2496,
            "vivo_active_hr_apac": 2497,
            "oregon7xx_ww": 2512,
            "edge_820": 2530,
            "edge_explore_820": 2531,
            "fr735xt_apac": 2533,
            "fr735xt_japan": 2534,
            "fenix5s": 2544,
            "d2_bravo_titanium": 2547,
            "varia_ut800": 2567,
            "running_dynamics_pod": 2593,
            "edge_820_china": 2599,
            "edge_820_japan": 2600,
            "fenix5x": 2604,
            "vivo_fit_jr": 2606,
            "vivo_smart3": 2622,
            "vivo_sport": 2623,
            "edge_820_taiwan": 2628,
            "edge_820_korea": 2629,
            "edge_820_sea": 2630,
            "fr35_hebrew": 2650,
            "approach_s60": 2656,
            "fr35_apac": 2667,
            "fr35_japan": 2668,
            "fenix3_chronos_asia": 2675,
            "virb_360": 2687,
            "fr935": 2691,
            "fenix5": 2697,
            "vivoactive3": 2700,
            "fr235_china_nfc": 2733,
            "foretrex_601_701": 2769,
            "vivo_move_hr": 2772,
            "edge_1030": 2713,
            "vector_3": 2787,
            "fenix5_asia": 2796,
            "fenix5s_asia": 2797,
            "fenix5x_asia": 2798,
            "approach_z80": 2806,
            "fr35_korea": 2814,
            "d2charlie": 2819,
            "vivo_smart3_apac": 2831,
            "vivo_sport_apac": 2832,
            "fr935_asia": 2833,
            "descent": 2859,
            "vivo_fit4": 2878,
            "fr645": 2886,
            "fr645m": 2888,
            "fr30": 2891,
            "fenix5s_plus": 2900,
            "Edge_130": 2909,
            "edge_1030_asia": 2924,
            "vivosmart_4": 2927,
            "vivo_move_hr_asia": 2945,
            "approach_x10": 2962,
            "fr30_asia": 2977,
            "vivoactive3m_w": 2988,
            "fr645_asia": 3003,
            "fr645m_asia": 3004,
            "edge_explore": 3011,
            "gpsmap66": 3028,
            "approach_s10": 3049,
            "vivoactive3m_l": 3066,
            "approach_g80": 3085,
            "edge_130_asia": 3092,
            "edge_1030_bontrager": 3095,
            "fenix5_plus": 3110,
            "fenix5x_plus": 3111,
            "edge_520_plus": 3112,
            "fr945": 3113,
            "edge_530": 3121,
            "edge_830": 3122,
            "instinct_esports": 3126,
            "fenix5s_plus_apac": 3134,
            "fenix5x_plus_apac": 3135,
            "edge_520_plus_apac": 3142,
            "fr235l_asia": 3144,
            "fr245_asia": 3145,
            "vivo_active3m_apac": 3163,
            "gen3_bsm": 3192,
            "gen3_bcm": 3193,
            "vivo_smart4_asia": 3218,
            "vivoactive4_small": 3224,
            "vivoactive4_large": 3225,
            "venu": 3226,
            "marq_driver": 3246,
            "marq_aviator": 3247,
            "marq_captain": 3248,
            "marq_commander": 3249,
            "marq_expedition": 3250,
            "marq_athlete": 3251,
            "descent_mk2": 3258,
            "gpsmap66i": 3284,
            "fenix6S_sport": 3287,
            "fenix6S": 3288,
            "fenix6_sport": 3289,
            "fenix6": 3290,
            "fenix6x": 3291,
            "hrm_dual": 3299,
            "hrm_pro": 3300,
            "vivo_move3_premium": 3308,
            "approach_s40": 3314,
            "fr245m_asia": 3321,
            "edge_530_apac": 3349,
            "edge_830_apac": 3350,
            "vivo_move3": 3378,
            "vivo_active4_small_asia": 3387,
            "vivo_active4_large_asia": 3388,
            "vivo_active4_oled_asia": 3389,
            "swim2": 3405,
            "marq_driver_asia": 3420,
            "marq_aviator_asia": 3421,
            "vivo_move3_asia": 3422,
            "fr945_asia": 3441,
            "vivo_active3t_chn": 3446,
            "marq_captain_asia": 3448,
            "marq_commander_asia": 3449,
            "marq_expedition_asia": 3450,
            "marq_athlete_asia": 3451,
            "fr45_asia": 3469,
            "vivoactive3_daimler": 3473,
            "legacy_rey": 3498,
            "legacy_darth_vader": 3499,
            "legacy_captain_marvel": 3500,
            "legacy_first_avenger": 3501,
            "fenix6s_sport_asia": 3512,
            "fenix6s_asia": 3513,
            "fenix6_sport_asia": 3514,
            "fenix6_asia": 3515,
            "fenix6x_asia": 3516,
            "legacy_captain_marvel_asia": 3535,
            "legacy_first_avenger_asia": 3536,
            "legacy_rey_asia": 3537,
            "legacy_darth_vader_asia": 3538,
            "descent_mk2s": 3542,
            "edge_130_plus": 3558,
            "edge_1030_plus": 3570,
            "rally_200": 3578,
            "fr745": 3589,
            "venusq": 3600,
            "lily": 3615,
            "marq_adventurer": 3624,
            "enduro": 3638,
            "marq_adventurer_asia": 3648,
            "swim2_apac": 3639,
            "descent_mk2_asia": 3702,
            "venu2": 3703,
            "venu2s": 3704,
            "venu_daimler_asia": 3737,
            "marq_golfer": 3739,
            "venu_daimler": 3740,
            "fr745_asia": 3794,
            "lily_asia": 3809,
            "edge_1030_plus_asia": 3812,
            "edge_130_plus_asia": 3813,
            "approach_s12": 3823,
            "enduro_asia": 3872,
            "venusq_asia": 3837,
            "marq_golfer_asia": 3850,
            "approach_g12": 3927,
            "descent_mk2s_asia": 3930,
            "approach_s42": 3934,
            "venu2s_asia": 3949,
            "venu2_asia": 3950,
            "approach_S12_asia": 3986,
            "approach_g12_asia": 4001,
            "approach_s42_asia": 4002,
            "sdm4": 10007,
            "edge_remote": 10014,
            "tacx_training_app_win": 20533,
            "tacx_training_app_mac": 20534,
            "training_center": 20119,
            "tacx_training_app_android": 30045,
            "tacx_training_app_ios": 30046,
            "tacx_training_app_legacy": 30047,
            "connectiq_simulator": 65531,
            "android_antplus_plugin": 65532,
            "connect": 65534
        }
    },
    "antplus_device_type": {
        "base_type": "uint8",
        "values": {
            "1": "antfs",
            "11": "bike_power",
            "12": "environment_sensor_legacy",
            "15": "multi_sport_speed_distance",
            "16": "control",
            "17": "fitness_equipment",
            "18": "blood_pressure",
            "19": "geocache_node",
            "20": "light_electric_vehicle",
            "25": "env_sensor",
            "26": "racquet",
            "27": "control_hub",
            "31": "muscle_oxygen",
            "35": "bike_light_main",
            "36": "bike_light_shared",
            "38": "exd",
            "40": "bike_radar",
            "46": "bike_aero",
            "119": "weight_scale",
            "120": "heart_rate",
            "121": "bike_speed_cadence",
            "122": "bike_cadence",
            "123": "bike_speed",
            "124": "stride_speed_distance",
            "antfs": 1,
            "bike_power": 11,
            "environment_sensor_legacy": 12,
            "multi_sport_speed_distance": 15,
            "control": 16,
            "fitness_equipment": 17,
            "blood_pressure": 18,
            "geocache_node": 19,
            "light_electric_vehicle": 20,
            "env_sensor": 25,
            "racquet": 26,
            "control_hub": 27,
            "muscle_oxygen": 31,
            "bike_light_main": 35,
            "bike_light_shared": 36,
            "exd": 38,
            "bike_radar": 40,
            "bike_aero": 46,
            "weight_scale": 119,
            "heart_rate": 120,
            "bike_speed_cadence": 121,
            "bike_cadence": 122,
            "bike_speed": 123,
            "stride_speed_distance": 124
        }
    },
    "ant_network": {
        "base_type": "enum",
        "values": {
            "0": "public",
            "1": "antplus",
            "2": "antfs",
            "3": "private",
            "public": 0,
            "antplus": 1,
            "antfs": 2,
            "private": 3
        }
    },
    "workout_capabilities": {
        "base_type": "uint32z",
        "values": {
            "1": "interval",
            "2": "custom",
            "4": "fitness_equipment",
            "8": "firstbeat",
            "16": "new_leaf",
            "32": "tcx",
            "128": "speed",
            "256": "heart_rate",
            "512": "distance",
            "1024": "cadence",
            "2048": "power",
            "4096": "grade",
            "8192": "resistance",
            "16384": "protected",
            "interval": 1,
            "custom": 2,
            "fitness_equipment": 4,
            "firstbeat": 8,
            "new_leaf": 16,
            "tcx": 32,
            "speed": 128,
            "heart_rate": 256,
            "distance": 512,
            "cadence": 1024,
            "power": 2048,
            "grade": 4096,
            "resistance": 8192,
            "protected": 16384
        }
    },
    "battery_status": {
        "base_type": "uint8",
        "values": {
            "1": "new",
            "2": "good",
            "3": "ok",
            "4": "low",
            "5": "critical",
            "6": "charging",
            "7": "unknown",
            "new": 1,
            "good": 2,
            "ok": 3,
            "low": 4,
            "critical": 5,
            "charging": 6,
            "unknown": 7
        }
    },
    "hr_type": {
        "base_type": "enum",
        "values": {
            "0": "normal",
            "1": "irregular",
            "normal": 0,
            "irregular": 1
        }
    },
    "course_capabilities": {
        "base_type": "uint32z",
        "values": {
            "1": "processed",
            "2": "valid",
            "4": "time",
            "8": "distance",
            "16": "position",
            "32": "heart_rate",
            "64": "power",
            "128": "cadence",
            "256": "training",
            "512": "navigation",
            "1024": "bikeway",
            "processed": 1,
            "valid": 2,
            "time": 4,
            "distance": 8,
            "position": 16,
            "heart_rate": 32,
            "power": 64,
            "cadence": 128,
            "training": 256,
            "navigation": 512,
            "bikeway": 1024
        }
    },
    "weight": {
        "base_type": "uint16",
        "values": {
            "65534": "calculating",
            "calculating": 65534
        }
    },
    "workout_hr": {
        "base_type": "uint32",
        "values": {
            "100": "bpm_offset",
            "bpm_offset": 100
        }
    },
    "workout_power": {
        "base_type": "uint32",
        "values": {
            "1000": "watts_offset",
            "watts_offset": 1000
        }
    },
    "bp_status": {
        "base_type": "enum",
        "values": {
            "0": "no_error",
            "1": "error_incomplete_data",
            "2": "error_no_measurement",
            "3": "error_data_out_of_range",
            "4": "error_irregular_heart_rate",
            "no_error": 0,
            "error_incomplete_data": 1,
            "error_no_measurement": 2,
            "error_data_out_of_range": 3,
            "error_irregular_heart_rate": 4
        }
    },
    "user_local_id": {
        "base_type": "uint16",
        "values": {
            "0": "local_min",
            "15": "local_max",
            "16": "stationary_min",
            "255": "stationary_max",
            "256": "portable_min",
            "65534": "portable_max",
            "local_min": 0,
            "local_max": 15,
            "stationary_min": 16,
            "stationary_max": 255,
            "portable_min": 256,
            "portable_max": 65534
        }
    },
    "swim_stroke": {
        "base_type": "enum",
        "values": {
            "0": "freestyle",
            "1": "backstroke",
            "2": "breaststroke",
            "3": "butterfly",
            "4": "drill",
            "5": "mixed",
            "6": "im",
            "freestyle": 0,
            "backstroke": 1,
            "breaststroke": 2,
            "butterfly": 3,
            "drill": 4,
            "mixed": 5,
            "im": 6
        }
    },
    "activity_type": {
        "base_type": "enum",
        "values": {
            "0": "generic",
            "1": "running",
            "2": "cycling",
            "3": "transition",
            "4": "fitness_equipment",
            "5": "swimming",
            "6": "walking",
            "8": "sedentary",
            "254": "all",
            "generic": 0,
            "running": 1,
            "cycling": 2,
            "transition": 3,
            "fitness_equipment": 4,
            "swimming": 5,
            "walking": 6,
            "sedentary": 8,
            "all": 254
        }
    },
    "activity_subtype": {
        "base_type": "enum",
        "values": {
            "0": "generic",
            "1": "treadmill",
            "2": "street",
            "3": "trail",
            "4": "track",
            "5": "spin",
            "6": "indoor_cycling",
            "7": "road",
            "8": "mountain",
            "9": "downhill",
            "10": "recumbent",
            "11": "cyclocross",
            "12": "hand_cycling",
            "13": "track_cycling",
            "14": "indoor_rowing",
            "15": "elliptical",
            "16": "stair_climbing",
            "17": "lap_swimming",
            "18": "open_water",
            "254": "all",
            "generic": 0,
            "treadmill": 1,
            "street": 2,
            "trail": 3,
            "track": 4,
            "spin": 5,
            "indoor_cycling": 6,
            "road": 7,
            "mountain": 8,
            "downhill": 9,
            "recumbent": 10,
            "cyclocross": 11,
            "hand_cycling": 12,
            "track_cycling": 13,
            "indoor_rowing": 14,
            "elliptical": 15,
            "stair_climbing": 16,
            "lap_swimming": 17,
            "open_water": 18,
            "all": 254
        }
    },
    "activity_level": {
        "base_type": "enum",
        "values": {
            "0": "low",
            "1": "medium",
            "2": "high",
            "low": 0,
            "medium": 1,
            "high": 2
        }
    },
    "side": {
        "base_type": "enum",
        "values": {
            "0": "right",
            "1": "left",
            "right": 0,
            "left": 1
        }
    },
    "left_right_balance": {
        "base_type": "uint8",
        "values": {
            "127": "mask",
            "128": "right",
            "mask": 127,
            "right": 128
        }
    },
    "left_right_balance_100": {
        "base_type": "uint16",
        "values": {
            "16383": "mask",
            "32768": "right",
            "mask": 16383,
            "right": 32768
        }
    },
    "length_type": {
        "base_type": "enum",
        "values": {
            "0": "idle",
            "1": "active",
            "idle": 0,
            "active": 1
        }
    },
    "day_of_week": {
        "base_type": "enum",
        "values": {
            "0": "sunday",
            "1": "monday",
            "2": "tuesday",
            "3": "wednesday",
            "4": "thursday",
            "5": "friday",
            "6": "saturday",
            "sunday": 0,
            "monday": 1,
            "tuesday": 2,
            "wednesday": 3,
            "thursday": 4,
            "friday": 5,
            "saturday": 6
        }
    },
    "connectivity_capabilities": {
        "base_type": "uint32z",
        "values": {
            "1": "bluetooth",
            "2": "bluetooth_le",
            "4": "ant",
            "8": "activity_upload",
            "16": "course_download",
            "32": "workout_download",
            "64": "live_track",
            "128": "weather_conditions",
            "256": "weather_alerts",
            "512": "gps_ephemeris_download",
            "1024": "explicit_archive",
            "2048": "setup_incomplete",
            "4096": "continue_sync_after_software_update",
            "8192": "connect_iq_app_download",
            "16384": "golf_course_download",
            "32768": "device_initiates_sync",
            "65536": "connect_iq_watch_app_download",
            "131072": "connect_iq_widget_download",
            "262144": "connect_iq_watch_face_download",
            "524288": "connect_iq_data_field_download",
            "1048576": "connect_iq_app_managment",
            "2097152": "swing_sensor",
            "4194304": "swing_sensor_remote",
            "8388608": "incident_detection",
            "16777216": "audio_prompts",
            "33554432": "wifi_verification",
            "67108864": "true_up",
            "134217728": "find_my_watch",
            "268435456": "remote_manual_sync",
            "536870912": "live_track_auto_start",
            "1073741824": "live_track_messaging",
            "2147483648": "instant_input",
            "bluetooth": 1,
            "bluetooth_le": 2,
            "ant": 4,
            "activity_upload": 8,
            "course_download": 16,
            "workout_download": 32,
            "live_track": 64,
            "weather_conditions": 128,
            "weather_alerts": 256,
            "gps_ephemeris_download": 512,
            "explicit_archive": 1024,
            "setup_incomplete": 2048,
            "continue_sync_after_software_update": 4096,
            "connect_iq_app_download": 8192,
            "golf_course_download": 16384,
            "device_initiates_sync": 32768,
            "connect_iq_watch_app_download": 65536,
            "connect_iq_widget_download": 131072,
            "connect_iq_watch_face_download": 262144,
            "connect_iq_data_field_download": 524288,
            "connect_iq_app_managment": 1048576,
            "swing_sensor": 2097152,
            "swing_sensor_remote": 4194304,
            "incident_detection": 8388608,
            "audio_prompts": 16777216,
            "wifi_verification": 33554432,
            "true_up": 67108864,
            "find_my_watch": 134217728,
            "remote_manual_sync": 268435456,
            "live_track_auto_start": 536870912,
            "live_track_messaging": 1073741824,
            "instant_input": 2147483648
        }
    },
    "weather_report": {
        "base_type": "enum",
        "values": {
            "0": "current",
            "1": "hourly_forecast",
            "2": "daily_forecast",
            "current": 0,
            "forecast": 1,
            "hourly_forecast": 1,
            "daily_forecast": 2
        }
    },
    "weather_status": {
        "base_type": "enum",
        "values": {
            "0": "clear",
            "1": "partly_cloudy",
            "2": "mostly_cloudy",
            "3": "rain",
            "4": "snow",
            "5": "windy",
            "6": "thunderstorms",
            "7": "wintry_mix",
            "8": "fog",
            "11": "hazy",
            "12": "hail",
            "13": "scattered_showers",
            "14": "scattered_thunderstorms",
            "15": "unknown_precipitation",
            "16": "light_rain",
            "17": "heavy_rain",
            "18": "light_snow",
            "19": "heavy_snow",
            "20": "light_rain_snow",
            "21": "heavy_rain_snow",
            "22": "cloudy",
            "clear": 0,
            "partly_cloudy": 1,
            "mostly_cloudy": 2,
            "rain": 3,
            "snow": 4,
            "windy": 5,
            "thunderstorms": 6,
            "wintry_mix": 7,
            "fog": 8,
            "hazy": 11,
            "hail": 12,
            "scattered_showers": 13,
            "scattered_thunderstorms": 14,
            "unknown_precipitation": 15,
            "light_rain": 16,
            "heavy_rain": 17,
            "light_snow": 18,
            "heavy_snow": 19,
            "light_rain_snow": 20,
            "heavy_rain_snow": 21,
            "cloudy": 22
        }
    },
    "weather_severity": {
        "base_type": "enum",
        "values": {
            "0": "unknown",
            "1": "warning",
            "2": "watch",
            "3": "advisory",
            "4": "statement",
            "unknown": 0,
            "warning": 1,
            "watch": 2,
            "advisory": 3,
            "statement": 4
        }
    },
    "weather_severe_type": {
        "base_type": "enum",
        "values": {
            "0": "unspecified",
            "1": "tornado",
            "2": "tsunami",
            "3": "hurricane",
            "4": "extreme_wind",
            "5": "typhoon",
            "6": "inland_hurricane",
            "7": "hurricane_force_wind",
            "8": "waterspout",
            "9": "severe_thunderstorm",
            "10": "wreckhouse_winds",
            "11": "les_suetes_wind",
            "12": "avalanche",
            "13": "flash_flood",
            "14": "tropical_storm",
            "15": "inland_tropical_storm",
            "16": "blizzard",
            "17": "ice_storm",
            "18": "freezing_rain",
            "19": "debris_flow",
            "20": "flash_freeze",
            "21": "dust_storm",
            "22": "high_wind",
            "23": "winter_storm",
            "24": "heavy_freezing_spray",
            "25": "extreme_cold",
            "26": "wind_chill",
            "27": "cold_wave",
            "28": "heavy_snow_alert",
            "29": "lake_effect_blowing_snow",
            "30": "snow_squall",
            "31": "lake_effect_snow",
            "32": "winter_weather",
            "33": "sleet",
            "34": "snowfall",
            "35": "snow_and_blowing_snow",
            "36": "blowing_snow",
            "37": "snow_alert",
            "38": "arctic_outflow",
            "39": "freezing_drizzle",
            "40": "storm",
            "41": "storm_surge",
            "42": "rainfall",
            "43": "areal_flood",
            "44": "coastal_flood",
            "45": "lakeshore_flood",
            "46": "excessive_heat",
            "47": "heat",
            "48": "weather",
            "49": "high_heat_and_humidity",
            "50": "humidex_and_health",
            "51": "humidex",
            "52": "gale",
            "53": "freezing_spray",
            "54": "special_marine",
            "55": "squall",
            "56": "strong_wind",
            "57": "lake_wind",
            "58": "marine_weather",
            "59": "wind",
            "60": "small_craft_hazardous_seas",
            "61": "hazardous_seas",
            "62": "small_craft",
            "63": "small_craft_winds",
            "64": "small_craft_rough_bar",
            "65": "high_water_level",
            "66": "ashfall",
            "67": "freezing_fog",
            "68": "dense_fog",
            "69": "dense_smoke",
            "70": "blowing_dust",
            "71": "hard_freeze",
            "72": "freeze",
            "73": "frost",
            "74": "fire_weather",
            "75": "flood",
            "76": "rip_tide",
            "77": "high_surf",
            "78": "smog",
            "79": "air_quality",
            "80": "brisk_wind",
            "81": "air_stagnation",
            "82": "low_water",
            "83": "hydrological",
            "84": "special_weather",
            "unspecified": 0,
            "tornado": 1,
            "tsunami": 2,
            "hurricane": 3,
            "extreme_wind": 4,
            "typhoon": 5,
            "inland_hurricane": 6,
            "hurricane_force_wind": 7,
            "waterspout": 8,
            "severe_thunderstorm": 9,
            "wreckhouse_winds": 10,
            "les_suetes_wind": 11,
            "avalanche": 12,
            "flash_flood": 13,
            "tropical_storm": 14,
            "inland_tropical_storm": 15,
            "blizzard": 16,
            "ice_storm": 17,
            "freezing_rain": 18,
            "debris_flow": 19,
            "flash_freeze": 20,
            "dust_storm": 21,
            "high_wind": 22,
            "winter_storm": 23,
            "heavy_freezing_spray": 24,
            "extreme_cold": 25,
            "wind_chill": 26,
            "cold_wave": 27,
            "heavy_snow_alert": 28,
            "lake_effect_blowing_snow": 29,
            "snow_squall": 30,
            "lake_effect_snow": 31,
            "winter_weather": 32,
            "sleet": 33,
            "snowfall": 34,
            "snow_and_blowing_snow": 35,
            "blowing_snow": 36,
            "snow_alert": 37,
            "arctic_outflow": 38,
            "freezing_drizzle": 39,
            "storm": 40,
            "storm_surge": 41,
            "rainfall": 42,
            "areal_flood": 43,
            "coastal_flood": 44,
            "lakeshore_flood": 45,
            "excessive_heat": 46,
            "heat": 47,
            "weather": 48,
            "high_heat_and_humidity": 49,
            "humidex_and_health": 50,
            "humidex": 51,
            "gale": 52,
            "freezing_spray": 53,
            "special_marine": 54,
            "squall": 55,
            "strong_wind": 56,
            "lake_wind": 57,
            "marine_weather": 58,
            "wind": 59,
            "small_craft_hazardous_seas": 60,
            "hazardous_seas": 61,
            "small_craft": 62,
            "small_craft_winds": 63,
            "small_craft_rough_bar": 64,
            "high_water_level": 65,
            "ashfall": 66,
            "freezing_fog": 67,
            "dense_fog": 68,
            "dense_smoke": 69,
            "blowing_dust": 70,
            "hard_freeze": 71,
            "freeze": 72,
            "frost": 73,
            "fire_weather": 74,
            "flood": 75,
            "rip_tide": 76,
            "high_surf": 77,
            "smog": 78,
            "air_quality": 79,
            "brisk_wind": 80,
            "air_stagnation": 81,
            "low_water": 82,
            "hydrological": 83,
            "special_weather": 84
        }
    },
    "time_into_day": {
        "base_type": "uint32",
        "values": {}
    },
    "localtime_into_day": {
        "base_type": "uint32",
        "values": {}
    },
    "stroke_type": {
        "base_type": "enum",
        "values": {
            "0": "no_event",
            "1": "other",
            "2": "serve",
            "3": "forehand",
            "4": "backhand",
            "5": "smash",
            "no_event": 0,
            "other": 1,
            "serve": 2,
            "forehand": 3,
            "backhand": 4,
            "smash": 5
        }
    },
    "body_location": {
        "base_type": "enum",
        "values": {
            "0": "left_leg",
            "1": "left_calf",
            "2": "left_shin",
            "3": "left_hamstring",
            "4": "left_quad",
            "5": "left_glute",
            "6": "right_leg",
            "7": "right_calf",
            "8": "right_shin",
            "9": "right_hamstring",
            "10": "right_quad",
            "11": "right_glute",
            "12": "torso_back",
            "13": "left_lower_back",
            "14": "left_upper_back",
            "15": "right_lower_back",
            "16": "right_upper_back",
            "17": "torso_front",
            "18": "left_abdomen",
            "19": "left_chest",
            "20": "right_abdomen",
            "21": "right_chest",
            "22": "left_arm",
            "23": "left_shoulder",
            "24": "left_bicep",
            "25": "left_tricep",
            "26": "left_brachioradialis",
            "27": "left_forearm_extensors",
            "28": "right_arm",
            "29": "right_shoulder",
            "30": "right_bicep",
            "31": "right_tricep",
            "32": "right_brachioradialis",
            "33": "right_forearm_extensors",
            "34": "neck",
            "35": "throat",
            "36": "waist_mid_back",
            "37": "waist_front",
            "38": "waist_left",
            "39": "waist_right",
            "left_leg": 0,
            "left_calf": 1,
            "left_shin": 2,
            "left_hamstring": 3,
            "left_quad": 4,
            "left_glute": 5,
            "right_leg": 6,
            "right_calf": 7,
            "right_shin": 8,
            "right_hamstring": 9,
            "right_quad": 10,
            "right_glute": 11,
            "torso_back": 12,
            "left_lower_back": 13,
            "left_upper_back": 14,
            "right_lower_back": 15,
            "right_upper_back": 16,
            "torso_front": 17,
            "left_abdomen": 18,
            "left_chest": 19,
            "right_abdomen": 20,
            "right_chest": 21,
            "left_arm": 22,
            "left_shoulder": 23,
            "left_bicep": 24,
            "left_tricep": 25,
            "left_brachioradialis": 26,
            "left_forearm_extensors": 27,
            "right_arm": 28,
            "right_shoulder": 29,
            "right_bicep": 30,
            "right_tricep": 31,
            "right_brachioradialis": 32,
            "right_forearm_extensors": 33,
            "neck": 34,
            "throat": 35,
            "waist_mid_back": 36,
            "waist_front": 37,
            "waist_left": 38,
            "waist_right": 39
        }
    },
    "segment_lap_status": {
        "base_type": "enum",
        "values": {
            "0": "end",
            "1": "fail",
            "end": 0,
            "fail": 1
        }
    },
    "segment_leaderboard_type": {
        "base_type": "enum",
        "values": {
            "0": "overall",
            "1": "personal_best",
            "2": "connections",
            "3": "group",
            "4": "challenger",
            "5": "kom",
            "6": "qom",
            "7": "pr",
            "8": "goal",
            "9": "rival",
            "10": "club_leader",
            "overall": 0,
            "personal_best": 1,
            "connections": 2,
            "group": 3,
            "challenger": 4,
            "kom": 5,
            "qom": 6,
            "pr": 7,
            "goal": 8,
            "rival": 9,
            "club_leader": 10
        }
    },
    "segment_delete_status": {
        "base_type": "enum",
        "values": {
            "0": "do_not_delete",
            "1": "delete_one",
            "2": "delete_all",
            "do_not_delete": 0,
            "delete_one": 1,
            "delete_all": 2
        }
    },
    "segment_selection_type": {
        "base_type": "enum",
        "values": {
            "0": "starred",
            "1": "suggested",
            "starred": 0,
            "suggested": 1
        }
    },
    "source_type": {
        "base_type": "enum",
        "values": {
            "0": "ant",
            "1": "antplus",
            "2": "bluetooth",
            "3": "bluetooth_low_energy",
            "4": "wifi",
            "5": "local",
            "ant": 0,
            "antplus": 1,
            "bluetooth": 2,
            "bluetooth_low_energy": 3,
            "wifi": 4,
            "local": 5
        }
    },
    "local_device_type": {
        "base_type": "uint8",
        "values": {}
    },
    "display_orientation": {
        "base_type": "enum",
        "values": {
            "0": "auto",
            "1": "portrait",
            "2": "landscape",
            "3": "portrait_flipped",
            "4": "landscape_flipped",
            "auto": 0,
            "portrait": 1,
            "landscape": 2,
            "portrait_flipped": 3,
            "landscape_flipped": 4
        }
    },
    "workout_equipment": {
        "base_type": "enum",
        "values": {
            "0": "none",
            "1": "swim_fins",
            "2": "swim_kickboard",
            "3": "swim_paddles",
            "4": "swim_pull_buoy",
            "5": "swim_snorkel",
            "none": 0,
            "swim_fins": 1,
            "swim_kickboard": 2,
            "swim_paddles": 3,
            "swim_pull_buoy": 4,
            "swim_snorkel": 5
        }
    },
    "watchface_mode": {
        "base_type": "enum",
        "values": {
            "0": "digital",
            "1": "analog",
            "2": "connect_iq",
            "3": "disabled",
            "digital": 0,
            "analog": 1,
            "connect_iq": 2,
            "disabled": 3
        }
    },
    "digital_watchface_layout": {
        "base_type": "enum",
        "values": {
            "0": "traditional",
            "1": "modern",
            "2": "bold",
            "traditional": 0,
            "modern": 1,
            "bold": 2
        }
    },
    "analog_watchface_layout": {
        "base_type": "enum",
        "values": {
            "0": "minimal",
            "1": "traditional",
            "2": "modern",
            "minimal": 0,
            "traditional": 1,
            "modern": 2
        }
    },
    "rider_position_type": {
        "base_type": "enum",
        "values": {
            "0": "seated",
            "1": "standing",
            "2": "transition_to_seated",
            "3": "transition_to_standing",
            "seated": 0,
            "standing": 1,
            "transition_to_seated": 2,
            "transition_to_standing": 3
        }
    },
    "power_phase_type": {
        "base_type": "enum",
        "values": {
            "0": "power_phase_start_angle",
            "1": "power_phase_end_angle",
            "2": "power_phase_arc_length",
            "3": "power_phase_center",
            "power_phase_start_angle": 0,
            "power_phase_end_angle": 1,
            "power_phase_arc_length": 2,
            "power_phase_center": 3
        }
    },
    "camera_event_type": {
        "base_type": "enum",
        "values": {
            "0": "video_start",
            "1": "video_split",
            "2": "video_end",
            "3": "photo_taken",
            "4": "video_second_stream_start",
            "5": "video_second_stream_split",
            "6": "video_second_stream_end",
            "7": "video_split_start",
            "8": "video_second_stream_split_start",
            "11": "video_pause",
            "12": "video_second_stream_pause",
            "13": "video_resume",
            "14": "video_second_stream_resume",
            "video_start": 0,
            "video_split": 1,
            "video_end": 2,
            "photo_taken": 3,
            "video_second_stream_start": 4,
            "video_second_stream_split": 5,
            "video_second_stream_end": 6,
            "video_split_start": 7,
            "video_second_stream_split_start": 8,
            "video_pause": 11,
            "video_second_stream_pause": 12,
            "video_resume": 13,
            "video_second_stream_resume": 14
        }
    },
    "sensor_type": {
        "base_type": "enum",
        "values": {
            "0": "accelerometer",
            "1": "gyroscope",
            "2": "compass",
            "3": "barometer",
            "accelerometer": 0,
            "gyroscope": 1,
            "compass": 2,
            "barometer": 3
        }
    },
    "bike_light_network_config_type": {
        "base_type": "enum",
        "values": {
            "0": "auto",
            "4": "individual",
            "5": "high_visibility",
            "6": "trail",
            "auto": 0,
            "individual": 4,
            "high_visibility": 5,
            "trail": 6
        }
    },
    "comm_timeout_type": {
        "base_type": "uint16",
        "values": {
            "0": "wildcard_pairing_timeout",
            "1": "pairing_timeout",
            "2": "connection_lost",
            "3": "connection_timeout",
            "wildcard_pairing_timeout": 0,
            "pairing_timeout": 1,
            "connection_lost": 2,
            "connection_timeout": 3
        }
    },
    "camera_orientation_type": {
        "base_type": "enum",
        "values": {
            "0": "camera_orientation_0",
            "1": "camera_orientation_90",
            "2": "camera_orientation_180",
            "3": "camera_orientation_270",
            "camera_orientation_0": 0,
            "camera_orientation_90": 1,
            "camera_orientation_180": 2,
            "camera_orientation_270": 3
        }
    },
    "attitude_stage": {
        "base_type": "enum",
        "values": {
            "0": "failed",
            "1": "aligning",
            "2": "degraded",
            "3": "valid",
            "failed": 0,
            "aligning": 1,
            "degraded": 2,
            "valid": 3
        }
    },
    "attitude_validity": {
        "base_type": "uint16",
        "values": {
            "1": "track_angle_heading_valid",
            "2": "pitch_valid",
            "4": "roll_valid",
            "8": "lateral_body_accel_valid",
            "16": "normal_body_accel_valid",
            "32": "turn_rate_valid",
            "64": "hw_fail",
            "128": "mag_invalid",
            "256": "no_gps",
            "512": "gps_invalid",
            "1024": "solution_coasting",
            "2048": "true_track_angle",
            "4096": "magnetic_heading",
            "track_angle_heading_valid": 1,
            "pitch_valid": 2,
            "roll_valid": 4,
            "lateral_body_accel_valid": 8,
            "normal_body_accel_valid": 16,
            "turn_rate_valid": 32,
            "hw_fail": 64,
            "mag_invalid": 128,
            "no_gps": 256,
            "gps_invalid": 512,
            "solution_coasting": 1024,
            "true_track_angle": 2048,
            "magnetic_heading": 4096
        }
    },
    "auto_sync_frequency": {
        "base_type": "enum",
        "values": {
            "0": "never",
            "1": "occasionally",
            "2": "frequent",
            "3": "once_a_day",
            "4": "remote",
            "never": 0,
            "occasionally": 1,
            "frequent": 2,
            "once_a_day": 3,
            "remote": 4
        }
    },
    "exd_layout": {
        "base_type": "enum",
        "values": {
            "0": "full_screen",
            "1": "half_vertical",
            "2": "half_horizontal",
            "3": "half_vertical_right_split",
            "4": "half_horizontal_bottom_split",
            "5": "full_quarter_split",
            "6": "half_vertical_left_split",
            "7": "half_horizontal_top_split",
            "8": "dynamic",
            "full_screen": 0,
            "half_vertical": 1,
            "half_horizontal": 2,
            "half_vertical_right_split": 3,
            "half_horizontal_bottom_split": 4,
            "full_quarter_split": 5,
            "half_vertical_left_split": 6,
            "half_horizontal_top_split": 7,
            "dynamic": 8
        }
    },
    "exd_display_type": {
        "base_type": "enum",
        "values": {
            "0": "numerical",
            "1": "simple",
            "2": "graph",
            "3": "bar",
            "4": "circle_graph",
            "5": "virtual_partner",
            "6": "balance",
            "7": "string_list",
            "8": "string",
            "9": "simple_dynamic_icon",
            "10": "gauge",
            "numerical": 0,
            "simple": 1,
            "graph": 2,
            "bar": 3,
            "circle_graph": 4,
            "virtual_partner": 5,
            "balance": 6,
            "string_list": 7,
            "string": 8,
            "simple_dynamic_icon": 9,
            "gauge": 10
        }
    },
    "exd_data_units": {
        "base_type": "enum",
        "values": {
            "0": "no_units",
            "1": "laps",
            "2": "miles_per_hour",
            "3": "kilometers_per_hour",
            "4": "feet_per_hour",
            "5": "meters_per_hour",
            "6": "degrees_celsius",
            "7": "degrees_farenheit",
            "8": "zone",
            "9": "gear",
            "10": "rpm",
            "11": "bpm",
            "12": "degrees",
            "13": "millimeters",
            "14": "meters",
            "15": "kilometers",
            "16": "feet",
            "17": "yards",
            "18": "kilofeet",
            "19": "miles",
            "20": "time",
            "21": "enum_turn_type",
            "22": "percent",
            "23": "watts",
            "24": "watts_per_kilogram",
            "25": "enum_battery_status",
            "26": "enum_bike_light_beam_angle_mode",
            "27": "enum_bike_light_battery_status",
            "28": "enum_bike_light_network_config_type",
            "29": "lights",
            "30": "seconds",
            "31": "minutes",
            "32": "hours",
            "33": "calories",
            "34": "kilojoules",
            "35": "milliseconds",
            "36": "second_per_mile",
            "37": "second_per_kilometer",
            "38": "centimeter",
            "39": "enum_course_point",
            "40": "bradians",
            "41": "enum_sport",
            "42": "inches_hg",
            "43": "mm_hg",
            "44": "mbars",
            "45": "hecto_pascals",
            "46": "feet_per_min",
            "47": "meters_per_min",
            "48": "meters_per_sec",
            "49": "eight_cardinal",
            "no_units": 0,
            "laps": 1,
            "miles_per_hour": 2,
            "kilometers_per_hour": 3,
            "feet_per_hour": 4,
            "meters_per_hour": 5,
            "degrees_celsius": 6,
            "degrees_farenheit": 7,
            "zone": 8,
            "gear": 9,
            "rpm": 10,
            "bpm": 11,
            "degrees": 12,
            "millimeters": 13,
            "meters": 14,
            "kilometers": 15,
            "feet": 16,
            "yards": 17,
            "kilofeet": 18,
            "miles": 19,
            "time": 20,
            "enum_turn_type": 21,
            "percent": 22,
            "watts": 23,
            "watts_per_kilogram": 24,
            "enum_battery_status": 25,
            "enum_bike_light_beam_angle_mode": 26,
            "enum_bike_light_battery_status": 27,
            "enum_bike_light_network_config_type": 28,
            "lights": 29,
            "seconds": 30,
            "minutes": 31,
            "hours": 32,
            "calories": 33,
            "kilojoules": 34,
            "milliseconds": 35,
            "second_per_mile": 36,
            "second_per_kilometer": 37,
            "centimeter": 38,
            "enum_course_point": 39,
            "bradians": 40,
            "enum_sport": 41,
            "inches_hg": 42,
            "mm_hg": 43,
            "mbars": 44,
            "hecto_pascals": 45,
            "feet_per_min": 46,
            "meters_per_min": 47,
            "meters_per_sec": 48,
            "eight_cardinal": 49
        }
    },
    "exd_qualifiers": {
        "base_type": "enum",
        "values": {
            "0": "no_qualifier",
            "1": "instantaneous",
            "2": "average",
            "3": "lap",
            "4": "maximum",
            "5": "maximum_average",
            "6": "maximum_lap",
            "7": "last_lap",
            "8": "average_lap",
            "9": "to_destination",
            "10": "to_go",
            "11": "to_next",
            "12": "next_course_point",
            "13": "total",
            "14": "three_second_average",
            "15": "ten_second_average",
            "16": "thirty_second_average",
            "17": "percent_maximum",
            "18": "percent_maximum_average",
            "19": "lap_percent_maximum",
            "20": "elapsed",
            "21": "sunrise",
            "22": "sunset",
            "23": "compared_to_virtual_partner",
            "24": "maximum_24h",
            "25": "minimum_24h",
            "26": "minimum",
            "27": "first",
            "28": "second",
            "29": "third",
            "30": "shifter",
            "31": "last_sport",
            "32": "moving",
            "33": "stopped",
            "34": "estimated_total",
            "242": "zone_9",
            "243": "zone_8",
            "244": "zone_7",
            "245": "zone_6",
            "246": "zone_5",
            "247": "zone_4",
            "248": "zone_3",
            "249": "zone_2",
            "250": "zone_1",
            "no_qualifier": 0,
            "instantaneous": 1,
            "average": 2,
            "lap": 3,
            "maximum": 4,
            "maximum_average": 5,
            "maximum_lap": 6,
            "last_lap": 7,
            "average_lap": 8,
            "to_destination": 9,
            "to_go": 10,
            "to_next": 11,
            "next_course_point": 12,
            "total": 13,
            "three_second_average": 14,
            "ten_second_average": 15,
            "thirty_second_average": 16,
            "percent_maximum": 17,
            "percent_maximum_average": 18,
            "lap_percent_maximum": 19,
            "elapsed": 20,
            "sunrise": 21,
            "sunset": 22,
            "compared_to_virtual_partner": 23,
            "maximum_24h": 24,
            "minimum_24h": 25,
            "minimum": 26,
            "first": 27,
            "second": 28,
            "third": 29,
            "shifter": 30,
            "last_sport": 31,
            "moving": 32,
            "stopped": 33,
            "estimated_total": 34,
            "zone_9": 242,
            "zone_8": 243,
            "zone_7": 244,
            "zone_6": 245,
            "zone_5": 246,
            "zone_4": 247,
            "zone_3": 248,
            "zone_2": 249,
            "zone_1": 250
        }
    },
    "exd_descriptors": {
        "base_type": "enum",
        "values": {
            "0": "bike_light_battery_status",
            "1": "beam_angle_status",
            "2": "batery_level",
            "3": "light_network_mode",
            "4": "number_lights_connected",
            "5": "cadence",
            "6": "distance",
            "7": "estimated_time_of_arrival",
            "8": "heading",
            "9": "time",
            "10": "battery_level",
            "11": "trainer_resistance",
            "12": "trainer_target_power",
            "13": "time_seated",
            "14": "time_standing",
            "15": "elevation",
            "16": "grade",
            "17": "ascent",
            "18": "descent",
            "19": "vertical_speed",
            "20": "di2_battery_level",
            "21": "front_gear",
            "22": "rear_gear",
            "23": "gear_ratio",
            "24": "heart_rate",
            "25": "heart_rate_zone",
            "26": "time_in_heart_rate_zone",
            "27": "heart_rate_reserve",
            "28": "calories",
            "29": "gps_accuracy",
            "30": "gps_signal_strength",
            "31": "temperature",
            "32": "time_of_day",
            "33": "balance",
            "34": "pedal_smoothness",
            "35": "power",
            "36": "functional_threshold_power",
            "37": "intensity_factor",
            "38": "work",
            "39": "power_ratio",
            "40": "normalized_power",
            "41": "training_stress_Score",
            "42": "time_on_zone",
            "43": "speed",
            "44": "laps",
            "45": "reps",
            "46": "workout_step",
            "47": "course_distance",
            "48": "navigation_distance",
            "49": "course_estimated_time_of_arrival",
            "50": "navigation_estimated_time_of_arrival",
            "51": "course_time",
            "52": "navigation_time",
            "53": "course_heading",
            "54": "navigation_heading",
            "55": "power_zone",
            "56": "torque_effectiveness",
            "57": "timer_time",
            "58": "power_weight_ratio",
            "59": "left_platform_center_offset",
            "60": "right_platform_center_offset",
            "61": "left_power_phase_start_angle",
            "62": "right_power_phase_start_angle",
            "63": "left_power_phase_finish_angle",
            "64": "right_power_phase_finish_angle",
            "65": "gears",
            "66": "pace",
            "67": "training_effect",
            "68": "vertical_oscillation",
            "69": "vertical_ratio",
            "70": "ground_contact_time",
            "71": "left_ground_contact_time_balance",
            "72": "right_ground_contact_time_balance",
            "73": "stride_length",
            "74": "running_cadence",
            "75": "performance_condition",
            "76": "course_type",
            "77": "time_in_power_zone",
            "78": "navigation_turn",
            "79": "course_location",
            "80": "navigation_location",
            "81": "compass",
            "82": "gear_combo",
            "83": "muscle_oxygen",
            "84": "icon",
            "85": "compass_heading",
            "86": "gps_heading",
            "87": "gps_elevation",
            "88": "anaerobic_training_effect",
            "89": "course",
            "90": "off_course",
            "91": "glide_ratio",
            "92": "vertical_distance",
            "93": "vmg",
            "94": "ambient_pressure",
            "95": "pressure",
            "96": "vam",
            "bike_light_battery_status": 0,
            "beam_angle_status": 1,
            "batery_level": 2,
            "light_network_mode": 3,
            "number_lights_connected": 4,
            "cadence": 5,
            "distance": 6,
            "estimated_time_of_arrival": 7,
            "heading": 8,
            "time": 9,
            "battery_level": 10,
            "trainer_resistance": 11,
            "trainer_target_power": 12,
            "time_seated": 13,
            "time_standing": 14,
            "elevation": 15,
            "grade": 16,
            "ascent": 17,
            "descent": 18,
            "vertical_speed": 19,
            "di2_battery_level": 20,
            "front_gear": 21,
            "rear_gear": 22,
            "gear_ratio": 23,
            "heart_rate": 24,
            "heart_rate_zone": 25,
            "time_in_heart_rate_zone": 26,
            "heart_rate_reserve": 27,
            "calories": 28,
            "gps_accuracy": 29,
            "gps_signal_strength": 30,
            "temperature": 31,
            "time_of_day": 32,
            "balance": 33,
            "pedal_smoothness": 34,
            "power": 35,
            "functional_threshold_power": 36,
            "intensity_factor": 37,
            "work": 38,
            "power_ratio": 39,
            "normalized_power": 40,
            "training_stress_Score": 41,
            "time_on_zone": 42,
            "speed": 43,
            "laps": 44,
            "reps": 45,
            "workout_step": 46,
            "course_distance": 47,
            "navigation_distance": 48,
            "course_estimated_time_of_arrival": 49,
            "navigation_estimated_time_of_arrival": 50,
            "course_time": 51,
            "navigation_time": 52,
            "course_heading": 53,
            "navigation_heading": 54,
            "power_zone": 55,
            "torque_effectiveness": 56,
            "timer_time": 57,
            "power_weight_ratio": 58,
            "left_platform_center_offset": 59,
            "right_platform_center_offset": 60,
            "left_power_phase_start_angle": 61,
            "right_power_phase_start_angle": 62,
            "left_power_phase_finish_angle": 63,
            "right_power_phase_finish_angle": 64,
            "gears": 65,
            "pace": 66,
            "training_effect": 67,
            "vertical_oscillation": 68,
            "vertical_ratio": 69,
            "ground_contact_time": 70,
            "left_ground_contact_time_balance": 71,
            "right_ground_contact_time_balance": 72,
            "stride_length": 73,
            "running_cadence": 74,
            "performance_condition": 75,
            "course_type": 76,
            "time_in_power_zone": 77,
            "navigation_turn": 78,
            "course_location": 79,
            "navigation_location": 80,
            "compass": 81,
            "gear_combo": 82,
            "muscle_oxygen": 83,
            "icon": 84,
            "compass_heading": 85,
            "gps_heading": 86,
            "gps_elevation": 87,
            "anaerobic_training_effect": 88,
            "course": 89,
            "off_course": 90,
            "glide_ratio": 91,
            "vertical_distance": 92,
            "vmg": 93,
            "ambient_pressure": 94,
            "pressure": 95,
            "vam": 96
        }
    },
    "auto_activity_detect": {
        "base_type": "uint32",
        "values": {
            "0": "none",
            "1": "running",
            "2": "cycling",
            "4": "swimming",
            "8": "walking",
            "32": "elliptical",
            "1024": "sedentary",
            "none": 0,
            "running": 1,
            "cycling": 2,
            "swimming": 4,
            "walking": 8,
            "elliptical": 32,
            "sedentary": 1024
        }
    },
    "supported_exd_screen_layouts": {
        "base_type": "uint32z",
        "values": {
            "1": "full_screen",
            "2": "half_vertical",
            "4": "half_horizontal",
            "8": "half_vertical_right_split",
            "16": "half_horizontal_bottom_split",
            "32": "full_quarter_split",
            "64": "half_vertical_left_split",
            "128": "half_horizontal_top_split",
            "full_screen": 1,
            "half_vertical": 2,
            "half_horizontal": 4,
            "half_vertical_right_split": 8,
            "half_horizontal_bottom_split": 16,
            "full_quarter_split": 32,
            "half_vertical_left_split": 64,
            "half_horizontal_top_split": 128
        }
    },
    "fit_base_type": {
        "base_type": "uint8",
        "values": {
            "0": "enum",
            "1": "sint8",
            "2": "uint8",
            "7": "string",
            "10": "uint8z",
            "13": "byte",
            "131": "sint16",
            "132": "uint16",
            "133": "sint32",
            "134": "uint32",
            "136": "float32",
            "137": "float64",
            "139": "uint16z",
            "140": "uint32z",
            "142": "sint64",
            "143": "uint64",
            "144": "uint64z",
            "enum": 0,
            "sint8": 1,
            "uint8": 2,
            "sint16": 131,
            "uint16": 132,
            "sint32": 133,
            "uint32": 134,
            "string": 7,
            "float32": 136,
            "float64": 137,
            "uint8z": 10,
            "uint16z": 139,
            "uint32z": 140,
            "byte": 13,
            "sint64": 142,
            "uint64": 143,
            "uint64z": 144
        }
    },
    "turn_type": {
        "base_type": "enum",
        "values": {
            "0": "arriving_idx",
            "1": "arriving_left_idx",
            "2": "arriving_right_idx",
            "3": "arriving_via_idx",
            "4": "arriving_via_left_idx",
            "5": "arriving_via_right_idx",
            "6": "bear_keep_left_idx",
            "7": "bear_keep_right_idx",
            "8": "continue_idx",
            "9": "exit_left_idx",
            "10": "exit_right_idx",
            "11": "ferry_idx",
            "12": "roundabout_45_idx",
            "13": "roundabout_90_idx",
            "14": "roundabout_135_idx",
            "15": "roundabout_180_idx",
            "16": "roundabout_225_idx",
            "17": "roundabout_270_idx",
            "18": "roundabout_315_idx",
            "19": "roundabout_360_idx",
            "20": "roundabout_neg_45_idx",
            "21": "roundabout_neg_90_idx",
            "22": "roundabout_neg_135_idx",
            "23": "roundabout_neg_180_idx",
            "24": "roundabout_neg_225_idx",
            "25": "roundabout_neg_270_idx",
            "26": "roundabout_neg_315_idx",
            "27": "roundabout_neg_360_idx",
            "28": "roundabout_generic_idx",
            "29": "roundabout_neg_generic_idx",
            "30": "sharp_turn_left_idx",
            "31": "sharp_turn_right_idx",
            "32": "turn_left_idx",
            "33": "turn_right_idx",
            "34": "uturn_left_idx",
            "35": "uturn_right_idx",
            "36": "icon_inv_idx",
            "37": "icon_idx_cnt",
            "arriving_idx": 0,
            "arriving_left_idx": 1,
            "arriving_right_idx": 2,
            "arriving_via_idx": 3,
            "arriving_via_left_idx": 4,
            "arriving_via_right_idx": 5,
            "bear_keep_left_idx": 6,
            "bear_keep_right_idx": 7,
            "continue_idx": 8,
            "exit_left_idx": 9,
            "exit_right_idx": 10,
            "ferry_idx": 11,
            "roundabout_45_idx": 12,
            "roundabout_90_idx": 13,
            "roundabout_135_idx": 14,
            "roundabout_180_idx": 15,
            "roundabout_225_idx": 16,
            "roundabout_270_idx": 17,
            "roundabout_315_idx": 18,
            "roundabout_360_idx": 19,
            "roundabout_neg_45_idx": 20,
            "roundabout_neg_90_idx": 21,
            "roundabout_neg_135_idx": 22,
            "roundabout_neg_180_idx": 23,
            "roundabout_neg_225_idx": 24,
            "roundabout_neg_270_idx": 25,
            "roundabout_neg_315_idx": 26,
            "roundabout_neg_360_idx": 27,
            "roundabout_generic_idx": 28,
            "roundabout_neg_generic_idx": 29,
            "sharp_turn_left_idx": 30,
            "sharp_turn_right_idx": 31,
            "turn_left_idx": 32,
            "turn_right_idx": 33,
            "uturn_left_idx": 34,
            "uturn_right_idx": 35,
            "icon_inv_idx": 36,
            "icon_idx_cnt": 37
        }
    },
    "bike_light_beam_angle_mode": {
        "base_type": "uint8",
        "values": {
            "0": "manual",
            "1": "auto",
            "manual": 0,
            "auto": 1
        }
    },
    "fit_base_unit": {
        "base_type": "uint16",
        "values": {
            "0": "other",
            "1": "kilogram",
            "2": "pound",
            "other": 0,
            "kilogram": 1,
            "pound": 2
        }
    },
    "set_type": {
        "base_type": "uint8",
        "values": {
            "0": "rest",
            "1": "active",
            "rest": 0,
            "active": 1
        }
    },
    "exercise_category": {
        "base_type": "uint16",
        "values": {
            "0": "bench_press",
            "1": "calf_raise",
            "2": "cardio",
            "3": "carry",
            "4": "chop",
            "5": "core",
            "6": "crunch",
            "7": "curl",
            "8": "deadlift",
            "9": "flye",
            "10": "hip_raise",
            "11": "hip_stability",
            "12": "hip_swing",
            "13": "hyperextension",
            "14": "lateral_raise",
            "15": "leg_curl",
            "16": "leg_raise",
            "17": "lunge",
            "18": "olympic_lift",
            "19": "plank",
            "20": "plyo",
            "21": "pull_up",
            "22": "push_up",
            "23": "row",
            "24": "shoulder_press",
            "25": "shoulder_stability",
            "26": "shrug",
            "27": "sit_up",
            "28": "squat",
            "29": "total_body",
            "30": "triceps_extension",
            "31": "warm_up",
            "32": "run",
            "65534": "unknown",
            "bench_press": 0,
            "calf_raise": 1,
            "cardio": 2,
            "carry": 3,
            "chop": 4,
            "core": 5,
            "crunch": 6,
            "curl": 7,
            "deadlift": 8,
            "flye": 9,
            "hip_raise": 10,
            "hip_stability": 11,
            "hip_swing": 12,
            "hyperextension": 13,
            "lateral_raise": 14,
            "leg_curl": 15,
            "leg_raise": 16,
            "lunge": 17,
            "olympic_lift": 18,
            "plank": 19,
            "plyo": 20,
            "pull_up": 21,
            "push_up": 22,
            "row": 23,
            "shoulder_press": 24,
            "shoulder_stability": 25,
            "shrug": 26,
            "sit_up": 27,
            "squat": 28,
            "total_body": 29,
            "triceps_extension": 30,
            "warm_up": 31,
            "run": 32,
            "unknown": 65534
        }
    },
    "bench_press_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "alternating_dumbbell_chest_press_on_swiss_ball",
            "1": "barbell_bench_press",
            "2": "barbell_board_bench_press",
            "3": "barbell_floor_press",
            "4": "close_grip_barbell_bench_press",
            "5": "decline_dumbbell_bench_press",
            "6": "dumbbell_bench_press",
            "7": "dumbbell_floor_press",
            "8": "incline_barbell_bench_press",
            "9": "incline_dumbbell_bench_press",
            "10": "incline_smith_machine_bench_press",
            "11": "isometric_barbell_bench_press",
            "12": "kettlebell_chest_press",
            "13": "neutral_grip_dumbbell_bench_press",
            "14": "neutral_grip_dumbbell_incline_bench_press",
            "15": "one_arm_floor_press",
            "16": "weighted_one_arm_floor_press",
            "17": "partial_lockout",
            "18": "reverse_grip_barbell_bench_press",
            "19": "reverse_grip_incline_bench_press",
            "20": "single_arm_cable_chest_press",
            "21": "single_arm_dumbbell_bench_press",
            "22": "smith_machine_bench_press",
            "23": "swiss_ball_dumbbell_chest_press",
            "24": "triple_stop_barbell_bench_press",
            "25": "wide_grip_barbell_bench_press",
            "26": "alternating_dumbbell_chest_press",
            "alternating_dumbbell_chest_press_on_swiss_ball": 0,
            "barbell_bench_press": 1,
            "barbell_board_bench_press": 2,
            "barbell_floor_press": 3,
            "close_grip_barbell_bench_press": 4,
            "decline_dumbbell_bench_press": 5,
            "dumbbell_bench_press": 6,
            "dumbbell_floor_press": 7,
            "incline_barbell_bench_press": 8,
            "incline_dumbbell_bench_press": 9,
            "incline_smith_machine_bench_press": 10,
            "isometric_barbell_bench_press": 11,
            "kettlebell_chest_press": 12,
            "neutral_grip_dumbbell_bench_press": 13,
            "neutral_grip_dumbbell_incline_bench_press": 14,
            "one_arm_floor_press": 15,
            "weighted_one_arm_floor_press": 16,
            "partial_lockout": 17,
            "reverse_grip_barbell_bench_press": 18,
            "reverse_grip_incline_bench_press": 19,
            "single_arm_cable_chest_press": 20,
            "single_arm_dumbbell_bench_press": 21,
            "smith_machine_bench_press": 22,
            "swiss_ball_dumbbell_chest_press": 23,
            "triple_stop_barbell_bench_press": 24,
            "wide_grip_barbell_bench_press": 25,
            "alternating_dumbbell_chest_press": 26
        }
    },
    "calf_raise_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "3_way_calf_raise",
            "1": "3_way_weighted_calf_raise",
            "2": "3_way_single_leg_calf_raise",
            "3": "3_way_weighted_single_leg_calf_raise",
            "4": "donkey_calf_raise",
            "5": "weighted_donkey_calf_raise",
            "6": "seated_calf_raise",
            "7": "weighted_seated_calf_raise",
            "8": "seated_dumbbell_toe_raise",
            "9": "single_leg_bent_knee_calf_raise",
            "10": "weighted_single_leg_bent_knee_calf_raise",
            "11": "single_leg_decline_push_up",
            "12": "single_leg_donkey_calf_raise",
            "13": "weighted_single_leg_donkey_calf_raise",
            "14": "single_leg_hip_raise_with_knee_hold",
            "15": "single_leg_standing_calf_raise",
            "16": "single_leg_standing_dumbbell_calf_raise",
            "17": "standing_barbell_calf_raise",
            "18": "standing_calf_raise",
            "19": "weighted_standing_calf_raise",
            "20": "standing_dumbbell_calf_raise",
            "3_way_calf_raise": 0,
            "3_way_weighted_calf_raise": 1,
            "3_way_single_leg_calf_raise": 2,
            "3_way_weighted_single_leg_calf_raise": 3,
            "donkey_calf_raise": 4,
            "weighted_donkey_calf_raise": 5,
            "seated_calf_raise": 6,
            "weighted_seated_calf_raise": 7,
            "seated_dumbbell_toe_raise": 8,
            "single_leg_bent_knee_calf_raise": 9,
            "weighted_single_leg_bent_knee_calf_raise": 10,
            "single_leg_decline_push_up": 11,
            "single_leg_donkey_calf_raise": 12,
            "weighted_single_leg_donkey_calf_raise": 13,
            "single_leg_hip_raise_with_knee_hold": 14,
            "single_leg_standing_calf_raise": 15,
            "single_leg_standing_dumbbell_calf_raise": 16,
            "standing_barbell_calf_raise": 17,
            "standing_calf_raise": 18,
            "weighted_standing_calf_raise": 19,
            "standing_dumbbell_calf_raise": 20
        }
    },
    "cardio_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "bob_and_weave_circle",
            "1": "weighted_bob_and_weave_circle",
            "2": "cardio_core_crawl",
            "3": "weighted_cardio_core_crawl",
            "4": "double_under",
            "5": "weighted_double_under",
            "6": "jump_rope",
            "7": "weighted_jump_rope",
            "8": "jump_rope_crossover",
            "9": "weighted_jump_rope_crossover",
            "10": "jump_rope_jog",
            "11": "weighted_jump_rope_jog",
            "12": "jumping_jacks",
            "13": "weighted_jumping_jacks",
            "14": "ski_moguls",
            "15": "weighted_ski_moguls",
            "16": "split_jacks",
            "17": "weighted_split_jacks",
            "18": "squat_jacks",
            "19": "weighted_squat_jacks",
            "20": "triple_under",
            "21": "weighted_triple_under",
            "bob_and_weave_circle": 0,
            "weighted_bob_and_weave_circle": 1,
            "cardio_core_crawl": 2,
            "weighted_cardio_core_crawl": 3,
            "double_under": 4,
            "weighted_double_under": 5,
            "jump_rope": 6,
            "weighted_jump_rope": 7,
            "jump_rope_crossover": 8,
            "weighted_jump_rope_crossover": 9,
            "jump_rope_jog": 10,
            "weighted_jump_rope_jog": 11,
            "jumping_jacks": 12,
            "weighted_jumping_jacks": 13,
            "ski_moguls": 14,
            "weighted_ski_moguls": 15,
            "split_jacks": 16,
            "weighted_split_jacks": 17,
            "squat_jacks": 18,
            "weighted_squat_jacks": 19,
            "triple_under": 20,
            "weighted_triple_under": 21
        }
    },
    "carry_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "bar_holds",
            "1": "farmers_walk",
            "2": "farmers_walk_on_toes",
            "3": "hex_dumbbell_hold",
            "4": "overhead_carry",
            "bar_holds": 0,
            "farmers_walk": 1,
            "farmers_walk_on_toes": 2,
            "hex_dumbbell_hold": 3,
            "overhead_carry": 4
        }
    },
    "chop_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "cable_pull_through",
            "1": "cable_rotational_lift",
            "2": "cable_woodchop",
            "3": "cross_chop_to_knee",
            "4": "weighted_cross_chop_to_knee",
            "5": "dumbbell_chop",
            "6": "half_kneeling_rotation",
            "7": "weighted_half_kneeling_rotation",
            "8": "half_kneeling_rotational_chop",
            "9": "half_kneeling_rotational_reverse_chop",
            "10": "half_kneeling_stability_chop",
            "11": "half_kneeling_stability_reverse_chop",
            "12": "kneeling_rotational_chop",
            "13": "kneeling_rotational_reverse_chop",
            "14": "kneeling_stability_chop",
            "15": "kneeling_woodchopper",
            "16": "medicine_ball_wood_chops",
            "17": "power_squat_chops",
            "18": "weighted_power_squat_chops",
            "19": "standing_rotational_chop",
            "20": "standing_split_rotational_chop",
            "21": "standing_split_rotational_reverse_chop",
            "22": "standing_stability_reverse_chop",
            "cable_pull_through": 0,
            "cable_rotational_lift": 1,
            "cable_woodchop": 2,
            "cross_chop_to_knee": 3,
            "weighted_cross_chop_to_knee": 4,
            "dumbbell_chop": 5,
            "half_kneeling_rotation": 6,
            "weighted_half_kneeling_rotation": 7,
            "half_kneeling_rotational_chop": 8,
            "half_kneeling_rotational_reverse_chop": 9,
            "half_kneeling_stability_chop": 10,
            "half_kneeling_stability_reverse_chop": 11,
            "kneeling_rotational_chop": 12,
            "kneeling_rotational_reverse_chop": 13,
            "kneeling_stability_chop": 14,
            "kneeling_woodchopper": 15,
            "medicine_ball_wood_chops": 16,
            "power_squat_chops": 17,
            "weighted_power_squat_chops": 18,
            "standing_rotational_chop": 19,
            "standing_split_rotational_chop": 20,
            "standing_split_rotational_reverse_chop": 21,
            "standing_stability_reverse_chop": 22
        }
    },
    "core_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "abs_jabs",
            "1": "weighted_abs_jabs",
            "2": "alternating_plate_reach",
            "3": "barbell_rollout",
            "4": "weighted_barbell_rollout",
            "5": "body_bar_oblique_twist",
            "6": "cable_core_press",
            "7": "cable_side_bend",
            "8": "side_bend",
            "9": "weighted_side_bend",
            "10": "crescent_circle",
            "11": "weighted_crescent_circle",
            "12": "cycling_russian_twist",
            "13": "weighted_cycling_russian_twist",
            "14": "elevated_feet_russian_twist",
            "15": "weighted_elevated_feet_russian_twist",
            "16": "half_turkish_get_up",
            "17": "kettlebell_windmill",
            "18": "kneeling_ab_wheel",
            "19": "weighted_kneeling_ab_wheel",
            "20": "modified_front_lever",
            "21": "open_knee_tucks",
            "22": "weighted_open_knee_tucks",
            "23": "side_abs_leg_lift",
            "24": "weighted_side_abs_leg_lift",
            "25": "swiss_ball_jackknife",
            "26": "weighted_swiss_ball_jackknife",
            "27": "swiss_ball_pike",
            "28": "weighted_swiss_ball_pike",
            "29": "swiss_ball_rollout",
            "30": "weighted_swiss_ball_rollout",
            "31": "triangle_hip_press",
            "32": "weighted_triangle_hip_press",
            "33": "trx_suspended_jackknife",
            "34": "weighted_trx_suspended_jackknife",
            "35": "u_boat",
            "36": "weighted_u_boat",
            "37": "windmill_switches",
            "38": "weighted_windmill_switches",
            "39": "alternating_slide_out",
            "40": "weighted_alternating_slide_out",
            "41": "ghd_back_extensions",
            "42": "weighted_ghd_back_extensions",
            "43": "overhead_walk",
            "44": "inchworm",
            "45": "weighted_modified_front_lever",
            "46": "russian_twist",
            "47": "abdominal_leg_rotations",
            "48": "arm_and_leg_extension_on_knees",
            "49": "bicycle",
            "50": "bicep_curl_with_leg_extension",
            "51": "cat_cow",
            "52": "corkscrew",
            "53": "criss_cross",
            "54": "criss_cross_with_ball",
            "55": "double_leg_stretch",
            "56": "knee_folds",
            "57": "lower_lift",
            "58": "neck_pull",
            "59": "pelvic_clocks",
            "60": "roll_over",
            "61": "roll_up",
            "62": "rolling",
            "63": "rowing_1",
            "64": "rowing_2",
            "65": "scissors",
            "66": "single_leg_circles",
            "67": "single_leg_stretch",
            "68": "snake_twist_1_and_2",
            "69": "swan",
            "70": "swimming",
            "71": "teaser",
            "72": "the_hundred",
            "abs_jabs": 0,
            "weighted_abs_jabs": 1,
            "alternating_plate_reach": 2,
            "barbell_rollout": 3,
            "weighted_barbell_rollout": 4,
            "body_bar_oblique_twist": 5,
            "cable_core_press": 6,
            "cable_side_bend": 7,
            "side_bend": 8,
            "weighted_side_bend": 9,
            "crescent_circle": 10,
            "weighted_crescent_circle": 11,
            "cycling_russian_twist": 12,
            "weighted_cycling_russian_twist": 13,
            "elevated_feet_russian_twist": 14,
            "weighted_elevated_feet_russian_twist": 15,
            "half_turkish_get_up": 16,
            "kettlebell_windmill": 17,
            "kneeling_ab_wheel": 18,
            "weighted_kneeling_ab_wheel": 19,
            "modified_front_lever": 20,
            "open_knee_tucks": 21,
            "weighted_open_knee_tucks": 22,
            "side_abs_leg_lift": 23,
            "weighted_side_abs_leg_lift": 24,
            "swiss_ball_jackknife": 25,
            "weighted_swiss_ball_jackknife": 26,
            "swiss_ball_pike": 27,
            "weighted_swiss_ball_pike": 28,
            "swiss_ball_rollout": 29,
            "weighted_swiss_ball_rollout": 30,
            "triangle_hip_press": 31,
            "weighted_triangle_hip_press": 32,
            "trx_suspended_jackknife": 33,
            "weighted_trx_suspended_jackknife": 34,
            "u_boat": 35,
            "weighted_u_boat": 36,
            "windmill_switches": 37,
            "weighted_windmill_switches": 38,
            "alternating_slide_out": 39,
            "weighted_alternating_slide_out": 40,
            "ghd_back_extensions": 41,
            "weighted_ghd_back_extensions": 42,
            "overhead_walk": 43,
            "inchworm": 44,
            "weighted_modified_front_lever": 45,
            "russian_twist": 46,
            "abdominal_leg_rotations": 47,
            "arm_and_leg_extension_on_knees": 48,
            "bicycle": 49,
            "bicep_curl_with_leg_extension": 50,
            "cat_cow": 51,
            "corkscrew": 52,
            "criss_cross": 53,
            "criss_cross_with_ball": 54,
            "double_leg_stretch": 55,
            "knee_folds": 56,
            "lower_lift": 57,
            "neck_pull": 58,
            "pelvic_clocks": 59,
            "roll_over": 60,
            "roll_up": 61,
            "rolling": 62,
            "rowing_1": 63,
            "rowing_2": 64,
            "scissors": 65,
            "single_leg_circles": 66,
            "single_leg_stretch": 67,
            "snake_twist_1_and_2": 68,
            "swan": 69,
            "swimming": 70,
            "teaser": 71,
            "the_hundred": 72
        }
    },
    "crunch_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "bicycle_crunch",
            "1": "cable_crunch",
            "2": "circular_arm_crunch",
            "3": "crossed_arms_crunch",
            "4": "weighted_crossed_arms_crunch",
            "5": "cross_leg_reverse_crunch",
            "6": "weighted_cross_leg_reverse_crunch",
            "7": "crunch_chop",
            "8": "weighted_crunch_chop",
            "9": "double_crunch",
            "10": "weighted_double_crunch",
            "11": "elbow_to_knee_crunch",
            "12": "weighted_elbow_to_knee_crunch",
            "13": "flutter_kicks",
            "14": "weighted_flutter_kicks",
            "15": "foam_roller_reverse_crunch_on_bench",
            "16": "weighted_foam_roller_reverse_crunch_on_bench",
            "17": "foam_roller_reverse_crunch_with_dumbbell",
            "18": "foam_roller_reverse_crunch_with_medicine_ball",
            "19": "frog_press",
            "20": "hanging_knee_raise_oblique_crunch",
            "21": "weighted_hanging_knee_raise_oblique_crunch",
            "22": "hip_crossover",
            "23": "weighted_hip_crossover",
            "24": "hollow_rock",
            "25": "weighted_hollow_rock",
            "26": "incline_reverse_crunch",
            "27": "weighted_incline_reverse_crunch",
            "28": "kneeling_cable_crunch",
            "29": "kneeling_cross_crunch",
            "30": "weighted_kneeling_cross_crunch",
            "31": "kneeling_oblique_cable_crunch",
            "32": "knees_to_elbow",
            "33": "leg_extensions",
            "34": "weighted_leg_extensions",
            "35": "leg_levers",
            "36": "mcgill_curl_up",
            "37": "weighted_mcgill_curl_up",
            "38": "modified_pilates_roll_up_with_ball",
            "39": "weighted_modified_pilates_roll_up_with_ball",
            "40": "pilates_crunch",
            "41": "weighted_pilates_crunch",
            "42": "pilates_roll_up_with_ball",
            "43": "weighted_pilates_roll_up_with_ball",
            "44": "raised_legs_crunch",
            "45": "weighted_raised_legs_crunch",
            "46": "reverse_crunch",
            "47": "weighted_reverse_crunch",
            "48": "reverse_crunch_on_a_bench",
            "49": "weighted_reverse_crunch_on_a_bench",
            "50": "reverse_curl_and_lift",
            "51": "weighted_reverse_curl_and_lift",
            "52": "rotational_lift",
            "53": "weighted_rotational_lift",
            "54": "seated_alternating_reverse_crunch",
            "55": "weighted_seated_alternating_reverse_crunch",
            "56": "seated_leg_u",
            "57": "weighted_seated_leg_u",
            "58": "side_to_side_crunch_and_weave",
            "59": "weighted_side_to_side_crunch_and_weave",
            "60": "single_leg_reverse_crunch",
            "61": "weighted_single_leg_reverse_crunch",
            "62": "skater_crunch_cross",
            "63": "weighted_skater_crunch_cross",
            "64": "standing_cable_crunch",
            "65": "standing_side_crunch",
            "66": "step_climb",
            "67": "weighted_step_climb",
            "68": "swiss_ball_crunch",
            "69": "swiss_ball_reverse_crunch",
            "70": "weighted_swiss_ball_reverse_crunch",
            "71": "swiss_ball_russian_twist",
            "72": "weighted_swiss_ball_russian_twist",
            "73": "swiss_ball_side_crunch",
            "74": "weighted_swiss_ball_side_crunch",
            "75": "thoracic_crunches_on_foam_roller",
            "76": "weighted_thoracic_crunches_on_foam_roller",
            "77": "triceps_crunch",
            "78": "weighted_bicycle_crunch",
            "79": "weighted_crunch",
            "80": "weighted_swiss_ball_crunch",
            "81": "toes_to_bar",
            "82": "weighted_toes_to_bar",
            "83": "crunch",
            "84": "straight_leg_crunch_with_ball",
            "bicycle_crunch": 0,
            "cable_crunch": 1,
            "circular_arm_crunch": 2,
            "crossed_arms_crunch": 3,
            "weighted_crossed_arms_crunch": 4,
            "cross_leg_reverse_crunch": 5,
            "weighted_cross_leg_reverse_crunch": 6,
            "crunch_chop": 7,
            "weighted_crunch_chop": 8,
            "double_crunch": 9,
            "weighted_double_crunch": 10,
            "elbow_to_knee_crunch": 11,
            "weighted_elbow_to_knee_crunch": 12,
            "flutter_kicks": 13,
            "weighted_flutter_kicks": 14,
            "foam_roller_reverse_crunch_on_bench": 15,
            "weighted_foam_roller_reverse_crunch_on_bench": 16,
            "foam_roller_reverse_crunch_with_dumbbell": 17,
            "foam_roller_reverse_crunch_with_medicine_ball": 18,
            "frog_press": 19,
            "hanging_knee_raise_oblique_crunch": 20,
            "weighted_hanging_knee_raise_oblique_crunch": 21,
            "hip_crossover": 22,
            "weighted_hip_crossover": 23,
            "hollow_rock": 24,
            "weighted_hollow_rock": 25,
            "incline_reverse_crunch": 26,
            "weighted_incline_reverse_crunch": 27,
            "kneeling_cable_crunch": 28,
            "kneeling_cross_crunch": 29,
            "weighted_kneeling_cross_crunch": 30,
            "kneeling_oblique_cable_crunch": 31,
            "knees_to_elbow": 32,
            "leg_extensions": 33,
            "weighted_leg_extensions": 34,
            "leg_levers": 35,
            "mcgill_curl_up": 36,
            "weighted_mcgill_curl_up": 37,
            "modified_pilates_roll_up_with_ball": 38,
            "weighted_modified_pilates_roll_up_with_ball": 39,
            "pilates_crunch": 40,
            "weighted_pilates_crunch": 41,
            "pilates_roll_up_with_ball": 42,
            "weighted_pilates_roll_up_with_ball": 43,
            "raised_legs_crunch": 44,
            "weighted_raised_legs_crunch": 45,
            "reverse_crunch": 46,
            "weighted_reverse_crunch": 47,
            "reverse_crunch_on_a_bench": 48,
            "weighted_reverse_crunch_on_a_bench": 49,
            "reverse_curl_and_lift": 50,
            "weighted_reverse_curl_and_lift": 51,
            "rotational_lift": 52,
            "weighted_rotational_lift": 53,
            "seated_alternating_reverse_crunch": 54,
            "weighted_seated_alternating_reverse_crunch": 55,
            "seated_leg_u": 56,
            "weighted_seated_leg_u": 57,
            "side_to_side_crunch_and_weave": 58,
            "weighted_side_to_side_crunch_and_weave": 59,
            "single_leg_reverse_crunch": 60,
            "weighted_single_leg_reverse_crunch": 61,
            "skater_crunch_cross": 62,
            "weighted_skater_crunch_cross": 63,
            "standing_cable_crunch": 64,
            "standing_side_crunch": 65,
            "step_climb": 66,
            "weighted_step_climb": 67,
            "swiss_ball_crunch": 68,
            "swiss_ball_reverse_crunch": 69,
            "weighted_swiss_ball_reverse_crunch": 70,
            "swiss_ball_russian_twist": 71,
            "weighted_swiss_ball_russian_twist": 72,
            "swiss_ball_side_crunch": 73,
            "weighted_swiss_ball_side_crunch": 74,
            "thoracic_crunches_on_foam_roller": 75,
            "weighted_thoracic_crunches_on_foam_roller": 76,
            "triceps_crunch": 77,
            "weighted_bicycle_crunch": 78,
            "weighted_crunch": 79,
            "weighted_swiss_ball_crunch": 80,
            "toes_to_bar": 81,
            "weighted_toes_to_bar": 82,
            "crunch": 83,
            "straight_leg_crunch_with_ball": 84
        }
    },
    "curl_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "alternating_dumbbell_biceps_curl",
            "1": "alternating_dumbbell_biceps_curl_on_swiss_ball",
            "2": "alternating_incline_dumbbell_biceps_curl",
            "3": "barbell_biceps_curl",
            "4": "barbell_reverse_wrist_curl",
            "5": "barbell_wrist_curl",
            "6": "behind_the_back_barbell_reverse_wrist_curl",
            "7": "behind_the_back_one_arm_cable_curl",
            "8": "cable_biceps_curl",
            "9": "cable_hammer_curl",
            "10": "cheating_barbell_biceps_curl",
            "11": "close_grip_ez_bar_biceps_curl",
            "12": "cross_body_dumbbell_hammer_curl",
            "13": "dead_hang_biceps_curl",
            "14": "decline_hammer_curl",
            "15": "dumbbell_biceps_curl_with_static_hold",
            "16": "dumbbell_hammer_curl",
            "17": "dumbbell_reverse_wrist_curl",
            "18": "dumbbell_wrist_curl",
            "19": "ez_bar_preacher_curl",
            "20": "forward_bend_biceps_curl",
            "21": "hammer_curl_to_press",
            "22": "incline_dumbbell_biceps_curl",
            "23": "incline_offset_thumb_dumbbell_curl",
            "24": "kettlebell_biceps_curl",
            "25": "lying_concentration_cable_curl",
            "26": "one_arm_preacher_curl",
            "27": "plate_pinch_curl",
            "28": "preacher_curl_with_cable",
            "29": "reverse_ez_bar_curl",
            "30": "reverse_grip_wrist_curl",
            "31": "reverse_grip_barbell_biceps_curl",
            "32": "seated_alternating_dumbbell_biceps_curl",
            "33": "seated_dumbbell_biceps_curl",
            "34": "seated_reverse_dumbbell_curl",
            "35": "split_stance_offset_pinky_dumbbell_curl",
            "36": "standing_alternating_dumbbell_curls",
            "37": "standing_dumbbell_biceps_curl",
            "38": "standing_ez_bar_biceps_curl",
            "39": "static_curl",
            "40": "swiss_ball_dumbbell_overhead_triceps_extension",
            "41": "swiss_ball_ez_bar_preacher_curl",
            "42": "twisting_standing_dumbbell_biceps_curl",
            "43": "wide_grip_ez_bar_biceps_curl",
            "alternating_dumbbell_biceps_curl": 0,
            "alternating_dumbbell_biceps_curl_on_swiss_ball": 1,
            "alternating_incline_dumbbell_biceps_curl": 2,
            "barbell_biceps_curl": 3,
            "barbell_reverse_wrist_curl": 4,
            "barbell_wrist_curl": 5,
            "behind_the_back_barbell_reverse_wrist_curl": 6,
            "behind_the_back_one_arm_cable_curl": 7,
            "cable_biceps_curl": 8,
            "cable_hammer_curl": 9,
            "cheating_barbell_biceps_curl": 10,
            "close_grip_ez_bar_biceps_curl": 11,
            "cross_body_dumbbell_hammer_curl": 12,
            "dead_hang_biceps_curl": 13,
            "decline_hammer_curl": 14,
            "dumbbell_biceps_curl_with_static_hold": 15,
            "dumbbell_hammer_curl": 16,
            "dumbbell_reverse_wrist_curl": 17,
            "dumbbell_wrist_curl": 18,
            "ez_bar_preacher_curl": 19,
            "forward_bend_biceps_curl": 20,
            "hammer_curl_to_press": 21,
            "incline_dumbbell_biceps_curl": 22,
            "incline_offset_thumb_dumbbell_curl": 23,
            "kettlebell_biceps_curl": 24,
            "lying_concentration_cable_curl": 25,
            "one_arm_preacher_curl": 26,
            "plate_pinch_curl": 27,
            "preacher_curl_with_cable": 28,
            "reverse_ez_bar_curl": 29,
            "reverse_grip_wrist_curl": 30,
            "reverse_grip_barbell_biceps_curl": 31,
            "seated_alternating_dumbbell_biceps_curl": 32,
            "seated_dumbbell_biceps_curl": 33,
            "seated_reverse_dumbbell_curl": 34,
            "split_stance_offset_pinky_dumbbell_curl": 35,
            "standing_alternating_dumbbell_curls": 36,
            "standing_dumbbell_biceps_curl": 37,
            "standing_ez_bar_biceps_curl": 38,
            "static_curl": 39,
            "swiss_ball_dumbbell_overhead_triceps_extension": 40,
            "swiss_ball_ez_bar_preacher_curl": 41,
            "twisting_standing_dumbbell_biceps_curl": 42,
            "wide_grip_ez_bar_biceps_curl": 43
        }
    },
    "deadlift_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "barbell_deadlift",
            "1": "barbell_straight_leg_deadlift",
            "2": "dumbbell_deadlift",
            "3": "dumbbell_single_leg_deadlift_to_row",
            "4": "dumbbell_straight_leg_deadlift",
            "5": "kettlebell_floor_to_shelf",
            "6": "one_arm_one_leg_deadlift",
            "7": "rack_pull",
            "8": "rotational_dumbbell_straight_leg_deadlift",
            "9": "single_arm_deadlift",
            "10": "single_leg_barbell_deadlift",
            "11": "single_leg_barbell_straight_leg_deadlift",
            "12": "single_leg_deadlift_with_barbell",
            "13": "single_leg_rdl_circuit",
            "14": "single_leg_romanian_deadlift_with_dumbbell",
            "15": "sumo_deadlift",
            "16": "sumo_deadlift_high_pull",
            "17": "trap_bar_deadlift",
            "18": "wide_grip_barbell_deadlift",
            "barbell_deadlift": 0,
            "barbell_straight_leg_deadlift": 1,
            "dumbbell_deadlift": 2,
            "dumbbell_single_leg_deadlift_to_row": 3,
            "dumbbell_straight_leg_deadlift": 4,
            "kettlebell_floor_to_shelf": 5,
            "one_arm_one_leg_deadlift": 6,
            "rack_pull": 7,
            "rotational_dumbbell_straight_leg_deadlift": 8,
            "single_arm_deadlift": 9,
            "single_leg_barbell_deadlift": 10,
            "single_leg_barbell_straight_leg_deadlift": 11,
            "single_leg_deadlift_with_barbell": 12,
            "single_leg_rdl_circuit": 13,
            "single_leg_romanian_deadlift_with_dumbbell": 14,
            "sumo_deadlift": 15,
            "sumo_deadlift_high_pull": 16,
            "trap_bar_deadlift": 17,
            "wide_grip_barbell_deadlift": 18
        }
    },
    "flye_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "cable_crossover",
            "1": "decline_dumbbell_flye",
            "2": "dumbbell_flye",
            "3": "incline_dumbbell_flye",
            "4": "kettlebell_flye",
            "5": "kneeling_rear_flye",
            "6": "single_arm_standing_cable_reverse_flye",
            "7": "swiss_ball_dumbbell_flye",
            "8": "arm_rotations",
            "9": "hug_a_tree",
            "cable_crossover": 0,
            "decline_dumbbell_flye": 1,
            "dumbbell_flye": 2,
            "incline_dumbbell_flye": 3,
            "kettlebell_flye": 4,
            "kneeling_rear_flye": 5,
            "single_arm_standing_cable_reverse_flye": 6,
            "swiss_ball_dumbbell_flye": 7,
            "arm_rotations": 8,
            "hug_a_tree": 9
        }
    },
    "hip_raise_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "barbell_hip_thrust_on_floor",
            "1": "barbell_hip_thrust_with_bench",
            "2": "bent_knee_swiss_ball_reverse_hip_raise",
            "3": "weighted_bent_knee_swiss_ball_reverse_hip_raise",
            "4": "bridge_with_leg_extension",
            "5": "weighted_bridge_with_leg_extension",
            "6": "clam_bridge",
            "7": "front_kick_tabletop",
            "8": "weighted_front_kick_tabletop",
            "9": "hip_extension_and_cross",
            "10": "weighted_hip_extension_and_cross",
            "11": "hip_raise",
            "12": "weighted_hip_raise",
            "13": "hip_raise_with_feet_on_swiss_ball",
            "14": "weighted_hip_raise_with_feet_on_swiss_ball",
            "15": "hip_raise_with_head_on_bosu_ball",
            "16": "weighted_hip_raise_with_head_on_bosu_ball",
            "17": "hip_raise_with_head_on_swiss_ball",
            "18": "weighted_hip_raise_with_head_on_swiss_ball",
            "19": "hip_raise_with_knee_squeeze",
            "20": "weighted_hip_raise_with_knee_squeeze",
            "21": "incline_rear_leg_extension",
            "22": "weighted_incline_rear_leg_extension",
            "23": "kettlebell_swing",
            "24": "marching_hip_raise",
            "25": "weighted_marching_hip_raise",
            "26": "marching_hip_raise_with_feet_on_a_swiss_ball",
            "27": "weighted_marching_hip_raise_with_feet_on_a_swiss_ball",
            "28": "reverse_hip_raise",
            "29": "weighted_reverse_hip_raise",
            "30": "single_leg_hip_raise",
            "31": "weighted_single_leg_hip_raise",
            "32": "single_leg_hip_raise_with_foot_on_bench",
            "33": "weighted_single_leg_hip_raise_with_foot_on_bench",
            "34": "single_leg_hip_raise_with_foot_on_bosu_ball",
            "35": "weighted_single_leg_hip_raise_with_foot_on_bosu_ball",
            "36": "single_leg_hip_raise_with_foot_on_foam_roller",
            "37": "weighted_single_leg_hip_raise_with_foot_on_foam_roller",
            "38": "single_leg_hip_raise_with_foot_on_medicine_ball",
            "39": "weighted_single_leg_hip_raise_with_foot_on_medicine_ball",
            "40": "single_leg_hip_raise_with_head_on_bosu_ball",
            "41": "weighted_single_leg_hip_raise_with_head_on_bosu_ball",
            "42": "weighted_clam_bridge",
            "43": "single_leg_swiss_ball_hip_raise_and_leg_curl",
            "44": "clams",
            "45": "inner_thigh_circles",
            "46": "inner_thigh_side_lift",
            "47": "leg_circles",
            "48": "leg_lift",
            "49": "leg_lift_in_external_rotation",
            "barbell_hip_thrust_on_floor": 0,
            "barbell_hip_thrust_with_bench": 1,
            "bent_knee_swiss_ball_reverse_hip_raise": 2,
            "weighted_bent_knee_swiss_ball_reverse_hip_raise": 3,
            "bridge_with_leg_extension": 4,
            "weighted_bridge_with_leg_extension": 5,
            "clam_bridge": 6,
            "front_kick_tabletop": 7,
            "weighted_front_kick_tabletop": 8,
            "hip_extension_and_cross": 9,
            "weighted_hip_extension_and_cross": 10,
            "hip_raise": 11,
            "weighted_hip_raise": 12,
            "hip_raise_with_feet_on_swiss_ball": 13,
            "weighted_hip_raise_with_feet_on_swiss_ball": 14,
            "hip_raise_with_head_on_bosu_ball": 15,
            "weighted_hip_raise_with_head_on_bosu_ball": 16,
            "hip_raise_with_head_on_swiss_ball": 17,
            "weighted_hip_raise_with_head_on_swiss_ball": 18,
            "hip_raise_with_knee_squeeze": 19,
            "weighted_hip_raise_with_knee_squeeze": 20,
            "incline_rear_leg_extension": 21,
            "weighted_incline_rear_leg_extension": 22,
            "kettlebell_swing": 23,
            "marching_hip_raise": 24,
            "weighted_marching_hip_raise": 25,
            "marching_hip_raise_with_feet_on_a_swiss_ball": 26,
            "weighted_marching_hip_raise_with_feet_on_a_swiss_ball": 27,
            "reverse_hip_raise": 28,
            "weighted_reverse_hip_raise": 29,
            "single_leg_hip_raise": 30,
            "weighted_single_leg_hip_raise": 31,
            "single_leg_hip_raise_with_foot_on_bench": 32,
            "weighted_single_leg_hip_raise_with_foot_on_bench": 33,
            "single_leg_hip_raise_with_foot_on_bosu_ball": 34,
            "weighted_single_leg_hip_raise_with_foot_on_bosu_ball": 35,
            "single_leg_hip_raise_with_foot_on_foam_roller": 36,
            "weighted_single_leg_hip_raise_with_foot_on_foam_roller": 37,
            "single_leg_hip_raise_with_foot_on_medicine_ball": 38,
            "weighted_single_leg_hip_raise_with_foot_on_medicine_ball": 39,
            "single_leg_hip_raise_with_head_on_bosu_ball": 40,
            "weighted_single_leg_hip_raise_with_head_on_bosu_ball": 41,
            "weighted_clam_bridge": 42,
            "single_leg_swiss_ball_hip_raise_and_leg_curl": 43,
            "clams": 44,
            "inner_thigh_circles": 45,
            "inner_thigh_side_lift": 46,
            "leg_circles": 47,
            "leg_lift": 48,
            "leg_lift_in_external_rotation": 49
        }
    },
    "hip_stability_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "band_side_lying_leg_raise",
            "1": "dead_bug",
            "2": "weighted_dead_bug",
            "3": "external_hip_raise",
            "4": "weighted_external_hip_raise",
            "5": "fire_hydrant_kicks",
            "6": "weighted_fire_hydrant_kicks",
            "7": "hip_circles",
            "8": "weighted_hip_circles",
            "9": "inner_thigh_lift",
            "10": "weighted_inner_thigh_lift",
            "11": "lateral_walks_with_band_at_ankles",
            "12": "pretzel_side_kick",
            "13": "weighted_pretzel_side_kick",
            "14": "prone_hip_internal_rotation",
            "15": "weighted_prone_hip_internal_rotation",
            "16": "quadruped",
            "17": "quadruped_hip_extension",
            "18": "weighted_quadruped_hip_extension",
            "19": "quadruped_with_leg_lift",
            "20": "weighted_quadruped_with_leg_lift",
            "21": "side_lying_leg_raise",
            "22": "weighted_side_lying_leg_raise",
            "23": "sliding_hip_adduction",
            "24": "weighted_sliding_hip_adduction",
            "25": "standing_adduction",
            "26": "weighted_standing_adduction",
            "27": "standing_cable_hip_abduction",
            "28": "standing_hip_abduction",
            "29": "weighted_standing_hip_abduction",
            "30": "standing_rear_leg_raise",
            "31": "weighted_standing_rear_leg_raise",
            "32": "supine_hip_internal_rotation",
            "33": "weighted_supine_hip_internal_rotation",
            "band_side_lying_leg_raise": 0,
            "dead_bug": 1,
            "weighted_dead_bug": 2,
            "external_hip_raise": 3,
            "weighted_external_hip_raise": 4,
            "fire_hydrant_kicks": 5,
            "weighted_fire_hydrant_kicks": 6,
            "hip_circles": 7,
            "weighted_hip_circles": 8,
            "inner_thigh_lift": 9,
            "weighted_inner_thigh_lift": 10,
            "lateral_walks_with_band_at_ankles": 11,
            "pretzel_side_kick": 12,
            "weighted_pretzel_side_kick": 13,
            "prone_hip_internal_rotation": 14,
            "weighted_prone_hip_internal_rotation": 15,
            "quadruped": 16,
            "quadruped_hip_extension": 17,
            "weighted_quadruped_hip_extension": 18,
            "quadruped_with_leg_lift": 19,
            "weighted_quadruped_with_leg_lift": 20,
            "side_lying_leg_raise": 21,
            "weighted_side_lying_leg_raise": 22,
            "sliding_hip_adduction": 23,
            "weighted_sliding_hip_adduction": 24,
            "standing_adduction": 25,
            "weighted_standing_adduction": 26,
            "standing_cable_hip_abduction": 27,
            "standing_hip_abduction": 28,
            "weighted_standing_hip_abduction": 29,
            "standing_rear_leg_raise": 30,
            "weighted_standing_rear_leg_raise": 31,
            "supine_hip_internal_rotation": 32,
            "weighted_supine_hip_internal_rotation": 33
        }
    },
    "hip_swing_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "single_arm_kettlebell_swing",
            "1": "single_arm_dumbbell_swing",
            "2": "step_out_swing",
            "single_arm_kettlebell_swing": 0,
            "single_arm_dumbbell_swing": 1,
            "step_out_swing": 2
        }
    },
    "hyperextension_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "back_extension_with_opposite_arm_and_leg_reach",
            "1": "weighted_back_extension_with_opposite_arm_and_leg_reach",
            "2": "base_rotations",
            "3": "weighted_base_rotations",
            "4": "bent_knee_reverse_hyperextension",
            "5": "weighted_bent_knee_reverse_hyperextension",
            "6": "hollow_hold_and_roll",
            "7": "weighted_hollow_hold_and_roll",
            "8": "kicks",
            "9": "weighted_kicks",
            "10": "knee_raises",
            "11": "weighted_knee_raises",
            "12": "kneeling_superman",
            "13": "weighted_kneeling_superman",
            "14": "lat_pull_down_with_row",
            "15": "medicine_ball_deadlift_to_reach",
            "16": "one_arm_one_leg_row",
            "17": "one_arm_row_with_band",
            "18": "overhead_lunge_with_medicine_ball",
            "19": "plank_knee_tucks",
            "20": "weighted_plank_knee_tucks",
            "21": "side_step",
            "22": "weighted_side_step",
            "23": "single_leg_back_extension",
            "24": "weighted_single_leg_back_extension",
            "25": "spine_extension",
            "26": "weighted_spine_extension",
            "27": "static_back_extension",
            "28": "weighted_static_back_extension",
            "29": "superman_from_floor",
            "30": "weighted_superman_from_floor",
            "31": "swiss_ball_back_extension",
            "32": "weighted_swiss_ball_back_extension",
            "33": "swiss_ball_hyperextension",
            "34": "weighted_swiss_ball_hyperextension",
            "35": "swiss_ball_opposite_arm_and_leg_lift",
            "36": "weighted_swiss_ball_opposite_arm_and_leg_lift",
            "37": "superman_on_swiss_ball",
            "38": "cobra",
            "39": "supine_floor_barre",
            "back_extension_with_opposite_arm_and_leg_reach": 0,
            "weighted_back_extension_with_opposite_arm_and_leg_reach": 1,
            "base_rotations": 2,
            "weighted_base_rotations": 3,
            "bent_knee_reverse_hyperextension": 4,
            "weighted_bent_knee_reverse_hyperextension": 5,
            "hollow_hold_and_roll": 6,
            "weighted_hollow_hold_and_roll": 7,
            "kicks": 8,
            "weighted_kicks": 9,
            "knee_raises": 10,
            "weighted_knee_raises": 11,
            "kneeling_superman": 12,
            "weighted_kneeling_superman": 13,
            "lat_pull_down_with_row": 14,
            "medicine_ball_deadlift_to_reach": 15,
            "one_arm_one_leg_row": 16,
            "one_arm_row_with_band": 17,
            "overhead_lunge_with_medicine_ball": 18,
            "plank_knee_tucks": 19,
            "weighted_plank_knee_tucks": 20,
            "side_step": 21,
            "weighted_side_step": 22,
            "single_leg_back_extension": 23,
            "weighted_single_leg_back_extension": 24,
            "spine_extension": 25,
            "weighted_spine_extension": 26,
            "static_back_extension": 27,
            "weighted_static_back_extension": 28,
            "superman_from_floor": 29,
            "weighted_superman_from_floor": 30,
            "swiss_ball_back_extension": 31,
            "weighted_swiss_ball_back_extension": 32,
            "swiss_ball_hyperextension": 33,
            "weighted_swiss_ball_hyperextension": 34,
            "swiss_ball_opposite_arm_and_leg_lift": 35,
            "weighted_swiss_ball_opposite_arm_and_leg_lift": 36,
            "superman_on_swiss_ball": 37,
            "cobra": 38,
            "supine_floor_barre": 39
        }
    },
    "lateral_raise_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "45_degree_cable_external_rotation",
            "1": "alternating_lateral_raise_with_static_hold",
            "2": "bar_muscle_up",
            "3": "bent_over_lateral_raise",
            "4": "cable_diagonal_raise",
            "5": "cable_front_raise",
            "6": "calorie_row",
            "7": "combo_shoulder_raise",
            "8": "dumbbell_diagonal_raise",
            "9": "dumbbell_v_raise",
            "10": "front_raise",
            "11": "leaning_dumbbell_lateral_raise",
            "12": "lying_dumbbell_raise",
            "13": "muscle_up",
            "14": "one_arm_cable_lateral_raise",
            "15": "overhand_grip_rear_lateral_raise",
            "16": "plate_raises",
            "17": "ring_dip",
            "18": "weighted_ring_dip",
            "19": "ring_muscle_up",
            "20": "weighted_ring_muscle_up",
            "21": "rope_climb",
            "22": "weighted_rope_climb",
            "23": "scaption",
            "24": "seated_lateral_raise",
            "25": "seated_rear_lateral_raise",
            "26": "side_lying_lateral_raise",
            "27": "standing_lift",
            "28": "suspended_row",
            "29": "underhand_grip_rear_lateral_raise",
            "30": "wall_slide",
            "31": "weighted_wall_slide",
            "32": "arm_circles",
            "33": "shaving_the_head",
            "45_degree_cable_external_rotation": 0,
            "alternating_lateral_raise_with_static_hold": 1,
            "bar_muscle_up": 2,
            "bent_over_lateral_raise": 3,
            "cable_diagonal_raise": 4,
            "cable_front_raise": 5,
            "calorie_row": 6,
            "combo_shoulder_raise": 7,
            "dumbbell_diagonal_raise": 8,
            "dumbbell_v_raise": 9,
            "front_raise": 10,
            "leaning_dumbbell_lateral_raise": 11,
            "lying_dumbbell_raise": 12,
            "muscle_up": 13,
            "one_arm_cable_lateral_raise": 14,
            "overhand_grip_rear_lateral_raise": 15,
            "plate_raises": 16,
            "ring_dip": 17,
            "weighted_ring_dip": 18,
            "ring_muscle_up": 19,
            "weighted_ring_muscle_up": 20,
            "rope_climb": 21,
            "weighted_rope_climb": 22,
            "scaption": 23,
            "seated_lateral_raise": 24,
            "seated_rear_lateral_raise": 25,
            "side_lying_lateral_raise": 26,
            "standing_lift": 27,
            "suspended_row": 28,
            "underhand_grip_rear_lateral_raise": 29,
            "wall_slide": 30,
            "weighted_wall_slide": 31,
            "arm_circles": 32,
            "shaving_the_head": 33
        }
    },
    "leg_curl_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "leg_curl",
            "1": "weighted_leg_curl",
            "2": "good_morning",
            "3": "seated_barbell_good_morning",
            "4": "single_leg_barbell_good_morning",
            "5": "single_leg_sliding_leg_curl",
            "6": "sliding_leg_curl",
            "7": "split_barbell_good_morning",
            "8": "split_stance_extension",
            "9": "staggered_stance_good_morning",
            "10": "swiss_ball_hip_raise_and_leg_curl",
            "11": "zercher_good_morning",
            "leg_curl": 0,
            "weighted_leg_curl": 1,
            "good_morning": 2,
            "seated_barbell_good_morning": 3,
            "single_leg_barbell_good_morning": 4,
            "single_leg_sliding_leg_curl": 5,
            "sliding_leg_curl": 6,
            "split_barbell_good_morning": 7,
            "split_stance_extension": 8,
            "staggered_stance_good_morning": 9,
            "swiss_ball_hip_raise_and_leg_curl": 10,
            "zercher_good_morning": 11
        }
    },
    "leg_raise_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "hanging_knee_raise",
            "1": "hanging_leg_raise",
            "2": "weighted_hanging_leg_raise",
            "3": "hanging_single_leg_raise",
            "4": "weighted_hanging_single_leg_raise",
            "5": "kettlebell_leg_raises",
            "6": "leg_lowering_drill",
            "7": "weighted_leg_lowering_drill",
            "8": "lying_straight_leg_raise",
            "9": "weighted_lying_straight_leg_raise",
            "10": "medicine_ball_leg_drops",
            "11": "quadruped_leg_raise",
            "12": "weighted_quadruped_leg_raise",
            "13": "reverse_leg_raise",
            "14": "weighted_reverse_leg_raise",
            "15": "reverse_leg_raise_on_swiss_ball",
            "16": "weighted_reverse_leg_raise_on_swiss_ball",
            "17": "single_leg_lowering_drill",
            "18": "weighted_single_leg_lowering_drill",
            "19": "weighted_hanging_knee_raise",
            "20": "lateral_stepover",
            "21": "weighted_lateral_stepover",
            "hanging_knee_raise": 0,
            "hanging_leg_raise": 1,
            "weighted_hanging_leg_raise": 2,
            "hanging_single_leg_raise": 3,
            "weighted_hanging_single_leg_raise": 4,
            "kettlebell_leg_raises": 5,
            "leg_lowering_drill": 6,
            "weighted_leg_lowering_drill": 7,
            "lying_straight_leg_raise": 8,
            "weighted_lying_straight_leg_raise": 9,
            "medicine_ball_leg_drops": 10,
            "quadruped_leg_raise": 11,
            "weighted_quadruped_leg_raise": 12,
            "reverse_leg_raise": 13,
            "weighted_reverse_leg_raise": 14,
            "reverse_leg_raise_on_swiss_ball": 15,
            "weighted_reverse_leg_raise_on_swiss_ball": 16,
            "single_leg_lowering_drill": 17,
            "weighted_single_leg_lowering_drill": 18,
            "weighted_hanging_knee_raise": 19,
            "lateral_stepover": 20,
            "weighted_lateral_stepover": 21
        }
    },
    "lunge_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "overhead_lunge",
            "1": "lunge_matrix",
            "2": "weighted_lunge_matrix",
            "3": "alternating_barbell_forward_lunge",
            "4": "alternating_dumbbell_lunge_with_reach",
            "5": "back_foot_elevated_dumbbell_split_squat",
            "6": "barbell_box_lunge",
            "7": "barbell_bulgarian_split_squat",
            "8": "barbell_crossover_lunge",
            "9": "barbell_front_split_squat",
            "10": "barbell_lunge",
            "11": "barbell_reverse_lunge",
            "12": "barbell_side_lunge",
            "13": "barbell_split_squat",
            "14": "core_control_rear_lunge",
            "15": "diagonal_lunge",
            "16": "drop_lunge",
            "17": "dumbbell_box_lunge",
            "18": "dumbbell_bulgarian_split_squat",
            "19": "dumbbell_crossover_lunge",
            "20": "dumbbell_diagonal_lunge",
            "21": "dumbbell_lunge",
            "22": "dumbbell_lunge_and_rotation",
            "23": "dumbbell_overhead_bulgarian_split_squat",
            "24": "dumbbell_reverse_lunge_to_high_knee_and_press",
            "25": "dumbbell_side_lunge",
            "26": "elevated_front_foot_barbell_split_squat",
            "27": "front_foot_elevated_dumbbell_split_squat",
            "28": "gunslinger_lunge",
            "29": "lawnmower_lunge",
            "30": "low_lunge_with_isometric_adduction",
            "31": "low_side_to_side_lunge",
            "32": "lunge",
            "33": "weighted_lunge",
            "34": "lunge_with_arm_reach",
            "35": "lunge_with_diagonal_reach",
            "36": "lunge_with_side_bend",
            "37": "offset_dumbbell_lunge",
            "38": "offset_dumbbell_reverse_lunge",
            "39": "overhead_bulgarian_split_squat",
            "40": "overhead_dumbbell_reverse_lunge",
            "41": "overhead_dumbbell_split_squat",
            "42": "overhead_lunge_with_rotation",
            "43": "reverse_barbell_box_lunge",
            "44": "reverse_box_lunge",
            "45": "reverse_dumbbell_box_lunge",
            "46": "reverse_dumbbell_crossover_lunge",
            "47": "reverse_dumbbell_diagonal_lunge",
            "48": "reverse_lunge_with_reach_back",
            "49": "weighted_reverse_lunge_with_reach_back",
            "50": "reverse_lunge_with_twist_and_overhead_reach",
            "51": "weighted_reverse_lunge_with_twist_and_overhead_reach",
            "52": "reverse_sliding_box_lunge",
            "53": "weighted_reverse_sliding_box_lunge",
            "54": "reverse_sliding_lunge",
            "55": "weighted_reverse_sliding_lunge",
            "56": "runners_lunge_to_balance",
            "57": "weighted_runners_lunge_to_balance",
            "58": "shifting_side_lunge",
            "59": "side_and_crossover_lunge",
            "60": "weighted_side_and_crossover_lunge",
            "61": "side_lunge",
            "62": "weighted_side_lunge",
            "63": "side_lunge_and_press",
            "64": "side_lunge_jump_off",
            "65": "side_lunge_sweep",
            "66": "weighted_side_lunge_sweep",
            "67": "side_lunge_to_crossover_tap",
            "68": "weighted_side_lunge_to_crossover_tap",
            "69": "side_to_side_lunge_chops",
            "70": "weighted_side_to_side_lunge_chops",
            "71": "siff_jump_lunge",
            "72": "weighted_siff_jump_lunge",
            "73": "single_arm_reverse_lunge_and_press",
            "74": "sliding_lateral_lunge",
            "75": "weighted_sliding_lateral_lunge",
            "76": "walking_barbell_lunge",
            "77": "walking_dumbbell_lunge",
            "78": "walking_lunge",
            "79": "weighted_walking_lunge",
            "80": "wide_grip_overhead_barbell_split_squat",
            "overhead_lunge": 0,
            "lunge_matrix": 1,
            "weighted_lunge_matrix": 2,
            "alternating_barbell_forward_lunge": 3,
            "alternating_dumbbell_lunge_with_reach": 4,
            "back_foot_elevated_dumbbell_split_squat": 5,
            "barbell_box_lunge": 6,
            "barbell_bulgarian_split_squat": 7,
            "barbell_crossover_lunge": 8,
            "barbell_front_split_squat": 9,
            "barbell_lunge": 10,
            "barbell_reverse_lunge": 11,
            "barbell_side_lunge": 12,
            "barbell_split_squat": 13,
            "core_control_rear_lunge": 14,
            "diagonal_lunge": 15,
            "drop_lunge": 16,
            "dumbbell_box_lunge": 17,
            "dumbbell_bulgarian_split_squat": 18,
            "dumbbell_crossover_lunge": 19,
            "dumbbell_diagonal_lunge": 20,
            "dumbbell_lunge": 21,
            "dumbbell_lunge_and_rotation": 22,
            "dumbbell_overhead_bulgarian_split_squat": 23,
            "dumbbell_reverse_lunge_to_high_knee_and_press": 24,
            "dumbbell_side_lunge": 25,
            "elevated_front_foot_barbell_split_squat": 26,
            "front_foot_elevated_dumbbell_split_squat": 27,
            "gunslinger_lunge": 28,
            "lawnmower_lunge": 29,
            "low_lunge_with_isometric_adduction": 30,
            "low_side_to_side_lunge": 31,
            "lunge": 32,
            "weighted_lunge": 33,
            "lunge_with_arm_reach": 34,
            "lunge_with_diagonal_reach": 35,
            "lunge_with_side_bend": 36,
            "offset_dumbbell_lunge": 37,
            "offset_dumbbell_reverse_lunge": 38,
            "overhead_bulgarian_split_squat": 39,
            "overhead_dumbbell_reverse_lunge": 40,
            "overhead_dumbbell_split_squat": 41,
            "overhead_lunge_with_rotation": 42,
            "reverse_barbell_box_lunge": 43,
            "reverse_box_lunge": 44,
            "reverse_dumbbell_box_lunge": 45,
            "reverse_dumbbell_crossover_lunge": 46,
            "reverse_dumbbell_diagonal_lunge": 47,
            "reverse_lunge_with_reach_back": 48,
            "weighted_reverse_lunge_with_reach_back": 49,
            "reverse_lunge_with_twist_and_overhead_reach": 50,
            "weighted_reverse_lunge_with_twist_and_overhead_reach": 51,
            "reverse_sliding_box_lunge": 52,
            "weighted_reverse_sliding_box_lunge": 53,
            "reverse_sliding_lunge": 54,
            "weighted_reverse_sliding_lunge": 55,
            "runners_lunge_to_balance": 56,
            "weighted_runners_lunge_to_balance": 57,
            "shifting_side_lunge": 58,
            "side_and_crossover_lunge": 59,
            "weighted_side_and_crossover_lunge": 60,
            "side_lunge": 61,
            "weighted_side_lunge": 62,
            "side_lunge_and_press": 63,
            "side_lunge_jump_off": 64,
            "side_lunge_sweep": 65,
            "weighted_side_lunge_sweep": 66,
            "side_lunge_to_crossover_tap": 67,
            "weighted_side_lunge_to_crossover_tap": 68,
            "side_to_side_lunge_chops": 69,
            "weighted_side_to_side_lunge_chops": 70,
            "siff_jump_lunge": 71,
            "weighted_siff_jump_lunge": 72,
            "single_arm_reverse_lunge_and_press": 73,
            "sliding_lateral_lunge": 74,
            "weighted_sliding_lateral_lunge": 75,
            "walking_barbell_lunge": 76,
            "walking_dumbbell_lunge": 77,
            "walking_lunge": 78,
            "weighted_walking_lunge": 79,
            "wide_grip_overhead_barbell_split_squat": 80
        }
    },
    "olympic_lift_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "barbell_hang_power_clean",
            "1": "barbell_hang_squat_clean",
            "2": "barbell_power_clean",
            "3": "barbell_power_snatch",
            "4": "barbell_squat_clean",
            "5": "clean_and_jerk",
            "6": "barbell_hang_power_snatch",
            "7": "barbell_hang_pull",
            "8": "barbell_high_pull",
            "9": "barbell_snatch",
            "10": "barbell_split_jerk",
            "11": "clean",
            "12": "dumbbell_clean",
            "13": "dumbbell_hang_pull",
            "14": "one_hand_dumbbell_split_snatch",
            "15": "push_jerk",
            "16": "single_arm_dumbbell_snatch",
            "17": "single_arm_hang_snatch",
            "18": "single_arm_kettlebell_snatch",
            "19": "split_jerk",
            "20": "squat_clean_and_jerk",
            "barbell_hang_power_clean": 0,
            "barbell_hang_squat_clean": 1,
            "barbell_power_clean": 2,
            "barbell_power_snatch": 3,
            "barbell_squat_clean": 4,
            "clean_and_jerk": 5,
            "barbell_hang_power_snatch": 6,
            "barbell_hang_pull": 7,
            "barbell_high_pull": 8,
            "barbell_snatch": 9,
            "barbell_split_jerk": 10,
            "clean": 11,
            "dumbbell_clean": 12,
            "dumbbell_hang_pull": 13,
            "one_hand_dumbbell_split_snatch": 14,
            "push_jerk": 15,
            "single_arm_dumbbell_snatch": 16,
            "single_arm_hang_snatch": 17,
            "single_arm_kettlebell_snatch": 18,
            "split_jerk": 19,
            "squat_clean_and_jerk": 20
        }
    },
    "plank_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "45_degree_plank",
            "1": "weighted_45_degree_plank",
            "2": "90_degree_static_hold",
            "3": "weighted_90_degree_static_hold",
            "4": "bear_crawl",
            "5": "weighted_bear_crawl",
            "6": "cross_body_mountain_climber",
            "7": "weighted_cross_body_mountain_climber",
            "8": "elbow_plank_pike_jacks",
            "9": "weighted_elbow_plank_pike_jacks",
            "10": "elevated_feet_plank",
            "11": "weighted_elevated_feet_plank",
            "12": "elevator_abs",
            "13": "weighted_elevator_abs",
            "14": "extended_plank",
            "15": "weighted_extended_plank",
            "16": "full_plank_passe_twist",
            "17": "weighted_full_plank_passe_twist",
            "18": "inching_elbow_plank",
            "19": "weighted_inching_elbow_plank",
            "20": "inchworm_to_side_plank",
            "21": "weighted_inchworm_to_side_plank",
            "22": "kneeling_plank",
            "23": "weighted_kneeling_plank",
            "24": "kneeling_side_plank_with_leg_lift",
            "25": "weighted_kneeling_side_plank_with_leg_lift",
            "26": "lateral_roll",
            "27": "weighted_lateral_roll",
            "28": "lying_reverse_plank",
            "29": "weighted_lying_reverse_plank",
            "30": "medicine_ball_mountain_climber",
            "31": "weighted_medicine_ball_mountain_climber",
            "32": "modified_mountain_climber_and_extension",
            "33": "weighted_modified_mountain_climber_and_extension",
            "34": "mountain_climber",
            "35": "weighted_mountain_climber",
            "36": "mountain_climber_on_sliding_discs",
            "37": "weighted_mountain_climber_on_sliding_discs",
            "38": "mountain_climber_with_feet_on_bosu_ball",
            "39": "weighted_mountain_climber_with_feet_on_bosu_ball",
            "40": "mountain_climber_with_hands_on_bench",
            "41": "mountain_climber_with_hands_on_swiss_ball",
            "42": "weighted_mountain_climber_with_hands_on_swiss_ball",
            "43": "plank",
            "44": "plank_jacks_with_feet_on_sliding_discs",
            "45": "weighted_plank_jacks_with_feet_on_sliding_discs",
            "46": "plank_knee_twist",
            "47": "weighted_plank_knee_twist",
            "48": "plank_pike_jumps",
            "49": "weighted_plank_pike_jumps",
            "50": "plank_pikes",
            "51": "weighted_plank_pikes",
            "52": "plank_to_stand_up",
            "53": "weighted_plank_to_stand_up",
            "54": "plank_with_arm_raise",
            "55": "weighted_plank_with_arm_raise",
            "56": "plank_with_knee_to_elbow",
            "57": "weighted_plank_with_knee_to_elbow",
            "58": "plank_with_oblique_crunch",
            "59": "weighted_plank_with_oblique_crunch",
            "60": "plyometric_side_plank",
            "61": "weighted_plyometric_side_plank",
            "62": "rolling_side_plank",
            "63": "weighted_rolling_side_plank",
            "64": "side_kick_plank",
            "65": "weighted_side_kick_plank",
            "66": "side_plank",
            "67": "weighted_side_plank",
            "68": "side_plank_and_row",
            "69": "weighted_side_plank_and_row",
            "70": "side_plank_lift",
            "71": "weighted_side_plank_lift",
            "72": "side_plank_with_elbow_on_bosu_ball",
            "73": "weighted_side_plank_with_elbow_on_bosu_ball",
            "74": "side_plank_with_feet_on_bench",
            "75": "weighted_side_plank_with_feet_on_bench",
            "76": "side_plank_with_knee_circle",
            "77": "weighted_side_plank_with_knee_circle",
            "78": "side_plank_with_knee_tuck",
            "79": "weighted_side_plank_with_knee_tuck",
            "80": "side_plank_with_leg_lift",
            "81": "weighted_side_plank_with_leg_lift",
            "82": "side_plank_with_reach_under",
            "83": "weighted_side_plank_with_reach_under",
            "84": "single_leg_elevated_feet_plank",
            "85": "weighted_single_leg_elevated_feet_plank",
            "86": "single_leg_flex_and_extend",
            "87": "weighted_single_leg_flex_and_extend",
            "88": "single_leg_side_plank",
            "89": "weighted_single_leg_side_plank",
            "90": "spiderman_plank",
            "91": "weighted_spiderman_plank",
            "92": "straight_arm_plank",
            "93": "weighted_straight_arm_plank",
            "94": "straight_arm_plank_with_shoulder_touch",
            "95": "weighted_straight_arm_plank_with_shoulder_touch",
            "96": "swiss_ball_plank",
            "97": "weighted_swiss_ball_plank",
            "98": "swiss_ball_plank_leg_lift",
            "99": "weighted_swiss_ball_plank_leg_lift",
            "100": "swiss_ball_plank_leg_lift_and_hold",
            "101": "swiss_ball_plank_with_feet_on_bench",
            "102": "weighted_swiss_ball_plank_with_feet_on_bench",
            "103": "swiss_ball_prone_jackknife",
            "104": "weighted_swiss_ball_prone_jackknife",
            "105": "swiss_ball_side_plank",
            "106": "weighted_swiss_ball_side_plank",
            "107": "three_way_plank",
            "108": "weighted_three_way_plank",
            "109": "towel_plank_and_knee_in",
            "110": "weighted_towel_plank_and_knee_in",
            "111": "t_stabilization",
            "112": "weighted_t_stabilization",
            "113": "turkish_get_up_to_side_plank",
            "114": "weighted_turkish_get_up_to_side_plank",
            "115": "two_point_plank",
            "116": "weighted_two_point_plank",
            "117": "weighted_plank",
            "118": "wide_stance_plank_with_diagonal_arm_lift",
            "119": "weighted_wide_stance_plank_with_diagonal_arm_lift",
            "120": "wide_stance_plank_with_diagonal_leg_lift",
            "121": "weighted_wide_stance_plank_with_diagonal_leg_lift",
            "122": "wide_stance_plank_with_leg_lift",
            "123": "weighted_wide_stance_plank_with_leg_lift",
            "124": "wide_stance_plank_with_opposite_arm_and_leg_lift",
            "125": "weighted_mountain_climber_with_hands_on_bench",
            "126": "weighted_swiss_ball_plank_leg_lift_and_hold",
            "127": "weighted_wide_stance_plank_with_opposite_arm_and_leg_lift",
            "128": "plank_with_feet_on_swiss_ball",
            "129": "side_plank_to_plank_with_reach_under",
            "130": "bridge_with_glute_lower_lift",
            "131": "bridge_one_leg_bridge",
            "132": "plank_with_arm_variations",
            "133": "plank_with_leg_lift",
            "134": "reverse_plank_with_leg_pull",
            "45_degree_plank": 0,
            "weighted_45_degree_plank": 1,
            "90_degree_static_hold": 2,
            "weighted_90_degree_static_hold": 3,
            "bear_crawl": 4,
            "weighted_bear_crawl": 5,
            "cross_body_mountain_climber": 6,
            "weighted_cross_body_mountain_climber": 7,
            "elbow_plank_pike_jacks": 8,
            "weighted_elbow_plank_pike_jacks": 9,
            "elevated_feet_plank": 10,
            "weighted_elevated_feet_plank": 11,
            "elevator_abs": 12,
            "weighted_elevator_abs": 13,
            "extended_plank": 14,
            "weighted_extended_plank": 15,
            "full_plank_passe_twist": 16,
            "weighted_full_plank_passe_twist": 17,
            "inching_elbow_plank": 18,
            "weighted_inching_elbow_plank": 19,
            "inchworm_to_side_plank": 20,
            "weighted_inchworm_to_side_plank": 21,
            "kneeling_plank": 22,
            "weighted_kneeling_plank": 23,
            "kneeling_side_plank_with_leg_lift": 24,
            "weighted_kneeling_side_plank_with_leg_lift": 25,
            "lateral_roll": 26,
            "weighted_lateral_roll": 27,
            "lying_reverse_plank": 28,
            "weighted_lying_reverse_plank": 29,
            "medicine_ball_mountain_climber": 30,
            "weighted_medicine_ball_mountain_climber": 31,
            "modified_mountain_climber_and_extension": 32,
            "weighted_modified_mountain_climber_and_extension": 33,
            "mountain_climber": 34,
            "weighted_mountain_climber": 35,
            "mountain_climber_on_sliding_discs": 36,
            "weighted_mountain_climber_on_sliding_discs": 37,
            "mountain_climber_with_feet_on_bosu_ball": 38,
            "weighted_mountain_climber_with_feet_on_bosu_ball": 39,
            "mountain_climber_with_hands_on_bench": 40,
            "mountain_climber_with_hands_on_swiss_ball": 41,
            "weighted_mountain_climber_with_hands_on_swiss_ball": 42,
            "plank": 43,
            "plank_jacks_with_feet_on_sliding_discs": 44,
            "weighted_plank_jacks_with_feet_on_sliding_discs": 45,
            "plank_knee_twist": 46,
            "weighted_plank_knee_twist": 47,
            "plank_pike_jumps": 48,
            "weighted_plank_pike_jumps": 49,
            "plank_pikes": 50,
            "weighted_plank_pikes": 51,
            "plank_to_stand_up": 52,
            "weighted_plank_to_stand_up": 53,
            "plank_with_arm_raise": 54,
            "weighted_plank_with_arm_raise": 55,
            "plank_with_knee_to_elbow": 56,
            "weighted_plank_with_knee_to_elbow": 57,
            "plank_with_oblique_crunch": 58,
            "weighted_plank_with_oblique_crunch": 59,
            "plyometric_side_plank": 60,
            "weighted_plyometric_side_plank": 61,
            "rolling_side_plank": 62,
            "weighted_rolling_side_plank": 63,
            "side_kick_plank": 64,
            "weighted_side_kick_plank": 65,
            "side_plank": 66,
            "weighted_side_plank": 67,
            "side_plank_and_row": 68,
            "weighted_side_plank_and_row": 69,
            "side_plank_lift": 70,
            "weighted_side_plank_lift": 71,
            "side_plank_with_elbow_on_bosu_ball": 72,
            "weighted_side_plank_with_elbow_on_bosu_ball": 73,
            "side_plank_with_feet_on_bench": 74,
            "weighted_side_plank_with_feet_on_bench": 75,
            "side_plank_with_knee_circle": 76,
            "weighted_side_plank_with_knee_circle": 77,
            "side_plank_with_knee_tuck": 78,
            "weighted_side_plank_with_knee_tuck": 79,
            "side_plank_with_leg_lift": 80,
            "weighted_side_plank_with_leg_lift": 81,
            "side_plank_with_reach_under": 82,
            "weighted_side_plank_with_reach_under": 83,
            "single_leg_elevated_feet_plank": 84,
            "weighted_single_leg_elevated_feet_plank": 85,
            "single_leg_flex_and_extend": 86,
            "weighted_single_leg_flex_and_extend": 87,
            "single_leg_side_plank": 88,
            "weighted_single_leg_side_plank": 89,
            "spiderman_plank": 90,
            "weighted_spiderman_plank": 91,
            "straight_arm_plank": 92,
            "weighted_straight_arm_plank": 93,
            "straight_arm_plank_with_shoulder_touch": 94,
            "weighted_straight_arm_plank_with_shoulder_touch": 95,
            "swiss_ball_plank": 96,
            "weighted_swiss_ball_plank": 97,
            "swiss_ball_plank_leg_lift": 98,
            "weighted_swiss_ball_plank_leg_lift": 99,
            "swiss_ball_plank_leg_lift_and_hold": 100,
            "swiss_ball_plank_with_feet_on_bench": 101,
            "weighted_swiss_ball_plank_with_feet_on_bench": 102,
            "swiss_ball_prone_jackknife": 103,
            "weighted_swiss_ball_prone_jackknife": 104,
            "swiss_ball_side_plank": 105,
            "weighted_swiss_ball_side_plank": 106,
            "three_way_plank": 107,
            "weighted_three_way_plank": 108,
            "towel_plank_and_knee_in": 109,
            "weighted_towel_plank_and_knee_in": 110,
            "t_stabilization": 111,
            "weighted_t_stabilization": 112,
            "turkish_get_up_to_side_plank": 113,
            "weighted_turkish_get_up_to_side_plank": 114,
            "two_point_plank": 115,
            "weighted_two_point_plank": 116,
            "weighted_plank": 117,
            "wide_stance_plank_with_diagonal_arm_lift": 118,
            "weighted_wide_stance_plank_with_diagonal_arm_lift": 119,
            "wide_stance_plank_with_diagonal_leg_lift": 120,
            "weighted_wide_stance_plank_with_diagonal_leg_lift": 121,
            "wide_stance_plank_with_leg_lift": 122,
            "weighted_wide_stance_plank_with_leg_lift": 123,
            "wide_stance_plank_with_opposite_arm_and_leg_lift": 124,
            "weighted_mountain_climber_with_hands_on_bench": 125,
            "weighted_swiss_ball_plank_leg_lift_and_hold": 126,
            "weighted_wide_stance_plank_with_opposite_arm_and_leg_lift": 127,
            "plank_with_feet_on_swiss_ball": 128,
            "side_plank_to_plank_with_reach_under": 129,
            "bridge_with_glute_lower_lift": 130,
            "bridge_one_leg_bridge": 131,
            "plank_with_arm_variations": 132,
            "plank_with_leg_lift": 133,
            "reverse_plank_with_leg_pull": 134
        }
    },
    "plyo_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "alternating_jump_lunge",
            "1": "weighted_alternating_jump_lunge",
            "2": "barbell_jump_squat",
            "3": "body_weight_jump_squat",
            "4": "weighted_jump_squat",
            "5": "cross_knee_strike",
            "6": "weighted_cross_knee_strike",
            "7": "depth_jump",
            "8": "weighted_depth_jump",
            "9": "dumbbell_jump_squat",
            "10": "dumbbell_split_jump",
            "11": "front_knee_strike",
            "12": "weighted_front_knee_strike",
            "13": "high_box_jump",
            "14": "weighted_high_box_jump",
            "15": "isometric_explosive_body_weight_jump_squat",
            "16": "weighted_isometric_explosive_jump_squat",
            "17": "lateral_leap_and_hop",
            "18": "weighted_lateral_leap_and_hop",
            "19": "lateral_plyo_squats",
            "20": "weighted_lateral_plyo_squats",
            "21": "lateral_slide",
            "22": "weighted_lateral_slide",
            "23": "medicine_ball_overhead_throws",
            "24": "medicine_ball_side_throw",
            "25": "medicine_ball_slam",
            "26": "side_to_side_medicine_ball_throws",
            "27": "side_to_side_shuffle_jump",
            "28": "weighted_side_to_side_shuffle_jump",
            "29": "squat_jump_onto_box",
            "30": "weighted_squat_jump_onto_box",
            "31": "squat_jumps_in_and_out",
            "32": "weighted_squat_jumps_in_and_out",
            "alternating_jump_lunge": 0,
            "weighted_alternating_jump_lunge": 1,
            "barbell_jump_squat": 2,
            "body_weight_jump_squat": 3,
            "weighted_jump_squat": 4,
            "cross_knee_strike": 5,
            "weighted_cross_knee_strike": 6,
            "depth_jump": 7,
            "weighted_depth_jump": 8,
            "dumbbell_jump_squat": 9,
            "dumbbell_split_jump": 10,
            "front_knee_strike": 11,
            "weighted_front_knee_strike": 12,
            "high_box_jump": 13,
            "weighted_high_box_jump": 14,
            "isometric_explosive_body_weight_jump_squat": 15,
            "weighted_isometric_explosive_jump_squat": 16,
            "lateral_leap_and_hop": 17,
            "weighted_lateral_leap_and_hop": 18,
            "lateral_plyo_squats": 19,
            "weighted_lateral_plyo_squats": 20,
            "lateral_slide": 21,
            "weighted_lateral_slide": 22,
            "medicine_ball_overhead_throws": 23,
            "medicine_ball_side_throw": 24,
            "medicine_ball_slam": 25,
            "side_to_side_medicine_ball_throws": 26,
            "side_to_side_shuffle_jump": 27,
            "weighted_side_to_side_shuffle_jump": 28,
            "squat_jump_onto_box": 29,
            "weighted_squat_jump_onto_box": 30,
            "squat_jumps_in_and_out": 31,
            "weighted_squat_jumps_in_and_out": 32
        }
    },
    "pull_up_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "banded_pull_ups",
            "1": "30_degree_lat_pulldown",
            "2": "band_assisted_chin_up",
            "3": "close_grip_chin_up",
            "4": "weighted_close_grip_chin_up",
            "5": "close_grip_lat_pulldown",
            "6": "crossover_chin_up",
            "7": "weighted_crossover_chin_up",
            "8": "ez_bar_pullover",
            "9": "hanging_hurdle",
            "10": "weighted_hanging_hurdle",
            "11": "kneeling_lat_pulldown",
            "12": "kneeling_underhand_grip_lat_pulldown",
            "13": "lat_pulldown",
            "14": "mixed_grip_chin_up",
            "15": "weighted_mixed_grip_chin_up",
            "16": "mixed_grip_pull_up",
            "17": "weighted_mixed_grip_pull_up",
            "18": "reverse_grip_pulldown",
            "19": "standing_cable_pullover",
            "20": "straight_arm_pulldown",
            "21": "swiss_ball_ez_bar_pullover",
            "22": "towel_pull_up",
            "23": "weighted_towel_pull_up",
            "24": "weighted_pull_up",
            "25": "wide_grip_lat_pulldown",
            "26": "wide_grip_pull_up",
            "27": "weighted_wide_grip_pull_up",
            "28": "burpee_pull_up",
            "29": "weighted_burpee_pull_up",
            "30": "jumping_pull_ups",
            "31": "weighted_jumping_pull_ups",
            "32": "kipping_pull_up",
            "33": "weighted_kipping_pull_up",
            "34": "l_pull_up",
            "35": "weighted_l_pull_up",
            "36": "suspended_chin_up",
            "37": "weighted_suspended_chin_up",
            "38": "pull_up",
            "banded_pull_ups": 0,
            "30_degree_lat_pulldown": 1,
            "band_assisted_chin_up": 2,
            "close_grip_chin_up": 3,
            "weighted_close_grip_chin_up": 4,
            "close_grip_lat_pulldown": 5,
            "crossover_chin_up": 6,
            "weighted_crossover_chin_up": 7,
            "ez_bar_pullover": 8,
            "hanging_hurdle": 9,
            "weighted_hanging_hurdle": 10,
            "kneeling_lat_pulldown": 11,
            "kneeling_underhand_grip_lat_pulldown": 12,
            "lat_pulldown": 13,
            "mixed_grip_chin_up": 14,
            "weighted_mixed_grip_chin_up": 15,
            "mixed_grip_pull_up": 16,
            "weighted_mixed_grip_pull_up": 17,
            "reverse_grip_pulldown": 18,
            "standing_cable_pullover": 19,
            "straight_arm_pulldown": 20,
            "swiss_ball_ez_bar_pullover": 21,
            "towel_pull_up": 22,
            "weighted_towel_pull_up": 23,
            "weighted_pull_up": 24,
            "wide_grip_lat_pulldown": 25,
            "wide_grip_pull_up": 26,
            "weighted_wide_grip_pull_up": 27,
            "burpee_pull_up": 28,
            "weighted_burpee_pull_up": 29,
            "jumping_pull_ups": 30,
            "weighted_jumping_pull_ups": 31,
            "kipping_pull_up": 32,
            "weighted_kipping_pull_up": 33,
            "l_pull_up": 34,
            "weighted_l_pull_up": 35,
            "suspended_chin_up": 36,
            "weighted_suspended_chin_up": 37,
            "pull_up": 38
        }
    },
    "push_up_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "chest_press_with_band",
            "1": "alternating_staggered_push_up",
            "2": "weighted_alternating_staggered_push_up",
            "3": "alternating_hands_medicine_ball_push_up",
            "4": "weighted_alternating_hands_medicine_ball_push_up",
            "5": "bosu_ball_push_up",
            "6": "weighted_bosu_ball_push_up",
            "7": "clapping_push_up",
            "8": "weighted_clapping_push_up",
            "9": "close_grip_medicine_ball_push_up",
            "10": "weighted_close_grip_medicine_ball_push_up",
            "11": "close_hands_push_up",
            "12": "weighted_close_hands_push_up",
            "13": "decline_push_up",
            "14": "weighted_decline_push_up",
            "15": "diamond_push_up",
            "16": "weighted_diamond_push_up",
            "17": "explosive_crossover_push_up",
            "18": "weighted_explosive_crossover_push_up",
            "19": "explosive_push_up",
            "20": "weighted_explosive_push_up",
            "21": "feet_elevated_side_to_side_push_up",
            "22": "weighted_feet_elevated_side_to_side_push_up",
            "23": "hand_release_push_up",
            "24": "weighted_hand_release_push_up",
            "25": "handstand_push_up",
            "26": "weighted_handstand_push_up",
            "27": "incline_push_up",
            "28": "weighted_incline_push_up",
            "29": "isometric_explosive_push_up",
            "30": "weighted_isometric_explosive_push_up",
            "31": "judo_push_up",
            "32": "weighted_judo_push_up",
            "33": "kneeling_push_up",
            "34": "weighted_kneeling_push_up",
            "35": "medicine_ball_chest_pass",
            "36": "medicine_ball_push_up",
            "37": "weighted_medicine_ball_push_up",
            "38": "one_arm_push_up",
            "39": "weighted_one_arm_push_up",
            "40": "weighted_push_up",
            "41": "push_up_and_row",
            "42": "weighted_push_up_and_row",
            "43": "push_up_plus",
            "44": "weighted_push_up_plus",
            "45": "push_up_with_feet_on_swiss_ball",
            "46": "weighted_push_up_with_feet_on_swiss_ball",
            "47": "push_up_with_one_hand_on_medicine_ball",
            "48": "weighted_push_up_with_one_hand_on_medicine_ball",
            "49": "shoulder_push_up",
            "50": "weighted_shoulder_push_up",
            "51": "single_arm_medicine_ball_push_up",
            "52": "weighted_single_arm_medicine_ball_push_up",
            "53": "spiderman_push_up",
            "54": "weighted_spiderman_push_up",
            "55": "stacked_feet_push_up",
            "56": "weighted_stacked_feet_push_up",
            "57": "staggered_hands_push_up",
            "58": "weighted_staggered_hands_push_up",
            "59": "suspended_push_up",
            "60": "weighted_suspended_push_up",
            "61": "swiss_ball_push_up",
            "62": "weighted_swiss_ball_push_up",
            "63": "swiss_ball_push_up_plus",
            "64": "weighted_swiss_ball_push_up_plus",
            "65": "t_push_up",
            "66": "weighted_t_push_up",
            "67": "triple_stop_push_up",
            "68": "weighted_triple_stop_push_up",
            "69": "wide_hands_push_up",
            "70": "weighted_wide_hands_push_up",
            "71": "parallette_handstand_push_up",
            "72": "weighted_parallette_handstand_push_up",
            "73": "ring_handstand_push_up",
            "74": "weighted_ring_handstand_push_up",
            "75": "ring_push_up",
            "76": "weighted_ring_push_up",
            "77": "push_up",
            "78": "pilates_pushup",
            "chest_press_with_band": 0,
            "alternating_staggered_push_up": 1,
            "weighted_alternating_staggered_push_up": 2,
            "alternating_hands_medicine_ball_push_up": 3,
            "weighted_alternating_hands_medicine_ball_push_up": 4,
            "bosu_ball_push_up": 5,
            "weighted_bosu_ball_push_up": 6,
            "clapping_push_up": 7,
            "weighted_clapping_push_up": 8,
            "close_grip_medicine_ball_push_up": 9,
            "weighted_close_grip_medicine_ball_push_up": 10,
            "close_hands_push_up": 11,
            "weighted_close_hands_push_up": 12,
            "decline_push_up": 13,
            "weighted_decline_push_up": 14,
            "diamond_push_up": 15,
            "weighted_diamond_push_up": 16,
            "explosive_crossover_push_up": 17,
            "weighted_explosive_crossover_push_up": 18,
            "explosive_push_up": 19,
            "weighted_explosive_push_up": 20,
            "feet_elevated_side_to_side_push_up": 21,
            "weighted_feet_elevated_side_to_side_push_up": 22,
            "hand_release_push_up": 23,
            "weighted_hand_release_push_up": 24,
            "handstand_push_up": 25,
            "weighted_handstand_push_up": 26,
            "incline_push_up": 27,
            "weighted_incline_push_up": 28,
            "isometric_explosive_push_up": 29,
            "weighted_isometric_explosive_push_up": 30,
            "judo_push_up": 31,
            "weighted_judo_push_up": 32,
            "kneeling_push_up": 33,
            "weighted_kneeling_push_up": 34,
            "medicine_ball_chest_pass": 35,
            "medicine_ball_push_up": 36,
            "weighted_medicine_ball_push_up": 37,
            "one_arm_push_up": 38,
            "weighted_one_arm_push_up": 39,
            "weighted_push_up": 40,
            "push_up_and_row": 41,
            "weighted_push_up_and_row": 42,
            "push_up_plus": 43,
            "weighted_push_up_plus": 44,
            "push_up_with_feet_on_swiss_ball": 45,
            "weighted_push_up_with_feet_on_swiss_ball": 46,
            "push_up_with_one_hand_on_medicine_ball": 47,
            "weighted_push_up_with_one_hand_on_medicine_ball": 48,
            "shoulder_push_up": 49,
            "weighted_shoulder_push_up": 50,
            "single_arm_medicine_ball_push_up": 51,
            "weighted_single_arm_medicine_ball_push_up": 52,
            "spiderman_push_up": 53,
            "weighted_spiderman_push_up": 54,
            "stacked_feet_push_up": 55,
            "weighted_stacked_feet_push_up": 56,
            "staggered_hands_push_up": 57,
            "weighted_staggered_hands_push_up": 58,
            "suspended_push_up": 59,
            "weighted_suspended_push_up": 60,
            "swiss_ball_push_up": 61,
            "weighted_swiss_ball_push_up": 62,
            "swiss_ball_push_up_plus": 63,
            "weighted_swiss_ball_push_up_plus": 64,
            "t_push_up": 65,
            "weighted_t_push_up": 66,
            "triple_stop_push_up": 67,
            "weighted_triple_stop_push_up": 68,
            "wide_hands_push_up": 69,
            "weighted_wide_hands_push_up": 70,
            "parallette_handstand_push_up": 71,
            "weighted_parallette_handstand_push_up": 72,
            "ring_handstand_push_up": 73,
            "weighted_ring_handstand_push_up": 74,
            "ring_push_up": 75,
            "weighted_ring_push_up": 76,
            "push_up": 77,
            "pilates_pushup": 78
        }
    },
    "row_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "barbell_straight_leg_deadlift_to_row",
            "1": "cable_row_standing",
            "2": "dumbbell_row",
            "3": "elevated_feet_inverted_row",
            "4": "weighted_elevated_feet_inverted_row",
            "5": "face_pull",
            "6": "face_pull_with_external_rotation",
            "7": "inverted_row_with_feet_on_swiss_ball",
            "8": "weighted_inverted_row_with_feet_on_swiss_ball",
            "9": "kettlebell_row",
            "10": "modified_inverted_row",
            "11": "weighted_modified_inverted_row",
            "12": "neutral_grip_alternating_dumbbell_row",
            "13": "one_arm_bent_over_row",
            "14": "one_legged_dumbbell_row",
            "15": "renegade_row",
            "16": "reverse_grip_barbell_row",
            "17": "rope_handle_cable_row",
            "18": "seated_cable_row",
            "19": "seated_dumbbell_row",
            "20": "single_arm_cable_row",
            "21": "single_arm_cable_row_and_rotation",
            "22": "single_arm_inverted_row",
            "23": "weighted_single_arm_inverted_row",
            "24": "single_arm_neutral_grip_dumbbell_row",
            "25": "single_arm_neutral_grip_dumbbell_row_and_rotation",
            "26": "suspended_inverted_row",
            "27": "weighted_suspended_inverted_row",
            "28": "t_bar_row",
            "29": "towel_grip_inverted_row",
            "30": "weighted_towel_grip_inverted_row",
            "31": "underhand_grip_cable_row",
            "32": "v_grip_cable_row",
            "33": "wide_grip_seated_cable_row",
            "barbell_straight_leg_deadlift_to_row": 0,
            "cable_row_standing": 1,
            "dumbbell_row": 2,
            "elevated_feet_inverted_row": 3,
            "weighted_elevated_feet_inverted_row": 4,
            "face_pull": 5,
            "face_pull_with_external_rotation": 6,
            "inverted_row_with_feet_on_swiss_ball": 7,
            "weighted_inverted_row_with_feet_on_swiss_ball": 8,
            "kettlebell_row": 9,
            "modified_inverted_row": 10,
            "weighted_modified_inverted_row": 11,
            "neutral_grip_alternating_dumbbell_row": 12,
            "one_arm_bent_over_row": 13,
            "one_legged_dumbbell_row": 14,
            "renegade_row": 15,
            "reverse_grip_barbell_row": 16,
            "rope_handle_cable_row": 17,
            "seated_cable_row": 18,
            "seated_dumbbell_row": 19,
            "single_arm_cable_row": 20,
            "single_arm_cable_row_and_rotation": 21,
            "single_arm_inverted_row": 22,
            "weighted_single_arm_inverted_row": 23,
            "single_arm_neutral_grip_dumbbell_row": 24,
            "single_arm_neutral_grip_dumbbell_row_and_rotation": 25,
            "suspended_inverted_row": 26,
            "weighted_suspended_inverted_row": 27,
            "t_bar_row": 28,
            "towel_grip_inverted_row": 29,
            "weighted_towel_grip_inverted_row": 30,
            "underhand_grip_cable_row": 31,
            "v_grip_cable_row": 32,
            "wide_grip_seated_cable_row": 33
        }
    },
    "shoulder_press_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "alternating_dumbbell_shoulder_press",
            "1": "arnold_press",
            "2": "barbell_front_squat_to_push_press",
            "3": "barbell_push_press",
            "4": "barbell_shoulder_press",
            "5": "dead_curl_press",
            "6": "dumbbell_alternating_shoulder_press_and_twist",
            "7": "dumbbell_hammer_curl_to_lunge_to_press",
            "8": "dumbbell_push_press",
            "9": "floor_inverted_shoulder_press",
            "10": "weighted_floor_inverted_shoulder_press",
            "11": "inverted_shoulder_press",
            "12": "weighted_inverted_shoulder_press",
            "13": "one_arm_push_press",
            "14": "overhead_barbell_press",
            "15": "overhead_dumbbell_press",
            "16": "seated_barbell_shoulder_press",
            "17": "seated_dumbbell_shoulder_press",
            "18": "single_arm_dumbbell_shoulder_press",
            "19": "single_arm_step_up_and_press",
            "20": "smith_machine_overhead_press",
            "21": "split_stance_hammer_curl_to_press",
            "22": "swiss_ball_dumbbell_shoulder_press",
            "23": "weight_plate_front_raise",
            "alternating_dumbbell_shoulder_press": 0,
            "arnold_press": 1,
            "barbell_front_squat_to_push_press": 2,
            "barbell_push_press": 3,
            "barbell_shoulder_press": 4,
            "dead_curl_press": 5,
            "dumbbell_alternating_shoulder_press_and_twist": 6,
            "dumbbell_hammer_curl_to_lunge_to_press": 7,
            "dumbbell_push_press": 8,
            "floor_inverted_shoulder_press": 9,
            "weighted_floor_inverted_shoulder_press": 10,
            "inverted_shoulder_press": 11,
            "weighted_inverted_shoulder_press": 12,
            "one_arm_push_press": 13,
            "overhead_barbell_press": 14,
            "overhead_dumbbell_press": 15,
            "seated_barbell_shoulder_press": 16,
            "seated_dumbbell_shoulder_press": 17,
            "single_arm_dumbbell_shoulder_press": 18,
            "single_arm_step_up_and_press": 19,
            "smith_machine_overhead_press": 20,
            "split_stance_hammer_curl_to_press": 21,
            "swiss_ball_dumbbell_shoulder_press": 22,
            "weight_plate_front_raise": 23
        }
    },
    "shoulder_stability_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "90_degree_cable_external_rotation",
            "1": "band_external_rotation",
            "2": "band_internal_rotation",
            "3": "bent_arm_lateral_raise_and_external_rotation",
            "4": "cable_external_rotation",
            "5": "dumbbell_face_pull_with_external_rotation",
            "6": "floor_i_raise",
            "7": "weighted_floor_i_raise",
            "8": "floor_t_raise",
            "9": "weighted_floor_t_raise",
            "10": "floor_y_raise",
            "11": "weighted_floor_y_raise",
            "12": "incline_i_raise",
            "13": "weighted_incline_i_raise",
            "14": "incline_l_raise",
            "15": "weighted_incline_l_raise",
            "16": "incline_t_raise",
            "17": "weighted_incline_t_raise",
            "18": "incline_w_raise",
            "19": "weighted_incline_w_raise",
            "20": "incline_y_raise",
            "21": "weighted_incline_y_raise",
            "22": "lying_external_rotation",
            "23": "seated_dumbbell_external_rotation",
            "24": "standing_l_raise",
            "25": "swiss_ball_i_raise",
            "26": "weighted_swiss_ball_i_raise",
            "27": "swiss_ball_t_raise",
            "28": "weighted_swiss_ball_t_raise",
            "29": "swiss_ball_w_raise",
            "30": "weighted_swiss_ball_w_raise",
            "31": "swiss_ball_y_raise",
            "32": "weighted_swiss_ball_y_raise",
            "90_degree_cable_external_rotation": 0,
            "band_external_rotation": 1,
            "band_internal_rotation": 2,
            "bent_arm_lateral_raise_and_external_rotation": 3,
            "cable_external_rotation": 4,
            "dumbbell_face_pull_with_external_rotation": 5,
            "floor_i_raise": 6,
            "weighted_floor_i_raise": 7,
            "floor_t_raise": 8,
            "weighted_floor_t_raise": 9,
            "floor_y_raise": 10,
            "weighted_floor_y_raise": 11,
            "incline_i_raise": 12,
            "weighted_incline_i_raise": 13,
            "incline_l_raise": 14,
            "weighted_incline_l_raise": 15,
            "incline_t_raise": 16,
            "weighted_incline_t_raise": 17,
            "incline_w_raise": 18,
            "weighted_incline_w_raise": 19,
            "incline_y_raise": 20,
            "weighted_incline_y_raise": 21,
            "lying_external_rotation": 22,
            "seated_dumbbell_external_rotation": 23,
            "standing_l_raise": 24,
            "swiss_ball_i_raise": 25,
            "weighted_swiss_ball_i_raise": 26,
            "swiss_ball_t_raise": 27,
            "weighted_swiss_ball_t_raise": 28,
            "swiss_ball_w_raise": 29,
            "weighted_swiss_ball_w_raise": 30,
            "swiss_ball_y_raise": 31,
            "weighted_swiss_ball_y_raise": 32
        }
    },
    "shrug_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "barbell_jump_shrug",
            "1": "barbell_shrug",
            "2": "barbell_upright_row",
            "3": "behind_the_back_smith_machine_shrug",
            "4": "dumbbell_jump_shrug",
            "5": "dumbbell_shrug",
            "6": "dumbbell_upright_row",
            "7": "incline_dumbbell_shrug",
            "8": "overhead_barbell_shrug",
            "9": "overhead_dumbbell_shrug",
            "10": "scaption_and_shrug",
            "11": "scapular_retraction",
            "12": "serratus_chair_shrug",
            "13": "weighted_serratus_chair_shrug",
            "14": "serratus_shrug",
            "15": "weighted_serratus_shrug",
            "16": "wide_grip_jump_shrug",
            "barbell_jump_shrug": 0,
            "barbell_shrug": 1,
            "barbell_upright_row": 2,
            "behind_the_back_smith_machine_shrug": 3,
            "dumbbell_jump_shrug": 4,
            "dumbbell_shrug": 5,
            "dumbbell_upright_row": 6,
            "incline_dumbbell_shrug": 7,
            "overhead_barbell_shrug": 8,
            "overhead_dumbbell_shrug": 9,
            "scaption_and_shrug": 10,
            "scapular_retraction": 11,
            "serratus_chair_shrug": 12,
            "weighted_serratus_chair_shrug": 13,
            "serratus_shrug": 14,
            "weighted_serratus_shrug": 15,
            "wide_grip_jump_shrug": 16
        }
    },
    "sit_up_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "alternating_sit_up",
            "1": "weighted_alternating_sit_up",
            "2": "bent_knee_v_up",
            "3": "weighted_bent_knee_v_up",
            "4": "butterfly_sit_up",
            "5": "weighted_butterfly_situp",
            "6": "cross_punch_roll_up",
            "7": "weighted_cross_punch_roll_up",
            "8": "crossed_arms_sit_up",
            "9": "weighted_crossed_arms_sit_up",
            "10": "get_up_sit_up",
            "11": "weighted_get_up_sit_up",
            "12": "hovering_sit_up",
            "13": "weighted_hovering_sit_up",
            "14": "kettlebell_sit_up",
            "15": "medicine_ball_alternating_v_up",
            "16": "medicine_ball_sit_up",
            "17": "medicine_ball_v_up",
            "18": "modified_sit_up",
            "19": "negative_sit_up",
            "20": "one_arm_full_sit_up",
            "21": "reclining_circle",
            "22": "weighted_reclining_circle",
            "23": "reverse_curl_up",
            "24": "weighted_reverse_curl_up",
            "25": "single_leg_swiss_ball_jackknife",
            "26": "weighted_single_leg_swiss_ball_jackknife",
            "27": "the_teaser",
            "28": "the_teaser_weighted",
            "29": "three_part_roll_down",
            "30": "weighted_three_part_roll_down",
            "31": "v_up",
            "32": "weighted_v_up",
            "33": "weighted_russian_twist_on_swiss_ball",
            "34": "weighted_sit_up",
            "35": "x_abs",
            "36": "weighted_x_abs",
            "37": "sit_up",
            "alternating_sit_up": 0,
            "weighted_alternating_sit_up": 1,
            "bent_knee_v_up": 2,
            "weighted_bent_knee_v_up": 3,
            "butterfly_sit_up": 4,
            "weighted_butterfly_situp": 5,
            "cross_punch_roll_up": 6,
            "weighted_cross_punch_roll_up": 7,
            "crossed_arms_sit_up": 8,
            "weighted_crossed_arms_sit_up": 9,
            "get_up_sit_up": 10,
            "weighted_get_up_sit_up": 11,
            "hovering_sit_up": 12,
            "weighted_hovering_sit_up": 13,
            "kettlebell_sit_up": 14,
            "medicine_ball_alternating_v_up": 15,
            "medicine_ball_sit_up": 16,
            "medicine_ball_v_up": 17,
            "modified_sit_up": 18,
            "negative_sit_up": 19,
            "one_arm_full_sit_up": 20,
            "reclining_circle": 21,
            "weighted_reclining_circle": 22,
            "reverse_curl_up": 23,
            "weighted_reverse_curl_up": 24,
            "single_leg_swiss_ball_jackknife": 25,
            "weighted_single_leg_swiss_ball_jackknife": 26,
            "the_teaser": 27,
            "the_teaser_weighted": 28,
            "three_part_roll_down": 29,
            "weighted_three_part_roll_down": 30,
            "v_up": 31,
            "weighted_v_up": 32,
            "weighted_russian_twist_on_swiss_ball": 33,
            "weighted_sit_up": 34,
            "x_abs": 35,
            "weighted_x_abs": 36,
            "sit_up": 37
        }
    },
    "squat_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "leg_press",
            "1": "back_squat_with_body_bar",
            "2": "back_squats",
            "3": "weighted_back_squats",
            "4": "balancing_squat",
            "5": "weighted_balancing_squat",
            "6": "barbell_back_squat",
            "7": "barbell_box_squat",
            "8": "barbell_front_squat",
            "9": "barbell_hack_squat",
            "10": "barbell_hang_squat_snatch",
            "11": "barbell_lateral_step_up",
            "12": "barbell_quarter_squat",
            "13": "barbell_siff_squat",
            "14": "barbell_squat_snatch",
            "15": "barbell_squat_with_heels_raised",
            "16": "barbell_stepover",
            "17": "barbell_step_up",
            "18": "bench_squat_with_rotational_chop",
            "19": "weighted_bench_squat_with_rotational_chop",
            "20": "body_weight_wall_squat",
            "21": "weighted_wall_squat",
            "22": "box_step_squat",
            "23": "weighted_box_step_squat",
            "24": "braced_squat",
            "25": "crossed_arm_barbell_front_squat",
            "26": "crossover_dumbbell_step_up",
            "27": "dumbbell_front_squat",
            "28": "dumbbell_split_squat",
            "29": "dumbbell_squat",
            "30": "dumbbell_squat_clean",
            "31": "dumbbell_stepover",
            "32": "dumbbell_step_up",
            "33": "elevated_single_leg_squat",
            "34": "weighted_elevated_single_leg_squat",
            "35": "figure_four_squats",
            "36": "weighted_figure_four_squats",
            "37": "goblet_squat",
            "38": "kettlebell_squat",
            "39": "kettlebell_swing_overhead",
            "40": "kettlebell_swing_with_flip_to_squat",
            "41": "lateral_dumbbell_step_up",
            "42": "one_legged_squat",
            "43": "overhead_dumbbell_squat",
            "44": "overhead_squat",
            "45": "partial_single_leg_squat",
            "46": "weighted_partial_single_leg_squat",
            "47": "pistol_squat",
            "48": "weighted_pistol_squat",
            "49": "plie_slides",
            "50": "weighted_plie_slides",
            "51": "plie_squat",
            "52": "weighted_plie_squat",
            "53": "prisoner_squat",
            "54": "weighted_prisoner_squat",
            "55": "single_leg_bench_get_up",
            "56": "weighted_single_leg_bench_get_up",
            "57": "single_leg_bench_squat",
            "58": "weighted_single_leg_bench_squat",
            "59": "single_leg_squat_on_swiss_ball",
            "60": "weighted_single_leg_squat_on_swiss_ball",
            "61": "squat",
            "62": "weighted_squat",
            "63": "squats_with_band",
            "64": "staggered_squat",
            "65": "weighted_staggered_squat",
            "66": "step_up",
            "67": "weighted_step_up",
            "68": "suitcase_squats",
            "69": "sumo_squat",
            "70": "sumo_squat_slide_in",
            "71": "weighted_sumo_squat_slide_in",
            "72": "sumo_squat_to_high_pull",
            "73": "sumo_squat_to_stand",
            "74": "weighted_sumo_squat_to_stand",
            "75": "sumo_squat_with_rotation",
            "76": "weighted_sumo_squat_with_rotation",
            "77": "swiss_ball_body_weight_wall_squat",
            "78": "weighted_swiss_ball_wall_squat",
            "79": "thrusters",
            "80": "uneven_squat",
            "81": "weighted_uneven_squat",
            "82": "waist_slimming_squat",
            "83": "wall_ball",
            "84": "wide_stance_barbell_squat",
            "85": "wide_stance_goblet_squat",
            "86": "zercher_squat",
            "87": "kbs_overhead",
            "88": "squat_and_side_kick",
            "89": "squat_jumps_in_n_out",
            "90": "pilates_plie_squats_parallel_turned_out_flat_and_heels",
            "91": "releve_straight_leg_and_knee_bent_with_one_leg_variation",
            "leg_press": 0,
            "back_squat_with_body_bar": 1,
            "back_squats": 2,
            "weighted_back_squats": 3,
            "balancing_squat": 4,
            "weighted_balancing_squat": 5,
            "barbell_back_squat": 6,
            "barbell_box_squat": 7,
            "barbell_front_squat": 8,
            "barbell_hack_squat": 9,
            "barbell_hang_squat_snatch": 10,
            "barbell_lateral_step_up": 11,
            "barbell_quarter_squat": 12,
            "barbell_siff_squat": 13,
            "barbell_squat_snatch": 14,
            "barbell_squat_with_heels_raised": 15,
            "barbell_stepover": 16,
            "barbell_step_up": 17,
            "bench_squat_with_rotational_chop": 18,
            "weighted_bench_squat_with_rotational_chop": 19,
            "body_weight_wall_squat": 20,
            "weighted_wall_squat": 21,
            "box_step_squat": 22,
            "weighted_box_step_squat": 23,
            "braced_squat": 24,
            "crossed_arm_barbell_front_squat": 25,
            "crossover_dumbbell_step_up": 26,
            "dumbbell_front_squat": 27,
            "dumbbell_split_squat": 28,
            "dumbbell_squat": 29,
            "dumbbell_squat_clean": 30,
            "dumbbell_stepover": 31,
            "dumbbell_step_up": 32,
            "elevated_single_leg_squat": 33,
            "weighted_elevated_single_leg_squat": 34,
            "figure_four_squats": 35,
            "weighted_figure_four_squats": 36,
            "goblet_squat": 37,
            "kettlebell_squat": 38,
            "kettlebell_swing_overhead": 39,
            "kettlebell_swing_with_flip_to_squat": 40,
            "lateral_dumbbell_step_up": 41,
            "one_legged_squat": 42,
            "overhead_dumbbell_squat": 43,
            "overhead_squat": 44,
            "partial_single_leg_squat": 45,
            "weighted_partial_single_leg_squat": 46,
            "pistol_squat": 47,
            "weighted_pistol_squat": 48,
            "plie_slides": 49,
            "weighted_plie_slides": 50,
            "plie_squat": 51,
            "weighted_plie_squat": 52,
            "prisoner_squat": 53,
            "weighted_prisoner_squat": 54,
            "single_leg_bench_get_up": 55,
            "weighted_single_leg_bench_get_up": 56,
            "single_leg_bench_squat": 57,
            "weighted_single_leg_bench_squat": 58,
            "single_leg_squat_on_swiss_ball": 59,
            "weighted_single_leg_squat_on_swiss_ball": 60,
            "squat": 61,
            "weighted_squat": 62,
            "squats_with_band": 63,
            "staggered_squat": 64,
            "weighted_staggered_squat": 65,
            "step_up": 66,
            "weighted_step_up": 67,
            "suitcase_squats": 68,
            "sumo_squat": 69,
            "sumo_squat_slide_in": 70,
            "weighted_sumo_squat_slide_in": 71,
            "sumo_squat_to_high_pull": 72,
            "sumo_squat_to_stand": 73,
            "weighted_sumo_squat_to_stand": 74,
            "sumo_squat_with_rotation": 75,
            "weighted_sumo_squat_with_rotation": 76,
            "swiss_ball_body_weight_wall_squat": 77,
            "weighted_swiss_ball_wall_squat": 78,
            "thrusters": 79,
            "uneven_squat": 80,
            "weighted_uneven_squat": 81,
            "waist_slimming_squat": 82,
            "wall_ball": 83,
            "wide_stance_barbell_squat": 84,
            "wide_stance_goblet_squat": 85,
            "zercher_squat": 86,
            "kbs_overhead": 87,
            "squat_and_side_kick": 88,
            "squat_jumps_in_n_out": 89,
            "pilates_plie_squats_parallel_turned_out_flat_and_heels": 90,
            "releve_straight_leg_and_knee_bent_with_one_leg_variation": 91
        }
    },
    "total_body_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "burpee",
            "1": "weighted_burpee",
            "2": "burpee_box_jump",
            "3": "weighted_burpee_box_jump",
            "4": "high_pull_burpee",
            "5": "man_makers",
            "6": "one_arm_burpee",
            "7": "squat_thrusts",
            "8": "weighted_squat_thrusts",
            "9": "squat_plank_push_up",
            "10": "weighted_squat_plank_push_up",
            "11": "standing_t_rotation_balance",
            "12": "weighted_standing_t_rotation_balance",
            "burpee": 0,
            "weighted_burpee": 1,
            "burpee_box_jump": 2,
            "weighted_burpee_box_jump": 3,
            "high_pull_burpee": 4,
            "man_makers": 5,
            "one_arm_burpee": 6,
            "squat_thrusts": 7,
            "weighted_squat_thrusts": 8,
            "squat_plank_push_up": 9,
            "weighted_squat_plank_push_up": 10,
            "standing_t_rotation_balance": 11,
            "weighted_standing_t_rotation_balance": 12
        }
    },
    "triceps_extension_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "bench_dip",
            "1": "weighted_bench_dip",
            "2": "body_weight_dip",
            "3": "cable_kickback",
            "4": "cable_lying_triceps_extension",
            "5": "cable_overhead_triceps_extension",
            "6": "dumbbell_kickback",
            "7": "dumbbell_lying_triceps_extension",
            "8": "ez_bar_overhead_triceps_extension",
            "9": "incline_dip",
            "10": "weighted_incline_dip",
            "11": "incline_ez_bar_lying_triceps_extension",
            "12": "lying_dumbbell_pullover_to_extension",
            "13": "lying_ez_bar_triceps_extension",
            "14": "lying_triceps_extension_to_close_grip_bench_press",
            "15": "overhead_dumbbell_triceps_extension",
            "16": "reclining_triceps_press",
            "17": "reverse_grip_pressdown",
            "18": "reverse_grip_triceps_pressdown",
            "19": "rope_pressdown",
            "20": "seated_barbell_overhead_triceps_extension",
            "21": "seated_dumbbell_overhead_triceps_extension",
            "22": "seated_ez_bar_overhead_triceps_extension",
            "23": "seated_single_arm_overhead_dumbbell_extension",
            "24": "single_arm_dumbbell_overhead_triceps_extension",
            "25": "single_dumbbell_seated_overhead_triceps_extension",
            "26": "single_leg_bench_dip_and_kick",
            "27": "weighted_single_leg_bench_dip_and_kick",
            "28": "single_leg_dip",
            "29": "weighted_single_leg_dip",
            "30": "static_lying_triceps_extension",
            "31": "suspended_dip",
            "32": "weighted_suspended_dip",
            "33": "swiss_ball_dumbbell_lying_triceps_extension",
            "34": "swiss_ball_ez_bar_lying_triceps_extension",
            "35": "swiss_ball_ez_bar_overhead_triceps_extension",
            "36": "tabletop_dip",
            "37": "weighted_tabletop_dip",
            "38": "triceps_extension_on_floor",
            "39": "triceps_pressdown",
            "40": "weighted_dip",
            "bench_dip": 0,
            "weighted_bench_dip": 1,
            "body_weight_dip": 2,
            "cable_kickback": 3,
            "cable_lying_triceps_extension": 4,
            "cable_overhead_triceps_extension": 5,
            "dumbbell_kickback": 6,
            "dumbbell_lying_triceps_extension": 7,
            "ez_bar_overhead_triceps_extension": 8,
            "incline_dip": 9,
            "weighted_incline_dip": 10,
            "incline_ez_bar_lying_triceps_extension": 11,
            "lying_dumbbell_pullover_to_extension": 12,
            "lying_ez_bar_triceps_extension": 13,
            "lying_triceps_extension_to_close_grip_bench_press": 14,
            "overhead_dumbbell_triceps_extension": 15,
            "reclining_triceps_press": 16,
            "reverse_grip_pressdown": 17,
            "reverse_grip_triceps_pressdown": 18,
            "rope_pressdown": 19,
            "seated_barbell_overhead_triceps_extension": 20,
            "seated_dumbbell_overhead_triceps_extension": 21,
            "seated_ez_bar_overhead_triceps_extension": 22,
            "seated_single_arm_overhead_dumbbell_extension": 23,
            "single_arm_dumbbell_overhead_triceps_extension": 24,
            "single_dumbbell_seated_overhead_triceps_extension": 25,
            "single_leg_bench_dip_and_kick": 26,
            "weighted_single_leg_bench_dip_and_kick": 27,
            "single_leg_dip": 28,
            "weighted_single_leg_dip": 29,
            "static_lying_triceps_extension": 30,
            "suspended_dip": 31,
            "weighted_suspended_dip": 32,
            "swiss_ball_dumbbell_lying_triceps_extension": 33,
            "swiss_ball_ez_bar_lying_triceps_extension": 34,
            "swiss_ball_ez_bar_overhead_triceps_extension": 35,
            "tabletop_dip": 36,
            "weighted_tabletop_dip": 37,
            "triceps_extension_on_floor": 38,
            "triceps_pressdown": 39,
            "weighted_dip": 40
        }
    },
    "warm_up_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "quadruped_rocking",
            "1": "neck_tilts",
            "2": "ankle_circles",
            "3": "ankle_dorsiflexion_with_band",
            "4": "ankle_internal_rotation",
            "5": "arm_circles",
            "6": "bent_over_reach_to_sky",
            "7": "cat_camel",
            "8": "elbow_to_foot_lunge",
            "9": "forward_and_backward_leg_swings",
            "10": "groiners",
            "11": "inverted_hamstring_stretch",
            "12": "lateral_duck_under",
            "13": "neck_rotations",
            "14": "opposite_arm_and_leg_balance",
            "15": "reach_roll_and_lift",
            "16": "scorpion",
            "17": "shoulder_circles",
            "18": "side_to_side_leg_swings",
            "19": "sleeper_stretch",
            "20": "slide_out",
            "21": "swiss_ball_hip_crossover",
            "22": "swiss_ball_reach_roll_and_lift",
            "23": "swiss_ball_windshield_wipers",
            "24": "thoracic_rotation",
            "25": "walking_high_kicks",
            "26": "walking_high_knees",
            "27": "walking_knee_hugs",
            "28": "walking_leg_cradles",
            "29": "walkout",
            "30": "walkout_from_push_up_position",
            "quadruped_rocking": 0,
            "neck_tilts": 1,
            "ankle_circles": 2,
            "ankle_dorsiflexion_with_band": 3,
            "ankle_internal_rotation": 4,
            "arm_circles": 5,
            "bent_over_reach_to_sky": 6,
            "cat_camel": 7,
            "elbow_to_foot_lunge": 8,
            "forward_and_backward_leg_swings": 9,
            "groiners": 10,
            "inverted_hamstring_stretch": 11,
            "lateral_duck_under": 12,
            "neck_rotations": 13,
            "opposite_arm_and_leg_balance": 14,
            "reach_roll_and_lift": 15,
            "scorpion": 16,
            "shoulder_circles": 17,
            "side_to_side_leg_swings": 18,
            "sleeper_stretch": 19,
            "slide_out": 20,
            "swiss_ball_hip_crossover": 21,
            "swiss_ball_reach_roll_and_lift": 22,
            "swiss_ball_windshield_wipers": 23,
            "thoracic_rotation": 24,
            "walking_high_kicks": 25,
            "walking_high_knees": 26,
            "walking_knee_hugs": 27,
            "walking_leg_cradles": 28,
            "walkout": 29,
            "walkout_from_push_up_position": 30
        }
    },
    "run_exercise_name": {
        "base_type": "uint16",
        "values": {
            "0": "run",
            "1": "walk",
            "2": "jog",
            "3": "sprint",
            "run": 0,
            "walk": 1,
            "jog": 2,
            "sprint": 3
        }
    },
    "water_type": {
        "base_type": "enum",
        "values": {
            "0": "fresh",
            "1": "salt",
            "2": "en13319",
            "3": "custom",
            "fresh": 0,
            "salt": 1,
            "en13319": 2,
            "custom": 3
        }
    },
    "tissue_model_type": {
        "base_type": "enum",
        "values": {
            "0": "zhl_16c",
            "zhl_16c": 0
        }
    },
    "dive_gas_status": {
        "base_type": "enum",
        "values": {
            "0": "disabled",
            "1": "enabled",
            "2": "backup_only",
            "disabled": 0,
            "enabled": 1,
            "backup_only": 2
        }
    },
    "dive_alarm_type": {
        "base_type": "enum",
        "values": {
            "0": "depth",
            "1": "time",
            "depth": 0,
            "time": 1
        }
    },
    "dive_backlight_mode": {
        "base_type": "enum",
        "values": {
            "0": "at_depth",
            "1": "always_on",
            "at_depth": 0,
            "always_on": 1
        }
    },
    "favero_product": {
        "base_type": "uint16",
        "values": {
            "10": "assioma_uno",
            "12": "assioma_duo",
            "assioma_uno": 10,
            "assioma_duo": 12
        }
    },
    "climb_pro_event": {
        "base_type": "enum",
        "values": {
            "0": "approach",
            "1": "start",
            "2": "complete",
            "approach": 0,
            "start": 1,
            "complete": 2
        }
    },
    "tap_sensitivity": {
        "base_type": "enum",
        "values": {
            "0": "high",
            "1": "medium",
            "2": "low",
            "high": 0,
            "medium": 1,
            "low": 2
        }
    },
    "radar_threat_level_type": {
        "base_type": "enum",
        "values": {
            "0": "threat_unknown",
            "1": "threat_none",
            "2": "threat_approaching",
            "3": "threat_approaching_fast",
            "threat_unknown": 0,
            "threat_none": 1,
            "threat_approaching": 2,
            "threat_approaching_fast": 3
        }
    }
};


var $7c197b9264f7b9ee$export$2e2bcd8739ae039 = {
    "type": {
        "type": "course_point",
        "base_type": "enum",
        "units": ""
    },
    "manufacturer": {
        "type": "manufacturer",
        "base_type": "uint16",
        "units": ""
    },
    "product": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "serial_number": {
        "type": "uint32z",
        "base_type": "uint32z",
        "units": ""
    },
    "time_created": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "number": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "product_name": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "software_version": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": ""
    },
    "hardware_version": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "timestamp": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "fractional_timestamp": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 32768,
        "units": "s"
    },
    "system_timestamp": {
        "type": "date_time",
        "base_type": "uint32",
        "units": "s"
    },
    "fractional_system_timestamp": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 32768,
        "units": "s"
    },
    "local_timestamp": {
        "type": "local_date_time",
        "base_type": "uint32",
        "units": ""
    },
    "timestamp_ms": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "ms"
    },
    "system_timestamp_ms": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "ms"
    },
    "total_timer_time": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "num_sessions": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "event": {
        "type": "event",
        "base_type": "enum",
        "units": ""
    },
    "event_type": {
        "type": "event_type",
        "base_type": "enum",
        "units": ""
    },
    "event_group": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "message_index": {
        "type": "message_index",
        "base_type": "uint16",
        "units": ""
    },
    "start_time": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "start_position_lat": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "start_position_long": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "sport": {
        "type": "sport",
        "base_type": "enum",
        "units": ""
    },
    "sub_sport": {
        "type": "sub_sport",
        "base_type": "enum",
        "units": ""
    },
    "total_elapsed_time": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "total_distance": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 100,
        "units": "m"
    },
    "total_cycles": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "cycles"
    },
    "total_calories": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "kcal"
    },
    "total_fat_calories": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "kcal"
    },
    "avg_speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "m/s"
    },
    "max_speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "m/s",
        "bits": 16
    },
    "avg_heart_rate": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "bpm"
    },
    "max_heart_rate": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "bpm"
    },
    "avg_cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "rpm"
    },
    "max_cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "rpm"
    },
    "avg_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "max_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "total_ascent": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "m"
    },
    "total_descent": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "m"
    },
    "total_training_effect": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 10,
        "units": ""
    },
    "first_lap_index": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "num_laps": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "trigger": {
        "type": "session_trigger",
        "base_type": "enum",
        "units": ""
    },
    "nec_lat": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "nec_long": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "swc_lat": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "swc_long": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "num_lengths": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "lengths"
    },
    "normalized_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "training_stress_score": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "tss"
    },
    "intensity_factor": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "if"
    },
    "left_right_balance": {
        "type": "left_right_balance",
        "base_type": "uint8",
        "units": ""
    },
    "avg_stroke_count": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 10,
        "units": "strokes/lap"
    },
    "avg_stroke_distance": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "m"
    },
    "swim_stroke": {
        "type": "swim_stroke",
        "base_type": "enum",
        "units": "swim_stroke"
    },
    "pool_length": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "m"
    },
    "threshold_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "pool_length_unit": {
        "type": "display_measure",
        "base_type": "enum",
        "units": ""
    },
    "num_active_lengths": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "lengths"
    },
    "total_work": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "J"
    },
    "avg_altitude": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 5,
        "offset": 500,
        "units": "m",
        "bits": 16
    },
    "max_altitude": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 5,
        "offset": 500,
        "units": "m",
        "bits": 16
    },
    "gps_accuracy": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "m"
    },
    "avg_grade": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "%"
    },
    "avg_pos_grade": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "%"
    },
    "avg_neg_grade": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "%"
    },
    "max_pos_grade": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "%"
    },
    "max_neg_grade": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "%"
    },
    "avg_temperature": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "C"
    },
    "max_temperature": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "C"
    },
    "total_moving_time": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "avg_pos_vertical_speed": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 1000,
        "units": "m/s"
    },
    "avg_neg_vertical_speed": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 1000,
        "units": "m/s"
    },
    "max_pos_vertical_speed": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 1000,
        "units": "m/s"
    },
    "max_neg_vertical_speed": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 1000,
        "units": "m/s"
    },
    "min_heart_rate": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "bpm"
    },
    "time_in_hr_zone": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "time_in_speed_zone": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "time_in_cadence_zone": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "time_in_power_zone": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "avg_lap_time": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "best_lap_index": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "min_altitude": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 5,
        "offset": 500,
        "units": "m",
        "bits": 16
    },
    "player_score": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "opponent_score": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "opponent_name": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "stroke_count": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "zone_count": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "max_ball_speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "m/s"
    },
    "avg_ball_speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "m/s"
    },
    "avg_vertical_oscillation": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "mm"
    },
    "avg_stance_time_percent": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "percent"
    },
    "avg_stance_time": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "ms"
    },
    "avg_fractional_cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 128,
        "units": "rpm"
    },
    "max_fractional_cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 128,
        "units": "rpm"
    },
    "total_fractional_cycles": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 128,
        "units": "cycles"
    },
    "avg_total_hemoglobin_conc": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "g/dL"
    },
    "min_total_hemoglobin_conc": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "g/dL"
    },
    "max_total_hemoglobin_conc": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "g/dL"
    },
    "avg_saturated_hemoglobin_percent": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "%"
    },
    "min_saturated_hemoglobin_percent": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "%"
    },
    "max_saturated_hemoglobin_percent": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "%"
    },
    "avg_left_torque_effectiveness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "avg_right_torque_effectiveness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "avg_left_pedal_smoothness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "avg_right_pedal_smoothness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "avg_combined_pedal_smoothness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "sport_index": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "time_standing": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "stand_count": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "avg_left_pco": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "mm"
    },
    "avg_right_pco": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "mm"
    },
    "avg_left_power_phase": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "avg_left_power_phase_peak": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "avg_right_power_phase": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "avg_right_power_phase_peak": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "avg_power_position": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "max_power_position": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "avg_cadence_position": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "rpm"
    },
    "max_cadence_position": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "rpm"
    },
    "enhanced_avg_speed": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "m/s"
    },
    "enhanced_max_speed": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "m/s"
    },
    "enhanced_avg_altitude": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 5,
        "offset": 500,
        "units": "m"
    },
    "enhanced_min_altitude": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 5,
        "offset": 500,
        "units": "m"
    },
    "enhanced_max_altitude": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 5,
        "offset": 500,
        "units": "m"
    },
    "avg_lev_motor_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "max_lev_motor_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "lev_battery_consumption": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "avg_vertical_ratio": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "percent"
    },
    "avg_stance_time_balance": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "percent"
    },
    "avg_step_length": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "mm"
    },
    "total_anaerobic_training_effect": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 10,
        "units": ""
    },
    "avg_vam": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "m/s",
        "bits": 16
    },
    "total_grit": {
        "type": "float32",
        "base_type": "float32",
        "units": "kGrit"
    },
    "total_flow": {
        "type": "float32",
        "base_type": "float32",
        "units": "Flow"
    },
    "jump_count": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "avg_grit": {
        "type": "float32",
        "base_type": "float32",
        "units": "kGrit"
    },
    "avg_flow": {
        "type": "float32",
        "base_type": "float32",
        "units": "Flow"
    },
    "total_fractional_ascent": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 100,
        "units": "m"
    },
    "total_fractional_descent": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 100,
        "units": "m"
    },
    "avg_core_temperature": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "C"
    },
    "min_core_temperature": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "C"
    },
    "max_core_temperature": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "C"
    },
    "end_position_lat": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "end_position_long": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "intensity": {
        "type": "intensity",
        "base_type": "enum",
        "units": ""
    },
    "lap_trigger": {
        "type": "lap_trigger",
        "base_type": "enum",
        "units": ""
    },
    "first_length_index": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "repetition_num": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "wkt_step_index": {
        "type": "message_index",
        "base_type": "uint16",
        "units": ""
    },
    "total_strokes": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "strokes"
    },
    "avg_swimming_cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "strokes/min"
    },
    "length_type": {
        "type": "length_type",
        "base_type": "enum",
        "units": ""
    },
    "position_lat": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "position_long": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "altitude": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 5,
        "offset": 500,
        "units": "m",
        "bits": 16
    },
    "heart_rate": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "bpm"
    },
    "cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "rpm"
    },
    "distance": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 100,
        "units": "m"
    },
    "speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "m/s",
        "bits": 16
    },
    "power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "compressed_speed_distance": {
        "type": "byte",
        "base_type": "byte",
        "scale": 100,
        "units": "m/s,\nm",
        "bits": [
            12,
            12
        ],
        "accumulate": [
            0,
            1
        ]
    },
    "grade": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "%"
    },
    "resistance": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "time_from_course": {
        "type": "sint32",
        "base_type": "sint32",
        "scale": 1000,
        "units": "s"
    },
    "cycle_length": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 100,
        "units": "m"
    },
    "temperature": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "C"
    },
    "speed_1s": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 16,
        "units": "m/s"
    },
    "cycles": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "cycles",
        "bits": 8,
        "accumulate": 1
    },
    "compressed_accumulated_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts",
        "bits": 16,
        "accumulate": 1
    },
    "accumulated_power": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "watts"
    },
    "vertical_speed": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 1000,
        "units": "m/s"
    },
    "calories": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "kcal"
    },
    "vertical_oscillation": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "mm"
    },
    "stance_time_percent": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "percent"
    },
    "stance_time": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "ms"
    },
    "activity_type": {
        "type": "activity_type",
        "base_type": "enum",
        "units": ""
    },
    "left_torque_effectiveness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "right_torque_effectiveness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "left_pedal_smoothness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "right_pedal_smoothness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "combined_pedal_smoothness": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "time128": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 128,
        "units": "s"
    },
    "stroke_type": {
        "type": "stroke_type",
        "base_type": "enum",
        "units": ""
    },
    "zone": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "ball_speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "m/s"
    },
    "cadence256": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 256,
        "units": "rpm"
    },
    "fractional_cadence": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 128,
        "units": "rpm"
    },
    "total_hemoglobin_conc": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "g/dL"
    },
    "total_hemoglobin_conc_min": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "g/dL"
    },
    "total_hemoglobin_conc_max": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "g/dL"
    },
    "saturated_hemoglobin_percent": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "%"
    },
    "saturated_hemoglobin_percent_min": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "%"
    },
    "saturated_hemoglobin_percent_max": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "%"
    },
    "device_index": {
        "type": "device_index",
        "base_type": "uint8",
        "units": ""
    },
    "left_pco": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "mm"
    },
    "right_pco": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "mm"
    },
    "left_power_phase": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "left_power_phase_peak": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "right_power_phase": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "right_power_phase_peak": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 0,
        "units": "degrees"
    },
    "enhanced_speed": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "m/s"
    },
    "enhanced_altitude": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 5,
        "offset": 500,
        "units": "m"
    },
    "battery_soc": {
        "type": "uint8",
        "base_type": "uint8",
        "scale": 2,
        "units": "percent"
    },
    "motor_power": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "watts"
    },
    "vertical_ratio": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "percent"
    },
    "stance_time_balance": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "percent"
    },
    "step_length": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10,
        "units": "mm"
    },
    "absolute_pressure": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "Pa"
    },
    "depth": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "m"
    },
    "next_stop_depth": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "m"
    },
    "next_stop_time": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1,
        "units": "s"
    },
    "time_to_surface": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1,
        "units": "s"
    },
    "ndl_time": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1,
        "units": "s"
    },
    "cns_load": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "percent"
    },
    "n2_load": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1,
        "units": "percent"
    },
    "grit": {
        "type": "float32",
        "base_type": "float32",
        "units": ""
    },
    "flow": {
        "type": "float32",
        "base_type": "float32",
        "units": ""
    },
    "ebike_travel_range": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "km"
    },
    "ebike_battery_level": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "percent"
    },
    "ebike_assist_mode": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "depends on sensor"
    },
    "ebike_assist_level_percent": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "percent"
    },
    "core_temperature": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "C"
    },
    "data16": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "",
        "bits": 16
    },
    "data": {
        "type": "uint32",
        "base_type": "uint32",
        "units": ""
    },
    "score": {
        "type": "float32",
        "base_type": "float32",
        "units": ""
    },
    "front_gear_num": {
        "type": "uint8z",
        "base_type": "uint8z",
        "units": ""
    },
    "front_gear": {
        "type": "uint8z",
        "base_type": "uint8z",
        "units": ""
    },
    "rear_gear_num": {
        "type": "uint8z",
        "base_type": "uint8z",
        "units": ""
    },
    "rear_gear": {
        "type": "uint8z",
        "base_type": "uint8z",
        "units": ""
    },
    "radar_threat_level_max": {
        "type": "radar_threat_level_type",
        "base_type": "enum",
        "units": ""
    },
    "radar_threat_count": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "device_type": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "cum_operating_time": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "s"
    },
    "battery_voltage": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 256,
        "units": "V"
    },
    "battery_status": {
        "type": "battery_status",
        "base_type": "uint8",
        "units": ""
    },
    "sensor_position": {
        "type": "body_location",
        "base_type": "enum",
        "units": ""
    },
    "descriptor": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "ant_transmission_type": {
        "type": "uint8z",
        "base_type": "uint8z",
        "units": ""
    },
    "ant_device_number": {
        "type": "uint16z",
        "base_type": "uint16z",
        "units": ""
    },
    "ant_network": {
        "type": "ant_network",
        "base_type": "enum",
        "units": ""
    },
    "source_type": {
        "type": "source_type",
        "base_type": "enum",
        "units": ""
    },
    "time": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "s",
        "invalid": 0xFFFF
    },
    "weather_report": {
        "type": "weather_report",
        "base_type": "enum",
        "units": ""
    },
    "condition": {
        "type": "weather_status",
        "base_type": "enum",
        "units": ""
    },
    "wind_direction": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "degrees"
    },
    "wind_speed": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 1000,
        "units": "m/s"
    },
    "precipitation_probability": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "temperature_feels_like": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "C"
    },
    "relative_humidity": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "location": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "observed_at_time": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "observed_location_lat": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "observed_location_long": {
        "type": "sint32",
        "base_type": "sint32",
        "units": "semicircles"
    },
    "day_of_week": {
        "type": "day_of_week",
        "base_type": "enum",
        "units": ""
    },
    "high_temperature": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "C"
    },
    "low_temperature": {
        "type": "sint8",
        "base_type": "sint8",
        "units": "C"
    },
    "report_id": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "issue_time": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "expire_time": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "severity": {
        "type": "weather_severity",
        "base_type": "enum",
        "units": ""
    },
    "heading": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 100,
        "units": "degrees"
    },
    "utc_timestamp": {
        "type": "date_time",
        "base_type": "uint32",
        "units": "s"
    },
    "velocity": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "m/s"
    },
    "camera_event_type": {
        "type": "camera_event_type",
        "base_type": "enum",
        "units": ""
    },
    "camera_file_uuid": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "camera_orientation": {
        "type": "camera_orientation_type",
        "base_type": "enum",
        "units": ""
    },
    "sample_time_offset": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "ms"
    },
    "gyro_x": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "gyro_y": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "gyro_z": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "calibrated_gyro_x": {
        "type": "float32",
        "base_type": "float32",
        "units": "deg/s"
    },
    "calibrated_gyro_y": {
        "type": "float32",
        "base_type": "float32",
        "units": "deg/s"
    },
    "calibrated_gyro_z": {
        "type": "float32",
        "base_type": "float32",
        "units": "deg/s"
    },
    "accel_x": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "accel_y": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "accel_z": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "calibrated_accel_x": {
        "type": "float32",
        "base_type": "float32",
        "units": "g"
    },
    "calibrated_accel_y": {
        "type": "float32",
        "base_type": "float32",
        "units": "g"
    },
    "calibrated_accel_z": {
        "type": "float32",
        "base_type": "float32",
        "units": "g"
    },
    "compressed_calibrated_accel_x": {
        "type": "sint16",
        "base_type": "sint16",
        "units": "mG"
    },
    "compressed_calibrated_accel_y": {
        "type": "sint16",
        "base_type": "sint16",
        "units": "mG"
    },
    "compressed_calibrated_accel_z": {
        "type": "sint16",
        "base_type": "sint16",
        "units": "mG"
    },
    "mag_x": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "mag_y": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "mag_z": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "counts"
    },
    "calibrated_mag_x": {
        "type": "float32",
        "base_type": "float32",
        "units": "G"
    },
    "calibrated_mag_y": {
        "type": "float32",
        "base_type": "float32",
        "units": "G"
    },
    "calibrated_mag_z": {
        "type": "float32",
        "base_type": "float32",
        "units": "G"
    },
    "baro_pres": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "Pa"
    },
    "sensor_type": {
        "type": "sensor_type",
        "base_type": "enum",
        "units": ""
    },
    "calibration_factor": {
        "type": "uint32",
        "base_type": "uint32",
        "units": ""
    },
    "calibration_divisor": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "counts"
    },
    "level_shift": {
        "type": "uint32",
        "base_type": "uint32",
        "units": ""
    },
    "offset_cal": {
        "type": "sint32",
        "base_type": "sint32",
        "units": ""
    },
    "orientation_matrix": {
        "type": "sint32",
        "base_type": "sint32",
        "scale": 65535,
        "units": ""
    },
    "frame_number": {
        "type": "uint32",
        "base_type": "uint32",
        "units": ""
    },
    "time_offset": {
        "type": "uint16",
        "base_type": "uint16",
        "units": "ms"
    },
    "pid": {
        "type": "byte",
        "base_type": "byte",
        "units": ""
    },
    "raw_data": {
        "type": "byte",
        "base_type": "byte",
        "units": ""
    },
    "pid_data_size": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "system_time": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "ms"
    },
    "start_timestamp": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "start_timestamp_ms": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "sentence": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "pitch": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 10430,
        "units": "radians"
    },
    "roll": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 10430,
        "units": "radians"
    },
    "accel_lateral": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "m/s^2"
    },
    "accel_normal": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 100,
        "units": "m/s^2"
    },
    "turn_rate": {
        "type": "sint16",
        "base_type": "sint16",
        "scale": 1024,
        "units": "radians/second"
    },
    "stage": {
        "type": "attitude_stage",
        "base_type": "enum",
        "units": ""
    },
    "attitude_stage_complete": {
        "type": "uint8",
        "base_type": "uint8",
        "units": "%"
    },
    "track": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 10430,
        "units": "radians"
    },
    "validity": {
        "type": "attitude_validity",
        "base_type": "uint16",
        "units": ""
    },
    "url": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "hosting_provider": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "duration": {
        "type": "uint32",
        "base_type": "uint32",
        "scale": 1000,
        "units": "s"
    },
    "message_count": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "text": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "clip_number": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "end_timestamp": {
        "type": "date_time",
        "base_type": "uint32",
        "units": ""
    },
    "end_timestamp_ms": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "clip_start": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "ms"
    },
    "clip_end": {
        "type": "uint32",
        "base_type": "uint32",
        "units": "ms"
    },
    "repetitions": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "weight": {
        "type": "uint16",
        "base_type": "uint16",
        "scale": 16,
        "units": "kg"
    },
    "set_type": {
        "type": "set_type",
        "base_type": "uint8",
        "units": ""
    },
    "category": {
        "type": "exercise_category",
        "base_type": "uint16",
        "units": ""
    },
    "category_subtype": {
        "type": "uint16",
        "base_type": "uint16",
        "units": ""
    },
    "weight_display_unit": {
        "type": "fit_base_unit",
        "base_type": "uint16",
        "units": ""
    },
    "height": {
        "type": "float32",
        "base_type": "float32",
        "units": "m"
    },
    "rotations": {
        "type": "uint8",
        "base_type": "uint8",
        "units": ""
    },
    "hang_time": {
        "type": "float32",
        "base_type": "float32",
        "units": "s"
    },
    "name": {
        "type": "string",
        "base_type": "string",
        "units": ""
    },
    "capabilities": {
        "type": "course_capabilities",
        "base_type": "uint32z",
        "units": ""
    },
    "favorite": {
        "type": "bool",
        "base_type": "bool",
        "units": ""
    }
};


function $c36558e913c23625$export$81390f6fcd635188(args = {}) {
    // merge product types, messages, and fields with the global ones
    const types = (0, $8464fac654ea63e2$export$2e2bcd8739ae039);
    const messages = (0, $848d20dca154f858$export$2e2bcd8739ae039);
    const fields = (0, $7c197b9264f7b9ee$export$2e2bcd8739ae039);
    // methods
    function numberToMessageName(number) {
        return types['mesg_num'].values[number.toString()] ?? `message_${number}`;
    }
    // String -> Field{}
    function Field(name) {
        return {
            name: name,
            ...fields[name] ?? {}
        };
    }
    // Int -> Field{
    //     name: String,
    //     type: String,
    //     base_type: BaseType,
    //     units: String,
    //     scale: Int,
    //     offset: Int,
    //     bits: Int,
    //     accumulate: String
    // }
    function numberToField(messageName, fieldNumber) {
        const message = messages[messageName];
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(message)) return Field(`field_${fieldNumber}`);
        const messageFields = message.fields;
        for(let fieldName in messageFields){
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(messageFields[fieldName], fieldNumber)) return Field(fieldName);
        }
        return Field(`field_${fieldNumber}`);
    }
    function messageNameToNumber(name) {
        return types.mesg_num.values[name] ?? 0xFFFF;
    }
    // String -> GlobalFieldDefinition{}
    function fieldNameToField(fieldName) {
        return fields[fieldName];
    }
    function fieldNameToNumber(messageName, fieldName) {
        return messages[messageName].fields[fieldName];
    }
    function fieldNameToSize(name) {
        return (0, $2c445aecb1469f67$export$c40f74f6a9873fff)[fields[name].base_type].size;
    }
    function fieldNameToBaseType(name) {
        return fields[name].base_type;
    }
    function baseTypeToSize(base_type) {
        return (0, $2c445aecb1469f67$export$c40f74f6a9873fff)[base_type].size;
    }
    return Object.freeze({
        BaseType: $2c445aecb1469f67$export$716a6faa393fdf39,
        BaseTypeDefinitions: $2c445aecb1469f67$export$c40f74f6a9873fff,
        types: types,
        messages: messages,
        fields: fields,
        numberToMessageName: numberToMessageName,
        messageNameToNumber: messageNameToNumber,
        numberToField: numberToField,
        fieldNameToField: fieldNameToField,
        fieldNameToNumber: fieldNameToNumber,
        fieldNameToSize: fieldNameToSize,
        fieldNameToBaseType: fieldNameToBaseType,
        baseTypeToSize: baseTypeToSize
    });
}
function $c36558e913c23625$var$toDualKeyMap(source, first_key, second_key) {
    return source.reduce(function(acc, sourceItem) {
        acc.set(sourceItem[first_key], sourceItem);
        acc.set(sourceItem[second_key], sourceItem);
        return acc;
    }, new Map());
}
const $c36558e913c23625$export$63dc120dff6c5db8 = $c36558e913c23625$export$81390f6fcd635188();


function $9c7d4c513424b120$var$FieldDefinition(args = {}) {
    const architecture = args.architecture ?? true;
    const length = 3;
    const numberIndex = (offset = 0)=>offset + 0;
    const sizeIndex = (offset = 0)=>offset + 1;
    const baseTypeIndex = (offset = 0)=>offset + 2;
    // {number: Int, size: Int, base_type: BaseType}
    // DataView,
    // Int,
    // -> DataView
    function encode(definition, view, i = 0) {
        const base_type_number = (0, $c36558e913c23625$export$63dc120dff6c5db8).BaseType[definition.base_type];
        view.setUint8(numberIndex(i), definition.number, architecture);
        view.setUint8(sizeIndex(i), definition.size, architecture);
        view.setUint8(baseTypeIndex(i), base_type_number, architecture);
        return view;
    }
    // String
    // DataView,
    // Int,
    // ->
    // {number: Int, size: Int, base_type: BaseType}
    function decode(messageName, view, i = 0) {
        const number = view.getUint8(numberIndex(i), architecture);
        const size = view.getUint8(sizeIndex(i), architecture);
        const base_type_number = view.getUint8(baseTypeIndex(i), architecture);
        const base_type = (0, $c36558e913c23625$export$63dc120dff6c5db8).BaseType[base_type_number.toString()];
        return {
            number: number,
            size: size,
            base_type: base_type
        };
    }
    return Object.freeze({
        length: length,
        numberIndex: numberIndex,
        sizeIndex: sizeIndex,
        baseTypeIndex: baseTypeIndex,
        encode: encode,
        decode: decode
    });
}
const $9c7d4c513424b120$export$213399610e994e5 = $9c7d4c513424b120$var$FieldDefinition();







function $289488a9833edc78$export$4589e51d25f40a74(args = {}) {
    const _type = (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition;
    const headerSize = (0, $483b10c4679c37af$export$a29c13bd16217000).size;
    const fixedContentLength = 6;
    const fieldLength = 3;
    const architecture = args.architecture ?? true ? 0 : 1;
    const numberOfFieldsIndex = 5;
    function numberToMessageName(number) {
        return (0, $c36558e913c23625$export$63dc120dff6c5db8).numberToMessageName(number);
    }
    function messageNameToNumber(messageName) {
        return (0, $c36558e913c23625$export$63dc120dff6c5db8).messageNameToNumber(messageName);
    }
    function getDefinitionRecordLength(view, start = 0) {
        const numberOfFields = readNumberOfFields(view, start);
        const numberOfDevFields = readNumberOfDevFields(view, start);
        return fixedContentLength + numberOfFields * fieldLength + (numberOfDevFields > 0 ? 1 : 0) + numberOfDevFields * fieldLength;
    }
    function getDataRecordLength(fields) {
        return headerSize + fields.reduce((acc, x)=>acc + x.size, 0);
    }
    function readNumberOfFields(view, start = 0) {
        return view.getUint8(start + numberOfFieldsIndex, true);
    }
    function readNumberOfDevFields(view, start = 0) {
        const header = (0, $483b10c4679c37af$export$a29c13bd16217000).decode(view.getUint8(start, true));
        if ((0, $483b10c4679c37af$export$a29c13bd16217000).isDeveloper(header)) {
            const numberOfFields = readNumberOfFields(view, start);
            const index = start + fixedContentLength + numberOfFields * fieldLength;
            return view.getUint8(index, true);
        }
        return 0;
    }
    // {
    //     type: RecordType,
    //     name: String,
    //     local_number: Int,
    //     architecture: Int,
    //     length: Int,
    //     data_record_length: Int,
    //     fields: [{number: Int, size: Int, base_type: BaseType}]
    //     dev_fields?: [{number: Int, size: Int, base_type: BaseType}]?
    // }
    // -> DataView
    function encode(definition, view, i = 0) {
        const header = (0, $483b10c4679c37af$export$a29c13bd16217000).encode({
            messageType: _type,
            localMessageType: definition.local_number
        });
        const numberOfFields = definition.fields.length;
        const globalNumber = messageNameToNumber(definition.name);
        const length = fixedContentLength + numberOfFields * fieldLength;
        view.setUint8(i + 0, header, true);
        view.setUint8(i + 1, 0, true);
        view.setUint8(i + 2, architecture, true);
        view.setUint16(i + 3, globalNumber, true);
        view.setUint8(i + 5, numberOfFields, true);
        i += fixedContentLength;
        definition.fields.forEach((field)=>{
            (0, $9c7d4c513424b120$export$213399610e994e5).encode(field, view, i);
            i += fieldLength;
        });
        // TODO:
        // if developer fields are defined
        // write # developer fields
        // write developer fields definitions
        if ('dev_fields' in definition) {
            const numberOfDeveloperFields = definition.dev_fields.length;
            view.setUint8(i, numberOfDeveloperFields, true);
            i += 1;
            definition.dev_fields.forEach((field)=>{
                (0, $9c7d4c513424b120$export$213399610e994e5).encode(field, view, i);
                i += fieldLength;
            });
        }
        return view;
    }
    // DataView,
    // Int
    // ->
    // {
    //     type: RecordType
    //     name: String,
    //     architecture: Int,
    //     local_number: Int,
    //     length: Int,
    //     data_record_length: Int,
    //     fields:      [{number: Int, size: Int, base_type: BaseTypes}],
    //     dev_fields?: [{number: Int, size: Int, base_type: BaseTypes}]?
    // }
    function decode(view, start = 0) {
        const header = (0, $483b10c4679c37af$export$a29c13bd16217000).decode(view.getUint8(start, true));
        const local_number = header.localMessageType;
        const architecture = view.getUint8(start + 2, true);
        const littleEndian = !architecture;
        const messageNumber = view.getUint16(start + 3, littleEndian);
        const messageName = numberToMessageName(messageNumber);
        const numberOfFields = readNumberOfFields(view, start);
        const numberOfDevFields = readNumberOfDevFields(view, start);
        // i  is the dataview index
        // f  is the current field index
        // df is the current developer field index
        let i = start + fixedContentLength;
        let fields = [];
        for(let f = 0; f < numberOfFields; f++){
            fields.push((0, $9c7d4c513424b120$export$213399610e994e5).decode(messageName, view, i));
            i += fieldLength;
        }
        i += 1; // add the 'number of dev fields' field
        let dev_fields = [];
        for(let df = 0; df < numberOfDevFields; df++){
            dev_fields.push((0, $9c7d4c513424b120$export$213399610e994e5).decode(messageName, view, i));
            i += fieldLength;
        }
        const length = getDefinitionRecordLength(view, start);
        const data_record_length = getDataRecordLength(fields.concat(dev_fields));
        return {
            type: _type,
            architecture: architecture,
            name: messageName,
            local_number: local_number,
            length: length,
            data_record_length: data_record_length,
            fields: fields,
            dev_fields: dev_fields
        };
    }
    // ['message_name', ['field_name'], Int] |
    // ['message_name', [['field_name', Int]], Int]
    // ->
    // {
    //     type: RecordType
    //     architecture: Int,
    //     name: String,
    //     local_number: Int,
    //     length: Int,
    //     data_record_length: Int,
    //     fields: [{number: Int, size: Int, base_type: base_type}]
    // }
    function toFITjs(productMessageDefinition = [
        '',
        []
    ]) {
        const messageName = (0, $c6a9e46ee7e4d896$export$6f6258299a22298a)(0, productMessageDefinition);
        const fields = (0, $c6a9e46ee7e4d896$export$6f6258299a22298a)(1, productMessageDefinition);
        // const fieldNames     = fields;
        const local_number = (0, $c6a9e46ee7e4d896$export$6f6258299a22298a)(2, productMessageDefinition);
        const numberOfFields = fields.length;
        const length = fixedContentLength + numberOfFields * fieldLength;
        return fields.reduce(function(acc, field) {
            const name = (0, $c6a9e46ee7e4d896$export$43bee75e5e14138e)(field) ? field[0] : field;
            const number = (0, $c36558e913c23625$export$63dc120dff6c5db8).fieldNameToNumber(messageName, name);
            const size = (0, $c6a9e46ee7e4d896$export$43bee75e5e14138e)(field) ? field[1] : (0, $c36558e913c23625$export$63dc120dff6c5db8).fieldNameToSize(name);
            const base_type = (0, $c36558e913c23625$export$63dc120dff6c5db8).fieldNameToBaseType(name);
            acc.data_record_length += size;
            acc.fields.push({
                number: number,
                size: size,
                base_type: base_type
            });
            return acc;
        }, {
            type: _type,
            architecture: architecture,
            name: messageName,
            local_number: local_number,
            length: length,
            data_record_length: 1,
            fields: [],
            dev_fields: []
        });
    }
    return Object.freeze({
        getDefinitionRecordLength: getDefinitionRecordLength,
        getDataRecordLength: getDataRecordLength,
        encode: encode,
        decode: decode,
        toFITjs: toFITjs
    });
}
const $289488a9833edc78$export$2213eed9e2fb2d05 = $289488a9833edc78$export$4589e51d25f40a74();







function $7460ce66a5541d7b$export$ba30ea40049bd308(args = {}) {
    const architecture = args.architecture ?? true;
    const _type = (0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).data;
    const recordHeaderSize = (0, $483b10c4679c37af$export$a29c13bd16217000).size;
    // {
    //     type: RecordType
    //     architecture: Int,
    //     name: String,
    //     local_number: Int,
    //     length: Int,
    //     data_record_length: Int,
    //     fields: [{number: Int, size: Int, base_type: BaseType}]
    // },
    // {fields: {field_name: Any}} | {field_name: Any},
    // DataView,
    // Int
    // ->
    // DataView
    function encode(definition, data, view, start = 0) {
        const architecture = definition.architecture ?? 0;
        const endian = !architecture; // arch wierdness?
        if (!('fields' in data)) data = {
            fields: data
        };
        const header = (0, $483b10c4679c37af$export$a29c13bd16217000).encode({
            messageType: _type,
            localMessageType: definition.local_number
        });
        view.setUint8(start, header, true);
        return definition.fields.reduce(function(acc, field) {
            const _field = (0, $c36558e913c23625$export$63dc120dff6c5db8).numberToField(definition.name, field.number);
            const value = data.fields[_field.name];
            const size = field.size;
            const base_type_size = (0, $c36558e913c23625$export$63dc120dff6c5db8).baseTypeToSize(field.base_type);
            if ((0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).string.isString(field.base_type)) // string
            (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).string.encode(field, value, view, acc.i, endian);
            else if (size > base_type_size) // array
            for(let j = 0, k = 0; j < size; j += base_type_size, k += 1)(0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).number.encode(_field, value[k], view, acc.i + j, endian, value % 0xFF === 0);
            else if ((0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.isTimestamp(_field.type)) // timestamp
            (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.encode(field, value, view, acc.i, endian);
            else // number
            (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).number.encode(_field, value, view, acc.i, endian);
            acc.i += field.size;
            return acc;
        }, {
            view: view,
            i: start + recordHeaderSize
        }).view;
    }
    // {
    //     type: RecordType
    //     architecture: Int,
    //     name: String,
    //     local_number: Int,
    //     length: Int,
    //     data_record_length: Int,
    //     fields: [{number: Int, size: Int, base_type: base_type}]
    // }
    // DataView,
    // Int
    // ->
    // {
    //     type: RecordType,
    //     name: String,
    //     local_number: Int,
    //     length: Int,
    //     fields: {field_name: Any,}
    // }
    function decode(definition, view, start = 0) {
        const header = (0, $483b10c4679c37af$export$a29c13bd16217000).decode(view.getUint8(start, true));
        const local_number = header.localMessageType;
        const name = definition.name;
        const architecture = definition.architecture;
        const endian = !architecture;
        const length = definition.data_record_length;
        return {
            type: _type,
            name: name,
            local_number: local_number,
            length: length,
            fields: definition.fields.reduce(function(acc, field) {
                const _field = (0, $c36558e913c23625$export$63dc120dff6c5db8).numberToField(definition.name, field.number);
                const size = field.size;
                const base_type_size = (0, $c36558e913c23625$export$63dc120dff6c5db8).baseTypeToSize(field.base_type);
                let value;
                if ((0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).string.isString(field.base_type)) // string
                value = (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).string.decode(field, view, acc.i, endian);
                else if (size > base_type_size) {
                    // array
                    value = [];
                    for(let j = 0; j < size; j += base_type_size){
                        const v = (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).number.decode(_field, view, acc.i + j, endian);
                        value.push(v);
                    }
                } else if ((0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.isTimestamp(_field.type)) // timestamp
                value = (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.decode(field, view, acc.i, endian);
                else // number
                value = (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).number.decode(_field, view, acc.i, endian);
                acc.fields[_field.name] = value;
                acc.i += field.size;
                return acc;
            }, {
                fields: {},
                i: start + recordHeaderSize
            }).fields
        };
    }
    function toFITjs(definition, values) {
        // if(!equals(definition.length, values.length)) {
        //     const msg = `DataRecord.toFITjs called with missing values for message: '${definition.name}'`;
        //     console.warn(`fit: error: '${msg}'`, values, definition.fields);
        // }
        return {
            type: _type,
            name: definition.name,
            local_number: definition.local_number,
            length: definition.data_record_length,
            fields: values
        };
    }
    return Object.freeze({
        type: _type,
        decode: decode,
        encode: encode,
        toFITjs: toFITjs
    });
}
const $7460ce66a5541d7b$export$2229092a8062126f = $7460ce66a5541d7b$export$ba30ea40049bd308();



//
// FITjs
//







function $b5d329ebd4e916e2$export$db7ba7d96dae0074() {
    function isHeader(record) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).header, record.type);
    }
    function isDefinition(record) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).definition, record.type);
    }
    function isData(record) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).data, record.type);
    }
    function isCRC(record) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $46e0b5f74a2a4c34$export$2edcab8dd1869daa).crc, record.type);
    }
    const definitions = {};
    // RecordJS, Value{}, DataView, Int -> DataView
    function encode(recordJS, view, i = 0) {
        if (isHeader(recordJS)) return (0, $ed88c44bd8f99c46$export$97013678e68d80d7).encode(recordJS, view, i);
        if (isDefinition(recordJS)) {
            definitions[recordJS.name] = recordJS;
            return (0, $289488a9833edc78$export$2213eed9e2fb2d05).encode(recordJS, view, i);
        }
        if (isData(recordJS)) {
            const definition = definitions[recordJS.name];
            return (0, $7460ce66a5541d7b$export$2229092a8062126f).encode(definition, recordJS, view, i);
        }
        if (isCRC(recordJS)) {
            const crc = (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).calculateCRC(view, 0, i - 1);
            return (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).encode(crc, view, i);
        }
        console.warn(`Unknown RecordType ${recordJS.type}`, recordJS);
        return view;
    }
    // DataView, Int, Map, Bool -> FitRecord
    function decode(view, i = 0, definitions = new Map(), unfinished = false) {
        const header = (0, $483b10c4679c37af$export$a29c13bd16217000).decode(view.getUint8(i, true));
        if (i > view.byteLength) return {};
        unfinished;
        if ((0, $5d332605c5db3f98$export$5be0c4d7d8d17551).isCRC(view, i)) return (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).decode(view, i);
        if ((0, $ed88c44bd8f99c46$export$97013678e68d80d7).isFileHeader(view, i)) {
            const fileHeaderJS = (0, $ed88c44bd8f99c46$export$97013678e68d80d7).decode(view, i);
            const byteLength = view.byteLength;
            const dataSize = fileHeaderJS.dataSize;
            const headerLength = fileHeaderJS.length;
            unfinished = byteLength !== dataSize + headerLength + (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).size;
            console.log(`:fit :decode :headerLength ${headerLength} :dataSize ${dataSize} :byteLength ${byteLength} :unfinished ${unfinished}`);
            return fileHeaderJS;
        }
        if ((0, $483b10c4679c37af$export$a29c13bd16217000).isDefinition(header)) {
            const definition = (0, $289488a9833edc78$export$2213eed9e2fb2d05).decode(view, i);
            definitions.set(header.localMessageType, definition);
            return definition;
        }
        if ((0, $483b10c4679c37af$export$a29c13bd16217000).isData(header)) {
            const definition = definitions.get(header.localMessageType);
            return (0, $7460ce66a5541d7b$export$2229092a8062126f).decode(definition, view, i);
        }
        return {};
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $b5d329ebd4e916e2$var$FITjsParser() {
    // const fitRecord = FitRecord();
    // [FITjs] -> Dataview
    function encode(fitJS) {
        const header = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(fitJS);
        const dataSize = header.dataSize;
        const viewSize = header.dataSize + header.length + (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).size;
        const view = new DataView(new Uint8Array(viewSize).buffer);
        fitJS.reduce(function(acc, recordJS) {
            if (acc.i + recordJS.length > viewSize) {
                console.log(`LocalActivity encode view size error: ${viewSize}/${acc.i}, ${recordJS.name}:${recordJS.length}`);
                return acc;
            }
            $b5d329ebd4e916e2$export$2c27b3c3de66209b.encode(recordJS, acc.view, acc.i);
            acc.i += recordJS.length;
            return acc;
        }, {
            view: view,
            i: 0
        });
        return view;
    }
    // Dataview -> [FITjs]
    function decode(dataview) {
        // Note:
        // - RGT uses the same local_number 0 for all definitions
        // - Zwift often produces unfinished files with broken file headers
        // config
        const architecture = true;
        // end config
        const byteLength = dataview.byteLength;
        // state
        let i = 0;
        let records = [];
        let record;
        let definitions = new Map();
        // end state
        while(i < byteLength)try {
            record = $b5d329ebd4e916e2$export$2c27b3c3de66209b.decode(dataview, i, definitions);
            records.push(record);
            // console.log(`${i} + ${record?.length ?? 0} `, record);
            i += record?.length ?? 0;
        } catch (e) {
            console.error(`:fit :decode :at ${i}/${byteLength} `, e);
            break;
        }
        return records;
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
const $b5d329ebd4e916e2$export$2c27b3c3de66209b = $b5d329ebd4e916e2$export$db7ba7d96dae0074();
const $b5d329ebd4e916e2$export$c804b577b4b7396a = $b5d329ebd4e916e2$var$FITjsParser();


//
// Local Activity Encoder
//


//
// Product/App Message Definitions
//
// this is the subset of definitions of messages and message fields
// that the product/app fit file encoder whats to use
const $e6100ff4db802773$var$productMessageDefinitions = [
    [
        'file_id',
        [
            'time_created',
            'manufacturer',
            'product',
            'serial_number',
            'number',
            'type'
        ],
        0
    ],
    [
        'file_creator',
        [
            'software_version'
        ],
        1
    ],
    [
        'event',
        [
            'timestamp',
            'event',
            'event_type',
            'event_group'
        ],
        2
    ],
    [
        'record',
        [
            'timestamp',
            'position_lat',
            'position_long',
            'altitude',
            'heart_rate',
            'cadence',
            'distance',
            'speed',
            'power',
            'grade',
            'device_index',
            'total_hemoglobin_conc',
            'saturated_hemoglobin_percent',
            'core_temperature'
        ],
        3
    ],
    [
        'hrv',
        [
            [
                'time',
                10
            ]
        ],
        4
    ],
    [
        'lap',
        [
            'timestamp',
            'start_time',
            'total_elapsed_time',
            'total_timer_time',
            'message_index',
            'event',
            'event_type'
        ],
        5
    ],
    [
        'session',
        [
            'timestamp',
            'start_time',
            'total_elapsed_time',
            'total_timer_time',
            'message_index',
            'sport',
            'sub_sport',
            'total_distance',
            'total_calories',
            'avg_speed',
            'max_speed',
            'avg_heart_rate',
            'max_heart_rate',
            'avg_cadence',
            'max_cadence',
            'avg_power',
            'max_power',
            'first_lap_index',
            'num_laps',
            'threshold_power'
        ],
        6
    ],
    [
        'activity',
        [
            'timestamp',
            'total_timer_time',
            'num_sessions',
            'type',
            'event',
            'event_type'
        ],
        7
    ],
    [
        'course',
        [
            'name'
        ],
        8
    ]
];
var $e6100ff4db802773$export$2e2bcd8739ae039 = $e6100ff4db802773$var$productMessageDefinitions;








const $9a46339c5268bef7$export$b43e4c66e7bb1fc7 = {
    stopped: 'stopped',
    started: 'started',
    paused: 'paused',
    resumed: 'resumed'
};
const $9a46339c5268bef7$export$facc1793bb74246d = {
    start: 'start',
    stop: 'stop',
    pause: 'pause'
};
const $9a46339c5268bef7$export$3d7865934588d77e = {
    start: 'start',
    stop: 'stop'
};


function $83ad487acde36489$var$LocalActivity(args = {}) {
    const definitions = (0, $e6100ff4db802773$export$2e2bcd8739ae039).reduce(function(acc, x) {
        const d = (0, $289488a9833edc78$export$2213eed9e2fb2d05).toFITjs(x);
        acc[d.name] = d;
        return acc;
    }, {});
    // [FITjs] -> {fileSize: Int, dataSize: Int}
    function getSize(fitjs) {
        // byteLength of the whole file start to end
        // this is needed for the DataView size
        const fileSize = fitjs.reduce((acc, x)=>acc += x?.length ?? 0, 0);
        // byteLength of the file minus the File Header and the CRC
        // this is needed for the dataSize field in the file header
        const header = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(fitjs);
        const dataSize = fileSize - (header.length + (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).size);
        return {
            fileSize: fileSize,
            dataSize: dataSize
        };
    }
    // [Record] -> Record?
    function findFirstRecord(records = []) {
        for(let i = 0; i < records.length; i += 1){
            if (records[i].timestamp !== undefined) return records[i];
        }
        console.error(`:fit :records 'has no valid records'`);
        return records[0];
    }
    // [Record] -> Record?
    function findLastRecord(records = []) {
        for(let i = records.length - 1; i >= 0; i -= 1){
            if (records[i].timestamp !== undefined) return records[i];
        }
        console.error(`:fit :records 'has no valid records'`);
        return records[0];
    }
    // {records: [Record], events: [Event]} -> Int
    function calcTotalTimerTime(args) {
        const records = args.records ?? [];
        const events = args.events ?? [];
        // fallbacks
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(events)) {
            if (records.length > 1) // if no events are recorded fallback to first and last record
            return (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.elapsed(// TODO: handle record is not guaranteed to be a Record
            findFirstRecord(records)?.timestamp, findLastRecord(records)?.timestamp);
            else {
                // if no events are recorded and no more than one record return 0
                console.warn(`fit: calcTotalTimerTime: 'not enough records'`);
                return 0;
            }
        }
        // sum the difference between start and stop event pairs
        return events.reduce(function(acc, event, i) {
            if (event.type === (0, $9a46339c5268bef7$export$3d7865934588d77e).stop) {
                const startEvent = events[i - 1] ?? undefined;
                if (startEvent?.type === (0, $9a46339c5268bef7$export$3d7865934588d77e).start) // all good
                acc += (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.elapsed(startEvent?.timestamp, event?.timestamp);
                else // we are at a stop event, but the prev event is not start
                console.warn(`fit: calcTotalTimerTime: 'invalid event order'`);
                return acc;
            }
            return acc;
        }, 0);
    }
    // {records: [Record], laps: [Lap], events: [Event], } -> Int
    function calcTotalElapsedTime(args) {
        const records = args.records ?? [];
        const laps = args.laps ?? [];
        const events = args.events ?? [];
        if (records.length < 2) {
            console.warn(`fit: calcTotalElapsedTime: 'not enough records'`);
            return 0;
        }
        const start_time = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(events)?.timestamp ?? findFirstRecord(records)?.timestamp;
        const timestamp = (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(laps)?.timestamp ?? findLastRecord(records)?.timestamp;
        return (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.elapsed(start_time, timestamp);
    }
    // {
    //     timestamp: Int,
    //     start_time: Int,
    //     totalElapsedTime: Int,
    //     avgPower: Int,
    //     maxPower: Int,
    //     avgCadence: Double,
    //     avgHeartRate: Double,
    //     saturated_hemoglobin_percent: Double,
    //     total_hemoglobin_conc: Double,
    //     core_temperature: Double,
    //     skin_temperature: Double
    // },
    // [{ timestamp: Int, type: EventType, }]
    // ->
    // Int
    function calcLapTotalTimerTime(lap, events) {
        const _lap = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(lap, `calcLapTotalTimerTime needs lap: Lap.`);
        const _events = events ?? [];
        const pausedTime = _events.reduce(function(acc, event, i) {
            if (event.timestamp >= _lap.start_time && event.timestamp <= _lap.timestamp && event.type === (0, $9a46339c5268bef7$export$3d7865934588d77e).stop) {
                // continue only if the event overlaps with the lap
                const startEvent = _events[i + 1] ?? {
                    timestamp: _lap.timestamp
                };
                const stopEvent = event;
                let startTime = stopEvent.timestamp;
                let endTime = startEvent.timestamp;
                if (endTime > _lap.timestamp) // clamp to lap start and end times
                endTime = _lap.timestamp;
                acc += (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.elapsed(startTime, endTime);
            }
            return acc;
        }, 0);
        const elapsedTime = calcLapTotalElapsedTime(lap);
        return elapsedTime - Math.max(0, Math.min(pausedTime, elapsedTime));
    }
    // {
    //     timestamp: Int,
    //     start_time: Int,
    //     totalElapsedTime: Int,
    //     avgPower: Int,
    //     maxPower: Int,
    //     avgCadence: Double,
    //     avgHeartRate: Double,
    //     saturated_hemoglobin_percent: Double,
    //     total_hemoglobin_conc: Double,
    //     core_temperature: Double,
    //     skin_temperature: Double
    // },
    // ->
    // Int
    function calcLapTotalElapsedTime(lap) {
        return (0, $46e0b5f74a2a4c34$export$bf9fb029d174d554).timestamp.elapsed(lap.start_time, lap.timestamp);
    }
    // {records: [Record], total_timer_time: Int}
    // ->
    // Stats
    function calcStats(args = {}) {
        const records = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.records, `fit: calcStats: needs records: []`);
        const total_timer_time = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.total_timer_time, `fit: calcStats: needs total_timer_tim: Int`);
        const defaultStats = {
            avg_power: 0,
            avg_cadence: 0,
            avg_speed: 0,
            avg_heart_rate: 0,
            max_power: 0,
            max_cadence: 0,
            max_speed: 0,
            max_heart_rate: 0,
            total_distance: findLastRecord(records)?.distance ?? 0,
            total_calories: 0
        };
        const stats = records.filter((record)=>record.timestamp !== undefined).reduce(function(acc, record, _, { length: length }) {
            acc.avg_power += record.power / length;
            acc.avg_cadence += record.cadence / length;
            acc.avg_speed += record.speed / length;
            acc.avg_heart_rate += record.heart_rate / length;
            if (record.power > acc.max_power) acc.max_power = record.power;
            if (record.cadence > acc.max_cadence) acc.max_cadence = record.cadence;
            if (record.speed > acc.max_speed) acc.max_speed = record.speed;
            if (record.heart_rate > acc.max_heart_rate) acc.max_heart_rate = record.heart_rate;
            return acc;
        }, defaultStats);
        stats.total_calories = Math.floor(stats.avg_power * total_timer_time * 0.001);
        stats.avg_power = Math.floor(stats.avg_power);
        stats.avg_cadence = Math.floor(stats.avg_cadence);
        stats.avg_heart_rate = Math.floor(stats.avg_heart_rate);
        return stats;
    }
    function timestampToDate(x) {
        const timeKeys = [
            'time_created',
            'start_time',
            'timestamp'
        ];
        for (let timeKey of timeKeys)if (x[timeKey]) x[timeKey] = new Date(x[timeKey]);
        return x;
    }
    function printAppData(records, laps, events) {
        const _records = window.structuredClone(records);
        const _laps = window.structuredClone(laps);
        const _events = window.structuredClone(events);
        console.log('----');
        console.log('records');
        console.log(_records.map(timestampToDate));
        // console.log(records);
        console.log('laps');
        console.log(_laps.map(timestampToDate));
        // console.log(laps);
        console.log('events');
        console.log(_events.map(timestampToDate));
        // console.log(events);
        console.log('----');
    }
    function printFITjs(structure) {
        const select = [
            'record',
            'event',
            'lap',
            'session',
            'activity'
        ];
        console.log('----');
        const _structure = window.structuredClone(structure);
        const _filtered = [];
        for (let record of _structure)if (record.type === "data") {
            if (record.fields) timestampToDate(record.fields);
            if (select.includes(record.name)) _filtered.push(record);
        }
        console.log(_filtered);
        console.log('----');
    }
    // {records: [{<field>: Any}], laps: [{<field>: Any}]}
    // ->
    // [FITjs]
    function toFITjs(args = {}) {
        const records = args.records ?? [];
        const laps = args.laps ?? [];
        const events = args.events ?? [];
        const ftp = args.ftp ?? 200;
        // printAppData(records, laps, events);
        const activity_start_time = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(events)?.start_time ?? findFirstRecord(records).timestamp;
        const time_created = (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(laps)?.timestamp ?? findLastRecord(records)?.timestamp;
        const timestamp = time_created;
        const total_elapsed_time = calcTotalElapsedTime({
            records: records,
            laps: laps,
            events: events
        });
        const total_timer_time = calcTotalTimerTime({
            records: records,
            events: events
        });
        const stats = calcStats({
            records: records,
            total_timer_time: total_timer_time
        });
        // structure: FITjs
        const structure = [
            // file header
            $83ad487acde36489$var$FileHeader(),
            // definition file_id
            definitions.file_id,
            // data file_id
            (0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(definitions.file_id, $83ad487acde36489$export$ea384f17a79d215a({
                time_created: time_created,
                manufacturer: 1,
                // garmin
                product: 3570,
                // edge 1030
                serial_number: 3313379353
            })),
            // definition file_creator
            definitions.file_creator,
            // data file_creator
            (0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(definitions.file_creator, $83ad487acde36489$var$FileCreator({
                software_version: 29 // edge 1030
            })),
            // definition record
            definitions.record,
            // definition hrv
            definitions.hrv,
            // data record messages
            ...records.map((record)=>(0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(record.time === undefined ? definitions.record : definitions.hrv, record)),
            // definition events
            definitions.event,
            // data event messages
            ...events.map((event)=>(0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(definitions.event, $83ad487acde36489$export$d61e24a684f9e51(event))),
            // definition lap
            definitions.lap,
            // data lap messages
            ...laps.map((lap, message_index)=>(0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(definitions.lap, $83ad487acde36489$export$c869d9dacc97131c({
                    total_elapsed_time: calcLapTotalElapsedTime(lap),
                    total_timer_time: calcLapTotalTimerTime(lap, events),
                    message_index: message_index,
                    ...lap
                }))),
            // definition session
            definitions.session,
            // data session
            (0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(definitions.session, $83ad487acde36489$export$1fb4852a55678982({
                records: records,
                laps: laps,
                events: events,
                definition: definitions.session,
                start_time: activity_start_time,
                timestamp: timestamp,
                total_elapsed_time: total_elapsed_time,
                total_timer_time: total_timer_time,
                stats: stats,
                threshold_power: ftp
            })),
            // definition activity
            definitions.activity,
            // data activity
            (0, $7460ce66a5541d7b$export$2229092a8062126f).toFITjs(definitions.activity, $83ad487acde36489$export$9c16c1426311996d({
                timestamp: timestamp,
                activity_start_time: activity_start_time,
                total_elapsed_time: total_elapsed_time,
                total_timer_time: total_timer_time
            })),
            // crc, needs to be computed last evetytime when encoding to binary
            (0, $5d332605c5db3f98$export$5be0c4d7d8d17551).toFITjs()
        ];
        const header = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(structure);
        header.dataSize = getSize(structure).dataSize;
        // printFITjs(structure);
        return structure;
    }
    // {records: [{<field>: Any}], laps: [{<field>: Any}]}
    // -> Dataview
    function encode(args = {}) {
        const fitjs = toFITjs(args);
        return (0, $b5d329ebd4e916e2$export$c804b577b4b7396a).encode(fitjs);
    }
    return Object.freeze({
        toFITjs: toFITjs,
        encode: encode
    });
}
// Special Data Messages
function $83ad487acde36489$var$FileHeader() {
    return (0, $ed88c44bd8f99c46$export$97013678e68d80d7).toFITjs();
}
function $83ad487acde36489$export$ea384f17a79d215a(args = {}) {
    return {
        time_created: args.time_created ?? Date.now(),
        manufacturer: args.manufacturer ?? 255,
        product: args.product ?? 0,
        serial_number: args.serial_number ?? 0,
        number: 0,
        type: 4
    };
}
function $83ad487acde36489$var$FileCreator(args = {}) {
    return {
        software_version: args.software_version ?? 0
    };
}
function $83ad487acde36489$export$d61e24a684f9e51(args = {}) {
    return {
        timestamp: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.timestamp, 'Event needs timestamp.'),
        event: (0, $c36558e913c23625$export$63dc120dff6c5db8)?.types?.event_type?.values['timer'] ?? 0,
        event_type: (0, $c36558e913c23625$export$63dc120dff6c5db8)?.types?.event_type?.values[args.type] ?? 0,
        event_group: 0
    };
}
function $83ad487acde36489$export$c869d9dacc97131c(args = {}) {
    return {
        timestamp: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.timestamp, 'Lap needs timestamp.'),
        start_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.start_time, 'Lap needs start_time.'),
        total_elapsed_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.total_elapsed_time, 'Lap needs total_elapsed_time.'),
        total_timer_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.total_timer_time, 'Lap needs total_timer_time'),
        message_index: args.message_index ?? 0,
        event: (0, $c36558e913c23625$export$63dc120dff6c5db8).types?.event?.values?.lap ?? 9,
        event_type: (0, $c36558e913c23625$export$63dc120dff6c5db8).types?.event_type?.values?.stop ?? 1
    };
}
function $83ad487acde36489$export$9c16c1426311996d(args = {}) {
    return {
        timestamp: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.timestamp, 'Activity needs timestamp.'),
        total_timer_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.total_timer_time, 'Activity needs total_timer_time'),
        num_sessions: 1,
        type: (0, $c36558e913c23625$export$63dc120dff6c5db8).types.activity.values.manual,
        event: (0, $c36558e913c23625$export$63dc120dff6c5db8).types.event.values.activity,
        event_type: (0, $c36558e913c23625$export$63dc120dff6c5db8).types.event_type.values.stop
    };
}
function $83ad487acde36489$export$1fb4852a55678982(args = {}) {
    return {
        timestamp: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.timestamp, 'Session needs timestamp.'),
        start_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.start_time, 'Session needs start_time.'),
        total_elapsed_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.total_elapsed_time, 'Session needs total_elapsed_time.'),
        total_timer_time: (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.total_timer_time, 'Session needs total_timer_time'),
        message_index: args.message_index ?? 0,
        sport: (0, $c36558e913c23625$export$63dc120dff6c5db8).types.sport.values.cycling,
        sub_sport: (0, $c36558e913c23625$export$63dc120dff6c5db8).types.sub_sport.values.virtual_activity,
        ...args.stats,
        first_lap_index: 0,
        num_laps: args.laps?.length ?? 1,
        threshold_power: args.threshold_power
    };
}
// END Special Data Messages
const $83ad487acde36489$export$770c4cd5af13980c = $83ad487acde36489$var$LocalActivity();




/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/ // to suit your point format, run search/replace for '.x' and '.y';
// square distance between 2 points
function $e9c32c0604b50709$var$getSqDist(p1, p2) {
    var dx = p1.x - p2.x, dy = p1.y - p2.y;
    return dx * dx + dy * dy;
}
// square distance from a point to a segment
function $e9c32c0604b50709$var$getSqSegDist(p, p1, p2) {
    var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
    if (dx !== 0 || dy !== 0) {
        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x = p2.x;
            y = p2.y;
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = p.x - x;
    dy = p.y - y;
    return dx * dx + dy * dy;
}
// rest of the code doesn't care about point format
// basic distance-based simplification
function $e9c32c0604b50709$var$simplifyRadialDist(points, sqTolerance) {
    var prevPoint = points[0], newPoints = [
        prevPoint
    ], point;
    for(var i = 1, len = points.length; i < len; i++){
        point = points[i];
        if ($e9c32c0604b50709$var$getSqDist(point, prevPoint) > sqTolerance) {
            newPoints.push(point);
            prevPoint = point;
        }
    }
    if (prevPoint !== point) newPoints.push(point);
    return newPoints;
}
function $e9c32c0604b50709$var$simplifyDPStep(points, first, last, sqTolerance, simplified) {
    var maxSqDist = sqTolerance, index;
    for(var i = first + 1; i < last; i++){
        var sqDist = $e9c32c0604b50709$var$getSqSegDist(points[i], points[first], points[last]);
        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }
    if (maxSqDist > sqTolerance) {
        if (index - first > 1) $e9c32c0604b50709$var$simplifyDPStep(points, first, index, sqTolerance, simplified);
        simplified.push(points[index]);
        if (last - index > 1) $e9c32c0604b50709$var$simplifyDPStep(points, index, last, sqTolerance, simplified);
    }
}
// simplification using Ramer-Douglas-Peucker algorithm
function $e9c32c0604b50709$var$simplifyDouglasPeucker(points, sqTolerance) {
    var last = points.length - 1;
    var simplified = [
        points[0]
    ];
    $e9c32c0604b50709$var$simplifyDPStep(points, 0, last, sqTolerance, simplified);
    simplified.push(points[last]);
    return simplified;
}
// both algorithms combined for awesome performance
function $e9c32c0604b50709$var$simplify(points, tolerance, highestQuality) {
    if (points.length <= 2) return points;
    var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;
    points = highestQuality ? points : $e9c32c0604b50709$var$simplifyRadialDist(points, sqTolerance);
    points = $e9c32c0604b50709$var$simplifyDouglasPeucker(points, sqTolerance);
    return points;
}
//
function $e9c32c0604b50709$var$slopeToColor(slope) {
    // avg hex
    const colors = new Map([
        [
            '-40',
            '#328AFF'
        ],
        [
            '-17.5',
            '#3690EA'
        ],
        [
            '-15',
            '#3B97D5'
        ],
        [
            '-12.5',
            '#3F9EC0'
        ],
        [
            '-10',
            '#44A5AB'
        ],
        [
            '-7.5',
            '#48AB96'
        ],
        [
            '-5',
            '#4DB281'
        ],
        [
            '-2.5',
            '#52B96C'
        ],
        [
            '0',
            '#57C057'
        ],
        [
            '2.5',
            '#68AC4E'
        ],
        [
            '5',
            '#799845'
        ],
        [
            '7.5',
            '#8A843C'
        ],
        [
            '10',
            '#9B7134'
        ],
        [
            '12.5',
            '#B36129'
        ],
        [
            '15',
            '#CC521F'
        ],
        [
            '17.5',
            '#E54315'
        ],
        [
            '40',
            '#FE340B'
        ]
    ]);
    for (var [key, value] of colors){
        if (slope <= parseFloat(key)) return value;
    }
// end avg hex
// base hue
// const baseHue = 120;
// const hue = baseHue - (slope * 12);
// return `hsl(${hue}, 45%, 55%)`;
// end base hue
}
function $e9c32c0604b50709$var$gradeToDeg(grade) {
    // 10 % = 5.71 deg, 5% = 2.86
    return 180 / Math.PI * Math.atan(grade / 100);
}
function $e9c32c0604b50709$var$slopeToRise(slope, distance) {
    return distance * Math.sin(Math.atan(slope / 100));
}
function $e9c32c0604b50709$var$slopeToRun(slope, distance) {
    return distance * Math.cos(Math.atan(slope / 100));
}
function $e9c32c0604b50709$var$adjacent(deg, r) {
    return r * Math.cos(Math.PI / 180 * deg);
}
function $e9c32c0604b50709$var$opposite(deg, r) {
    return r * Math.sin(Math.PI / 180 * deg);
}
const $e9c32c0604b50709$export$39b482c5e57630a8 = {
    simplifyDouglasPeucker: $e9c32c0604b50709$var$simplifyDouglasPeucker,
    simplify: $e9c32c0604b50709$var$simplify,
    slopeToColor: $e9c32c0604b50709$var$slopeToColor,
    gradeToDeg: $e9c32c0604b50709$var$gradeToDeg,
    slopeToRise: $e9c32c0604b50709$var$slopeToRise,
    slopeToRun: $e9c32c0604b50709$var$slopeToRun,
    adjacent: $e9c32c0604b50709$var$adjacent,
    opposite: $e9c32c0604b50709$var$opposite
};


function $75e573301bd7f064$var$toCourse(points, distance, name, description) {
    const pointsSimplified = (0, $e9c32c0604b50709$export$39b482c5e57630a8).simplify(points, 0.5, true).map((p, i, xs)=>{
        const x1 = xs[i].x;
        const y1 = xs[i].y;
        const x2 = xs[i + 1]?.x ?? xs[i].x;
        const y2 = xs[i + 1]?.y ?? xs[i].y;
        const run = x2 - x1;
        const rise = y2 - y1;
        const r = Math.sqrt(run ** 2 + rise ** 2);
        const slope = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(run, 0) ? 0 : 100 * (rise / run);
        xs[i].r = r;
        xs[i].slope = slope;
        return xs[i];
    });
    return {
        meta: {
            name: name ?? 'Course',
            author: 'n/a',
            category: 'Course',
            description: description,
            distance: distance
        },
        points: // id: 0,
        points,
        pointsSimplified: pointsSimplified
    };
}
function $75e573301bd7f064$var$isDataRecord(x) {
    return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(x.type, 'data') && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(x.name, 'record');
}
function $75e573301bd7f064$var$hasAltitude(x) {
    return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(x.fields.altitude);
}
function $75e573301bd7f064$var$hasDistance(x) {
    return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(x.fields.distance);
}
function $75e573301bd7f064$var$isCourseDataMessage(x) {
    return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(x.type, 'data') && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(x.message, 'course');
}
function $75e573301bd7f064$var$courseName(course, fileName) {
    const courseDataMessage = course.find($75e573301bd7f064$var$isCourseDataMessage);
    const name = courseDataMessage?.fields?.name ?? fileName;
    return name.replace(/.fit/gi, '').replace(/_|-/gi, ' ');
}
function $75e573301bd7f064$var$decode(view, fileName) {
    const courseJS = (0, $b5d329ebd4e916e2$export$c804b577b4b7396a).decode(view);
    console.log(courseJS);
    const name = $75e573301bd7f064$var$courseName(courseJS, fileName);
    const author = `n/a`;
    const description = ``;
    let distanceTotal = 0;
    let x = 0;
    const dataRecords = courseJS.filter((r)=>$75e573301bd7f064$var$isDataRecord(r) && $75e573301bd7f064$var$hasDistance(r));
    const altitudeRecords = dataRecords.filter($75e573301bd7f064$var$hasAltitude);
    let prevAltitude = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(altitudeRecords).fields.altitude;
    const points = dataRecords.reduce((acc, m, i, xs)=>{
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(m.fields.altitude)) {
            m.fields.altitude = prevAltitude;
            console.log(prevAltitude);
        } else prevAltitude = m.fields.altitude;
        const altitude = m.fields.altitude;
        const altitudeNext = xs[i + 1]?.fields?.altitude ?? m.fields.altitude;
        const distance = m.fields.distance;
        const distanceNext = xs[i + 1]?.fields?.distance ?? m.fields.distance;
        const rise = altitudeNext - altitude;
        const r = distanceNext - distance;
        const run = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(r, 0) ? 0 : Math.sqrt(Math.abs(r ** 2 - rise ** 2));
        const slope = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(run, 0) ? 0 : 100 * (rise / run);
        acc.push({
            x: x,
            y: altitude,
            r: r,
            slope: slope,
            distance: distance,
            position_lat: m.fields.position_lat,
            position_long: m.fields.position_long
        });
        x += run;
        distanceTotal = distance;
        return acc;
    }, []);
    return $75e573301bd7f064$var$toCourse(points, distanceTotal, name, description);
}
const $75e573301bd7f064$export$673e66ddaf29258 = {
    decode: $75e573301bd7f064$var$decode
};


function $9fc84fe8d280ba8c$export$4167682884112e66(args = {}) {
    return {
        fileHeader: $ed88c44bd8f99c46$export$97013678e68d80d7,
        recordHeader: $483b10c4679c37af$export$a29c13bd16217000,
        definitionRecord: $289488a9833edc78$export$2213eed9e2fb2d05,
        dataRecord: $7460ce66a5541d7b$export$2229092a8062126f,
        fieldDefinition: $9c7d4c513424b120$export$213399610e994e5,
        CRC: $5d332605c5db3f98$export$5be0c4d7d8d17551,
        profiles: $c36558e913c23625$export$63dc120dff6c5db8,
        fitRecord: $b5d329ebd4e916e2$export$2c27b3c3de66209b,
        FITjs: $b5d329ebd4e916e2$export$c804b577b4b7396a,
        localActivity: // remove those from the general library
        $83ad487acde36489$export$770c4cd5af13980c,
        localCourse: $75e573301bd7f064$export$673e66ddaf29258
    };
}
const $9fc84fe8d280ba8c$export$1e044b7877db048c = $9fc84fe8d280ba8c$export$4167682884112e66();


const $21d6c30d826f68a8$export$96e9906d6d93a972 = {
    disconnected: "disconnected",
    connected: "connected",
    connecting: "connecting",
    disconnecting: "disconnecting"
};
const $21d6c30d826f68a8$export$8215d14a63d9fb10 = {
    controllable: 'controllable',
    speedCadenceSensor: 'speedCadenceSensor',
    powerMeter: 'powerMeter',
    heartRateMonitor: 'heartRateMonitor',
    raceController: 'raceController',
    smo2: 'smo2',
    coreTemp: 'coreTemp',
    generic: 'generic'
};
const $21d6c30d826f68a8$export$efdd3e096bc27746 = {
    power: 'power',
    cadence: 'cadence',
    heartRate: 'heartRate',
    smo2: 'smo2',
    thb: 'thb',
    coreBodyTemperature: 'coreBodyTemperature',
    skinTemperature: 'skinTemperature'
};
const $21d6c30d826f68a8$export$b2f3fe740501a543 = {
    controllable: [
        $21d6c30d826f68a8$export$efdd3e096bc27746.power,
        $21d6c30d826f68a8$export$efdd3e096bc27746.cadence,
        $21d6c30d826f68a8$export$efdd3e096bc27746.heartRate
    ],
    powerMeter: [
        $21d6c30d826f68a8$export$efdd3e096bc27746.power,
        $21d6c30d826f68a8$export$efdd3e096bc27746.cadence
    ],
    speedCadenceSensor: [
        $21d6c30d826f68a8$export$efdd3e096bc27746.cadence
    ],
    heartRateMonitor: [
        $21d6c30d826f68a8$export$efdd3e096bc27746.heartRate,
        $21d6c30d826f68a8$export$efdd3e096bc27746.cadence
    ],
    smo2: [
        $21d6c30d826f68a8$export$efdd3e096bc27746.smo2,
        $21d6c30d826f68a8$export$efdd3e096bc27746.thb
    ]
};
const $21d6c30d826f68a8$export$300334f671c43555 = {
    power: [
        $21d6c30d826f68a8$export$8215d14a63d9fb10.powerMeter,
        $21d6c30d826f68a8$export$8215d14a63d9fb10.controllable
    ],
    cadence: [
        $21d6c30d826f68a8$export$8215d14a63d9fb10.speedCadenceSensor,
        $21d6c30d826f68a8$export$8215d14a63d9fb10.powerMeter,
        $21d6c30d826f68a8$export$8215d14a63d9fb10.controllable,
        $21d6c30d826f68a8$export$8215d14a63d9fb10.heartRateMonitor
    ],
    heartRate: [
        $21d6c30d826f68a8$export$8215d14a63d9fb10.heartRateMonitor,
        $21d6c30d826f68a8$export$8215d14a63d9fb10.controllable
    ],
    smo2: [
        $21d6c30d826f68a8$export$8215d14a63d9fb10.smo2
    ],
    coreTemp: [
        $21d6c30d826f68a8$export$8215d14a63d9fb10.coreTemp
    ]
};
const $21d6c30d826f68a8$export$83d617ae204944c5 = {
    erg: 'erg',
    sim: 'sim',
    resistance: 'resistance',
    virtualGear: 'virtualGear'
};



class $9aba94002b6a15c7$var$Model {
    constructor(args = {}){
        this.init(args);
        this.prop = args.prop;
        this.default = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.default, this.defaultValue());
        this.prev = args.default;
        this.set = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.set, this.defaultSet);
        this.parser = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.parser, this.defaultParse);
        this.isValid = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.isValid, this.defaultIsValid);
        this.onInvalid = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.onInvalid, this.defaultOnInvalid);
        this.storage = this.defaultStorage();
        this.postInit(args);
    }
    init() {
        return;
    }
    postInit() {
        return;
    }
    defaultValue() {
        return '';
    }
    defaultIsValid(value) {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value);
    }
    defaultSet(value) {
        const self1 = this;
        if (self1.isValid(value)) {
            self1.state = value;
            // console.log(`${this.prop} : ${this.state}`);
            return value;
        } else {
            self1.defaultOnInvalid(value);
            return self1.default;
        }
    }
    defaultParse(value) {
        return value;
    }
    defaultOnInvalid(x) {
        const self1 = this;
        console.error(`Trying to set invalid ${self1.prop}. ${typeof x}`, x);
    }
    defaultStorage() {
        const self1 = this;
        return {
            add: (x)=>x,
            restore: (_)=>self1.default
        };
    }
    backup(value) {
        const self1 = this;
        self1.storage.set(value);
    }
    restore() {
        const self1 = this;
        return self1.parser(self1.storage.restore());
    }
}
class $9aba94002b6a15c7$var$Power extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 2500);
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        return Number.isInteger(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self.min, self.max, value);
    }
}
class $9aba94002b6a15c7$var$HeartRate extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 255);
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        const self1 = this;
        return Number.isInteger(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self1.min, self1.max, value);
    }
}
class $9aba94002b6a15c7$var$Cadence extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 255);
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        return Number.isInteger(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self.min, self.max, value);
    }
}
class $9aba94002b6a15c7$var$Speed extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 120);
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        return (Number.isInteger(value) || Number.isFloat(value)) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self.min, self.max, value);
    }
    kmhToMps(kmh) {
        return kmh / 3.6;
    }
    mpsToKmh(mps) {
        return mps * 3.6;
    }
    mpsToMph(mps) {
        return mps * 2.23693629;
    }
    kmhToMph(kmh) {
        return kmh * 0.621371192;
    }
}
class $9aba94002b6a15c7$var$SmO2 extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 100);
        this.zones = {
            one: 30,
            two: 70,
            three: 100
        };
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        return (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self.min, self.max, value);
    }
}
class $9aba94002b6a15c7$var$THb extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 400);
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        return (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self.min, self.max, value);
    }
}
class $9aba94002b6a15c7$var$Sources extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        self1.state = self1.default;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:sources', (value)=>self1.state = value);
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue(),
            parse: JSON.parse,
            encode: JSON.stringify
        };
        self1.storage = new args.storage(storageModel);
    }
    defaultSet(target, source) {
        return Object.assign(target, source);
    }
    isSource(path, value) {
        const self1 = this;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(self1.state[path])) return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(self1.state[path], value);
        return false;
    }
    defaultValue() {
        const sources = {
            // device data source map
            power: 'ble:controllable',
            cadence: 'ble:controllable',
            speed: 'ble:controllable',
            control: 'ble:controllable',
            heartRate: 'ble:heartRateMonitor',
            smo2: 'ble:smo2',
            thb: 'ble:smo2',
            coreBodyTemperature: 'ble:coreTemp',
            skinTemperature: 'ble:coreTemp',
            // settings
            virtualState: 'power',
            autoPause: true,
            autoStart: true,
            theme: 'DARK',
            // data tile settings
            // ['power1s', 'power3s']
            powerZStack: 0,
            // ['heartRate', 'heartRateLap', 'heartRateAvg']
            heartRateZStack: 0,
            // ['cadence', 'cadenceLap', 'cadenceAvg', 'cadenceTarget']
            cadenceZStack: 0,
            // ['powerAvg', 'powerLap', 'kcal']
            kcalZStack: 0,
            // ['graph', 'power']
            graphZStack: 0
        };
        return sources;
    }
}
class $9aba94002b6a15c7$var$Target extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 100);
        this.step = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.step, 1);
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        const self1 = this;
        return Number.isInteger(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self1.min, self1.max, value);
    }
    defaultSet(value) {
        const self1 = this;
        if (isNaN(value)) {
            self1.onInvalid();
            return self1.default;
        }
        return (0, $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4)(self1.min, self1.max, self1.parse(value));
    }
    parse(value) {
        return parseInt(value);
    }
    inc(value) {
        const self1 = this;
        const x = value + self1.step;
        return self1.set(x);
    }
    dec(value) {
        const self1 = this;
        const x = value - self1.step;
        return self1.set(x);
    }
}
class $9aba94002b6a15c7$var$Volume extends $9aba94002b6a15c7$var$Target {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue(),
            parse: parseInt
        };
        self1.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        self1.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 100);
        self1.step = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 10);
        self1.storage = new args.storage(storageModel);
    }
    defaultValue() {
        return 0;
    }
    mute() {
        const self1 = this;
        return self1.set(self1.min);
    }
}
class $9aba94002b6a15c7$var$PowerTarget extends $9aba94002b6a15c7$var$Target {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 4000);
        this.step = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.step, 10);
    }
}
class $9aba94002b6a15c7$var$ResistanceTarget extends $9aba94002b6a15c7$var$Target {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, -100);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 100);
        this.step = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.step, 10);
    }
    parse(value) {
        return parseInt(value);
    }
}
class $9aba94002b6a15c7$var$SlopeTarget extends $9aba94002b6a15c7$var$Target {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, -40);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 40);
        this.step = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.step, 0.5);
    }
    defaultIsValid(value) {
        const self1 = this;
        return Number.isFloat(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self1.min, self1.max, value);
    }
    parse(value) {
        return parseFloat(value);
    }
}
class $9aba94002b6a15c7$var$CadenceTarget extends $9aba94002b6a15c7$var$Target {
    postInit(args = {}) {
        this.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        this.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 255);
        this.step = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.step, 5);
    }
    parse(value) {
        return parseInt(value);
    }
}
class $9aba94002b6a15c7$var$Mode extends $9aba94002b6a15c7$var$Model {
    postInit(args) {
        this.state = this.defaultValue();
        this.values = Object.values((0, $21d6c30d826f68a8$export$83d617ae204944c5));
    }
    defaultValue() {
        return (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg;
    }
    defaultIsValid(value) {
        return this.values.includes(value);
    }
}
class $9aba94002b6a15c7$var$Page extends $9aba94002b6a15c7$var$Model {
    postInit(args) {
        this.values = [
            'settings',
            'home',
            'workouts'
        ];
    }
    defaultValue() {
        return 'home';
    }
    defaultIsValid(value) {
        return this.values.includes(value);
    }
}
class $9aba94002b6a15c7$var$FTP extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue(),
            parse: parseInt
        };
        self1.state = self1.default;
        self1.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        self1.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 500);
        self1.storage = args.storage(storageModel);
        self1.zones = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.zones, self1.defaultZones());
        self1.percentages = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.percentages, self1.defaultPercentages());
        self1.minAbsValue = 9;
    }
    defaultValue() {
        return 200;
    }
    defaultIsValid(value) {
        const self1 = this;
        return Number.isInteger(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self1.min, self1.max, value);
    }
    defaultZones() {
        return [
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven'
        ];
    }
    defaultPercentages() {
        return {
            'one': 0.54,
            'two': 0.75,
            'three': 0.87,
            'four': 0.94,
            'five': 1.05,
            'six': 1.20
        };
    }
    toRelative(value, ftp) {
        const self1 = this;
        if (value > self1.minAbsValue) return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(value / ftp, 2);
        return value;
    }
    toAbsolute(value, ftp) {
        const self1 = this;
        if (value < self1.minAbsValue) {
            const roundedUpValue = Math.round(value * 100) / 100; // round up to second position after decimal point
            const absolute = Math.round(roundedUpValue * (ftp ?? self1.state));
            return absolute;
        }
        return value;
    }
    powerToZone(value, ftp, zones) {
        const self1 = this;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(ftp)) ftp = self1.state;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(zones)) zones = self1.zones;
        let index = 0;
        let name = zones[index];
        if (value < ftp * self1.percentages.one) {
            index = 0;
            name = zones[index];
        } else if (value < ftp * self1.percentages.two) {
            index = 1;
            name = zones[index];
        } else if (value < ftp * self1.percentages.three) {
            index = 2;
            name = zones[index];
        } else if (value < ftp * self1.percentages.four) {
            index = 3;
            name = zones[index];
        } else if (value < ftp * self1.percentages.five) {
            index = 4;
            name = zones[index];
        } else if (value < ftp * self1.percentages.six) {
            index = 5;
            name = zones[index];
        } else {
            index = 6;
            name = zones[index];
        }
        return {
            name: name,
            index: index
        };
    }
    zoneToColor(zone) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'one')) return '#636468';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'two')) return '#328AFF';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'thee')) return '#44A5AB';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'four')) return '#57C057';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'five')) return '#F8C73A';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'six')) return '#FF663A';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(zone, 'seven')) return '#FE340B';
        return '#636468';
    }
    percentageToZone(value) {
        const self1 = this;
        const zones = self1.zones;
        if (value < self1.percentages.one) return zones[0];
        else if (value < self1.percentages.two) return zones[1];
        else if (value < self1.percentages.three) return zones[2];
        else if (value < self1.percentages.four) return zones[3];
        else if (value < self1.percentages.five) return zones[4];
        else if (value < self1.percentages.six) return zones[5];
        else return zones[6];
        return zones[0];
    }
}
class $9aba94002b6a15c7$var$Weight extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue(),
            parse: parseInt
        };
        self1.min = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.min, 0);
        self1.max = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.max, 500);
        self1.storage = new args.storage(storageModel);
    }
    defaultValue() {
        return 75;
    }
    defaultIsValid(value) {
        const self1 = this;
        return Number.isInteger(value) && (0, $820877bea407f5fe$export$ddf89a9c5af38f94)(self1.min, self1.max, value);
    }
}
class $9aba94002b6a15c7$var$Theme extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue()
        };
        self1.storage = new args.storage(storageModel);
        self1.values = [
            'dark',
            'light'
        ];
    }
    defaultValue() {
        return 'dark';
    }
    defaultIsValid(value) {
        return this.values.includes(value);
    }
    switch(theme) {
        const self1 = this;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(theme, (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(self1.values))) return (0, $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d)(self1.values);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(theme, (0, $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d)(self1.values))) return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(self1.values);
        self1.onInvalid(theme);
        return self1.default;
    }
}
class $9aba94002b6a15c7$var$DockMode extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue(),
            parse: (x)=>x === 'true'
        };
        self1.storage = new args.storage(storageModel);
        self1.values = [
            true,
            false
        ];
    }
    defaultValue() {
        return false;
    }
    switch(state) {
        return !state;
    }
    apply(state) {
        const self1 = this;
        if (state && window.innerHeight > 200) self1.resize();
    }
    calcSize() {
        const width = window.screen.availWidth;
        const height = 150;
        const top = window.screen.availHeight - height;
        return {
            width: width,
            height: height,
            top: top
        };
    }
    resize() {
        const self1 = this;
        let { width: width, height: height, top: top } = self1.calcSize();
        window.resizeTo(width, height);
        window.moveTo(0, top);
    }
    open() {
        const href = document.location.href;
        let self1 = this;
        let { width: width, height: height, top: top } = self1.calcSize();
        window.open(`${href}`, '', `width=${width},height=${height},left=0,top=${top}`);
        window.close();
    }
}
class $9aba94002b6a15c7$var$Measurement extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue()
        };
        self1.storage = new args.storage(storageModel);
        self1.values = [
            'metric',
            'imperial'
        ];
    }
    defaultValue() {
        return 'metric';
    }
    defaultIsValid(value) {
        return this.values.includes(value);
    }
    switch(theme) {
        const self1 = this;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(theme, (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(self1.values))) return (0, $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d)(self1.values);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(theme, (0, $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d)(self1.values))) return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(self1.values);
        self1.onInvalid(theme);
        return self1.default;
    }
}
class $9aba94002b6a15c7$var$DataTileSwitch extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        const storageModel = {
            key: self1.prop,
            fallback: self1.defaultValue()
        };
        self1.storage = new args.storage(storageModel);
        this.values = [
            0,
            1,
            2
        ];
    }
    defaultValue() {
        return 0;
    }
    defaultIsValid(value) {
        return this.values.includes(value);
    }
    defaultParse(value) {
        return parseInt(value);
    }
}
class $9aba94002b6a15c7$var$Activity extends $9aba94002b6a15c7$var$Model {
    // var activity = {
    //         id: UUID,
    //         blob: Blob,
    //         summary: {
    //             timestamp: Int,
    //             duration: Int,
    //             name: String,
    //             status: {
    //                 strava: String,
    //                 intervals: String,
    //                 trainingPeaks: String,
    //             }
    //         },
    // };
    name = 'activity';
    postInit(args) {
        this.api = args.api;
        this.capacity = 7;
    }
    defaultValue() {
        return [];
    }
    createFromCurrent(db) {
        const id = (0, $36efb14127c8c4dd$export$31b40729666a4ae0)();
        const blob = (0, $4720983c2827b7ff$export$1d35aa040498b1e5).toBlob(this.encode(db));
        const name = db.workout?.meta?.name ?? 'Powered by Auuki workout';
        const summary = {
            id: id,
            timestamp: Date.now(),
            name: name,
            duration: db.elapsed ?? 0,
            status: {
                strava: 'none',
                intervals: 'none',
                trainingPeaks: 'none'
            }
        };
        const record = {
            id: id,
            blob: blob,
            summary: summary
        };
        this.add(summary, db.activity);
        (0, $e655ee46f487092f$export$53df56d89c7d7ac4).put('activity', record);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('activity:add', summary);
    }
    add(activity, activityList) {
        activityList.unshift(activity);
        if (activityList.length > this.capacity) {
            const summary = activityList.pop();
            (0, $e655ee46f487092f$export$53df56d89c7d7ac4).remove('activity', summary.id);
        }
        return activityList;
    }
    remove(id) {
        (0, $e655ee46f487092f$export$53df56d89c7d7ac4).remove('activity', id);
    }
    async upload(service, id) {
        let record = await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).get('activity', id);
        if (service === 'strava' || service === 'intervals' || service === 'trainingPeaks') {
            const res = await this.api[service].uploadWorkout(record);
            record = await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).get('activity', id);
            record.summary.status[service] = res.substring(1);
            await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).put('activity', record);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`action:activity:${id}`, `:${service}:upload${res}`);
        }
        return;
    }
    async download(id) {
        const self1 = this;
        const record = await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).get('activity', id);
        (0, $4720983c2827b7ff$export$1d35aa040498b1e5).download()(record.blob, self1.fileName(record.summary.timestamp), (0, $4720983c2827b7ff$export$1d35aa040498b1e5).Type.OctetStream);
    }
    fileName(timestamp) {
        return `workout-${(0, $820877bea407f5fe$export$d19070df23277278)(new Date(timestamp))}.fit`;
    }
    encode(db) {
        const records = db.records;
        const laps = db.laps;
        const events = db.events;
        const ftp = db.ftp;
        return (0, $9fc84fe8d280ba8c$export$1e044b7877db048c).localActivity.encode({
            records: records,
            laps: laps,
            events: events,
            ftp: ftp
        });
    }
    async restore() {
        const records = await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).getAll('activity') ?? [];
        // migrate summary.status String to {strava: String, intervals: String}
        records.forEach((record)=>{
            if (typeof record.summary.status === 'string') {
                console.log(`:activity :migrating `, record.id);
                record.summary.status = {
                    strava: 'none',
                    intervals: 'none'
                };
                (0, $e655ee46f487092f$export$53df56d89c7d7ac4).put('activity', record);
            }
        });
        return records.map((record)=>record.summary).sort((a, b)=>b.timestamp - a.timestamp);
    }
}
// TODO:
// - differentiate between Workout and Activity
// - this model should hold methods related to working on a Workout as memeber of the
//   workout list or as the current selected workout
// - Activity is about the current active recording, session, and the list of actities
//   which are just recorded data or .fit format, Workout is about .zwo format
class $9aba94002b6a15c7$var$Workout extends $9aba94002b6a15c7$var$Model {
    postInit(args = {}) {
        const self1 = this;
        self1.api = args.api;
    }
    // state init
    defaultValue() {
        return this.parse((0, $c6a9e46ee7e4d896$export$43128fadae87b74a)((0, $dcdf7029c6c77c73$export$550a5441be043621)));
    }
    defaultIsValid(value) {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value);
    }
    restore(db) {
        return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(db.workouts);
    }
    // accessors
    find(workouts, id) {
        for (let workout of workouts){
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(workout.id, id)) return workout;
        }
        console.error(`tring to get a missing workout: ${id}`, workouts);
        return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(workouts);
    }
    // parsers
    parse(result, name = '') {
        if ((0, $c6a9e46ee7e4d896$export$43bee75e5e14138e)(result) || (0, $c6a9e46ee7e4d896$export$a6cdc56e425d0d0a)(result)) {
            const view = new DataView(result);
            const courseJS = (0, $9fc84fe8d280ba8c$export$1e044b7877db048c).localCourse.decode(view, name);
            console.log(courseJS);
            return courseJS;
        }
        return (0, $bf91c66429ac832e$export$85cfc7c114c368df).readToInterval(result);
    }
    fromIntervalsEvent(event) {
        const workout = this.parse(atob(event.workout_file_base64));
        workout.meta.planned = true;
        workout.id = (0, $36efb14127c8c4dd$export$31b40729666a4ae0)();
        workout.intervals_id = event.id;
        return workout;
    }
    fromIntervalsResponse(response) {
        return response.map(this.fromIntervalsEvent.bind(this));
    }
    async readFromFile(file) {
        const result = await (0, $4720983c2827b7ff$export$1d35aa040498b1e5).read(file);
        return {
            result: result,
            name: file.name
        };
    }
    encode(db) {
        const records = db.records;
        const laps = db.laps;
        const events = db.events;
        const ftp = db.ftp;
        return (0, $9fc84fe8d280ba8c$export$1e044b7877db048c).localActivity.encode({
            records: records,
            laps: laps,
            events: events,
            ftp: ftp
        });
    }
    // utils
    fileName() {
        return `workout-${(0, $820877bea407f5fe$export$d19070df23277278)(new Date())}.fit`;
    }
    download(db) {
        (0, $4720983c2827b7ff$export$1d35aa040498b1e5).download()(this.encode(db), this.fileName(), (0, $4720983c2827b7ff$export$1d35aa040498b1e5).Type.OctetStream);
    }
    send(db) {
        // TODO: remove the whole method
        const name = this.fileName();
        const blob = (0, $4720983c2827b7ff$export$1d35aa040498b1e5).toBlob(this.encode(db));
        this.api.strava.uploadWorkout(blob);
        return {
            name: name,
            blob: blob
        };
    }
}
// TODO:
// - rename to Libarary
// - use to just manage the library list of workouts
class $9aba94002b6a15c7$var$Workouts extends $9aba94002b6a15c7$var$Model {
    name = 'workouts';
    init(args) {
        const self1 = this;
        self1.workoutModel = args.workoutModel;
    }
    defaultValue() {
        const self1 = this;
        return (0, $dcdf7029c6c77c73$export$550a5441be043621).map((w)=>Object.assign(self1.workoutModel.parse(w), {
                id: (0, $36efb14127c8c4dd$export$31b40729666a4ae0)()
            }));
    }
    defaultIsValid(value) {
        const self1 = this;
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value);
    }
    async restore(db) {
        const self1 = this;
        const workouts = await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).getAll(`${self1.name}`) ?? [];
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(workouts)) return self1.default;
        else return self1.default.concat(workouts);
    }
    get(workouts, id) {
        for (let workout of workouts){
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(workout.id, id)) return workout;
        }
        console.error(`tring to get a missing workout: ${id}`, workouts);
        return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(workouts);
    }
    add(workouts, workout) {
        const self1 = this;
        workouts.push((0, $e655ee46f487092f$export$53df56d89c7d7ac4).setId(workout));
        self1.save(workout);
        return workouts;
    }
    save(workout) {
        const self1 = this;
        console.log(`:models :workouts :save`);
        (0, $e655ee46f487092f$export$53df56d89c7d7ac4).put(self1.name, (0, $e655ee46f487092f$export$53df56d89c7d7ac4).setId(workout));
    }
    remove(workouts, id) {
        const self1 = this;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(id)) {
            console.error(`:models :workouts :remove 'called without workout id!'`);
            return workouts;
        }
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)($9aba94002b6a15c7$var$workout)) {
            console.error(`:models :workouts :remove 'called with empty id!'`);
            return workouts;
        }
        (0, $e655ee46f487092f$export$53df56d89c7d7ac4).remove(self1.name, id);
        return workouts.filter((w)=>w.id !== id);
    }
}
function $9aba94002b6a15c7$var$yesterdayOrOlder(timestamp) {
    return new Date().getDate() - new Date(timestamp).getDate() > 0;
}
// TODO:
// - standardize the methods
class $9aba94002b6a15c7$var$Planned {
    name = 'planned';
    constructor(args = {}){
        const self1 = this;
        this.data = this.defaultValue();
        this.workoutModel = args.workoutModel;
        this.athlete = {};
        this.storage = (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)({
            key: 'planned',
            encode: JSON.stringify,
            parse: JSON.parse,
            fallback: this.defaultValue()
        });
    }
    defaultValue() {
        return {
            workouts: [],
            modified: {}
        };
    }
    get(id) {
        for (let workout of this.data.workouts){
            if (workout.id === id) return workout;
        }
        console.error(`tring to get a missing planned workout: ${id}`);
        return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(this.data.workouts);
    }
    setWorkouts(workouts) {
        this.data.workouts = workouts;
    }
    list() {
        return this.data.workouts;
    }
    setModified(service = 'intervals') {
        this.data.modified[service] = Date.now();
    }
    isEmpty() {
        return this.data.workouts.length === 0;
    }
    restore() {
        console.log(':planned :restore');
        this.data = this.storage.restore();
        if ($9aba94002b6a15c7$var$yesterdayOrOlder(this.data.modified.intervals)) {
            console.log(`:planned :outdated :calling :wod 'intervals'`);
            this.getAthlete('intervals');
            this.wod('intervals');
            return;
        }
        console.log(`:planned :up-to-date`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`action:planned`, ':data');
    }
    backup() {
        this.storage.set(this.data);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`action:planned`, ':data');
    }
    // force refresh the wod data
    async wod(service) {
        const self1 = this;
        if (service === 'intervals') {
            const response = await $9aba94002b6a15c7$var$api.intervals.wod();
            const workouts = self1.workoutModel.fromIntervalsResponse(response);
            this.setWorkouts(workouts);
            this.setModified(service);
            this.backup();
            if (!this.isEmpty()) {
                const id = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(this.data.workouts).id;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`action:li:${id}`, ':select');
            }
        }
    }
    async getAthlete(service) {
        const self1 = this;
        if (service === 'intervals') {
            const response = await $9aba94002b6a15c7$var$api.intervals.getAthlete();
            console.log(response);
            if (response.weight > 0) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:weight-set', response.weight);
            if (response.ftp > 0) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:ftp-set', response.ftp);
        }
    }
}
function $9aba94002b6a15c7$var$Session(args = {}) {
    let name = 'session';
    function backup(db) {
        (0, $e655ee46f487092f$export$53df56d89c7d7ac4).put('session', (0, $e655ee46f487092f$export$53df56d89c7d7ac4).setId(dbToSession(db), 0));
    }
    async function restore(db) {
        const sessions = await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).getAll(`${name}`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${name}:restore`, sessions);
        console.log(`:idb :restore '${name}' :length ${sessions.length}`);
        let session = (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(sessions);
        if (!(0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(sessions)) {
            if (session.elapsed > 0) sessionToDb(db, session);
            else (0, $e655ee46f487092f$export$53df56d89c7d7ac4).clear(`${name}`);
        }
    }
    function sessionToDb(db, session) {
        return Object.assign(db, session);
    }
    function dbToSession(db) {
        const session = {
            // Watch
            elapsed: db.elapsed,
            lapTime: db.lapTime,
            stepTime: db.stepTime,
            intervalIndex: db.intervalIndex,
            stepIndex: db.stepIndex,
            intervalDuration: db.intervalDuration,
            stepDuration: db.stepDuration,
            lapStartTime: db.lapStartTime,
            watchStatus: db.watchStatus,
            workoutStatus: db.workoutStatus,
            // Course
            courseIndex: db.courseIndex,
            speedVirtual: db.speedVirtual,
            speed: db.speed,
            // Recording
            records: db.records,
            laps: db.laps,
            events: db.events,
            lap: db.lap,
            distance: db.distance,
            altitude: db.altitude,
            position_lat: db.position_lat,
            position_long: db.position_long,
            // Avg State
            kcal: db.kcal,
            powerLap: db.powerLap,
            cadenceLap: db.cadenceLap,
            heartRateLap: db.heartRateLap,
            powerAvg: db.powerAvg,
            cadenceAvg: db.cadenceAvg,
            heartRateAvg: db.heartRateAvg,
            powerLapCount: db.powerLapCount,
            cadenceLapCount: db.cadenceLapCount,
            heartRateLapCount: db.heartRateLapCount,
            powerAvgCount: db.powerAvgCount,
            cadenceAvgCount: db.cadenceAvgCount,
            heartRateAvgCount: db.heartRateAvgCount,
            // Report
            powerInZone: db.powerInZone,
            // Workouts
            workout: db.workout,
            mode: db.mode,
            lock: db.lock,
            page: db.page,
            // Targets
            powerTarget: db.powerTarget,
            resistanceTarget: db.resistanceTarget,
            slopeTarget: db.slopeTarget,
            // sources: db.sources,
            // UI options
            powerSmoothing: db.powerSmoothing
        };
        return session;
    }
    function reset(db) {
        db.records = [];
        db.lap = [];
        db.laps = [];
        db.events = [];
        db.lapStartTime = false;
        db.rrInterval = [];
        db.elapsed = 0;
        db.lapTime = 0;
        db.stepTime = 0;
        db.intervalIndex = 0;
        db.stepIndex = 0;
        db.intervalDuration = 0;
        db.stepDuration = 0;
        db.resistanceTarget = 0;
        db.slopeTarget = 0;
        db.powerTarget = 0;
        db.position_lat = 0;
        db.position_long = 0;
        db.altitude = $9aba94002b6a15c7$var$virtualState.altitude;
        db.distance = $9aba94002b6a15c7$var$virtualState.distance;
        db.ascent = $9aba94002b6a15c7$var$virtualState.ascent;
        db.powerLap = $9aba94002b6a15c7$var$powerLap.default;
        db.heartRateLap = $9aba94002b6a15c7$var$heartRateLap.default;
        db.cadenceLap = $9aba94002b6a15c7$var$cadenceLap.default;
        db.kcal = $9aba94002b6a15c7$var$kcal.default;
        db.powerAvg = $9aba94002b6a15c7$var$powerAvg.default;
        db.cadenceAvg = $9aba94002b6a15c7$var$cadenceAvg.default;
        db.heartRateAvg = $9aba94002b6a15c7$var$heartRateAvg.default;
        db.powerLapCount = $9aba94002b6a15c7$var$powerLap.count;
        db.heartRateLapCount = $9aba94002b6a15c7$var$heartRateLap.count;
        db.cadenceLapCount = $9aba94002b6a15c7$var$cadenceLap.count;
        db.powerAvgCount = $9aba94002b6a15c7$var$powerAvg.count;
        db.cadenceAvgCount = $9aba94002b6a15c7$var$cadenceAvg.count;
        db.heartRateAvgCount = $9aba94002b6a15c7$var$heartRateAvg.count;
    }
    function elapsed(x, db) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(db.watchStatus, (0, $9a46339c5268bef7$export$b43e4c66e7bb1fc7).stopped)) {
            db.elapsed = x;
            return;
        }
        db.elapsed = x;
        const speed = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(db.sources.virtualState, 'speed') ? db.speed : db.speedVirtual;
        const record = {
            timestamp: Date.now(),
            power: db.power1s,
            cadence: db.cadence,
            speed: speed,
            heart_rate: db.heartRate,
            distance: db.distance,
            grade: db.slopeTarget,
            altitude: db.altitude,
            position_lat: db.position_lat,
            position_long: db.position_long,
            saturated_hemoglobin_percent: db.smo2,
            total_hemoglobin_conc: db.thb,
            core_temperature: db.coreBodyTemperature,
            skin_temperature: db.skinTemperature,
            device_index: 0
        };
        db.records.push(record);
        if (!(0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(db.rrInterval)) db.records.push({
            time: (0, $820877bea407f5fe$export$5d04458e2a6c373e)(db.rrInterval, 5, 0xFFFF)
        });
        db.lap.push(record);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(db.elapsed % 60, 0)) {
            // models.session.backup(db);
            backup(db);
            console.log(`backing up of ${db.records.length} records ...`);
        }
    }
    function lap(x, db) {
        let timeEnd = Date.now();
        let timeStart = db.lapStartTime;
        let elapsed = (0, $820877bea407f5fe$export$5348c053b94136a6)(timeStart, timeEnd);
        if (elapsed > 0) {
            const lap = {
                timestamp: timeEnd,
                start_time: timeStart,
                totalElapsedTime: elapsed,
                avgPower: db.powerLap,
                maxPower: (0, $c6a9e46ee7e4d896$export$8960430cfd85939f)(db.lap, 'power'),
                avgCadence: Math.round((0, $c6a9e46ee7e4d896$export$86c4352b5bd9c815)(db.lap, 'cadence')),
                avgHeartRate: Math.round((0, $c6a9e46ee7e4d896$export$86c4352b5bd9c815)(db.lap, 'heart_rate')),
                saturated_hemoglobin_percent: (0, $c6a9e46ee7e4d896$export$a81f732198733497)((0, $c6a9e46ee7e4d896$export$86c4352b5bd9c815)(db.lap, 'saturated_hemoglobin_percent'), 2),
                total_hemoglobin_conc: (0, $c6a9e46ee7e4d896$export$a81f732198733497)((0, $c6a9e46ee7e4d896$export$86c4352b5bd9c815)(db.lap, 'total_hemoglobin_conc'), 2),
                core_temperature: (0, $c6a9e46ee7e4d896$export$a81f732198733497)((0, $c6a9e46ee7e4d896$export$86c4352b5bd9c815)(db.lap, 'core_temperature'), 2),
                skin_temperature: (0, $c6a9e46ee7e4d896$export$a81f732198733497)((0, $c6a9e46ee7e4d896$export$86c4352b5bd9c815)(db.lap, 'skin_temperature'), 2)
            };
            db.laps.push(lap);
            db.lap = [];
        }
        db.lapStartTime = timeEnd + 0;
    }
    function event(x, db) {
        if (!(0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(db.events) && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(db.events).type, x.type)) return;
        db.events.push(x);
    }
    return Object.freeze({
        backup: backup,
        restore: restore,
        reset: reset,
        sessionToDb: sessionToDb,
        dbToSession: dbToSession,
        elapsed: elapsed,
        lap: lap,
        event: event
    });
}
class $9aba94002b6a15c7$var$MetaProp {
    constructor(args = {}){
        const self1 = this;
        this.init(args);
        this.prop = args.prop ?? this.getDefaults().prop;
        this.disabled = args.default ?? this.getDefaults().disabled;
        this.default = args.default ?? this.getDefaults().default;
        this.state = args.state ?? this.default;
        this.name = args.name ?? `meta-prop`;
        this.propName = self1.toCamelCase(args.name) ?? `metaProp`;
        this.postInit(args);
        this.start();
    }
    init(args) {
        return args;
    }
    postInit(args = {}) {
        return args;
    }
    getPropValue(propValue) {
        return propValue;
    }
    getState() {
        return this.format(this.state);
    }
    setState(propValue) {
        return this.updateState(propValue);
    }
    format(state) {
        return state;
    }
    start() {
        this.subs();
    }
    stop() {
        this.unsubs();
    }
    toCamelCase(str) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(str)) return str.replace(/-([a-z])/g, function(g) {
            return g[1].toUpperCase();
        });
        return str;
    }
    subs() {
        const self1 = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self1.abortController.signal
        };
        this.subsConfig();
    }
    subsConfig() {
        return;
    }
    unsubs() {
        this.abortController.abort();
    }
    onUpdate(propValue) {
        if (this.shouldUpdate(propValue)) this.updateState(propValue);
    }
    shouldUpdate() {
        return true;
    }
    updateState(value) {
        this.state = value;
        return this.state;
    }
}
class $9aba94002b6a15c7$var$PropAccumulator extends $9aba94002b6a15c7$var$MetaProp {
    postInit(args = {}) {
        this.event = args.event ?? this.getDefaults().event;
        this.count = this.getDefaults().count;
        this.prev = this.getDefaults().prev;
    }
    getDefaults() {
        return {
            value: 0,
            prev: 0,
            default: 0,
            disabled: false,
            prop: '',
            event: '',
            prev: 0,
            count: 0
        };
    }
    format(state) {
        return Math.round(state);
    }
    reset() {
        this.count = 0;
    }
    subsConfig() {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.prop, '')) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.event, '')) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.event}`, this.onEvent.bind(this), this.signal);
    }
    updateState(value) {
        if (this.state === 0 && value === 0) this.state = 0;
        else if (value === 0) return this.state;
        else {
            this.count += 1;
            const value_c = value;
            const value_p = this.prev;
            const count_c = this.count;
            const count_p = this.count - 1;
            this.state = (0, $c6a9e46ee7e4d896$export$f63d28b738249587)(value_c, value_p, count_c, count_p);
            this.prev = this.state;
        }
        return this.state;
    }
    onEvent() {
        this.reset();
    }
    restore(db) {
        this.count = db[this.propName + "Count"] ?? this.count;
        this.state = db[this.propName] ?? this.state;
        this.prev = db[this.propName] ?? this.prev;
    }
}
class $9aba94002b6a15c7$var$KcalAccumulator extends $9aba94002b6a15c7$var$PropAccumulator {
    updateState(power) {
        this.state = this.state + power * 0.001;
        return this.state;
    }
}
const $9aba94002b6a15c7$var$powerLap = new $9aba94002b6a15c7$var$PropAccumulator({
    event: 'watch:lap',
    name: 'power-lap'
});
const $9aba94002b6a15c7$var$powerAvg = new $9aba94002b6a15c7$var$PropAccumulator({
    event: 'watch:stopped',
    name: 'power-avg'
});
const $9aba94002b6a15c7$var$kcal = new $9aba94002b6a15c7$var$KcalAccumulator({
    event: 'watch:stopped',
    name: 'kcal'
});
const $9aba94002b6a15c7$var$cadenceLap = new $9aba94002b6a15c7$var$PropAccumulator({
    event: 'watch:lap',
    name: 'cadence-lap'
});
const $9aba94002b6a15c7$var$cadenceAvg = new $9aba94002b6a15c7$var$PropAccumulator({
    event: 'watch:stopped',
    name: 'cadence-avg'
});
const $9aba94002b6a15c7$var$heartRateLap = new $9aba94002b6a15c7$var$PropAccumulator({
    event: 'watch:lap',
    name: 'heart-rate-lap'
});
const $9aba94002b6a15c7$var$heartRateAvg = new $9aba94002b6a15c7$var$PropAccumulator({
    event: 'watch:stopped',
    name: 'heart-rate-avg'
});
class $9aba94002b6a15c7$var$PropInterval {
    constructor(args = {}){
        const self1 = this;
        this.default = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.default, this.getDefaults().default);
        this.state = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.state, this.getDefaults().default);
        this.accumulator = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.accumulator, this.getDefaults().accumulator);
        this.count = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.count, this.getDefaults().count);
        this.prop = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.prop, this.getDefaults().prop);
        this.effect = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.effect, this.getDefaults().effect);
        this.interval = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.interval, this.getDefaults().interval);
        this.start();
    }
    getDefaults() {
        const self1 = this;
        return {
            default: 0,
            accumulator: 0,
            count: 0,
            interval: 1000,
            prop: '',
            effect: ''
        };
    }
    start() {
        this.subs();
        this.intervalId = setInterval(this.onInterval.bind(this), this.interval);
    }
    stop() {
        clearInterval(this.intervalId);
        this.unsubs();
    }
    reset() {
        this.accumulator = 0;
        this.count = 0;
    }
    subs() {
        const self1 = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self1.abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    unsubs() {
        this.abortController.abort();
    }
    onUpdate(propValue) {
        this.accumulator += propValue;
        this.count += 1;
    }
    onInterval() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.count, 0)) return;
        this.state = this.accumulator / this.count;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, this.state);
        this.reset();
    }
}
class $9aba94002b6a15c7$var$PowerInZone {
    constructor(args = {}){
        const self1 = this;
        this.ftpModel = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.ftpModel);
        this.default = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.default, this.getDefaults().default);
        this.count = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.count, this.getDefaults().count);
        this.weights = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.weights, this.getDefaults().weights);
        this.state = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.state, this.getDefaults().default);
        this.prop = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.prop, this.getDefaults().prop);
        this.start();
    }
    getDefaults() {
        const self1 = this;
        const value = self1.ftpModel.zones.map((x)=>[
                0,
                0
            ]);
        const weights = self1.ftpModel.zones.map((x)=>0);
        return {
            default: value,
            weights: weights,
            count: 0,
            prop: 'db:elapsed'
        };
    }
    start() {
        this.subs();
    }
    stop() {
        this.unsubs();
    }
    subs() {
        const self1 = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self1.abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    unsubs() {
        this.abortController.abort();
    }
    onUpdate(propValue, db) {
        this.updateState(db.power);
    }
    powerToZone(power) {
        return this.ftpModel.powerToZone(power);
    }
    updateState(value) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, 0)) return this.state;
        const zone = this.powerToZone(value);
        this.count += 1;
        this.weights[zone.index] += 1;
        for(let i = 0; i < this.state.length; i++)if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.weights[i], 0)) this.state[i] = [
            this.weights[i] / this.count,
            this.weights[i]
        ];
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('powerInZone', this.state);
        return this.state;
    }
}
class $9aba94002b6a15c7$var$VirtualState extends $9aba94002b6a15c7$var$MetaProp {
    postInit() {
        this.speed = this.getDefaults().speed;
        this.altitude = this.getDefaults().altitude;
        this.distance = this.getDefaults().distance;
        this.ascent = this.getDefaults().ascent;
        this.slope = this.getDefaults().slope;
        this.riderWeight = this.getDefaults().riderWeight;
        this.equipmentWeight = this.getDefaults().equipmentWeight;
        this.mass = this.getDefaults().mass;
        this.source = this.getDefaults().source;
        this.cycling = (0, $46ce891f4ee94034$export$a1edc412be3e1841)({
            rho: 1.275,
            dragCoefficient: 0.88,
            // 1.0, 0.88
            frontalArea: 0.36,
            // 0.4, 0.36
            CdA: 0.3168 // 0.4, 0.3168
        });
        this.lastUpdate = undefined;
    }
    getDefaults() {
        return {
            riderWeight: 75,
            equipmentWeight: 10,
            mass: 85,
            slope: 0.00,
            speed: 0,
            altitude: 0,
            distance: 0,
            ascent: 0,
            prop: 'power',
            source: 'power',
            disabled: false,
            default: 0
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:sources`, this.onSources.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:weight`, this.onWeight.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('watch:started', this.onStarted.bind(this), this.signal);
    }
    onSources(sources) {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.source, sources.virtualState)) this.lastUpdate = Date.now();
        this.source = sources.virtualState;
    }
    onWeight(weight) {
        this.riderWeight = weight;
        this.systemWeight = this.riderWeight + this.equipmentWeight;
    }
    onStarted() {
        this.lastUpdate = Date.now();
    }
    onUpdate(power, db) {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.source, this.prop)) return;
        // Take into acount the pauses
        const now = Date.now();
        const dt = (now - this.lastUpdate) / 1000;
        this.lastUpdate = now;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dt, 0)) // console.warn(`dt: ${dt}, s: ${this.speed}`);
        return;
        const { speed: speed, distance: distance, altitude: altitude, ascent: ascent } = this.cycling.virtualSpeedCF({
            power: db.power,
            slope: db.slopeTarget / 100,
            distance: db.distance,
            altitude: db.altitude,
            ascent: db.ascent,
            mass: this.mass,
            speed: this.speed,
            dt: isNaN(dt) ? 1 / 4 : dt
        });
        this.speed = speed;
        // xf.dispatch('speedVirtual', (speed * 3.6));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('speedVirtual', speed);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('distance', distance);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('altitude', altitude);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ascent', ascent);
    }
}
class $9aba94002b6a15c7$var$SpeedState extends $9aba94002b6a15c7$var$VirtualState {
    getDefaults() {
        return {
            prop: 'speed',
            source: 'power',
            disabled: false,
            default: 0,
            riderWeight: 75,
            equipmentWeight: 10,
            mass: 85,
            slope: 0.00,
            speed: 0,
            altitude: 0,
            distance: 0
        };
    }
    onUpdate(speed, db) {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.source, this.prop)) return;
        const now = Date.now();
        const dt = (now - this.lastUpdate) / 1000;
        this.lastUpdate = now;
        const { distance: distance, altitude: altitude, ascent: ascent } = this.cycling.trainerSpeed({
            slope: db.slopeTarget / 100,
            // speed:     db.speed / 3.6,
            speed: db.speed,
            distance: db.distance,
            altitude: db.altitude,
            ascent: db.ascent,
            speedPrev: this.speedPrev,
            mass: this.mass,
            dt: isNaN(dt) ? 1 / 4 : dt
        });
        // this.speedPrev = speed / 3.6;
        this.speedPrev = speed;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('distance', distance);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('altitude', altitude);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ascent', ascent);
    }
}
class $9aba94002b6a15c7$var$TSS {
}
const $9aba94002b6a15c7$var$api = (0, $7a52499dfd919b34$export$2e2bcd8739ae039)();
const $9aba94002b6a15c7$var$power = new $9aba94002b6a15c7$var$Power({
    prop: 'power'
});
const $9aba94002b6a15c7$var$cadence = new $9aba94002b6a15c7$var$Cadence({
    prop: 'cadence'
});
const $9aba94002b6a15c7$var$heartRate = new $9aba94002b6a15c7$var$HeartRate({
    prop: 'heartRate'
});
const $9aba94002b6a15c7$var$speed = new $9aba94002b6a15c7$var$Speed({
    prop: 'speed'
});
const $9aba94002b6a15c7$var$smo2 = new $9aba94002b6a15c7$var$SmO2({
    prop: 'smo2'
});
const $9aba94002b6a15c7$var$thb = new $9aba94002b6a15c7$var$THb({
    prop: 'thb'
});
const $9aba94002b6a15c7$var$sources = new $9aba94002b6a15c7$var$Sources({
    prop: 'sources',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$virtualState = new $9aba94002b6a15c7$var$VirtualState();
const $9aba94002b6a15c7$var$speedState = new $9aba94002b6a15c7$var$SpeedState();
const $9aba94002b6a15c7$var$powerTarget = new $9aba94002b6a15c7$var$PowerTarget({
    prop: 'powerTarget'
});
const $9aba94002b6a15c7$var$resistanceTarget = new $9aba94002b6a15c7$var$ResistanceTarget({
    prop: 'resistanceTarget'
});
const $9aba94002b6a15c7$var$slopeTarget = new $9aba94002b6a15c7$var$SlopeTarget({
    prop: 'slopeTarget'
});
const $9aba94002b6a15c7$var$cadenceTarget = new $9aba94002b6a15c7$var$CadenceTarget({
    prop: 'cadenceTarget'
});
const $9aba94002b6a15c7$var$mode = new $9aba94002b6a15c7$var$Mode({
    prop: 'mode'
});
const $9aba94002b6a15c7$var$page = new $9aba94002b6a15c7$var$Page({
    prop: 'page'
});
const $9aba94002b6a15c7$var$ftp = new $9aba94002b6a15c7$var$FTP({
    prop: 'ftp',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$weight = new $9aba94002b6a15c7$var$Weight({
    prop: 'weight',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$theme = new $9aba94002b6a15c7$var$Theme({
    prop: 'theme',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$dockMode = new $9aba94002b6a15c7$var$DockMode({
    prop: 'dockMode',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$volume = new $9aba94002b6a15c7$var$Volume({
    prop: 'volume',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$measurement = new $9aba94002b6a15c7$var$Measurement({
    prop: 'measurement',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$dataTileSwitch = new $9aba94002b6a15c7$var$DataTileSwitch({
    prop: 'dataTileSwitch',
    storage: (0, $e0788cfb3ff22b2a$export$e1f6585d046ad36a)
});
const $9aba94002b6a15c7$var$power1s = new $9aba94002b6a15c7$var$PropInterval({
    prop: 'db:power',
    effect: 'power1s',
    interval: 1000
});
const $9aba94002b6a15c7$var$power3s = new $9aba94002b6a15c7$var$PropInterval({
    prop: 'db:power',
    effect: 'power3s',
    interval: 3000
});
const $9aba94002b6a15c7$var$powerInZone = new $9aba94002b6a15c7$var$PowerInZone({
    ftpModel: $9aba94002b6a15c7$var$ftp
});
const $9aba94002b6a15c7$var$activity = new $9aba94002b6a15c7$var$Activity({
    prop: 'activity',
    api: $9aba94002b6a15c7$var$api
});
const $9aba94002b6a15c7$var$workout = new $9aba94002b6a15c7$var$Workout({
    prop: 'workout',
    api: $9aba94002b6a15c7$var$api
});
const $9aba94002b6a15c7$var$workouts = new $9aba94002b6a15c7$var$Workouts({
    prop: 'workouts',
    workoutModel: $9aba94002b6a15c7$var$workout
});
const $9aba94002b6a15c7$var$planned = new $9aba94002b6a15c7$var$Planned({
    prop: 'planned',
    workoutModel: $9aba94002b6a15c7$var$workout,
    api: $9aba94002b6a15c7$var$api
});
const $9aba94002b6a15c7$var$session = $9aba94002b6a15c7$var$Session();
let $9aba94002b6a15c7$export$f14fa567d4bea4ac = {
    power: $9aba94002b6a15c7$var$power,
    heartRate: $9aba94002b6a15c7$var$heartRate,
    cadence: $9aba94002b6a15c7$var$cadence,
    speed: $9aba94002b6a15c7$var$speed,
    smo2: $9aba94002b6a15c7$var$smo2,
    thb: $9aba94002b6a15c7$var$thb,
    sources: $9aba94002b6a15c7$var$sources,
    virtualState: $9aba94002b6a15c7$var$virtualState,
    power1s: $9aba94002b6a15c7$var$power1s,
    power3s: $9aba94002b6a15c7$var$power3s,
    powerLap: $9aba94002b6a15c7$var$powerLap,
    powerAvg: $9aba94002b6a15c7$var$powerAvg,
    powerInZone: $9aba94002b6a15c7$var$powerInZone,
    kcal: $9aba94002b6a15c7$var$kcal,
    heartRateLap: $9aba94002b6a15c7$var$heartRateLap,
    heartRateAvg: $9aba94002b6a15c7$var$heartRateAvg,
    cadenceLap: $9aba94002b6a15c7$var$cadenceLap,
    cadenceAvg: $9aba94002b6a15c7$var$cadenceAvg,
    powerTarget: $9aba94002b6a15c7$var$powerTarget,
    resistanceTarget: $9aba94002b6a15c7$var$resistanceTarget,
    slopeTarget: $9aba94002b6a15c7$var$slopeTarget,
    cadenceTarget: $9aba94002b6a15c7$var$cadenceTarget,
    mode: $9aba94002b6a15c7$var$mode,
    page: $9aba94002b6a15c7$var$page,
    ftp: $9aba94002b6a15c7$var$ftp,
    weight: $9aba94002b6a15c7$var$weight,
    dockMode: $9aba94002b6a15c7$var$dockMode,
    volume: $9aba94002b6a15c7$var$volume,
    theme: $9aba94002b6a15c7$var$theme,
    measurement: $9aba94002b6a15c7$var$measurement,
    dataTileSwitch: $9aba94002b6a15c7$var$dataTileSwitch,
    activity: $9aba94002b6a15c7$var$activity,
    workout: $9aba94002b6a15c7$var$workout,
    workouts: $9aba94002b6a15c7$var$workouts,
    planned: $9aba94002b6a15c7$var$planned,
    session: $9aba94002b6a15c7$var$session,
    PropInterval: $9aba94002b6a15c7$var$PropInterval,
    api: $9aba94002b6a15c7$var$api
};



const $cd49d00d6f1363b1$var$notes = [
    {},
    // 0
    {},
    // 1
    {},
    // 2
    {
        c: 130.81,
        'c#': 138.59,
        d: 146.83,
        'd#': 155.56,
        e: 164.81,
        f: 174.61,
        'f#': 185.00,
        g: 196.00,
        'g#': 207.65,
        a: 220.00,
        'a#': 233.08,
        b: 246.94
    },
    // 3
    {
        c: 261.63,
        'c#': 277.18,
        d: 293.66,
        'd#': 311.13,
        e: 329.63,
        f: 349.23,
        'f#': 369.99,
        g: 392.00,
        'g#': 415.30,
        a: 440.00,
        'a#': 466.16,
        b: 493.88
    },
    // 4
    {
        c: 523.25,
        'c#': 554.37,
        d: 587.33,
        'd#': 622.25,
        e: 659.25,
        f: 698.46,
        'f#': 739.99,
        g: 783.99,
        'g#': 830.61,
        a: 880.00,
        'a#': 932.33,
        b: 987.77
    } // 5
];
function $cd49d00d6f1363b1$export$85990f0f98a390bb(args) {
    let vibrate = false;
    let volume = args.volume ?? 0;
    let audioContext;
    let oscillator;
    let abortController;
    function start() {
        abortController = new AbortController();
        let signal = {
            signal: abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:volume`, (x)=>{
            volume = x;
        }, signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('watch:started', (_)=>{
            if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(audioContext)) audioContext = new AudioContext();
        }, signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('watch:beep', (_)=>{
            interval();
        }, signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('watch:paused', (_)=>{
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(oscillator)) audioContext.suspend();
        }, signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('watch:started', (_)=>{
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(audioContext) && (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(oscillator)) {
                if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(audioContext.state, 'suspended')) audioContext.resume();
            }
        }, signal);
    }
    function stop() {
        abortController.abort();
    }
    // one standart triange wave,
    // gain is turned up and down to produce beeps,
    function interval() {
        const options = {
            type: 'triangle'
        };
        oscillator = new OscillatorNode(audioContext, options);
        const gainNode = audioContext.createGain();
        const high = volume / 100;
        const low = 0;
        const time = audioContext.currentTime;
        gainNode.gain.setTargetAtTime(low, time, 0);
        gainNode.gain.setTargetAtTime(high, time + 0.84, 0.001);
        gainNode.gain.setTargetAtTime(low, time + 1.00, 0.001);
        gainNode.gain.setTargetAtTime(high, time + 1.84, 0.001);
        gainNode.gain.setTargetAtTime(low, time + 2.00, 0.001);
        gainNode.gain.setTargetAtTime(high, time + 2.84, 0.001);
        gainNode.gain.setTargetAtTime(low, time + 3.00, 0.001);
        gainNode.gain.setTargetAtTime(high, time + 3.84, 0.001);
        gainNode.gain.setTargetAtTime(low, time + 4.00, 0.001);
        oscillator.frequency.setValueAtTime($cd49d00d6f1363b1$var$notes[5].c, time);
        oscillator.frequency.setValueAtTime($cd49d00d6f1363b1$var$notes[5].a, time + 3.74);
        oscillator.connect(gainNode).connect(audioContext.destination);
        oscillator.start(time);
        oscillator.stop(time + 4.15);
    }
    // 2 canceling sine waves,
    // and gain is turned up and down on the first one to produce beeps
    function customWaveInterval() {
        const n = 2;
        const waves = [
            {
                real: new Float32Array(n),
                imag: new Float32Array(n)
            },
            {
                real: new Float32Array(n),
                imag: new Float32Array(n)
            }
        ];
        waves[0].real[0] = 0;
        waves[0].imag[0] = 0;
        waves[0].real[1] = 1;
        waves[0].imag[1] = 0;
        waves[1].real[0] = 0;
        waves[1].imag[0] = 0;
        waves[1].real[1] = -1;
        waves[1].imag[1] = 0;
        const wave1 = audioContext.createPeriodicWave(waves[0].real, waves[0].imag);
        const wave2 = audioContext.createPeriodicWave(waves[1].real, waves[1].imag);
        let osc1 = new OscillatorNode(audioContext, {});
        let osc2 = new OscillatorNode(audioContext, {});
        osc1.setPeriodicWave(wave1);
        osc2.setPeriodicWave(wave2);
        const gainNode1 = audioContext.createGain();
        const gainNode2 = audioContext.createGain();
        const high = 1;
        const low = 0;
        const fade = 0.015;
        const time = audioContext.currentTime;
        gainNode1.gain.setTargetAtTime(low, time + 0.84, fade);
        gainNode1.gain.setTargetAtTime(high, time + 1.00, fade);
        gainNode1.gain.setTargetAtTime(low, time + 1.84, fade);
        gainNode1.gain.setTargetAtTime(high, time + 2.00, fade);
        gainNode1.gain.setTargetAtTime(low, time + 2.84, fade);
        gainNode1.gain.setTargetAtTime(high, time + 3.00, fade);
        gainNode1.gain.setTargetAtTime(low, time + 3.84, fade);
        gainNode1.gain.setTargetAtTime(low, time + 4.00, fade);
        gainNode2.gain.setTargetAtTime(low, time + 4.00, fade);
        osc1.frequency.setValueAtTime($cd49d00d6f1363b1$var$notes[4].c, time);
        osc1.frequency.setValueAtTime($cd49d00d6f1363b1$var$notes[4].a, time + 3.84);
        osc2.frequency.setValueAtTime($cd49d00d6f1363b1$var$notes[4].c, time);
        osc2.frequency.setValueAtTime($cd49d00d6f1363b1$var$notes[4].a, time + 3.84);
        osc1.connect(gainNode1).connect(audioContext.destination);
        osc2.connect(gainNode2).connect(audioContext.destination);
        osc1.start(time);
        osc1.stop(time + 4.15);
        osc2.start(time);
        osc2.stop(time + 4.15);
    }
    return Object.freeze({
        start: start,
        stop: stop,
        interval: interval
    });
}





// import { trainerMock } from './simulation-scripts.js';
let $961577053109551e$export$f932f06c7eb6abeb = {
    // Data Screen
    power: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).power.default,
    heartRate: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRate.default,
    rrInterval: [],
    cadence: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadence.default,
    speed: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).speed.default,
    sources: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.default,
    smo2: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).smo2.default,
    thb: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).thb.default,
    coreBodyTemperature: 0,
    skinTemperature: 0,
    position_lat: 0,
    position_long: 0,
    speedVirtual: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).virtualState.speed,
    altitude: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).virtualState.altitude,
    distance: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).virtualState.distance,
    ascent: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).virtualState.ascent,
    power1s: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).power1s.default,
    power3s: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).power3s.default,
    powerInZone: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerInZone.default,
    powerLap: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerLap.default,
    heartRateLap: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateLap.default,
    cadenceLap: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceLap.default,
    kcal: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).kcal.default,
    powerAvg: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerAvg.default,
    cadenceAvg: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceAvg.default,
    heartRateAvg: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateAvg.default,
    powerLapCount: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerLap.count,
    heartRateLapCount: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateLap.count,
    cadenceLapCount: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceLap.count,
    powerAvgCount: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerAvg.count,
    cadenceAvgCount: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceAvg.count,
    heartRateAvgCount: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateAvg.count,
    heartRateMax: 0,
    // Targets
    powerTarget: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerTarget.default,
    powerScale: 100,
    resistanceTarget: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).resistanceTarget.default,
    slopeTarget: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).slopeTarget.default,
    cadenceTarget: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceTarget.default,
    mode: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).mode.default,
    page: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).page.default,
    lock: false,
    // Profile
    ftp: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.default,
    weight: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).weight.default,
    theme: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).theme.default,
    dockMode: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.default,
    measurement: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.default,
    volume: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.default,
    // UI options
    powerSmoothing: 0,
    dataTileSwitch: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dataTileSwitch.default,
    auth: ':login',
    // Workouts
    workouts: [],
    workout: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workout.default,
    // Activities
    activity: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.default,
    // Recording
    records: [],
    lap: [],
    laps: [],
    events: [],
    lapStartTime: false,
    // Watch
    elapsed: 0,
    lapTime: 0,
    stepTime: 0,
    intervalIndex: 0,
    stepIndex: 0,
    intervalDuration: 0,
    stepDuration: 0,
    watchStatus: (0, $9a46339c5268bef7$export$b43e4c66e7bb1fc7).stopped,
    workoutStatus: (0, $9a46339c5268bef7$export$b43e4c66e7bb1fc7).stopped,
    // Course
    courseIndex: 0,
    // Request ANT+ Device
    antSearchList: [],
    antDeviceId: {},
    // Services
    services: {
        strava: false,
        intervals: false,
        trainingPeaks: false
    }
};
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).create($961577053109551e$export$f932f06c7eb6abeb);
// Data Screen
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRate.prop, (heartRate, db)=>{
    db.heartRate = heartRate;
    db.heartRateLap = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateLap.setState(heartRate);
    db.heartRateAvg = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateAvg.setState(heartRate);
    db.heartRateLapCount = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateLap.count;
    db.heartRateAvgCount = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateAvg.count;
    if (heartRate > db.heartRateMax) db.heartRateMax = heartRate;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('rrInterval', (rrInterval, db)=>{
    db.rrInterval = rrInterval;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).power.prop, (power, db)=>{
    db.power = power;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadence.prop, (cadence, db)=>{
    db.cadence = cadence;
    db.cadenceLap = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceLap.setState(cadence);
    db.cadenceAvg = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceAvg.setState(cadence);
    db.cadenceLapCount = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceLap.count;
    db.cadenceAvgCount = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceAvg.count;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).speed.prop, (speed, db)=>{
    db.speed = speed;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).smo2.prop, (smo2, db)=>{
    db.smo2 = smo2;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).thb.prop, (thb, db)=>{
    db.thb = thb;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`coreBodyTemperature`, (coreBodyTemperature, db)=>{
    db.coreBodyTemperature = coreBodyTemperature;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`skinTemperature`, (skinTemperature, db)=>{
    db.skinTemperature = skinTemperature;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.prop, (sources, db)=>{
    db.sources = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.set(db.sources, sources);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.backup(db.sources);
    console.log(db.sources);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.prop, (value, db)=>{
    db.dockMode = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.set(value);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.backup(db.dockMode);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('power1s', (power, db)=>{
    db.power1s = power;
    db.powerLap = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerLap.setState(power);
    db.powerAvg = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerAvg.setState(power);
    db.kcal = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).kcal.setState(power);
    db.powerLapCount = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerLap.count;
    db.powerAvgCount = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerAvg.count;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('power3s', (power, db)=>{
    db.power3s = power;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('powerInZone', (powerInZone, db)=>{
    db.powerInZone = powerInZone;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('speedVirtual', (speedVirtual, db)=>{
    db.speedVirtual = speedVirtual;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('altitude', (altitude, db)=>{
    db.altitude = altitude;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ascent', (ascent, db)=>{
    db.ascent = ascent;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('distance', (distance, db)=>{
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(db.watchStatus, 'started')) db.distance = distance;
});
// Pages
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:page-set', (page, db)=>{
    db.page = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).page.set(page);
});
// Modes
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:mode-set', (mode, db)=>{
    if (db.lock) return;
    db.mode = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).mode.set(mode);
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:power-target-set`, db.powerTarget);
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).resistance)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:resistance-target-set`, db.resistanceTarget);
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:slope-target-set`, db.slopeTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:lock-set', (_, db)=>{
    db.lock = !db.lock;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:lock-toggle', (_, db)=>{
    db.lock = !db.lock;
});
// UI options
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:data-tile-switch-set', (index, db)=>{
    db.dataTileSwitch = index;
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dataTileSwitch.backup(db.dataTileSwitch);
});
// Targets
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:power-target-set', (powerTarget, db)=>{
    db.powerTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerTarget.set(powerTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:power-scale-set', (powerScale, db)=>{
    db.powerScale = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerTarget.set(powerScale);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:power-scale-inc', (_, db)=>{
    const newScale = db.powerScale + 5;
    db.powerScale = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerTarget.set(newScale);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:power-scale:update-target');
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`ui:power-scale-dec`, (_, db)=>{
    const newScale = db.powerScale - 5;
    db.powerScale = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerTarget.set(newScale);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:power-scale:update-target');
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:cadence-target-set', (cadenceTarget, db)=>{
    db.cadenceTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceTarget.set(cadenceTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:resistance-target-set', (resistanceTarget, db)=>{
    db.resistanceTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).resistanceTarget.set(resistanceTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:resistance-target-inc', (_, db)=>{
    db.resistanceTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).resistanceTarget.inc(db.resistanceTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`ui:resistance-target-dec`, (_, db)=>{
    db.resistanceTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).resistanceTarget.dec(db.resistanceTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:slope-target-set', (slopeTarget, db)=>{
    db.slopeTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).slopeTarget.set(slopeTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:slope-target-inc', (_, db)=>{
    db.slopeTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).slopeTarget.inc(db.slopeTarget);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`ui:slope-target-dec`, (_, db)=>{
    db.slopeTarget = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).slopeTarget.dec(db.slopeTarget);
});
// Profile
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:ftp-set', (ftp, db)=>{
    db.ftp = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.set(ftp);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.backup(db.ftp);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:weight-set', (weight, db)=>{
    db.weight = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).weight.set(weight);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).weight.backup(db.weight);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:theme-switch', (_, db)=>{
    db.theme = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).theme.switch(db.theme);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).theme.backup(db.theme);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:dock-mode-switch', (_, db)=>{
    db.theme = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.switch(db.dockMode);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.backup(db.dockMode);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:measurement-switch', (_, db)=>{
    db.measurement = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.switch(db.measurement);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.backup(db.measurement);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:volume-mute', (_, db)=>{
    db.volume = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.mute();
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.backup(db.volume);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:volume-down', (_, db)=>{
    db.volume = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.dec(db.volume);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.backup(db.volume);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`ui:volume-up`, (_, db)=>{
    db.volume = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.inc(db.volume);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.backup(db.volume);
});
// Workouts
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('workout', (workout, db)=>{
    db.workout = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workout.set(workout);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:workout:select', (id, db)=>{
    db.workout = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workouts.get(db.workouts, id);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:planned:select', (id, db)=>{
    db.workout = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).planned.get(id);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:workout:remove', (id, db)=>{
    db.workouts = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workouts.remove(db.workouts, id);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:workout:upload', async function(files, db) {
    for (let file of Object.values(files)){
        const { result: result, name: name } = await (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workout.readFromFile(file);
        const workout = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workout.parse(result, name);
        (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workouts.add(db.workouts, workout);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('db:workouts', db);
    }
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('watch:stopped', (_, db)=>{
    try {
        (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.createFromCurrent(db);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('activity:save:success');
    } catch (err) {
        console.error(`Error on activity save: `, err);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('activity:save:fail');
    }
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('activity:save:success', (e, db)=>{
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.reset(db);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('ui:activity:upload:by:id', (id)=>{
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.upload(id);
});
// download the current activity as a .fit file
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:activity:save', (_, db)=>{
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:page-set`, 'workouts');
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('course:index', (index, db)=>{
    db.courseIndex = index;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('course:position', (position, db)=>{
    db.position_lat = position.position_lat;
    db.position_long = position.position_long;
});
// Wake Lock
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('lock:beforeunload', (e, db)=>{
    // backup session
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.backup(db);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('lock:release', (e, db)=>{
    // backup session
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.backup(db);
});
// Request ANT+ Device
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:ant:request:selected', (x, db)=>{
    db.antDeviceId = db.antSearchList.filter((d)=>{
        return d.deviceNumber === parseInt(x);
    })[0];
});
function $961577053109551e$var$includesDevice(devices, id) {
    return devices.filter((d)=>d.deviceNumber === id.deviceNumber).length > 0;
}
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`ant:search:device-found`, (x, db)=>{
    if ($961577053109551e$var$includesDevice(db.antSearchList, x)) return;
    db.antSearchList.push(x);
    db.antSearchList = db.antSearchList;
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`ant:search:stopped`, (x, db)=>{
    db.antSearchList = [];
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('auth', (x, db)=>{
// TODO: remove?
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('services', (x, db)=>{
    db.services = Object.assign(db.services, x);
});
//
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('app:start', async function(_, db) {
    db.dockMode = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.restore());
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.apply(db.dockMode);
    db.ftp = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.restore());
    db.weight = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).weight.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).weight.restore());
    db.theme = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).theme.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).theme.restore());
    db.measurement = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.restore());
    db.volume = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).volume.restore());
    db.dataTileSwitch = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dataTileSwitch.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dataTileSwitch.restore()), db.sources = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.set((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.restore());
    // IndexedDB Schema Version 3
    await (0, $e655ee46f487092f$export$53df56d89c7d7ac4).start('store', 3, [
        'session',
        'workouts',
        'activity'
    ]);
    db.workouts = await (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workouts.restore();
    db.activity = await (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.restore();
    db.workout = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).workout.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).planned.restore();
    await (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.restore(db);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('workout:restore');
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('activity:restore');
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).kcal.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerLap.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).powerAvg.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceLap.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).cadenceAvg.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateLap.restore(db);
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).heartRateAvg.restore(db);
    const sound = (0, $cd49d00d6f1363b1$export$85990f0f98a390bb)({
        volume: db.volume
    });
    sound.start();
    (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api.start();
// TODO: remove
// xf.dispatch(`ui:page-set`, 'workouts');
// TRAINER MOCK
// trainerMock.init();
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg('ui:power-scale:update-target', (_, db)=>{
    if (db.workoutStatus === 'started' && (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(db.workout.intervals)) {
        const currentStep = db.workout.intervals[db.intervalIndex].steps[db.stepIndex];
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(currentStep.power)) {
            const basePower = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(currentStep.power, db.ftp);
            const scaledPower = basePower * (db.powerScale / 100);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:power-target-set', scaledPower);
        }
    }
});
function $961577053109551e$var$start() {
    console.log('start db');
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('db:start');
// UI test
// setInterval(function() {
//     xf.dispatch('watch:elapsed', 1);
//     xf.dispatch('power', 180);
//     xf.dispatch('cadence', 80);
//     xf.dispatch('heartRate', 140 + (Math.random() * 10));
//     xf.dispatch('smo2', 71.17); // + (Math.random() * 10));
//     xf.dispatch('thb', 11.14); // + (Math.random() / 2));
//     xf.dispatch('coreBodyTemperature', 38.12);
//     xf.dispatch('skinTemperature', 38.47);
// }, 1000);
// end UI test
}
$961577053109551e$var$start();




class $9a75f2bf87d8b1dc$export$6eb75ca500ea128b extends HTMLElement {
    constructor(){
        super();
        this.status = 'off';
    }
    getDefaults() {
        return {
            class: {
                on: 'on',
                off: 'off',
                loading: 'loading',
                indicator: 'connection-switch--indicator'
            }
        };
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.for = this.getAttribute('for');
        this.onClass = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('onClass'), this.getDefaults().class.on);
        this.offClass = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('offClass'), this.getDefaults().class.off);
        this.loadingClass = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('loadingClass'), this.getDefaults().class.loading);
        this.indicatorClass = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('indicatorClass'), this.getDefaults().class.indicator);
        this.$indicator = this.querySelector(`.${this.indicatorClass}`) ?? this;
        this.addEventListener('pointerup', this.onEffect.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.for}:connected`, this.on.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.for}:disconnected`, this.off.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.for}:connecting`, this.loading.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    defaultOnClass() {
        return;
    }
    defaultOffClass() {
        return;
    }
    defaultLoadingClass() {
        return;
    }
    defaultIndicatorClass() {
        return;
    }
    onEffect(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.for}:switch`);
    }
    on(e) {
        this.$indicator.classList.remove(this.loadingClass);
        this.$indicator.classList.remove(this.offClass);
        this.$indicator.classList.add(this.onClass);
        this.status = 'on';
    }
    off(e) {
        this.$indicator.classList.remove(this.loadingClass);
        this.$indicator.classList.remove(this.onClass);
        this.$indicator.classList.add(this.offClass);
        this.status = 'off';
    }
    loading(e) {
        this.$indicator.classList.remove(this.offClass);
        this.$indicator.classList.remove(this.onClass);
        this.$indicator.classList.add(this.loadingClass);
        this.status = 'loading';
    }
}
customElements.define('connection-switch', $9a75f2bf87d8b1dc$export$6eb75ca500ea128b);
class $9a75f2bf87d8b1dc$var$ProtocolSwitch extends $9a75f2bf87d8b1dc$export$6eb75ca500ea128b {
    constructor(){
        super();
        this.confirmMsg = "Proceeding will stop the ANT+ driver! Are you sure?";
    }
    getDefaults() {
        return {
            class: {
                on: 'on',
                off: 'off',
                loading: 'loading',
                indicator: 'this'
            }
        };
    }
    onEffect(e) {
        console.log(this.status);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.status, 'on') || (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.status, 'loading')) {
            const proceed = confirm(this.confirmMsg);
            if (proceed) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.for}:switch`);
        } else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.for}:switch`);
    }
}
customElements.define('protocol-switch', $9a75f2bf87d8b1dc$var$ProtocolSwitch);
class $9a75f2bf87d8b1dc$export$2c19b1e5755eb0e7 extends HTMLElement {
    constructor(){
        super();
        this.prop = 'db:sources';
        this.effect = 'sources';
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.path = this.getAttribute('for');
        this.value = this.getAttribute('use');
        this.$dataView = this.querySelector('.data-view');
        this.$toggle = this.querySelector('.toggle--button');
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        this.addEventListener('pointerup', this.onEffect.bind(this), this.signal);
        this.render();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onUpdate(sources) {
        this.render();
    }
    onEffect(e) {
        const update = {};
        update[this.path] = this.value;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, update);
    }
    disable() {
        this.classList.add('active');
        this.$dataView.removeAttribute('disabled');
        if (this.$toggle) this.$toggle.classList.add('active');
    }
    enable() {
        this.classList.remove('active');
        this.$dataView.setAttribute('disabled', '');
        if (this.$toggle) this.$toggle.classList.remove('active');
    }
    render() {
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource(this.path, this.value)) this.disable();
        else this.enable();
    }
}
customElements.define('source-switch', $9a75f2bf87d8b1dc$export$2c19b1e5755eb0e7);
class $9a75f2bf87d8b1dc$var$ANTDeviceRequest extends HTMLElement {
    constructor(){
        super();
        this.devices = new Map();
        this.selected = undefined;
        this._status = 'closed';
        this.listSelector = '.device-request--list';
        this.cancelSelector = '#device-request--cancel';
        this.pairSelector = '#device-request--pair';
    }
    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
        console.log(this._status);
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$list = this.querySelector(this.listSelector);
        this.$cancelBtn = this.querySelector(this.cancelSelector);
        this.$pairBtn = this.querySelector(this.pairSelector);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:search:start`, this.onStart.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:search:cancel`, this.onCancel.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:search:found`, this.onFound.bind(this), this.signal);
        this.$list.addEventListener(`pointerup`, this.onSelectAction.bind(this), this.signal);
        this.$cancelBtn.addEventListener(`pointerup`, this.onCancelAction.bind(this), this.signal);
        this.$pairBtn.addEventListener(`pointerup`, this.onPairAction.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onStart() {
        this.open();
    }
    onCancel() {
        this.close();
    }
    onPair() {
        this.pair();
        this.close();
    }
    onFound(channelId) {
        this.add(channelId);
    }
    onLost(device) {
        this.remove(device);
    }
    onSelectAction(e) {
        const el = e.target.closest('.device-request--item');
        const els = this.$list.querySelectorAll('.device-request--item');
        if (el === undefined || el === null) return;
        if (el.id === undefined) return;
        els.forEach((el)=>el.classList.remove('active'));
        el.classList.add('active');
        this.select(parseInt(el.id));
    }
    onCancelAction() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ant:search:cancel`);
    }
    onPairAction() {
        this.pair();
    }
    open() {
        this.status = 'opened';
        this.classList.add('active');
    }
    close() {
        this.status = 'closed';
        this.clear();
        this.classList.remove('active');
    }
    select(deviceNumber) {
        const channelId = this.devices.get(deviceNumber);
        this.selected = channelId;
        console.log(`:device-selected ${channelId}`);
    }
    pair() {
        this.status = 'pairing';
        this.close();
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ant:search:pair', this.selected);
    }
    deviceItemTemplate(args = {
        deviceNumber: '--',
        deviceType: '--'
    }) {
        return `<div class="device-request--item" id="${args.deviceNumber}">
        <div class="device-request--item--protocol">ANT+</div>
        <div class="device-request--item--number">${args.deviceNumber}</div>
        <div class="device-request--item--type">${args.deviceType}</div>
     </div>`;
    }
    add(channelId) {
        if (this.devices.has(channelId.deviceNumber)) return;
        this.devices.set(channelId.deviceNumber, channelId);
        const item = this.deviceItemTemplate(channelId);
        this.$list.insertAdjacentHTML('beforeend', item);
    }
    remove(device) {
        const item = this.$list.querySelector(`#${device.deviceNumber}`);
        this.$list.removeChild(item);
    }
    clear() {
        this.$list.innerHTML = '';
        this.devices = new Map();
    }
}
customElements.define('ant-device-request', $9a75f2bf87d8b1dc$var$ANTDeviceRequest);






//
// DataView
//
// Usage:
// <data-view id="count-value" prop="db:count">--</data-view>
//
// Template Method:
// overwrite methods to augment the general logic
//
// getDefaults() -> setup default and fallback values
// config()      -> work with attributes and props here
// subs()        -> subscribe to events or db
// unsubs()      -> executes after abort signal
// getValue()    -> getter for the value for state from a complex prop say an object or array
// onUpdate()    -> determine the rules for state update that will trigger rendering
// transform()   -> apply transforming functions to state just before rendering
//
class $9b54029243cc3f84$export$5e15d737b33a1c27 extends HTMLElement {
    constructor(){
        super();
        this.state = '';
        this.postInit();
    }
    postInit() {
        return;
    }
    static get observedAttributes() {
        return [
            'disabled'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(name, 'disabled')) this.disabled = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(newValue) ? true : false;
    }
    getDefaults() {
        return {
            prop: ''
        };
    }
    config() {
        return;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.prop = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('prop'), this.getDefaults().prop);
        this.disabled = this.hasAttribute('disabled');
        this.config();
        this.subs();
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
        this.unsubs();
    }
    unsubs() {}
    getValue(propValue) {
        return propValue;
    }
    shouldUpdate(value) {
        return !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, this.state) && !this.disabled;
    }
    updateState(value) {
        this.state = value;
    }
    onUpdate(propValue) {
        const value = this.getValue(propValue);
        if (this.shouldUpdate(value)) {
            this.updateState(value);
            this.render();
        }
    }
    transform(state) {
        return state;
    }
    render() {
        this.textContent = this.transform(this.state);
    }
}
customElements.define('data-view', $9b54029243cc3f84$export$5e15d737b33a1c27);
class $9b54029243cc3f84$var$AutoStartCounter extends HTMLElement {
    constructor(){
        super();
        this.isVisible = false;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('ui:autoStartCounter', this.onUpdate.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onUpdate(value) {
        if (value === -1) this.hide();
        else {
            if (!this.isVisible) this.show();
            this.render(value);
        }
    }
    show() {
        this.classList.add('active');
    }
    hide() {
        this.classList.remove('active');
    }
    render(value) {
        this.textContent = value;
    }
}
customElements.define('auto-start-counter', $9b54029243cc3f84$var$AutoStartCounter);
class $9b54029243cc3f84$var$ModeLockToggle extends HTMLElement {
    constructor(){
        super();
        this.isOn = false;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$icon = this.querySelector('.mode-lock--toggle--icon');
        this.$use = this.querySelector('use');
        this.addEventListener('pointerup', this.onPointerup.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:lock', this.onUpdate.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onUpdate(value) {
        this.isOn = value;
        this.render();
    }
    onPointerup() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:lock-set');
    }
    render() {
        if (this.isOn) this.$use.setAttribute('href', '#icon--lock--close');
        else this.$use.setAttribute('href', '#icon--lock--open');
    }
}
customElements.define('mode-lock-toggle', $9b54029243cc3f84$var$ModeLockToggle);
class $9b54029243cc3f84$export$d10f777f3d0cf87b extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            format: 'hh:mm:ss',
            prop: 'db:elapsed'
        };
    }
    config() {
        this.format = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('format'), this.getDefaults().format);
    }
    transform(state) {
        return (0, $820877bea407f5fe$export$3203edd9e5edd663)({
            value: this.state,
            format: this.format,
            unit: 'seconds'
        });
    }
}
customElements.define('timer-time', $9b54029243cc3f84$export$d10f777f3d0cf87b);
class $9b54029243cc3f84$export$6d5168a4256d3200 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            format: 'mm:ss',
            prop: 'db:lapTime'
        };
    }
    config() {
        this.format = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(this.getAttribute('format'), this.getDefaults().format);
    }
    transform(state) {
        return (0, $820877bea407f5fe$export$3203edd9e5edd663)({
            value: this.state,
            format: this.format,
            unit: 'seconds'
        });
    }
}
customElements.define('interval-time', $9b54029243cc3f84$export$6d5168a4256d3200);
class $9b54029243cc3f84$export$866b9647f641ac91 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.measurement = this.getDefaults().measurement;
    }
    getDefaults() {
        return {
            prop: 'db:speed',
            measurement: 'metric'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:measurement`, this.onMeasurement.bind(this), this.signal);
    }
    onMeasurement(measurement) {
        this.measurement = measurement;
    }
    format(value, measurement = 'metric') {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(measurement, 'imperial')) value = `${(0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).speed.mpsToMph(value).toFixed(1)}`;
        else value = `${(0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).speed.mpsToKmh(value).toFixed(1)}`;
        return value;
    }
    transform(state) {
        return this.format(state, this.measurement);
    }
}
customElements.define('speed-value', $9b54029243cc3f84$export$866b9647f641ac91);
class $9b54029243cc3f84$var$SpeedVirtual extends $9b54029243cc3f84$export$866b9647f641ac91 {
    getDefaults() {
        return {
            prop: 'db:speedVirtual',
            measurement: 'metric'
        };
    }
}
customElements.define('speed-virtual', $9b54029243cc3f84$var$SpeedVirtual);
class $9b54029243cc3f84$var$SpeedSwitch extends $9b54029243cc3f84$export$866b9647f641ac91 {
    postInit() {
        this.measurement = this.getDefaults().measurement;
    }
    getDefaults() {
        return {
            prop: '',
            measurement: 'metric'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:speed`, this.onSpeed.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:speedVirtual`, this.onSpeedVirtual.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:measurement`, this.onMeasurement.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:sources`, this.onSources.bind(this), this.signal);
    }
    onSpeed(value) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.source, 'speed')) this.onUpdate(value);
    }
    onSpeedVirtual(value) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.source, 'power')) this.onUpdate(value);
    }
    onSources(sources) {
        this.source = sources.virtualState;
    }
}
customElements.define('speed-switch', $9b54029243cc3f84$var$SpeedSwitch);
class $9b54029243cc3f84$export$36def2afa5ee6c1e extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.measurement = this.getDefaults().measurement;
    }
    getDefaults() {
        return {
            prop: 'db:distance',
            measurement: 'metric'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:measurement`, this.onMeasurement.bind(this), this.signal);
    }
    onMeasurement(measurement) {
        this.measurement = measurement;
    }
    metersToYards(meters) {
        return 1.09361 * meters;
    }
    format(meters, measurement = 'metric') {
        let value = `0`;
        const km = meters / 1000;
        const miles = meters / 1609.34;
        const yards = this.metersToYards(meters);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(measurement, 'imperial')) {
            const yardsTemplate = `${this.metersToYards(meters).toFixed(0)}`;
            const milesTemplate = `${miles.toFixed(2)}`;
            return value = yards < 1609.34 ? yardsTemplate : milesTemplate;
        } else {
            const metersTemplate = `${meters.toFixed(0)}`;
            const kmTemplate = `${km.toFixed(2)}`;
            return value = meters < 1000 ? metersTemplate : kmTemplate;
        }
    }
    transform(state) {
        return this.format(state, this.measurement);
    }
}
customElements.define('distance-value', $9b54029243cc3f84$export$36def2afa5ee6c1e);
class $9b54029243cc3f84$var$AltitudeValue extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:altitude'
        };
    }
    transform(state) {
        return state.toFixed(1);
    }
}
customElements.define('altitude-value', $9b54029243cc3f84$var$AltitudeValue);
class $9b54029243cc3f84$var$AscentValue extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:ascent'
        };
    }
    transform(state) {
        return state.toFixed(1);
    }
}
customElements.define('ascent-value', $9b54029243cc3f84$var$AscentValue);
class $9b54029243cc3f84$export$f3d4df7b8e09ae0e extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:cadence'
        };
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('cadence-value', $9b54029243cc3f84$export$f3d4df7b8e09ae0e);
class $9b54029243cc3f84$export$a6dc7cc4f9dc1e9c extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:cadenceLap'
        };
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('cadence-lap-value', $9b54029243cc3f84$export$a6dc7cc4f9dc1e9c);
class $9b54029243cc3f84$export$d4989acf8efc5123 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:cadenceAvg'
        };
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('cadence-avg-value', $9b54029243cc3f84$export$d4989acf8efc5123);
class $9b54029243cc3f84$export$61ec540d7b0e5c4a extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:cadenceTarget'
        };
    }
    transform(state) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(state, 0)) return '';
        return state;
    }
}
customElements.define('cadence-target', $9b54029243cc3f84$export$61ec540d7b0e5c4a);
class $9b54029243cc3f84$export$2e0cf70aca42787c extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:cadenceTarget'
        };
    }
    config() {
        this.$main = this.querySelector('cadence-value');
        this.$aux = this.querySelector('cadence-target');
    }
    render() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 0)) {
            this.$main.classList.remove('active');
            this.$aux.classList.remove('active');
        } else {
            this.$main.classList.add('active');
            this.$aux.classList.add('active');
        }
    }
}
customElements.define('cadence-group', $9b54029243cc3f84$export$2e0cf70aca42787c);
class $9b54029243cc3f84$export$db1118f39653f76a extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:heartRate'
        };
    }
    transform(state) {
        this.style = 'color: #FE340B';
        return Math.round(state);
    }
}
customElements.define('heart-rate-value', $9b54029243cc3f84$export$db1118f39653f76a);
class $9b54029243cc3f84$export$f225b60a6b8728f0 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:heartRateLap'
        };
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('heart-rate-lap-value', $9b54029243cc3f84$export$f225b60a6b8728f0);
class $9b54029243cc3f84$export$b5d055a460f0faac extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:heartRateAvg'
        };
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('heart-rate-avg-value', $9b54029243cc3f84$export$b5d055a460f0faac);
class $9b54029243cc3f84$var$HeartRateMaxValue extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:heartRateMax'
        };
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('heart-rate-max-value', $9b54029243cc3f84$var$HeartRateMaxValue);
class $9b54029243cc3f84$export$a735b5d697c75f00 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:smo2'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    // this.style = 'color: #2A5F97';
    // this.style = 'color: #278B65';
    // this.style = 'color: #D72A1C';
    transform(state) {
        // if(state < models.smo2.zones.one) {
        //     this.style = 'color: #328AFF';
        // } else if(state < models.smo2.zones.two) {
        //     this.style = 'color: #56C057';
        // } else {
        //     this.style = 'color: #FE340B';
        // }
        this.style = 'color: #56C057';
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(state, 1);
    }
}
customElements.define('smo2-value', $9b54029243cc3f84$export$a735b5d697c75f00);
class $9b54029243cc3f84$export$a66d3877d78f1036 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:thb'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    transform(state) {
        this.style = 'color: #FF663A';
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(state, 2);
    }
}
customElements.define('thb-value', $9b54029243cc3f84$export$a66d3877d78f1036);
class $9b54029243cc3f84$var$CoreBodyTemperatureValue extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.measurement = this.getDefaults().measurement;
    }
    getDefaults() {
        return {
            prop: 'db:coreBodyTemperature',
            measurement: 'metric'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:measurement`, this.onMeasurement.bind(this), this.signal);
    }
    onMeasurement(measurement) {
        this.measurement = measurement;
    }
    celsiusToFahrenheit(celsius) {
        return Math.round((celsius * 9 / 5 + 32) * 100) / 100;
    }
    format(temperature, measurement = 'metric') {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(measurement, 'imperial')) return this.celsiusToFahrenheit(temperature);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(measurement, 'metric')) return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(temperature);
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(temperature);
    }
    transform(state) {
        return this.format(state, this.measurement);
    }
}
customElements.define('core-body-temperature-value', $9b54029243cc3f84$var$CoreBodyTemperatureValue);
class $9b54029243cc3f84$var$SkinTemperatureValue extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:skinTemperature'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    transform(state) {
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(state, 2);
    }
}
customElements.define('skin-temperature-value', $9b54029243cc3f84$var$SkinTemperatureValue);
class $9b54029243cc3f84$export$72321a2146273eac extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:workout'
        };
    }
    getValue(propValue) {
        return propValue.meta.name;
    }
}
customElements.define('workout-name', $9b54029243cc3f84$export$72321a2146273eac);
class $9b54029243cc3f84$export$2eefb26d5d9aa7c6 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:powerTarget'
        };
    }
}
customElements.define('power-target', $9b54029243cc3f84$export$2eefb26d5d9aa7c6);
class $9b54029243cc3f84$var$PowerTargetFTP extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:powerTarget'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:ftp`, this.onFTP.bind(this), this.signal);
    }
    onFTP(ftp) {
        this.ftp = ftp;
    }
    toPercentage(state, ftp) {
        return Math.round(state * 100 / ftp);
    }
    transform(state) {
        return `${this.toPercentage(state, this.ftp)}%`;
    }
}
customElements.define('power-target-ftp', $9b54029243cc3f84$var$PowerTargetFTP);
class $9b54029243cc3f84$var$CompanionGroup extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: '',
            active: false
        };
    }
    config() {
        this.$main = this.querySelector('.companion-main');
        this.$aux = this.querySelector('.companion-aux');
    }
    subs() {
        this.addEventListener(`pointerup`, this.onPointerup.bind(this), this.signal);
    }
    onPointerup() {
        this.active = !this.active;
        this.render();
    }
    render() {
        if (this.active) {
            this.$main.classList.add('active');
            this.$aux.classList.add('active');
        } else {
            this.$main.classList.remove('active');
            this.$aux.classList.remove('active');
        }
    }
}
customElements.define('companion-group', $9b54029243cc3f84$var$CompanionGroup);
class $9b54029243cc3f84$var$ZStack extends HTMLElement {
    constructor(){
        super();
        this.items = [];
        this.activeIndex = 0;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$items = this.querySelectorAll('z-stack-item');
        this.key = this.dataset.key;
        this.persistance = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.key) ? true : false;
        this.hasSwitchSub = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.dataset.sub);
        if (this.hasSwitchSub) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(this.$sub, this.onSwitch.bind(this), this.signal);
        else this.addEventListener(`pointerup`, this.onSwitch.bind(this), this.signal);
        if (this.persistance) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:sources`, this.onSources.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onSources(value) {
        const index = parseInt(value[this.key] ?? this.activeIndex);
        // console.log(`:onSources ${index} === ${this.activeIndex}`);
        if (index === this.activeIndex) return;
        this.activeIndex = index;
        this.render();
    }
    onSwitch() {
        this.incrementActive();
        this.render();
        if (this.persistance) this.backup();
    }
    backup() {
        const update = {};
        update[this.key] = this.activeIndex;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`sources`, update);
    }
    incrementActive() {
        this.activeIndex = (this.activeIndex + 1) % Math.max(this.$items.length, 1);
    }
    render() {
        this.$items.forEach(($item, i)=>{
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(i, this.activeIndex)) $item.classList.add('active');
            else $item.classList.remove('active');
        });
    }
}
customElements.define('z-stack', $9b54029243cc3f84$var$ZStack);
class $9b54029243cc3f84$export$800ba388dcad0c02 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:slopeTarget'
        };
    }
    transform(state) {
        return state.toFixed(1);
    }
}
customElements.define('slope-target', $9b54029243cc3f84$export$800ba388dcad0c02);
class $9b54029243cc3f84$var$PowerTargetControl extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        const self = this;
        this.state = 0;
    }
    setDefaults() {
        this.prop = 'db:powerTarget';
        this.selectors = {
            input: '#power-target-input',
            inc: '#power-target-inc',
            dec: '#power-target-dec'
        };
        this.effects = {
            inc: 'power-target-inc',
            dec: 'power-target-dec',
            set: 'power-target-set'
        };
        this.parse = parseInt;
    }
    config() {
        this.setDefaults();
        this.$input = document.querySelector(this.selectors.input);
        this.$inc = document.querySelector(this.selectors.inc);
        this.$dec = document.querySelector(this.selectors.dec);
    }
    subs() {
        this.$input.addEventListener('change', this.onChange.bind(this), this.signal);
        this.$inc.addEventListener('pointerup', this.onInc.bind(this), this.signal);
        this.$dec.addEventListener('pointerup', this.onDec.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    onInc(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effects.inc}`);
    }
    onDec(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effects.dec}`);
    }
    onChange(e) {
        this.state = this.parse(e.target.value);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effects.set}`, this.state);
    }
    render() {
        this.$input.value = this.transform(this.state);
    }
}
customElements.define('power-target-control', $9b54029243cc3f84$var$PowerTargetControl);
class $9b54029243cc3f84$var$ResistanceTargetControl extends $9b54029243cc3f84$var$PowerTargetControl {
    setDefaults() {
        this.prop = 'db:resistanceTarget';
        this.selectors = {
            input: '#resistance-target-input',
            inc: '#resistance-target-inc',
            dec: '#resistance-target-dec'
        };
        this.effects = {
            inc: 'resistance-target-inc',
            dec: 'resistance-target-dec',
            set: 'resistance-target-set'
        };
        this.parse = parseInt;
    }
}
customElements.define('resistance-target-control', $9b54029243cc3f84$var$ResistanceTargetControl);
class $9b54029243cc3f84$var$SlopeTargetControl extends $9b54029243cc3f84$var$PowerTargetControl {
    setDefaults() {
        this.prop = 'db:slopeTarget';
        this.selectors = {
            input: '#slope-target-input',
            inc: '#slope-target-inc',
            dec: '#slope-target-dec'
        };
        this.effects = {
            inc: 'slope-target-inc',
            dec: 'slope-target-dec',
            set: 'slope-target-set'
        };
        this.parse = parseFloat;
    }
    transform(state) {
        return state.toFixed(1);
    }
}
customElements.define('slope-target-control', $9b54029243cc3f84$var$SlopeTargetControl);
class $9b54029243cc3f84$export$2940075913519887 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:power'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    transform(state) {
        this.style = 'color: #F8C73A';
        return Math.round(state);
    }
}
customElements.define('power-value', $9b54029243cc3f84$export$2940075913519887);
class $9b54029243cc3f84$export$1d49f43ec0e011b3 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:powerAvg'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    transform(state) {
        return Math.ceil(state);
    }
}
customElements.define('power-avg', $9b54029243cc3f84$export$1d49f43ec0e011b3);
class $9b54029243cc3f84$var$PowerLap extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:powerLap'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    transform(state) {
        return Math.ceil(state);
    }
}
customElements.define('power-lap', $9b54029243cc3f84$var$PowerLap);
class $9b54029243cc3f84$var$KcalAvg extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:kcal'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    transform(state) {
        return Math.round(state);
    }
}
customElements.define('kcal-avg', $9b54029243cc3f84$var$KcalAvg);
class $9b54029243cc3f84$var$PowerInZone extends HTMLElement {
    constructor(){
        super();
        this.state = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        this.selectors = {
            values: '.power--zone-value',
            bars: '.power--zone-bar',
            btn: '.power--unit'
        };
        this.format = 'percentage';
        this.prop = 'db:powerInZone';
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$values = this.querySelectorAll(this.selectors.values);
        this.$bars = this.querySelectorAll(this.selectors.bars);
        this.$btn = this.querySelector(this.selectors.btn);
        this.$btn.addEventListener('pointerup', this.onSwitch.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onUpdate(propValue) {
        this.state = propValue;
        this.render();
    }
    onSwitch() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.format, 'time')) {
            this.format = 'percentage';
            this.$btn.textContent = '%';
            this.render();
        } else {
            this.format = 'time';
            this.$btn.textContent = 'min';
            this.render();
        }
    }
    render() {
        for(let i = 0; i < this.state.length; i++){
            let text;
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.format, 'percentage')) text = Math.round(this.state[i][0] * 100);
            else text = (0, $820877bea407f5fe$export$3203edd9e5edd663)({
                value: Math.round(this.state[i][1]),
                format: 'mm:ss'
            });
            const height = `${this.state[i][0] * 100}%`;
            this.$values[i].textContent = text;
            this.$bars[i].style.height = height;
        }
    }
}
customElements.define('power-in-zone', $9b54029243cc3f84$var$PowerInZone);
class $9b54029243cc3f84$var$LapsList extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.isEmpty = true;
    }
    getDefaults() {
        return {
            prop: 'db:lap'
        };
    }
    config() {
        this.$lapsCont = this.querySelector('.laps--cont');
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    toLap(lap, index) {
        const duration = lap.totalElapsedTime;
        const powerLap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], (0, $c6a9e46ee7e4d896$export$a81f732198733497)(lap.avgPower, 0), 0);
        const cadenceLap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], (0, $c6a9e46ee7e4d896$export$a81f732198733497)(lap.avgCadence, 0), 0);
        const heartRateLap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], (0, $c6a9e46ee7e4d896$export$a81f732198733497)(lap.avgHeartRate, 0), 0);
        const zone = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.powerToZone(powerLap).name;
        const smo2Lap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], lap.saturated_hemoglobin_percent, 0);
        const thbLap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], lap.total_hemoglobin_conc, 0);
        const coreTemperatureLap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], lap.core_temperature, 0);
        const skinTemperatureLap = (0, $c6a9e46ee7e4d896$export$a22775fa5e2eebd9)([
            (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17),
            (0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)
        ], lap.skin_temperature, 0);
        return `<div class="lap--item">
                    <div class="lap--item--inner">
                        <div class="lap--value lap--index">${index}</div>
                        <div class="lap--value lap--duration">${(0, $820877bea407f5fe$export$3203edd9e5edd663)({
            value: duration,
            format: 'mm:ss'
        })}</div>
                        <div class="lap--value lap--power zone-${zone}-color">${powerLap} W</div>
                        <div class="lap--value lap--cadence">${cadenceLap}</div>
                        <div class="lap--value lap--heart-rate">${heartRateLap}</div>
                        <div class="lap--value lap--smo2">${smo2Lap.toFixed(2)}</div>
                        <div class="lap--value lap--thb">${thbLap.toFixed(2)}</div>
                        <div class="lap--value lap--core-temperature">${coreTemperatureLap.toFixed(2)}</div>
                        <div class="lap--value lap--skin-temperature">${skinTemperatureLap.toFixed(2)}</div>
                    </div>
                </div>`;
    }
    restore(laps) {
        this.state = laps;
        laps.forEach((lap, index)=>this.render(lap, index + 1));
    }
    onUpdate(propValue, db) {
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(db.laps)) return;
        else if (this.isEmpty) {
            this.restore(db.laps);
            this.isEmpty = false;
        } else {
            this.updateState(db.laps);
            this.render((0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(db.laps), this.state.length);
        }
    }
    render(lap, i) {
        this.$lapsCont.insertAdjacentHTML('afterbegin', this.toLap(lap, i));
    }
}
customElements.define('laps-list', $9b54029243cc3f84$var$LapsList);
function $9b54029243cc3f84$var$scale(value, max = 100) {
    return 100 * (value / max);
}
class $9b54029243cc3f84$export$2897f950f79985da extends HTMLElement {
    constructor(){
        super();
        this.value = this.defaults().value;
        this.metricValue = this.defaults().metricValue;
        this.scaleFactor = this.defaults().scaleFactor;
        this.barsCount = this.defaults().barsCount;
        this.scaleMax = this.setScaleMax();
        this.model = {};
        this.postInit();
    }
    postInit() {
        this.model = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp;
        this.prop = 'power';
        this.metric = 'ftp';
    }
    defaults() {
        return {
            value: 0,
            barsCount: 0,
            metricValue: 200,
            scaleFactor: 1.6
        };
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.graphWidth = this.calcGraphWidth();
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.prop}`, this.onUpdate.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.metric}`, this.onMetric.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    calcGraphWidth() {
        return this.getBoundingClientRect().width;
    }
    onUpdate(value) {
        this.value = value;
        this.render();
    }
    onMetric(value) {
        this.metricValue = value;
        this.setScaleMax();
    }
    setScaleMax() {
        this.scaleMax = this.metricValue * this.scaleFactor;
    }
    bar(zone = 'one', height = 80, width = 1) {
        return `<div class="graph-bar zone-${zone}" style="height: ${height}%; width: ${width}px;"></div>`;
    }
    shift() {
        this.removeChild(this.childNodes[0]);
    }
    render() {
        const zone = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.powerToZone(this.value, this.metricValue).name;
        const barHeight = $9b54029243cc3f84$var$scale(this.value, this.scaleMax);
        if (this.barsCount >= this.graphWidth) this.shift();
        this.insertAdjacentHTML('beforeend', this.bar(zone, barHeight, 1));
        this.barsCount += 1;
    }
}
customElements.define('instant-power-graph', $9b54029243cc3f84$export$2897f950f79985da);
class $9b54029243cc3f84$export$1b8cf0fbf52a628d extends HTMLElement {
    constructor(){
        super();
        this.state = 0;
        this.postInit();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$switchList = this.querySelectorAll('.switch-item');
        this.config();
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.prop}`, this.onState.bind(this), this.signal);
        this.addEventListener('pointerup', this.onSwitch.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    eventOwner(e) {
        const path = e.composedPath();
        const pathLength = path.length;
        for(let i = 0; i < pathLength; i++){
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(path[i].hasAttribute) && path[i].hasAttribute('index')) return path[i];
        }
        return e.path[0];
    }
    onSwitch(e) {
        const element = this.eventOwner(e);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(element.attributes.index)) {
            const id = parseInt(element.attributes.index.value) || 0;
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(id, this.state)) return;
            else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, id);
        }
    }
    onState(state) {
        this.state = state;
        this.setSwitch(this.state);
        this.renderEffect(this.state);
    }
    setSwitch(state) {
        this.$switchList.forEach(function(s, i) {
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(i, state)) s.classList.add('active');
            else s.classList.remove('active');
        });
    }
    // overwrite the rest to augment behavior
    postInit() {
        this.prop = '';
    }
    config() {}
    renderEffect(state) {
        return state;
    }
}
class $9b54029243cc3f84$export$abdfddbd5519d5be extends $9b54029243cc3f84$export$1b8cf0fbf52a628d {
    postInit() {
        this.prop = 'dataTileSwitch';
        this.effect = 'ui:data-tile-switch-set';
    }
    config() {
        this.$speed = document.querySelector('#data-tile--speed'); // tab 0
        this.$distance = document.querySelector('#data-tile--distance'); // tab 0
        this.$powerAvg = document.querySelector('#data-tile--power-avg'); // tab 1
        this.$slope = document.querySelector('#data-tile--slope'); // tab 1
        this.$smo2 = document.querySelector('#data-tile--smo2'); // tab 2
        this.$thb = document.querySelector('#data-tile--thb'); // tab 2
        this.$coreBodyTemperature = document.querySelector('#data-tile--core-body-temperature'); // tab 3
        this.$skinTemperature = document.querySelector('#data-tile--skin-temperature'); // tab 3
        this.renderEffect(this.state);
    }
    renderEffect(state) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(state, 0)) {
            if (this.$speed) this.$speed.classList.add('active');
            if (this.$distance) this.$distance.classList.add('active');
            if (this.$slope) this.$slope.classList.add('active');
            if (this.$powerAvg) this.$powerAvg.classList.add('active');
            if (this.$smo2) this.$smo2.classList.remove('active');
            if (this.$thb) this.$thb.classList.remove('active');
            if (this.$coreBodyTemperature) this.$coreBodyTemperature.classList.remove('active');
            if (this.$skinTemperature) this.$skinTemperature.classList.remove('active');
        }
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(state, 1)) {
            if (this.$smo2) this.$smo2.classList.add('active');
            if (this.$thb) this.$thb.classList.add('active');
            if (this.$coreBodyTemperature) this.$coreBodyTemperature.classList.add('active');
            if (this.$skinTemperature) this.$skinTemperature.classList.add('active');
            if (this.$speed) this.$speed.classList.remove('active');
            if (this.$distance) this.$distance.classList.remove('active');
            if (this.$powerAvg) this.$powerAvg.classList.remove('active');
            if (this.$slope) this.$slope.classList.remove('active');
        }
        return;
    }
}
customElements.define('data-tile-switch-group', $9b54029243cc3f84$export$abdfddbd5519d5be);
class $9b54029243cc3f84$export$6be21178dc0e799e extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.tabs = {
            settings: {
                $view: document.querySelector(`#view--settings`),
                $link: document.querySelector(`#link--settings`),
                children: {
                    settings: {
                        $view: document.querySelector(`#view--settings-settings`),
                        $link: document.querySelector(`#link--settings-settings`)
                    },
                    profile: {
                        $view: document.querySelector(`#view--settings-profile`),
                        $link: document.querySelector(`#link--settings-profile`)
                    }
                }
            },
            home: {
                $view: document.querySelector(`#view--home`),
                $link: document.querySelector(`#link--home`)
            },
            workouts: {
                $view: document.querySelector(`#view--workouts`),
                $link: document.querySelector(`#view--workouts`),
                children: {
                    workouts: {
                        $view: document.querySelector(`#view--workouts-workouts`),
                        $link: document.querySelector(`#link--workouts-workouts`)
                    },
                    editor: {
                        $view: document.querySelector(`#view--workouts-editor`),
                        $link: document.querySelector(`#link--workouts-editor`)
                    },
                    report: {
                        $view: document.querySelector(`#view--workouts-report`),
                        $link: document.querySelector(`#link--workouts-report`)
                    }
                }
            }
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`action:nav`, this.onAction.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onAction(action) {
        console.log(action);
        if (action === 'settings') {
            this.switch('settings', this.tabs);
            return;
        }
        if (action === 'home') {
            this.switch('home', this.tabs);
            return;
        }
        if (action === 'workouts') {
            this.switch('workouts', this.tabs);
            return;
        }
        if (action === 'settings:settings') {
            this.switch('settings', this.tabs.settings.children);
            return;
        }
        if (action === 'settings:profile') {
            this.switch('profile', this.tabs.settings.children);
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api.auth.loadTurnstile();
            return;
        }
        if (action === 'workouts:workouts') {
            this.switch('workouts', this.tabs.workouts.children);
            return;
        }
        if (action === 'workouts:editor') {
            this.switch('editor', this.tabs.workouts.children);
            return;
        }
        if (action === 'workouts:report') {
            this.switch('report', this.tabs.workouts.children);
            return;
        }
    }
    switch(target, elements) {
        // prevent potential content flash
        // by first removing and only after that adding .active
        // if there is no target element this is not an error,
        // it means all content should be 'non-active'
        for(let prop in elements)if (!(target === prop)) {
            elements[prop].$view.classList.remove('active');
            elements[prop].$link.classList.remove('active');
        }
        if (target) {
            elements[target].$view.classList.add('active');
            elements[target].$link.classList.add('active');
        }
    }
}
customElements.define('navigation-stack', $9b54029243cc3f84$export$6be21178dc0e799e);
// TODO:
// - use data-<prop name> properties instead of attributes
// - get them with this.dataset.<data name>
class $9b54029243cc3f84$export$a96f88e1928d92fa extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        const action = this.getAttribute('action');
        const topic = this.getAttribute('topic') ?? '';
        const on = this.getAttribute('on') ?? 'pointerup';
        const stopPropagation = this.hasAttribute('stoppropagation');
        if (action === undefined || action === '') throw Error(`need to setup action attribute on view-action `, self);
        this.addEventListener(on, (e)=>{
            if (stopPropagation) e.stopPropagation();
            // console.log(`action${topic}`, action, stopPropagation);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`action${topic}`, action);
            this.postAction();
        }, this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    postAction() {}
}
customElements.define('view-action', $9b54029243cc3f84$export$a96f88e1928d92fa);
class $9b54029243cc3f84$export$3415838ff2355a2b extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.for = this.getAttribute('for');
        this.$level = this.querySelector('.battery--level');
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.for}:batteryLevel`, this.onUpdate.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onUpdate(level) {
        this.$level.style.width = `${level}%`;
        this.classList.remove('ok');
        this.classList.remove('low');
        this.classList.remove('critical');
        if (level < 11) {
            this.classList.add('critical');
            return;
        }
        if (level < 21) {
            this.classList.add('low');
            return;
        }
        this.classList.add('ok');
    }
}
customElements.define('battery-level', $9b54029243cc3f84$export$3415838ff2355a2b);
class $9b54029243cc3f84$var$NavigationAction extends $9b54029243cc3f84$export$a96f88e1928d92fa {
    constructor(){
        super();
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    postAction() {
    // this.siblings = this.parentElement.querySelectorAll('navigation-action');
    // for(let sibling of this.siblings) {
    //     sibling.classList.remove('active');
    // }
    // this.classList.add('active');
    }
}
customElements.define('navigation-action', $9b54029243cc3f84$var$NavigationAction);
class $9b54029243cc3f84$var$OAuth extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.services = {
            strava: false,
            intervals: false
        };
        this.$stravaButton = self.querySelector('#strava--connect--button');
        this.$intervalsButton = self.querySelector('#intervals--connect--button');
        this.$tpButton = self.querySelector('#tp--connect--button');
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('action:oauth', self.onAction.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:services', self.onServices.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onServices(value) {
        this.services = value;
        this.render(this.services);
    }
    onAction(action) {
        const self = this;
        console.log(action);
        let service = action.split(':')[1];
        if (service === 'strava' || service === 'intervals' || service === 'trainingPeaks') {
            console.log(this.services[service]);
            if (this.services[service]) (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api[service].disconnect();
            else (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api[service].connect();
            return;
        }
    }
    render(services) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.$stravaButton)) this.$stravaButton.textContent = services.strava ? 'Disconnect' : 'Connect';
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.$intervalsButton)) this.$intervalsButton.textContent = services.intervals ? 'Disconnect' : 'Connect';
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.$tpButton)) this.$tpButton.textContent = services.tp ? 'Disconnect' : 'Connect';
    }
}
customElements.define('o-auth', $9b54029243cc3f84$var$OAuth);
class $9b54029243cc3f84$var$ModalError extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$dialog = this.querySelector(`dialog`);
        this.$dismissBtn = this.querySelector(`.dialog--dismiss--btn`);
        this.$message = this.querySelector(`.dialog--message`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ui:modal:error:open`, this.onOpen.bind(this), this.signal);
        this.$dismissBtn.addEventListener('pointerup', this.onClose.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onOpen(msg) {
        this.$dialog.showModal();
        this.$message.innerHTML = this.message(msg);
    }
    onClose(result) {
        this.$dialog.close();
    }
    message(msg) {
        if (msg === (0, $f66b95f67168c04c$export$42aa85db4eb429d1).noAuth) return `Your session is over. You need to login again.`;
        return '';
    }
}
customElements.define('modal-error', $9b54029243cc3f84$var$ModalError);
class $9b54029243cc3f84$export$199862e56a02026a extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            state: (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.default,
            prop: 'db:measurement'
        };
    }
    formatUnit(measurement = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.default) {
        if (measurement === 'imperial') return `lbs`;
        else return `kg`;
    }
    transform(state) {
        return this.formatUnit(state);
    }
}
customElements.define('measurement-unit', $9b54029243cc3f84$export$199862e56a02026a);
class $9b54029243cc3f84$export$c30b7f94063685bd extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:theme'
        };
    }
}
customElements.define('theme-value', $9b54029243cc3f84$export$c30b7f94063685bd);
class $9b54029243cc3f84$export$69dd5de7403ef984 extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    getDefaults() {
        return {
            prop: 'db:measurement'
        };
    }
}
customElements.define('measurement-value', $9b54029243cc3f84$export$69dd5de7403ef984);
class $9b54029243cc3f84$var$VirtualStateSource extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.sources = [
            'power',
            'speed'
        ];
        this.source = 'power';
        this.effect = 'sources';
        this.state = {
            virtualState: 'power'
        };
    }
    getDefaults() {
        return {
            prop: 'db:sources',
            effect: 'sources'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        this.addEventListener('pointerup', this.onEffect.bind(this), this.signal);
    }
    onUpdate(value) {
        this.state = value.virtualState;
        this.render();
    }
    onEffect() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'power')) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, {
            virtualState: 'speed'
        });
        else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, {
            virtualState: 'power'
        });
    }
    render() {
        this.textContent = this.state;
    }
}
customElements.define('virtual-state-source', $9b54029243cc3f84$var$VirtualStateSource);
class $9b54029243cc3f84$var$AutoPause extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.effect = 'sources';
        this.key = 'autoPause';
        this.state = {
            autoPause: false
        };
        this.values = {
            on: {
                autoPause: true
            },
            off: {
                autoPause: false
            }
        };
    }
    getDefaults() {
        return {
            prop: 'db:sources',
            effect: 'sources'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        this.addEventListener('pointerup', this.onEffect.bind(this), this.signal);
    }
    onUpdate(value) {
        this.state = value[this.key];
        this.render();
    }
    onEffect() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, true)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, this.values.off);
        else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, this.values.on);
    }
    render() {
        this.textContent = this.state ? 'On' : 'Off';
    }
}
customElements.define('auto-pause', $9b54029243cc3f84$var$AutoPause);
class $9b54029243cc3f84$var$AutoStart extends $9b54029243cc3f84$var$AutoPause {
    postInit() {
        this.effect = 'sources';
        this.key = 'autoStart';
        this.state = {
            autoStart: true
        };
        this.values = {
            on: {
                autoStart: true
            },
            off: {
                autoStart: false
            }
        };
    }
}
customElements.define('auto-start', $9b54029243cc3f84$var$AutoStart);
class $9b54029243cc3f84$var$Theme extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.effect = 'sources';
        this.state = {
            theme: 'DARK'
        };
    }
    getDefaults() {
        return {
            prop: 'db:sources',
            effect: 'sources'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        this.addEventListener('pointerup', this.onEffect.bind(this), this.signal);
    }
    onUpdate(value) {
        this.state = value.theme;
        this.render();
    }
    onEffect() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'DARK')) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, {
            theme: 'WHITE'
        });
        else if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'WHITE')) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, {
            theme: 'AUTO'
        });
        else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, {
            theme: 'DARK'
        });
    }
    render() {
        this.textContent = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'DARK') ? 'DARK' : (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'WHITE') ? 'WHITE' : 'AUTO';
        document.body.className = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'DARK') ? 'dark-theme' : (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, 'WHITE') ? 'white-theme' : 'auto-theme';
    }
}
customElements.define('theme-layout', $9b54029243cc3f84$var$Theme);
class $9b54029243cc3f84$var$DockModeDefault extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.effect = 'dockMode';
        this.state = false;
    }
    getDefaults() {
        return {
            prop: 'db:dockMode',
            effect: 'dockMode'
        };
    }
    subs() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
        this.addEventListener('pointerup', this.onEffect.bind(this), this.signal);
    }
    onUpdate(value) {
        this.state = value;
        this.render();
    }
    onEffect() {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, true)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, false);
        else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${this.effect}`, true);
    }
    render() {
        this.textContent = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.state, true) ? 'ON' : 'OFF';
    }
}
customElements.define('dock-mode-default', $9b54029243cc3f84$var$DockModeDefault);
class $9b54029243cc3f84$export$50b368876e58f6cb extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    subs() {
        this.addEventListener('pointerup', this.onSwitch.bind(this), this.signal);
    }
    onSwitch() {
        (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).dockMode.open();
    }
}
customElements.define('dock-mode-btn', $9b54029243cc3f84$export$50b368876e58f6cb);
class $9b54029243cc3f84$var$SoundControl extends $9b54029243cc3f84$export$5e15d737b33a1c27 {
    postInit() {
        this.volume = 100;
        this.selectors = {
            mute: '#sound--mute',
            down: '#sound--down',
            up: '#sound--up',
            volume: '#sound--volume'
        };
    }
    getDefaults() {
        return {
            prop: 'db:volume'
        };
    }
    config() {
        this.$mute = this.querySelector(this.selectors.mute);
        this.$down = this.querySelector(this.selectors.down);
        this.$up = this.querySelector(this.selectors.up);
        this.$volume = this.querySelector(this.selectors.volume);
    }
    subs() {
        this.$mute.addEventListener(`pointerup`, this.onMute.bind(this), this.signal);
        this.$down.addEventListener(`pointerup`, this.onDown.bind(this), this.signal);
        this.$up.addEventListener(`pointerup`, this.onUp.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop}`, this.onUpdate.bind(this), this.signal);
    }
    onMute() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:volume-mute`);
    }
    onDown() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:volume-down`);
    }
    onUp() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:volume-up`);
    }
    render() {
        this.$volume.textContent = `${this.state}%`;
    }
}
customElements.define('sound-control', $9b54029243cc3f84$var$SoundControl);
class $9b54029243cc3f84$var$CompatibilityCheck extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        if (!self.compatible()) self.show();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    compatible() {
        return 'bluetooth' in navigator;
    }
    show() {
        const self = this;
        this.innerHTML = `<div id="compatibility--cont">
             <p>This browser is NOT supported. Please open the app with </p>
             <a href="https://www.google.com/chrome/" target="_blank">Chrome</a> or
             <a href="https://www.microsoft.com/edge" target="_blank">Edge</a>
             <p>Please note that <b>iOS</b> is NOT supported at all, regardless of browser.</p>
             <p>For more information visit the project <a href="https://github.com/dvmarinoff/Flux" target="_blank">Page.</a></p>
         </div>`;
    }
    hide() {
        const self = this;
        this.innerHTML = '';
    }
}
customElements.define('compatibility-check', $9b54029243cc3f84$var$CompatibilityCheck);




// TODO: This needs refactoring to something more general with
// declarative configuration. Something that will work for all tabs and switches.
class $3db5a8fdc9e6fa74$var$AuthForms extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.el = {
            // each subset is exclusive or with css class .active
            //
            // tabs
            // passkey, password
            // forms
            // passkey -> login, register -> profile
            // password -> login, register, forgot, reset -> profile
            // error
            // switch: {
            //     $passkey: document.querySelector('#passkey--tab--switch'),
            //     $password: document.querySelector('#password--tab--switch'),
            // },
            // tab: {
            //     $passkey:  document.querySelector('#passkey--forms'),
            //     $password: document.querySelector('#password--forms'),
            // },
            password: {
                $register: self.querySelector('#register--form'),
                $login: self.querySelector('#login--form'),
                $forgot: self.querySelector('#forgot--form'),
                $reset: self.querySelector('#reset--form'),
                $profile: document.querySelector('#profile')
            },
            // passkey: {
            //     $register: self.querySelector('#passkey--register--form'),
            //     $login: self.querySelector('#passkey--login--form'),
            //     $profile: document.querySelector('#profile'),
            // },
            $logout: document.querySelector('#logout--button'),
            $error: document.querySelector('#auth-error--section'),
            $pwds: document.querySelectorAll('input[type="password"]')
        };
        this.subForm('password', '$login', 'login');
        this.subForm('password', '$register', 'register');
        this.subForm('password', '$forgot', 'forgot');
        this.subForm('password', '$reset', 'reset');
        this.el.$logout.addEventListener('pointerup', (e)=>{
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api.auth.logout();
        });
        this.$forgotMsg = document.querySelector('#forgot--msg'), (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('action:auth', self.onAction.bind(this));
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    subForm(group, form, method) {
        const $form = this.el[group][form];
        $form.addEventListener('submit', async (e)=>{
            e.preventDefault();
            const formData = new FormData($form);
            const cfTurnstileResponse = window.turnstile.getResponse();
            if (cfTurnstileResponse === undefined) return;
            formData.append('cf-turnstile-response', cfTurnstileResponse);
            const data = Object.fromEntries(formData);
            await (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api.auth[method]({
                data: data
            });
            $form.reset();
            // TODO:
            // refresh turnstile
            if (method === 'register' || method === 'forgot' || method === 'reset') (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).api.auth.resetTurnstile();
        }, this.signal);
    }
    onAction(action) {
        const self = this;
        console.log(action);
        // TODO: figure out a condition
        // models.api.auth.loadTurnstile();
        if (action === ':password') {
            this.switch('$password', this.el.tab);
            this.switch('$password', this.el.switch);
            return;
        }
        // if(action === ':passkey') {
        //     // TODO: fix when webauthn is ready
        //     // this.switch('$passkey', this.el.tab);
        //     // this.switch('$passkey', this.el.switch);
        //     return;
        // }
        if (action === ':password:login') {
            this.switch('$login', this.el.password);
            return;
        }
        if (action === ':password:register') {
            this.switch('$register', this.el.password);
            return;
        }
        if (action === ':password:forgot') {
            this.switch('$forgot', this.el.password);
            return;
        }
        if (action === ':password:reset') {
            this.switch('$reset', this.el.password);
            return;
        }
        if (action === ':password:profile') {
            this.switch('$profile', this.el.password);
            return;
        }
        if (action === ':password:logout') {
            this.switch('$login', this.el.password);
            return;
        }
        // if(action === ':passkey:login') {
        //     this.switch('$login', this.el.passkey);
        //     return;
        // }
        // if(action === ':passkey:register') {
        //     this.switch('$register', this.el.passkey);
        //     return;
        // }
        if (action === ':forgot:loading') {
            console.log(`:view :action:auth :forgot:loading`);
            this.$forgotMsg.textContent = "Sending reset request ...";
            this.$forgotMsg.classList.remove('success');
            this.$forgotMsg.classList.remove('error');
            this.$forgotMsg.classList.add('loading');
        }
        if (action === ':forgot:success') {
            console.log(`:view :action:auth :forgot:success`);
            this.$forgotMsg.textContent = "An email with a password reset link has been sent to your email!";
            this.$forgotMsg.classList.remove('loading');
            this.$forgotMsg.classList.remove('error');
            this.$forgotMsg.classList.add('success');
        }
        if (action === ':forgot:fail') {
            console.log(`:view :action:auth :forgot:fail`);
            this.$forgotMsg.textContent = "Something went wrong while sending a password reset email!";
            this.$forgotMsg.classList.remove('loading');
            this.$forgotMsg.classList.remove('success');
            this.$forgotMsg.classList.add('error');
        }
        if (action === ':error') {
            this.error('Wrong credentials or Authentication error');
            return;
        }
        if (action === ':no-api') {
            this.switch('', this.el.tab);
            this.switch('', this.el.password);
            this.switch('', this.el.passkey);
            this.error('No internet connection or the API service is currently offline.');
            return;
        }
    }
    switch(target, elements) {
        this.el.$error.classList.remove('active');
        // prevent potential content flash
        // by first removing and only after that adding .active
        // if there is no target element this is not an error,
        // it means all content should be 'non-active'
        for(let prop in elements)if (!(target === prop)) elements[prop].classList.remove('active');
        if (target) elements[target].classList.add('active');
    }
    error(msg = '') {
        if (msg !== '') this.el.$error.textContent = msg;
        this.el.$error.classList.add('active');
        this.el.$pwds.forEach(($el)=>$el.value = '');
    }
}
customElements.define('auth-forms', $3db5a8fdc9e6fa74$var$AuthForms);




class $25fbccdd635e1192$export$62ffd7d4f6d4149a extends HTMLInputElement {
    constructor(){
        super();
        this.state = 0;
        this.prop = this.getAttribute("prop");
        this.effect = this.getAttribute("effect");
        this.postInit();
    }
    postInit() {
        return;
    }
    connectedCallback() {
        this.addEventListener("change", this.onChange.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.prop}`, this.onUpdate.bind(this));
    }
    disconnectedCallback() {
        document.removeEventListener(`db:${this.prop}`, this.onUpdate);
        this.removeEventListener("change", this.onChange);
    }
    onUpdate(value) {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, this.state)) {
            this.state = value;
            this.render();
        }
    }
    onChange(e) {
        this.state = parseInt(e.target.value);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effect}`, this.state);
    // if (this.prop === "powerScale") {
    //   xf.dispatch("ui:power-scale:update-target");
    // }
    }
    render() {
        this.value = this.state;
    }
}
class $25fbccdd635e1192$export$e1fed1752ad5e684 extends $25fbccdd635e1192$export$62ffd7d4f6d4149a {
    postInit() {
        this.points = this.getAttribute("points") || 2;
    }
    onChange(e) {
        this.state = parseFloat(e.target.value);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effect}`, this.state);
    // if (this.prop === "powerScale") {
    //   xf.dispatch("ui:power-scale:update-target");
    // }
    }
    render() {
        this.value = this.state.toFixed(this.points);
    }
}
class $25fbccdd635e1192$var$WeightInput extends $25fbccdd635e1192$export$62ffd7d4f6d4149a {
    postInit() {
        this.measurement = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).measurement.default;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:measurement`, this.onMeasurement.bind(this));
    }
    onMeasurement(measurement) {
        this.measurement = measurement;
        this.render();
    }
    kgToLbs(kg) {
        return Math.round(2.20462 * kg);
    }
    parseKg(weight) {
        if (this.measurement === "imperial") return Math.round(0.453592 * weight);
        return Math.round(weight);
    }
    formatWeight(value, measurement) {
        if (measurement === "imperial") value = `${this.kgToLbs(value)}`;
        else value = `${value}`;
        return value;
    }
    onChange(e) {
        this.state = this.parseKg(e.target.value);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effect}`, this.state);
    }
    render() {
        this.value = this.formatWeight(this.state, this.measurement);
    }
}
customElements.define("int-input", $25fbccdd635e1192$export$62ffd7d4f6d4149a, {
    extends: "input"
});
customElements.define("float-input", $25fbccdd635e1192$export$e1fed1752ad5e684, {
    extends: "input"
});
customElements.define("weight-input", $25fbccdd635e1192$var$WeightInput, {
    extends: "input"
});
class $25fbccdd635e1192$export$1d07582e426fd60c extends HTMLButtonElement {
    constructor(){
        super();
        this.effect = this.getAttribute("effect");
    }
    connectedCallback() {
        this.addEventListener("pointerup", this.onEffect.bind(this));
    }
    disconnectedCallback() {
        this.removeEventListener("pointerup", this.onEffect);
    }
    onEffect(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effect}`);
    }
}
customElements.define("effect-button", $25fbccdd635e1192$export$1d07582e426fd60c, {
    extends: "button"
});
class $25fbccdd635e1192$var$SetButton extends HTMLButtonElement {
    constructor(){
        super();
        this.effect = this.getAttribute("effect");
        this.prop = this.getAttribute("prop");
        this.state = 0;
    }
    connectedCallback() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.prop}`, this.onUpdate.bind(this));
        this.addEventListener("pointerup", this.onEffect.bind(this));
    }
    disconnectedCallback() {
        this.removeEventListener("pointerup", this.onEffect);
    }
    onEffect(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effect}`, parseInt(this.state));
    }
    onUpdate(value) {
        this.state = value;
    }
}
customElements.define("set-button", $25fbccdd635e1192$var$SetButton, {
    extends: "button"
});
class $25fbccdd635e1192$var$Upload extends HTMLInputElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.addEventListener("change", this.onSubmit.bind(this));
    }
    disconnectedCallback() {
        this.removeEventListener(`pointerup`, this.onSubmit);
    }
    onSubmit(e) {
        const files = e.target.files;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:workout:upload", files);
    }
}
customElements.define("workout-upload", $25fbccdd635e1192$var$Upload, {
    extends: "input"
});








function $ca9720dedef31d7d$var$stringToSeconds(str) {
    const values = str.split(':').map(Number);
    return (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(values) * 60 + (0, $c6a9e46ee7e4d896$export$3d3c77ce7df7d30d)(values);
}
function $ca9720dedef31d7d$var$toNumericString(str) {
    return str.replace(/[^\d.-]/g, '');
}
function $ca9720dedef31d7d$var$Duration() {
    function encode(num) {
        return (0, $820877bea407f5fe$export$3203edd9e5edd663)({
            value: num,
            format: 'mm:ss'
        });
    }
    function decode(str) {
        return $ca9720dedef31d7d$var$stringToSeconds(str);
    }
    function valid(decoded) {
        return decoded > 0;
    }
    return Object.freeze({
        encode: encode,
        decode: decode,
        valid: valid
    });
}
function $ca9720dedef31d7d$var$Power(args = {}) {
    const _defaults = {
        encode: '-',
        decode: 0
    };
    const defaults = args.defaults ?? _defaults;
    function encode(num) {
        let value = Math.floor(Math.abs(num) * 100);
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value) || isNaN(value)) return defaults.encode;
        return `${value}%`;
    }
    function decode(str) {
        return parseInt($ca9720dedef31d7d$var$toNumericString(str)) / 100;
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $ca9720dedef31d7d$var$Slope(args = {}) {
    function encode(num) {
        let value = parseFloat(num);
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value) || isNaN(value)) return '-';
        return `${(0, $c6a9e46ee7e4d896$export$a81f732198733497)(value, 1)}%`;
    }
    function decode(str) {
        let value = parseFloat($ca9720dedef31d7d$var$toNumericString(str));
        if (isNaN(value)) return undefined;
        return value;
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $ca9720dedef31d7d$var$Cadence(args = {}) {
    function encode(num) {
        let value = parseInt(num);
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value) || isNaN(value)) return '-';
        return `${value}`;
    }
    function decode(str) {
        let value = parseInt($ca9720dedef31d7d$var$toNumericString(str));
        if (isNaN(value)) return undefined;
        return value;
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
const $ca9720dedef31d7d$var$fields = {
    time: $ca9720dedef31d7d$var$Duration(),
    duration: $ca9720dedef31d7d$var$Duration(),
    power: $ca9720dedef31d7d$var$Power(),
    ramp: $ca9720dedef31d7d$var$Power({
        defaults: {
            encode: '-',
            decode: undefined
        }
    }),
    slope: $ca9720dedef31d7d$var$Slope(),
    cadence: $ca9720dedef31d7d$var$Cadence()
};
function $ca9720dedef31d7d$var$Row(args = {}) {
    const id = args.id ?? genId();
    let state = {
        time: 0,
        duration: 600,
        power: 0.0,
        ramp: undefined,
        slope: undefined,
        cadence: undefined,
        powerZone: undefined,
        rampZone: undefined,
        select: false
    };
    function genId() {
        return (0, $36efb14127c8c4dd$export$31b40729666a4ae0)();
    }
    function setTime(value) {
        state.time = $ca9720dedef31d7d$var$fields.time.decode(value);
    }
    function setDuration(value) {
        state.duration = $ca9720dedef31d7d$var$fields.duration.decode(value);
    }
    function setPower(value) {
        const percentage = $ca9720dedef31d7d$var$fields.power.decode(value);
        if (isNaN(percentage)) return;
        state.power = percentage;
        state.powerZone = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.percentageToZone(state.power);
    }
    function setRamp(value) {
        const percentage = $ca9720dedef31d7d$var$fields.power.decode(value);
        if (isNaN(percentage)) {
            state.ramp = undefined;
            state.rampZone = '';
        } else {
            state.ramp = percentage;
            state.rampZone = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.percentageToZone(state.ramp);
        }
    }
    function setSlope(value) {
        const slope = $ca9720dedef31d7d$var$fields.slope.decode(value);
        state.slope = slope;
    }
    function setCadence(value) {
        const cadence = $ca9720dedef31d7d$var$fields.cadence.decode(value);
        state.cadence = cadence;
    }
    function getId() {
        return state.id;
    }
    function getSelect() {
        return state.select;
    }
    function getTime() {
        return state.time;
    }
    function getDuration() {
        return state.duration;
    }
    function getPower() {
        return state.power;
    }
    function getRamp() {
        return state.ramp;
    }
    function getSlope() {
        return state.slope;
    }
    function getCadence() {
        return state.cadence;
    }
    function set(data) {
        state = Object.assign(state, data);
    }
    function get() {
        return Object.assign({}, state);
    }
    function switchSelect() {
        state.select = !state.select;
    }
    function toView(data) {
        return Object.keys(data).reduce((acc, key)=>{
            acc[key] = $ca9720dedef31d7d$var$fields[key]?.encode(data[key]);
            return acc;
        }, {});
    }
    function toInterval(row = state) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(row.ramp)) return {
            duration: row.duration,
            steps: toRamp(row)
        };
        else return {
            duration: row.duration,
            steps: [
                toStep(row)
            ]
        };
    }
    function toRamp(row) {
        const timeStep = 10;
        const duration = row.duration;
        const stepsCount = parseInt(duration / timeStep);
        const powerStep = (row.ramp - row.power) / (stepsCount - 1);
        let steps = [];
        let power = row.power;
        for(let i = 0; i < stepsCount; i++){
            const step = {
                duration: timeStep,
                power: power
            };
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(row.slope)) step.slope = row.slope;
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(row.cadence)) step.cadence = row.cadence;
            steps.push(step);
            power = power + powerStep;
        }
        const fixedSteps = steps.map((step)=>{
            step.power = (0, $c6a9e46ee7e4d896$export$a81f732198733497)(step.power, 2);
            return step;
        });
        return steps;
    }
    function toStep(row) {
        const step = {
            duration: row.duration
        };
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(row.power)) step.power = row.power;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(row.slope)) step.slope = row.slope;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(row.cadence)) step.cadence = row.cadence;
        return step;
    }
    return Object.freeze({
        setDuration: setDuration,
        setPower: setPower,
        setRamp: setRamp,
        setSlope: setSlope,
        setCadence: setCadence,
        getId: getId,
        getSelect: getSelect,
        getDuration: getDuration,
        getPower: getPower,
        getRamp: getRamp,
        getSlope: getSlope,
        getCadence: getCadence,
        set: set,
        get: get,
        switchSelect: switchSelect,
        toView: toView,
        toInterval: toInterval,
        toStep: toStep
    });
}
function $ca9720dedef31d7d$var$Selection(args = {}) {
    const state = new Map();
    function set(rows) {
        rows.forEach(add);
        return state;
    }
    function get() {
        return state;
    }
    function add(row) {
        state.set(row.id, row);
        return state;
    }
    function remove(row) {
        state.delete(row.id);
        return state;
    }
    function clear() {
        state.clear();
        return state;
    }
    return Object.freeze({
        set: set,
        get: get,
        add: add,
        remove: remove,
        clear: clear
    });
}
function $ca9720dedef31d7d$export$7cda8d932e2f33c0() {
    const rows = [];
    let workout = {
        meta: {
            name: 'New Workout',
            author: 'Auuki',
            category: 'SweetSpot',
            description: 'Best workout ever!',
            type: 'bike'
        },
        intervals: []
    };
    function setName(value) {
        workout.meta.name = value;
    }
    function getName(value) {
        return workout.meta.name;
    }
    function setAuthor(value) {
        workout.meta.author = value;
    }
    function getAuthor(value) {
        return workout.meta.author;
    }
    function setCategory(value) {
        workout.meta.category = value;
    }
    function getCategory(value) {
        return workout.meta.category;
    }
    function setDescription(value) {
        workout.meta.description = value;
    }
    function getDescription(value) {
        return workout.meta.description;
    }
    function add() {
        const addition = [];
        rows.forEach((row)=>{
            const selected = row.getSelect();
            if (selected) {
                const r = $ca9720dedef31d7d$var$Row();
                r.set(row.get());
                r.switchSelect();
                rows.push(r);
                addition.push(r);
            }
        });
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(addition)) {
            const row = $ca9720dedef31d7d$var$Row();
            rows.push(row);
            addition.push(row);
        }
        return addition;
    }
    function remove() {
        rows.pop();
        return rows;
    }
    function save() {
        const meta = rows.reduce((acc, row)=>{
            acc.duration += row.get().duration;
            return acc;
        }, {
            duration: 0
        });
        const intervals = rows.reduce((acc, row)=>{
            acc.push(row.toInterval());
            return acc;
        }, []);
        workout.meta = Object.assign(workout.meta, meta);
        workout.intervals = Object.assign(workout.intervals, intervals);
        console.log(workout);
    }
    function format(args = {}) {
        return toZwo(workout);
    }
    function toZwo(data) {
        return (0, $bf91c66429ac832e$export$85cfc7c114c368df).write((0, $bf91c66429ac832e$export$85cfc7c114c368df).fromInterval(data));
    }
    return Object.freeze({
        setName: setName,
        getName: getName,
        setAuthor: setAuthor,
        getAuthor: getAuthor,
        setCategory: setCategory,
        getCategory: getCategory,
        setDescription: setDescription,
        getDescription: getDescription,
        add: add,
        remove: remove,
        save: save,
        format: format,
        toZwo: toZwo
    });
}
function $ca9720dedef31d7d$var$RowView(args = {}) {
    const model = args.model;
    const selectors = {
        select: '.select',
        on: '.editor--radio-on',
        off: '.editor--radio-off',
        time: '.time',
        duration: '.duration',
        power: '.power',
        ramp: '.ramp',
        slope: '.slope',
        cadence: '.cadence'
    };
    let $root;
    let $select;
    let $on;
    let $off;
    let $time;
    let $duration;
    let $power;
    let $ramp;
    let $slope;
    let $cadence;
    let abortController;
    let signal;
    function connect($this) {
        $root = $this;
        $select = $root.querySelector(selectors.select);
        $on = $root.querySelector(selectors.on);
        $off = $root.querySelector(selectors.off);
        $time = $root.querySelector(selectors.time);
        $duration = $root.querySelector(selectors.duration);
        $power = $root.querySelector(selectors.power);
        $ramp = $root.querySelector(selectors.ramp);
        $slope = $root.querySelector(selectors.slope);
        $cadence = $root.querySelector(selectors.cadence);
        abortController = new AbortController();
        signal = {
            signal: abortController.signal
        };
        $select.addEventListener(`pointerup`, onSelect.bind(this), signal);
        $duration.addEventListener(`input`, onDuration.bind(this), signal);
        $power.addEventListener(`input`, onPower.bind(this), signal);
        $ramp.addEventListener(`input`, onRamp.bind(this), signal);
        $slope.addEventListener(`input`, onSlope.bind(this), signal);
        $cadence.addEventListener(`input`, onCadence.bind(this), signal);
        renderPowerZone();
        renderRampZone();
    }
    function disconnect() {
        abortController.abort();
    }
    function onSelect(e) {
        model.switchSelect();
        const selected = model.getSelect();
        if (selected) select();
        else unselect();
    }
    function select() {
        $on.classList.add('selected');
        $off.classList.remove('selected');
    }
    function unselect() {
        $on.classList.remove('selected');
        $off.classList.add('selected');
    }
    function renderPowerZone() {
        const zoneClass = model.get().powerZone;
        $power.className = $power.className.replace(/(\zone.*)/gi, `zone-${zoneClass}-color`);
    }
    function renderRampZone() {
        const zoneClass = model.get().rampZone;
        $ramp.className = $ramp.className.replace(/(\zone.*)/gi, `zone-${zoneClass}-color`);
    }
    function onDuration(e) {
        model.setDuration(e.target.value);
    }
    function onPower(e) {
        model.setPower(e.target.value);
        renderPowerZone();
    }
    function onRamp(e) {
        model.setRamp(e.target.value);
        renderRampZone();
    }
    function onSlope(e) {
        model.setSlope(e.target.value);
    }
    function onCadence(e) {
        model.setCadence(e.target.value);
    }
    function template(data) {
        return `<div class="editor--row">
            <div class="editor--td select">
                <svg class="editor--radio editor--radio-off selected"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path fill="#none" class="path" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                </svg>
                <svg class="editor--radio editor--radio-on"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path class="path" fill="#none" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0
                            18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
                    <circle class="circle" cx="12" cy="12" r="5" fill="#none"/>
                </svg>
            </div>
            <div class="editor--td editor--static time">${data.time}</div>
            <input class="editor--td duration" type="text" value="${data.duration}" />
            <input class="editor--td power zone" type="text" value="${data.power}" />
            <input class="editor--td ramp zone" type="text" value="${data.ramp}" />
            <input class="editor--td slope" type="text" value="${data.slope}" />
            <input class="editor--td cadence" type="text" value="${data.cadence}" />
        </div>`;
    }
    function build() {
        return template(model.toView(model.get()));
    }
    return Object.freeze({
        connect: connect,
        disconnect: disconnect,
        template: template,
        build: build
    });
}
class $ca9720dedef31d7d$var$WorkoutEditor extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            name: '.editor--name',
            author: '.editor--author',
            category: '.editor--category',
            description: '.editor--description',
            body: '.editor--body',
            add: '.editor--add',
            remove: '.editor--remove',
            save: '.editor--save',
            download: '.editor--download'
        };
        this.editor = $ca9720dedef31d7d$export$7cda8d932e2f33c0();
        this.rows = new Map();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$root = this;
        this.$name = this.$root.querySelector(this.selectors.name);
        this.$author = this.$root.querySelector(this.selectors.author);
        this.$category = this.$root.querySelector(this.selectors.category);
        this.$description = this.$root.querySelector(this.selectors.description);
        this.$body = this.$root.querySelector(this.selectors.body);
        this.$add = this.$root.querySelector(this.selectors.add);
        this.$remove = this.$root.querySelector(this.selectors.remove);
        this.$save = this.$root.querySelector(this.selectors.save);
        this.$download = this.$root.querySelector(this.selectors.download);
        this.setTimeRefs();
        this.$body.addEventListener('input', this.setTime.bind(this), this.signal);
        this.$name.addEventListener(`input`, this.onName.bind(this), this.signal);
        this.$author.addEventListener(`input`, this.onAuthor.bind(this), this.signal);
        this.$category.addEventListener(`input`, this.onCategory.bind(this), this.signal);
        this.$description.addEventListener(`input`, this.onDescription.bind(this), this.signal);
        this.$add.addEventListener(`pointerup`, this.onAdd.bind(this), this.signal);
        this.$remove.addEventListener(`pointerup`, this.onRemove.bind(this), this.signal);
        this.$save.addEventListener(`pointerup`, this.onSave.bind(this), this.signal);
        this.$download.addEventListener(`pointerup`, this.onDownload.bind(this), this.signal);
        this.$name.value = this.editor.getName();
        this.$author.value = this.editor.getAuthor();
        this.$category.value = this.editor.getCategory();
        this.$description.value = this.editor.getDescription();
        this.onAdd();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    setTimeRefs() {
        this.$durationInputs = this.$body.querySelectorAll('.editor--td.duration');
        this.$timeOutputs = this.$body.querySelectorAll('.editor--td.time');
    }
    setTime(e) {
        const self = this;
        let acc = 0;
        self.$durationInputs.forEach((input, i)=>{
            self.$timeOutputs.item(i).textContent = $ca9720dedef31d7d$var$fields.time.encode(acc);
            acc += $ca9720dedef31d7d$var$fields.duration.decode(input.value);
        });
    }
    onName(e) {
        this.editor.setName(e.target.value);
    }
    onAuthor(e) {
        this.editor.setAuthor(e.target.value);
    }
    onCategory(e) {
        this.editor.setCategory(e.target.value);
    }
    onDescription(e) {
        this.editor.setDescription(e.target.value);
    }
    onAdd(e) {
        // const rowModel = this.editor.add();
        // const rowView = RowView({model: rowModel});
        // this.rows.set(this.rows.size, rowView);
        // this.$body.insertAdjacentHTML('beforeend', rowView.build());
        // const $row = this.$body.lastChild;
        // rowView.connect($row);
        // this.setTimeRefs();
        // this.setTime();
        const rowModels = this.editor.add();
        rowModels.forEach((rowModel)=>{
            const rowView = $ca9720dedef31d7d$var$RowView({
                model: rowModel
            });
            this.rows.set(this.rows.size, rowView);
            this.$body.insertAdjacentHTML('beforeend', rowView.build());
            const $row = this.$body.lastChild;
            rowView.connect($row);
            this.setTimeRefs();
            this.setTime();
        });
    }
    onRemove(e) {
        if (this.rows.size > 0) {
            this.editor.remove();
            const $row = this.$body.lastChild;
            const rowView = this.rows.get(this.rows.size - 1);
            rowView.disconnect();
            $row.remove();
            this.setTimeRefs();
            this.setTime();
        }
    }
    validate(fn) {
        // const { isValid, errors } = this.editor.validate();
        // if(isValid) {
        //     fn();
        // } else {
        //     this.onError(errors);
        // }
        fn();
    }
    onError(errors) {}
    onSave() {
        this.validate(this.save.bind(this));
    }
    onDownload() {
        this.validate(this.download.bind(this));
    }
    save() {
        this.editor.save();
    }
    download() {
        this.editor.save();
        const file = this.editor.format({
            format: 'zwo'
        });
        const name = `${this.editor.getName()}.zwo`;
        console.log(file);
        (0, $4720983c2827b7ff$export$1d35aa040498b1e5).download()(file, name, (0, $4720983c2827b7ff$export$1d35aa040498b1e5).Type.TextPlain);
    }
}
customElements.define('workout-editor', $ca9720dedef31d7d$var$WorkoutEditor);



class $101bc8008a336d92$export$449f3f80d617ef6a extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.state = '';
        this.effect = this.getAttribute('effect') || '';
        this.param = this.getAttribute('param') || '';
        this.prop = this.getAttribute('prop') || false;
        this.addEventListener('pointerup', this.onEffect.bind(this));
        if (this.prop) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.prop}`, this.onUpdate.bind(this));
            document.removeEventListener(`db:${this.prop}`, this.onUpdate);
        }
    }
    disconnectedCallback() {
        this.removeEventListener('pointerup', this.onEffect);
    }
    onEffect(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:${this.effect}`, this.param);
    }
    onUpdate(state) {
        this.state = state;
        if (this.state === this.param) {
            this.classList.remove('active');
            this.classList.add('active');
        } else this.classList.remove('active');
    }
}
class $101bc8008a336d92$export$85fd4ed3b8ca1010 extends HTMLElement {
    constructor(){
        super();
        this.tabClass = this.defaultTabSelector();
        this.tabAttr = this.defaultTabAttr();
        this.prop = this.getAttribute('prop') || '';
        this.tabs = this.querySelectorAll(this.tabClass);
    }
    defaultTabSelector() {
        return '.tab';
    }
    defaultTabAttr() {
        return 'tab';
    }
    connectedCallback() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:${this.prop}`, this.onUpdate.bind(this));
    }
    disconnectedCallback() {
        document.removeEventListener(`db:${this.prop}`, this.onUpdate);
    }
    onUpdate(param) {
        this.tabs.forEach((tab)=>{
            if (this.getId(tab) === param) tab.classList.add('active');
            else tab.classList.remove('active');
        });
    }
    getId(tab) {
        return tab.getAttribute(this.tabAttr);
    }
}
customElements.define('tab-btn', $101bc8008a336d92$export$449f3f80d617ef6a);
customElements.define('tab-group', $101bc8008a336d92$export$85fd4ed3b8ca1010);
class $101bc8008a336d92$var$PageBtn extends $101bc8008a336d92$export$449f3f80d617ef6a {
}
class $101bc8008a336d92$var$PageGroup extends $101bc8008a336d92$export$85fd4ed3b8ca1010 {
    defaultTabSelector() {
        return '.page';
    }
    defaultTabAttr() {
        return 'page';
    }
}
customElements.define('page-btn', $101bc8008a336d92$var$PageBtn);
customElements.define('page-group', $101bc8008a336d92$var$PageGroup);








function $498932bfaecb34a2$var$powerToHeight(power, powerMax, viewPort) {
    const height = (0, $820877bea407f5fe$export$d73ee8ef04f5226a)(power, 0, powerMax, 0, viewPort.height * 0.90);
    // console.log(`${viewPort.height} -> ${height}`);
    if (height < viewPort.height * 0.10) return viewPort.height * 0.14;
    return height;
}
function $498932bfaecb34a2$var$intervalToWidth(intervalDuration, totalDuration, totalWidth) {
    return (0, $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4)(1, totalDuration, (0, $820877bea407f5fe$export$d73ee8ef04f5226a)(intervalDuration, 0, totalDuration, 0, totalWidth));
}
function $498932bfaecb34a2$var$intervalsToMaxPower(intervals, ftp) {
    return intervals.reduce((highest, interval)=>{
        interval.steps.forEach((step)=>{
            const power = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(step.power, ftp);
            if (power > highest) highest = power;
        });
        return highest;
    }, ftp * 1.6);
}
function $498932bfaecb34a2$var$Interval(acc, interval, width, ftp, powerMax, viewPort) {
    const stepsLength = interval.steps.length;
    return acc + interval.steps.reduce((a, step)=>{
        const power = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(step.power, ftp) ?? 0;
        const cadence = step.cadence;
        const slope = step.slope;
        const duration = step.duration;
        const width = 100 / stepsLength;
        const height = $498932bfaecb34a2$var$powerToHeight(power, powerMax, viewPort);
        const zone = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.powerToZone(power, ftp).name;
        const infoTime = (0, $820877bea407f5fe$export$3203edd9e5edd663)({
            value: duration,
            format: 'mm:ss'
        });
        const powerAttr = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(power) ? `power="${power}"` : '';
        const cadenceAttr = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(cadence) ? `cadence="${cadence}"` : '';
        const slopeAttr = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(slope) ? `slope="${slope}"` : '';
        const durationAttr = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(duration) ? `duration="${infoTime}"` : '';
        return a + `<div class="graph--bar zone-${zone}" style="height: ${height}px; width: ${width}%" ${powerAttr} ${cadenceAttr} ${slopeAttr} ${durationAttr}></div>`;
    }, `<div class="graph--bar-group" style="width: ${width}px;">`) + `</div>`;
}
function $498932bfaecb34a2$export$376b477d208d45bf(workout, ftp, viewPort) {
    const totalWidth = viewPort.width;
    const intervals = workout.intervals;
    const totalDuration = workout.meta.duration;
    const maxPower = $498932bfaecb34a2$var$intervalsToMaxPower(intervals, ftp);
    return intervals.reduce((acc, interval)=>{
        let width = 1;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(interval.duration)) {
            width = $498932bfaecb34a2$var$intervalToWidth(interval.duration, totalDuration, totalWidth);
            return $498932bfaecb34a2$var$Interval(acc, interval, width, ftp, maxPower, viewPort);
        }
        return '';
    }, '<div class="graph--info--cont"></div>');
}
function $498932bfaecb34a2$export$751a7c2349f9bdd6(args = {}) {
    const power = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.power) ? `${args.power}W ` : '';
    const cadence = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.cadence) ? `${args.cadence}rpm ` : '';
    const slope = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.slope) ? `${(0, $c6a9e46ee7e4d896$export$a81f732198733497)(args.slope, 2)}%` : '';
    const duration = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.duration) ? `${args.duration}min ` : '';
    const distance = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.distance) ? `${args.distance}m ` : '';
    const dom = args.dom;
    const intervalLeft = args.intervalRect.left;
    const contLeft = args.contRect.left;
    const contWidth = args.contRect.width;
    const left = intervalLeft - contLeft;
    const bottom = args.intervalRect.height;
    dom.info.style.display = 'block';
    dom.info.innerHTML = `<div>${power}</div><div>${cadence}</div><div>${slope}</div><div class="graph--info--time">${duration}</div>`;
    const width = dom.info.getBoundingClientRect().width;
    const height = dom.info.getBoundingClientRect().height;
    const minHeight = bottom + height + 40; // fix 40
    dom.info.style.left = `min(${contWidth}px - ${width}px, ${left}px)`;
    if (window.innerHeight > minHeight) dom.info.style.bottom = bottom;
    else dom.info.style.bottom = bottom - (minHeight - window.innerHeight);
}
class $498932bfaecb34a2$export$1058965622af921c extends HTMLElement {
    constructor(){
        super();
        this.workout = {};
        this.workoutStatus = "stopped";
        this.metricValue = 0;
        this.index = 0;
        this.minHeight = 30;
        this.type = 'workout';
    }
    connectedCallback() {
        const self = this;
        this.dom = {};
        this.$graphCont = document.querySelector('#graph-workout') ?? this;
        this.viewPort = this.getViewPort();
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.debounced = {
            onWindowResize: (0, $c6a9e46ee7e4d896$export$61fc7d43ac8f84b0)(self.onWindowResize.bind(this), 300, {
                trailing: true,
                leading: false
            })
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:workout`, this.onWorkout.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:ftp`, this.onFTP.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:intervalIndex', this.onIntervalIndex.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:distance', this.onDistance.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:page', this.onPage.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:lapTime', this.onLapTime.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:workoutStatus', this.onWorkoutStatus.bind(this), this.signal);
        this.addEventListener('mouseover', this.onHover.bind(this), this.signal);
        this.addEventListener('mouseout', this.onMouseOut.bind(this), this.signal);
        // window.addEventListener('resize', this.debounced.onWindowResize.bind(this), this.signal);
        window.addEventListener('resize', this.onWindowResize.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    getViewPort() {
        // const rect = this.getBoundingClientRect();
        const rect = this.$graphCont.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height,
            left: rect.left,
            aspectRatio: rect.width / rect.height
        };
    }
    onFTP(value) {
        this.ftp = value;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.workout.intervals)) this.render();
    }
    onPage(page) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(page, 'home')) {
            const viewPort = this.getViewPort();
            this.viewPort = viewPort;
            this.render();
        }
    }
    onWindowResize(e) {
        const viewPort = this.getViewPort();
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(viewPort.width, 0)) return;
        this.viewPort = viewPort;
        this.render();
    }
    onHover(e) {
        const self = this;
        const target = this.querySelector('.graph--bar:hover');
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(target)) {
            const power = target.getAttribute('power');
            const cadence = target.getAttribute('cadence');
            const slope = target.getAttribute('slope');
            const duration = target.getAttribute('duration');
            const distance = target.getAttribute('distance');
            const intervalRect = target.getBoundingClientRect();
            this.renderInfo({
                power: power,
                cadence: cadence,
                slope: slope,
                duration: duration,
                distance: distance,
                intervalRect: intervalRect,
                contRect: self.viewPort,
                dom: self.dom
            });
        }
    }
    onMouseOut(e) {
        this.dom.info.style.display = 'none';
    }
    onWorkout(value) {
        this.workout = value; // this.workout = Object.assign({}, value);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value.intervals)) this.type = 'workout';
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(value.points)) this.type = 'course';
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.viewPort.width, 0)) this.render();
    }
    onWorkoutStatus(value) {
        this.workoutStatus = value;
    }
    onIntervalIndex(index) {
        const self = this;
        this.index = index;
        this.progress({
            index: self.index,
            dom: self.dom,
            parent: self,
            lapTime: self.lapTime
        });
    }
    onDistance(distance) {
        const self = this;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(this.workout?.points)) {
            const totalDistance = this.workout.meta.distance;
            const $dom = self.dom;
            const $parent = self;
            const height = $parent.getBoundingClientRect().height;
            const width = $parent.getBoundingClientRect().width;
            const left = (0, $820877bea407f5fe$export$d73ee8ef04f5226a)(distance, 0, totalDistance, 0, width);
            $dom.active.style.left = `${left % width}px`;
            $dom.active.style.width = `2px`;
            $dom.active.style.height = `${height}px`;
            if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.type, 'course')) $dom.progress.style.left = `${left % width}px`;
        }
        return;
    }
    onLapTime(lapTime) {
        const self = this;
        this.lapTime = lapTime;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.type, 'workout')) this.progress({
            index: self.index,
            dom: self.dom,
            parent: self,
            lapTime: self.lapTime
        });
    }
    progress(args = {}) {
        if (this.workoutStatus === "done") return;
        const index = args.index ?? 0;
        const lapTime = args.lapTime ?? this.workout.intervals[index].duration;
        const $dom = args.dom;
        const $parent = args.parent;
        const rect = $dom.intervals[index].getBoundingClientRect();
        const left = rect.left - $parent.getBoundingClientRect().left;
        const lapPercentageComplete = 1 - lapTime / this.workout.intervals[index].duration;
        $dom.active.style.left = `${left}px`;
        $dom.active.style.width = `${rect.width}px`;
        $dom.active.style.height = `${$parent.getBoundingClientRect().height}px`;
        $dom.progress.style.width = `${left + rect.width * lapPercentageComplete}px`;
    }
    render() {
        const self = this;
        const progress = `<div id="progress" class="progress"></div><div id="progress-active"></div>`;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.type, 'workout')) {
            this.innerHTML = progress + $498932bfaecb34a2$export$376b477d208d45bf(this.workout, this.ftp, this.viewPort);
            this.dom.info = this.querySelector('.graph--info--cont');
            this.dom.progress = this.querySelector('#progress');
            this.dom.active = this.querySelector('#progress-active');
            this.dom.intervals = this.querySelectorAll('.graph--bar-group');
            this.dom.steps = this.querySelectorAll('.graph--bar');
            this.progress({
                index: self.index,
                dom: self.dom,
                parent: self,
                lapTime: self.lapTime
            });
        }
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.type, 'course')) {
            this.innerHTML = progress + $498932bfaecb34a2$export$74c2863347e8d9e0(this.workout, this.viewPort);
            this.dom.info = this.querySelector('.graph--info--cont');
            this.dom.progress = this.querySelector('#progress');
            this.dom.active = this.querySelector('#progress-active');
        }
    }
    renderInfo(args = {}) {
        $498932bfaecb34a2$export$751a7c2349f9bdd6(args);
    }
}
customElements.define('workout-graph', $498932bfaecb34a2$export$1058965622af921c);
function $498932bfaecb34a2$var$Segment(points, prop) {
    return points.reduce((acc, point, i)=>{
        const value = point[prop];
        if (value > acc.max) acc.max = value;
        if (value < acc.min) acc.min = value;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(i, 0)) {
            acc.min = value;
            acc.start = value;
        }
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(i, points.length - 1)) acc.end = value;
        return acc;
    }, {
        min: 0,
        max: 0,
        start: 0,
        end: 0
    });
}
function $498932bfaecb34a2$var$scale(value, max = 100) {
    return 100 * (value / max);
}
function $498932bfaecb34a2$export$74c2863347e8d9e0(course, viewPort) {
    const altitudeSpec = $498932bfaecb34a2$var$Segment(course.points, 'y');
    const distanceTotal = course.meta.distance;
    const aspectRatio = viewPort.aspectRatio;
    const yOffset = Math.min(altitudeSpec.min, altitudeSpec.start, altitudeSpec.end);
    const yMax = altitudeSpec.max - altitudeSpec.min;
    const yScale = 1 / (aspectRatio * yMax / distanceTotal);
    const flatness = altitudeSpec.max - altitudeSpec.min;
    const altitudeScale = yScale * (flatness < 100 ? 0.2 : 0.7);
    const viewBox = {
        width: distanceTotal,
        height: yMax
    };
    // console.table({distanceTotal, yMax, aspectRatio, yScale, flatness, altitudeScale, altitudeSpec});
    const track = course.pointsSimplified.reduce((acc, p, i, xs)=>{
        const color = (0, $e9c32c0604b50709$export$39b482c5e57630a8).slopeToColor(p.slope);
        const px1 = p.x;
        const px2 = xs[i + 1]?.x ?? px1;
        const py1 = p.y;
        const py2 = xs[i + 1]?.y ?? py1;
        const x1 = px1;
        const y1 = yMax;
        const x2 = px1;
        const y2 = yMax - (py1 - yOffset) * altitudeScale;
        const x3 = px2;
        const y3 = yMax - (py2 - yOffset) * altitudeScale;
        const x4 = px2;
        const y4 = yMax;
        return acc + `<polygon points="${x1},${y1} ${x2},${y2} ${x3},${y3} ${x4},${y4}" stroke="none" fill="${color}" class="graph--bar" index="${i}" slope="${p.slope}" />`;
    }, ``);
    const display = `<altitude-value class="elevation--value altitude--value">${altitudeSpec.start ?? '--'}</altitude-value>
        <ascent-value class="elevation--value ascent--value">0.0</ascent-value>`;
    return `${display}<div class="graph--info--cont"></div><svg class="graph--bar-group" width="100%" height="100%" viewBox="0 0 ${viewBox.width} ${viewBox.height}" preserveAspectRatio="xMinYMax meet">${track}</svg>`;
}


const $cc4e56d8442529da$export$bc0764e5dda4c34e = `
        <svg class="radio radio-off">
            <use href="#icon--radio-off">
        </svg>`;
const $cc4e56d8442529da$export$7e0a0a413cc10af6 = `
        <svg class="radio radio-on">
            <use href="#icon--radio-on">
        </svg>`;
const $cc4e56d8442529da$export$41c562ebe57d11e2 = `
        <svg class="workout--options-btn control--btn--icon">
            <use href="#icon--options">
        </svg>`;
function $cc4e56d8442529da$export$6bf1c961053e09a8(workout) {
    let duration = '';
    if (workout.meta.duration) duration = `${Math.round(workout.meta.duration / 60)} min`;
    if (workout.meta.distance) duration = `${(workout.meta.distance / 1000).toFixed(2)} km`;
    return `<workout-item class='workout cf' id="${workout.id}" metric="ftp">
                <div class="workout--info">
                    <div class="workout--short-info">
                        <div class="workout--summary">
                            <div class="workout--name">${workout.meta.name}</div>
                            <div class="workout--type">${workout.meta.category}</div>
                            <div class="workout--duration">${duration}</div>
                            <div class="workout--select" id="btn${workout.id}">${workout.selected ? $cc4e56d8442529da$export$7e0a0a413cc10af6 : $cc4e56d8442529da$export$bc0764e5dda4c34e}
                            </div>
                            <div class="workout--options">${$cc4e56d8442529da$export$41c562ebe57d11e2}</div>
                        </div>
                    </div>
                    <div class="workout--full-info">
                        <div class="workout-list--graph-cont">${workout.graph}</div>
                        <div class="workout--description">${workout.meta.description}</div>
                    </div>
                </div>
                <div class="workout--actions">
                    <span class="workout--remove">Delete</span>
                </div>
            </workout-item>`;
}
class $cc4e56d8442529da$var$WorkoutList extends HTMLElement {
    constructor(){
        super();
        this.state = [];
        this.ftp = 0;
        this.items = [];
        this.postInit();
        this.workout = {};
    }
    postInit() {
        return;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:workouts`, this.onWorkouts.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:workout', this.onWorkout.bind(this), this.signal); // ?
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:ftp`, this.onFTP.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    getWidth() {
        return window.innerWidth;
    }
    onWorkout(value) {
        this.workout = value;
    }
    onFTP(value) {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, this.ftp)) {
            this.ftp = value;
            if (!(0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(this.state)) this.render();
        }
    }
    onWorkouts(value) {
        this.state = value;
        this.render();
    }
    getViewPort() {
        const self = this;
        const $el = document.querySelector('#workouts-page');
        const fontSize = parseInt(window.getComputedStyle($el).getPropertyValue('font-size'));
        const em = 8;
        const width = self.getWidth();
        const height = fontSize * em;
        const aspectRatio = width / height;
        return {
            height: height,
            width: width,
            aspectRatio: aspectRatio
        };
    }
    stateToHtml(state, ftp, selectedWorkout) {
        const self = this;
        const viewPort = this.getViewPort();
        return state.reduce((acc, workout, i)=>{
            let graph = '';
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(workout.intervals)) graph = (0, $498932bfaecb34a2$export$376b477d208d45bf)(workout, ftp, viewPort);
            else graph = (0, $498932bfaecb34a2$export$74c2863347e8d9e0)(workout, viewPort);
            const selected = (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(workout.id, selectedWorkout.id);
            workout = Object.assign(workout, {
                graph: graph,
                selected: selected
            });
            return acc + $cc4e56d8442529da$export$6bf1c961053e09a8(workout);
        }, '');
    }
    render() {
        this.innerHTML = this.stateToHtml(this.state, this.ftp, this.workout);
    }
}
class $cc4e56d8442529da$var$WorkoutListItem extends HTMLElement {
    constructor(){
        super();
        this.state = '';
        this.isExpanded = false;
        this.isSelected = false;
        this.optionsActive = false;
    }
    connectedCallback() {
        const self = this;
        this.infoCont = this.querySelector('.workout--info');
        this.summary = this.querySelector('.workout--summary');
        this.description = this.querySelector('.workout--full-info');
        this.selectBtn = this.querySelector('.workout--select');
        this.optionsBtn = this.querySelector('.workout--options');
        this.removeBtn = this.querySelector('.workout--remove');
        this.indicator = this.selectBtn;
        this.id = this.getAttribute('id');
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.debounced = {
            onWindowResize: (0, $c6a9e46ee7e4d896$export$61fc7d43ac8f84b0)(self.onWindowResize.bind(this), 300, {
                trailing: true,
                leading: false
            })
        };
        this.dom = {};
        this.dom.info = this.querySelector('.graph--info--cont');
        this.dom.cont = this.querySelector('.workout-list--graph-cont');
        this.viewPort = this.getViewPort();
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:workout', this.onWorkout.bind(this), this.signal);
        this.summary.addEventListener('pointerup', this.toggleExpand.bind(this), this.signal);
        this.optionsBtn.addEventListener('pointerup', this.toggleOptions.bind(this), this.signal);
        this.selectBtn.addEventListener('pointerup', this.onRadio.bind(this), this.signal);
        this.removeBtn.addEventListener('pointerup', this.onRemove.bind(this), this.signal);
        this.addEventListener('mouseover', this.onHover.bind(this), this.signal);
        this.addEventListener('mouseout', this.onMouseOut.bind(this), this.signal);
        window.addEventListener('resize', this.debounced.onWindowResize.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    toggleExpand(e) {
        if (e.target.classList.contains('workout--options')) return;
        if (this.isExpanded) this.collapse();
        else this.expand();
    }
    expand() {
        this.description.style.display = 'block';
        this.isExpanded = true;
    }
    collapse() {
        this.description.style.display = 'none';
        this.isExpanded = false;
    }
    toggleSelect(id) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.id, id)) {
            if (!this.isSelected) {
                this.select();
                this.expand();
            }
        } else this.diselect();
    }
    select() {
        this.indicator.innerHTML = $cc4e56d8442529da$export$7e0a0a413cc10af6;
        this.isSelected = true;
    }
    diselect() {
        this.indicator.innerHTML = $cc4e56d8442529da$export$bc0764e5dda4c34e;
        this.isSelected = false;
    }
    toggleOptions() {
        if (this.optionsActive) this.hideOptions();
        else this.showOptions();
    }
    showOptions() {
        this.infoCont.classList.remove('options-hide');
        this.infoCont.classList.add('options-show');
        this.optionsActive = true;
    }
    hideOptions() {
        this.infoCont.classList.remove('options-show');
        this.infoCont.classList.add('options-hide');
        this.optionsActive = false;
    }
    onWorkout(workout) {
        this.workout = workout;
        this.toggleSelect(workout.id);
    }
    onRadio(e) {
        e.stopPropagation();
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:workout:select', this.id);
    }
    onRemove(e) {
        console.log(`:ui :workout :remove :id '${this.id}'`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:workout:remove', this.id);
    }
    onUpdate(value) {
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, this.state)) {
            this.state = value;
            this.render();
        }
    }
    onHover(e) {
        const self = this;
        const target = this.querySelector('.graph--bar:hover');
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(target)) {
            const power = target.getAttribute('power');
            const cadence = target.getAttribute('cadence');
            const slope = target.getAttribute('slope');
            const duration = target.getAttribute('duration');
            const distance = target.getAttribute('distance');
            const intervalRect = target.getBoundingClientRect();
            this.viewPort = this.getViewPort(); // move to more sensible event
            this.renderInfo({
                power: power,
                cadence: cadence,
                slope: slope,
                duration: duration,
                distance: distance,
                intervalRect: intervalRect,
                contRect: self.viewPort,
                dom: self.dom
            });
        }
    }
    onMouseOut(e) {
        this.dom.info.style.display = 'none';
    }
    getViewPort() {
        const rect = this.dom.cont.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height,
            left: rect.left,
            aspectRatio: rect.width / rect.height
        };
    }
    onWindowResize(e) {
        this.viewPort = this.getViewPort();
    }
    render() {}
    renderInfo(args = {}) {
        (0, $498932bfaecb34a2$export$751a7c2349f9bdd6)(args);
    }
}
customElements.define('workout-list', $cc4e56d8442529da$var$WorkoutList);
customElements.define('workout-item', $cc4e56d8442529da$var$WorkoutListItem);








// Just keep here logic that calculates the graph as svg
class $73b0b703e27776b4$export$27d18bad757d1f02 {
    constructor(){
        const self = this;
        this.px = this.px ?? 10; // the workouts page font-size from em to absolute px
        this.xOutRange = {
            min: 0,
            max: 400
        };
        this.yOutRange = {
            min: 0,
            max: self.calcYOutRangeMax(self.px)
        };
        this.xInRange = {
            min: 0,
            max: 1
        };
        this.yInRange = {
            min: 0,
            max: 1
        };
        this.powerMin = 0.1;
    }
    translate(value, inRange, outRange) {
        const inSpan = inRange.max - inRange.min;
        const outSpan = outRange.max - outRange.min;
        const valueScaled = (value - inRange.min) / inSpan;
        return inRange.min + valueScaled * outSpan;
    }
    findMaxTarget(workout) {
        const intervals = workout.intervals;
        let interval;
        let step;
        let max = 0;
        for(let i = 0; i < intervals.length; i++){
            interval = intervals[i];
            for(let j = 0; j < interval.steps.length; j++){
                step = interval.steps[j];
                if (step.power > max) max = step.power;
            }
        }
        return max;
    }
    calcYOutRangeMax(px) {
        const em = 8;
        return px * em;
    }
    calcYInRangeMax(data, ftp) {
        const self = this;
        const targetMax = Math.round(self.findMaxTarget(data) * ftp);
        return targetMax > ftp ? targetMax : ftp * 1.6;
    }
    intervalToInfo(interval) {
        const firstStep = (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(interval.steps);
        const lastStep = (0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(interval.steps);
        const powerStart = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(firstStep.power);
        const powerEnd = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(lastStep.power);
        const cadenceStart = firstStep.cadence;
        const cadenceEnd = lastStep.cadence;
        const slopeStart = firstStep.slope;
        const slopeEnd = lastStep.slope;
        const duration = `${(0, $820877bea407f5fe$export$3203edd9e5edd663)({
            value: interval.duration ?? 0,
            format: 'mm:ss'
        })}min`;
        const power = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(powerStart) ? powerStart === powerEnd ? `${powerStart}W` : `${powerStart}-${powerEnd}W` : '';
        const cadence = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(cadenceStart) ? cadenceStart === cadenceEnd ? `${cadenceStart}W` : `${cadenceStart}-${cadenceEnd}rpm` : '';
        const slope = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(slopeStart) ? slopeStart === slopeEnd ? `${slopeStart}%` : `${slopeStart}-${slopeEnd}%` : '';
        return {
            duration: duration,
            power: power,
            cadence: cadence,
            slope: slope
        };
    }
    // Int
    // ->
    // String
    toSVG(data, ftp = 200, size) {
        const self = this;
        const intervals = data.intervals;
        let graphWidth = window.innerWidth;
        if (size) self.yOutRange.max = size.height;
        this.xOutRange.max = graphWidth;
        this.xInRange.max = data?.meta?.duration;
        self.yInRange.max = self.calcYInRangeMax(data, ftp);
        // initial values
        let x = self.xOutRange.min;
        let x0 = self.xOutRange.min;
        const y0 = self.yOutRange.min;
        let x1 = self.xOutRange.min;
        let y1 = self.yOutRange.min;
        let x2 = self.xOutRange.min;
        let y2 = self.yOutRange.min;
        let x3 = self.xOutRange.min;
        const y3 = self.yOutRange.min;
        let heightStart = self.yOutRange.min;
        let heightEnd = self.yOutRange.min;
        let powerStartRelative = this.powerMin;
        let powerEndRelative = this.powerMin;
        let powerStart = 0;
        let powerEnd = 0;
        let width = 0;
        const initialInterval = {
            duration: 0,
            steps: [
                {
                    duration: 0,
                    power: 0
                }
            ]
        };
        const initialStep = initialInterval.steps[0];
        let stepPrev = initialStep;
        let points = '';
        let color = '#328AFF'; // from css var(--zone-blue)
        // accumulators
        let accX = 0;
        let acc = '';
        for(let i = 0; i < intervals.length; i++){
            let intervalPrev = i === 0 ? initialInterval : intervals[i - 1];
            let interval = intervals[i];
            // TODO: handle ramps zone change, maybe with
            // - a mask
            // - a nested polygon element for each color change
            // for(let j = 0; j < interval.steps.length; j++) {
            // }
            powerStartRelative = Math.max((0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(interval.steps)?.power ?? 0, this.powerMin);
            powerEndRelative = Math.max((0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(interval.steps)?.power ?? 0, this.powerMin);
            powerStart = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(powerStartRelative, ftp);
            powerEnd = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(powerEndRelative, ftp);
            accX += intervalPrev.duration;
            x = self.translate(accX, self.xInRange, self.xOutRange);
            width = self.translate(interval.duration, self.xInRange, self.xOutRange);
            heightStart = self.translate(powerStart, self.yInRange, self.yOutRange);
            heightEnd = self.translate(powerEnd, self.yInRange, self.yOutRange);
            x0 = x;
            x1 = x;
            y1 = heightStart;
            x2 = x1 + width;
            y2 = heightEnd;
            x3 = x + width;
            points = `${x0},${y0} ${x1},${y1} ${x2},${y2} ${x3},${y3}`;
            color = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.zoneToColor((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.powerToZone(powerStart, ftp).name);
            const info = self.intervalToInfo(interval);
            acc += `<polygon points="${points}"
                             fill="${color}"
                             power="${info.power}"
                             cadence="${info.cadence}"
                             slope="${info.slope}"
                             duration="${info.duration}" />`;
        }
        return `
            <svg
                class="workout--graph"
                viewBox="0 0 ${graphWidth} ${this.yOutRange.max}"
                preserveAspectRatio="none">
                <g transform="matrix(1 0 0 -1 0 ${this.yOutRange.max})">
                    ${acc}
                </g>
            </svg>
            `;
    }
}
// The graph element itself, just holds some events and actions
class $73b0b703e27776b4$var$WorkoutGraph extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$info = this.querySelector('.graph--info--cont');
        this.addEventListener('mouseover', this.onHover.bind(this), this.signal);
        this.addEventListener('mouseout', this.onMouseOut.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onHover(e) {
        const self = this;
        const target = this.querySelector('polygon:hover');
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(target)) {
            const contRect = this.getBoundingClientRect();
            self.renderInfo(target, contRect);
        }
    }
    onMouseOut(e) {
        this.$info.style.display = 'none';
    }
    // TODO: simplify
    renderInfo(target, contRect) {
        const power = target.getAttribute('power');
        const cadence = target.getAttribute('cadence');
        const slope = target.getAttribute('slope');
        const duration = target.getAttribute('duration');
        const rect = target.getBoundingClientRect();
        const intervalLeft = rect.left;
        const contLeft = contRect.left;
        const contWidth = contRect.width;
        const left = intervalLeft;
        const bottom = rect.height;
        this.$info.style.display = 'block';
        this.$info.innerHTML = `<div>${power}</div><div>${cadence}</div><div>${slope}</div><div class="graph--info--time">${duration}</div>`;
        const width = this.$info.getBoundingClientRect().width;
        const height = this.$info.getBoundingClientRect().height;
        const minHeight = bottom + height + 40; // fix 40
        this.$info.style.left = `min(${contWidth}px - ${width}px, ${left}px)`;
        if (window.innerHeight > minHeight) this.$info.style.bottom = bottom;
        else this.$info.style.bottom = bottom - (minHeight - window.innerHeight);
    }
}
customElements.define('workout-graph-svg', $73b0b703e27776b4$var$WorkoutGraph);
// TODO:
// - should extend the workout graph with watch actions
// - it bridges session, activity and workout
class $73b0b703e27776b4$var$WorkoutGraphActive extends HTMLElement {
}
customElements.define('workout-graph-active-svg', $73b0b703e27776b4$var$WorkoutGraphActive);


// TODO:
// - Use Model as a way to store, and isolated the operations on the data,
//   and potentially share it
// - use directly the Model to that view, not just the data through sub
// - maybe no need to have list data in db, just the shared session data
class $2741b9ae2dc72316$var$PlannedList extends HTMLElement {
    constructor(){
        super();
        this.capacity = 10;
        this.index = 0;
        this.model = (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).planned;
        this.viewModel = new (0, $73b0b703e27776b4$export$27d18bad757d1f02)({
            item: ':planned'
        });
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$indicatorIntervals = document.querySelector(`.planned--actions .connection-icon-switch--indicator.intervals`);
        this.$indicatorTrainingPeaks = document.querySelector(`.planned--actions .connection-icon-switch--indicator.tp`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:ftp`, this.onFTP.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('action:planned', self.onAction.bind(this), this.signal);
        // TODO: maybe debounce the resize
        // window.addEventListener('resize', this.onWindowResize.bind(this), this.signal);
        self.size = self.getSize();
        this.render();
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onAction(action) {
        // TODO: handle this directly in db
        if (action === ':data') {
            this.render();
            return;
        }
        if (action === ':intervals:wod') {
            this.model.wod('intervals');
            this.model.getAthlete('intervals');
            this.onLoading(this.$indicatorIntervals);
            return;
        }
        if (action === ':intervals:wod:success') this.onSuccess(this.$indicatorIntervals);
        if (action === ':intervals:wod:fail') this.onFail(this.$indicatorIntervals);
        if (action === ':intervals:athlete:sucess') console.log(':intervals:athlete:sucess');
        if (action === ':intervals:athlete:fail') console.log(':intervals:athlete:fail');
        if (action === ':trainingPeaks:wod') {
            this.model.wod('trainingPeaks');
            return;
        }
        if (action === ':trainingPeaks:wod:success') this.onSuccess(this.$indicatorTrainingPeaks);
        if (action === ':trainingPeaks:wod:fail') this.onFail(this.$indicatorTrainingPeaks);
    }
    getSize() {
        const self = this;
        const parent = document.querySelector('#workouts-page');
        const em = 8;
        const px = parseFloat(window.getComputedStyle(parent).fontSize);
        // .getPropertyValue('font-size')
        const height = px * em;
        const width = self.getBoundingClientRect().width ?? window.innerWidth;
        return {
            width: width,
            height: height
        };
    }
    onFTP(ftp) {
        this.ftp = ftp;
        this.render();
    }
    onWindowResize() {}
    toListItem(workout, ftp, size) {
        const self = this;
        const id = workout.id;
        const name = workout.meta.name;
        const category = workout.meta.category;
        const description = workout.meta.description;
        let duration = '';
        if (workout.meta.duration) duration = `${Math.round(workout.meta.duration / 60)} min`;
        if (workout.meta.distance) duration = `${(workout.meta.distance / 1000).toFixed(2)} km`;
        const summary = `
        <div class="workout--name">${name}</div>
        <div class="workout--type">${category}</div>
        <div class="workout--duration">${duration}</div>`;
        const graph = `
            <workout-graph-svg>
                <div class="graph--info--cont"></div>
                ${self.viewModel.toSVG(workout, ftp, size)}
            </workout-graph-svg>`;
        const details = `
        ${graph}
        <div class="workout--description">${description}</div>`;
        return $2741b9ae2dc72316$export$f8f517b1dee64471(id, summary, details, 'li', 'planned-list-item');
    }
    toList() {
        const self = this;
        let list = '';
        const planned = this.model.list();
        for (let workout of planned)list += self.toListItem(workout, self.ftp, self.size);
        return list;
    }
    toEmpty() {
        return `<div class="planned--empty">
                    <p>You have no planned workouts for today.</p>
                </div>`;
    }
    render() {
        const self = this;
        if (this.checkVisibility()) self.size = self.getSize();
        if ((0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).planned.data)) self.innerHTML = self.toEmpty();
        else self.innerHTML = self.toList();
    }
    onLoading($el) {
        $el.classList.remove('fail');
        $el.classList.remove('success');
        $el.classList.remove('none');
        $el.classList.add('loading');
    }
    onSuccess($el) {
        $el.classList.remove('off');
        $el.classList.remove('none');
        $el.classList.remove('loading');
        $el.classList.add('success');
    }
    onFail($el) {
        $el.classList.remove('success');
        $el.classList.remove('loading');
        $el.classList.remove('none');
        $el.classList.add('fail');
    }
}
customElements.define('planned-list', $2741b9ae2dc72316$var$PlannedList);
// List Item that is expandable, selectable and has optional actions
class $2741b9ae2dc72316$var$PlannedListItem extends HTMLElement {
    constructor(){
        super();
        this.isExpanded = false;
        this.isSelected = false;
        this.isOptions = false;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        // NOTE: assigning to this.id will set the id attribute of the html element,
        // we don't won't that
        this.wid = this.dataset.wid;
        this.$expandable = this.querySelector('.expandable');
        this.$optional = this.querySelector('.optional');
        this.$selectable = this.querySelector('.selectable');
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`action:li:${self.wid}`, self.onAction.bind(self), self.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:workout', self.onWorkout.bind(self), self.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onAction(action) {
        if (action === ':select') {
            this.onSelect();
            return;
        }
        if (action === ':remove') {
            this.onRemove();
            return;
        }
        if (action === ':toggle') {
            this.onToggle();
            return;
        }
        if (action === ':options') {
            this.onOptions();
            return;
        }
    }
    onWorkout(value) {
        this.selectedWorkoutId = value.id;
        if (this.wid === this.selectedWorkoutId) this.select();
        else this.deselect();
    }
    onSelect() {
        if (this.selected) return;
        this.select();
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:planned:select`, this.wid);
    }
    select() {
        this.$selectable.classList.add('active');
        this.selected = true;
        this.expand();
    }
    deselect() {
        this.$selectable.classList.remove('active');
        this.selected = false;
    }
    onRemove() {
        console.log(`:remove`);
    // TODO: delete
    }
    onToggle() {
        this.isExpanded ? this.collapse() : this.expand();
    }
    onOptions() {
        this.isOptions ? this.hideOptions() : this.showOptions();
    }
    expand() {
        this.$expandable.classList.add('active');
        this.isExpanded = true;
    }
    collapse() {
        this.$expandable.classList.remove('active');
        this.isExpanded = false;
    }
    showOptions() {
        this.$optional.classList.toggle('active');
        this.isOptions = true;
    }
    hideOptions() {
        this.$optional.classList.toggle('active');
        this.isOptions = false;
    }
}
customElements.define('planned-list-item', $2741b9ae2dc72316$var$PlannedListItem);
function $2741b9ae2dc72316$export$f8f517b1dee64471(id = 0, summary = '', details = '', topic = 'li', element = "planned-list-item") {
    return `<${element} class="active-list-item" data-wid="${id}">
                <div class="item--cont optional">
                    <div class="summary">
                        <view-action action=":toggle" topic=":${topic}:${id}" class="summary--data">
                            ${summary}
                            <view-action class="selectable" action=":select" topic=":${topic}:${id}" stoppropagation class="item--select" id="btn${id}">
                                <svg class="radio">
                                    <use class="off" href="#icon--radio-off" />
                                    <use class="on" href="#icon--radio-on" />
                                </svg>
                            </view-action>
                            <view-action action=":options" topic=":${topic}:${id}" stoppropagation class="item--options">
                                <svg class="control--btn--icon">
                                    <use href="#icon--options" />
                                </svg>
                            </view-action>
                        </view-action>
                    </div>
                    <div class="details expandable">${details}</div>
                </div>
                <div>
                    <view-action action=":remove" topic=":${topic}:${id}" class="optional--actions">
                        <span class="remove">Delete</span>
                    </view-action>
                </div>
            </${element}>`;
}







class $9ffa82d520e40c5a$var$ActivityList extends HTMLElement {
    constructor(){
        super();
        this.capacity = 3;
        this.index = 0;
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('activity:add', self.onAdd.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:activity', self.onRestore.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
        this.unsubs();
    }
    onAdd(activity) {
        const self = this;
        self.insertAdjacentHTML("afterbegin", self.template(this.index, activity));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`action:activity:${this.id(activity)}`, ':toggleExpand');
        if (this.childElementCount > 3) self.removeChild(self.lastElementChild);
        this.index++;
    }
    onRestore(activities) {
        const self = this;
        activities.forEach((a)=>{
            self.insertAdjacentHTML("beforeend", self.template(this.index, a));
        });
    }
    id(data) {
        return data.id;
    }
    name(data) {
        return data.name;
    }
    date(data) {
        return (0, $c6a9e46ee7e4d896$export$3ae94a2503e890a1)({
            date: new Date(data.timestamp),
            separator: '/',
            year: false
        });
    }
    duration(data) {
        return `${Math.ceil(data.duration / 60)} min`;
    }
    uploadStatus(data) {
        return data.status;
    }
    template(i, data) {
        const status = this.uploadStatus(data);
        return `
            <activity-item id="i${i}--activity--item" class="some" data-id="${this.id(data)}">
                    <div class="activity--cont list--row--outer">
                        <div class="list--row--inner activity--info">
                            <div class="activity--info--short">
                                <view-action
                                    class="info"
                                    action=":toggleExpand"
                                    topic=":activity:${this.id(data)}">
                                    <div id="i${i}--activity--date" class="activity--name">
                                        ${this.name(data)}
                                    </div>
                                    <div class="activity--date">
                                        ${this.date(data)}
                                    </div>
                                    <div id="i${i}--activity--duration" class="activity--duration">
                                        ${this.duration(data)}
                                    </div>
                                </view-action>
                                <view-action
                                    class=""
                                    action=":options"
                                    topic=":activity:${this.id(data)}">
                                    <svg class="control--btn--icon" width="24" height="24">
                                        <use href="#icon--options" />
                                    </svg>
                                </view-action>
                            </div>
                            <div class="activity--info--full">
                                <div class="activity--image">
                                </div>
                                <div class="activity--actions">
                                    <div></div>
                                    <view-action
                                        class="activity--action action--intervals"
                                        action=":intervals:upload"
                                        topic=":activity:${this.id(data)}">
                                        <svg class="activity--icon intervals--icon" width="24" height="24">
                                            <use href="#icon--intervals" />
                                        </svg>
                                        <div class="connection-icon-switch--indicator ${status.intervals ?? 'none'} intervals"></div>
                                    </view-action>

                                    <view-action
                                        class="activity--action"
                                        action=":strava:upload"
                                        topic=":activity:${this.id(data)}">
                                        <svg class="activity--icon strava--icon" width="24" height="24">
                                            <use href="#icon--strava" />
                                        </svg>
                                        <div class="connection-icon-switch--indicator ${status.strava ?? 'none'} strava"></div>
                                    </view-action>
                                    <view-action
                                        class="activity--action action--download"
                                        action=":download"
                                        topic=":activity:${this.id(data)}">
                                        <svg class="activity--icon">
                                            <use href="#icon--save-btn" />
                                        </svg>
                                    </view-action>
                                    <view-action
                                        class="activity--action action--image"
                                        action=":image"
                                        topic=":activity:${this.id(data)}">
                                        <svg class="activity--icon">
                                            <use href="#icon--image" />
                                        </svg>
                                    </view-action>
                                </div> <!-- end activity--actions -->
                            </div> <!-- end activity--info--full -->
                        </div> <!-- end activity--info -->
                    </div> <!-- end activity--cont -->
                    <view-action
                        class="activity--options"
                        action=":remove"
                        topic=":activity:${this.id(data)}">
                        <span class="activity--remove">Delete</span>
                    </view-action>
            </activity-item>
        `;
    }
}
// <view-action
//     class="activity--action"
//     action=":tp:upload"
//     topic=":activity:${this.id(data)}">
//     <div class="tp-logo--icon">TP</div>
//     <div class="connection-icon-switch--indicator ${status.tp ?? 'none'} tp"></div>
// </view-action>
customElements.define('activity-list', $9ffa82d520e40c5a$var$ActivityList);
class $9ffa82d520e40c5a$var$ActivityItem extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$indicatorStrava = this.querySelector(`.connection-icon-switch--indicator.strava`);
        this.$indicatorIntervals = this.querySelector(`.connection-icon-switch--indicator.intervals`);
        this.$indicatorTP = this.querySelector(`.connection-icon-switch--indicator.tp`);
        this.id = this.dataset.id;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`action:activity:${self.id}`, this.onAction.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onAction(action) {
        console.log(action, this.id);
        if (action === ':options') {
            this.classList.toggle('options');
            return;
        }
        if (action === ':toggleExpand') {
            this.classList.toggle('expand');
            return;
        }
        if (action === ':remove') {
            // TODO: refactor to a functional state driven approach
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.remove(this.id);
            this.remove();
            return;
        }
        if (action === ':download') {
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.download(this.id);
            return;
        }
        if (action === ':strava:upload') {
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.upload('strava', this.id);
            this.onLoading(this.$indicatorStrava);
            return;
        }
        if (action === ':intervals:upload') {
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.upload('intervals', this.id);
            this.onLoading(this.$indicatorIntervals);
            return;
        }
        if (action === ':tp:upload') {
            (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).activity.upload('trainingPeaks', this.id);
            this.onLoading(this.$indicatorTP);
            return;
        }
        if (action === ':strava:upload:success') this.onSuccess(this.$indicatorStrava);
        if (action === ':strava:upload:fail') this.onFail(this.$indicatorStrava);
        if (action === ':intervals:upload:success') this.onSuccess(this.$indicatorIntervals);
        if (action === ':intervals:upload:fail') this.onFail(this.$indicatorIntervals);
        if (action === ':tp:upload:success') this.onSuccess(this.$indicatorTP);
        if (action === ':tp:upload:fail') this.onFail(this.$indicatorTP);
    }
    onLoading($el) {
        $el.classList.remove('fail');
        $el.classList.remove('success');
        $el.classList.remove('none');
        $el.classList.add('loading');
    }
    onSuccess($el) {
        $el.classList.remove('off');
        $el.classList.remove('none');
        $el.classList.remove('loading');
        $el.classList.add('success');
    }
    onFail($el) {
        $el.classList.remove('success');
        $el.classList.remove('loading');
        $el.classList.remove('none');
        $el.classList.add('fail');
    }
}
customElements.define('activity-item', $9ffa82d520e40c5a$var$ActivityItem);






class $5c7162cabced001c$export$656e74e527ff7e92 extends HTMLElement {
    constructor(){
        super();
        const self = this;
        this.Key = {
            smo2: 'smo2',
            thb: 'thb',
            heartRate: 'heartRate',
            power: 'power'
        };
        // Moxy defined ranges and color codes:
        //
        // SmO2 range: 0 - 100,   step: 0.1, <30% - blue, 30%-70% - green, >70% red
        // THb  range: 0 - 40.00, step: 0.01, 8.0 - 15.0, orange
        //
        // We are going to use just green for SmO2, because we are going to add
        // HeartRate layer and it is going to be red and we don't want those to clash
        // initial state
        this.smo2 = {
            value: 0,
            x: 0,
            min: 0,
            max: 100
        };
        this.thb = {
            value: 0,
            x: 0,
            min: 8,
            max: 15
        };
        this.heartRate = {
            value: 0,
            x: 0,
            min: 30,
            max: 200
        };
        this.power = {
            value: 0,
            x: 0,
            min: 0,
            max: 600
        };
        this.path = {
            smo2: [],
            thb: [],
            heartRate: [],
            power: []
        };
        this.$path = {};
        this.xAxis = {
            min: 0,
            max: 100
        };
        this.yAxis = {
            min: 0,
            max: 100
        };
        this.step = 1;
        this.width = 0;
        this.x = 0;
        // configurations
        this.prop = {
            elapsed: 'watch:elapsed',
            smo2: 'db:smo2',
            thb: 'db:thb',
            heartRate: 'db:heartRate',
            power: 'db:power1s'
        };
        this.selectors = {
            svg: '#moxy-svg',
            path: {
                smo2: '#moxy-path-smo2',
                thb: '#moxy-path-thb',
                heartRate: '#moxy-path-hr',
                power: '#moxy-path-power'
            }
        };
        this.color = {
            smo2: '#57C057',
            thb: '#FF663A',
            heartRate: '#FE340B',
            power: '#F8C73A'
        };
        this.stroke = {
            all: 1
        };
        this.handlers = {
            smo2: (value)=>self.smo2.value = value,
            heartRate: (value)=>self.heartRate.value = value,
            power: (value)=>self.power.value = value,
            thb: (value)=>{
                self.adjustYMinMaxFor('thb', value);
                self.thb.value = value;
            }
        };
        this.postInit();
    }
    postInit() {
    // overwrite in child classes
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.$cont = document.querySelector('#graph-power') ?? this;
        this.$svg = this.querySelector(this.selectors.svg);
        this.width = this.calcWidth();
        for(let key in this.Key){
            // this.path[key] = [];
            this.$path[key] = this.querySelector(this.selectors.path[key]);
            this.$path[key].setAttribute('stroke', this.color[key]);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop[key]}`, this.handlers[key].bind(this), this.signal);
        }
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`${this.prop.elapsed}`, this.onElapsed.bind(this), this.signal);
        window.addEventListener(`resize`, this.onResize.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    calcWidth() {
        return this.$cont.getBoundingClientRect()?.width ?? window.innerWidth;
    }
    onResize() {
        // TODO: debounce
        this.width = this.calcWidth();
    }
    adjustYMinMaxFor(key, value) {
        if (this[key].value === 0) {
            this[key].min = value - 1;
            this[key].max = value + 1;
        }
        // this[key].value = value;
        if (value < this[key].min) this[key].min = value;
        if (value > this[key].max) this[key].max = value;
    }
    onElapsed() {
        // first calculate
        for(let key in this.path)this.calcStep(key);
        // render all
        for(let key in this.path)this.renderStep(key);
        // move x to the right for the next elapsed interval
        this.x += this.step;
    }
    // this.smo2 =      {value: 0, x: 0, min:  0, max: 100};
    // this.thb =       {value: 0, x: 0, min:  8, max:  15};
    // this.heartRate = {value: 0, x: 0, min: 30, max: 200};
    // this.power =     {value: 0, x: 0, min:  0, max: 600};
    // this.xAxis =     {min: 0, max: 100};
    // this.yAxis =     {min: 0, max: 100};
    translate(value, inMin, inMax, outMin, outMax) {
        return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
    }
    translateY(key, value) {
        return this.yAxis.max - this.translate((0, $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4)(this[key].min, this[key].max, value), this[key].min, this[key].max, this.yAxis.min, this.yAxis.max);
    }
    calcStep(key) {
        const y = this.translateY(key, this[key].value);
        let length = this.path[key].length;
        if (length / 2 >= this.width / this.step) {
            const diff = length / 2 - this.width / this.step;
            if (diff >= 2) {
                length = this.width * 2;
                // splice window diff from the front and account for the one shift
                this.path[key].splice(0, diff * 2 + 2);
                // shift path x values to start from 0
                for(let i = 0, j = 0; i < length; i += 1)if (i % 2 == 0) {
                    this.path[key][i] = j;
                    j += 1;
                }
                this.x = length / 2 - 1;
                // shift
                this.path[key][length - 2] = this.x;
                this.path[key][length - 1] = y;
            } else {
                // when xAxis.max is reached,
                // shift in place 2 positions back
                // and set the last 2 position with the new data
                for(let i = 2; i < length; i += 1)if (i % 2 !== 0) this.path[key][i - 2] = this.path[key][i];
                // update x to the new smaller length and
                // compansate for the shift with - 1
                this.x = length / 2 - 1;
                // shift
                this.path[key][length - 2] = this.x;
                this.path[key][length - 1] = y;
            }
        } else {
            // push until xAxis.max is reached
            this.path[key].push(this.x);
            this.path[key].push(y);
        }
    }
    renderStep(key) {
        const points = this.path[key].join(',');
        this.$path[key].setAttribute('points', points);
    }
}
customElements.define('moxy-graph', $5c7162cabced001c$export$656e74e527ff7e92);



class $49687dba4b212ef2$export$4c68f1a79f88778c extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        const self = this;
        this.abortController = new AbortController();
        this.signal = {
            signal: self.abortController.signal
        };
        this.dom = {
            start: document.querySelector('#watch-start'),
            pause: document.querySelector('#watch-pause'),
            back: document.querySelector('#watch-back'),
            lap: document.querySelector('#watch-lap'),
            stop: document.querySelector('#watch-stop'),
            save: document.querySelector('#activity-save')
        };
        this.dom.start.addEventListener('pointerup', this.onStart, this.signal);
        this.dom.pause.addEventListener('pointerup', this.onPause, this.signal);
        this.dom.back.addEventListener('pointerup', this.onBack, this.signal);
        this.dom.lap.addEventListener('pointerup', this.onLap, this.signal);
        this.dom.stop.addEventListener('pointerup', this.onStop, this.signal);
        // this.dom.workout.addEventListener('pointerup', this.onWorkoutStart);
        this.dom.save.addEventListener(`pointerup`, this.onSave, this.signal);
        this.renderInit(this.dom);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:watchStatus`, this.onWatchStatus.bind(this), this.signal);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:workoutStatus`, this.onWorkoutStatus.bind(this), this.signal);
    }
    disconnectedCallback() {
        this.abortController.abort();
    }
    onStart(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:watchStart');
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:workoutStart');
    }
    onPause(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:watchPause');
    }
    onBack(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:watchBack');
    }
    onLap(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:watchLap');
    }
    onStop(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:watchStop');
    }
    onSave(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:activity:save');
    }
    onWorkoutStart(e) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('ui:workoutStart');
    }
    onWatchStatus(status) {
        if (status === 'started') this.renderStarted(this.dom);
        if (status === 'paused') this.renderPaused(this.dom);
        if (status === 'stopped') this.renderStopped(this.dom);
    }
    onWorkoutStatus(status) {
        if (status === 'started') this.renderWorkoutStarted(this.dom);
        status;
    }
    renderInit(dom) {
        dom.pause.style.display = 'none';
        dom.stop.style.display = 'none';
        dom.save.style.display = 'none';
        dom.lap.style.display = 'none';
        dom.back.style.display = 'none';
    }
    renderStarted(dom) {
        dom.start.style.display = 'none';
        dom.save.style.display = 'none';
        dom.pause.style.display = 'inline-block';
        dom.lap.style.display = 'inline-block';
        dom.back.style.display = 'inline-block';
        dom.stop.style.display = 'none';
    // dom.stop.style.display  = 'inline-block';
    }
    renderPaused(dom) {
        dom.pause.style.display = 'none';
        // dom.back.style.display = 'none';
        dom.lap.style.display = 'none';
        dom.start.style.display = 'inline-block';
        dom.stop.style.display = 'inline-block';
    }
    renderStopped(dom) {
        dom.pause.style.display = 'none';
        dom.lap.style.display = 'none';
        dom.back.style.display = 'none';
        dom.stop.style.display = 'none';
        dom.save.style.display = 'inline-block';
        // dom.workout.style.display = 'inline-block';
        dom.start.style.display = 'inline-block';
    }
    renderWorkoutStarted(dom) {
    // dom.workout.style.display = 'none';
    }
}
customElements.define('watch-control', $49687dba4b212ef2$export$4c68f1a79f88778c);





const $41a965098aa674bf$export$ef31c55765759ec = {
    // config
    setNetworkKey: 70,
    // 0x46
    unassignChannel: 65,
    // 0x41
    assignChannel: 66,
    // 0x42
    assignChannelExt: 66,
    // 0x42
    channelPeriod: 67,
    // 0x43
    channelFrequency: 69,
    // 0x45
    setChannelId: 81,
    // 0x51
    serialNumberSet: 101,
    // 0x65
    searchTimeout: 68,
    // 0x44
    searchLowTimeout: 99,
    // 0x63
    enableExtRx: 102,
    // 0x66
    libConfig: 110,
    // 0x6E
    // control
    resetSystem: 74,
    // 0x4A
    openChannel: 75,
    // 0x4B
    closeChannel: 76,
    // 0x4C
    requestMessage: 77,
    // 0x4D
    openRxScanMode: 91,
    // 0x5B
    sleepMessage: 197,
    // 0xC5
    // notification
    startUp: 111,
    // 0x6F
    serialError: 174,
    // 0xAE
    // data
    broadcastData: 78,
    // 0x4E
    acknowledgedData: 79,
    // 0x4F
    broascastExtData: 93,
    // 0x5D
    burstData: 80,
    // 0x50
    burstAdvData: 114,
    // 0x72
    // channel
    channelResponse: 64,
    // 0x40
    channelEvent: 64,
    // 0x40
    // requested response
    channelStatus: 82,
    // 0x52
    channelId: 81,
    // 0x51 response
    ANTVersion: 62,
    // 0x3E
    capabilities: 84,
    // 0x54
    serialNumber: 97 // 0x61
};
const $41a965098aa674bf$export$4bf9923669ad6c63 = {
    response_no_error: 0,
    event_rx_search_timeout: 1,
    event_rx_fail: 2,
    event_tx: 3,
    event_transfer_rx_failed: 4,
    event_transfer_tx_completed: 5,
    event_transfer_tx_failed: 6,
    event_channel_closed: 7,
    event_rx_fail_go_to_search: 8,
    event_channel_collision: 9,
    event_transfer_tx_start: 10,
    event_transfer_next_data_block: 11,
    channel_in_wrong_state: 21,
    channel_not_opened: 22,
    channel_id_not_set: 24,
    close_all_channels: 25,
    transfer_in_progress: 31,
    transfer_sequence_number_error: 32,
    transfer_in_error: 33,
    message_size_exceeds_limit: 39,
    invalid_message: 40,
    invalid_network_number: 41,
    invalid_list_id: 48,
    invalid_scan_tx_channel: 49,
    invalid_parameter_provided: 51,
    event_serial_que_overflow: 52,
    event_que_overflow: 53,
    encrypt_negotiation_success: 56,
    encrypt_negotiation_fail: 57,
    nvm_full_error: 64,
    nvm_write_error: 65,
    usb_string_write_fail: 112,
    mesg_serial_error_id: 174
};
const $41a965098aa674bf$export$68c286be0e7e55b7 = {
    sync: 164,
    libConfig: {
        disabled: 0,
        rxTimestamps: 32,
        // 0x20
        rssi: 64,
        // 0x40
        channelId: 128 // 0x80
    }
};
const $41a965098aa674bf$export$2269465c504bb083 = {
    slave: {
        bidirectional: 0x00,
        sharedBidirectional: 0x20,
        receiveOnly: 0x40
    },
    master: {
        bidirectional: 0x10,
        sharedBidirectional: 0x30
    }
};
const $41a965098aa674bf$export$ed97f33186d4b816 = {
    antPlus: [
        0xB9,
        0xA5,
        0x21,
        0xFB,
        0xBD,
        0x72,
        0xC3,
        0x45
    ],
    public: [
        0xE8,
        0xE4,
        0x21,
        0x3B,
        0x55,
        0x7A,
        0x67,
        0xC1
    ]
};


function $7dba573f618f5969$export$f69c19e57285b83a(args = {}) {
    const sync = (0, $41a965098aa674bf$export$68c286be0e7e55b7).sync;
    const id = (0, $41a965098aa674bf$export$ef31c55765759ec)[(0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.id)];
    const fixedLength = 4;
    let _contentLength;
    let _totalLength;
    setLengths((0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.contentLength, 0));
    function getLength() {
        return _totalLength;
    }
    function setLength(length) {
        _totalLength = length;
        return _totalLength;
    }
    function getContentLength() {
        return _contentLength;
    }
    function setContentLength(length) {
        _contentLength = length;
        return _contentLength;
    }
    function calcLength(contentLength) {
        return fixedLength + contentLength;
    }
    function setLengths(contentLength) {
        const length = calcLength(contentLength);
        setContentLength(contentLength);
        setLength(length);
        return {
            length: length,
            contentLength: contentLength
        };
    }
    function validate(dataview, check) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)((0, $c6a9e46ee7e4d896$export$6444ef5cd411280c)(dataview, 0, -1), check);
    }
    return {
        sync: sync,
        id: id,
        fixedLength: fixedLength,
        getContentLength: getContentLength,
        setContentLength: setContentLength,
        getLength: getLength,
        calcLength: calcLength,
        setLengths: setLengths,
        validate: validate,
        xor: (0, $c6a9e46ee7e4d896$export$6444ef5cd411280c)
    };
}
// Config messages
function $7dba573f618f5969$var$AssignChannel() {
    const extendedAssignment = {
        backgroundScanningEnable: 0x01,
        frequencyAgilityEnable: 0x04,
        fastChannelInitiationEnable: 0x10,
        asynchronousTransmissionEnable: 0x20
    };
    const defaults = {
        channelNumber: 0,
        channelType: (0, $41a965098aa674bf$export$2269465c504bb083).slave.bidirectional,
        networkNumber: 0,
        extended: extendedAssignment.backgroundScanningEnable
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        id: 'assignChannel' // 66, 0x42
    });
    function contentLength(isExtended) {
        if (isExtended) return 4;
        return 3;
    }
    function encode(args = {}) {
        const { length: length } = msg.setLengths(contentLength((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.extended)));
        const xorIndex = length - 1;
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const channelType = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelType, defaults.channelType);
        const networkNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.networkNumber, defaults.networkNumber);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, channelType, true);
        view.setUint8(5, networkNumber, true);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.extended)) view.setUint8(6, args.extended, true);
        view.setUint8(xorIndex, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const contentLength = dataview.getUint8(1, true);
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const channeType = dataview.getUint8(4, true);
        const networkNumber = dataview.getUint8(5, true);
        const xorIndex = dataview.byteLength - 1;
        const check = dataview.getUint8(xorIndex, true);
        const valid = msg.validate(dataview, check);
        const res = {
            id: id,
            channelNumber: channelNumber,
            channeType: channeType,
            networkNumber: networkNumber,
            valid: valid
        };
        let extended;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(contentLength, 4)) {
            extended = dataview.getUint8(6, true);
            res.extended = extended;
        }
        return res;
    }
    return Object.freeze({
        extendedAssignment: extendedAssignment,
        contentLength: contentLength,
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$UnassignChannel() {
    const defaults = {
        channelNumber: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 1,
        id: 'unassignChannel' // 65, 0x41
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const check = dataview.getUint8(4, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$SetChannelId() {
    const defaults = {
        channelNumber: 0,
        deviceNumber: 0,
        deviceType: 0,
        transmissionType: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 5,
        id: 'setChannelId'
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const deviceNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.deviceNumber, defaults.deviceNumber);
        const deviceType = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.deviceType, defaults.deviceType);
        const transmissionType = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.transmissionType, defaults.transmissionType);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint16(4, deviceNumber, true);
        view.setUint8(6, deviceType, true);
        view.setUint8(7, transmissionType, true);
        view.setUint8(8, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const deviceNumber = dataview.getUint16(4, true);
        const deviceType = dataview.getUint8(6, true);
        const transmissionType = dataview.getUint8(7, true);
        const check = dataview.getUint8(8, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            deviceNumber: deviceNumber,
            deviceType: deviceType,
            transmissionType: transmissionType,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$SetChannelPeriod() {
    const defaults = {
        channelNumber: 0,
        channelPeriod: 8192 // (4Hz)
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 3,
        id: 'channelPeriod' // 67, 0x43
    });
    const length = msg.getLength();
    // The channel messaging period in seconds * 32768.
    // Maximum messaging period is ~2 seconds.
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const channelPeriod = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelPeriod, defaults.channelPeriod);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint16(4, channelPeriod, true);
        view.setUint8(6, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const channelPeriod = dataview.getUint16(4, true);
        const check = dataview.getUint8(6, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            channelPeriod: channelPeriod,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$SetChannelFrequency() {
    const defaults = {
        channelNumber: 0,
        rfFrequency: 66
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'channelFrequency' // 69, 0x45
    });
    const length = msg.getLength();
    // ChannelFrequency = 2400 MHz + ChannelRFFrequencyNumber * 1.0 MHz
    // most ANT devices ara between 2450 MHz and 2457 MHz
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const rfFrequency = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.rfFrequency, defaults.rfFrequency);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, rfFrequency, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const rfFrequency = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            rfFrequency: rfFrequency,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$SetNetworkKey() {
    const defaults = {
        networkKey: (0, $41a965098aa674bf$export$ed97f33186d4b816).public,
        networkNumber: 0
    };
    const networkKeyIndex = 4;
    const networkKeyLength = 8;
    const networkKeyIndexEnd = networkKeyIndex + networkKeyLength;
    const xorIndex = 12;
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 9,
        id: 'setNetworkKey' // 70, 0x46
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const networkKey = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.networkKey, defaults.networkKey);
        const networkNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.networkNumber, defaults.networkNumber);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        const uint8 = new Uint8Array(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, networkNumber, true);
        uint8.set(new Uint8Array(networkKey), networkKeyIndex);
        view.setUint8(xorIndex, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const networkNumber = dataview.getUint8(3, true);
        const array = (0, $c6a9e46ee7e4d896$export$d59ba87ce515b3fd)(dataview);
        const networkKey = array.slice(networkKeyIndex, networkKeyIndexEnd);
        const check = dataview.getUint8(xorIndex, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            networkNumber: networkNumber,
            networkKey: networkKey,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
// Control Messages
function $7dba573f618f5969$var$ResetSystem() {
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 1,
        id: 'resetSystem' // 74, 0x4A
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, 0, true);
        view.setUint8(4, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const check = dataview.getUint8(4, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$OpenChannel() {
    const defaults = {
        channelNumber: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 1,
        id: 'openChannel' // 75, 0x4B
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const check = dataview.getUint8(4, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$CloseChannel() {
    const defaults = {
        channelNumber: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 1,
        id: 'closeChannel' // 76, 0x4C
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const check = dataview.getUint8(4, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$RequestMessage(args = {}) {
    const defaults = {
        channelNumber: 0,
        subMessageId: false,
        requestedMessageId: (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.requestedMessageId, (0, $41a965098aa674bf$export$ef31c55765759ec).channelStatus)
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'requestMessage' // 77, 0x4D
    });
    const length = msg.getLength();
    function encode(args = {
        subMessageId: false
    }) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const subMessageId = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.subMessageId, defaults.subMessageId);
        const requestedMessageId = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.requestedMessageId, defaults.requestedMessageId);
        // it sends channelNumber or subMessageId if command is applicable for the whole system,
        // Example:
        // if requesting Advanced Burst Capabilities/Configuration,
        // instead of channel number, set to:
        // 0x00 – Request Advanced Burst Capabilities
        // 0x01 – Request Advanced Burst Current Configuration
        let param = channelNumber;
        if (subMessageId) param = subMessageId;
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, param, true);
        view.setUint8(4, requestedMessageId, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const param = dataview.getUint8(3, true);
        const requestedMessageId = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        const res = {
            id: id,
            param: param,
            requestedMessageId: requestedMessageId,
            valid: valid
        };
        return res;
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$OpenRxScanMode() {
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        id: 'openRxScanMode' // 91, 0x5B
    });
    function contentLength(args) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.syncPackets)) return 2;
        return 1;
    }
    // syncPackets:
    // 0 – Default configuration.
    // 1 – Allow synchronous channel packets only.
    function encode(args = {}) {
        const syncPackets = args.syncPackets;
        const { length: length } = msg.setLengths(contentLength(args));
        const xorIndex = length - 1;
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, 0, true);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(syncPackets)) view.setUint8(4, syncPackets, true);
        view.setUint8(xorIndex, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const contentLength = dataview.getUint8(1, true);
        const id = dataview.getUint8(2, true);
        const xorIndex = dataview.byteLength - 1;
        const check = dataview.getUint8(xorIndex, true);
        const valid = msg.validate(dataview, check);
        let syncPackets;
        const res = {
            id: id,
            valid: valid
        };
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(contentLength, 2)) {
            syncPackets = dataview.getUint8(4, true);
            res.syncPackets = syncPackets;
        }
        return res;
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$Sleep() {
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 1,
        id: 'sleepMessage' // 197, 0xC5
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, 0, true);
        view.setUint8(4, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const check = dataview.getUint8(4, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$SearchTimeout() {
    const defaults = {
        channelNumber: 0,
        searchTimeout: 10 // 10 * 2.5 seconds = 25 seconds
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'searchTimeout' // 68, 0x44
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const searchTimeout = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.searchTimeout, defaults.searchTimeout);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, searchTimeout, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const searchTimeout = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            searchTimeout: searchTimeout,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$LowPrioritySearchTimeout() {
    const defaults = {
        channelNumber: 0,
        lowSearchTimeout: 2 // 2 * 2.5 seconds = 5 seconds, 255 is infinite
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'searchLowTimeout' // 99, 0x63
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const lowSearchTimeout = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.lowSearchTimeout, defaults.lowSearchTimeout);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, lowSearchTimeout, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const lowSearchTimeout = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            lowSearchTimeout: lowSearchTimeout,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$EnableExtRxMessages() {
    const defaults = {
        enable: 1 // 0 disable, 1 enable
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'enableExtRx' // 102, 0x66
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const enable = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.enable, defaults.enable);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, 0, true);
        view.setUint8(4, enable, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const enable = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            enable: enable,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$LibConfig() {
    const defaults = {
        config: (0, $41a965098aa674bf$export$68c286be0e7e55b7).libConfig.disabled
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'libConfig' // 110, 0x6E
    });
    const length = msg.getLength();
    function encode(args = {}) {
        const config = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.config, defaults.config);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, 0, true);
        view.setUint8(4, config, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const config = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            config: config,
            valid: valid
        };
    }
    return Object.freeze({
        values: $41a965098aa674bf$export$68c286be0e7e55b7,
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$Data(args = {}) {
    const defaults = {
        channelNumber: 0,
        typeId: 'broadcastData',
        payload: (length)=>new Uint8Array(new ArrayBuffer(length))
    };
    const payloadIndex = 4;
    const payloadLength = 8;
    const extendedDataIndex = payloadIndex + payloadLength;
    const flagIndex = 12;
    const typeId = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.typeId, defaults.typeId);
    function contentLength(args = {}) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.extended)) return 9 + args.extended.byteLength;
        return 9;
    }
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        id: typeId
    });
    // Configuring extended data with:
    // - EnableExtendedMessages, sends ChannelId (Device number, Device Type, Transmission Type)
    // - LibConfig, sends ChannelId, RSSI and timestamp
    function encode(args = {}) {
        const { length: length } = msg.setLengths(contentLength(args));
        const xorIndex = length - 1;
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const payload = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.payload, defaults.payload(0));
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        const uint8 = new Uint8Array(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        uint8.set(new Uint8Array(payload.buffer), payloadIndex);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.extended)) uint8.set(new Uint8Array(args.extended.buffer), extendedDataIndex);
        view.setUint8(xorIndex, msg.xor(view), true);
        return view;
    }
    function decode(dataview, payloadDecoder) {
        const contentLength = dataview.getUint8(1, true);
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const xorIndex = dataview.byteLength - 1;
        const check = dataview.getUint8(xorIndex, true);
        const valid = msg.validate(dataview, check);
        let payload = new DataView(new ArrayBuffer(contentLength - 1)); // must be dataview
        for(let i = 0; i < contentLength - 1; i++)payload.setUint8(i, dataview.getUint8(payloadIndex + i, true), true);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(payloadDecoder)) payload = payloadDecoder(payload);
        const res = {
            id: id,
            channelNumber: channelNumber,
            payload: payload,
            valid: valid
        };
        if (isExtended(dataview)) {
            const channelId = channelIdDecoder(dataview);
            res.channelId = channelId;
        }
        return res;
    }
    function channelIdDecoder(dataview) {
        const deviceNumber = dataview.getUint16(13, true);
        const deviceType = dataview.getUint8(15, true);
        const transmissionType = dataview.getUint8(16, true);
        return {
            deviceNumber: deviceNumber,
            deviceType: deviceType,
            transmissionType: transmissionType
        };
    }
    function isBroadcast(dataview) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dataview.getUint8(2, true), (0, $41a965098aa674bf$export$ef31c55765759ec).broadcastData);
    }
    function isAcknowledged(dataview) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dataview.getUint8(2, true), (0, $41a965098aa674bf$export$ef31c55765759ec).acknowledgedData);
    }
    function isExtended(dataview) {
        return dataview.byteLength > 13;
    }
    return Object.freeze({
        isBroadcast: isBroadcast,
        isAcknowledged: isAcknowledged,
        isExtended: isExtended,
        encode: encode,
        decode: decode,
        channelIdDecoder: channelIdDecoder
    });
}
function $7dba573f618f5969$var$BroadcastData() {
    return $7dba573f618f5969$var$Data({
        typeId: 'broadcastData'
    }); // 78, 0x4E
}
function $7dba573f618f5969$var$AcknowledgedData() {
    return $7dba573f618f5969$var$Data({
        typeId: 'acknowledgedData'
    }); // 79, 0x4F
}
function $7dba573f618f5969$var$BurstTransferData() {
    function encode() {
        throw new Error('not implemented');
    }
    function decode() {
        throw new Error('not implemented');
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$AdvancedBurstData() {
    function encode() {
        throw new Error('not implemented');
    }
    return Object.freeze({
        encode: encode
    });
}
function $7dba573f618f5969$var$ChannelEvent() {
    const defaults = {
        channelNumber: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        id: 'channelEvent'
    });
    const encryptionIdLength = 4;
    const userInfoStringLength = 19;
    function calcContentLength(args) {
        let length = 3;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.encryptionId)) length += encryptionIdLength;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.userInfoString)) length += userInfoStringLength;
        return length;
    }
    function encode(args) {
        const contentLength = calcContentLength(args);
        const { length: length } = msg.setLengths(contentLength);
        const xorIndex = length - 1;
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        const uint8 = new Uint8Array(buffer);
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const eventCode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.eventCode);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, 1, true);
        view.setUint8(5, eventCode, true);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.encryptionId)) {
            view.setUint32(6, args.encryptionId, true);
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(args.userInfoString)) uint8.set(args.userInfoString, 10);
        }
        view.setUint8(xorIndex, (0, $c6a9e46ee7e4d896$export$6444ef5cd411280c)(view), true);
        return view;
    }
    function decode(dataview) {
        const sync = dataview.getUint8(0, true);
        const contentLength = dataview.getUint8(1, true);
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const eventCode = dataview.getUint8(5, true);
        const { length: length } = msg.setLengths(contentLength);
        const xorIndex = length - 1;
        const uint8 = new Uint8Array(dataview.buffer);
        const check = dataview.getUint8(xorIndex, true);
        const valid = msg.validate(dataview, check);
        let encryptionId;
        let userInfoString;
        const res = {
            id: id,
            channelNumber: channelNumber,
            eventCode: eventCode,
            valid: valid
        };
        if (length > 7) {
            encryptionId = dataview.getUint32(6, true);
            res.encryptionId = encryptionId;
            if (length > 7 + encryptionIdLength) {
                userInfoString = uint8.subarray(10, 10 + userInfoStringLength);
                res.userInfoString = userInfoString;
            }
        }
        return res;
    }
    function isEvent(dataview) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dataview.getUint8(2, true), (0, $41a965098aa674bf$export$ef31c55765759ec).channelResponse) && (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dataview.getUint8(4, true), 1);
    }
    return Object.freeze({
        isEvent: isEvent,
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$ChannelResponse() {
    const defaults = {
        channelNumber: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 3,
        id: 'channelResponse'
    });
    function encode(args) {
        const buffer = new ArrayBuffer(msg.getLength());
        const view = new DataView(buffer);
        const channelNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelNumber, defaults.channelNumber);
        const initMsgId = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.initMsgId);
        const responseCode = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.responseCode);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, initMsgId, true);
        view.setUint8(5, responseCode, true);
        view.setUint8(6, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const sync = dataview.getUint8(0, true);
        const contentLength = dataview.getUint8(1, true);
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const initMsgId = dataview.getUint8(4, true);
        const responseCode = dataview.getUint8(5, true);
        const check = dataview.getUint8(6, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            initMsgId: initMsgId,
            responseCode: responseCode,
            valid: valid
        };
    }
    function isResponse(dataview) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dataview.getUint8(2, true), (0, $41a965098aa674bf$export$ef31c55765759ec).channelResponse) && !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(dataview.getUint8(4, true), 1);
    }
    return Object.freeze({
        isResponse: isResponse,
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$ChannelStatus() {
    const defaults = {
        channelNumber: 0,
        channelState: 0,
        networkNumber: 0,
        channelType: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 2,
        id: 'channelStatus'
    });
    const channelStates = {
        unassigned: 0,
        assigned: 1,
        searching: 2,
        tracking: 3
    };
    function encodeChannelStatus(args) {
        let status = 0;
        status |= (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelState, defaults.channelState);
        status |= (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.networkNumber, defaults.networkNumber) << 2;
        status |= (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.channelType, defaults.channelType) << 4;
        return status;
    }
    function encode(args = {}) {
        const buffer = new ArrayBuffer(msg.getLength());
        const view = new DataView(buffer);
        const channelNumber = args.channelNumber || defaults.channelNumber;
        const status = encodeChannelStatus(args);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, channelNumber, true);
        view.setUint8(4, status, true);
        view.setUint8(5, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const sync = dataview.getUint8(0, true);
        const contentLength = dataview.getUint8(1, true);
        const id = dataview.getUint8(2, true);
        const channelNumber = dataview.getUint8(3, true);
        const status = dataview.getUint8(4, true);
        const check = dataview.getUint8(5, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            channelNumber: channelNumber,
            status: status,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$ChannelId() {
    return $7dba573f618f5969$var$SetChannelId();
}
function $7dba573f618f5969$var$Capabilities() {
    const defaults = {
        maxChannels: 0,
        maxNetworks: 0,
        maxSensRcore: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 8,
        id: 'capabilities'
    });
    const length = msg.getLength();
    function encodeStandardOptions(args) {
        let options = 0;
        if (args.no_receive_channels) options |= 1;
        if (args.no_transmit_channels) options |= 2;
        if (args.no_receive_messages) options |= 4;
        if (args.no_transmit_messages) options |= 8;
        if (args.no_ackd_messages) options |= 16;
        if (args.no_burst_messages) options |= 32;
        return options;
    }
    function decodeStandardOptions(bitField) {
        return {
            no_receive_channels: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 0),
            no_transmit_channels: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 1),
            no_receive_messages: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 2),
            no_transmit_messages: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 3),
            no_ackd_messages: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 4),
            no_burst_messages: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 5)
        };
    }
    function encodeAdvancedOptions(args) {
        let options = 0;
        if (args.network_enabled) options |= 2;
        if (args.serial_number_enabled) options |= 8;
        if (args.per_channel_tx_power_enabled) options |= 16;
        if (args.low_priority_search_enabled) options |= 32;
        if (args.script_enabled) options |= 64;
        if (args.search_list_enabled) options |= 128;
        return options;
    }
    function decodeAdvancedOptions(bitField) {
        return {
            network_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 1),
            serial_number_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 3),
            per_channel_tx_power_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 4),
            low_priority_search_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 5),
            script_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 6),
            search_list_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 7)
        };
    }
    function encodeAdvancedOptions2(args) {
        let options = 0;
        if (args.led_enabled) options |= 1;
        if (args.ext_message_enabled) options |= 2;
        if (args.scan_mode_enabled) options |= 4;
        if (args.prox_search_enabled) options |= 16;
        if (args.ext_assign_enabled) options |= 32;
        if (args.fs_antfs_enabled) options |= 64;
        if (args.fit1_enabled) options |= 128;
        return options;
    }
    function decodeAdvancedOptions2(bitField) {
        return {
            led_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 0),
            ext_message_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 1),
            scan_mode_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 2),
            prox_search_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 4),
            ext_assign_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 5),
            fs_antfs_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 6),
            fit1_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 7)
        };
    }
    function encodeAdvancedOptions3(args) {
        let options = 0;
        if (args.advanced_burst_enabled) options |= 1;
        if (args.event_buffering_enabled) options |= 2;
        if (args.event_filtering_enabled) options |= 4;
        if (args.high_duty_search_enabled) options |= 8;
        if (args.search_sharing_enabled) options |= 16;
        if (args.selective_data_updates_enabled) options |= 64;
        if (args.encrypted_channel_enabled) options |= 128;
        return options;
    }
    function decodeAdvancedOptions3(bitField) {
        return {
            advanced_burst_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 0),
            event_buffering_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 1),
            event_filtering_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 2),
            high_duty_search_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 3),
            search_sharing_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 4),
            selective_data_updates_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 6),
            encrypted_channel_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 7)
        };
    }
    function encodeAdvancedOptions4(args) {
        let options = 0;
        if (args.capabilities_rfactive_notification_enabled) options |= 1;
        return options;
    }
    function decodeAdvancedOptions4(bitField) {
        return {
            capabilities_rfactive_notification_enabled: (0, $c6a9e46ee7e4d896$export$bc7d73a5d14928db)(bitField, 0)
        };
    }
    function encode(args = {}) {
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        const maxChannels = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.maxChannels, defaults.maxChannels);
        const maxNetworks = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.maxNetworks, defaults.maxNetworks);
        const standard = encodeStandardOptions(args);
        const advanced = encodeAdvancedOptions(args);
        const advanced2 = encodeAdvancedOptions2(args);
        const maxSensRcore = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.maxSensRcore, defaults.maxSensRcore);
        const advanced3 = encodeAdvancedOptions3(args);
        const advanced4 = encodeAdvancedOptions4(args);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint8(3, maxChannels, true);
        view.setUint8(4, maxNetworks, true);
        view.setUint8(5, standard, true);
        view.setUint8(6, advanced, true);
        view.setUint8(7, advanced2, true);
        view.setUint8(8, maxSensRcore, true);
        view.setUint8(9, advanced3, true);
        view.setUint8(10, advanced4, true);
        view.setUint8(11, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const maxChannels = dataview.getUint8(3, true);
        const maxNetworks = dataview.getUint8(4, true);
        const standard = decodeStandardOptions(dataview.getUint8(5, true));
        const advanced = decodeAdvancedOptions(dataview.getUint8(6, true));
        const advanced2 = decodeAdvancedOptions2(dataview.getUint8(7, true));
        const maxSensRcore = dataview.getUint8(8, true);
        const advanced3 = decodeAdvancedOptions3(dataview.getUint8(9, true));
        const advanced4 = decodeAdvancedOptions4(dataview.getUint8(10, true));
        const check = dataview.getUint8(11, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            maxChannels: maxChannels,
            maxNetworks: maxNetworks,
            ...standard,
            ...advanced,
            ...advanced2,
            maxSensRcore: maxSensRcore,
            ...advanced3,
            ...advanced4,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        encodeStandardOptions: encodeStandardOptions,
        encodeAdvancedOptions: encodeAdvancedOptions,
        encodeAdvancedOptions2: encodeAdvancedOptions2,
        encodeAdvancedOptions3: encodeAdvancedOptions3,
        encodeAdvancedOptions4: encodeAdvancedOptions4,
        decode: decode
    });
}
function $7dba573f618f5969$var$SerialNumber() {
    const defaults = {
        serialNumber: 0
    };
    const msg = $7dba573f618f5969$export$f69c19e57285b83a({
        contentLength: 4,
        id: 'serialNumber' // 97, 0x61
    });
    const length = msg.getLength();
    function encode(args) {
        const serialNumber = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.serialNumber, defaults.serialNumber);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, msg.sync, true);
        view.setUint8(1, msg.getContentLength(), true);
        view.setUint8(2, msg.id, true);
        view.setUint32(3, serialNumber, true);
        view.setUint8(7, msg.xor(view), true);
        return view;
    }
    function decode(dataview) {
        const id = dataview.getUint8(2, true);
        const serialNumber = dataview.getUint32(3, true);
        const check = dataview.getUint8(7, true);
        const valid = msg.validate(dataview, check);
        return {
            id: id,
            serialNumber: serialNumber,
            valid: valid
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $7dba573f618f5969$var$deviceTypeToString(deviceType) {
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(deviceType, 120)) return 'Heart Rate';
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(deviceType, 17)) return 'Trainer';
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(deviceType, 11)) return 'Power Meter';
    if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(deviceType, 121)) return 'Speed and Cadence';
    return 'unsupported';
}
function $7dba573f618f5969$var$isExtended(dataview) {
    return $7dba573f618f5969$export$a8ecead220dd38a6.data.isExtended(dataview);
}
function $7dba573f618f5969$var$isBroadcast(dataview) {
    return $7dba573f618f5969$export$a8ecead220dd38a6.data.isBroadcast(dataview);
}
function $7dba573f618f5969$var$isAcknowledged(dataview) {
    return $7dba573f618f5969$export$a8ecead220dd38a6.data.isAcknowledged(dataview);
}
function $7dba573f618f5969$var$isEvent(dataview) {
    return $7dba573f618f5969$export$a8ecead220dd38a6.channelEvent.isEvent(dataview);
}
function $7dba573f618f5969$var$isResponse(dataview) {
    return $7dba573f618f5969$export$a8ecead220dd38a6.channelResponse.isResponse(dataview);
}
const $7dba573f618f5969$export$a8ecead220dd38a6 = {
    // config
    assignChannel: $7dba573f618f5969$var$AssignChannel(),
    unassignChannel: $7dba573f618f5969$var$UnassignChannel(),
    setChannelId: $7dba573f618f5969$var$SetChannelId(),
    setChannelPeriod: $7dba573f618f5969$var$SetChannelPeriod(),
    setChannelFrequency: $7dba573f618f5969$var$SetChannelFrequency(),
    setNetworkKey: $7dba573f618f5969$var$SetNetworkKey(),
    searchTimeout: $7dba573f618f5969$var$SearchTimeout(),
    lowPrioritySearchTimeout: $7dba573f618f5969$var$LowPrioritySearchTimeout(),
    enableExtRxMessages: $7dba573f618f5969$var$EnableExtRxMessages(),
    libConfig: $7dba573f618f5969$var$LibConfig(),
    // control
    resetSystem: $7dba573f618f5969$var$ResetSystem(),
    openChannel: $7dba573f618f5969$var$OpenChannel(),
    closeChannel: $7dba573f618f5969$var$CloseChannel(),
    requestMessage: $7dba573f618f5969$var$RequestMessage(),
    requestChannelStatus: $7dba573f618f5969$var$RequestMessage({
        requestedMessageId: (0, $41a965098aa674bf$export$ef31c55765759ec).channelStatus
    }),
    openRxScanMode: $7dba573f618f5969$var$OpenRxScanMode(),
    sleep: $7dba573f618f5969$var$Sleep(),
    // data
    data: $7dba573f618f5969$var$Data(),
    broadcastData: $7dba573f618f5969$var$BroadcastData(),
    acknowledgedData: $7dba573f618f5969$var$AcknowledgedData(),
    burstTransferData: $7dba573f618f5969$var$BurstTransferData(),
    advancedBurstData: $7dba573f618f5969$var$AdvancedBurstData(),
    // channel messages
    channelEvent: $7dba573f618f5969$var$ChannelEvent(),
    channelResponse: $7dba573f618f5969$var$ChannelResponse(),
    // requested response messages
    channelStatus: $7dba573f618f5969$var$ChannelStatus(),
    channelId: $7dba573f618f5969$var$ChannelId(),
    capabilities: $7dba573f618f5969$var$Capabilities(),
    serialNumber: $7dba573f618f5969$var$SerialNumber(),
    isExtended: // utils
    $7dba573f618f5969$var$isExtended,
    isBroadcast: $7dba573f618f5969$var$isBroadcast,
    isAcknowledged: $7dba573f618f5969$var$isAcknowledged,
    isEvent: $7dba573f618f5969$var$isEvent,
    isResponse: $7dba573f618f5969$var$isResponse
};
const $7dba573f618f5969$export$eab97d15b1788b8d = {
    deviceTypeToString: $7dba573f618f5969$var$deviceTypeToString
};


class $c625457ae1a0ce5c$export$7fa6c5b6f8193917 extends HTMLElement {
    constructor(){
        super();
        this.state = {};
        this.list = this.querySelector('#request-popup-list');
        this.status = this.querySelector('#request-popup-status');
        this.cancelBtn = this.querySelector('#request-popup-cancel-btn');
        this.pairBtn = this.querySelector('#request-popup-pair-btn');
    }
    connectedCallback() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:antDeviceId`, this.onDeviceId.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:antSearchList', this.onDeviceFound.bind(this));
        this.list.addEventListener('pointerup', this.onSelect.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:search:started`, this.onSearchStarted.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:search:stopped`, this.onSearchStopped.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:request:pair`, this.onRequestPair.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ant:request:cancel`, this.onRequestCancel.bind(this));
    }
    disconnectedCallback() {
        this.list.removeEventListener('pointerup', this.onSelect.bind(this));
        document.removeEventListener(`db:antDeviceId`, this.onDeviceId);
        document.removeEventListener(`db:antSearchList`, this.onDeviceId);
        document.removeEventListener(`ant:search:started`, this.onSearchStarted);
        document.removeEventListener(`ant:search:stopped`, this.onSearchStopped);
        document.removeEventListener(`ant:request:pair`, this.onSearchStarted);
        document.removeEventListener(`ant:request:cancel`, this.onSearchStopped);
    }
    onDeviceId(deviceId) {
        this.state.deviceId = deviceId;
    }
    onSearchStarted(e) {
        this.show();
    }
    onSearchStopped(e) {
        this.clear();
        this.hide();
    }
    onRequestPair() {
        if (!this.selected) return;
        this.clear();
        this.hide();
    }
    onRequestCancel() {
        this.clear();
        this.hide();
    }
    onDeviceFound(searchList) {
        if (!(0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(searchList)) this.add((0, $c6a9e46ee7e4d896$export$4c7897fafd92b108)(searchList));
    }
    onSelect(e) {
        const el = e.target.closest('.device-chooser-item');
        const els = this.list.querySelectorAll('.device-chooser-item');
        if (el === undefined || el === null) return;
        if (el.id === undefined) return;
        const id = el.id;
        this.state.selected = id;
        els.forEach((el)=>el.style.backgroundColor = '#fff');
        el.style.backgroundColor = '#efefef';
        console.log(`:view :device-selected ${id}`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:ant:request:selected`, id);
    }
    show() {
        this.style.display = 'block';
    }
    hide() {
        this.style.display = 'none';
    }
    clear() {
        this.list.innerHTML = ``;
    }
    add(device) {
        this.list.insertAdjacentHTML('beforeend', $c625457ae1a0ce5c$var$item(device));
    }
}
function $c625457ae1a0ce5c$var$item(args) {
    let deviceType = (0, $7dba573f618f5969$export$eab97d15b1788b8d).deviceTypeToString(args.deviceType);
    return `<div class="device-chooser-item" id="${args.deviceNumber}">
            <div class="device-connection-type t2">ANT+</div>
            <div class="device-number t3">${args.deviceNumber}</div>
            <div class="device-type t2">${deviceType}</div>
         </div>`;
}
customElements.define('request-popup', $c625457ae1a0ce5c$export$7fa6c5b6f8193917);




function $85f49df6c023425e$export$16e4d70cc375e707() {
    const isKeyUp = (code)=>code === "ArrowUp";
    const isKeyDown = (code)=>code === "ArrowDown";
    const isKeyE = (code)=>code === "KeyE";
    const isKeyR = (code)=>code === "KeyR";
    const isKeyS = (code)=>code === "KeyS";
    const isKeyL = (code)=>code === "KeyL";
    const isKeySpace = (code)=>code === "Space";
    window.addEventListener("keydown", onKeydown.bind(this));
    function onKeydown(e) {
        let keyCode = e.keyCode;
        let code = e.code;
        if (e.isComposing || keyCode === 229 || e.ctrlKey || e.shiftKey || e.altKey || (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(e.target.form)) return;
        if (isKeyUp(code)) {
            e.preventDefault();
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:up");
        }
        if (isKeyDown(code)) {
            e.preventDefault();
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:down");
        }
        if (isKeyS(code)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:s");
        if (isKeyR(code)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:r");
        if (isKeyE(code)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:e");
        if (isKeyL(code)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:l");
        if (isKeySpace(code)) {
            e.preventDefault();
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("key:space");
        }
    }
}
function $85f49df6c023425e$export$a34fcda2dd58fb18() {
    let mode = (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg;
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:mode", (x)=>mode = x);
    let watchStatus = "stopped";
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:watchStatus", (x)=>watchStatus = x);
    // Modes Inc/Dec
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:up", (e)=>{
        if (mode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:power-scale-inc");
        if (mode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).resistance) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:resistance-target-inc");
        if (mode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:slope-target-inc");
    });
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:down", (e)=>{
        if (mode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:power-scale-dec");
        if (mode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).resistance) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:resistance-target-dec");
        if (mode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:slope-target-dec");
    });
    // Modes
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:e", (e)=>{
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:mode-set", (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg);
    });
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:r", (e)=>{
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:mode-set", (0, $21d6c30d826f68a8$export$83d617ae204944c5).resistance);
    });
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:s", (e)=>{
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:mode-set", (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim);
    });
    // Watch
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:space", (e)=>{
        if (watchStatus === "paused" || watchStatus === "stopped") {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:watchStart");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:workoutStart");
        } else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:watchPause");
    });
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("key:l", (e)=>{
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:watchLap");
    });
}
$85f49df6c023425e$export$16e4d70cc375e707();
$85f49df6c023425e$export$a34fcda2dd58fb18();


function $548373fbdb9c2b99$var$start() {
    console.log('start views.');
}
$548373fbdb9c2b99$var$start();








const $5f192bdbcf8caac3$var$services = {
    fitnessMachine: '00001826-0000-1000-8000-00805f9b34fb',
    cyclingPower: '00001818-0000-1000-8000-00805f9b34fb',
    heartRate: '0000180d-0000-1000-8000-00805f9b34fb',
    speedCadence: '00001816-0000-1000-8000-00805f9b34fb',
    battery: '0000180f-0000-1000-8000-00805f9b34fb',
    fec: '6e40fec1-b5a3-f393-e0a9-e50e24dcca9e',
    wahooFitnessMachine: 'a026ee0b-0a7d-4ab3-97fa-f1500f9feb8b',
    raceController: '00000001-19ca-4651-86e5-fa29dcdd09d1',
    smo2: '6404d801-4cb9-11e8-b566-0800200c9a66',
    coreTemp: '00002100-5b1e-4347-b07c-97b514dae121'
};
const $5f192bdbcf8caac3$var$characteristics = {
    // Fitness Machine
    indoorBikeData: '00002ad2-0000-1000-8000-00805f9b34fb',
    fitnessMachineControlPoint: '00002ad9-0000-1000-8000-00805f9b34fb',
    fitnessMachineFeature: '00002acc-0000-1000-8000-00805f9b34fb',
    supportedResistanceLevelRange: '00002ad6-0000-1000-8000-00805f9b34fb',
    supportedPowerRange: '00002ad8-0000-1000-8000-00805f9b34fb',
    fitnessMachineStatus: '00002ada-0000-1000-8000-00805f9b34fb',
    // Cycling Power
    cyclingPowerMeasurement: '00002a63-0000-1000-8000-00805f9b34fb',
    cyclingPowerFeature: '00002a65-0000-1000-8000-00805f9b34fb',
    cyclingPowerControlPoint: '00002a66-0000-1000-8000-00805f9b34fb',
    wahooTrainer: 'a026e005-0a7d-4ab3-97fa-f1500f9feb8b',
    // Heart Rate
    heartRateMeasurement: '00002a37-0000-1000-8000-00805f9b34fb',
    // Cycling Speed and Cadence
    speedCadenceMeasurement: '00002a5b-0000-1000-8000-00805f9b34fb',
    speedCadenceFeature: '00002a5c-0000-1000-8000-00805f9b34fb',
    speedCadenceControlPoint: '00002a55-0000-1000-8000-00805f9b34fb',
    // Battery
    batteryLevel: '00002a19-0000-1000-8000-00805f9b34fb',
    batteryLevelStatus: '00002bed-0000-1000-8000-00805f9b34fb',
    // Device Information
    manufacturerNameString: '00002a29-0000-1000-8000-00805f9b34fb',
    modelNumberString: '00002a24-0000-1000-8000-00805f9b34fb',
    firmwareRevisionString: '00002a26-0000-1000-8000-00805f9b34fb',
    // FEC over BLE
    fec2: '6e40fec2-b5a3-f393-e0a9-e50e24dcca9e',
    fec3: '6e40fec3-b5a3-f393-e0a9-e50e24dcca9e',
    // Wahoo Fitness Machine
    wahooFitnessMachineControlPoint: 'a026e037-0a7d-4ab3-97fa-f1500f9feb8b',
    // Race Controller (Zwift)
    raceControllerMeasurement: '00000002-19ca-4651-86e5-fa29dcdd09d1',
    raceControllerControlPoint: '00000003-19ca-4651-86e5-fa29dcdd09d1',
    raceControllerResponse: '00000004-19ca-4651-86e5-fa29dcdd09d1',
    // SmO2 Moxy
    smo2SensorData: '6404d804-4cb9-11e8-b566-0800200c9a66',
    smo2DeviceControl: '6404d810-4cb9-11e8-b566-0800200c9a66',
    smo2ControlPoint: '6404d811-4cd9-11e8-b566-0800200c9a66',
    // CoreTemp
    coreBodyTemp: '00002101-5b1e-4347-b07c-97b514dae121',
    corePrivate: '00004200-f366-40b2-ac37-70cce0aa83b1',
    // others
    sensorLocation: '00002a5d-0000-1000-8000-00805f9b34fb',
    clientCharacteristicConfiguration: '00002902-0000-1000-8000-00805f9b34fb'
};
const $5f192bdbcf8caac3$export$8bc6870d73ba12c7 = {
    ...$5f192bdbcf8caac3$var$services,
    ...$5f192bdbcf8caac3$var$characteristics
};
function $5f192bdbcf8caac3$var$Filters() {
    function controllable() {
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.fitnessMachine
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.fec
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.wahooFitnessMachine
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.cyclingPower
                    ]
                }
            ],
            optionalServices: [
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.heartRate
            ]
        };
    }
    function powerMeter() {
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.cyclingPower
                    ]
                }
            ],
            optionalServices: [
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.battery
            ]
        };
    }
    function speedCadenceSensor() {
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.speedCadence
                    ]
                }
            ],
            optionalServices: [
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.speedCadence,
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.battery
            ]
        };
    }
    function heartRateMonitor() {
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.heartRate
                    ]
                }
            ],
            optionalServices: [
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.speedCadence,
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.battery
            ]
        };
    }
    function smo2() {
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.smo2
                    ]
                }
            ],
            optionalServices: [
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.battery
            ]
        };
    }
    function coreTemp() {
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.coreTemp
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.corePrivate
                    ]
                }
            ],
            optionalServices: [
                $5f192bdbcf8caac3$export$8bc6870d73ba12c7.battery
            ]
        };
    }
    function all() {
        return {
            acceptAllDevices: true
        };
    }
    async function generic(args = {}) {
        const devices = await navigator.bluetooth.getDevices();
        let exclusionFilters = devices.reduce((acc, device)=>{
            if (device?.gatt?.connected ?? false) acc.push({
                name: device?.name ?? 'unknown'
            });
            return acc;
        }, []);
        // NOTE: guard against empty exclusion filter, they cause an error
        exclusionFilters = (0, $c6a9e46ee7e4d896$export$6e22c362a0406a2c)(exclusionFilters) ? undefined : exclusionFilters;
        return {
            filters: [
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.fitnessMachine
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.fec
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.wahooFitnessMachine
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.cyclingPower
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.speedCadence
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.raceController
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.smo2
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.heartRate
                    ]
                },
                {
                    services: [
                        $5f192bdbcf8caac3$export$8bc6870d73ba12c7.coreTemp
                    ]
                }
            ],
            exclusionFilters: exclusionFilters
        };
    }
    return Object.freeze({
        controllable: controllable,
        speedCadenceSensor: speedCadenceSensor,
        heartRateMonitor: heartRateMonitor,
        powerMeter: powerMeter,
        smo2: smo2,
        coreTemp: coreTemp,
        all: all,
        generic: generic
    });
}
function $5f192bdbcf8caac3$var$WebBLE() {
    const filters = $5f192bdbcf8caac3$var$Filters();
    function isAvailable() {
        // TODO: comment when not working on the iOS connect functionality.
        // This allows the iOS connection to show up in Chrome not just Safari
        // if(dev) {
        //     console.warn(`BLE Bridge mode ACTIVE!`);
        //     console.warn(`app will use BLE Bridge connection ONLY!`);
        //     return false;
        // }
        // END comment
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(navigator)) return 'bluetooth' in navigator;
        return false;
    }
    function uuidToName(uuid) {
        return Object.entries($5f192bdbcf8caac3$export$8bc6870d73ba12c7).find((kv)=>kv[1] === uuid)[0];
    }
    return Object.freeze({
        filters: filters,
        isAvailable: isAvailable,
        uuidToName: uuidToName
    });
}
const $5f192bdbcf8caac3$export$961dfcffa9c52590 = $5f192bdbcf8caac3$var$WebBLE();


function $b826f871ddcf7129$export$4149f73a79c1cb74(args = {}) {
    //
    // config
    //
    // BluetoothRemoteGATTCharacteristic
    const _characteristic = args.characteristic;
    // Uuid
    const uuid = _characteristic.uuid;
    // String
    const name = args.name ?? (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).uuidToName(_characteristic.uuid);
    // Function
    // some browsers don't have writeValueWithResponse,
    // but writeValue is depricated, so try the first or fallback to last.
    const writterFn = (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(_characteristic.writeValueWithResponse) ? 'writeValueWithResponse' : 'writeValue';
    // Int, ms
    const responseTimeout = args.responseTimeout ?? 1000;
    // end  config
    //
    // state
    //
    // private state
    // Int
    let _responseTimeoutId;
    // Bool
    let _ready = true;
    let abortController;
    let signal;
    // end private state
    // end state
    // accesor methods
    function isReady() {
        return _ready;
    }
    // end accesor methods
    //
    // methods
    //
    // Function -> Bool;
    async function startNotifications(handler) {
        try {
            abortController = new AbortController();
            signal = {
                signal: abortController.signal
            };
            await _characteristic.startNotifications();
            _characteristic.addEventListener('characteristicvaluechanged', (e)=>handler(e.target.value), signal);
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: notifications: started: on: ${name} ${uuid}.`);
            return true;
        } catch (e) {
            console.error(`notifications: failed: starting: on: name: ${name} uuid: ${uuid}`, e);
            return false;
        }
    }
    // Function, Int, Int -> Bool;
    async function startNotificationsWithRetry(handler, attempts = 10, txRate = 250) {
        const success = await startNotifications(handler);
        if (success) return true;
        else if (attempts > 0) {
            await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: startNotificationsWithRetry: fail: 'trying again'`);
            return await startNotificationsWithRetry(handler, attempts - 1);
        } else {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: startNotificationsWithRetry: fail: 'give up'`);
            return false;
        }
    }
    // Function -> Bool;
    async function stopNotifications(handler) {
        try {
            await _characteristic.stopNotifications();
            abortController.abort();
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`notifications: stopped: on: ${name} ${uuid}.`);
            return true;
        } catch (e) {
            console.error(`notifications: failed: stopping: on: name: ${name} uuid: ${uuid}`, e);
            return false;
        }
    }
    // {} -> Any
    async function read(args = {}) {
        const fallback = args.fallback;
        try {
            const value = await _characteristic.readValue();
            return value;
        } catch (e) {
            console.error(`rx: characteristic: :failed :read on: ${name} uuid: ${uuid}`, e);
            return fallback;
        }
    }
    // DataView -> Bool
    async function write(value) {
        let res;
        try {
            res = await _characteristic[writterFn](value);
            return true;
        } catch (e) {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).warn(`tx: characteristic: failed: write: on: ${name} uuid: ${uuid} value: [${(0, $c6a9e46ee7e4d896$export$9d73071cd264bdb)(value)}]`, e);
            return false;
        }
    }
    // Any, Int, Int -> Bool
    async function writeWithRetry(value, attempts = 10, txRate = 250) {
        let success = await write(value);
        if (success) {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: characteristic: writeWithRetry: success:`);
            return true;
        } else if (attempts > 0) {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: characteristic: writeWithRetry: fail: continue:`);
            await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
            return await writeWithRetry(value, attempts - 1);
        } else {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: characteristic: writeWithRetry: fail: break:`);
            return false;
        }
    }
    // Void -> Void
    function block() {
        _responseTimeoutId = setTimeout(release, responseTimeout);
        _ready = false;
    }
    // Void -> Void
    function release() {
        clearTimeout(_responseTimeoutId);
        _ready = true;
    }
    // end methods
    return Object.freeze({
        startNotifications: startNotifications,
        startNotificationsWithRetry: startNotificationsWithRetry,
        stopNotifications: stopNotifications,
        read: read,
        write: write,
        writeWithRetry: writeWithRetry,
        isReady: isReady,
        block: block,
        release: release
    });
}





// TODO:
// - add support for mapping write methods to parsers in the service spec object,
//   like 'write' for the WRITE property of a characteristic
// - in the start() methods handle startNotificationWithRetry fail if something fails
//   we need to disconnect the device
// Usage:
//
// function onData(msg) {
// // do something with the decoded data message
// }
//
// function onControl(msg) {
// // do something with the decoded response message
// }
//
// const spec = {
//     measurement: {
//         uuid: uuids.indoorBikeData,
//         notify: {callback: onData, parser: indoorBikeDataParser},
//     },
//     control: {
//         uuid: uuids.fitnessMachineControlPoint,
//         notify: {callback: onControl, parser: controlResponseParser},
//     },
// };
//
// const service = Service({service: BluetoothRemoteGATTService, spec,});
// await service.setup();
//
// service.characteristcics?.control.write(Dataview);
//
function $97c3323ad61e1e5e$export$8b2af884909d32a5(args = {}) {
    // config
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const _service = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'Service needs BluetoothRemoteGATTService!');
    // String
    const _name = args.name ?? (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).uuidToName(_service.uuid);
    // spec, is the declarative specification of the characteristics under this service
    //
    // the structure of a spec object is the following:
    // {
    //     <characteristic-class>?: {
    //         uuid: UUID,
    //         <characteristic-property>: {callback: Function, parser: Parser},
    //     },
    // }
    // where:
    // <characteristic-class> is one of:
    // - 'measurement' for the data transmitting characteristic as in Cycling Power
    // measurement, Heart Rate measurement, etc.
    // - 'control' for the control point characteristic if one exists
    // - 'response' for a response characteristic if one exists
    // - 'status' for a status characteristic if one exists
    //
    // <characteristic-property> is one of:
    // - 'notify' for the NOTIFY property of a characteristic
    //
    // - callback is the function that will return the message decoded
    // - parser is an object with decode or encode method that can handle the
    // parsing of the dataview received from a characteristic,
    // note that the parsed message will be availble in the configured callback
    //
    // Example with FTMS:
    // const spec = {
    //     measurement: {
    //         uuid: uuids.indoorBikeData,
    //         notify: {callback: onData, parser: indoorBikeDataParser},
    //     },
    //     control: {
    //         uuid: uuids.fitnessMachineControlPoint,
    //         notify: {callback: onControl, parser: controlResponseParser},
    //     },
    //     status: {
    //         uuid: uuids.fitnessMachineStatus,
    //         notify: {callback: onStatus, parser: statusParser},
    //     },
    // };
    //
    const spec = args.spec ?? {};
    // protocol is the configurable function where the specific steps for each
    // characteristcs initialization will be executed. For example FTMS needs
    // to receive unlock message before it will start transmitting and responding
    // this is the place to add service specific init code.
    //
    // Void -> Bool
    const protocol = args.protocol ?? defaultProtocol;
    async function defaultProtocol() {
        return true;
    }
    function defaultCallback(msg) {
        console.log(`ble: ${getName()} on-data: `, msg);
    }
    // if a parser is not configured in the spec object the default one will used
    // decode(), method will decode the received messages to:
    // {raw: [Int]}, where the raw contains the the raw message, this is useful for
    // debuging and when developing a new device
    // encode(), method will log back the device name and data, but it won't write
    // to the characteristic
    const defaultParser = {
        decode: (dataview)=>{
            const msg = {
                raw: (0, $c6a9e46ee7e4d896$export$d59ba87ce515b3fd)(dataview)
            };
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`rx: ${getName()} msg: `, msg);
            return msg;
        },
        encode: (data = {})=>{
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: ${getName()} msg: `, data);
        }
    };
    // end config
    //
    // state
    //
    // public state
    // {'<characteristic-name>': Characteristic}
    let characteristics = {};
    // end public state
    // private state
    // [BluetoothRemoteGATTCharacteristic {
    //     service: BluetoothRemoteGATTService,
    //     uuid: String,
    //     properties: BluetoothCharacteristicProperties,
    //     oncharacteristicvaluechanged: null,
    //     value: null,
    // ]
    let _gattCharacteristics;
    // {'<characteristic-uuid>': BluetoothRemoteGATTCharacteristic}
    let _characteristics;
    // Bool
    let _started = false;
    // end private state
    // end state
    // accessors
    // Void -> String
    function getName() {
        return _name;
    }
    // Void -> String
    function isStarted() {
        return _started;
    }
    // end accessors
    async function getCharacteristics() {
        _gattCharacteristics = await _service.getCharacteristics();
        _characteristics = $97c3323ad61e1e5e$export$19cb70ee18e2ac77(_gattCharacteristics);
    }
    // start notifications on the configured characteristics
    //
    // Void -> Bool
    async function start() {
        for(const key in spec){
            characteristics[key] = (0, $b826f871ddcf7129$export$4149f73a79c1cb74)({
                characteristic: _characteristics[spec[key].uuid]
            });
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(spec[key].notify)) await characteristics[key].startNotificationsWithRetry((0, $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30)(spec[key].notify?.callback ?? defaultCallback, spec[key].notify?.parser?.decode ?? defaultParser));
        }
        _started = true;
        return true;
    }
    // stop notifications on the configured characteristics
    //
    // Void -> Bool
    async function stop() {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:ble :tx :service ${_name} :stoping`);
        for(const key in spec)await characteristics[key]?.stopNotifications();
        _started = false;
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:ble :tx :service ${_name} :stoped`);
    }
    // execute all steps needed to init the service
    // - get characteristics
    // - start notifications
    // - do any service specific work in the protocol method
    //
    // Void -> Bool
    async function setup() {
        try {
            let resChars = await getCharacteristics();
            let resStart = await start();
            let resProtocol = await protocol();
            return resStart && resProtocol;
        } catch (e) {
            console.warn(`ble: error: service: setup: `, e);
            return false;
        }
    }
    return {
        start: start,
        stop: stop,
        isStarted: isStarted,
        getCharacteristics: getCharacteristics,
        setup: setup,
        characteristics: characteristics
    };
}
// think of the following as static methods
// BluetoothRemoteGATTService -> String
function $97c3323ad61e1e5e$export$c9f5068253e7a355(service) {
    for(let name in 0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7){
        if ((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7)[name] === service.uuid) return `uuid: ${service.uuid} primary-service: ${name} `;
    }
    return `uuid: ${service.uuid} primary-service: unknown`;
}
// [BluetoothRemoteGATTService] -> {'<service-uuid>': BluetoothRemoteGATTService}
function $97c3323ad61e1e5e$export$19cb70ee18e2ac77(xs) {
    return xs.reduce((acc, x)=>{
        acc[x.uuid] = x;
        return acc;
    }, {});
}


//
// Fitness Machine Service
//





//
// FTMS spec
// 4.9 Indoor Bike Data (characteristic)
//

const $1f189511ae166bac$var$speedPresent = (flags)=>(flags >> 0 & 1) === 0;
const $1f189511ae166bac$var$avgSpeedPresent = (flags)=>(flags >> 1 & 1) === 1;
const $1f189511ae166bac$var$cadencePresent = (flags)=>(flags >> 2 & 1) === 1;
const $1f189511ae166bac$var$avgCadencePresent = (flags)=>(flags >> 3 & 1) === 1;
const $1f189511ae166bac$var$distancePresent = (flags)=>(flags >> 4 & 1) === 1;
const $1f189511ae166bac$var$resistancePresent = (flags)=>(flags >> 5 & 1) === 1;
const $1f189511ae166bac$var$powerPresent = (flags)=>(flags >> 6 & 1) === 1;
const $1f189511ae166bac$var$avgPowerPresent = (flags)=>(flags >> 7 & 1) === 1;
const $1f189511ae166bac$var$expandedEnergyPresent = (flags)=>(flags >> 8 & 1) === 1;
const $1f189511ae166bac$var$heartRatePresent = (flags)=>(flags >> 9 & 1) === 1;
const $1f189511ae166bac$var$metabolicEquivalentPresent = (flags)=>(flags >> 10 & 1) === 1;
const $1f189511ae166bac$var$elapsedTimePresent = (flags)=>(flags >> 11 & 1) === 1;
const $1f189511ae166bac$var$remainingTimePresent = (flags)=>(flags >> 12 & 1) === 1;
const $1f189511ae166bac$var$fields = {
    Flags: {
        resolution: 1,
        unit: 'bit',
        size: 2,
        type: 'Uint16',
        present: (_)=>true
    },
    InstantaneousSpeed: {
        resolution: 0.01,
        unit: 'kph',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$speedPresent,
        short: 'speed'
    },
    AverageSpeed: {
        resolution: 0.01,
        unit: 'kph',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$avgSpeedPresent
    },
    InstantaneousCadence: {
        resolution: 0.5,
        unit: 'rpm',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$cadencePresent,
        short: 'cadence'
    },
    AverageCadence: {
        resolution: 0.5,
        unit: 'rpm',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$avgCadencePresent
    },
    TotalDistance: {
        resolution: 1,
        unit: 'm',
        size: 3,
        type: 'Uint24',
        present: $1f189511ae166bac$var$distancePresent,
        short: 'distance'
    },
    ResistanceLevel: {
        resolution: 1,
        unit: 'unitless',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$resistancePresent
    },
    InstantaneousPower: {
        resolution: 1,
        unit: 'W',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$powerPresent,
        short: 'power'
    },
    AveragePower: {
        resolution: 1,
        unit: 'W',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$avgPowerPresent
    },
    TotalEnergy: {
        resolution: 1,
        unit: 'kcal',
        size: 2,
        type: 'Int16',
        present: $1f189511ae166bac$var$expandedEnergyPresent
    },
    EnergyPerHour: {
        resolution: 1,
        unit: 'kcal',
        size: 2,
        type: 'Int16',
        present: $1f189511ae166bac$var$expandedEnergyPresent
    },
    EnergyPerMinute: {
        resolution: 1,
        unit: 'kcal',
        size: 1,
        type: 'Uint8',
        present: $1f189511ae166bac$var$expandedEnergyPresent
    },
    HeartRate: {
        resolution: 1,
        unit: 'bpm',
        size: 1,
        type: 'Uint8',
        present: $1f189511ae166bac$var$heartRatePresent,
        short: 'heartRate'
    },
    MetabolicEquivalent: {
        resolution: 1,
        unit: 'me',
        size: 1,
        type: 'Uint8',
        present: $1f189511ae166bac$var$metabolicEquivalentPresent
    },
    ElapsedTime: {
        resolution: 1,
        unit: 's',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$elapsedTimePresent
    },
    RemainingTime: {
        resolution: 1,
        unit: 's',
        size: 2,
        type: 'Uint16',
        present: $1f189511ae166bac$var$remainingTimePresent
    }
};
const $1f189511ae166bac$var$order = [
    'Flags',
    'InstantaneousSpeed',
    'AverageSpeed',
    'InstantaneousCadence',
    'AverageCadence',
    'TotalDistance',
    'ResistanceLevel',
    'InstantaneousPower',
    'AveragePower',
    'TotalEnergy',
    'EnergyPerHour',
    'EnergyPerMinute',
    'HeartRate',
    'MetabolicEquivalent',
    'ElapsedTime',
    'RemainingTime'
];
function $1f189511ae166bac$export$2614e5c605d6b0af(args = {}) {
    const architecture = true;
    function getField(field, dataview, i) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(field.type, 'Uint24')) return (0, $c6a9e46ee7e4d896$export$ac13700e638c384c)(dataview, i) * field.resolution;
        return dataview[`get${field.type}`](i, architecture) * field.resolution;
    }
    // Dataview -> {'<field-name>': {value: Number, unit: String}}
    function decode(dataview) {
        const byteLength = dataview.byteLength;
        return $1f189511ae166bac$var$order.reduce(function(acc, fieldName) {
            const field = $1f189511ae166bac$var$fields[fieldName];
            if (acc.i + field.size > byteLength) return acc;
            if (field.present(acc.flags)) {
                const value = getField(field, dataview, acc.i);
                const unit = field?.unit ?? '';
                const name = field?.short ?? fieldName;
                if (acc.i === 0) acc.flags = value;
                else // acc.data[name] = {value, unit,};
                acc.data[name] = value;
                acc.i += field.size;
            }
            return acc;
        }, {
            i: 0,
            flags: 0,
            data: {}
        }).data;
    }
    return Object.freeze({
        getField: getField,
        decode: decode
    });
}
const $1f189511ae166bac$export$2a828fbb75260fe3 = $1f189511ae166bac$export$2614e5c605d6b0af();


//
// FTMS spec
// 4.16 Fitness Machine Control Point (characteristic)
//

function $430ffefc9ad9acb9$var$SimulationParameters(args) {
    const opCode = 0x11;
    const length = 7;
    // 2 m/s -> 7.20 km/h, 4 -> 14.4, 6 -> 21.6, 8 -> 28.8, 10 -> 36
    const definitions = {
        windSpeed: {
            resolution: 0.001,
            unit: 'mps',
            size: 2,
            min: -35.56,
            max: 35.56,
            default: 0.1
        },
        // 2,
        grade: {
            resolution: 0.01,
            unit: '%',
            size: 2,
            min: -40,
            max: 40,
            default: 0
        },
        crr: {
            resolution: 0.0001,
            unit: '',
            size: 1,
            min: 0,
            max: 0.0254,
            default: 0.004
        },
        windResistance: {
            resolution: 0.01,
            unit: 'kg/m',
            size: 1,
            min: 0,
            max: 1.86,
            default: 0.51
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        const windSpeed = spec.encodeField('windSpeed', args.windSpeed);
        const grade = spec.encodeField('grade', args.grade);
        const crr = spec.encodeField('crr', args.crr);
        const windResistance = spec.encodeField('windResistance', args.windResistance);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setInt16(1, windSpeed, true);
        view.setInt16(3, grade, true);
        view.setUint8(5, crr, true);
        view.setUint8(6, windResistance, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: ftms: simulation: grade: ${grade}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0);
        const windSpeed = spec.decodeField('windSpeed', dataview.getUint16(1, true));
        const grade = spec.decodeField('grade', dataview.getInt16(3, true));
        const crr = spec.decodeField('crr', dataview.getInt8(5, true));
        const windResistance = spec.decodeField('windResistance', dataview.getUint8(6, true));
        return {
            windSpeed: windSpeed,
            grade: grade,
            crr: crr,
            windResistance: windResistance
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $430ffefc9ad9acb9$var$ResistanceTarget() {
    const opCode = 0x04;
    const length = 3; // 3
    const definitions = {
        resistance: {
            resolution: 0.1,
            unit: '',
            size: 2,
            min: -100,
            max: 100,
            default: 0
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        const resistance = spec.encodeField('resistance', args.resistance);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setInt16(1, resistance, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:tx :ftms :resistance ${args.resistance} -> ${resistance}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0);
        const resistance = spec.decodeField('resistance', dataview.getInt16(1, true));
        return {
            resistance: resistance
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $430ffefc9ad9acb9$var$PowerTarget() {
    const opCode = 0x05;
    const length = 3;
    const definitions = {
        power: {
            resolution: 1,
            unit: 'W',
            size: 2,
            min: 0,
            max: 65534,
            default: 0
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    // {power: Int} -> ArrayBuffer
    function encode(args = {}) {
        const power = spec.encodeField('power', args.power);
        const view = new DataView(new ArrayBuffer(length));
        view.setUint8(0, opCode, true);
        view.setUint16(1, power, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: ftms: powerTarget: ${power}`);
        return view.buffer;
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode
    });
}
function $430ffefc9ad9acb9$var$WheelCircumference(args) {
    const opCode = 0x12;
    const length = 3;
    const definitions = {
        circumference: {
            resolution: 0.1,
            unit: 'mm',
            min: 0,
            max: 6553.4,
            default: 2105
        }
    };
    const values = {
        2080: '700x19C',
        2086: '700x20C',
        2096: '700x23C',
        2105: '700x25C',
        2136: '700x28C',
        // 20s
        2146: '700x30C',
        2155: '700x32C',
        2168: '700x35C',
        2180: '700x38C',
        // 30s
        2200: '700x40C',
        2242: '700x45C',
        2268: '700x47C',
        // 40s
        2281: `29"x2.25"`,
        2326: `29"x2.3"`,
        2750: 'tractor' // MTBs
    };
    // 700x25C -> 2105 -> [0x12, 0x3A, 0x52] -> [18, 58, 82]
    // 700x40C -> 2200 -> [0x12, 0xF0, 0x55] -> [18, 240, 85]
    // 700x47C -> 2268 -> [0x12, 0x98, 0x58] -> [18, 152, 88]
    // Max     -> 2750 -> [0x12, 0x6C, 0x6B] -> [18, 108, 107]
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        const circumference = spec.encodeField('circumference', args.circumference);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint16(1, circumference, true);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0);
        const circumference = spec.decodeField('circumference', dataview.getUint16(1, true));
        return {
            circumference: circumference
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        values: values,
        encode: encode,
        decode: decode
    });
}
function $430ffefc9ad9acb9$var$RequestControl() {
    const opCode = 0x00;
    const length = 1;
    function encode() {
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`rx: ftms: request-control:`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0);
        return {
            opCode: opCode
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        encode: encode,
        decode: decode
    });
}
function $430ffefc9ad9acb9$var$Reset() {
    const opCode = 0x01;
    const length = 1;
    function encode() {
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`rx: ftms: reset:`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0);
        return {
            opCode: opCode
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        encode: encode,
        decode: decode
    });
}
function $430ffefc9ad9acb9$var$Response() {
    const opCode = 0x80;
    // Format:
    // response code - request code - result code
    // 128-0-1
    // 128-5-3
    // 128-5-1
    //
    // 128 (0x80) | request control  | success
    // 128 (0x80) | set target power | invalid parameter
    // 128 (0x80) | set target power | success
    const results = {
        '0x01': {
            definition: 'success',
            msg: 'success'
        },
        '0x02': {
            definition: 'notSupported',
            msg: 'not supported'
        },
        '0x03': {
            definition: 'invalidParameter',
            msg: 'invalid parameter'
        },
        '0x04': {
            definition: 'operationFail',
            msg: 'operation fail'
        },
        '0x05': {
            definition: 'notPermitted',
            msg: 'not permitted'
        },
        '0xFF': {
            definition: 'unknownError',
            msg: 'unknown error'
        }
    };
    const requests = {
        '0x00': {
            definition: 'requestControl',
            msg: 'request control'
        },
        '0x01': {
            definition: 'reset',
            msg: 'reset'
        },
        '0x04': {
            definition: 'setTargetResistanceLevel',
            msg: 'set target resistance'
        },
        '0x05': {
            definition: 'setTargetPower',
            msg: 'set target power'
        },
        '0x11': {
            definition: 'setIndoorBikeSimulationParameters',
            msg: 'set indoor bike simulation'
        },
        '0x13': {
            definition: 'spinDownControl',
            msg: 'Spin Down Control'
        },
        '0xFF': {
            definition: 'unknown',
            msg: 'unknown request'
        }
    };
    function encode(value) {
        throw 'Not implemented!';
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true) ?? opCode;
        const requestCode = dataview.getUint8(1, true) ?? 0xFF;
        const resultCode = dataview.getUint8(2, true) ?? 0xFF;
        // const raw = dataviewToArray(dataview).slice(dataview.byteOffset);
        const request = requests[(0, $c6a9e46ee7e4d896$export$834dfc94dde4b3d8)(requestCode)]?.definition ?? '';
        const result = results[(0, $c6a9e46ee7e4d896$export$834dfc94dde4b3d8)(resultCode)]?.msg ?? '';
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`rx: ftms: status: ${result} request: ${request}`);
        return {
            opCode: opCode,
            requestCode: requestCode,
            resultCode: resultCode
        };
    }
    return Object.freeze({
        opCode: opCode,
        results: results,
        requests: requests,
        encode: encode,
        decode: decode
    });
}
const $430ffefc9ad9acb9$export$b5cde1de278b4330 = {
    simulationParameters: $430ffefc9ad9acb9$var$SimulationParameters(),
    resistanceTarget: $430ffefc9ad9acb9$var$ResistanceTarget(),
    powerTarget: $430ffefc9ad9acb9$var$PowerTarget(),
    wheelCircumference: $430ffefc9ad9acb9$var$WheelCircumference(),
    requestControl: $430ffefc9ad9acb9$var$RequestControl(),
    reset: $430ffefc9ad9acb9$var$Reset(),
    response: $430ffefc9ad9acb9$var$Response()
};


function $ee8aec6b20c39b4f$var$FTMS(args = {}) {
    // config
    const onData = args.onData;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'FTMS needs BluetoothRemoteGATTService!');
    // end config
    // Service
    function onControlResponse(msg) {
        const control = service.characteristics.control;
        // it's important to release the control characteristic for writes
        // but that can happen only when a response has been received from
        // the control point characteristic
        control.release();
    }
    async function protocol() {
        const control = service.characteristics.control;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control)) {
            const res = await control.write((0, $430ffefc9ad9acb9$export$b5cde1de278b4330).requestControl.encode());
            return res;
        }
        return false;
    }
    async function reset() {
        const control = service.characteristics.control;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control)) {
            let res = await control.write((0, $430ffefc9ad9acb9$export$b5cde1de278b4330).reset.encode());
            await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(1000);
            return res;
        }
        return false;
    }
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).indoorBikeData,
            notify: {
                callback: onData,
                parser: (0, $1f189511ae166bac$export$2a828fbb75260fe3)
            }
        },
        control: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fitnessMachineControlPoint,
            notify: {
                callback: onControlResponse,
                parser: (0, $430ffefc9ad9acb9$export$b5cde1de278b4330).response
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        service: gattService,
        spec: spec,
        protocol: protocol
    });
    // end sevice
    // methods
    // this service has special write methods
    // {WindSpeed: Float, Grade: Float, Crr: Float, WindResistance: Float} -> Bool
    async function setSimulation(args = {}) {
        const control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control) || !control.isReady()) return false;
        control.block();
        const res = await control.write((0, $430ffefc9ad9acb9$export$b5cde1de278b4330).simulationParameters.encode(args));
        return res;
    }
    // {power: Int} -> Bool
    async function setPowerTarget(args = {}) {
        const control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control)) return false;
        const res = await control.writeWithRetry((0, $430ffefc9ad9acb9$export$b5cde1de278b4330).powerTarget.encode(args), 4, 500);
        return res;
    }
    // {power: Int} -> Bool
    async function setResistanceTarget(args = {}) {
        const control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control)) return false;
        const res = await control.writeWithRetry((0, $430ffefc9ad9acb9$export$b5cde1de278b4330).resistanceTarget.encode(args), 4, 500);
        return res;
    }
    // end methods
    // expose public methods and properties
    return Object.freeze({
        ...service,
        protocol: // FTMS will have all the public methods and properties of Service
        protocol,
        reset: reset,
        setSimulation: setSimulation,
        setPowerTarget: setPowerTarget,
        setResistanceTarget: setResistanceTarget
    });
}
var $ee8aec6b20c39b4f$export$2e2bcd8739ae039 = $ee8aec6b20c39b4f$var$FTMS;


//
// FEC over BLE
//






//
// FEC3 Custom characteristic
//

function $fec1f62a7632aede$var$applyDefinition(field, value) {
    const _value = value ?? field.default;
    const _resolution = field.resolution ?? 1;
    const _offset = field.offset ?? 0;
    return _value / _resolution + _offset / _resolution;
}
function $fec1f62a7632aede$var$removeDefinition(field, value) {
    const _value = value ?? field.default;
    const _resolution = field.resolution ?? 1;
    const _offset = field.offset ?? 0;
    return (_value - _offset * _resolution) * _resolution;
}
function $fec1f62a7632aede$var$DataPage48() {
    // Data Page 48 (0x30) – Basic Resistance
    const number = 48;
    const length = 8;
    const architecture = true;
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 48
        },
        resistance: {
            size: 1,
            type: 'Uint8',
            default: 0,
            resolution: 0.5,
            unit: ''
        }
    };
    function encode(dataview, start = 4, payload = {}) {
        const resistance = $fec1f62a7632aede$var$applyDefinition(fields.resistance, payload?.resistance);
        dataview.setUint8(start + 0, number, architecture);
        dataview.setUint8(start + 7, resistance, architecture);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:tx :fec :basic-resistance ${payload?.resistance} ${resistance}`);
        return dataview;
    }
    return Object.freeze({
        number: number,
        length: length,
        fields: fields,
        encode: encode
    });
}
function $fec1f62a7632aede$var$DataPage50() {
    // DataPage 50 (0x32) - Wind Resistance
    const number = 50;
    const length = 8;
    const architecture = true;
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 50
        },
        reserved1: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved2: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved3: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved4: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        windResistance: {
            size: 1,
            type: 'Uint8',
            default: 0.51,
            resolution: 0.01
        },
        windSpeed: {
            size: 1,
            type: 'Uint8',
            default: 0,
            resolution: 1,
            offset: 127
        },
        draftingFactor: {
            size: 1,
            type: 'Uint8',
            default: 1.0,
            resolution: 0.01
        }
    };
    function encode(dataview, start = 4, payload = {}) {
        const dataPage = fields.dataPage.default;
        const windResistance = $fec1f62a7632aede$var$applyDefinition(fields.windResistance, payload?.windResistance);
        const windSpeed = $fec1f62a7632aede$var$applyDefinition(fields.windSpeed, payload?.windSpeed);
        const draftingFactor = $fec1f62a7632aede$var$applyDefinition(fields.draftingFactor, payload?.draftingFactor);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:tx :fec :wind-resistance :windResistance ${windResistance} windSpeed: ${windSpeed} :draftingFactor ${draftingFactor}`);
        dataview.setUint8(start + 0, dataPage, architecture);
        dataview.setUint8(start + 5, windResistance, architecture);
        dataview.setUint8(start + 6, windSpeed, architecture);
        dataview.setUint8(start + 7, draftingFactor, architecture);
        return dataview;
    }
    return Object.freeze({
        number: number,
        encode: encode
    });
}
function $fec1f62a7632aede$var$DataPage51() {
    // DataPage 51 (0x33) - Track Resistance
    const number = 51;
    const length = 8;
    const architecture = true;
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 51
        },
        reserved1: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved2: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved3: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved4: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        grade: {
            size: 2,
            type: 'Uint16',
            default: 0,
            resolution: 0.01,
            offset: 200
        },
        crr: {
            size: 1,
            type: 'Uint8',
            default: 0.004,
            resolution: 0.00005
        }
    };
    function encode(dataview, start = 4, payload = {}) {
        const dataPage = fields.dataPage.default;
        const grade = $fec1f62a7632aede$var$applyDefinition(fields.grade, payload?.grade);
        const crr = $fec1f62a7632aede$var$applyDefinition(fields.crr, payload?.crr);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:tx :fec :track-resistance :grade ${payload?.grade} :crr ${crr}`);
        dataview.setUint8(start + 0, dataPage, architecture);
        dataview.setUint16(start + 5, grade, architecture);
        dataview.setUint8(start + 7, crr, architecture);
        return dataview;
    }
    return Object.freeze({
        number: number,
        fields: fields,
        encode: encode
    });
}
function $fec1f62a7632aede$var$DataPage49() {
    // Data Page 49 (0x31) – Target Power
    const number = 49;
    const length = 8;
    const architecture = true;
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 49
        },
        power: {
            size: 1,
            type: 'Uint8',
            resolution: 0.25,
            unit: 'W',
            min: 0,
            max: 4000,
            invalid: 0,
            default: 0
        }
    };
    function encode(dataview, start = 4, payload = {}) {
        const dataPage = fields.dataPage.default;
        const power = $fec1f62a7632aede$var$applyDefinition(fields.power, payload?.power);
        dataview.setUint8(start + 0, dataPage, architecture);
        dataview.setUint16(start + 6, power, architecture);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:tx :fec :target-power :power ${payload?.power}`);
        return dataview;
    }
    return Object.freeze({
        number: number,
        length: length,
        fields: fields,
        encode: encode
    });
}
function $fec1f62a7632aede$var$DataPage55() {
    // DataPage 55 (0x37) - User Configuration
    const number = 55;
    const length = 8;
    const architecture = true;
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 55
        },
        userWeight: {
            size: 2,
            type: 'Uint16',
            default: 75,
            resolution: 0.01
        },
        reserved: {
            size: 1,
            type: 'Reserved',
            default: 0
        },
        diameterOffset: {
            size: 0.5,
            type: 'Uint4',
            default: 0xF
        },
        bikeWeight: {
            size: 1.5,
            type: 'Uint12',
            default: 8,
            resolution: 0.05
        },
        wheelDiameter: {
            size: 1,
            type: 'Uint4',
            default: 0.7,
            resolution: 0.01
        },
        gearRatio: {
            size: 1,
            type: 'Uint8',
            default: 0,
            resolution: 0.03
        }
    };
    function encode(dataview, start = 4, payload = {}) {
        const dataPage = fields.dataPage.default;
        const userWeight = $fec1f62a7632aede$var$applyDefinition(fields.userWeight, payload?.userWeight);
        const diameterOffset = $fec1f62a7632aede$var$applyDefinition(fields.diameterOffset, payload?.diameterOffset);
        const bikeWeight = $fec1f62a7632aede$var$applyDefinition(fields.bikeWeight, payload?.bikeWeight);
        const wheelDiameter = $fec1f62a7632aede$var$applyDefinition(fields.wheelDiameter, payload?.wheelDiameter);
        const gearRatio = $fec1f62a7632aede$var$applyDefinition(fields.gearRatio, payload?.gearRatio);
        const combined1 = ((0, $c6a9e46ee7e4d896$export$afb88973713cb16a)(0, 4, bikeWeight) << 4) + diameterOffset;
        const bikeWeightMSB = bikeWeight >> 4;
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:tx :fec :user-configuration :userWeight ${userWeight} :bikeWeight ${bikeWeight}`);
        dataview.setUint8(start + 0, dataPage, architecture);
        dataview.setUint16(start + 1, userWeight, architecture);
        dataview.setUint8(start + 4, combined1, architecture);
        dataview.setUint8(start + 5, bikeWeightMSB, architecture);
        dataview.setUint8(start + 6, wheelDiameter, architecture);
        dataview.setUint8(start + 7, gearRatio, architecture);
        return dataview;
    }
    return Object.freeze({
        number: number,
        fields: fields,
        encode: encode
    });
}
function $fec1f62a7632aede$var$DataPage252() {
    const number = 252;
    const length = 8;
    const architecture = true;
    // [0xA4, 0x09, 0x4F, 0x05, 0xFC, 0x00, 0,0, ]
    const RoadSurface = {
        simulationOff: 0,
        concretePlates: 1,
        cattleGrid: 2,
        cobblestonesHard: 3,
        cobblestonesSoft: 4,
        brickRoad: 5,
        offRoad: 6,
        gravel: 7,
        ice: 8,
        woodenBoards: 9
    };
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 252
        },
        reserved1: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        isokineticMode: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        isokineticSpeed: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        reserved2: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        roadSurfaceValue: {
            size: 1,
            type: 'Uint8',
            default: RoadSurface.simulationOff
        },
        roadSurfaceIntensity: {
            size: 1,
            type: 'Uint8',
            default: 255
        },
        reserved3: {
            size: 1,
            type: 'Uint8',
            default: 0
        }
    };
    function encode(dataview, start = 4, payload = {}) {
        const roadSurfaceValue = $fec1f62a7632aede$var$applyDefinition(fields.roadSurfaceValue, payload?.roadSurfaceValue);
        const roadSurfaceIntensity = $fec1f62a7632aede$var$applyDefinition(fields.roadSurfaceIntensity, payload?.roadSurfaceIntensity);
        dataview.setUint8(start + 0, fields.dataPage.default, architecture);
        dataview.setUint8(start + 1, fields.reserved1.default, architecture);
        dataview.setUint8(start + 2, fields.isokineticMode.default, architecture);
        dataview.setUint8(start + 3, fields.isokineticSpeed.default, architecture);
        dataview.setUint8(start + 4, fields.reserved2.default, architecture);
        dataview.setUint8(start + 5, roadSurfaceValue, architecture);
        dataview.setUint8(start + 6, roadSurfaceIntensity, architecture);
        dataview.setUint8(start + 7, fields.reserved3.default, architecture);
        return dataview;
    }
    return Object.freeze({
        number: number,
        fields: fields,
        RoadSurface: RoadSurface,
        encode: encode
    });
}
function $fec1f62a7632aede$var$DataPage16() {
    // DataPage 16 (0x10) - General FE Data
    const number = 16;
    const length = 8;
    const architecture = true;
    // elapsedTime
    // distance
    // speed
    // heartRate
    function decode(dataview, start = 4, end = length) {
        return {
            speed: 0,
            heartRate: 0
        };
    }
    return Object.freeze({
        number: number,
        decode: decode
    });
}
function $fec1f62a7632aede$var$DataPage25() {
    // DataPage 25 (0x19) - Trainer Specific
    const number = 25;
    const length = 8;
    const architecture = true;
    const fields = {
        dataPage: {
            size: 1,
            type: 'Uint8',
            default: 25
        },
        eventCount: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        cadence: {
            size: 1,
            type: 'Uint8',
            default: 0
        },
        accumulatedPower: {
            size: 2,
            type: 'Uint16',
            default: 0
        },
        power: {
            size: 1.5,
            type: 'Uint12',
            default: 0
        },
        status: {
            size: 0.5,
            type: 'Uint4'
        }
    };
    function decode(dataview, start = 4, end = length) {
        const dataPage = dataview.getUint8(start + 0, architecture);
        const cadence = dataview.getUint8(start + 2, architecture) ?? 0;
        const combined1 = dataview.getUint16(start + 5, architecture);
        const power = (0, $c6a9e46ee7e4d896$export$afb88973713cb16a)(0, 12, combined1) ?? 0;
        return {
            dataPage: dataPage,
            cadence: cadence,
            power: power
        };
    }
    return Object.freeze({
        number: number,
        decode: decode
    });
}
function $fec1f62a7632aede$var$DataPage71() {
    // DataPage 71 (0x47) - Command Status
    const number = 71;
    const length = 8;
    const architecture = true;
    function decode(dataview, start = 4, end = length) {
        const dataPage = dataview.getUint8(start + 0, architecture);
        const lastCommandId = dataview.getUint8(start + 1, architecture);
        const sequenceNumber = dataview.getUint8(start + 2, architecture);
        const status = dataview.getUint8(start + 3, architecture);
        const data1 = dataview.getUint8(start + 4, architecture);
        const data2 = dataview.getUint8(start + 5, architecture);
        const data3 = dataview.getUint8(start + 6, architecture);
        const data4 = dataview.getUint8(start + 7, architecture);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:rx :fec :command-status ${status} sequence: ${sequenceNumber} :id ${lastCommandId}`);
        return {
            dataPage: dataPage,
            lastCommandId: lastCommandId,
            sequenceNumber: sequenceNumber,
            status: status,
            data1: data1,
            data2: data2,
            data3: data3,
            data4: data4
        };
    }
    return Object.freeze({
        number: number,
        decode: decode
    });
}
const $fec1f62a7632aede$var$messages = {
    // fec3
    dataPage48: $fec1f62a7632aede$var$DataPage48(),
    dataPage49: $fec1f62a7632aede$var$DataPage49(),
    dataPage50: $fec1f62a7632aede$var$DataPage50(),
    dataPage51: $fec1f62a7632aede$var$DataPage51(),
    dataPage55: $fec1f62a7632aede$var$DataPage55(),
    dataPage252: $fec1f62a7632aede$var$DataPage252(),
    // fec2
    dataPage16: $fec1f62a7632aede$var$DataPage16(),
    dataPage25: $fec1f62a7632aede$var$DataPage25(),
    dataPage71: $fec1f62a7632aede$var$DataPage71()
};
var $fec1f62a7632aede$export$2e2bcd8739ae039 = $fec1f62a7632aede$var$messages;


function $ceb0ab6d2e228045$export$e5b43ae2087442d3() {
    const sync = 164;
    const length = 13;
    const id = 79;
    const channel = 5;
    const architecture = true;
    const fields = {
        sync: {
            size: 1,
            type: 'Uint8',
            default: 164
        },
        length: {
            size: 1,
            type: 'Uint8',
            default: 9
        },
        id: {
            size: 1,
            type: 'Uint8',
            default: 79
        },
        channel: {
            size: 1,
            type: 'Uint8',
            default: 5
        },
        payload: {
            size: 8,
            type: 'DataPage'
        },
        check: {
            size: 1,
            type: 'Uint8'
        }
    };
    const order = [
        'sync',
        'length',
        'id',
        'channel',
        'payload',
        'check'
    ];
    function encode(args = {}) {
        const dataPage = args.dataPage;
        const payload = args.payload;
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, fields.sync.default, architecture);
        view.setUint8(1, fields.length.default, architecture);
        view.setUint8(2, id, architecture);
        view.setUint8(3, fields.channel.default, architecture);
        encodeDataPage(view, 4, dataPage, payload);
        const check = (0, $c6a9e46ee7e4d896$export$6444ef5cd411280c)(view, 0, length);
        view.setUint8(12, check, architecture);
        return view;
    }
    function encodeDataPage(dataview, i, dataPage, payload) {
        return (0, $fec1f62a7632aede$export$2e2bcd8739ae039)[`dataPage${dataPage}`]?.encode(dataview, i, payload);
    }
    function decode(dataview) {
        return order.reduce(function(acc, fieldName) {
            const field = fields[fieldName];
            if (field.type === 'DataPage') {
                const dataPage = getView('Uint8', acc.i, dataview);
                acc.data = decodeDataPage(dataview, dataPage);
                acc.data.dataPage = dataPage;
            }
            acc.i += field.size;
            return acc;
        }, {
            i: 0,
            data: {}
        }).data;
    }
    function getView(type, i, dataview) {
        return dataview[`get${type}`](i, architecture);
    }
    function decodeDataPage(dataview, dataPage) {
        return (0, $fec1f62a7632aede$export$2e2bcd8739ae039)[`dataPage${dataPage}`]?.decode(dataview, 4, 12) ?? {};
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $ceb0ab6d2e228045$var$hex(n) {
    let h = parseInt(n).toString(16).toUpperCase();
    if (h.length === 1) h = '0' + h;
    return '0x' + h;
}
const $ceb0ab6d2e228045$export$a8ecead220dd38a6 = $ceb0ab6d2e228045$export$e5b43ae2087442d3();




function $471e1f142048e38f$export$c257d9904737f20a(args = {}) {
    const defaults = {
        userWeight: 75,
        bikeWeight: 8
    };
    let _userWeight = args.userWeight ?? defaults.userWeight;
    let _bikeWeight = args.bikeWeight ?? defaults.bikeWeight;
    function userWeight() {
        return _userWeight;
    }
    function bikeWeight() {
        return _bikeWeight;
    }
    // x: Int
    // weight in grams 75000 -> 75 kg
    function setUserWeight(x) {
        if ((0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)(x)) _userWeight = x / 1000;
        else throw 'invalid userWeight';
    }
    // x: Int
    // weight in grams 8000 -> 8 kg
    function setBikeWeight(x) {
        if ((0, $c6a9e46ee7e4d896$export$7e4aa119212bc614)(x)) _bikeWeight = x / 1000;
        else throw 'invalid bikeWeight';
    }
    return {
        userWeight: userWeight,
        bikeWeight: bikeWeight,
        setUserWeight: setUserWeight
    };
}
const $471e1f142048e38f$export$c2507140e5bb8721 = $471e1f142048e38f$export$c257d9904737f20a();


function $920c8ecd383ec8b2$var$FEC(args = {}) {
    // config
    const onData = args.onData;
    const txRate = 1000;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'FEC needs BluetoothRemoteGATTService!');
    // end config
    //
    // service
    //
    // takes decoded msg from onData and returns it,
    // while releasing the block on write if the received message is a response message
    // that's needed because all messages are being received on the same characteristic
    //
    // ANTMessageData{} -> ANTMessageData{}
    function onFEC2(msg) {
        if (msg.dataPage === (0, $fec1f62a7632aede$export$2e2bcd8739ae039).dataPage71.number) {
            let control = service.characteristics.control;
            control.release();
        }
        return msg;
    }
    function onControlResponse(msg) {
        console.log(`ble: fec: on-control-response: `, msg);
        let control = service.characteristics.control;
        control.release();
    }
    async function protocol() {
        let control = service.characteristics.control;
        await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
        console.log(`${(0, $471e1f142048e38f$export$c2507140e5bb8721).userWeight()} ${(0, $471e1f142048e38f$export$c2507140e5bb8721).bikeWeight()}`);
        let resUserData = await setUserData({
            userWeight: (0, $471e1f142048e38f$export$c2507140e5bb8721).userWeight(),
            bikeWeight: (0, $471e1f142048e38f$export$c2507140e5bb8721).bikeWeight()
        });
        await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
        let resWind = await setWindResistance();
        return resUserData && resWind;
    }
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fec2,
            notify: {
                callback: (0, $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30)(onData, onFEC2),
                parser: (0, $ceb0ab6d2e228045$export$a8ecead220dd38a6)
            }
        },
        control: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fec3
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        protocol: protocol,
        service: gattService
    });
    // end service
    //
    // methods
    //
    // {power: Int} -> Bool
    async function setPowerTarget(args = {}) {
        let control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control)) return false;
        const res = await control.writeWithRetry((0, $ceb0ab6d2e228045$export$a8ecead220dd38a6).encode({
            dataPage: 49,
            payload: args
        }), 4, 500);
        return res;
    }
    // {resistance: Int} -> Bool
    async function setResistanceTarget(args = {}) {
        let control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control)) return false;
        let res = await control.write((0, $ceb0ab6d2e228045$export$a8ecead220dd38a6).encode({
            dataPage: 48,
            payload: args
        }));
        return res;
    }
    // {WindSpeed: Float, Grade: Float, Crr: Float, WindResistance: Float} -> Bool
    async function setSimulation(args = {}) {
        let control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control) || !control.isReady()) return false;
        control.block();
        let res = await control.write((0, $ceb0ab6d2e228045$export$a8ecead220dd38a6).encode({
            dataPage: 51,
            payload: args
        }));
        return res;
    }
    // {userWeight: Int, bikeWeight: Int}
    async function setUserData(args = {}) {
        const control = service.characteristics.control;
        // TODO: validate the input
        const data = {
            userWeight: args.userWeight ?? (0, $471e1f142048e38f$export$c2507140e5bb8721).userWeight(),
            bikeWeight: args.bikeWeight ?? (0, $471e1f142048e38f$export$c2507140e5bb8721).bikeWeight()
        };
        const res = await control.write((0, $ceb0ab6d2e228045$export$a8ecead220dd38a6).encode({
            dataPage: 55,
            payload: data
        }));
        return res;
    }
    // {userWeight: Int, bikeWeight: Int}
    async function setWindResistance(args = {}) {
        const control = service.characteristics.control;
        const res = await control.write((0, $ceb0ab6d2e228045$export$a8ecead220dd38a6).encode({
            dataPage: 50,
            payload: args
        }));
        return res;
    }
    // {userWeight: Int, bikeWeight: Int}
    async function setRoadFeel(args = {}) {
        const control = service.characteristics.control;
        const res = await control.write((0, $ceb0ab6d2e228045$export$a8ecead220dd38a6).encode({
            dataPage: 252,
            payload: args
        }));
        return res;
    }
    return Object.freeze({
        ...service,
        protocol: // FEC will have all the public methods and properties of Service
        protocol,
        setPowerTarget: setPowerTarget,
        setResistanceTarget: setResistanceTarget,
        setSimulation: setSimulation,
        setUserData: setUserData,
        setWindResistance: setWindResistance,
        setRoadFeel: setRoadFeel
    });
}
var $920c8ecd383ec8b2$export$2e2bcd8739ae039 = $920c8ecd383ec8b2$var$FEC;


//
// Wahoo Cycling Power Service
//



//
// Cycling Power Spec
// Cycling Power Measurement Characteristic
//


function $d6a2baf07ff93ce4$export$a48b1aff3da70cf0(args = {}) {
    const defaults = {
        revs: -1,
        time: -1,
        value: 0,
        rate: 0.5,
        // (1024/2 / 1024), 0.5 second,
        maxRateCount: 3,
        rateCount: 0
    };
    const format = args.format ?? ((x)=>x);
    const resolution = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.resolution, 'needs resolution.');
    const maxRevs = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.maxRevs, 'needs maxRevs.');
    const maxTime = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.maxTime, 'needs maxTime.');
    const rate = args.rate ?? defaults.rate;
    // state
    let maxRateCount = defaults.maxRateCount;
    let rateCount = defaults.rateCount;
    let revs_1 = defaults.revs;
    let time_1 = defaults.time;
    let value = defaults.value;
    const setRevs = (revs)=>{
        revs_1 = revs;
        return revs_1;
    };
    const setTime = (time)=>{
        time_1 = time;
        return time_1;
    };
    const setRateCount = (count)=>{
        rateCount = count;
        return rateCount;
    };
    const getRevs = ()=>revs_1;
    const getTime = ()=>time_1;
    const getRateCount = ()=>rateCount;
    const getMaxRateCount = ()=>maxRateCount;
    const isRolloverTime = (time_2)=>time_2 < getTime();
    const isRolloverRevs = (revs_2)=>revs_2 < getRevs();
    const rollOverTime = ()=>getTime() - maxTime;
    const rollOverRevs = ()=>getRevs() - maxRevs;
    // coasting or not moving
    const stillRevs = (revs_2)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getRevs(), revs_2);
    // multiple transmissions of the same time
    const stillTime = (time)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getTime(), time);
    function setMaxRateCount(maxCount) {
        maxRateCount = maxCount ?? defaults.maxRateCount;
        console.log(`maxRateCount: ${maxRateCount}`);
        return maxRateCount;
    }
    function reset() {
        setRevs(defaults.revs);
        setTime(defaults.time);
        setRateCount(defaults.rateCount);
        value = defaults.value;
        return {
            revs: revs_1,
            time: time_1
        };
    }
    function underRate(time) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(rateCount, maxRateCount)) {
            rateCount = 0;
            return false;
        }
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getTime(), time)) {
            rateCount += 1;
            return true;
        }
        if (time - getTime() < rate) {
            rateCount += 1;
            return true;
        }
        rateCount = 0;
        return false;
    }
    function calculate(revs_2, time_2) {
        if (getRevs() < 0) setRevs(revs_2); // set initial revs
        if (getTime() < 0) setTime(time_2); // set initial time
        if (underRate(time_2)) return value;
        if (stillRevs(revs_2)) {
            setTime(time_2);
            value = 0;
            return value;
        }
        if (isRolloverTime(time_2)) setTime(rollOverTime());
        if (isRolloverRevs(revs_2)) setRevs(rollOverRevs());
        value = format((revs_2 - getRevs()) / ((time_2 - getTime()) / resolution));
        setRevs(revs_2);
        setTime(time_2);
        return value;
    }
    return {
        reset: reset,
        calculate: calculate,
        setMaxRateCount: setMaxRateCount
    };
}
function $d6a2baf07ff93ce4$export$97ac7cca7986975a(args = {}) {
    const Status = {
        reading: 'reading',
        done: 'done',
        is: (expected, value)=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(expected, value)
    };
    const defaults = {
        sampleSize: 0,
        rate: 3,
        // [0,1,2,3]
        cutoff: 20,
        maxStillTime: 3000,
        // ms
        sensor: 'cscs',
        onDone: (x)=>x
    };
    let _sample = [];
    let _sampleSize = defaults.sampleSize;
    let _rate = defaults.rate;
    let _maxStillTime = defaults.maxStillTime;
    let _cutoff = defaults.cutoff;
    let _status = Status.reading;
    const onDone = args.onDone ?? defaults.onDone;
    const sensor = args.sensor ?? defaults.sensor;
    const setCutoff = (count)=>_cutoff = count;
    const setMaxStillTime = (ms)=>_maxStillTime = ms;
    const getSampleSize = ()=>_sampleSize;
    const getSample = ()=>_sample;
    const getRate = ()=>_rate;
    const getStatus = ()=>_status;
    const getCutoff = ()=>_cutoff;
    const getMaxStillTime = (ms)=>_maxStillTime;
    const isDone = ()=>(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(_status, Status.done);
    function reset() {
        _sample = [];
        _sampleSize = defaults.sampleSize;
        _rate = defaults.rate;
        _status = Status.reading;
    }
    function timestampAvgDiff(sample) {
        return sample.reduce(function(acc, x, i, xs) {
            let tsd = 1000;
            if (i > 0) tsd = xs[i].ts - xs[i - 1].ts;
            acc += (tsd - acc) / (i + 1);
            return acc;
        }, 0);
    }
    function calculate(sample) {
        const tsAvgDiff = timestampAvgDiff(sample);
        const maxRateCount = (0, $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4)(2, 15, Math.round(_maxStillTime / tsAvgDiff) - 1);
        console.log(`rateAdjuster on: ${sensor} tsAvgDiff: ${tsAvgDiff} result: ${maxRateCount}`);
        return maxRateCount;
    }
    function update(value) {
        if (isDone()) return;
        _sample.push(value);
        _sampleSize += 1;
        if (_sampleSize >= _cutoff) {
            _status = Status.done;
            _rate = calculate(_sample);
            onDone(_rate);
        }
    }
    return Object.freeze({
        reset: reset,
        isDone: isDone,
        timestampAvgDiff: timestampAvgDiff,
        calculate: calculate,
        update: update
    });
}


const $22411b810222879d$var$pedalPowerBalancePresent = (flags)=>(flags >> 0 & 1) === 1;
const $22411b810222879d$var$pedalPowerBalanceRefPresent = (flags)=>(flags >> 1 & 1) === 1;
const $22411b810222879d$var$accumulatedTorquePresent = (flags)=>(flags >> 2 & 1) === 1;
const $22411b810222879d$var$accumulatedTorqueSourcePresent = (flags)=>(flags >> 3 & 1) === 1;
const $22411b810222879d$var$wheelRevolutionDataPresent = (flags)=>(flags >> 4 & 1) === 1;
const $22411b810222879d$var$crankRevolutionDataPresent = (flags)=>(flags >> 5 & 1) === 1;
const $22411b810222879d$var$cadencePresent = (flags)=>(flags >> 5 & 1) === 1;
const $22411b810222879d$var$extremeForceMagnitudesPresent = (flags)=>(flags >> 6 & 1) === 1;
const $22411b810222879d$var$extremeTorqueMagnitudesPresent = (flags)=>(flags >> 7 & 1) === 1;
const $22411b810222879d$var$extremeAnglesPresent = (flags)=>(flags >> 8 & 1) === 1;
const $22411b810222879d$var$topDeadSpotAnglePresent = (flags)=>(flags >> 9 & 1) === 1;
const $22411b810222879d$var$bottomDeadSpotAnglePresent = (flags)=>(flags >> 10 & 1) === 1;
const $22411b810222879d$var$accumulatedEnergyPresent = (flags)=>(flags >> 11 & 1) === 1;
const $22411b810222879d$var$offsetIndicator = (flags)=>(flags >> 12 & 1) === 1;
const $22411b810222879d$var$fields = {
    flags: {
        resolution: 1,
        unit: '',
        size: 2,
        type: 'Uint16',
        present: (_)=>true
    },
    power: {
        resolution: 1,
        unit: 'W',
        size: 2,
        type: 'Int16',
        present: (_)=>true
    },
    pedalPowerBalance: {
        resolution: 0.5,
        unit: '',
        size: 1,
        type: 'Uint8',
        present: $22411b810222879d$var$pedalPowerBalancePresent
    },
    accumulatedTorque: {
        resolution: 1 / 32,
        unit: '',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$accumulatedTorquePresent
    },
    cumulativeWheelRevolutions: {
        resolution: 1,
        unit: '',
        size: 4,
        type: 'Uint32',
        present: $22411b810222879d$var$wheelRevolutionDataPresent
    },
    lastWheelEventTime: {
        resolution: 1 / 2048,
        unit: 's',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$wheelRevolutionDataPresent
    },
    cumulativeCrankRevolutions: {
        resolution: 1,
        unit: '',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$crankRevolutionDataPresent
    },
    lastCrankEventTime: {
        resolution: 1 / 1024,
        unit: 's',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$crankRevolutionDataPresent
    },
    maximumForceMagnitude: {
        resolution: 1,
        unit: '',
        size: 2,
        type: 'Int16',
        present: $22411b810222879d$var$extremeForceMagnitudesPresent
    },
    minimumForceMagnitude: {
        resolution: 1,
        unit: '',
        size: 2,
        type: 'Int16',
        present: $22411b810222879d$var$extremeForceMagnitudesPresent
    },
    maximumTorqueMagnitude: {
        resolution: 1 / 32,
        unit: '',
        size: 2,
        type: 'Int16',
        present: $22411b810222879d$var$extremeTorqueMagnitudesPresent
    },
    minimumTorqueMagnitude: {
        resolution: 1 / 32,
        unit: '',
        size: 2,
        type: 'Int16',
        present: $22411b810222879d$var$extremeTorqueMagnitudesPresent
    },
    extreamAngles: {
        resolution: 1,
        unit: 'deg',
        size: 3,
        type: 'Uint24',
        present: $22411b810222879d$var$extremeAnglesPresent
    },
    // maximumAngle:               {resolution: 1,        unit: 'deg', size: 1.5, type: 'Uint12', present: extremeAnglesPresent},
    // minimumAngle:               {resolution: 1,        unit: 'deg', size: 1.5, type: 'Uint12', present: extremeAnglesPresent},
    topDeadSpotAngle: {
        resolution: 1,
        unit: 'deg',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$topDeadSpotAnglePresent
    },
    bottomDeadSpotAngle: {
        resolution: 1,
        unit: 'deg',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$bottomDeadSpotAnglePresent
    },
    accumulatedEnergy: {
        resolution: 1,
        unit: 'kJ',
        size: 2,
        type: 'Uint16',
        present: $22411b810222879d$var$accumulatedEnergyPresent
    }
};
const $22411b810222879d$var$order = [
    'flags',
    'power',
    'pedalPowerBalance',
    'accumulatedTorque',
    'cumulativeWheelRevolutions',
    'lastWheelEventTime',
    'cumulativeCrankRevolutions',
    'lastCrankEventTime',
    'maximumForceMagnitude',
    'minimumForceMagnitude',
    'maximumTorqueMagnitude',
    'minimumTorqueMagnitude',
    'extreamAngles',
    // maybe remove those it's Uint12 + Uint12
    'topDeadSpotAngle',
    'bottomDeadSpotAngle',
    'accumulatedEnergy'
];
// Example input:
//
//
//      flags  power  wheel revs   wheel time  crank revs  crank time
//       0  1   2  3   4  5  6  7   8  9       10 11       12 13
//
// (0x) 30-00 -21-00 -2A-00-00-00  -C4-60      -12-00      -F7-04
//      48, 0, 33, 0, 42, 0, 0, 0, 196,96,      18, 0,     247, 4
// (0x) 30-00 -56-00 -00-00-00-00  -00-00      -00-00      -F7-04
//      48, 0, 86, 0,  0, 0, 0, 0,   0, 0,       0, 0,     247, 4
// (0x) 30-00 -5E-00 -03-00-00-00  -16-0B      -01-00      -0A-03
//      48, 0, 94, 0,  3, 0, 0, 0,  22,11,       1, 0,      10, 3
//
// '30-00-21-00-2A-00-00-00-C4-60-12-00-F7-04'.split('-').map(x => Number('0x'+x))
//
function $22411b810222879d$export$200b7adf2058d8b9(args = {}) {
    const architecture = true;
    function getField(field, dataview, i) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(field.type, 'Uint24')) return (((dataview.getUint16(i, architecture) & 65520) << 4) + dataview.getUint8(i + 2, architecture)) * field.resolution;
        return dataview[`get${field.type}`](i, architecture) * field.resolution;
    }
    const cadence = (0, $d6a2baf07ff93ce4$export$a48b1aff3da70cf0)({
        resolution: 1,
        maxRevs: 2 ** 16 * $22411b810222879d$var$fields.cumulativeCrankRevolutions.resolution,
        // 1
        maxTime: 2 ** 16 * $22411b810222879d$var$fields.lastCrankEventTime.resolution,
        // 1024
        // revs per second to revs per 60 seconds
        format: (x)=>Math.round(x * 60)
    });
    const rateAdjuster = (0, $d6a2baf07ff93ce4$export$97ac7cca7986975a)({
        sensor: 'powerMeter',
        onDone: function(maxRateCount) {
            cadence.setMaxRateCount(maxRateCount);
        }
    });
    function decode(dataview) {
        const byteLength = dataview.byteLength;
        return $22411b810222879d$var$order.reduce(function(acc, fieldName) {
            const field = $22411b810222879d$var$fields[fieldName];
            if (acc.i + field.size > byteLength) return acc;
            if (field.present(acc.flags)) {
                const value = getField(field, dataview, acc.i);
                const unit = field.unit;
                const name = field.short ?? fieldName;
                if (acc.i === 0) acc.flags = value;
                acc.data[name] = value;
                if (name === 'lastCrankEventTime') acc.data['cadence'] = cadence.calculate(acc.data['cumulativeCrankRevolutions'], acc.data['lastCrankEventTime']);
                acc.i += field.size;
            }
            return acc;
        }, {
            i: 0,
            flags: 0,
            data: {}
        }).data;
    }
    return Object.freeze({
        decode: decode
    });
}
const $22411b810222879d$export$daa229863fb64c83 = $22411b810222879d$export$200b7adf2058d8b9();



function $20d601f30173d155$var$RequestControl() {
    const opCode = 0x20; // 32
    const length = 3;
    const unlockCode = [
        0xEE,
        0xFC
    ];
    function encode() {
        // [0x20, 0xEE, 0xFC]
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint8(1, unlockCode[0], true);
        view.setUint8(2, unlockCode[1], true);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const unlockCode = [
            dataview.getUint8(1, true),
            dataview.getUint8(2, true)
        ];
        return {
            opCode: opCode,
            unlockCode: unlockCode
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$SetERG() {
    const opCode = 0x42;
    const length = 3;
    const definitions = {
        power: {
            resolution: 1,
            unit: 'W',
            size: 2,
            min: 0,
            max: 65534,
            default: 0
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    // {power: Int} -> ArrayBuffer
    function encode(args = {}) {
        const power = spec.encodeField('power', args.power);
        const view = new DataView(new ArrayBuffer(length));
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: setERG: ${args.power}`);
        view.setUint8(0, opCode, true);
        view.setUint16(1, power, true);
        return view.buffer;
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode
    });
}
function $20d601f30173d155$var$Grade() {
    // set Sim Grade
    const opCode = 0x46; // 70
    const length = 3;
    // Format ????
    // let norm = UInt16((min(1, max(-1, grade)) + 1.0) * 65535 / 2.0)
    // int value = (gradient / 100.0 + 1.0) * 32768;
    // Math.min(1, Math.max(-1, grade) + 1) * 32768
    const definitions = {
        grade: {
            resolution: 1,
            unit: '%',
            size: 2,
            min: applyOffset(-100),
            max: applyOffset(100),
            default: applyOffset(0)
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function applyOffset(value) {
        return (value / 100 + 1) * 32768;
    }
    function removeOffset(prop, value) {
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)((value / 32768 - 1) * 100, 1);
    }
    function encode(args = {}) {
        const grade = spec.encodeField('grade', args.grade, applyOffset);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint16(1, grade, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: grade: ${grade}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const grade = spec.decodeField('grade', dataview.getUint16(1, true), removeOffset);
        return {
            grade: grade
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$SIM() {
    const opCode = 0x43; // 67
    const length = 7;
    const definitions = {
        weight: {
            resolution: 0.01,
            unit: 'kg',
            size: 2,
            min: 0,
            max: 655.35,
            default: 75
        },
        crr: {
            resolution: 0.0001,
            unit: '',
            size: 2,
            min: 0,
            max: 6.5535,
            default: 0.004
        },
        windResistance: {
            resolution: 0.001,
            unit: 'kg/m',
            size: 2,
            min: 0,
            max: 65.535,
            default: 0.51
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        const weight = spec.encodeField('weight', args.weight);
        const crr = spec.encodeField('crr', args.crr);
        const windResistance = spec.encodeField('windResistance', args.windResistance);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint16(1, weight, true);
        view.setUint16(3, crr, true);
        view.setUint16(5, windResistance, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: sim: ${weight}, ${crr}, ${windResistance}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const weight = spec.decodeField('weight', dataview.getUint16(1, true));
        const crr = spec.decodeField('crr', dataview.getUint16(3, true));
        const windResistance = spec.decodeField('windResistance', dataview.getUint16(5, true));
        return {
            weight: weight,
            crr: crr,
            windResistance: windResistance
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$WindSpeed() {
    // set Wind Speed
    const opCode = 0x47; // 71
    const length = 3;
    // Format ????
    // int value = (int)((windSpeed + 32.768) * 1000.0);
    const definitions = {
        windSpeed: {
            resolution: 1,
            unit: 'mps',
            size: 2,
            min: applyOffset(-35.56),
            max: applyOffset(35.56),
            default: applyOffset(0)
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function applyOffset(value) {
        return (value + 32.768) * 1000;
    }
    function removeOffset(prop, value) {
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(value / 1000 - 32.768, 2);
    }
    function encode(args = {}) {
        const windSpeed = spec.encodeField('windSpeed', args.windSpeed, applyOffset);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint16(1, windSpeed, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: windSpeed: ${windSpeed}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const windSpeed = spec.decodeField('windSpeed', dataview.getUint16(1, true), removeOffset);
        return {
            windSpeed: windSpeed
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$WheelCircumference() {
    // set Wind Speed
    const opCode = 0x48; // 72
    const length = 3;
    // Format ????
    // int value = (int)(wheelSize * 10.0);
    const definitions = {
        circumference: {
            resolution: 0.1,
            unit: 'mm',
            size: 2,
            min: 0,
            max: 6553.4,
            default: 2136
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        const circumference = spec.encodeField('circumference', args.circumference);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint16(1, circumference, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: circumference: ${circumference}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const circumference = spec.decodeField('circumference', dataview.getUint16(1, true));
        return {
            circumference: circumference
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$LoadIntensity() {
    // set Load Intensity
    const opCode = 0x40; // 64
    const length = 3;
    // Format ????
    // input value is between 0 and 1
    // let norm = UInt16((1 - resistance) * 16383)
    // int value = (1.0 - load) * 16383.0;
    const definitions = {
        intensity: {
            resolution: 1,
            unit: '',
            size: 2,
            min: applyOffset(1),
            // it flips the value
            max: applyOffset(0),
            default: applyOffset(0)
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function applyOffset(value) {
        return Math.round((1 - value) * 16383);
    }
    function removeOffset(prop, value) {
        return (0, $c6a9e46ee7e4d896$export$a81f732198733497)(1 - value / 16383, 2);
    }
    function encode(args = {}) {
        const intensity = spec.encodeField('intensity', args.intensity, applyOffset);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint16(1, intensity, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: loadIntensity: ${args.intensity}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const intensity = spec.decodeField('intensity', dataview.getUint16(1, true), removeOffset);
        return {
            intensity: intensity
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$LoadLevel() {
    // set Load Level
    const opCode = 0x41; // 65
    const length = 2;
    // Format ????
    // input value is between 0 and 9
    const definitions = {
        level: {
            resolution: 1,
            unit: '',
            size: 1,
            min: 0,
            max: 9,
            default: 0
        }
    };
    const spec = (0, $c6a9e46ee7e4d896$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        const level = spec.encodeField('level', args.level);
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, opCode, true);
        view.setUint8(1, level, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`tx: wcps: loadLevel: ${args.level}`);
        return view.buffer;
    }
    function decode(dataview) {
        const opCode = dataview.getUint8(0, true);
        const level = spec.decodeField('level', dataview.getUint8(1, true));
        return {
            level: level
        };
    }
    return Object.freeze({
        opCode: opCode,
        length: length,
        definitions: definitions,
        encode: encode,
        decode: decode
    });
}
function $20d601f30173d155$var$Response() {
    // Format:
    //
    // Example 1:
    // msg:      [66, 50, 0],
    // response: [1, 66, 1, 0, 50, 0]
    //
    // status - op code - ? - value
    // 1        66        1   50
    //
    // 0b01 status === success
    //
    // Example 2:
    // msg:      [32],
    // response: [1, 32, 2]
    //
    // status - op code - ?
    // 1        32        2
    //
    // Responses:
    // [   1,   67,    1,    0], setSimMode success
    // [0x01, 0x43, 0x01, 0x00],
    //
    // [   1,   70,    1,    0,    0,  128], setSlopeTarget success
    // [0x01, 0x46, 0x01, 0x00, 0x00, 0x80],
    //
    const results = {
        '1': {
            definition: 'success',
            msg: 'success'
        },
        '0': {
            definition: 'fail',
            msg: 'fail'
        } // maybe just a guess
    };
    const requests = {
        '0x20': {
            definition: 'unlock',
            msg: 'unlock'
        },
        // 32
        '0x40': {
            definition: 'setResistanceTarget',
            msg: 'setResistanceTarget'
        },
        // 64
        '0x41': {
            definition: 'setStandardMode',
            msg: 'setStandardMode'
        },
        // 65
        '0x42': {
            definition: 'setPowerTarget',
            msg: 'setPowerTarget'
        },
        // 66
        '0x43': {
            definition: 'setSimMode',
            msg: 'setSimMode'
        },
        // 67
        '0x44': {
            definition: 'setCrr',
            msg: 'setCrr'
        },
        // 68
        '0x45': {
            definition: 'setWindResistance',
            msg: 'setWindResistance'
        },
        // 69
        '0x46': {
            definition: 'setSlopeTarget',
            msg: 'setSlopeTarget'
        },
        // 70
        '0x47': {
            definition: 'setWindSpeed',
            msg: 'setWindSpeed'
        },
        // 71
        '0x48': {
            definition: 'setWheelCircumference',
            msg: 'setWheelCircumference'
        } // 72
    };
    function decodeStatus(value) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, 0)) return 'fail';
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(value, 1)) return 'success';
        return ':unknown';
    }
    function decodeRequest(value) {
        const hexValue = (0, $c6a9e46ee7e4d896$export$834dfc94dde4b3d8)(value);
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(requests[hexValue])) return requests[hexValue]?.msg ?? '';
        return ':unknown';
    }
    function encode(value) {}
    function decode(dataview) {
        const raw = (0, $c6a9e46ee7e4d896$export$d59ba87ce515b3fd)(dataview).slice(dataview.byteOffset);
        const res = {};
        res.status = decodeStatus(dataview.getUint8(0, true));
        res.request = decodeRequest(dataview.getUint8(1, true));
        if (dataview.byteLength > 5) res.value = dataview.getUint16(4, true);
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`rx: wcps: status: ${res.status} request: ${res.request} ${raw}`);
        return res;
    }
    return Object.freeze({
        results: results,
        requests: requests,
        encode: encode,
        decode: decode
    });
}
const $20d601f30173d155$export$b5cde1de278b4330 = {
    grade: $20d601f30173d155$var$Grade(),
    windSpeed: $20d601f30173d155$var$WindSpeed(),
    sim: $20d601f30173d155$var$SIM(),
    wheelCircumference: $20d601f30173d155$var$WheelCircumference(),
    setERG: $20d601f30173d155$var$SetERG(),
    loadIntensity: $20d601f30173d155$var$LoadIntensity(),
    loadLevel: $20d601f30173d155$var$LoadLevel(),
    requestControl: $20d601f30173d155$var$RequestControl(),
    response: $20d601f30173d155$var$Response()
};





function $2b51732e8014f04e$var$WCPS(args = {}) {
    // config
    const onData = args.onData;
    const txRate = 1000;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'WCPS needs BluetoothRemoteGATTService!');
    // end config
    // private state
    let controlMode = (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim;
    let q = [];
    let msgSeqLock = false;
    // end private state
    // service
    function onControlResponse(msg) {
        let control = service.characteristics.control;
        if (msgSeqLock) {
            if (msg.request === 'setSimMode') {
                if (msg.status === 'success') {
                    msgSeqLock = false;
                    setSimulation(q.pop()?.params ?? {
                        grade: 0
                    });
                    return;
                } else {
                    msgSeqLock = true;
                    setSimMode();
                    return;
                }
            }
        }
        control.release();
    }
    // Void -> Bool
    async function protocol() {
        const control = service.characteristics.control;
        // TODO: return false if any of those fails or
        // returns false and dicsonnect the device
        await requestControl();
        await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
        await setUser();
        await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
        await setWindResistance();
        await (0, $c6a9e46ee7e4d896$export$5c069c93d2b7493f)(txRate);
        await setWheelCircumference();
        return true;
    }
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).cyclingPowerMeasurement,
            notify: {
                callback: onData,
                parser: (0, $22411b810222879d$export$daa229863fb64c83)
            }
        },
        control: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).wahooTrainer,
            notify: {
                callback: onControlResponse,
                parser: (0, $20d601f30173d155$export$b5cde1de278b4330).response
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        protocol: protocol,
        service: gattService
    });
    // end service
    // methods
    // {WindSpeed: Float, Grade: Float, Crr: Float, WindResistance: Float} -> Void
    function setSimulation(parameters = {}) {
        const control = service.characteristics.control;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(control) || !control.isReady() || msgSeqLock) return false;
        const gradeParams = {
            grade: parameters.grade
        };
        // if in erg mode -> init sim mode -> send grade
        // else send grade
        if (controlMode === (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim) {
            control.write((0, $20d601f30173d155$export$b5cde1de278b4330).grade.encode(gradeParams));
            control.block();
        } else {
            msgSeqLock = true;
            q.push({
                command: "setSimulation",
                params: gradeParams
            });
            setSimMode();
        }
    }
    // {resistance: Int} -> Void
    function setResistanceTarget(args = {}) {
        const control = service.characteristics.control;
        control.write((0, $20d601f30173d155$export$b5cde1de278b4330).loadIntensity.encode({
            intensity: args.resistance / 100
        }));
        controlMode = (0, $21d6c30d826f68a8$export$83d617ae204944c5).resistance;
    // control.block();
    }
    // {power: Int} -> Void
    function setPowerTarget(args = {}) {
        const control = service.characteristics.control;
        control.write((0, $20d601f30173d155$export$b5cde1de278b4330).setERG.encode(args));
        controlMode = (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg;
    // control.block();
    }
    // {weigth: Float, crr: Float, windResistance: Float} -> Void
    function setSimMode(args = {}) {
        const control = service.characteristics.control;
        const weight = (0, $471e1f142048e38f$export$c2507140e5bb8721).userWeight() + (0, $471e1f142048e38f$export$c2507140e5bb8721).bikeWeight();
        control.write((0, $20d601f30173d155$export$b5cde1de278b4330).sim.encode({
            weight: weight,
            crr: args.crr,
            windResistance: args.windResistance
        }));
        controlMode = (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim;
    }
    function setUser() {
        setSimMode();
    }
    async function requestControl() {
        const control = service.characteristics.control;
        const res = await control.write((0, $20d601f30173d155$export$b5cde1de278b4330).requestControl.encode());
        return res;
    }
    async function setWindResistance() {
        const control = service.characteristics.control;
        const res = await control.write((0, $20d601f30173d155$export$b5cde1de278b4330).windSpeed.encode({
            windSpeed: 0
        }));
        return res;
    }
    async function setWheelCircumference() {
        const control = service.characteristics.control;
        const res = await control.write((0, $20d601f30173d155$export$b5cde1de278b4330).wheelCircumference.encode({
            circumference: (0, $20d601f30173d155$export$b5cde1de278b4330).wheelCircumference.definitions.circumference.default
        }));
        return res;
    }
    // end methods
    return Object.freeze({
        ...service,
        setSimulation: // WCPS will have all the public methods and properties of Service
        setSimulation,
        setResistanceTarget: setResistanceTarget,
        setPowerTarget: setPowerTarget,
        setUser: setUser,
        setWindResistance: setWindResistance,
        setWheelCircumference: setWheelCircumference,
        requestControl: requestControl
    });
}
var $2b51732e8014f04e$export$2e2bcd8739ae039 = $2b51732e8014f04e$var$WCPS;


//
// Cycling Power Service
//





function $c6a357b188d73f5f$var$CPS(args = {}) {
    // config
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'CPS needs BluetoothRemoteGATTService!');
    // {} -> Void
    const onData = args.onData;
    // end config
    // Service
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).cyclingPowerMeasurement,
            notify: {
                callback: onData,
                parser: (0, $22411b810222879d$export$daa229863fb64c83)
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        service: gattService,
        spec: spec
    });
    return Object.freeze({
        ...service // CPS will have all the public methods and properties of Service
    });
}
var $c6a357b188d73f5f$export$2e2bcd8739ae039 = $c6a357b188d73f5f$var$CPS;


//
// Cycling Speec and Cadence Service
//




//
// Cycling Speed and Cadence Measurement Characteristic
//


const $be2d32a964e6c9f0$var$wheelRevolutionDataPresent = (flags)=>(flags >> 0 & 1) === 1;
const $be2d32a964e6c9f0$var$crankRevolutionDataPresent = (flags)=>(flags >> 1 & 1) === 1;
const $be2d32a964e6c9f0$var$cumulativeWheelRevolutionsPresent = (flags)=>(flags >> 2 & 1) === 1;
const $be2d32a964e6c9f0$var$fields = {
    flags: {
        resolution: 1,
        unit: '',
        size: 1,
        type: 'Uint8',
        present: (_)=>true
    },
    cumulativeWheelRevolutions: {
        resolution: 1,
        unit: '',
        size: 4,
        type: 'Uint32',
        present: $be2d32a964e6c9f0$var$wheelRevolutionDataPresent
    },
    lastWheelEventTime: {
        resolution: 1 / 1024,
        unit: 's',
        size: 2,
        type: 'Uint16',
        present: $be2d32a964e6c9f0$var$wheelRevolutionDataPresent
    },
    cumulativeCrankRevolutions: {
        resolution: 1,
        unit: '',
        size: 2,
        type: 'Uint16',
        present: $be2d32a964e6c9f0$var$crankRevolutionDataPresent
    },
    lastCrankEventTime: {
        resolution: 1 / 1024,
        unit: 's',
        size: 2,
        type: 'Uint16',
        present: $be2d32a964e6c9f0$var$crankRevolutionDataPresent
    }
};
const $be2d32a964e6c9f0$var$order = [
    'flags',
    'cumulativeWheelRevolutions',
    'lastWheelEventTime',
    'cumulativeCrankRevolutions',
    'lastCrankEventTime'
];
function $be2d32a964e6c9f0$export$d91c3f0bec6c0ad7(args = {}) {
    const defaults = {
        wheelCircumference: 2.105 // meters or 700x25
    };
    const architecture = true;
    let wheelCircumference = args.wheelCircumference ?? defaults.wheelCircumference;
    const cadence = (0, $d6a2baf07ff93ce4$export$a48b1aff3da70cf0)({
        resolution: 1,
        maxRevs: 2 ** 16 * $be2d32a964e6c9f0$var$fields.cumulativeCrankRevolutions.resolution,
        // 1
        maxTime: 2 ** 16 * $be2d32a964e6c9f0$var$fields.lastCrankEventTime.resolution,
        // 1024
        // revs per second to revs per 60 seconds
        format: (x)=>Math.round(x * 60)
    });
    const rateAdjuster = (0, $d6a2baf07ff93ce4$export$97ac7cca7986975a)({
        sensor: 'cscs',
        onDone: function(maxRateCount) {
            cadence.setMaxRateCount(maxRateCount);
        }
    });
    function getField(field, dataview, i) {
        return dataview[`get${field.type}`](i, architecture) * field.resolution;
    }
    function decode(dataview) {
        const byteLength = dataview.byteLength;
        if (!rateAdjuster.isDone()) rateAdjuster.update({
            ts: Date.now()
        });
        return $be2d32a964e6c9f0$var$order.reduce(function(acc, fieldName) {
            const field = $be2d32a964e6c9f0$var$fields[fieldName];
            if (acc.i + field.size > byteLength) return acc;
            if (field.present(acc.flags)) {
                const value = getField(field, dataview, acc.i);
                const unit = field.unit;
                const name = field.short ?? fieldName;
                if (acc.i === 0) acc.flags = value;
                acc.data[name] = value;
                if (name === 'lastCrankEventTime') acc.data['cadence'] = cadence.calculate(acc.data['cumulativeCrankRevolutions'], acc.data['lastCrankEventTime']);
                acc.i += field.size;
            }
            return acc;
        }, {
            i: 0,
            flags: 0,
            data: {}
        }).data;
    }
    return Object.freeze({
        decode: decode
    });
}
const $be2d32a964e6c9f0$export$f94305e82ca48278 = $be2d32a964e6c9f0$export$d91c3f0bec6c0ad7();


function $91e28be2869b7451$var$CSCS(args = {}) {
    // config
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'HRS needs BluetoothRemoteGATTService!');
    const onData = args.onData;
    // end config
    // Service
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).speedCadenceMeasurement,
            notify: {
                callback: onData,
                parser: (0, $be2d32a964e6c9f0$export$f94305e82ca48278)
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        service: gattService,
        spec: spec
    });
    return Object.freeze({
        ...service
    });
}
var $91e28be2869b7451$export$2e2bcd8739ae039 = $91e28be2869b7451$var$CSCS;


//
// Heart Rate Service
//




//
// Heart Rate Spec
// Heart Rate Measurement characteristic
//
function $9960ceb5d49077ac$export$e1e2e996f6a57c01(args = {}) {
    const rrIntervalResolution = 1024;
    function decode(dataview) {
        const flags = dataview.getUint8(0, true);
        const heartRateValueFormat = (flags >> 0 & 1) === 1;
        const sensorContactStatus = (flags >> 1 & 1) === 1;
        const sensorContactSupported = (flags >> 2 & 1) === 1;
        const energyExpenditureStatus = (flags >> 3 & 1) === 1;
        const rrIntervalPresent = (flags >> 4 & 1) === 1;
        let i = 1;
        let heartRate = 0;
        let energyExpenditure;
        let rrInterval;
        if (heartRateValueFormat) {
            heartRate = dataview.getUint16(i, true);
            i += 2;
        } else {
            heartRate = dataview.getUint8(i, true);
            i += 1;
        }
        if (energyExpenditureStatus) {
            energyExpenditure = dataview.getUint16(i, true);
            i += 2;
        }
        if (rrIntervalPresent) {
            rrInterval = [];
            while(i <= dataview.byteLength - 2){
                rrInterval.push(dataview.getUint16(i, true) / rrIntervalResolution);
                i += 2;
            }
        }
        return {
            sensorContactSupported: sensorContactSupported,
            sensorContactStatus: // Bool
            sensorContactStatus,
            heartRate: // Bool
            heartRate,
            energyExpenditure: // Int
            energyExpenditure,
            rrInterval: // Int?
            rrInterval // [Float]?
        };
    }
    return Object.freeze({
        rrIntervalResolution: rrIntervalResolution,
        decode: decode
    });
}
const $9960ceb5d49077ac$export$c39a098f38a74749 = $9960ceb5d49077ac$export$e1e2e996f6a57c01();


function $d5413625f9559e1f$var$HRS(args = {}) {
    // config
    const onData = args.onData;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'HRS needs BluetoothRemoteGATTService!');
    // end config
    // service
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).heartRateMeasurement,
            notify: {
                callback: onData,
                parser: (0, $9960ceb5d49077ac$export$c39a098f38a74749)
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        service: gattService
    });
    // end service
    return Object.freeze({
        ...service // HRS will have all the public methods and properties of Service
    });
}
var $d5413625f9559e1f$export$2e2bcd8739ae039 = $d5413625f9559e1f$var$HRS;


//
// Battery Service
//




//
// Battery Service Spec
// Battery Level (characteristic)
//

function $649c189f8084ceed$var$BatteryLevel() {
    function decode(dataview) {
        const batteryLevel = dataview.getUint8(0, true); // 0-100, %
        return {
            batteryLevel: batteryLevel
        };
    }
    return Object.freeze({
        decode: decode
    });
}
const $649c189f8084ceed$export$44425983b94758f1 = $649c189f8084ceed$var$BatteryLevel();


function $c64fc57441e42a7b$var$BAS(args = {}) {
    // config
    const onData = args.onData;
    // const onRead = args.onRead;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'BAS needs BluetoothRemoteGATTService!');
    // end config
    // service
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).batteryLevel,
            // read: {callback: onData, parser: batteryLevelParser},
            notify: {
                callback: onData,
                parser: (0, $649c189f8084ceed$export$44425983b94758f1)
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        service: gattService
    });
    // end service
    async function readBatteryLevel() {
        const measurement = service.characteristics.measurement;
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(measurement)) return false;
        const res = await measurement.read();
        return res;
    }
    return Object.freeze({
        ...service,
        readBatteryLevel: // BAS will have all the public methods and properties of Service
        readBatteryLevel
    });
}
var $c64fc57441e42a7b$export$2e2bcd8739ae039 = $c64fc57441e42a7b$var$BAS;


//
// Race Controller Service
//




//
// Race Controller Measurement Characteristic
//
function $152846896e87991e$export$adc6d916322e3d8b(args = {}) {
    const architecture = true;
    const opCodes = {
        buttons: 7,
        idle: 21,
        unknown: 0xFF
    };
    const crypto = args.crypto ?? {
        decrypt: (x)=>''
    };
    // Dataview -> String
    function decrypt(dataview) {
        return crypto.decrypt(decrypt.buffer);
    }
    // NOTE:
    // normal button: not pressed 1, pressed 0
    // numeric button: not pressed 0, pressed: Int > 0
    // Dataview -> { type: String, plus: Bool, minus: Bool }
    function decode(dataview) {
        const str = decrypt(dataview) ?? '0xFF';
        const opCode = str.substring(0, 1);
        let type = 'unknown';
        let data = {};
        if (opCode === opCodes.buttons) {
            type = 'buttons';
            data.plus = str.substring(4, 6) === '00';
            data.minus = str.substring(8, 10) === '00';
        }
        if (opCode === opCodes.idle) type = 'idle';
        // TODO: handle other message types
        return {
            type: type,
            ...data
        };
    }
    return Object.freeze({
        decrypt: decrypt,
        decode: decode
    });
}


// import { Crypto } from './crypto.js';
function $2cf053fd3c49c3e6$var$Crypto() {
    function createPublicKey() {}
    function createSharedKey() {}
    function decodePublicKey() {}
    return {
        createPublicKey: createPublicKey,
        createSharedKey: createSharedKey,
        decodePublicKey: decodePublicKey
    };
}
function $2cf053fd3c49c3e6$var$RCS(args = {}) {
    // config
    const onData = args.onData;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'RCS needs BluetoothRemoteGATTService!');
    // end config
    // service
    const crypto = $2cf053fd3c49c3e6$var$Crypto();
    const raceControllerMeasurementParser = (0, $152846896e87991e$export$adc6d916322e3d8b)({
        crypto: crypto
    });
    async function protocol() {
        const control = service.characteristics.control;
        // Step 1: create key pair
        crypto.createPublicKey();
        // Step 2: send handshake
        await control.write(crypto.handshake());
    }
    function onResponse(msg) {
        console.log(`ble: rcs: on-response: `, msg);
        // Step 3: create shared key
        crypto.createSharedKey(msg);
    }
    function onControl(msg) {
        console.log(`ble: rcs: on-control: `, msg);
    }
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).raceControllerMeasurement,
            notify: {
                callback: onData,
                parser: raceControllerMeasurementParser
            }
        },
        control: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).raceControllerControlPoint
        },
        response: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).raceControllerResponse,
            notify: {
                callback: onResponse,
                parser: {
                    decode: (dataview)=>crypto.decodePublicKey(dataview)
                }
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        service: gattService
    });
    // end service
    return Object.freeze({
        ...service,
        protocol: // RCS will have all the public methods and properties of Service
        protocol
    });
}
var $2cf053fd3c49c3e6$export$2e2bcd8739ae039 = $2cf053fd3c49c3e6$var$RCS;


//
// SmO2 Service
//




//
// Saturated Muscle Oxygen Service
//

function $7264b5afad388097$export$6298b650a59e6ea5(args = {}) {
    const definitions = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.definitions);
    const applyResolution = (0, $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2)((prop, value)=>{
        return value / definitions[prop].resolution;
    });
    const removeResolution = (0, $c6a9e46ee7e4d896$export$6944c5e0a4d7bdd2)((prop, value)=>{
        return value * definitions[prop].resolution;
    });
    function encodeField(prop, input, transform = applyResolution(prop)) {
        const fallback = definitions[prop].default;
        const min = applyResolution(definitions[prop].min);
        const max = applyResolution(definitions[prop].max);
        const value = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(input, fallback);
        return Math.floor((0, $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4)(min, max, transform(value)));
    }
    function decodeField(prop, input, transform = removeResolution) {
        return transform(prop, input);
    }
    return {
        definitions: definitions,
        applyResolution: applyResolution,
        removeResolution: removeResolution,
        encodeField: encodeField,
        decodeField: decodeField
    };
}
function $7264b5afad388097$export$7254cc27399e90bd(args = {}) {
    const defaults = {
        revs: -1,
        time: -1,
        value: 0,
        resolution: 1024,
        maxRevs: 2 ** 16,
        maxTime: 2 ** 16,
        transform: (x)=>x,
        rate: 512,
        // 0.5 second,
        maxRateCount: 3,
        rateCount: 0
    };
    const resolution = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.resolution, defaults.resolution);
    const transform = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.transform, defaults.transform);
    const maxRevs = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.maxRevs, defaults.maxRevs);
    const maxTime = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.maxTime, defaults.maxTime);
    const calculate = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.calculate, defaultCalculate);
    const rate = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.rate, defaults.rate);
    let maxRateCount = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.maxRateCount, defaults.maxRateCount);
    let rateCount = defaults.rateCount;
    let revs_1 = defaults.revs;
    let time_1 = defaults.time;
    let value = defaults.value;
    function setRevs(revs) {
        revs_1 = revs;
        return revs_1;
    }
    function setTime(time) {
        time_1 = time;
        return time_1;
    }
    function setRateCount(count) {
        rateCount = count;
        return rateCount;
    }
    function setMaxRateCount(maxCount) {
        maxRateCount = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(maxCount, defaults.maxRateCount);
        console.log(`maxRateCount: ${maxRateCount}`);
        return maxRateCount;
    }
    function getRevs() {
        return revs_1;
    }
    function getTime() {
        return time_1;
    }
    function getRateCount() {
        return rateCount;
    }
    function getMaxRateCount() {
        return maxRateCount;
    }
    function reset() {
        setRevs(defaults.revs);
        setTime(defaults.time);
        setRateCount(defaults.rateCount);
        value = defaults.value;
        return {
            revs: revs_1,
            time: time_1
        };
    }
    function isRolloverTime(time_2) {
        return time_2 < getTime();
    }
    function isRolloverRevs(revs_2) {
        return revs_2 < getRevs();
    }
    function rollOverTime() {
        return getTime() - maxTime;
    }
    function rollOverRevs() {
        return getRevs() - maxRevs;
    }
    function stillRevs(revs_2) {
        // coasting or not moving
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getRevs(), revs_2);
    }
    function stillTime(time) {
        // multiple transmissions of the same time
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getTime(), time);
    }
    function underRate(time) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(rateCount, maxRateCount)) {
            rateCount = 0;
            return false;
        }
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getTime(), time)) {
            rateCount += 1;
            return true;
        }
        if (time - getTime() < rate) {
            rateCount += 1;
            return true;
        }
        rateCount = 0;
        return false;
    }
    function defaultCalculate(revs_2, time_2) {
        if (getRevs() < 0) setRevs(revs_2); // set initial revs
        if (getTime() < 0) setTime(time_2); // set initial time
        if (underRate(time_2)) return value;
        if (stillRevs(revs_2)) {
            setTime(time_2);
            value = 0;
            return value;
        }
        if (isRolloverTime(time_2)) setTime(rollOverTime());
        if (isRolloverRevs(revs_2)) setRevs(rollOverRevs());
        value = transform((revs_2 - getRevs()) / ((time_2 - getTime()) / resolution));
        setRevs(revs_2);
        setTime(time_2);
        return value;
    }
    return {
        setRevs: setRevs,
        setTime: setTime,
        setRateCount: setRateCount,
        setMaxRateCount: setMaxRateCount,
        getRevs: getRevs,
        getTime: getTime,
        getRateCount: getRateCount,
        getMaxRateCount: getMaxRateCount,
        reset: reset,
        calculate: calculate,
        rollOverTime: rollOverTime,
        rollOverRevs: rollOverRevs
    };
}
function $7264b5afad388097$export$97ac7cca7986975a(args = {}) {
    const defaults = {
        sampleSize: 0,
        rate: 3,
        // [0,1,2,3]
        cutoff: 20,
        maxStillTime: 3000,
        // ms
        status: 'reading',
        statusList: [
            'reading',
            'done'
        ],
        sensor: 'cscs',
        onDone: (x)=>x
    };
    let _sample = [];
    let _sampleSize = defaults.sampleSize;
    let _rate = defaults.rate;
    let _maxStillTime = defaults.maxStillTime;
    let _cutoff = defaults.cutoff;
    let _status = defaults.status;
    const onDone = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.onDone, defaults.onDone);
    const sensor = (0, $c6a9e46ee7e4d896$export$32e504f4cccd6638)(args.sensor, defaults.sensor);
    function getSampleSize() {
        return _sampleSize;
    }
    function getSample() {
        return _sample;
    }
    function getRate() {
        return _rate;
    }
    function getStatus() {
        return _status;
    }
    function getCutoff() {
        return _cutoff;
    }
    function getMaxStillTime(ms) {
        return _maxStillTime;
    }
    function setCutoff(count) {
        _cutoff = count;
    }
    function setMaxStillTime(ms) {
        _maxStillTime = ms;
    }
    function reset() {
        _sample = [];
        _sampleSize = defaults.sampleSize;
        _rate = defaults.rate;
        _status = defaults.status;
    }
    function isDone() {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(_status, 'done');
    }
    function timestampAvgDiff(sample) {
        return sample.reduce(function(acc, x, i, xs) {
            let tsd = 1000;
            if (i > 0) tsd = xs[i].ts - xs[i - 1].ts;
            acc += (tsd - acc) / (i + 1);
            return acc;
        }, 0);
    }
    function calculate(sample) {
        const tsAvgDiff = timestampAvgDiff(sample);
        const maxRateCount = (0, $c6a9e46ee7e4d896$export$7d15b64cf5a3a4c4)(2, 15, Math.round(_maxStillTime / tsAvgDiff) - 1);
        console.log(`rateAdjuster :on ${sensor} :tsAvgDiff ${tsAvgDiff} :result ${maxRateCount}`);
        return maxRateCount;
    }
    function update(value) {
        if (isDone()) return;
        _sample.push(value);
        _sampleSize += 1;
        if (_sampleSize >= _cutoff) {
            _status = 'done';
            _rate = calculate(_sample);
            onDone(_rate);
        }
    }
    return Object.freeze({
        getSampleSize: getSampleSize,
        getSample: getSample,
        getRate: getRate,
        getStatus: getStatus,
        getCutoff: getCutoff,
        getMaxStillTime: getMaxStillTime,
        setCutoff: setCutoff,
        setMaxStillTime: setMaxStillTime,
        reset: reset,
        isDone: isDone,
        timestampAvgDiff: timestampAvgDiff,
        calculate: calculate,
        update: update
    });
}


function $87d25c5fd90058a7$var$SensorData(args = {}) {
    const definitions = {
        sensorCount: {
            size: 2,
            resolution: 1,
            unit: '',
            min: 0,
            max: 32767
        },
        currentSaturatedHemoglobin: {
            size: 2,
            resolution: 0.1,
            unit: '%',
            min: 0,
            max: 1000
        },
        previousSaturatedHemoglobin: {
            size: 2,
            resolution: 0.1,
            unit: '%',
            min: 0,
            max: 1000
        },
        totalHemoglobinSaturation: {
            size: 2,
            resolution: 0.01,
            unit: 'g/dl',
            min: 0,
            max: 4000
        },
        requestTimeSetBit: {
            size: 1,
            resolution: 1,
            unit: '',
            min: 0,
            max: 1
        }
    };
    const spec = (0, $7264b5afad388097$export$6298b650a59e6ea5)({
        definitions: definitions
    });
    function encode(args = {}) {
        throw new Error("SmOS SensorData.encode is not yet implemented!");
    }
    // Example:
    //
    // (0x) CB-06- 15-02- 16-02- C0-04 -00
    //      1739   533    534    1216   0
    //
    // (0x) CC-06- 12-02- 12-02- C1-04 -00
    //      1740   530    530    1217   0
    //
    // (0x) CD-06- 12-02- 12-02- C1-04 -00
    //      1741   530    530    1217   0
    //
    // (0x) CE-06- 13-02- 12-02- C1-04 -00
    //      1742   531    530    1217   0
    //
    // (0x) CF-06- 14-02- 13-02- C1-04 -00
    //      1743   532    531    1217   0
    //
    function decode(dataview) {
        const sensorCount = dataview.getUint16(0, true);
        const currentSaturatedHemoglobin = spec.decodeField('currentSaturatedHemoglobin', dataview.getUint16(2, true));
        const previousSaturatedHemoglobin = spec.decodeField('previousSaturatedHemoglobin', dataview.getUint16(4, true));
        const totalHemoglobinSaturation = spec.decodeField('totalHemoglobinSaturation', dataview.getUint16(6, true));
        const requestTimeSetBit = dataview.getUint8(8, true);
        return {
            sensorCount: sensorCount,
            currentSaturatedHemoglobin: currentSaturatedHemoglobin,
            previousSaturatedHemoglobin: previousSaturatedHemoglobin,
            totalHemoglobinSaturation: totalHemoglobinSaturation,
            requestTimeSetBit: requestTimeSetBit
        };
    }
    return Object.freeze({
        encode: encode,
        decode: decode
    });
}
function $87d25c5fd90058a7$var$DeviceControl(args = {}) {
    const length = 3;
    const definitions = {
        dataControl: {
            size: 1,
            resolution: 1,
            unit: '',
            min: 0,
            max: 5
        },
        updateType: {
            size: 1,
            resolution: 1,
            unit: '',
            min: 0,
            max: 5
        }
    };
    const values = {
        dataControl: {
            notIncluded: 0,
            reset: 1,
            markLap: 2,
            start: 3,
            stop: 4,
            clearData: 5
        },
        updateType: {
            'doNotChange': 0,
            '2sDataSmoothing': 1,
            // Default
            '2sNoDataSmoothing': 2,
            '2sDataSmoothing': 3,
            '0.5sNoDataSmoothing': 4,
            '1sDataSmoothing': 5
        },
        antProfile: {
            doNotChange: 0,
            matchExisting: 1,
            matchExisting: 2,
            matchExisting: 3
        },
        antBleSelector: {
            doNotChange: 0,
            antPlus: 1,
            ble: 2,
            both: 3,
            neither: 4
        }
    };
    const defaults = {
        dataControl: values.dataControl.notIncluded,
        updateType: values.updateType.doNotChange,
        antProfile: values.antProfile.doNotChange,
        antBleSelector: values.antBleSelector.doNotChange
    };
    function encode(args = {}) {
        const dataControl = args.dataControl ?? defaults.dataControl;
        const updateType = args.updateType ?? defaults.updateType;
        // Depricated
        const antProfile = defaults.antProfile;
        const antBleSelector = defaults.antBleSelector;
        const compound = (antProfile << 4) + antBleSelector;
        // end Depricated
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        view.setUint8(0, dataControl, true);
        view.setUint8(1, updateType, true);
        view.setUint8(1, compound, true);
        return view.buffer;
    }
    function decode(dataview) {
        throw new Error("SmO2 DeviceControl.decode is not yet implemented!");
    }
    return Object.freeze({
        encode: encode,
        decode: decode,
        length: length,
        definitions: definitions,
        values: values,
        defaults: defaults
    });
}
const $87d25c5fd90058a7$export$8962ea274a4171c1 = $87d25c5fd90058a7$var$SensorData();
const $87d25c5fd90058a7$export$127774d0e342727c = $87d25c5fd90058a7$var$DeviceControl();


function $061668052390c0fe$var$SMO2(args = {}) {
    // config
    const onData = args.onData;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'SMO2 needs BluetoothRemoteGATTService!');
    // end config
    // service
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).smo2SensorData,
            notify: {
                callback: onData,
                parser: (0, $87d25c5fd90058a7$export$8962ea274a4171c1)
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        service: gattService
    });
    // end service
    return Object.freeze({
        ...service // SMO2 will have all the public methods and properties of Service
    });
}
var $061668052390c0fe$export$2e2bcd8739ae039 = $061668052390c0fe$var$SMO2;


//
// Core Temp Service
//




//
// Core Body Temperature characteristic
//
const $e6607c10fac3851d$var$skinTemperaturePresent = (flags)=>(flags >> 0 & 1) === 1;
const $e6607c10fac3851d$var$coreReservedPresent = (flags)=>(flags >> 1 & 1) === 1;
const $e6607c10fac3851d$var$qualityAndStatePresent = (flags)=>(flags >> 2 & 1) === 1;
const $e6607c10fac3851d$var$heartRatePresent = (flags)=>(flags >> 4 & 1) === 1;
const $e6607c10fac3851d$var$Flags = {
    skinTemperature: {
        bit: 0,
        values: [
            'notPresent',
            'present'
        ]
    },
    coreReserved: {
        bit: 1,
        values: [
            'notPresent',
            'present'
        ]
    },
    qualityAndState: {
        bit: 2,
        values: [
            'notPresent',
            'present'
        ]
    },
    temperatureUnit: {
        bit: 3,
        values: [
            'C',
            'F'
        ]
    },
    heartRate: {
        bit: 4,
        values: [
            'notPresent',
            'present'
        ]
    }
};
const $e6607c10fac3851d$var$Fields = {
    flags: {
        resolution: 1,
        size: 1,
        type: 'Uint8',
        present: (_)=>true
    },
    coreBodyTemperature: {
        resolution: 0.01,
        size: 2,
        type: 'Int16',
        invalid: 0x7FFF,
        present: (_)=>true
    },
    skinTemperature: {
        resolution: 0.01,
        size: 2,
        type: 'Int16',
        present: $e6607c10fac3851d$var$skinTemperaturePresent
    },
    coreReserved: {
        resolution: 1,
        size: 2,
        type: 'Int16',
        present: $e6607c10fac3851d$var$coreReservedPresent
    },
    qualityAndState: {
        resolution: 1,
        size: 1,
        type: 'Uint8',
        present: $e6607c10fac3851d$var$qualityAndStatePresent
    },
    heartRate: {
        resolution: 1,
        size: 1,
        type: 'Uint8',
        present: $e6607c10fac3851d$var$heartRatePresent
    }
};
const $e6607c10fac3851d$var$order = [
    'flags',
    'coreBodyTemperature',
    'skinTemperature',
    'coreReserved',
    'qualityAndState',
    'heartRate'
];
const $e6607c10fac3851d$var$QualityAndState = {};
function $e6607c10fac3851d$export$a8ded2711963d8e6(args = {}) {
    const architecture = true;
    function getField(field, dataview, i) {
        return dataview[`get${field.type}`](i, architecture) * field.resolution;
    }
    function fahrenheitToCelsius(fahrenheit) {
        return Math.round(5 / 9 * (fahrenheit - 32) * 100) / 100;
    }
    function celsiusToFahrenheit(celsius) {
        return Math.round((celsius * 9 / 5 + 32) * 100) / 100;
    }
    // Int -> String
    function readTemperatureUnit(flags) {
        return (flags >> 3 & 1) === 0 ? 'C' : 'F';
    }
    // Example 1:
    // core body temperature, 38.12
    // skin temperature, 38.47
    //
    // [0b00000001, 228,   14,    7,   15,]
    // [0x01,      0xe4, 0x0e, 0x07, 0x0f,]
    //
    // Example 2:
    // core body temperature, 38.12
    // skin temperature, 38.47
    // core reserved, 0
    // quality and state, 011 good, 10 heart rate supported receiveing signal
    // heart rate, 130
    //
    // [0b00010111, 228,   14,    7,   15,    0,    0, 0b00010011, 130]
    // [0x17,      0xE4, 0x0E, 0x07, 0x0F, 0x00, 0x00, 0x13,     , 0x82]
    //
    // Dataview -> {'<field-name>': {value: Number, unit: String}}
    function decode(dataview) {
        const byteLength = dataview.byteLength;
        return $e6607c10fac3851d$var$order.reduce(function(acc, fieldName, i) {
            const field = $e6607c10fac3851d$var$Fields[fieldName];
            if (acc.i + field.size > byteLength) return acc;
            if (field.present(acc.flags)) {
                let value = getField(field, dataview, acc.i);
                const unit = field?.unit ?? '';
                const name = field?.short ?? fieldName;
                if (acc.temperatureUnit === 'F' && (fieldName === 'coreBodyTemperature' || fieldName === 'skinTemperature')) value = fahrenheitToCelsius(value);
                if (acc.i === 0) {
                    acc.flags = value;
                    acc.temperatureUnit = readTemperatureUnit(value);
                } else // acc.data[name] = {value, unit,};
                acc.data[name] = value;
                acc.i += field.size;
            }
            return acc;
        }, {
            i: 0,
            flags: 0,
            data: {}
        }).data;
    }
    function encode(args = {}) {
        const coreBodyTemperature = Math.round(args.coreBodyTemperature / $e6607c10fac3851d$var$Fields.coreBodyTemperature.resolution) ?? $e6607c10fac3851d$var$Fields.coreBodyTemperature.invalid;
        // construct based on what is present in args
        let flags = args.flags ?? 0;
        let length = 3; // depends on flags, min 3, max 9
        if ('temperatureUnit' in args && args.temperatureUnit === 'F') flags = flags | 8;
        if ('skinTemperature' in args) {
            flags = flags | 1;
            length += $e6607c10fac3851d$var$Fields.skinTemperature.size;
        }
        const dataview = new DataView(new ArrayBuffer(length));
        dataview.setUint8(0, flags, architecture);
        dataview.setInt16(1, coreBodyTemperature, architecture);
        if ('skinTemperature' in args) {
            const skinTemperature = Math.round(args.skinTemperature / $e6607c10fac3851d$var$Fields.skinTemperature.resolution);
            dataview.setInt16(3, skinTemperature, architecture);
        }
        return dataview;
    }
    return Object.freeze({
        decode: decode,
        encode: encode,
        fahrenheitToCelsius: fahrenheitToCelsius,
        celsiusToFahrenheit: celsiusToFahrenheit
    });
}
const $e6607c10fac3851d$export$1078d7c43041691e = $e6607c10fac3851d$export$a8ded2711963d8e6();


function $30c1e89f09778235$var$CoreTemp(args = {}) {
    // config
    const onData = args.onData;
    // BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }
    const gattService = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.service, 'CoreTemp needs BluetoothRemoteGATTService!');
    // end config
    // service
    const spec = {
        measurement: {
            uuid: (0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).coreBodyTemp,
            notify: {
                callback: onData,
                parser: (0, $e6607c10fac3851d$export$1078d7c43041691e)
            }
        }
    };
    const service = (0, $97c3323ad61e1e5e$export$8b2af884909d32a5)({
        spec: spec,
        service: gattService
    });
    // end service
    return Object.freeze({
        ...service // CoreTemp will have all the public methods and properties of Service
    });
}
var $30c1e89f09778235$export$2e2bcd8739ae039 = $30c1e89f09778235$var$CoreTemp;




// TODO:
// - in the watch() method handle:
//     - getDevices() fail,
//     - the device not being in devices.
// - in the setup() method and services object add the ability to work with multiple
//   services start and stop them on demand, and switch between them dynamically
// Usage:
//
// Case 1: Connect unknown number of devices or multiple devices
// of the same device type (power meters, heart rate monitors).
// Here the device is being requested from client code and passed
// as option to the construtor function:
//
// const filter = {filters: [
//     {services: [uuids.heartRate]},
//     {services: [uuids.cyclingPower]},
// ]};
// const device = await navigator.bluetooth.requestDevice(filter);
// const connectable = Connectable({device});
// await connectable.connect();
//
// Case 2: Connect devices by Device Category
// Here we are going to have a predetermined set of devices that we are interested in.
// We care to connect only one device per device type: power meter, heart rate monitor
// The client code creates a strict filter and passes it as configuration option to
// the function constructor:
//
// const heartRateMonitorFilter = {filters: [{services: [uuids.heartRate]}]};
// const heartRateMonitor = Connectable({filter: heartRateMonitorFilter});
// await heartRateMonitor.connect();
//
// const powerMeterFilter = {filters: [{services: [uuids.cyclingPower]}]};
// const powerMeter = Connectable({filter: powerMeterFilter});
// await powerMeter.connect();
//
function $0bbce9dda137ce4d$var$Connectable(args = {}) {
    const defaults = {
        name: 'Unknown',
        filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.all()
    };
    //
    // Config
    //
    // the following values can be optionally configured if not they will use the
    // their default values.
    // this is the device filter for requestDevice.
    // The default value will look for any bluetooth device.
    //
    // {}
    const filter = args.filter ?? defaults.filter;
    // setup(), method will be executed by the end of the connection procedure,
    // It will try to determine the deviceType of the device based on what services
    // are present there and it will initialize those services.
    // Extend the method if you want to add support for new Services.
    // Overwrite the method if you want to implement each device separetly.
    //
    // Function
    const setup = args.setup ?? defaultSetup;
    // Connection callbacks
    // the defaults only log, but they are composed with corresponding optional
    // callbacks
    //
    // Function
    const onConnecting = (0, $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30)(args.onConnecting ?? ((x)=>x), defaultOnConnecting);
    const onConnected = (0, $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30)(args.onConnected ?? ((x)=>x), defaultOnConnected);
    const onConnectFail = (0, $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30)(args.onConnectFail ?? ((x)=>x), defaultOnConnectFail);
    const onDisconnect = (0, $c6a9e46ee7e4d896$export$3f77d4ba3adcbe30)(args.onDisconnect ?? ((x)=>x), defaultOnDisconnect);
    // Characteristics notify/indicate callbacks
    // onData(), will be attached to the each service measurement characteristic
    // it will return data like power, heartRate, etc. in an object called with
    // structure: {power?: Int, heartRate?: Int, ...}
    // note that each object will have different contents based on what
    // data is included in the message being decoded.
    //
    // Function
    const onData = args.onData ?? defaultOnData;
    // onControl(), will be attached to the each service control characteristic
    // if one is present and has a notify property.
    // It will return object from the decoded message.
    // The parser that decodes the message is configured on the Service factory.
    //
    // Function
    const onControl = args.onControl ?? defaultOnControl;
    // default callback implementations
    // Void -> Void
    function defaultOnConnecting() {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connecting: to: ${getName()} ...`);
    }
    // Void -> Void
    function defaultOnConnected() {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connected: to: ${getName()} ${getDeviceType()}`);
    }
    // Void -> Void
    function defaultOnConnectFail() {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connection-fail: from: ${getName()}`);
    }
    // Void -> Void
    function defaultOnDisconnect() {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: disconnected: from: ${getName()}`);
    }
    // {} -> Void
    function defaultOnData(msg) {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: rx: from: ${getName()} `, msg);
    }
    // {} -> Void
    function defaultOnControl(msg) {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: rx: from: ${getName()} `, msg);
    }
    // end default callback implementations
    //
    // End Config
    //
    //
    // State
    //
    // public state
    // {'<service-name>': Service}
    let services = {};
    // end public state
    // private state variables, please don't expose them, use the accesor methods
    // BluetoothDevice{
    //     id: String,
    //     name: String,
    //     gatt: BluetoothRemoteGATTServer,
    //     onadvertisementreceived: null,
    //     ongattserverdisconnected: null,
    //     watchingAdvertisements: Bool,
    // }
    let _device = args.device;
    // BluetoothRemoteGATTServer{
    //     device: BluetoothDevice,
    //     connected: Bool
    // }
    let _server;
    // [BluetoothRemoteGATTService{
    //     device: BluetoothDevice,
    //     uuid: String,
    //     isPrimary: Bool,
    // }]
    let _primaryServicesList;
    // {'<service-uuid>': BluetoothRemoteGATTService}
    let _primaryServices;
    let _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).disconnected;
    let _connected = false;
    let _ready = false;
    let _autoReconnect = true;
    let _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).generic;
    let abortController;
    let signal;
    // end private state
    // accesor methods
    function isConnected() {
        return _connected;
    }
    function isReady() {
        return _ready;
    }
    function getName() {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(_device) ? _device.name : defaults.name;
    }
    function getId() {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(_device) ? _device.id : undefined;
    }
    function getDeviceType() {
        return _deviceType;
    }
    function getSignature() {
        return {
            id: getId(),
            name: getName(),
            deviceType: getDeviceType()
        };
    }
    function getStatus() {
        return _status;
    }
    function setReady(ready) {
        _ready = ready;
    }
    // end accesor methods
    function printServices() {
        _primaryServicesList.forEach((service)=>{
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: service: ${(0, $97c3323ad61e1e5e$export$c9f5068253e7a355)(service)}`);
        });
    }
    // String -> Bool
    function hasService(uuid) {
        return uuid in _primaryServices;
    }
    // String -> BluetoothRemoteGATTService?
    function getService(uuid) {
        return _primaryServices[uuid];
    }
    //
    // methods
    //
    // connect(), can be used in 3 ways to connect to a device
    //
    // - connect({requesting: false, watching: false})
    //   this is the default case, here the raw gatt device has been already requested
    //   and must be passed as config option:
    //
    //   const connectable = Connectable({device: GATTDevice});
    //   connectable.connect();
    //
    // - connect({requesting: true, watching: false})
    //   here we want to request and connect to the device in one step
    //
    //   const connectable = Connectable();
    //   connectable.connect();
    //
    // - connect({requesting: false, watching: true})
    //   here the device is already known and available in the browser web-ble cache
    //   so we want to listen for when it becomes availbale again. This is used to
    //   recover devices that have droped.
    //
    async function connect(args = {}) {
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getStatus(), (0, $21d6c30d826f68a8$export$96e9906d6d93a972).connecting) || (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(getStatus(), (0, $21d6c30d826f68a8$export$96e9906d6d93a972).connected)) return;
        const requesting = args.requesting ?? false;
        const watching = args.watching ?? false;
        // guard
        // stop execution on missuse and notify the developer
        if (!requesting && !watching && !(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(_device)) {
            // can't be watching or requesting if device is not passed as config
            console.error(`ble: connectable: 'watching false and requesting false requires a gatt device to be passed as config to Connectable!'`);
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).makeCoffee();
        }
        if (requesting && watching) {
            // can't be watching and requesting at the same time
            console.error(`ble: connectable: 'can't be requesting and watching for a devices at the same time pick one!'`);
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).callKarenFromHR();
            return;
        }
        // end guard
        abortController = new AbortController();
        signal = {
            signal: abortController.signal
        };
        _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).connecting;
        onConnecting();
        try {
            if (watching) _device = await watch(_device.id);
            if (requesting) _device = await request();
            _server = await _device.gatt.connect();
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: gatt: connected: to: ${getName()} 'setting up ...'`);
            _primaryServicesList = await _server.getPrimaryServices();
            _primaryServices = (0, $97c3323ad61e1e5e$export$19cb70ee18e2ac77)(_primaryServicesList);
            _connected = true;
            _autoReconnect = true;
            _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).connected;
            _device.addEventListener('gattserverdisconnected', _onDisconnect, signal);
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: gatt: services: of: ${getName()}`);
            printServices();
            let resSetup = await setup();
            // calling the connected callback last, because only at that point
            // the device is usable.
            onConnected();
        } catch (e) {
            _connected = false;
            _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).disconnected;
            onConnectFail(e);
            console.warn(e);
        }
    }
    // request a device by using the configured filter
    // can throw an error handle it outside
    //
    // Void -> GATTDevice?
    async function request() {
        const device = await navigator.bluetooth.requestDevice(filter);
        return device;
    }
    // Int -> GATTDevice?
    async function watch(deviceId) {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: watching: advertisements: for: ${deviceId}`);
        const devices = await navigator.bluetooth.getDevices();
        const device = devices.find((device)=>device.id === deviceId);
        let resolve;
        let reject;
        const maybeDevice = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        const timeout = 60000; // 60s
        const timeoutId = setTimeout(function() {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: watch: timeout:`);
            abortController.abort();
            reject();
        }, timeout);
        const abortController = new AbortController();
        device.addEventListener('advertisementreceived', onAdvertisementReceived, {
            signal: abortController.signal,
            once: true
        });
        async function onAdvertisementReceived(e) {
            abortController.abort();
            clearTimeout(timeoutId);
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: watch: advertisement: received:`);
            resolve(e.device);
        }
        await device.watchAdvertisements({
            signal: abortController.signal
        });
        return maybeDevice;
    }
    async function disconnect() {
        if (!_connected) return;
        _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).disconnecting;
        // TODO: implement Disconnecting
        onConnecting();
        if (services?.trainer?.reset ?? false) {
            let res = await services.trainer.reset();
        }
        for(let key in services)await services[key].stop();
        _connected = false;
        _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).disconnected;
        _autoReconnect = false;
        abortController.abort();
        const res = await _device.gatt.disconnect();
        onDisconnect();
    }
    function _onDisconnect() {
        _status = (0, $21d6c30d826f68a8$export$96e9906d6d93a972).disconnected;
        onDisconnect();
        if (_autoReconnect) onDropout();
    }
    async function onDropout() {
        (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).warn(`ble: dropout: ${_device.name}`);
        if (watchAdvertisementsSupported()) connect({
            watching: true,
            requesting: false
        });
        else {
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`:connectable 'watchAdvertisements not supported falling back to device.connect ${_device.name}'`);
            connect({
                watching: false,
                requesting: false
            });
        }
    }
    function watchAdvertisementsSupported() {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(_device.watchAdvertisements);
    }
    // check what services got collected from the device
    // execute a fallthrough logic to determine:
    // - deviceType
    // - setup Services by linking them to data callbacks
    //   and the raw gattService object
    async function defaultSetup() {
        const hasFTMS = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fitnessMachine);
        const hasFEC = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fec);
        const hasWCPS = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).wahooFitnessMachine);
        const hasPower = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).cyclingPower);
        const hasCadence = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).speedCadence);
        const hasHeartRate = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).heartRate);
        const hasBattery = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).battery);
        const hasRaceController = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).raceController);
        const hasSmo2 = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).smo2);
        const hasCoreTemp = hasService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).coreTemp);
        const hasTrainerControl = hasFTMS || hasWCPS || hasFEC;
        // Order here is important
        if (hasBattery) {
            services['bas'] = (0, $c64fc57441e42a7b$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).battery),
                onData: onData
            });
            let res = await services.bas.setup();
            services.bas.readBatteryLevel();
        // always continue
        }
        if (hasHeartRate) {
            // heart rate
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).heartRateMonitor;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()} `);
            services['hrs'] = (0, $d5413625f9559e1f$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).heartRate),
                onData: onData
            });
            let res = await services.hrs.setup();
            // NOTE: we don't return here because:
            // - the Tickr X has a CSC service too
            // - the Zwift Hub has FTMS
            if (!(hasCadence || hasTrainerControl)) return res;
        }
        if (hasTrainerControl) {
            // controllable
            //
            // Here we are determining which trainer control service the device
            // supports and we initialize it. We can initialize only one if more are
            // present else the device could fail (Tacx), so we do early return.
            // The supported control services are FTMS, FEC and WCPS.
            // There choosen one will be called 'trainer' and assigned to services.
            //
            // We don't want more than one control service to be initialized, because
            // on many trainers they will clash and this results in resistance jumping
            // between both services. This is resolved only by power cycling the
            // trainer and reconnecting again.
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).controllable;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()}`);
            if (hasFTMS) {
                services['trainer'] = (0, $ee8aec6b20c39b4f$export$2e2bcd8739ae039)({
                    service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fitnessMachine),
                    onData: onData
                });
                let res = await services.trainer.setup();
                return res;
            }
            if (hasFEC) {
                services['trainer'] = (0, $920c8ecd383ec8b2$export$2e2bcd8739ae039)({
                    service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).fec),
                    onData: onData
                });
                let res = await services.trainer.setup();
                return res;
            }
            if (hasWCPS) {
                services['trainer'] = (0, $2b51732e8014f04e$export$2e2bcd8739ae039)({
                    service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).cyclingPower),
                    onData: onData
                });
                let res = await services.trainer.setup();
                return res;
            }
        }
        if (hasPower) {
            // power meter
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).powerMeter;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()}`);
            services['cps'] = (0, $c6a357b188d73f5f$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).cyclingPower),
                onData: onData
            });
            let res = await services.cps.setup();
            return res;
        }
        if (hasRaceController) {
            // zwift click or play
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).raceController;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()}`);
            services['rcs'] = (0, $2cf053fd3c49c3e6$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).raceController),
                onData: onData
            });
            let res = await services.rcs.setup();
            return res;
        }
        if (hasSmo2) {
            // SmO2
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).smo2;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()}`);
            services['smo2'] = (0, $061668052390c0fe$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).smo2),
                onData: onData
            });
            let res = await services.smo2.setup();
            return res;
        }
        if (hasCoreTemp) {
            // CoreTemp
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).coreTemp;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()}`);
            services['coreTemp'] = (0, $30c1e89f09778235$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).coreTemp),
                onData: onData
            });
            let res = await services.coreTemp.setup();
            return res;
        }
        if (hasCadence) {
            // cadence
            _deviceType = (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).speedCadenceSensor;
            (0, $c6a9e46ee7e4d896$export$c2d084dc44961371).log(`ble: connectable: setup: ${getDeviceType()}`);
            services['cscs'] = (0, $91e28be2869b7451$export$2e2bcd8739ae039)({
                service: getService((0, $5f192bdbcf8caac3$export$8bc6870d73ba12c7).speedCadence),
                onData: onData
            });
            let res = await services.cscs.setup();
            return res;
        }
        // NOTE: if we reach this point the device doesn't have the advertized
        // services or is not supported at all. This is a developer error.
        // Either the filters are wrong or the remote device is advertising wrong.
        // In any case we can't continue using the device.
        // If we throw an error here the device will disconnect and the User
        // won't know why.
        // So this case must be handled in the UI and the method simply returns false.
        console.warn(`ble: connectable: setup: ${getName()} fail: 'this device doesn't have a supported service!`);
        return false;
    }
    async function setupService(args = {}) {
        const name = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.name, 'connectable.setupService needs name: String');
        const struct = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.struct, `connectable.setupService needs struct: Function.`);
        const uuid = (0, $c6a9e46ee7e4d896$export$3570f33b1a1f3329)(args.uuid, `connectable.setupService needs service uuid: UUID.`);
        services[name] = struct({
            service: getService(uuid),
            onData: onData
        });
        let res = await services[name].setup();
        return res;
    }
    // expose public methods and properties
    return {
        connect: connect,
        disconnect: disconnect,
        request: request,
        watch: watch,
        hasService: hasService,
        getService: getService,
        getName: getName,
        getId: getId,
        getDeviceType: getDeviceType,
        getSignature: getSignature,
        getStatus: getStatus,
        isConnected: isConnected,
        isReady: isReady,
        setReady: setReady,
        services: services
    };
}
var $0bbce9dda137ce4d$export$2e2bcd8739ae039 = $0bbce9dda137ce4d$var$Connectable;




function $62e3927cdcf885a0$var$ReactiveConnectable(args = {}) {
    // config
    const deviceType = args.deviceType ?? (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).generic;
    const filter = args.filter ?? (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.generic();
    const identifier = `ble:${deviceType}`;
    const connectable = (0, $0bbce9dda137ce4d$export$2e2bcd8739ae039)({
        filter: filter,
        onData: onData,
        onConnecting: onConnecting,
        onConnected: onConnected,
        onDisconnect: onDisconnect,
        onConnectFail: onConnectFail
    });
    // end config
    // state
    let mode = (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg;
    let abortController;
    let signal;
    // end state
    function getIdentifier() {
        return identifier;
    }
    function onConnecting() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:connecting`);
    }
    function onConnected() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:connected`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:name`, connectable.getName());
    }
    function onDisconnect() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:disconnected`);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:name`, '--');
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('power', getIdentifier())) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`power`, 0);
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('cadence', getIdentifier())) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`cadence`, 0);
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('speed', getIdentifier())) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`speed`, 0);
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('heartRate', getIdentifier())) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`heartRate`, 0);
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('smo2', getIdentifier())) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`smo2`, 0);
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('thb', getIdentifier())) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`thb`, 0);
        if ((0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('coreBodyTemperature', getIdentifier())) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`coreBodyTemperature`, 0);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`skinTemperature`, 0);
        }
    }
    function onConnectFail() {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:disconnected`);
    }
    function onData(data) {
        if ('power' in data && (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('power', identifier)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`power`, data.power);
        if ('cadence' in data && (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('cadence', identifier)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`cadence`, data.cadence);
        if ('speed' in data && (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('speed', identifier)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`speed`, (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).speed.kmhToMps(data.speed));
        if ('heartRate' in data && (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).sources.isSource('heartRate', identifier)) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`heartRate`, data.heartRate);
            if ('rrInterval' in data) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`rrInterval`, data.rrInterval);
        }
        if ('batteryLevel' in data) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`${getIdentifier()}:batteryLevel`, data.batteryLevel);
            console.log(`:ble :device ${connectable.getName()} ${getIdentifier()} :battery-level ${data.batteryLevel}`);
        }
        if ('currentSaturatedHemoglobin' in data) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`smo2`, data.currentSaturatedHemoglobin);
        if ('totalHemoglobinSaturation' in data) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`thb`, data.totalHemoglobinSaturation);
        if ('coreBodyTemperature' in data) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`coreBodyTemperature`, data.coreBodyTemperature);
        if ('skinTemperature' in data) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`skinTemperature`, data.skinTemperature);
    }
    async function onSwitch() {
        if (connectable.isConnected()) connectable.disconnect();
        else connectable.connect({
            requesting: true
        });
    }
    function onMode(x) {
        mode = x;
    }
    function onUserWeight(x) {
        if (!connectable.isConnected()) return;
    }
    function onPowerTarget(powerTarget) {
        if (!connectable.isConnected() || !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg)) return;
        connectable.services.trainer.setPowerTarget({
            power: powerTarget
        });
    }
    function onResistanceTarget(resistanceTarget) {
        if (!connectable.isConnected() || !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).resistance)) return;
        connectable.services.trainer.setResistanceTarget({
            resistance: resistanceTarget
        });
    }
    function onSlopeTarget(slopeTarget) {
        if (!connectable.isConnected() || !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim)) return;
        connectable.services.trainer.setSimulation({
            grade: slopeTarget
        });
    }
    function onTrainerReset() {
        if (!connectable.isConnected() || !(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(connectable.services?.trainer?.reset)) return;
        connectable.services.trainer.reset();
    }
    function start() {
        abortController = new AbortController();
        signal = {
            signal: abortController.signal
        };
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`ui:${getIdentifier()}:switch`, onSwitch, signal);
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(deviceType, (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).controllable)) {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:mode', onMode, signal);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:weight', onUserWeight, signal);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:powerTarget', onPowerTarget, signal);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:resistanceTarget', onResistanceTarget, signal);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:slopeTarget', onSlopeTarget, signal);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('ui:trainer:reset', onTrainerReset, signal);
        }
    }
    function stop() {
        abortController.abort();
    }
    start();
    return Object.freeze({
        getIdentifier: getIdentifier,
        start: start,
        stop: stop,
        ...connectable
    });
}
var $62e3927cdcf885a0$export$2e2bcd8739ae039 = $62e3927cdcf885a0$var$ReactiveConnectable;




const $efa19655a92b0220$var$controllable = (0, $62e3927cdcf885a0$export$2e2bcd8739ae039)({
    deviceType: (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).controllable,
    filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.controllable()
});
const $efa19655a92b0220$var$speedCadenceSensor = (0, $62e3927cdcf885a0$export$2e2bcd8739ae039)({
    deviceType: (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).speedCadenceSensor,
    filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.speedCadenceSensor()
});
const $efa19655a92b0220$var$heartRateMonitor = (0, $62e3927cdcf885a0$export$2e2bcd8739ae039)({
    deviceType: (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).heartRateMonitor,
    filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.heartRateMonitor()
});
const $efa19655a92b0220$var$powerMeter = (0, $62e3927cdcf885a0$export$2e2bcd8739ae039)({
    deviceType: (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).powerMeter,
    filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.powerMeter()
});
const $efa19655a92b0220$var$moxy = (0, $62e3927cdcf885a0$export$2e2bcd8739ae039)({
    deviceType: (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).smo2,
    filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.smo2()
});
const $efa19655a92b0220$var$coreTemp = (0, $62e3927cdcf885a0$export$2e2bcd8739ae039)({
    deviceType: (0, $21d6c30d826f68a8$export$8215d14a63d9fb10).coreTemp,
    filter: (0, $5f192bdbcf8caac3$export$961dfcffa9c52590).filters.coreTemp()
}); // export {
 //     controllabe,
 //     heartRateMonitor,
 //     powerMeter,
 //     speedCadenceSensor,
 // };







var $f2a33a33b0895ab8$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $f2a33a33b0895ab8$var$url = new URL(import.meta.resolve("ffPfH"));
$f2a33a33b0895ab8$exports = $56b621a6dd25b2cb$exports($f2a33a33b0895ab8$var$url.toString(), $f2a33a33b0895ab8$var$url.origin, true);


// const timer = new Worker('./timer.js');
const $be7ac4e15077640d$var$timer = new Worker($f2a33a33b0895ab8$exports);
class $be7ac4e15077640d$var$Watch {
    constructor(args){
        this.elapsed = 0;
        this.lapTime = 0;
        this.stepTime = 0;
        this.intervalIndex = 0;
        this.stepIndex = 0;
        this.intervalDuration = 0;
        this.stepDuration = 0;
        this.state = "stopped";
        this.stateWorkout = "stopped";
        // Distance
        this.intervalType = "duration";
        // end Distance
        this.intervals = [];
        this.workoutType = "workout";
        this.autoStartCounter = 3;
        this.autoPauseCounter = 0;
        this.hasBeenAutoPaused = false;
        this.autoPause = true;
        this.autoStart = true;
        this.init();
    }
    init() {
        const self = this;
        // Data subs
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:elapsed", (elapsed)=>{
            self.elapsed = elapsed;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:lapTime", (time)=>{
            self.lapTime = time;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:stepTime", (time)=>{
            self.stepTime = time;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:intervalDuration", (time)=>{
            self.lapDuration = time;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:stepDuration", (time)=>{
            self.stepDuration = time;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:intervalIndex", (index)=>{
            self.intervalIndex = index;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:stepIndex", (index)=>{
            self.stepIndex = index;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:watchStatus", (state)=>{
            self.state = state;
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:workoutStatus", (state)=>{
            self.stateWorkout = state;
            if (self.isWorkoutDone()) {
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lap");
                // reset to slope mode 0% when workout is done
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:slope-target-set", 0);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:mode-set", (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim);
                console.log(`Workout done!`);
            }
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:workout", (workout)=>{
            self.intervals = workout.intervals;
            if (workout.meta.category?.toLowerCase().includes("test")) {
                self.workoutType = "test";
                // force turn off auto pausing for Test Category workouts
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`sources`, {
                    autoPause: false
                });
            } else self.workoutType = "workout";
            console.log(`:workout :type ${self.workoutType}`);
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:power1s", self.onPower1s.bind(this));
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("db:sources", self.onSources.bind(this));
        $be7ac4e15077640d$var$timer.addEventListener("message", self.onTick.bind(self));
        // UI subs
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:workoutStart", (e)=>{
            self.startWorkout();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:watchStart", (e)=>{
            self.start();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("workout:restore", (e)=>{
            self.restoreWorkout();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:watchPause", (e)=>{
            self.pause();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:watchResume", (e)=>{
            self.resume();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:watchLap", (e)=>{
            self.lap();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:watchBack", (e)=>{
            self.back();
        });
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub("ui:watchStop", (e)=>{
            const stop = confirm("Confirm Stop?");
            if (stop) self.stop();
        });
    }
    isStarted() {
        return this.state === "started";
    }
    isPaused() {
        return this.state === "paused";
    }
    isStopped() {
        return this.state === "stopped";
    }
    isWorkoutStarted() {
        return this.stateWorkout === "started";
    }
    isWorkoutDone() {
        return this.stateWorkout === "done";
    }
    isIntervalType(type) {
        return (0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(this.intervalType, type);
    }
    status() {
        return this.state;
    }
    onSources(value) {
        this.autoPause = value.autoPause ?? this.autoPause;
        this.autoStart = value.autoStart ?? this.autoStart;
    }
    onPower1s(power) {
        if (this.autoPause) {
            if (power === 0 && this.isStarted()) this.autoPauseCounter += 1;
            else this.autoPauseCounter = 0;
            if (this.autoPauseCounter >= 4) {
                this.autoPauseCounter = 0;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:watchPause`);
                this.hasBeenAutoPaused = true;
            }
            if (power > 40 && this.hasBeenAutoPaused) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:watchResume`);
        }
        if (this.autoStart && this.isStopped()) {
            // check
            if (this.autoStartCounter < 0) return;
            if (this.autoStartCounter === 0) {
                this.autoStartCounter = -1;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:watchStart`);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:workoutStart");
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:autoStartCounter`, -1);
                return;
            }
            // update
            if (power === 0) {
                this.autoStartCounter = 3;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:autoStartCounter`, this.autoStartCounter);
            }
            if (power > 40) {
                this.autoStartCounter -= 1;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:autoStartCounter`, this.autoStartCounter);
            }
        }
    }
    start() {
        const self = this;
        if (self.isStarted() && !self.isWorkoutStarted()) self.pause();
        else {
            $be7ac4e15077640d$var$timer.postMessage("start");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:started");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:event", {
                timestamp: Date.now(),
                type: (0, $9a46339c5268bef7$export$3d7865934588d77e).start
            });
        }
    }
    startWorkout() {
        const self = this;
        // in case of pressing play button during auto start countdown
        this.autoStartCounter = -1;
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:autoStartCounter`, -1);
        if (self.isWorkoutStarted() || // check for intervalIndex allows for multiple workouts in one session
        self.isWorkoutDone() && self.intervalIndex > 0) return;
        let intervalTime = 0;
        let stepTime = 0;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(self.intervals)) {
            intervalTime = self.intervals[0]?.duration ?? 0;
            stepTime = self.intervals[0]?.steps[0].duration ?? 0;
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:intervalIndex", 0);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepIndex", 0);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("workout:started");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:intervalDuration", intervalTime);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepDuration", stepTime);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lapTime", intervalTime);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepTime", stepTime);
        }
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(self.points)) self.intervalType = "distance";
        if (!self.isStarted()) self.start();
    }
    restoreWorkout() {
        const self = this;
        if (self.isWorkoutStarted()) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("workout:started");
        if (self.isStarted()) self.pause();
    }
    resume() {
        const self = this;
        if (!self.isStarted()) {
            $be7ac4e15077640d$var$timer.postMessage("start");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:started");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:event", {
                timestamp: Date.now(),
                type: (0, $9a46339c5268bef7$export$3d7865934588d77e).start
            });
            this.hasBeenAutoPaused = false;
        }
    }
    pause() {
        const self = this;
        $be7ac4e15077640d$var$timer.postMessage("pause");
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:paused");
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:event", {
            timestamp: Date.now(),
            type: (0, $9a46339c5268bef7$export$3d7865934588d77e).stop
        });
    }
    stop() {
        const self = this;
        if (self.isStarted() || self.isPaused()) {
            $be7ac4e15077640d$var$timer.postMessage("stop");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:event", {
                timestamp: Date.now(),
                type: (0, $9a46339c5268bef7$export$3d7865934588d77e).stop
            });
            if (self.isWorkoutStarted()) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("workout:stopped");
            self.lap();
            // should be called after event and lap are created
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stopped");
            if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(self.intervals)) {
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:intervalIndex", 0);
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepIndex", 0);
            }
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:elapsed", 0);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lapTime", 0);
        }
    }
    onTick() {
        const self = this;
        let elapsed = self.elapsed + 1;
        let lapTime = self.lapTime;
        let stepTime = self.stepTime;
        if (self.isWorkoutStarted() && !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(self.stepTime, 0)) {
            lapTime -= 1;
            stepTime -= 1;
        } else lapTime += 1;
        if ((0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(lapTime, 4) && stepTime > 0) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:beep", "interval");
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:elapsed", elapsed);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lapTime", lapTime);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepTime", stepTime);
        if (self.isWorkoutStarted() && stepTime <= 0 && this.isIntervalType("duration")) self.step();
    }
    lap() {
        const self = this;
        if (self.isWorkoutStarted()) {
            let i = self.intervalIndex;
            let s = self.stepIndex;
            let intervals = self.intervals;
            let moreIntervals = i < intervals.length - 1;
            if (moreIntervals) {
                i += 1;
                s = 0;
                self.nextInterval(intervals, i, s);
                self.nextStep(intervals, i, s);
            } else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("workout:done");
        } else {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lap");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lapTime", 0);
        }
    }
    step() {
        const self = this;
        let i = self.intervalIndex;
        let s = self.stepIndex;
        let intervals = self.intervals;
        let steps = intervals[i].steps;
        let moreIntervals = i < intervals.length - 1;
        let moreSteps = s < steps.length - 1;
        if (moreSteps) {
            s += 1;
            self.nextStep(intervals, i, s);
        } else if (moreIntervals) {
            i += 1;
            s = 0;
            self.nextInterval(intervals, i, s);
            self.nextStep(intervals, i, s);
        } else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("workout:done");
    }
    nextInterval(intervals, intervalIndex, stepIndex) {
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(intervals[intervalIndex].duration)) return this.nextDurationInterval(intervals, intervalIndex, stepIndex);
        return undefined;
    }
    nextStep(intervals, intervalIndex, stepIndex) {
        if (this.isDurationStep(intervals, intervalIndex, stepIndex)) {
            this.intervalType = "duration";
            return this.nextDurationStep(intervals, intervalIndex, stepIndex);
        }
        return undefined;
    }
    back() {
        const self = this;
        if (self.isWorkoutStarted()) {
            let i = self.intervalIndex;
            let s = self.stepIndex;
            let currentInterval = self.intervals[i];
            let duration = currentInterval?.duration ?? 0;
            let intervalElapsed = duration - self.lapTime;
            let intervals = self.intervals;
            let lessIntervals = i - 1 >= 0;
            if (lessIntervals) {
                i = intervalElapsed > 4 ? i : i - 1;
                s = 0;
                self.nextInterval(intervals, i, s);
                console.log(`interval = ${JSON.stringify(intervals[i])}`);
                self.nextStep(intervals, i, s);
            } else {
                console.log("At first interval, resetting step to 0");
                i = 0;
                s = 0;
                self.nextInterval(intervals, i, s);
                console.log(`interval = ${JSON.stringify(intervals[i])}`);
                self.nextStep(intervals, i, s);
            }
        } else {
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lap");
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lapTime", 0);
        }
    }
    isDurationStep(intervals, intervalIndex, stepIndex) {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(intervals[intervalIndex].steps[stepIndex].duration);
    }
    nextDurationInterval(intervals, intervalIndex, stepIndex) {
        const intervalDuration = this.intervalsToDuration(intervals, intervalIndex);
        const stepDuration = this.intervalsToStepDuration(intervals, intervalIndex, stepIndex);
        this.dispatchInterval(intervalDuration, intervalIndex);
    }
    nextDurationStep(intervals, intervalIndex, stepIndex) {
        const stepDuration = this.intervalsToStepDuration(intervals, intervalIndex, stepIndex);
        this.dispatchStep(stepDuration, stepIndex);
    }
    intervalsToDuration(intervals, intervalIndex) {
        return intervals[intervalIndex].duration;
    }
    intervalsToStepDuration(intervals, intervalIndex, stepIndex) {
        const steps = intervals[intervalIndex].steps;
        return steps[stepIndex].duration;
    }
    dispatchInterval(intervalDuration, intervalIndex) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:intervalDuration", intervalDuration);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lapTime", intervalDuration);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:intervalIndex", intervalIndex);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:lap");
    }
    dispatchStep(stepDuration, stepIndex) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepDuration", stepDuration);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepTime", stepDuration);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:stepIndex", stepIndex);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("watch:step");
    }
}
// These regs have access to the global db state and can mutate it
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:lapDuration", (time, db)=>db.intervalDuration = time);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:stepDuration", (time, db)=>db.stepDuration = time);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:lapTime", (time, db)=>db.lapTime = time);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:stepTime", (time, db)=>db.stepTime = time);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:intervalIndex", (index, db)=>db.intervalIndex = index);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:stepIndex", (index, db)=>{
    db.stepIndex = index;
    const intervalIndex = db.intervalIndex;
    const powerTarget = db.workout.intervals[intervalIndex].steps[index].power;
    const slopeTarget = db.workout.intervals[intervalIndex].steps[index].slope;
    const cadenceTarget = db.workout.intervals[intervalIndex].steps[index].cadence;
    const distanceTarget = db.workout.intervals[intervalIndex].steps[index].distance;
    if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(slopeTarget)) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:slope-target-set", slopeTarget);
        if (!(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(db.mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:mode-set", (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim);
    }
    if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(distanceTarget)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:distance-target-set", distanceTarget);
    if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(cadenceTarget)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:cadence-target-set", cadenceTarget);
    else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:cadence-target-set", 0);
    if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(powerTarget)) {
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:power-target-set", (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).ftp.toAbsolute(powerTarget, db.ftp) * (db.powerScale / 100));
        if (!(0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(slopeTarget) && !(0, $c6a9e46ee7e4d896$export$e9bab7fafb253603)(db.mode, (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg)) (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:mode-set", (0, $21d6c30d826f68a8$export$83d617ae204944c5).erg);
    } else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch("ui:power-target-set", 0);
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("workout:started", (x, db)=>db.workoutStatus = "started");
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("workout:stopped", (x, db)=>db.workoutStatus = "stopped");
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("workout:done", (x, db)=>db.workoutStatus = "done");
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:started", (x, db)=>{
    db.watchStatus = "started";
    if (db.lapStartTime === false) db.lapStartTime = Date.now(); // if first lap
});
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:paused", (x, db)=>db.watchStatus = "paused");
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:stopped", (x, db)=>db.watchStatus = "stopped");
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:elapsed", (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.elapsed);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:lap", (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.lap);
(0, $c6a9e46ee7e4d896$export$499ab16161e1b192).reg("watch:event", (0, $9aba94002b6a15c7$export$f14fa567d4bea4ac).session.event);
const $be7ac4e15077640d$export$3db5d71bdb2d5499 = new $be7ac4e15077640d$var$Watch();





function $3aa40ed40f239264$var$Course() {
    const abortController = new AbortController();
    const signal = {
        signal: abortController.signal
    };
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub(`db:distance`, onDistance.bind(this), signal);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:workout', onWorkout.bind(this), signal);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('ui:workoutStart', onWatchStart.bind(this), signal);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('ui:watchStart', onWatchStart.bind(this), signal);
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).sub('db:courseIndex', onCourseIndex.bind(this), signal);
    let started = false;
    let distance = 0;
    let index = 0;
    let maxIndex = 0;
    let maxPointIndex = 0;
    let courseDistance = 0;
    let r = 0;
    let slope = 0;
    let course;
    let pointIndex = 0;
    let segmentStart = 0;
    let segment = {};
    function isCourse() {
        return (0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(course?.points);
    }
    function restore() {}
    function onCourseIndex(courseIndex) {
        console.log(`:course :index ${courseIndex}`);
        index = courseIndex;
    }
    function onDistance(value) {
        if (!started) return;
        while(pointIndex % maxPointIndex < course.points.length)if (value % courseDistance > course.points[pointIndex].distance) // console.log(`< ${pointIndex}/${value} : ${pointIndex} ${course.points[pointIndex].distance}`);
        pointIndex += 1;
        else {
            var p0 = course.points[pointIndex - 1]?.distance ?? 0;
            var p1 = course.points[pointIndex].distance;
            var p0d = Math.abs(p0 - value);
            var p1d = Math.abs(p1 - value);
            // console.log(`>= ${pointIndex}/${value} : ${p0} ~${p0d}, ${p1} ~${p1d}`);
            if (p0d < p1d) {
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('course:position', {
                    position_lat: course.points[pointIndex - 1].position_lat,
                    position_long: course.points[pointIndex - 1].position_long
                });
                pointIndex = Math.max(pointIndex - 1, 0);
            } else (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('course:position', {
                position_lat: course.points[pointIndex].position_lat,
                position_long: course.points[pointIndex].position_long
            });
            break;
        }
        distance = parseFloat(value) % courseDistance;
        if (distance - segmentStart >= r || segmentStart > distance) {
            const indexNext = (index + 1) % maxIndex;
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('course:index', indexNext);
            setSegment(indexNext);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:slope-target-set`, slope);
        }
    }
    function onWorkout(workout) {
        course = workout;
        if ((0, $c6a9e46ee7e4d896$export$f7e9f41ea797a17)(course?.points)) {
            console.log((0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(course.points).y);
            setCourse(course);
            setSegment(index);
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('altitude', (0, $c6a9e46ee7e4d896$export$43128fadae87b74a)(course.points).y);
        }
    }
    function onWatchStart() {
        if (isCourse()) start();
    }
    function start() {
        if (distance > 0) return;
        started = true;
        // setWorkout
        setCourse(course);
        setSegment(index);
        // r = indexToR(index);
        // slope = indexToSlope(index);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:slope-target-set`, slope);
        (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch(`ui:mode-set`, (0, $21d6c30d826f68a8$export$83d617ae204944c5).sim);
        console.log(`start a course ...`);
    }
    function setCourse(course) {
        maxIndex = course.pointsSimplified.length - 1;
        maxPointIndex = course.points.length - 1;
        courseDistance = course.meta.distance;
    }
    function setSegment(index) {
        segment = indexToSegment(index);
        r = segment.r;
        slope = segment.slope;
        segmentStart = segment.distance ?? distance;
    }
    function indexToSlope(index) {
        return course.pointsSimplified[index].slope;
    }
    function indexToR(index) {
        return course.pointsSimplified[index].r;
    }
    function indexToSegment(index) {
        return course.pointsSimplified[index];
    }
    Object.freeze({
        start: start
    });
}
// r = 12;
// slope = -0.4819;
// distance = 7429;
//  0: -1.2,    453, 0,
//  1: -0.4, 	   94, 454,
//  2:  1.2,    104, 548,
//  3:  0.447, 1072, 652,
//  4:  0.133,  299, 1724,
//  5:  0.9,    564, 2023,
//  6:  0.57,  1087, 2587,
//  7:  0.0,    823, 3674,
//  8: -0.7, 	  680, 4497,
//  9: -0.46,	  649, 5177,
// 10: -0.15,   390, 5826,
// 11:  0.0,   1213, 6216,
// 12: -0.4,     83, 7413,
// 13: -3.9,     56, 7512,
// 14: -1.0, 	  220, 7568,
// 15:  0,        0, 7788,
// 1:10, 0.4, 3, ~800
const $3aa40ed40f239264$export$5cc5db413381cac = $3aa40ed40f239264$var$Course();



class $488d6f540b96a2ec$var$WakeLock {
    constructor(args){
        this.lock = undefined;
        this.isLocked = false;
        this.isLocable = false;
        this.isVisible = false;
        this.init();
    }
    init() {
        let self = this;
        self.isLocable = 'wakeLock' in navigator;
        self.isVisible = self.checkVisibility();
        self.lockScreen();
        document.addEventListener('visibilitychange', self.onVisibilityChange.bind(self));
        window.addEventListener('beforeunload', (e)=>{
            (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('lock:beforeunload');
        });
    }
    checkVisibility() {
        let isVisible = false;
        let visibilityState = document.visibilityState;
        if (visibilityState === 'visible') isVisible = true;
        else isVisible = false;
        return isVisible;
    }
    onVisibilityChange() {
        let self = this;
        if (self.checkVisibility()) self.lockScreen();
    }
    async lockScreen() {
        let self = this;
        if (self.isLocable && self.isVisible) try {
            let lock = await navigator.wakeLock.request('screen');
            self.isLocked = true;
            lock.addEventListener('release', (e)=>{
                self.isLocked = false;
                (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('lock:release');
                console.log(`Wake lock released.`);
            });
        } catch (e) {
            console.warn(`wake-lock: not-supported:`, e);
        }
    }
}
const $488d6f540b96a2ec$export$6a9f04c98a658ecb = new $488d6f540b96a2ec$var$WakeLock();


var $129d2eddeeb40f93$exports = {};
$129d2eddeeb40f93$exports = import.meta.resolve("kLn2N");


function $35da740d59af89ba$var$startServiceWorker() {
    if ('serviceWorker' in navigator) try {
        // const reg = navigator.serviceWorker.register('./sw.js');
        const reg = navigator.serviceWorker.register($129d2eddeeb40f93$exports);
        console.log(`SW: register success.`);
        console.log('Cache Version: Flux-v003');
    } catch (err) {
        console.log(`SW: register error: `, err);
    }
}
function $35da740d59af89ba$export$b3571188c770cc5a() {
    console.log('start app.');
    // startServiceWorker(); // stable version only
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('app:start');
}
function $35da740d59af89ba$export$fa6813432f753b0d() {
    (0, $c6a9e46ee7e4d896$export$499ab16161e1b192).dispatch('app:stop');
}
$35da740d59af89ba$export$b3571188c770cc5a();


//# sourceMappingURL=Auuki.84572a22.js.map
